webpackJsonp([2,1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _vue = __webpack_require__(226);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(225);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(26);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _manifest = __webpack_require__(84);
	
	var _manifest2 = _interopRequireDefault(_manifest);
	
	var _App = __webpack_require__(199);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Preloader = __webpack_require__(83);
	
	var _gsap = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.app = {};
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  routes: _routes2.default
	});
	
	window.app.current = _routes2.default[0];
	router.afterEach(function (to, from) {
	  window.app.current = to;
	});
	
	router.beforeEach(function (to, from, next) {
	  var _preloader = new _Preloader.ImagePreloader();
	  var _images = _manifest2.default[to.name];
	  var _slideEasing = _gsap.Power2.easeOut;
	  var _slideDuration = 0.5;
	
	  var _loader = '';
	
	  var showLoader = function showLoader() {
	    _loader = document.querySelector('.view-loader__panel');
	    _gsap.TweenLite.fromTo(_loader, _slideDuration, {
	      x: -Math.max(_loader.offsetWidth)
	    }, {
	      x: 0,
	      ease: _slideEasing,
	      onComplete: preloadImages
	    });
	  };
	
	  var hideLoader = function hideLoader() {
	    _loader = document.querySelector('.view-loader__panel');
	    _gsap.TweenLite.fromTo(_loader, _slideDuration, {
	      x: 0
	    }, {
	      x: -Math.max(_loader.offsetWidth),
	      ease: _slideEasing
	    });
	    fixControls();
	  };
	
	  var preloadImages = function preloadImages() {
	    _preloader.queue(_images);
	    _preloader.preload().then(function () {
	      next();
	
	      _vue2.default.nextTick(function () {
	        return setTimeout(function () {
	          return hideLoader();
	        }, 1000);
	      });
	    });
	  };
	
	  if (from.name !== null) {
	    showLoader();
	  } else {
	    preloadImages();
	  }
	});
	
	window.app.vue = new _vue2.default({
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');
	
	document.ontouchmove = function (event) {
	  return event.preventDefault();
	};
	
	var fastclick = __webpack_require__(228);
	fastclick.attach(document.body);
	
	var viewportHeight = 0;
	var fixControls = function fixControls() {
	  var pos = '20px';
	  viewportHeight = window.innerHeight;
	
	  if (window.matchMedia('(max-width: 1024px)').matches) {
	    pos = '20px';
	  } else if (window.matchMedia('(max-width: 1366px) and (max-height: 768px)').matches) {
	    pos = (768 - viewportHeight) / 2 + 20 + 'px';
	  } else if (window.matchMedia('(min-width: 1367px) and (max-height: 1080px)').matches) {
	    pos = (1080 - viewportHeight) / 2 + 20 + 'px';
	  }
	
	  var viewControls = document.querySelector('.view-controls__wrapper');
	  viewControls.style.bottom = pos;
	};
	window.addEventListener('resize', function () {
	  return fixControls();
	});
	fixControls();
	
	var logoPosition = function logoPosition() {
	  var pos = '0';
	
	  if (window.matchMedia('(max-width: 1024px)').matches) {
	    pos = '0';
	  } else if (window.matchMedia('(max-width: 1366px) and (max-height: 768px)').matches) {
	    pos = (768 - viewportHeight) / 2 + 'px';
	  } else if (window.matchMedia('(min-width: 1367px) and (max-height: 1080px)').matches) {
	    pos = (1080 - viewportHeight) / 2 + 'px';
	  }
	
	  var logoBlock = document.querySelector('.app-logo');
	  logoBlock.style.top = pos;
	};
	window.addEventListener('resize', function () {
	  return logoPosition();
	});
	logoPosition();
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Scores = undefined;
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(99);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _scoreData = __webpack_require__(44);
	
	var _scoreData2 = _interopRequireDefault(_scoreData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Scores = function () {
	  function Scores() {
	    (0, _classCallCheck3.default)(this, Scores);
	
	    this.total = 0;
	    this.progress = 0;
	    this.right = 0;
	    this.wrong = 0;
	    this.score = 0;
	    this.answers = {};
	    this.sections = {};
	    this.scoreData = _scoreData2.default;
	
	    this.retrieveAnswers();
	
	    this.bindButtonEvents();
	  }
	
	  (0, _createClass3.default)(Scores, [{
	    key: 'retrieveAnswers',
	    value: function retrieveAnswers() {
	      if (this.getCookie('answers')) {
	        this.answers = JSON.parse(this.getCookie('answers'));
	      }
	
	      this.setProgress();
	    }
	  }, {
	    key: 'bindButtonEvents',
	    value: function bindButtonEvents() {
	      var _this = this;
	
	      document.body.addEventListener('click', function (e) {
	        var item = e.target;
	        if (item.classList.contains('quiz__button')) {
	          e.preventDefault();
	          _this.processAnswer(item);
	        }
	      });
	    }
	  }, {
	    key: 'setProgress',
	    value: function setProgress() {
	      this.right = 0;
	      this.wrong = 0;
	      this.score = 0;
	      this.total = 0;
	      this.progress = 0;
	      this.sections = {};
	
	      if (!this.scoreData) {
	        return;
	      }
	
	      for (var page in this.scoreData) {
	        for (var modal in this.scoreData[page]) {
	          this.total++;
	
	          if (!this.sections[page]) {
	            this.sections[page] = { progress: 0, right: 0, total: 0 };
	          }
	
	          this.sections[page].total++;
	          if (this.getAnswer(page, modal)) {
	            this.progress++;
	            this.sections[page].progress++;
	            if (this.checkAnswer(page, modal)) {
	              this.right++;
	              this.sections[page].right++;
	            } else {
	              this.wrong++;
	            }
	          }
	        }
	      }
	
	      if (this.right === 0) {
	        this.score = 0;
	      } else {
	        this.score = Math.round(this.right / this.progress * 100);
	      }
	    }
	  }, {
	    key: 'getLetter',
	    value: function getLetter(id) {
	      var letters = ['A', 'B', 'C', 'D', 'E', 'F'];
	      return letters[id] ? letters[id] : 'U';
	    }
	  }, {
	    key: 'processAnswer',
	    value: function processAnswer(item) {
	      var optId = parseInt(item.dataset.id);
	      var page = item.dataset.page;
	      var modal = item.dataset.modal;
	
	      var question = this.scoreData[page][modal];
	      if (question === undefined) {
	        alert('There was an unexpected issue\nplease reload the page and try again.');
	        return;
	      }
	
	      this.setAnswer(page, modal, optId);
	      this.updateAnswer(page, modal, item);
	      this.setProgress();
	    }
	  }, {
	    key: 'setAnswer',
	    value: function setAnswer(page, modal, optId) {
	      if (this.answers[page] === undefined) {
	        this.answers[page] = {};
	      }
	      if (this.answers[page][modal] === undefined) {
	        this.answers[page][modal] = {};
	      }
	      this.answers[page][modal] = parseInt(optId);
	      this.setCookie('answers', (0, _stringify2.default)(this.answers), 1);
	    }
	  }, {
	    key: 'getAnswer',
	    value: function getAnswer(page, modal) {
	      return this.answers[page] && this.answers[page][modal] ? this.answers[page][modal] : null;
	    }
	  }, {
	    key: 'checkAnswer',
	    value: function checkAnswer(page, modal) {
	      var question = this.scoreData[page][modal];
	      var answer = this.getAnswer(page, modal);
	      return question.correct + 1 === answer;
	    }
	  }, {
	    key: 'updateAnswer',
	    value: function updateAnswer(page, modal, item) {
	      var answer = this.getAnswer(page, modal);
	      if (!answer) {
	        return;
	      }
	
	      if (!item) {
	        item = document.querySelector('.' + modal + ' button[data-id="' + answer + '"');
	      }
	
	      var parent = item.parentElement;
	      var container = item.closest('.quiz');
	      var trigger = document.querySelector('.modal__button--quiz.modal__button--' + modal);
	
	      if (this.checkAnswer(page, modal)) {
	        parent.classList.add('quiz__item--correct');
	        container.classList.add('quiz--correct');
	        trigger.classList.add('modal__button--correct');
	      } else {
	        parent.classList.add('quiz__item--wrong');
	        container.classList.add('quiz--wrong');
	        trigger.classList.add('modal__button--wrong');
	      }
	
	      var options = container.querySelectorAll('.quiz__item');
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var opt = _step.value;
	
	          opt.querySelector('.quiz__button').setAttribute('disabled', true);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'clearAnswers',
	    value: function clearAnswers() {
	      this.eraseCookie('answers');
	    }
	  }, {
	    key: 'setCookie',
	    value: function setCookie(name, value, days) {
	      var expires = '';
	      if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	        expires = '; expires=' + date.toUTCString();
	      }
	      document.cookie = name + '=' + (value || '') + expires + '; path=/';
	    }
	  }, {
	    key: 'getCookie',
	    value: function getCookie(name) {
	      var nameEQ = name + '=';
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	          c = c.substring(1, c.length);
	        }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	      }
	      return null;
	    }
	  }, {
	    key: 'eraseCookie',
	    value: function eraseCookie(name) {
	      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	    }
	  }]);
	  return Scores;
	}();
	
	exports.Scores = Scores;

/***/ },
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/turbine.29ca881.svg";

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(185);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Start = function Start(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(211));
	  });
	};
	var SceneIntro = function SceneIntro(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(209));
	  });
	};
	var SceneSchoolGrounds = function SceneSchoolGrounds(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(210));
	  });
	};
	var SceneClassroom = function SceneClassroom(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(207));
	  });
	};
	var SceneCanteen = function SceneCanteen(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(206));
	  });
	};
	var SceneCorridor = function SceneCorridor(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(208));
	  });
	};
	var SceneBathroom = function SceneBathroom(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(205));
	  });
	};
	var Conclusion = function Conclusion(r) {
	  return __webpack_require__.e/* nsure */(0, function () {
	    return r(__webpack_require__(204));
	  });
	};
	
	exports.default = [{
	  scene: 0,
	  path: '/start',
	  name: 'start',
	  type: 'page',
	  component: Start
	}, {
	  scene: 1,
	  path: '/1/intro',
	  name: 'intro',
	  type: 'scene',
	  component: SceneIntro
	}, {
	  scene: 2,
	  path: '/2/school-grounds',
	  name: 'school-grounds',
	  type: 'scene',
	  component: SceneSchoolGrounds
	}, {
	  scene: 3,
	  path: '/3/classroom',
	  name: 'classroom',
	  type: 'scene',
	  component: SceneClassroom
	}, {
	  scene: 4,
	  path: '/4/canteen',
	  name: 'canteen',
	  type: 'scene',
	  component: SceneCanteen
	}, {
	  scene: 5,
	  path: '/5/corridor',
	  name: 'corridor',
	  type: 'scene',
	  component: SceneCorridor
	}, {
	  scene: 6,
	  path: '/6/bathroom',
	  name: 'bathroom',
	  type: 'scene',
	  component: SceneBathroom
	}, {
	  scene: 0,
	  path: '/conclusion',
	  name: 'conclusion',
	  type: 'page',
	  component: Conclusion
	}, {
	  scene: 0,
	  path: '*',
	  type: 'catchall',
	  redirect: {
	    path: '/start'
	  }
	}];

/***/ },
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.6a79114.svg";

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.8844e9d.svg";

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/midground.11f788c.svg";

/***/ },
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'start': [],
	  'intro': {
	    'intro-bike': {
	      'correct': 2,
	      'question': 'What percentage of schools and colleges in Britain are located in areas with dangerously high levels of air pollution?',
	      'answer': 'A scary 27% of schools are located in areas where air pollution is above guidelines recommended by the World Health Organisation – but you can help by ditching the car and travelling sustainably to school. Alternatively, you can work with your local authority to create a School Street, where no motorised traffic is allowed during school drop-off and pick-up times.',
	      'options': [{ 'size': 'large', 'title': '4%' }, { 'size': 'large', 'title': '19%' }, { 'size': 'large', 'title': '27%' }]
	    },
	    'intro-pupils': {
	      'correct': 0,
	      'question': 'What percentage of primary school children does the government want to be to walking to school, each day, by 2025?',
	      'answer': '55%! The government’s target is 55%, but this target is a lot less than a generation ago when 70% of primary school pupils walked to school every day.',
	      'options': [{ 'size': 'large', 'title': '55%' }, { 'size': 'large', 'title': '65%' }, { 'size': 'large', 'title': '70%' }]
	    },
	    'intro-trees': {
	      'correct': 2,
	      'question': 'How much Carbon Dioxide do you think one, fully mature tree will absorb from the atmosphere in a year?',
	      'answer': 'An amazing 22kg! However, sapling trees don’t absorb quite so much, so it’s important to look after them until they are fully matured trees!',
	      'options': [{ 'size': 'large', 'title': '8kg' }, { 'size': 'large', 'title': '14kg' }, { 'size': 'large', 'title': '22kg' }]
	    },
	    'intro-solar': {
	      'correct': 1,
	      'question': 'What percentage of the UK\'s energy do you think comes from renewable energy sources, like solar panels and wind turbines?',
	      'answer': '39%. whilst our capacity for renewable energy is now 6x greater than 2010, we still have a long way to go to meet the Government’s aim of Net Zero by 2050.',
	      'options': [{ 'size': 'large', 'title': '17%' }, { 'size': 'large', 'title': '39%' }, { 'size': 'large', 'title': '51%' }]
	    },
	    'intro-bin': {
	      'correct': 2,
	      'question': 'How many phone calls do you think the RSPCA receives about animals affected by litter every day? ',
	      'answer': '10! The RSPCA receives 10 calls a day about animals affected by litter… and not only does litter harm wildlife, it also costs our country hundreds of millions of pounds to clean up every year.',
	      'options': [{ 'size': 'large', 'title': '1' }, { 'size': 'large', 'title': '5' }, { 'size': 'large', 'title': '10' }]
	    }
	  },
	  'school-grounds': {
	    'bird-feeders': {
	      'correct': 1,
	      'question': 'How many pairs of native breeding birds do you think there are in the UK?',
	      'answer': '83 million! There are an estimated 83 million, but this is down by 19 million since widespread monitoring began in the 1960s. This shows the importance of encouraging biodiversity and supporting animal life.',
	      'options': [{ 'size': 'small', 'title': '8.3 <br> million' }, { 'size': 'small', 'title': '83 <br> million' }, { 'size': 'small', 'title': '830 <br> million' }]
	    },
	    'polytunnel': {
	      'correct': 2,
	      'question': 'Transporting food is responsible for 25% of all miles covered by heavy goods vehicles (ie. lorries) in the UK. How much CO2 does transporting food around the UK produce annually?',
	      'answer': '19 million tonnes! That’s the equivalent emissions of 5.5 million cars. Luckily these carbon emissions can be reduced by growing your own, shopping seasonally and locally, and of course avoiding food waste.',
	      'options': [{ 'size': 'small', 'title': '900,00 <br> tonnes' }, { 'size': 'small', 'title': '9.1 <br> million <br> tonnes' }, { 'size': 'small', 'title': '19 <br> million <br> tonnes' }]
	    },
	    'composting': {
	      'correct': 0,
	      'question': 'Which of these items shouldn’t be composted?',
	      'answer': 'Cooked food waste! This will smell bad and attract vermin. Surprisingly you can compost teabags (providing they contain no plastic).',
	      'options': [{ 'size': 'small', 'title': 'Cooked <br>food <br>waste' }, { 'size': 'small', 'title': 'Used <br> Teabags' }, { 'size': 'small', 'title': 'Fruit peel' }]
	    },
	    'green-roof': {
	      'correct': 2,
	      'question': 'Green roofs can attract and support insect life. A recent survey from Kent Wildlife Trust found that between 2004 and 2022 the number of insects splats on number plates declined by how much?',
	      'answer': '64%! Whilst it might seem a little strange to record the number of insect splats on number plates, it is a good way to find out about insect populations nationally.',
	      'options': [{ 'size': 'large', 'title': '6%' }, { 'size': 'large', 'title': '46%' }, { 'size': 'large', 'title': '64%' }]
	    },
	    'water-butt': {
	      'correct': 2,
	      'question': 'Which month is the best for collecting rainwater in the UK (during what month does it rain the most)?',
	      'answer': 'December! When average rainfall is 127.27mm and it rains on average for 15 days.',
	      'options': [{ 'size': 'small', 'title': 'April' }, { 'size': 'small', 'title': 'October' }, { 'size': 'small', 'title': 'December' }]
	    }
	  },
	  'classroom': {
	    'computers': {
	      'correct': 0,
	      'question': 'What percentage of greenhouse gas emissions produced by the UK are from energy production?',
	      'answer': '21%! The only sector that produces more emissions is transport, so it\'s vital that schools manage their energy use and transition to renewable sources!',
	      'options': [{ 'size': 'large', 'title': '21%' }, { 'size': 'large', 'title': '31%' }, { 'size': 'large', 'title': '41%' }]
	    },
	    'recycling-paper': {
	      'correct': 2,
	      'question': 'How many trees does recycling one tonne of paper save?',
	      'answer': '17! It also requires 70% less energy and water to create recycled paper than it does to create new paper from trees. Are your schoolbooks made from recycled paper?  ',
	      'options': [{ 'size': 'large', 'title': '1' }, { 'size': 'large', 'title': '8' }, { 'size': 'large', 'title': '17' }]
	    },
	    'recycling-plastic': {
	      'correct': 2,
	      'question': 'What percentage of single-use plastics are produced from never-before-used fossil fuels?',
	      'answer': '98%! Which is why the production, use, and disposal of plastics is expected to account for 19% of the global carbon budget by 2040.',
	      'options': [{ 'size': 'large', 'title': '17%' }, { 'size': 'large', 'title': '54%' }, { 'size': 'large', 'title': '98%' }]
	    },
	    'water-bottle': {
	      'correct': 2,
	      'question': 'What percentage of British adults do you think buy and drink a new bottle of water every day?',
	      'answer': '18%! Nearly one in five adults buy and drink a new bottle of water every day. This needs to end - bottled water is 900 times more carbon intensive than tap water! Luckily the UK now has over 30,000 free-to-use refill stations and even a refill app to help people find them!',
	      'options': [{ 'size': 'large', 'title': '7%' }, { 'size': 'large', 'title': '11%' }, { 'size': 'large', 'title': '18%' }]
	    },
	    'books': {
	      'correct': 1,
	      'question': 'How much paper waste does the average primary school pupil produce each year?',
	      'answer': '45kg! Secondary school students use less at 22kg! 45kg is the same weight as a (heavy) baby hippo!',
	      'options': [{ 'size': 'small', 'title': '4kg' }, { 'size': 'small', 'title': '45kg' }, { 'size': 'small', 'title': '145kg' }]
	    }
	  },
	  'corridor': {
	    'posters': {
	      'correct': 2,
	      'question': 'How much plastic do you think reaches oceans each year, harming marine life?',
	      'answer': '8 million tonnes! This is the equivalent of placing five bags full of rubbish on every foot of coastline around the world!',
	      'options': [{ 'size': 'small', 'title': '80,000 <br>tonnes' }, { 'size': 'small', 'title': '800,000<br>tonnes' }, { 'size': 'small', 'title': '8 million<br>tonnes' }]
	    },
	    'lights': {
	      'correct': 1,
	      'question': 'What percentage of a school’s energy use do you think lighting accounts for?',
	      'answer': '8%! Only heating classrooms and water uses more energy in a school.',
	      'options': [{ 'size': 'large', 'title': '2%' }, { 'size': 'large', 'title': '8%' }, { 'size': 'large', 'title': '19%' }]
	    },
	    'noticeboard': {
	      'correct': 0,
	      'question': 'What uses the most energy in a school?',
	      'answer': 'Heating! Space heating accounts for 58% (more than half!) of a school’s energy use, but simple measures like draft proofing, ensuring radiators aren’t blocked, and using communal entrances can save up to 30% of heating costs.',
	      'options': [{ 'size': 'small', 'title': 'Heating' }, { 'size': 'small', 'title': 'food and drink prep' }, { 'size': 'small', 'title': 'Powering devices' }]
	    },
	    'crisp-bin': {
	      'correct': 1,
	      'question': 'How many packets of crisps do you think we eat in the UK every year?',
	      'answer': '6 billion! That’s 100 packets per person every year - schools can make a huge difference by collecting crisp packets for recycling.',
	      'options': [{ 'size': 'small', 'title': '900<br>million' }, { 'size': 'small', 'title': '6<br>billion' }, { 'size': 'small', 'title': '8<br>billion' }]
	    },
	    'litter-pickers': {
	      'correct': 0,
	      'question': 'What do you think is the most commonly littered item that pupils will find whilst litter-picking?',
	      'answer': 'Cigarette butts! This is bad because they’re made of plastic, take up to 14 years to decompose, can easily make their way to marine environments, they are also tricky to pick up with litter-pickers!',
	      'options': [{ 'size': 'small', 'title': 'Cigarette<br> butts' }, { 'size': 'small', 'title': 'Chocolate<br>bar wrappers' }, { 'size': 'small', 'title': 'Drinks bottles and cans' }]
	    }
	  },
	  'bathroom': {
	    'cistern': {
	      'correct': 2,
	      'question': 'How much water do you think an old-style toilet uses each time it is flushed?',
	      'answer': '13 litres! This school’s simple water-saving devices will make a huge difference. Modern dual flush systems only use between 4 – 6 litres per flush.',
	      'options': [{ 'size': 'small', 'title': '4 litres' }, { 'size': 'small', 'title': '6 litres' }, { 'size': 'small', 'title': '13 litres' }]
	    },
	    'toilet': {
	      'correct': 2,
	      'question': 'In 2019 Thames 21 organised a two-hour volunteer clean up on the shore of the Thames River in Barnes Southwest London. How many wet wipes did they find?',
	      'answer': '23,000! Wet wipes do not break down like toilet paper and contribute to more than 90% of sewer blockages in the UK. They can also devastate wildlife when they eventually enter our rivers and oceans… remember to only flush the three p’s!',
	      'options': [{ 'size': 'small', 'title': '1,700' }, { 'size': 'small', 'title': '11,600' }, { 'size': 'small', 'title': '23,000' }]
	    },
	    'hand-dryer': {
	      'correct': 2,
	      'question': 'Paper towels generate more emissions than the most efficient hand dryers, but how much more?',
	      'answer': 'Up to 70% more! This figure takes into account all aspects of the manufacturing process including mining the ore to produce metal hand dryers!',
	      'options': [{ 'size': 'small', 'title': 'Up to 5% more' }, { 'size': 'small', 'title': 'Up to 40% more' }, { 'size': 'small', 'title': 'Up to 70% more' }]
	    },
	    'hand-soap': {
	      'correct': 2,
	      'question': 'How long do you think it takes a single-use, plastic bottle to decompose?',
	      'answer': '450 years! That’s a very long time for something that will be used for just a few weeks before being discarded!',
	      'options': [{ 'size': 'small', 'title': '4 years' }, { 'size': 'small', 'title': '45 years' }, { 'size': 'small', 'title': '450 years' }]
	    },
	    'sensor-taps': {
	      'correct': 1,
	      'question': 'How many litres of water would a tap waste in 1 minute if it was left on by mistake?',
	      'answer': '6! It would waste six litres per minute! That’s approximately the same as 24 full, average sized glasses!',
	      'options': [{ 'size': 'large', 'title': '3' }, { 'size': 'large', 'title': '6' }, { 'size': 'large', 'title': '9' }]
	    }
	  },
	  'canteen': {
	    'meals': {
	      'correct': 0,
	      'question': 'Which of these foods has the largest Carbon Footprint?',
	      'answer': 'Beef! Beef produces 60kg of CO2e for every 1kg of food, and nuts only create around 0.5kg of C02e for every kg! One of the reasons beef is responsible for so much CO2e is because cows produce a lot of methane, a greenhouse gas more potent than CO2.',
	      'options': [{ 'size': 'small', 'title': 'Beef' }, { 'size': 'small', 'title': 'Fish' }, { 'size': 'small', 'title': 'Potatoes' }]
	    },
	    'staff': {
	      'correct': 1,
	      'question': 'How much food is wasted in the UK every year?',
	      'answer': '6.6 million tonnes! This wasted food is responsible for nearly 25 million tonnes of CO2 emissions annually and could be used to make over 15 billion meals, enough to feed everyone in the UK 3 meals a day for 11 weeks!',
	      'options': [{ 'size': 'small', 'title': '3.1<br>million tonnes' }, { 'size': 'small', 'title': '6.6<br>million tonnes' }, { 'size': 'small', 'title': '9.5<br>million tonnes' }]
	    },
	    'fairtrade-food': {
	      'correct': 1,
	      'question': 'How many farmers and workers are in Fairtrade certified organisations around the world?',
	      'answer': '1.9 million! This is great because Fairtrade certification not only sets high standards for workers, it also sets strict environmental standards that certified producers must follow.',
	      'options': [{ 'size': 'small', 'title': '1.4<br>million' }, { 'size': 'small', 'title': '1.9<br>million' }, { 'size': 'small', 'title': '2.1<br>million' }]
	    },
	    'cups-plates': {
	      'correct': 0,
	      'question': 'On 27th December 2019, the government’s education secretary challenged each school to become single-use-plastic-free by when?',
	      'answer': '2022! Did your school manage it? If not It’s never too late to go single-use-plastic-free!',
	      'options': [{ 'size': 'large', 'title': '2022' }, { 'size': 'large', 'title': '2025' }, { 'size': 'large', 'title': '2030' }]
	    },
	    'recycling-bins': {
	      'correct': 0,
	      'question': 'How much of England and Wales’ waste cannot be recycled due to recycling contamination?',
	      'answer': '17%! this shows how important it is that people understand what belongs in each bin and how to pre-cycle items (prepare an item for recycling).',
	      'options': [{ 'size': 'large', 'title': '17%' }, { 'size': 'large', 'title': '27%' }, { 'size': 'large', 'title': '37%' }]
	    }
	  }
	};

/***/ },
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.1f58530.svg";

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.3908b22.svg";

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.d970594.svg";

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.2c94db9.svg";

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/midground.2e3decb.svg";

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.f1e25e9.svg";

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/clock.840c9a9.svg";

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.604e9aa.svg";

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/midground.f6eb724.svg";

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.dd3a3ca.svg";

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.946a282.svg";

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/midground.da96102.svg";

/***/ },
/* 69 */,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/cyclist--small.6c7b787.svg";

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/cyclist.5ccdf47.svg";

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/flag--small.86b2643.svg";

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/flag.3b55ef9.svg";

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/schoolboy--small.4d8f4cf.svg";

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/schoolboy.b6b775e.svg";

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/scene__layer--ground.dae8f9f.svg";

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/background.89025dc.svg";

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.db18ab8.svg";

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/midground.382a83b.svg";

/***/ },
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImagePreloader = undefined;
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _promise = __webpack_require__(45);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defer() {
	  var resolve = '';
	  var reject = '';
	  var promise = new _promise2.default(function (resolve, reject) {});
	
	  return {
	    resolve: resolve,
	    reject: reject,
	    promise: promise
	  };
	}
	
	var ImagePreloader = function () {
	  function ImagePreloader(options) {
	    (0, _classCallCheck3.default)(this, ImagePreloader);
	
	    this.options = options || {};
	    this.options.parallel = this.options.parallel || false;
	    this.items = [];
	    this.max = 0;
	  }
	
	  (0, _createClass3.default)(ImagePreloader, [{
	    key: 'queue',
	    value: function queue(array) {
	      if (!Array.isArray(array)) {
	        array = [array];
	      }
	
	      if (array.length > this.max) {
	        this.max = array.length;
	      }
	
	      var deferred = defer();
	
	      this.items.push({
	        collection: array,
	        deferred: deferred
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'preloadImage',
	    value: function preloadImage(path) {
	      return new _promise2.default(function (resolve, reject) {
	        var image = new Image();
	        image.onload = resolve;
	        image.onerror = resolve;
	        image.src = path;
	      });
	    }
	  }, {
	    key: 'preload',
	    value: function preload() {
	      var _this = this;
	
	      var deck = '';
	      var decks = [];
	
	      if (this.options.parallel) {
	        var _loop = function _loop(i) {
	          _this.items.forEach(function (item) {
	            if (typeof item.collection[i] !== 'undefined') {
	              item.collection[i] = _this.preloadImage(item.collection[i]);
	            }
	          }, _this);
	        };
	
	        for (var i = 0; i < this.max; i++) {
	          _loop(i);
	        }
	      } else {
	        this.items.forEach(function (item) {
	          item.collection = item.collection.map(_this.preloadImage);
	        }, this);
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop2 = function _loop2() {
	          var item = _step.value;
	
	          deck = _promise2.default.all(item.collection).then(function () {
	            item.deferred.resolve();
	          }).catch(function (reason) {
	            console.log.bind(console);
	          });
	          decks.push(deck);
	        };
	
	        for (var _iterator = (0, _getIterator3.default)(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop2();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return _promise2.default.all(decks);
	    }
	  }]);
	  return ImagePreloader;
	}();
	
	exports.ImagePreloader = ImagePreloader;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'start': [__webpack_require__(76), __webpack_require__(39), __webpack_require__(40), __webpack_require__(38), __webpack_require__(71), __webpack_require__(70), __webpack_require__(73), __webpack_require__(72), __webpack_require__(75), __webpack_require__(74), __webpack_require__(24)],
	  'intro': [__webpack_require__(76), __webpack_require__(39), __webpack_require__(40), __webpack_require__(38), __webpack_require__(71), __webpack_require__(70), __webpack_require__(73), __webpack_require__(72), __webpack_require__(75), __webpack_require__(74), __webpack_require__(24)],
	  'school-grounds': [__webpack_require__(78), __webpack_require__(79), __webpack_require__(77), __webpack_require__(168), __webpack_require__(167), __webpack_require__(170), __webpack_require__(169), __webpack_require__(172), __webpack_require__(171), __webpack_require__(174), __webpack_require__(173)],
	  'classroom': [__webpack_require__(64), __webpack_require__(65), __webpack_require__(62), __webpack_require__(159), __webpack_require__(158), __webpack_require__(157), __webpack_require__(156), __webpack_require__(63)],
	  'corridor': [__webpack_require__(67), __webpack_require__(68), __webpack_require__(66), __webpack_require__(165), __webpack_require__(164), __webpack_require__(163), __webpack_require__(162), __webpack_require__(161), __webpack_require__(160)],
	  'bathroom': [__webpack_require__(58), __webpack_require__(57), __webpack_require__(146), __webpack_require__(145), __webpack_require__(144), __webpack_require__(143), __webpack_require__(148), __webpack_require__(147)],
	  'school-hall': [__webpack_require__(177), __webpack_require__(180), __webpack_require__(179), __webpack_require__(178), __webpack_require__(176), __webpack_require__(175), __webpack_require__(182), __webpack_require__(181), __webpack_require__(183)],
	  'canteen': [__webpack_require__(60), __webpack_require__(61), __webpack_require__(59), __webpack_require__(150), __webpack_require__(149), __webpack_require__(154), __webpack_require__(153), __webpack_require__(152), __webpack_require__(151)]
	};

/***/ },
/* 85 */,
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProgressBar = __webpack_require__(200);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _ViewContainer = __webpack_require__(201);
	
	var _ViewContainer2 = _interopRequireDefault(_ViewContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    ProgressBar: _ProgressBar2.default,
	    ViewContainer: _ViewContainer2.default
	  }
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(26);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _ViewLink = __webpack_require__(202);
	
	var _ViewLink2 = _interopRequireDefault(_ViewLink);
	
	var _ViewMap = __webpack_require__(203);
	
	var _ViewMap2 = _interopRequireDefault(_ViewMap);
	
	var _Scores = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scores = new _Scores.Scores();
	
	exports.default = {
	  name: 'progress-bar',
	  data: function data() {
	    return {
	      routing: null,
	      routes: [],
	      routeCur: null,
	      sceneID: 0,
	      sceneCur: null,
	      scenePrv: null,
	      sceneNex: null,
	      showBack: false,
	      showNext: true,
	      showFinish: false,
	      showMap: false,
	      showProgress: true
	    };
	  },
	
	  methods: {
	    load: function load() {
	      this.getScenes();
	      this.setScene();
	    },
	    setMap: function setMap() {
	      var scenes = document.querySelectorAll('[id^="scene_"]');
	      for (var i = 0; i < scenes.length; i++) {
	        var scene = scenes[i];
	
	        var name = scene.getAttribute('id');
	        name = name.replace('scene_', '');
	
	        var score = scores.sections[name];
	
	        if (score && score.progress === score.total) {
	          scene.classList.add('complete');
	        } else {
	          scene.classList.remove('complete');
	        }
	
	        scene.addEventListener('click', function (event) {
	          var name = event.currentTarget.getAttribute('id');
	          name = name.replace('scene_', '');
	          window.app.vue.$router.push({ name: name });
	        });
	      }
	    },
	    getScenes: function getScenes() {
	      var paths = [];
	
	      for (var i = 0; i < _routes2.default.length; i++) {
	        if (_routes2.default[i].type === 'scene') {
	          paths.push(_routes2.default[i]);
	        }
	      }
	      this.routes = paths;
	    },
	    setScene: function setScene() {
	      var item = null;
	      var last = null;
	      var next = null;
	      this.sceneID = 0;
	      this.scenePrv = last;
	      this.sceneNex = next;
	      this.routeCur = this.$router.currentRoute;
	      for (var i = 0; i < this.routes.length; i++) {
	        if (i > 0 && item !== null) {
	          last = item;
	        }
	        item = this.routes[i];
	        if (this.routeCur && this.routeCur.name === item.name) {
	          this.sceneCur = item;
	          this.scenePrv = last;
	          this.sceneID = item.scene;
	          next = this.routes[i + 1];
	          if (next !== undefined) {
	            this.sceneNex = next;
	          }
	        }
	      }
	
	      this.showProgress = true;
	      if (this.routeCur.name === 'start') {
	        this.showProgress = false;
	      }
	
	      if (this.routeCur.name === 'conclusion') {
	        this.showProgress = false;
	      }
	
	      this.showFinish = false;
	      var lastScene = this.routes.length - 1;
	      if (this.routeCur.name === this.routes[lastScene].name) {
	        this.showFinish = true;
	      }
	
	      this.showBack = this.scenePrv !== null;
	      this.showNext = this.sceneNex !== null;
	    },
	    goBack: function goBack() {
	      if (this.scenePrv !== null) {
	        this.$router.push({ name: this.scenePrv.name });
	      }
	    },
	    goNext: function goNext() {
	      if (this.sceneNex !== null) {
	        this.$router.push({ name: this.sceneNex.name });
	      }
	    },
	    goFinish: function goFinish() {
	      if (scores.total === scores.progress) {
	        this.$router.push({ name: 'conclusion' });
	      } else {
	        alert('You have not answered all of the questions');
	      }
	    },
	    openMap: function openMap() {
	      this.setMap();
	      this.showMap = true;
	    },
	    hideMap: function hideMap() {
	      this.showMap = false;
	    }
	  },
	  mounted: function mounted() {
	    this.load();
	  },
	  components: {
	    ViewLink: _ViewLink2.default,
	    ViewMap: _ViewMap2.default
	  }
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'view-container'
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    to: Object,
	    scene: Number,
	    current: Number
	  },
	  data: function data() {
	    return { icon: __webpack_require__(190) };
	  }
	};

/***/ },
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 142 */,
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/door--small.5ae5401.svg";

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/door.011afdb.svg";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dryer--small.edb61ee.svg";

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dryer.6840171.svg";

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/girl--small.9a0c610.svg";

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/girl.21b2144.svg";

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lady--small.580d19f.svg";

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lady.962b26a.svg";

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil-drinking--small.3304b8f.svg";

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil-drinking.b33e706.svg";

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil-plate--small.9de4013.svg";

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil-plate.d3db859.svg";

/***/ },
/* 155 */,
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil--small.c7d22a1.svg";

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil.efde508.svg";

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/teacher--small.5b8f736.svg";

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/teacher.6d15d8e.svg";

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/noticeboard--small.5e8f130.svg";

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/noticeboard.a4148c6.svg";

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil--small.8641d4b.svg";

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil.095ac87.svg";

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/watertank--small.5342dbe.svg";

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/watertank.d0ab7af.svg";

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.7443c39.svg";

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/birdhouse--small.d969769.svg";

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/birdhouse.4bf8392.svg";

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/butterflies-left--small.8f16b74.svg";

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/butterflies-left.9ff988b.svg";

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/butterflies-right--small.e329562.svg";

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/butterflies-right.2b3a760.svg";

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil--small.84d2514.svg";

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pupil.86178a0.svg";

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/boy-waving--small.d0e8bed.svg";

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/boy-waving.eb2c838.svg";

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/foreground.809017c.svg";

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/girl--small.a6d9e74.svg";

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/girl.ea90d3a.svg";

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/midground.3cf5eb1.svg";

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/piano-player--small.68cfaa5.svg";

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/piano-player.e6af7e8.svg";

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/piano.1f7bf2d.svg";

/***/ },
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"27\" height=\"31\" viewBox=\"0 0 27 31\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FFF\" d=\"M12.81 30.792c-4.99-1.87-8.68-5.3-10.676-9.872C-.46 15.1.038 5.644.038 5.228l.1-1.974h1.896C8.419 3.254 12.41.76 12.41.76l1.098-.728 1.097.728s3.99 2.494 10.376 2.494h1.896l.1 1.974c0 .416.399 9.976-2.096 15.692-1.995 4.572-5.687 8.002-10.675 9.872l-.698.208-.699-.208z\"/><path class=\"shield\" fill=\"#CCC\" d=\"M13.492 27.903c4.785-1.727 7.876-4.877 9.57-8.534 2.393-5.283 1.895-14.427 1.895-14.427-7.079 0-11.465-2.845-11.465-2.845S9.105 4.942 2.027 4.942c0 0-.4 9.144 1.894 14.427 1.695 3.657 4.785 6.807 9.57 8.534z\"/></g></svg>"

/***/ },
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(141)
	
	/* script */
	__vue_exports__ = __webpack_require__(86)
	
	/* template */
	var __vue_template__ = __webpack_require__(224)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(87)
	
	/* template */
	var __vue_template__ = __webpack_require__(219)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(88)
	
	/* template */
	var __vue_template__ = __webpack_require__(214)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(89)
	
	/* template */
	var __vue_template__ = __webpack_require__(212)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* template */
	var __vue_template__ = __webpack_require__(215)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('router-link', {
	    staticClass: "view-controls__link",
	    class: (_vm.scene < _vm.current) ? 'view-controls__link--active' : '',
	    attrs: {
	      "to": _vm.to,
	      "active-class": "view-controls__link--active"
	    }
	  }, [_h('span', {
	    staticClass: "view-controls__link-label"
	  }, [_vm._t("default")]), " ", _h('div', {
	    staticClass: "view-controls__link-icon",
	    domProps: {
	      "innerHTML": _vm._s(_vm.icon)
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 213 */,
/* 214 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "view-container"
	  }, [_h('keep-alive', [_h('router-view', {
	    staticClass: "view"
	  })])])
	},staticRenderFns: []}

/***/ },
/* 215 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "viewBox": "0 0 1920 996.14"
	    }
	  }, [_h('defs', [_h('clipPath', {
	    attrs: {
	      "id": "clippath"
	    }
	  }, [_h('polygon', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "points": "453.22 638.07 453.22 638.07 271.35 718.62 453.22 718.62 635.1 718.62 453.22 638.07"
	    }
	  })]), _h('clipPath', {
	    attrs: {
	      "id": "clippath-1"
	    }
	  }, [_h('polygon', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "points": "453.22 638.07 453.22 638.07 271.35 718.62 453.22 718.62 635.1 718.62 453.22 638.07"
	    }
	  })])]), _h('g', {
	    staticStyle: {
	      "isolation": "isolate"
	    }
	  }, [_h('g', {
	    attrs: {
	      "id": "Layer_1"
	    }
	  }, [_h('g', {
	    attrs: {
	      "id": "MAP_BACKGROUND"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1898.22,448.39c.09-.14.18-2.93.2-7.88l-.2,7.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1897.61,162.24c-.01.23-.02.28-.05.74.02.42.03-.03.05-.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1896.9,277.36c0-3.34,0-7.59-.09-7.88.03,2.36.06,5.11.09,7.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1896.92,280.04c0,.68.02,1.09.04,1.07-.02-1.22-.03-2.49-.05-3.75,0,1.05.01,2,.01,2.68Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1899.03,596.47c0,1.35,0,2.73,0,4.1,0,.84,0,1.68,0,2.51l-.02.76c-.04.24-.26.42-.38.64-.28.41-.58.81-.89,1.2-.34.42-.56.66-.82.93-.25.27-.52.52-.78.75-.52.47-1.03.9-1.53,1.25-.99.75-1.9,1.31-2.65,1.76-1.5.9-2.39,1.39-2.33,1.42,1.88-1.06,4.1-2.24,6.21-4.07.52-.44,1.05-.93,1.52-1.48.56-.62,1.14-1.44,1.65-2.18.09-.09.07-.21.08-.32v-.34s.03-.69.03-.69c0-.42,0-.83,0-1.25,0-.59,0-1.17,0-1.75,0-4.6-.03-8.6-.16-10.53.05,2.03.07,4.59.08,7.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m20.43,557.02c0-1.21,0-2.82-.01-5.38v5.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m809.79,979.71h-.14s.14,0,.14,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m809.79,979.71c6.17,0,11.95-.04,19.56-.24-6.12-.04-14.88.1-19.56.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m767.71,979.61c.78,0,1.47.02,2.31.02-.92,0-1.53-.02-2.31-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1144.06,978.65s.05-.02,0-.02c-.11.02-.17.04-.22.05l.22-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1060.34,979.94c1.31.04,3.09.07,5.37.09-1.38-.02-3.29-.05-5.37-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m573.34,980.16c.09,0,.09,0,.09,0-.19,0-.23,0-.41,0,.14,0,.23,0,.32,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m846.75,971.35c-.3.38-.6.78-.89,1.15.24-.31.55-.71.89-1.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m883.83,964.69c.43-.02.62-.05.65-.07-.56,0-.81.02-.65.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1753.62,968.61c.23-.11.47-.22.71-.32-.24.11-.47.21-.71.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1754.33,968.29c.99-.45,2-.89,3.01-1.29-1.02.4-2.02.84-3.01,1.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1863.89,690.92c0,.21,0,.38.01.56,0-.1,0-.28-.01-.56Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1751.27,969.77c.78-.4,1.56-.79,2.35-1.16-.79.37-1.58.75-2.35,1.16Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1898.76,98.98c0-.11,0-.23,0-.34,0,.11,0,.23,0,.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m789.88,980.07l-.36.04c.24-.02.35-.03.36-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1898.76,98.64c0-.47-.01-.92-.02-1.34,0,.45.01.9.02,1.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m586.94,13.25c.69,0,1.39,0,2.09,0-.66,0-1.35,0-2.09,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fdecdc"
	    },
	    attrs: {
	      "d": "m1882.05,617.31c-.46.68-.58,1.1-.79,1.45.21-.69.6-2.07,2.32-3.49,1.62-1.47,4.25-2.86,6.92-4.41,1.34-.78,2.7-1.61,3.94-2.58.63-.45,1.21-1.01,1.77-1.52.28-.27.54-.55.78-.83.26-.29.58-.69.83-1.03.25-.36.5-.71.74-1.05.06-.4.04-.81.05-1.19,0-.65,0-1.24,0-1.78,0-.19,0-.37,0-.55-.02.66-.04,1.23-.05,1.68-.01.53-.03.96-.06,1.29-.01.17-.02.31-.03.43-.03.12-.13.19-.17.25-.5.49.25.04.04-1.58-.02-1.18-.06-3.03-.1-5.26-.02-2.14-.05-4.64-.07-7.21-.08-10.24-.14-21.44-.32-14.65-.11-2.42-.13-17.2.06-18.72.29,17.69.43-13.31.69-10.44-.11-6.58-.28,13.9-.42,5.01-.03-10.54.21-18.26.33-24.14l.07,4.4.17-16.28c-.19-2.68-.32,15.77-.42.76.08-3.95-.02-18.97.13-18.5.26,7.14.6,1.95.67,14.74-.03-10.61-.07-44.35-.42-30.72v-12.66c-.15,7.95-.43,30.16-.49,4.78l.08.23-.29-17.65.2-7.69c-.1.23-.18-2.56-.18-9.1.11-1.71.16-7.88.31-7.38-.02-18.98-.21-17.44-.32-19.92-.03-10.61.05-14.59.28-9.63.05-14.54,0-39.91.2-49.83-.17-19.46-.08,4-.34-7.37.66-16.81.26-64.28.17-96.02-.29,4.31-.3,2.14-.31-1.83,0-.55,0-1.13,0-1.73v-.54c.02-.19-.13-.33-.19-.5-.16-.31-.32-.63-.48-.95-.52-1.01-1.05-2.05-1.57-3.07-.47-1.02-.93-2.02-1.34-2.92-.27-.6-.49-1.16-.71-1.67-.03-.18-.27-.95-.62-2.05-.24-.98-.59-2.2-.88-3.48-.23-1.29-.56-2.62-.7-3.81-.15-1.19-.3-2.22-.35-2.89-.04-.67-.04-.98.01-.72.03.13.06.41.12.85.08.44.18,1.04.32,1.84.13.8.29,1.79.58,2.98.13.6.28,1.25.44,1.95.2.69.42,1.45.65,2.26-1.55-5.26-2.38-10.75-2.39-16.26.35-5.64-.09,1.21.73,7.24.27,1.49.44,2.96.75,4.14.28,1.19.5,2.13.65,2.63.35.98.12.23-.58-3.92-1.56-9.01-1.13-16.77.51-24.63.86-3.93,2.08-7.9,3.9-12,.24-.51.49-1.02.73-1.53l.43-.89.28-.58c.08-.19.22-.37.18-.59,0-1.32,0-2.66,0-4.04.01-2.52.03-5.16.04-7.96.41,7.51-.13-17.24.31-11.66.15,4.65.1,10.86.13,17.21l.08-3.93c.12-41.66-.48-12.05-.76-33.88-.05-25.39.32-20.02.52-21.5.07-3.64.03-14.78-.07-21.73.19,14.74-.29,26.7-.54,19.83.47-11.17.04-37.68-.14-44.6-.49,36.25-.02,25.12-.55,59.19.15,4.68.57,3.89.39,24.33-.21-12.83-.23.87-.3,4.5.24-3.93.1,14.19.2,20.41-.1,2.84-.24-.22-.36-1.4-.06-.59-.12-.71-.17.61-.01.66-.04,1.68-.07,3.18,0,.41,0,.85-.01,1.33-.18.42-.46.95-.66,1.37-.44.9-.97,1.9-1.45,3.1-.33,1.26-.66,2.52-.89,3.8-.71,1.86-.95,2.62-1.08,2.91-.13.3-.13.15-.21.27-.08.12-.23.52-.65,1.91-.17.71-.4,1.66-.72,2.96-.17.65-.27,1.4-.43,2.24-.15.84-.33,1.78-.44,2.84.09-1.15.22-1.96.3-2.55.08-.59.12-.97.14-1.24.05-.54,0-.64.07-1.16.09-.52.24-1.47.8-3.69.62-2.19,1.56-5.7,4.04-10.98-.82,1.53-1.43,3.11-2.1,4.6-.55,1.54-1.18,3.02-1.6,4.52-.23.74-.45,1.48-.67,2.2-.18.74-.36,1.46-.54,2.18-.39,1.43-.6,2.86-.87,4.25-.95,5.57-1,10.77-.54,15.68.49,4.92,1.56,9.58,3.23,14.12.21.57.42,1.13.64,1.7.23.56.49,1.12.74,1.68.25.56.5,1.12.76,1.69.29.55.58,1.11.87,1.67.29.56.59,1.13.88,1.7l.5.98v1.11c.03,1.31.04,2.64.06,3.99-.02-1.11-.05-1.72-.07-2.34-.01-.31-.03-.61-.04-.97,0-.39-.02-.84-.03-1.41.02,1.18.05,2.61.08,4.17.01,1.54.03,3.22.04,4.96.01,3.48.03,7.17.04,10.37-.13,14.29-.26-11.3-.41-7.59v23.14c0,.47-.01.58-.03.58.08,6.08.13,11.88-.01,14-.07-2.83-.15-4.96-.22-6.8v-43.06c-.73-1.4-1.45-2.81-2.12-4.24-8.04-17.21-6.57-37.93,2.12-54.73v-112.06c-4.28-1.24-8.56-2.47-12.85-3.71-6.93-2-13.98-4.06-19.98-8.06-6-4-10.89-10.34-11.32-17.54,4.61,2.83,10.63-2.87,10.21-8.27-.41-5.4-4.59-9.64-8.52-13.36-2.17-2.06-4.36-4.09-6.54-6.14h-65.99c2.73-.08-7.78-.15-5.68-.29l-42.12.03c-3.99-.08,11.08-.18,4.68-.15-7.94-.16-13.02.14-17.3.14-3.66-.16-31.44,0-30.28-.37-28.57-.25-12.02.48-38.64.27-3.5-.23,21.14-.05,9.32-.29l-27.62.09c2.5-.11,5.38-.37,15.73-.32-74.65-.3-114.94-1.52-183.17-1.21-9.63-.28,6.92-.18,13.76-.37-49.43.37-69.53-.6-111.63-.57l-.75.23c-17.58-.21-36.23-.32-55.53-.38-9.65-.02-19.45-.04-29.36-.06-2.48,0-4.96,0-7.45,0h-2.99c-.3-.07-.47.19-.68.36l-.61.54-1.22,1.08c-.99.89-1.92,1.8-2.85,2.74-.93.94-1.81,1.91-2.68,2.91-.43.5-.86,1-1.27,1.52l-.61.77-.49.62c-.38.47-.73,1.08-1.04,1.5-.13-.4-.29-.79-.47-1.16l-.14-.28-.2-.38c-.44-.79-.9-1.57-1.38-2.34-.97-1.53-2.02-3.01-3.16-4.42l-.43-.53-.67-.77c-.44-.51-.93-1.06-1.42-1.61l-.37-.41-.09-.1s-.09,0-.13-.01h-.28s-1.1-.01-1.1-.01h-2.11c-6.75,0-13.51-.01-20.26-.02-13.5-.04-26.96-.07-40.25-.11l7.92.16c-9.12.22-23.86.24-34.75.34-1.67-.11,7.88-.48-11.36-.39,3.98.08,12.1.17,9.69.28-5.85-.05-12.36-.1-19.51-.16-7.85-.04-16.4-.08-25.6-.12-2.98,7.99-6.13,16.45-9.41,25.27-1.5,4.04-3.03,8.16-4.59,12.35-.78,2.1-1.56,4.21-2.36,6.35-.3.8-.6,1.6-.89,2.4-.09.22-.18.45-.29.66-.22.42-.5.83-.91,1.08-.1.06-.21.11-.33.15-.06-.04-.03-.22-.04-.33l-.03-.74c-.16-3.05-.31-6.13-.47-9.25-.25-4.85-.51-9.74-.77-14.66-.28-4.96-.62-10.14-1.9-15.4-.16-.65-.34-1.31-.53-1.96l-.38-1.23c-.18-.53-.39-1.05-.58-1.58-.38-1.05-.81-2.09-1.22-3.14-.04-.05-.03-.16-.1-.17h-.21s-.42-.02-.42-.02l-.84-.02c-.56-.01-1.11-.04-1.68-.03-2.85,0-5.71,0-8.57,0-5.02,0-10.06-.01-15.09-.02-10.07-.01-20.15-.03-30.14-.04-19.99-.04-39.64-.09-58.23-.13-125.86-.04-262.35-.09-386.13-.13,16.21.02,8.25.54-5.48.41-39.05-.95-67.74.16-107.66-.49-72.43.3-137.08-.52-204.47.21l-1.3-.27c-10.06-.12-12.79.06-23.35.09l.25-.08c-24.96-.1-55.17.17-69.5.04l-.92.3c-14.84.03-7.7-.23-22.9-.06l.44-.15-17.72.29c.85-.26-9.61-.28-21.77-.25-1.52,0-3.07,0-4.62.01h-2.6s-2.19,0-2.19,0h-.27c-.09,0-.19-.03-.25.06l-.4.37-.8.74c-.73.67-1.45,1.33-2.17,2-.57.51-1.13,1.02-1.69,1.52-1.13,1.01-2.26,2.04-3.34,3.07-2.17,2.06-4.17,4.18-5.72,6.3-1.57,2.1-2.68,4.15-3.39,5.75-1.12,2.63-1.79,5.77-2.01,8.92-.24,3.18-.12,6.39-.08,9.64.11,6.57.23,13.83.36,21.4.06,3.78.11,7.63.17,11.51.04,3.83-.06,7.61-.46,11.28-.38,3.67-1.15,7.18-2.4,10.31-1.22,3.15-3.09,5.77-5.33,7.79-.2.19-.51.41-.89.67-.39.26-.81.61-1.35.94-.57.31-1.17.7-1.89,1.06-.76.32-1.51.76-2.45,1.07-1.79.74-4.04,1.33-6.55,1.94-2.52.6-5.38,1.11-8.45,1.78-3.07.67-6.39,1.48-9.76,2.82-1.68.67-3.37,1.5-4.99,2.49-.79.54-1.62,1.02-2.37,1.61-.77.58-1.46,1.19-2.14,1.79-2.66,2.44-4.76,4.84-6.85,6.54-1.04.86-2.05,1.51-3.06,2.01-.26.12-.52.24-.78.34l-.53.2c-.34.12-.67.23-1.02.32-1.39.37-2.84.68-4.21,1-.02.54,0,1.04-.01,1.52.02,39.7.06,94.15.09,145.7,1.35.74,2.82,1.53,4.03,2.23l1.14.66,1.01.6c1.34.8,2.64,1.64,3.92,2.49.63.43,1.26.87,1.89,1.3l1.29.92c.1.08.22.2.19.34-.02.12-.13.19-.22.23.1.08.23.14.38.19-.28.16.08-.02-1.57.7-1.2.53-2.38,1.1-3.54,1.72-1.16.61-2.3,1.26-3.41,1.95-.76.46-3.08,1.97-4.74,3.26-.03-.22-.07.58-.1.92-.01.17-.03.23-.03-.02,0-.12,0-.32,0-.62,0-.07,0-.15,0-.24,0-.09-.02-.19.09-.23.16-.12.35-.25.56-.4l-.42.28-.21.14c-.07.05-.02.16-.04.23,0,.34-.02.68-.03,1.03-.01.7-.03,1.43-.04,2.17-.01.93-.03,1.9-.04,2.92-.01,1.73-.03,3.59-.04,5.55.01,3.9.02,8.17.03,12.44.05,8.55.12,17.15,0,23.07.31-7.44.05-10.31.06-18.71.16-12.08.49-.54.32,15.77l-.08-.32.18,11.13c-.27,1.24-.39,11.35-.66,12.64.06,48.48.52,81.48.4,131.49-.3-5.15.08,35.95-.44,25.9.2,30.04.42-4.95.79,8.77,0,8.39.13,17.2-.06,18.71-.12-3.95-.32,6.82-.36,0l.04,20.07c-.04,1.91-.11-2.5-.15-4.72.3,40.87-.34,72.48-.04,109.14.19,2.73.05-14.55.24-11.88.38,36.9-.34,32.6-.07,67.03l-.26-7.13c.07,3.7.12,6.7.18,9.74.02,1.52.04,3.05.07,4.69.01,2.32.03,4.79.04,7.52.78.4,1.59.82,2.42,1.25.41.21.84.44,1.23.67l.42.25.28.18c.76.49,1.53,1.05,2.27,1.7,1.47,1.3,2.87,2.96,3.81,5.18.12.43.06.36-.17-.06-.23-.41-.62-1.18-1.28-2.08-.65-.91-1.56-1.95-2.76-2.94-.6-.5-1.27-.98-2-1.44l-.27-.17-.34-.2c-.39-.23-.85-.49-1.3-.72-.9-.46-1.81-.92-2.72-1.39-.01-2.64-.03-5.26-.04-7.72-.02-1.67-.04-3.23-.05-4.56,0,3.27,0,7.57,0,12.33.78.4,1.56.8,2.35,1.21.4.2.8.41,1.18.62l.84.49c.65.4,1.27.84,1.86,1.3,1.17.93,2.19,1.96,2.99,3.09.82,1.12,1.41,2.3,1.85,3.52.43,1.22.72,2.47.91,3.64.38,2.34.48,4.29.55,5.11.07.82.11.54.09-1.29.43,7.17-.06,12.11-.61,16.16-.59,4.06-1.23,7.27-2.17,11.08,0,.13.82-3.16,1.28-5.48.26-1.15.4-2.06.45-2.15.03-.09.01.64-.37,2.74-.94,4.85-2.35,10.33-4.24,16.11-.97,2.88-2.01,5.86-3.19,8.86-.57,1.51-1.21,3.02-1.82,4.55-.32.76-.64,1.52-.97,2.29l-.43,1.01-.23.55c-.08.18-.02.4-.04.59v1.83c-.02,13.59-.03,27.75-.04,40.26-.08-.23-.19,1.52-.23-.65.4,20.11-.28,17.99-.2,45.62.04,21.44.09,44.6.14,68.64,7.41-.02,14.9-.03,22.42-.05,1.53,0,3.05,0,4.58-.01h4.01s2.24,0,2.24,0h1.12c.08-.02.22.03.25-.04l.05-.28.1-.55.79-4.42.2-1.11.16-.8.22-1.09c.3-1.45.62-2.91.98-4.35,1.12-4.6,2.53-9.15,4.19-13.6-.07,1.95-.12,3.9-.14,5.84-.01,2.3-.02,4.6.04,6.89.03,1.15.06,2.29.09,3.43l.06,1.71.14,3.07.17,3.19.08,1.59v.2s.02.1.02.1h.1s.4,0,.4,0h.8c2.13,0,4.25,0,6.37,0,2.27,0,4.53,0,6.78,0,17.63,0,34.64,0,50.59,0,3.98-.1,8.42-.18,13.2-.24,1.4-.01,2.83-.03,4.29-.04.57,0,1.14,0,1.72,0h.11s.08-.07.08-.07l.16-.15.31-.3.63-.6c.61-.59,1.23-1.18,1.85-1.78,1.7-1.68,3.6-3.15,5.65-4.52,2.05-1.36,4.26-2.53,6.59-3.43,2.33-.92,4.77-1.55,7.26-1.79,1.25-.15,2.48-.13,3.75-.09,1.44.08,2.94.17,4.52.18,1.58,0,3.22-.05,5-.38,1.75-.35,3.82-.93,5.7-2.67.3-.19.57-.43.83-.71.26-.27.54-.54.76-.84.42-.61.88-1.29,1.11-1.96.09-.35.18-.69.25-1.05l.04-.27.02-.13v.03s-.01,0-.01,0c0-.04,0-.07-.02-.11-.02-.08-.05-.15-.08-.23-.06-.16-.11-.34-.11-.54,0-.2.04-.41.13-.61.04-.1.1-.2.17-.29.03-.04.07-.09.11-.13.04-.03.04.05.07.07.11.36.1.43.07.43-.02,0-.04-.03-.07-.07,0,0-.01-.02-.02-.03l-.04.05s-.05.07-.07.11c-.09.15-.13.3-.1.38.02.09.1.06.27.15.01-.16.04-.26.09-.32.04-.05.1-.07.17-.04,0,.16.13.59.22,1.04l.02.08c.05.2.1.4.16.6.13.52.26,1.05.39,1.58.26,1.07.5,2.18.72,3.28.45,2.2.8,4.41,1.05,6.37.06.53.13,1.04.19,1.53.08.82.16,1.6.23,2.35.15,1.6.29,3.03.4,4.21.03.31.05.6.08.87.01.06,0,.15.03.19h.19c.13,0,.25,0,.37,0,.48,0,.88.01,1.21.02.66.01,1.01.02.99.04,0,0-.11.01-.32.02-.2,0-.51.01-.92.02-.42,0-.94.01-1.58.02-.11.04-.07-.1-.09-.17,0-.08-.02-.16-.03-.25-.02-.17-.04-.35-.06-.53-.04-.37-.09-.77-.13-1.21-.18-1.56-.4-3.57-.69-6.07-.2-1.36-.45-3-.82-4.91.27,1.48.5,2.97.7,4.47.08.45.25,2.25.39,3.56l.46,4.54.06.58s0,.11.02.14h1.61s2.35,0,2.35,0h27.93s37.82,0,37.82,0c16.72.02,9.77-.45,28.26-.31,3.76.16-6.64.11-5.13.3,55.51.4,64.14-1.04,115.9-.79l-4.4.07c4.41-.07,10.8-.1,16.12-.12,2.66-.01,5.05-.02,6.79-.03.87,0,1.58-.01,2.07-.02.5,0,.78-.02.81-.03-6.65-.54-9.29.29-25.09-.03,1.38-.45,19.69-.24,18.67-.59,12.11.16,19.23-.09,29.8-.12,17.99.28,43.85.08,57.42.44,8.81-.14,18.67-.59,37.64-.61,13.58.36-3.21.34,15.29.47l2.97-.26c15.16.04,12.79.11,12.24.24,16.22.01,13.49-.36,33.83-.19l-11.34.26c15.05-.1,21.17-.06,42.12-.03-.47.15-8.87.14-15.02.1,11.37.39,19.48-.17,25.63-.13-1.76-.11-16.27-.17-9.16-.43,10.38.05,22.14-.36,29.56-.05l-11.35.25c21.7-.2,11.6-.33,36.47-.23-1.34.02-.69.08-1.24.14,15.75-.34,36.33-.03,59.6,0l-4.41.07c9.39-.09,14.55-.32,19.62-.31-13.27-.15-9.65-.23-10.84-.48,17.54.44,26.79-.5,55.42-.25-.46.15-7.36.33-15.24.17-9.79.45-11.01.82-28.46,1.03,9.89-.09,21.38-.15,21.29-.02l3.04-.37c6.58,0,11.77.01,16.73.01,2.82-.26-13.3-.43,1.95-.6,17.18-.13,9.12.43,11.81.24,5.91-.04,9.48-.09,11.86-.14,1.25-.03,2.2-.05,2.98-.07.53-.01,1.01-.02,1.45-.03.22,0,.44-.01.65-.01h.31c.11,0,.22,0,.26-.11.82-1.12,1.63-2.21,3.23-4.39,1.38-1.81,3.44-4.51,6.89-9.04-1.05,1.43-2.95,4.02-4.29,5.79.98-1.28,1.99-2.59,3.03-3.94,1.36-1.78,2.64-3.54,4.15-4.86,1.52-1.33,3.09-2.01,4.98-2.01,1.9-.03,3.98.54,6.13.97,8.55,1.84,15.83,2.27,18.25,2.67-1.24-.02-1.97-.03-3.19-.04-1.22,0-2.91-.17-6.06-.54l.27-.05c-9.1-1.16-5.31-.6.04.15,4.57.63,10.29.79,10.12.92,1.65-.01,6.06.07,11.29-.28,3.51-.19,7.37-.66,10.99-1.19,1.81-.3,3.56-.63,5.18-.92,1.61-.36,3.1-.69,4.39-.97l-3.34.44c2.13-.53,3.98-1,5.58-1.5,1.6-.46,2.96-.87,4.1-1.28,1.14-.38,2.09-.7,2.87-.95.77-.28,1.37-.5,1.84-.67,1.89-.67,1.69-.49,1.49-.29-.2.21-.41.45,1.48-.13.93-.32,2.38-.86,4.6-1.76,1.09-.49,2.37-1.08,3.88-1.76,1.5-.7,3.12-1.56,4.93-2.35,2.28-1.01,3.82-1.36,4.85-1.51,1.02-.14,1.55-.11,1.74-.13.37,0-.67-.11-1.92.07-1.25.14-2.77.63-3.27.8-.25.08-.25.06.16-.1.41-.16,1.24-.5,2.6-.78,2.95-.52,5.6.2,8.2,1.07,1.29.44,2.6.94,3.9,1.44,1.3.49,2.61,1,3.96,1.54,5.39,2.15,11.55,4.63,21.17,9.05,2.64,1.31,6.63,3.33,10.03,5.19,3.39,1.86,6.19,3.53,6.55,3.92,1.97,1.05,4.28,2.32,6.77,3.76,1.25.71,2.53,1.49,3.86,2.26,1.58.96,3.19,1.94,4.83,2.94,6.3,0,12.85.01,18.46.02,5.32-.01,9.75-.05,12.15-.16-7.54-.1-12.51-.09-16.81-.05-2.15.02-4.14.05-6.21.07-2.35.02-4.78.03-7.56.05-2.1-1.27-4.49-2.71-7.34-4.44-2.55-1.51-5.52-3.26-9.1-5.27,2.17,1.04,4.32,2.11,6.46,3.21,1.51.86,3.06,1.76,4.63,2.69.79.47,1.58.94,2.39,1.42,1.02.62,2.06,1.25,3.1,1.88,7.98-.02,16.32-.04,23.95-.06,7.38-.01,14.08-.01,19.06.04-2.51-.07-3.62-.15-2.04-.22,25.57-.13,32.94-.46,57.8-.36,3.27.31-11.28.25-21.89.28,8.02.12,12.21.13,17.51.11,2.65,0,5.58-.01,9.39-.02,1.91,0,4.04,0,6.47,0,1.22,0,2.51,0,3.88,0,.69,0,1.4,0,2.13,0,.43,0,.86,0,1.3,0,.45-.07.9-.14,1.36-.21.17,0,.03.05-.33.13-.23.04-.54.1-.91.17-.21.02-.55.01-.71.02-.17,0-.36,0-.55,0-1.55,0-3.78,0-6.14.01-4.71,0-9.95-.01-11.39.12l13.78-.04h3.45s.86-.01.86-.01h.65s.65-.11.65-.11l1.68-.27c2.24-.36,4.49-.69,6.74-.99-.11.03,0,.03,0,.05,1.93-.48,7.1-1.11,13.89-1.64,6.79-.53,15.21-.92,23.6-1.31,19.91-.71,31.41-1.14,40.67-1.55,9.26-.41,16.31-.77,27.35-1.11,5.94.06,7.69.16,5.19.3-9.8-.11-8.05.06-11.47.22,13.46-.27,29.46.16,21.95.37,21.39-.21-7.7-.21,5.37-.39,9.76-.04,19.53,0,29.29.1-3.46-.26-13.77-.41,1.4-.44,6.39.02,11.13.09,16.36.2,5.23.08,10.94.24,19.3.47-2.42.05,5.26.48-7.28.15,8.06.26,20.67.72,25.54.66-9.13-.4-1.63-.25,6.44.06,8.08.25,16.73.64,9.93.11,6.08.41,12.16.73,18.23,1.2-4.16-.27-4.63-.14-10.77-.5,5.16.58,14.93.76,21.31,1.12,3.21.25,8.98.7,14.12,1.1,5.14.43,9.64.86,10.32.98,1.44.11,3.4.25,5.57.42l.41.03c.21.02.43.03.59.02h.84c.57,0,1.14,0,1.72,0,1.16,0,2.33.01,3.48.02,4.59.03,8.79.09,10.11.18,8.61-.07.7-.23,3.2-.34l29.26.03c1.56.19,4,.73-.41.8,11.09-.18,3.96-.57,20.69-.55-9.6.37,22.12.29,8.2.73,9.58.27,36.93.26,51.98.17,9.33-.3-16.29-.17-15.32-.47,42.3-.11,44.91-.94,75.95-.8l-8.06-.08c19.38-.17,17.2-.13,28.5-.39-5.37.37,22,1.01,53.82.93,2.69-.19-17.81-.36-12.62-.66l21.14-.06c1.53.03-.79.09-3.52.14,9.48-.07,18.29.06,25.42.14,3.56.03,6.71.05,9.3.07.75,0,1.46,0,2.13-.01.41,0,.8,0,1.18-.01h.28c.09-.01.14-.12.21-.17.13-.13.26-.26.39-.39.82-.84,1.52-1.56,2.08-2.13,3.05-2.56,6.4-4.74,9.94-6.58-.21.11-.42.2-.63.31.53-.35,2.05-1.26,4.17-2.31,2.12-1.04,4.84-2.23,7.7-3.22,5.71-2.04,11.89-3.14,14.05-3.44,5.28-.82,9.8-1.18,13.74-1.45,3.94-.24,7.32-.36,10.4-.45,6.16-.18,11.11-.23,17.09-.55-1.9.06-5.22.13-5.91.04-.7-.12,1.21-.16,9.77-.93-.03.13,2.2.07,5.56-.35,1.68-.17,3.63-.51,5.73-.85,2.08-.43,4.31-.83,6.52-1.45,4.43-1.16,8.81-3.12,11.59-5.43,1.41-1.11,2.42-2.23,3.07-3.01.69-.76.97-1.24.98-1.15,1.13-1.53,2.12-3.56,2.9-5.69.78-2.14,1.31-4.4,1.65-6.45.69-4.11.87-7.36.81-7.77l.27,1.19c-.09-.41-.02-2.31.19-5.15.1-1.42.28-3.07.54-4.88.36-1.79.66-3.78,1.31-5.83,1.17-4.13,3.1-8.61,5.68-12.85,2.56-4.25,5.71-8.25,8.9-11.73-1.17,1.83,2.21-2.1,7.26-6.64,2.53-2.27,5.45-4.7,8.24-6.79.7-.52,1.37-1.04,2.04-1.51.79-.56,1.55-1.09,2.26-1.6.45-.32.89-.62,1.31-.92l.16-.11c.05-.04.12-.07.1-.14v-.37c.02-.25.03-.49.03-.73.02-.48.03-.94.05-1.37,0-.22.02-.44.03-.64.01-.15.02-.29.03-.43-.49-3.62-.19-34.16-.61-37.55-.02-14.82.43-13.34.59-17.1l-.18-6.9c.1-3.11.16-9.76.21-17.64.04-8.32.1-17.94.14-26.44-1.08-.59-2.14-1.17-3.19-1.74-.73-.41-1.45-.81-2.15-1.2-1.3-.74-2.51-1.47-3.63-2.18-2.13-1.26-4.18-2.58-6-4.18-1.9-1.52-3.56-3.32-5.17-5.16l-1.53-2.26c-.51-.75-.93-1.57-1.39-2.35-.71-.95-2.46-4.18-3.49-6.39-.98-2.23-1.49-3.31-.08.28-1.04-2.48-2.03-4.99-2.81-7.59-.31-.25-1.28-2.95-2.37-7.68-1.08-4.72-2.26-11.5-3.3-19.72-.32-3.8-.11-2.8.33.75-.45-4.08-.43-5.25-.42-5.96.02-.64.1-.92.07-2.63-.03.97-.61-5.49-.47-10.29.05-2.65.24-4.78.15-4.91-.04-.06-.14.38-.32,1.52-.1.57-.17,1.32-.26,2.27-.11.95-.18,2.1-.23,3.48-.1.76-.19-2.1.21-6.12.37-4.02,1.49-9.17,2.97-12.9.31-.75.74-1.45,1.11-2.17l.57-1.07.64-1.03c1.26-2.91,2.95-5.68,4.64-8.46,3.55-5.3,6.19-9.14,7.79-13.26.79-2.04,1.42-4.14,1.53-6.44.08-.57.03-1.16.01-1.75-.01-.3-.02-.6-.03-.9-.03-.3-.09-.6-.14-.91-.12-.61-.18-1.25-.36-1.87-.17-.62-.37-1.24-.57-1.86.21.63.44,1.29.63,1.97.19.69.29,1.4.43,2.09.21,1.39.28,2.76.18,3.97-.02.3-.02.6-.05.89-.04.28-.08.55-.12.81-.08.52-.13,1.01-.22,1.42-.19.82-.32,1.43-.36,1.74-.04.31,0,.32.17-.07.08-.19.19-.48.33-.89.14-.4.32-.91.45-1.57.14-.66.34-1.43.4-2.39.03-.47.12-.98.1-1.53-.02-.55-.04-1.14-.06-1.76-.16-1.22-.37-2.68-.85-4.09-.44-1.41-1-2.82-1.25-4.21.27,1.47.9,2.99,1.41,4.61.13.4.25.82.35,1.24.08.42.16.84.24,1.25.19.82.23,1.63.26,2.41.12,3.15-.56,5.85-1.35,8.12-.8,2.3-1.79,4.19-2.76,5.95-.97,1.76-1.98,3.34-3,4.93,1.61-2.36,2.75-4.26,2.94-4.53.19-.28-.51,1.17-2.92,4.93,3-4.51,4.56-7.45,5.37-9.45.42-.99.66-1.75.88-2.34.19-.61.3-1.09.43-1.55.06-.23.12-.47.19-.72.05-.26.09-.54.15-.86.11-.63.28-1.41.32-2.53.04-.56.1-1.19.03-1.93-.04-.74-.05-1.58-.27-2.51-.21-1.93-1.22-4.13-1.81-6.31.15.22.19.06.13-.49-.02-.27-.06-.64-.06-1.07,0-.21.01-.44.04-.69.06-.25.12-.52.17-.81.33-1.11,1.15-2.48,3.51-4.02,1.15-.77,2.59-1.56,4.29-2.48,1.7-.93,3.67-1.95,5.78-3.54-2.12,1.57-4.29,2.67-6.32,3.74-2.01,1.06-3.92,2.09-5.36,3.3.2-.19.44-.41.71-.67.3-.24.66-.51,1.04-.79-1.98,1.3-2.78,2.27-3.26,2.94Zm14.77-312.11c-.04-.5-.07-.1-.1.76v-6.96l.1,6.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1898.63,600.32c.01-.45.03-.94.05-1.5-.02.35-.04.86-.05,1.5Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1143.27,978.86c-.68.11-1.93.33-4.21.71,4.96-.8,9.95-1.45,14.96-1.99-3.33.29-6.65.66-9.96,1.07,0,.03-.1.08-.79.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m692.91,979.85c-1.26.03-2.51.06-3.62.08,2.44-.01,3.25-.05,3.62-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m576.51,980.39c8.31-.07.9-.15-3.17-.23-.19.06,0,.13,3.17.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1422.25,978.65c2.36.14,2.87.14,2.54.08-1.76-.12-2.83-.16-2.54-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1867.93,663.14c.24-.47.6-1.41,1.24-2.55-.21.4-.42.78-.63,1.19-.19.42-.39.86-.61,1.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1864.25,700.07c.24,2,.56,4.61,1.18,8.31-.56-3.63-.89-6.24-1.18-8.31Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1243.29,973.54c-2.78.05-5.51.12-7.87.22,4.29-.08,6.43-.15,7.87-.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1867.03,716.76c.69,3.37,1.54,6.69,2.56,9.95.04.05.09.16.11.15-1.07-3.3-1.95-6.68-2.67-10.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1872.71,654.73c1.19-1.8,2.29-3.45,3.35-5.05-2.32,3.43-5.43,7.9-6.89,10.91,1.11-2.2,2.38-4.08,3.54-5.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1700.33,978.85c-.32,0-.71,0-1.12,0-8.16.13-3.05.08,1.12,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1888.93,753.64c.34.23.75.49,1.13.74.84.5,1.71.98,2.58,1.45-1.27-.7-2.51-1.42-3.71-2.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1890.3,611.52c-.53.25-.66.29-.67.27-1.75.97-3.26,1.82-4.33,2.57,1.23-.81,2.83-1.66,5-2.84Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m1852.25,949.17c1.19-1.14,1.83-2.09,2.27-2.67.44-.58.55-.91.57-.96-1.09,1.56-2.18,2.71-2.8,3.33-.63.62-.74.79-.04.3Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m202.42,363.77c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m202.48,363.78h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m202.88,363.85c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "202.75 363.78 202.73 363.84 202.82 363.74 202.75 363.78"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "202.69 363.72 202.7 363.74 202.83 363.68 202.69 363.72"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m203.2,363.89l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m208.77,363.22s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m210.29,363.14s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m207.81,363.46s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.52,363.9s0,.02,0,.04h0s.02-.03.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m212,362.95s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m207.26,363.47s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m209.79,362.97s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m204.61,364.03s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.16,364.02s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.51,364.03s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m204.68,364.02s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m208.76,363.26s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m208.29,363.39s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m206.52,363.34s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m208.38,363.39s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m207.05,363.43s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m224.81,364.45s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.97,364.13h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m218.01,363.93s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m223.63,364.41s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m211.89,364.31s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.13,364.02s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m219.93,362.99c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m224.85,364.49s0,0,0-.01c0,0,0,0,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m221.58,362.96s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.68,363.88h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m219.03,362.92l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.03-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.13-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m216.85,364.31s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m218.07,363.81s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m203.39,363.49l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m203.45,364.05s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m204.82,364.3l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m204.33,363.41l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.11,364.31c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.04,363.34c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.7,364.02c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.2,363.33c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m206.02,364.22l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.49,363.49v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.75,363.36l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m205.88,363.44v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m207.76,364.21c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m207.39,363.26s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m207.67,363.18s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m210.34,362.92s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m210.27,362.95s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m210.89,362.97s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.02,364.45c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "215.17 364.37 215.18 364.4 215.22 364.46 215.17 364.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.58,364.47s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.54,364.51s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.51,364.49v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.7,364.49l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.97,364.46c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m215.93,364.23c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "216.38 364.4 216.44 364.45 216.46 364.4 216.38 364.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m216.62,364.42l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m216.96,364.52c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.74,364.24s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.72,363.81c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.87,364.39s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m218.04,364.36s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m217.79,364l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "218.73 364.27 218.87 364.24 218.83 364.23 218.73 364.27"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "218.82 364.32 218.83 364.36 218.93 364.28 218.82 364.32"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "218.97 364.36 218.95 364.36 218.87 364.39 218.97 364.36"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m219.26,364.39l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m220.24,362.91s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m220.41,363.07l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m222.5,363.16c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m227.97,363.93s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.49,322.8c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.55,322.82h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.95,322.88c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "95.81 322.81 95.8 322.87 95.88 322.78 95.81 322.81"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "95.75 322.75 95.77 322.78 95.89 322.71 95.75 322.75"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m96.26,322.93l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.83,322.26s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.36,322.17s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.88,322.49s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.59,322.94s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m105.07,321.98s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.33,322.5s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m102.86,322s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.68,323.06s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.22,323.05s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.57,323.06s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.74,323.05s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.83,322.29s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.36,322.42s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.58,322.37s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.45,322.43s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.12,322.47s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m117.88,323.49s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.03,323.16h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.07,322.97s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m116.69,323.44s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m104.96,323.35s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.19,323.06s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113,322.02c-.03.12.02,0,.08.06l.06-.07c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "117.92 323.52 117.92 323.51 117.92 323.52 117.92 323.52"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m114.65,321.99s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.74,322.91h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m112.09,321.95l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.05.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.91,323.34s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.14,322.84s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m96.46,322.52l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m96.52,323.08s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.89,323.33l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.4,322.44l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.18,323.34c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.1,322.38c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.77,323.05c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.27,322.37c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.09,323.25l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.55,322.52v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.82,322.39l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.95,322.47v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.83,323.24c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.46,322.29s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.74,322.21s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.41,321.95s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.34,321.98s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.95,322.01s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.08,323.48c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "108.24 323.4 108.24 323.44 108.28 323.49 108.24 323.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.64,323.51s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.61,323.54s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.58,323.52v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.76,323.52l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.03,323.49c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109,323.27c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "109.44 323.43 109.51 323.48 109.52 323.44 109.44 323.43"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.69,323.46l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.03,323.55c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.81,323.27s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.79,322.84c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.93,323.43s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.11,323.39s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.86,323.03l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "111.8 323.31 111.94 323.27 111.89 323.27 111.8 323.31"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "111.89 323.35 111.89 323.39 112 323.32 111.89 323.35"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "112.04 323.4 112.02 323.39 111.94 323.43 112.04 323.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m112.33,323.42l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113.3,321.95s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113.47,322.11l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m115.57,322.19c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.04,322.96s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.49,528.34c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.55,528.36h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.95,528.42c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "95.81 528.35 95.8 528.41 95.88 528.32 95.81 528.35"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "95.75 528.29 95.77 528.32 95.89 528.25 95.75 528.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m96.26,528.47l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.83,527.8s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.36,527.71s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.88,528.03s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.59,528.48s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m105.07,527.52s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.33,528.04s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m102.86,527.54s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.68,528.6s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.22,528.59s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.57,528.6s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.74,528.59s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.83,527.83s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.36,527.96s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.58,527.91s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.45,527.97s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.12,528.01s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m117.88,529.03s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.03,528.7h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.07,528.51s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m116.69,528.98s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m104.96,528.89s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.19,528.59s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113,527.56c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "117.92 529.06 117.92 529.05 117.92 529.06 117.92 529.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m114.65,527.53s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.74,528.45h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m112.09,527.49l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.91,528.88s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.14,528.38s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m96.46,528.06l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m96.52,528.62s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.89,528.87l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.4,527.98l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.18,528.88c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.1,527.92c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.77,528.59c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.27,527.91c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.09,528.79l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.55,528.06v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.82,527.93l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.95,528.01v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.83,528.78c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.46,527.83s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.74,527.75s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.41,527.49s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.34,527.52s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.95,527.55s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.08,529.02c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "108.24 528.94 108.24 528.98 108.28 529.03 108.24 528.94"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.64,529.05s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.61,529.08s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.58,529.06v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.76,529.06l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.03,529.03c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109,528.81c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "109.44 528.97 109.51 529.02 109.52 528.98 109.44 528.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.69,529l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.03,529.09c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.81,528.81s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.79,528.38c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.93,528.97s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.11,528.93s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.86,528.57l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "111.8 528.85 111.94 528.81 111.89 528.81 111.8 528.85"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "111.89 528.89 111.89 528.93 112 528.86 111.89 528.89"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "112.04 528.94 112.02 528.93 111.94 528.97 112.04 528.94"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m112.33,528.96l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113.3,527.49s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113.47,527.65l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m115.57,527.73c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.04,528.5s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m118.47,637c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m118.53,637.02h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m118.93,637.08c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "118.79 637.01 118.78 637.07 118.86 636.98 118.79 637.01"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "118.73 636.96 118.74 636.98 118.87 636.92 118.73 636.96"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.24,637.13l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m124.81,636.46s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m126.33,636.37s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.85,636.69s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.57,637.14s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m128.04,636.18s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.3,636.7s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m125.84,636.21s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.66,637.27s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.2,637.25s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.55,637.26s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.72,637.26s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m124.8,636.49s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m124.33,636.62s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m122.56,636.58s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m124.42,636.63s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.09,636.67s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m140.85,637.69s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m134.01,637.36h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m134.05,637.17s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m139.67,637.64s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m127.93,637.55s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.17,637.26s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m135.98,636.22c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "140.9 637.73 140.9 637.71 140.89 637.72 140.9 637.73"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m137.62,636.2s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.72,637.12h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m135.07,636.15l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.04.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.03.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m132.89,637.55s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m134.11,637.05s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.44,636.72l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.5,637.29s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.86,637.53l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.38,636.64l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.16,637.54c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.08,636.58c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.75,637.26c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.25,636.57c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m122.06,637.45l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.53,636.73v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.8,636.6l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.92,636.67v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.81,637.44c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.44,636.5s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.71,636.41s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m126.38,636.15s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m126.32,636.18s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m126.93,636.21s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.06,637.68c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "131.21 637.6 131.22 637.64 131.26 637.69 131.21 637.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.62,637.71s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.58,637.75s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.56,637.72v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.74,637.72l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m132.01,637.69c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.98,637.47c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "132.42 637.63 132.49 637.68 132.5 637.64 132.42 637.63"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m132.66,637.66l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133,637.75c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.79,637.47s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.77,637.04c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.91,637.63s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m134.09,637.59s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m133.84,637.23l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "134.78 637.51 134.92 637.48 134.87 637.47 134.78 637.51"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "134.87 637.55 134.87 637.59 134.98 637.52 134.87 637.55"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "135.01 637.6 135 637.59 134.91 637.63 135.01 637.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m135.31,637.63l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m136.28,636.15s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m136.45,636.31l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m138.54,636.4c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m144.01,637.17s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m86.08,833.45c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m86.14,833.47h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m86.54,833.54c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "86.4 833.47 86.39 833.53 86.47 833.43 86.4 833.47"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "86.34 833.41 86.35 833.43 86.48 833.37 86.34 833.41"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m86.85,833.58l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m92.42,832.91s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m93.95,832.83s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m91.47,833.15s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.18,833.59s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.65,832.64s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m90.91,833.16s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m93.45,832.66s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.27,833.72s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.81,833.71s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.16,833.72s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.33,833.71s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m92.41,832.95s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m91.94,833.07s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m90.17,833.03s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m92.03,833.08s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m90.7,833.12s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m108.46,834.14s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.62,833.82h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.66,833.62s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m107.28,834.1s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.54,834s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.78,833.71s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.59,832.68c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "108.51 834.18 108.51 834.17 108.5 834.17 108.51 834.18"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m105.23,832.65s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.33,833.57h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m102.68,832.6l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.5,834s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.72,833.5s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m87.05,833.18l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m87.11,833.74s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.47,833.99l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m87.99,833.1l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.77,834c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.69,833.03c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.36,833.71c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.86,833.02c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.67,833.9l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.14,833.18v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.41,833.05l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.53,833.13v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m91.42,833.89c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m91.05,832.95s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m91.32,832.87s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m93.99,832.61s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m93.93,832.64s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m94.54,832.66s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.67,834.14c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "98.82 834.05 98.83 834.09 98.87 834.15 98.82 834.05"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.23,834.16s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.19,834.2s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.17,834.18v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.35,834.18l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.62,834.14c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m99.59,833.92c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "100.03 834.09 100.1 834.14 100.11 834.09 100.03 834.09"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.27,834.11l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m100.61,834.21c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.4,833.93s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.38,833.5c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.52,834.08s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.7,834.04s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m101.45,833.69l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "102.39 833.96 102.53 833.93 102.48 833.92 102.39 833.96"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "102.48 834.01 102.48 834.05 102.59 833.97 102.48 834.01"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "102.62 834.05 102.61 834.05 102.52 834.08 102.62 834.05"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m102.92,834.08l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m103.89,832.6s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m104.06,832.76l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m106.15,832.85c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.62,833.62s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m140.74,915.87c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m140.8,915.89h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m141.2,915.95c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "141.06 915.88 141.05 915.94 141.13 915.85 141.06 915.88"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "141.01 915.82 141.02 915.85 141.14 915.78 141.01 915.82"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m141.51,916l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m147.08,915.33s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m148.61,915.24s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m146.13,915.56s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m155.84,916.01s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m150.32,915.05s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m145.58,915.57s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m148.11,915.08s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m142.93,916.14s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.47,916.12s0,0,0,0c0,.02,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.82,916.13s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143,916.13s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m147.08,915.36s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m146.61,915.49s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m144.84,915.45s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m146.7,915.5s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m145.37,915.54s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m163.13,916.56s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.29,916.23h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.32,916.04s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m161.94,916.51s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m150.21,916.42s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m155.44,916.13s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m158.25,915.09c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "163.17 916.6 163.17 916.58 163.17 916.59 163.17 916.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m159.9,915.07s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m155.99,915.99h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m157.34,915.02l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.02.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.07-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.13.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0,0,.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.29.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.06-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.17-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05,0-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.1-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.04.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m155.16,916.42s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.39,915.92s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m141.71,915.59l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m141.77,916.15s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.14,916.4l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m142.65,915.51l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.43,916.41c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.35,915.45c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m144.02,916.13c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.52,915.44c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m144.34,916.32l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.81,915.6v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m144.07,915.47l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m144.2,915.54v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m146.08,916.31c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m145.71,915.37s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m145.99,915.28s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m148.66,915.02s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m148.59,915.05s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m149.21,915.08s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m153.33,916.55c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "153.49 916.47 153.49 916.51 153.53 916.56 153.49 916.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m153.89,916.58s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m153.86,916.62s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m153.83,916.59v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m154.02,916.59l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m154.29,916.56c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m154.25,916.34c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "154.69 916.5 154.76 916.55 154.78 916.51 154.69 916.5"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m154.94,916.53l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m155.28,916.62c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.06,916.34s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.04,915.91c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.19,916.5s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.36,916.46s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m156.11,916.1l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "157.05 916.38 157.19 916.35 157.14 916.34 157.05 916.38"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "157.14 916.42 157.14 916.46 157.25 916.39 157.14 916.42"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "157.29 916.47 157.27 916.46 157.19 916.5 157.29 916.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m157.58,916.5l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m158.55,915.02s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m158.72,915.18l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m160.82,915.27c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m166.29,916.03s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m771.55,826.8c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m771.62,826.82h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m772.02,826.88c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "771.88 826.81 771.87 826.87 771.95 826.78 771.88 826.81"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "771.82 826.76 771.83 826.78 771.96 826.72 771.82 826.76"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m772.33,826.93l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.9,826.26s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m779.42,826.17s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.94,826.49s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.66,826.94s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m781.13,825.98s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.39,826.5s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m778.92,826.01s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.74,827.07s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.29,827.05s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.64,827.07s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.81,827.06s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.89,826.29s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.42,826.42s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m775.65,826.38s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.51,826.43s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.18,826.47s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m793.94,827.49s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787.1,827.16h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787.14,826.97s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m792.76,827.44s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m781.02,827.35s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.26,827.06s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m789.06,826.02c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "793.99 827.53 793.99 827.52 793.98 827.52 793.99 827.53"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m790.71,826s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.81,826.92h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m788.16,825.95l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.14.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.04.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.03.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.98,827.35s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787.2,826.85s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m772.52,826.52l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m772.58,827.09s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.95,827.33l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.46,826.44l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.25,827.34c.03-.1.11.05.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.17,826.38c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.83,827.06c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.34,826.37c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m775.15,827.25l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.62,826.53v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.89,826.4l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m775.01,826.48v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.89,827.24c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.52,826.3s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.8,826.21s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m779.47,825.95s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m779.41,825.98s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m780.02,826.01s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.15,827.49c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "784.3 827.4 784.31 827.44 784.35 827.49 784.3 827.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.71,827.51s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.67,827.55s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.64,827.52v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.83,827.52l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.1,827.49c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.06,827.27c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "785.51 827.43 785.57 827.48 785.59 827.44 785.51 827.43"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.75,827.46l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.09,827.55c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.87,827.28s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.86,826.84c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787,827.43s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787.18,827.39s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.93,827.03l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "787.86 827.31 788 827.28 787.96 827.27 787.86 827.31"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "787.95 827.35 787.96 827.39 788.07 827.32 787.95 827.35"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "788.1 827.4 788.09 827.39 788 827.43 788.1 827.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m788.4,827.43l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m789.37,825.95s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m789.54,826.11l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m791.63,826.2c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m797.1,826.97s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m805.52,885.53c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m805.58,885.55h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m805.98,885.61c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "805.84 885.54 805.83 885.6 805.91 885.51 805.84 885.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "805.79 885.48 805.8 885.51 805.92 885.44 805.79 885.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m806.29,885.66l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m811.86,884.99s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.39,884.9s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.91,885.22s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.62,885.67s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m815.1,884.71s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.36,885.23s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m812.89,884.74s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m807.71,885.8s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.25,885.78s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.6,885.79s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m807.78,885.78s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m811.86,885.02s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m811.39,885.15s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m809.61,885.11s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m811.48,885.16s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.15,885.2s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.91,886.22s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m821.06,885.89h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m821.1,885.7s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m826.72,886.17s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.99,886.08s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.22,885.79s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m823.03,884.75c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "827.95 886.26 827.95 886.24 827.95 886.25 827.95 886.26"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m824.68,884.73s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.77,885.65h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m822.12,884.68l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04,0,.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.02-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.04.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.94,886.08s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m821.17,885.58s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m806.49,885.25l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m806.55,885.81s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m807.92,886.06l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m807.43,885.17l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.21,886.07c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.13,885.11c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.8,885.78c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.3,885.1c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m809.12,885.98l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.58,885.25v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.85,885.13l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.98,885.2v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.86,885.97c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.49,885.03s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.77,884.94s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.44,884.68s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.37,884.71s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.98,884.74s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.11,886.21c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "818.27 886.13 818.27 886.17 818.31 886.22 818.27 886.13"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.67,886.24s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.64,886.28s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.61,886.25v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.79,886.25l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.06,886.22c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.06-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.03,886c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "819.47 886.16 819.54 886.21 819.55 886.17 819.47 886.16"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.72,886.19l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.06,886.28c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.84,886s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.82,885.57c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.96,886.16s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m821.14,886.12s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.89,885.76l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "821.83 886.04 821.97 886.01 821.92 886 821.83 886.04"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "821.92 886.08 821.92 886.12 822.03 886.05 821.92 886.08"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "822.07 886.13 822.05 886.12 821.97 886.16 822.07 886.13"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m822.36,886.16l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m823.33,884.68s-.01.07,0,.11l.04-.1s-.04.02-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m823.5,884.84l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m825.6,884.92c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.1l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m831.07,885.69s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1535.69,482.84c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1535.75,482.86h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1536.16,482.92c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1536.02 482.85 1536.01 482.91 1536.09 482.82 1536.02 482.85"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1535.96 482.79 1535.97 482.82 1536.1 482.75 1535.96 482.79"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1536.47,482.97l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1542.04,482.3s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1543.56,482.21s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1541.08,482.53s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1550.8,482.98s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1545.27,482.02s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1540.53,482.54s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1543.06,482.05s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1537.88,483.11s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.43,483.09s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.78,483.1s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1537.95,483.09s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1542.03,482.33s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1541.56,482.46s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1539.79,482.42s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1541.65,482.47s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1540.32,482.51s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1558.08,483.53s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.24,483.2h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.28,483.01s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1556.9,483.48s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1545.16,483.39s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1550.4,483.1s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1553.2,482.06c-.03.12.02,0,.08.06l.06-.07c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1558.12,483.57s0,0,0-.01c0,0,0,0,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1554.85,482.04s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1550.95,482.96h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1552.3,481.99l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1550.12,483.39s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.34,482.89s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1536.66,482.56l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1536.72,483.12s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.09,483.37l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1537.6,482.48l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.39,483.38c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.31,482.42c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.97,483.09c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.48,482.41c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1539.29,483.29l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.76,482.56v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1539.02,482.44l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1539.15,482.51v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1541.03,483.28c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1540.66,482.34s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1540.94,482.25s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1543.61,481.99s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1543.55,482.02s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1544.16,482.05s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1548.29,483.52c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1548.44 483.44 1548.45 483.48 1548.49 483.53 1548.44 483.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1548.85,483.55s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1548.81,483.58s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1548.78,483.56v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1548.97,483.56l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1549.24,483.53c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1549.2,483.31c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1549.65 483.47 1549.71 483.52 1549.73 483.48 1549.65 483.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1549.89,483.5l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1550.23,483.59c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.01,483.31s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551,482.88c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.14,483.47s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.32,483.43s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.06,483.07l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1552 483.35 1552.14 483.32 1552.1 483.31 1552 483.35"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1552.09 483.39 1552.1 483.43 1552.2 483.36 1552.09 483.39"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1552.24 483.44 1552.22 483.43 1552.14 483.47 1552.24 483.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1552.53,483.47l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1553.51,481.99s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1553.68,482.15l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1555.77,482.23c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1561.24,483s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.39,501.89c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.45,501.9h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.85,501.97c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1624.71 501.9 1624.7 501.96 1624.78 501.86 1624.71 501.9"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1624.65 501.84 1624.66 501.86 1624.79 501.8 1624.65 501.84"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.16,502.01l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.73,501.34s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1632.25,501.26s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.77,501.58s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.49,502.02s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1633.96,501.07s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.22,501.59s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1631.76,501.09s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.58,502.15s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.12,502.14s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.47,502.15s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.64,502.14s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.72,501.38s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.25,501.51s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1628.48,501.46s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.34,501.51s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.01,501.55s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1646.77,502.57s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.93,502.25h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.97,502.05s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1645.59,502.53s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1633.85,502.43s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.09,502.14s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1641.9,501.11c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1646.82 502.61 1646.82 502.6 1646.81 502.6 1646.82 502.61"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1643.54,501.08s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.64,502h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1640.99,501.04l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.81,502.43s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1640.03,501.93s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.36,501.61l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.41,502.17s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.78,502.42l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.3,501.53l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.08,502.43c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627,501.46c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.67,502.14c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.17,501.45c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.98,502.34l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.45,501.61v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.72,501.48l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.84,501.56v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.73,502.33c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.36,501.38s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.63,501.3s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1632.3,501.04s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1632.24,501.07s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1632.85,501.09s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1636.98,502.57c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1637.13 502.49 1637.14 502.52 1637.18 502.58 1637.13 502.49"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.54,502.59s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.5,502.63s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.48,502.61v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.66,502.61l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.93,502.58c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.9,502.35c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1638.34 502.52 1638.41 502.57 1638.42 502.52 1638.34 502.52"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.58,502.54l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.92,502.64c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.71,502.36s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.69,501.93c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.83,502.51s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1640.01,502.48s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.76,502.12l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1640.7 502.39 1640.84 502.36 1640.79 502.35 1640.7 502.39"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1640.79 502.44 1640.79 502.48 1640.9 502.4 1640.79 502.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1640.93 502.48 1640.92 502.48 1640.83 502.51 1640.93 502.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1641.23,502.51l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1642.2,501.03s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1642.37,501.19l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1644.46,501.28c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1649.93,502.05s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1066.71,813.42c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1066.77,813.44h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1067.18,813.51c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1067.04 813.43 1067.03 813.5 1067.11 813.4 1067.04 813.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1066.98 813.38 1066.99 813.4 1067.12 813.34 1066.98 813.38"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1067.49,813.55l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1073.06,812.88s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1074.58,812.8s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1072.1,813.12s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.82,813.56s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1076.29,812.6s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1071.55,813.13s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1074.08,812.63s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1068.9,813.69s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.45,813.68s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.8,813.69s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1068.97,813.68s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1073.05,812.92s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1072.58,813.04s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1070.81,813s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1072.67,813.05s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1071.34,813.09s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.1,814.11s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.26,813.79h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.3,813.59s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1087.92,814.07s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1076.18,813.97s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.42,813.68s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1084.22,812.65c-.03.12.02,0,.08.06l.06-.07c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1089.14 814.15 1089.15 814.14 1089.14 814.14 1089.14 814.15"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1085.87,812.62s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.97,813.54h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1083.32,812.57l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.04-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.14,813.97s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.36,813.47s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1067.68,813.15l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1067.74,813.71s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.11,813.95l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1068.62,813.07l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.41,813.97c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.33,813c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.99,813.68c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.5,812.99c-.06-.03-.09-.1-.16-.09.01.05.03.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1070.31,813.87l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1069.78,813.15v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1070.04,813.02l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1070.17,813.1v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1072.05,813.86c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1071.68,812.92s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1071.96,812.84s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1074.63,812.58s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1074.57,812.61s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1075.18,812.63s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1079.31,814.11c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1079.46 814.02 1079.47 814.06 1079.51 814.12 1079.46 814.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1079.87,814.13s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1079.83,814.17s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1079.8,814.15v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1079.99,814.15l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1080.26,814.11c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1080.22,813.89c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1080.67 814.05 1080.73 814.11 1080.75 814.06 1080.67 814.05"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1080.91,814.08l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.25,814.18c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.03,813.9s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.02,813.46c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.16,814.05s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.34,814.01s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1082.09,813.66l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1083.02 813.93 1083.16 813.9 1083.12 813.89 1083.02 813.93"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1083.11 813.98 1083.12 814.02 1083.22 813.94 1083.11 813.98"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1083.26 814.02 1083.24 814.02 1083.16 814.05 1083.26 814.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1083.55,814.05l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1084.53,812.57s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1084.7,812.73l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1086.79,812.82c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.26,813.59s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1278.89,867.53c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1278.95,867.55h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1279.35,867.61c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1279.21 867.54 1279.2 867.6 1279.28 867.51 1279.21 867.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1279.15 867.48 1279.17 867.51 1279.29 867.44 1279.15 867.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1279.66,867.66l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1285.23,866.99s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1286.76,866.9s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1284.28,867.22s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1293.99,867.67s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1288.46,866.71s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1283.73,867.23s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1286.26,866.74s.04.02.06.02c-.02-.01-.04-.01-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.08,867.8s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.62,867.78s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.97,867.79s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.14,867.78s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1285.23,867.02s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1284.76,867.15s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1282.98,867.11s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1284.84,867.16s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1283.52,867.2s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.28,868.22s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.43,867.89h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.47,867.7s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.03.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.09,868.17s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1288.36,868.08s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1293.59,867.79s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1296.4,866.75c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1301.32 868.25 1301.32 868.24 1301.32 868.25 1301.32 868.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.05,866.72s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.14,867.65h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.49,866.68l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.14-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.02.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.07-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.13.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0,0,.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.06-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.17-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.1-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1293.31,868.08s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.54,867.58s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1279.86,867.25l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1279.92,867.81s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.29,868.06l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1280.8,867.17l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.58,868.07c.03-.1.11.05.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.5,867.11c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1282.17,867.78c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.67,867.1c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1282.49,867.98l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1281.95,867.25v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1282.22,867.13l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1282.35,867.2v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1284.23,867.97c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1283.86,867.03s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1284.14,866.94s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1286.8,866.68s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1286.74,866.71s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1287.35,866.74s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1291.48,868.21c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1291.64 868.13 1291.64 868.17 1291.68 868.22 1291.64 868.13"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1292.04,868.24s-.01.02-.02.03c.02,0,.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1292.01,868.27s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1291.98,868.25v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1292.16,868.25l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1292.43,868.22c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1292.4,868c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1292.84 868.16 1292.91 868.21 1292.92 868.17 1292.84 868.16"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1293.09,868.19l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1293.42,868.28c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.21,868s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.19,867.57c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.33,868.16s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.51,868.12s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1294.26,867.76l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1295.2 868.04 1295.34 868 1295.29 868 1295.2 868.04"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1295.29 868.08 1295.29 868.12 1295.4 868.05 1295.29 868.08"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1295.44 868.13 1295.42 868.12 1295.34 868.16 1295.44 868.13"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.73,868.15l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1296.7,866.68s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1296.87,866.84l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.97,866.92c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1304.44,867.69s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.37,895.98c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.43,896h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.83,896.06c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1360.69 895.99 1360.68 896.05 1360.76 895.95 1360.69 895.99"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1360.63 895.93 1360.64 895.95 1360.77 895.89 1360.63 895.93"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.14,896.1l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1366.71,895.44s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1368.24,895.35s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1365.76,895.67s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.47,896.12s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1369.94,895.16s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1365.2,895.68s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1367.74,895.18s.04.02.06.01c-.02,0-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.56,896.24s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.1,896.23s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.45,896.24s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.62,896.23s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1366.7,895.47s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1366.23,895.6s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1364.46,895.55s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1366.32,895.6s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1364.99,895.65s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1382.75,896.67s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.91,896.34h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.95,896.15s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1381.57,896.62s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1369.83,896.53s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.07,896.23s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1377.88,895.2c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1382.8 896.7 1382.8 896.69 1382.79 896.69 1382.8 896.7"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1379.52,895.17s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.62,896.09h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1376.97,895.13l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.14-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04,0,.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.02-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.25-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.04,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1374.79,896.52s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1376.01,896.02s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.34,895.7l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.4,896.26s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.76,896.51l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.28,895.62l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.06,896.52c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.98,895.56c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.65,896.23c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.15,895.54c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.96,896.43l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.43,895.7v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.7,895.57l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.82,895.65v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1365.71,896.42c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1365.34,895.47s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1365.61,895.39s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1368.28,895.13s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1368.22,895.16s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1368.83,895.19s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1372.96,896.66c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1373.11 896.58 1373.12 896.61 1373.16 896.67 1373.11 896.58"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1373.52,896.69s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1373.48,896.72s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1373.46,896.7v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1373.64,896.7l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1373.91,896.67c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.06-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1373.88,896.44c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1374.32 896.61 1374.39 896.66 1374.4 896.62 1374.32 896.61"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1374.56,896.63l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1374.9,896.73c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.69,896.45s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.67,896.02c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.81,896.6s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.99,896.57s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1375.74,896.21l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1376.68 896.48 1376.82 896.45 1376.77 896.44 1376.68 896.48"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1376.77 896.53 1376.77 896.57 1376.88 896.5 1376.77 896.53"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1376.91 896.58 1376.9 896.57 1376.81 896.6 1376.91 896.58"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1377.21,896.6l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1378.18,895.12s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1378.35,895.29l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1380.44,895.37c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.1l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1385.91,896.14s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1024.81,858.34c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1024.87,858.36h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1025.27,858.43c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1025.13 858.35 1025.12 858.42 1025.2 858.32 1025.13 858.35"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1025.08 858.3 1025.09 858.32 1025.21 858.26 1025.08 858.3"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1025.59,858.47l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1031.15,857.8s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1032.68,857.72s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1030.2,858.04s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.91,858.48s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.39,857.52s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1029.65,858.05s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1032.18,857.55s.04.02.06.02c-.02-.01-.04-.01-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027,858.61s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.55,858.6s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.89,858.61s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.07,858.6s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1031.15,857.83s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1030.68,857.96s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.91,857.92s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1030.77,857.97s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1029.44,858.01s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1047.2,859.03s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.36,858.71h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.39,858.51s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.01,858.98s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.28,858.89s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.51,858.6s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1042.32,857.57c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1047.24 859.07 1047.24 859.06 1047.24 859.06 1047.24 859.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1043.97,857.54s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.06,858.46h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.41,857.49l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.14-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.07-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0,0,.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.02-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.25-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.04,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.23,858.89s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.46,858.39s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1025.78,858.07l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1025.84,858.63s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.21,858.87l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1026.72,857.99l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.5,858.89c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.43,857.92c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.09,858.6c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.59,857.91c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.41,858.79l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.88,858.07v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.14,857.94l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.27,858.02v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1030.15,858.78c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1029.78,857.84s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1030.06,857.76s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1032.73,857.5s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1032.66,857.53s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1033.28,857.55s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.4,859.03c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1037.56 858.94 1037.57 858.98 1037.6 859.04 1037.56 858.94"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.96,859.05s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.93,859.09s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.9,859.07v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.09,859.07l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.36,859.03c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.06-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.32,858.81c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1038.77 858.97 1038.83 859.03 1038.85 858.98 1038.77 858.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.01,859l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.35,859.1c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.13,858.82s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.11,858.38c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.26,858.97s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.43,858.93s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.18,858.58l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1041.12 858.85 1041.26 858.82 1041.22 858.81 1041.12 858.85"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1041.21 858.9 1041.21 858.94 1041.32 858.86 1041.21 858.9"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1041.36 858.94 1041.34 858.94 1041.26 858.97 1041.36 858.94"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.65,858.97l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1042.62,857.49s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1042.79,857.65l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1044.89,857.74c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.1l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1050.36,858.51s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1100.29,915.87c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1100.35,915.89h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1100.76,915.95c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1100.62 915.88 1100.6 915.94 1100.69 915.85 1100.62 915.88"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1100.56 915.82 1100.57 915.85 1100.7 915.78 1100.56 915.82"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.07,916l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.64,915.33s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1108.16,915.24s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.68,915.56s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.4,916.01s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1109.87,915.05s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.13,915.57s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1107.66,915.08s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.48,916.14s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.03,916.12s0,0,0,0c0,.02,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.38,916.13s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.55,916.13s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.63,915.36s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.16,915.49s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.39,915.45s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.25,915.5s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.92,915.54s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1122.68,916.56s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.84,916.23h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.88,916.04s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1121.5,916.51s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1109.76,916.42s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115,916.13s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1117.8,915.09c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1122.72 916.6 1122.72 916.58 1122.72 916.59 1122.72 916.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1119.45,915.07s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.55,915.99h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1116.9,915.02l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.02.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.13.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.29.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.06-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.17-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05,0-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.1-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.04.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1114.72,916.42s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.94,915.92s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.26,915.59l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.32,916.15s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.69,916.4l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.2,915.51l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.98,916.41c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.91,915.45c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.57,916.13c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.07,915.44c-.06-.03-.09-.1-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.89,916.32l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.36,915.6v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.62,915.47l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.75,915.54v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.63,916.31c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.26,915.37s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.54,915.28s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1108.21,915.02s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1108.15,915.05s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1108.76,915.08s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1112.89,916.55c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1113.04 916.47 1113.05 916.51 1113.09 916.56 1113.04 916.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1113.45,916.58s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1113.41,916.62s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1113.38,916.59v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1113.57,916.59l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1113.84,916.56c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1113.8,916.34c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1114.25 916.5 1114.31 916.55 1114.33 916.51 1114.25 916.5"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1114.49,916.53l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1114.83,916.62c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.61,916.34s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.6,915.91c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.74,916.5s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.91,916.46s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.66,916.1l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1116.6 916.38 1116.74 916.35 1116.7 916.34 1116.6 916.38"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1116.69 916.42 1116.7 916.46 1116.8 916.39 1116.69 916.42"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1116.84 916.47 1116.82 916.46 1116.74 916.5 1116.84 916.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1117.13,916.5l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1118.11,915.02s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1118.28,915.18l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1120.37,915.27c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1125.84,916.03s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m954.27,902.06c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m954.33,902.08h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m954.73,902.15c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "954.6 902.07 954.58 902.14 954.66 902.04 954.6 902.07"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "954.54 902.02 954.55 902.04 954.68 901.98 954.54 902.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m955.05,902.19l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m960.61,901.52s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m962.14,901.44s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m959.66,901.76s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.37,902.2s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m963.85,901.24s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m959.11,901.77s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m961.64,901.27s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m956.46,902.33s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.01,902.32s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.35,902.33s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m956.53,902.32s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m960.61,901.55s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m960.14,901.68s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m958.37,901.64s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m960.23,901.69s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m958.9,901.73s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m976.66,902.75s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.82,902.43h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.85,902.23s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m975.48,902.7s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m963.74,902.61s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m968.97,902.32s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m971.78,901.29c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "976.7 902.79 976.7 902.78 976.7 902.78 976.7 902.79"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m973.43,901.26s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.52,902.18h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m970.88,901.21l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04,0,.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.02-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.13-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.04.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m968.7,902.61s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.92,902.11s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m955.24,901.79l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m955.3,902.35s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m956.67,902.59l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m956.18,901.71l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m956.96,902.6c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m956.89,901.64c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.55,902.32c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.05,901.63c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.87,902.51l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.34,901.79v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.6,901.66l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m957.73,901.74v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m959.61,902.5c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m959.24,901.56s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m959.52,901.48s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m962.19,901.22s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m962.12,901.25s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m962.74,901.27s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m966.86,902.75c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "967.02 902.66 967.03 902.7 967.06 902.76 967.02 902.66"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m967.42,902.77s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m967.39,902.81s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m967.36,902.78v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m967.55,902.78l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m967.82,902.75c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.06-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m967.78,902.53c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "968.23 902.69 968.29 902.75 968.31 902.7 968.23 902.69"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m968.47,902.72l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m968.81,902.82c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.59,902.54s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.57,902.1c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.72,902.69s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.89,902.65s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m969.64,902.29l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "970.58 902.57 970.72 902.54 970.68 902.53 970.58 902.57"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "970.67 902.61 970.67 902.65 970.78 902.58 970.67 902.61"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "970.82 902.66 970.8 902.66 970.72 902.69 970.82 902.66"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m971.11,902.69l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m972.09,901.21s-.01.07,0,.11l.04-.1s-.04.02-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m972.26,901.37l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m974.35,901.46c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.1l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m979.82,902.23s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1033.68,106.2c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1033.74,106.22h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.14,106.28c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1034 106.21 1033.99 106.27 1034.07 106.18 1034 106.21"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1033.94 106.15 1033.95 106.18 1034.08 106.11 1033.94 106.15"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.45,106.33l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.02,105.66s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.54,105.57s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.06,105.89s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.78,106.34s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1043.25,105.38s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.51,105.9s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.05,105.4s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1035.86,106.46s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.41,106.45s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.76,106.46s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1035.93,106.45s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1040.01,105.69s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.54,105.82s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.77,105.77s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.63,105.83s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.3,105.87s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1056.06,106.89s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1049.22,106.56h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1049.26,106.37s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1054.88,106.84s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1043.14,106.75s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.38,106.45s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1051.18,105.42c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1056.11 106.92 1056.11 106.91 1056.1 106.92 1056.11 106.92"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1052.83,105.39s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.93,106.31h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1050.28,105.35l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.13-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.1,106.74s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1049.32,106.24s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.65,105.92l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.7,106.48s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.07,106.73l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1035.59,105.84l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.37,106.74c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.29,105.78c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.96,106.45c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.46,105.77c-.06-.03-.09-.09-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.27,106.65l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.74,105.92v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.01,105.79l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1037.13,105.87v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.02,106.64c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.64,105.69s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1038.92,105.61s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.59,105.35s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.53,105.38s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1042.14,105.41s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.27,106.88c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1046.42 106.8 1046.43 106.84 1046.47 106.89 1046.42 106.8"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.83,106.91s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.79,106.94s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.77,106.92v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.95,106.92l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1047.22,106.89c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1047.18,106.67c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1047.63 106.83 1047.69 106.88 1047.71 106.84 1047.63 106.83"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1047.87,106.86l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.21,106.95c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.99,106.67s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.98,106.24c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1049.12,106.83s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1049.3,106.79s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1049.05,106.43l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1049.98 106.71 1050.13 106.67 1050.08 106.67 1049.98 106.71"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1050.07 106.75 1050.08 106.79 1050.19 106.72 1050.07 106.75"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1050.22 106.8 1050.21 106.79 1050.12 106.83 1050.22 106.8"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1050.52,106.82l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1051.49,105.35s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1051.66,105.51l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1053.75,105.59c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1059.22,106.36s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "152.23",
	      "cy": "455.7",
	      "r": "33.06",
	      "transform": "translate(-326.29 498.75) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "149.56",
	      "y": "465.6",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1119.71,39.49c-1.08.09.36.03,1.69.02l-1.69-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1121.4,39.5h1.19c-.32,0-.74,0-1.19,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1132.53,39.57c-2.56.07-5.61-.03-7.21.08,2.58.07,6.57.04,7.21-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1128.68 39.5 1128.36 39.56 1130.61 39.46 1128.68 39.5"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1127.08 39.44 1127.4 39.46 1130.91 39.4 1127.08 39.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1141.18,39.61l-2.57.02c-2.4-.08,1.59-.11-.02-.17-3.2,0-1.1.17-5.11.15.32.08,6.41,0,5.76.12,3.36.04.16-.07,1.93-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.62,38.95c.13,0,.24,0,.36.01-.14-.01-.29-.02-.36-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1337.92,38.86c.58.01,1.16.02,1.73.03-.17-.01-.39-.02-.68-.03h-1.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1269.14,39.18c-.61-.01-1.16-.02-1.67-.03.32.02.81.03,1.67.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1538.56,39.62c-.1,0-.19.02-.22.04.02,0,.05,0,.08,0l.47-.03h-.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1385.28,38.67c.67,0,1.32,0,1.91-.01-1.11,0-1.65,0-1.91.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.88,39.19c.23,0,.43,0,.64,0-.2,0-.48,0-.79-.01h.12s.01.01.03.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1324.11,38.69c.57,0,1.09.02,1.53.01-.52-.01-1.03-.01-1.53-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1180.41,39.75c.73.01,1.33,0,1.86-.01-.46-.02-1.05-.02-1.86.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1195.54,39.74s-.06,0-.09,0c.09.01.13.01.09,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1205.21,39.75c-.06,0-.11,0-.17,0,.11.01.17.01.17,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1182.27,39.74c1.25.05,1.63.21,3.24.03l-.32-.02c.97.04,2.41-.03,3.53-.03-.11-.02-.25-.03-.41-.04-.57,0-1.31,0-2.46-.02-1.37-.04-2.26.05-3.58.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.46,38.98c-.14-.03-1.16-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1282.42,39.11c.42,0,.85,0,1.28,0-.41,0-.82-.01-1.28,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.28,39.06c.08,0,.16,0,.23,0,.07-.02-.12-.02-.23,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1284.89,39.11c-.4,0-.79,0-1.18,0,.36,0,.74.01,1.18,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1248.04,39.15c.07,0,.14,0,.2,0-.04,0-.12,0-.2,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1740.58,40.17c-.99.01-1.57-.03-2.51-.04-2.1.11,4.32,0,1.28.1.93,0,1.66-.02,2.34-.03l-1.33-.11c-1.83.04,1.23.04.21.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1550.84,39.85h-.42c.29.04.03.05,1.65.08,1.38-.07-.77-.19,1.64-.27-.47,0-1.16,0-1.82,0,.99.07.01.14-1.05.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.88,39.65s-.04,0-.07,0c-.1-.01-.22-.02-.35-.03-.35,0-.69,0-.96-.01.26.02.79.04,1.38.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1707.78,40.13c-.41,0-.77,0-1.1-.01.54.02.86.02,1.1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1382.24,40.03c-.48.01-.95.02-1.32.03.73,0,1.09-.02,1.32-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1527.49,39.74c-.37,0-.75-.01-1.17-.02-.24,0-.45,0-.74,0h1.91Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1605.3,38.71c-.83.12.64,0,2.3.06l1.54-.06c-1.41-.02-2.72,0-3.84,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1741.8,40.21s0,0,.02-.01c-.04,0-.07,0-.12,0h.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1651.02,38.68c.26,0,.5.01.74.02-.15,0-.38-.01-.74-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1542.72,39.6h-5.88s1.72.02,1.72.02c.82-.06,3.35.05,4.17-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1580.2,38.64l-.52-.07c-5.85.16-12.57-.07-17.23.15-7.13-.26-4.68.23-11.22,0l.22.04c-21.5-.04-44.31-.18-64.41-.05l.04-.05c-32.4-.09-63.94.02-96.05-.02-3,.05-1.19.16-3.77.22-1.12,0-3.66,0-3.67-.06,2.17-.04.95-.09,1.69-.12-3.61,0-8.27-.07-11.49.01l2.7.08c-1.25.03-3.22.01-4.36,0,.48-.04-1.17-.13-.19-.15-6.8.21-5.3-.09-11.03,0-1.14.18-8.3.32-13.02.45l-2.48-.05c3.29,0-.06-.13,4.02-.12-3.41-.05-6.57.02-9.79,0,.63.04.47.1-.83.12-1.98-.02-2.15-.11-4.41-.12l2.23-.06c-1.5-.07-2.8.02-4.19.03-.45-.07-3.83-.09-3.23-.17-3.04.1-4.12.04-7.4.11,3.41.08-.88.1-.49.16l3.84-.03c-5.42-.05,1.76-.01,1.35-.14,2.55.06-3.5.21.77.19-5.1.06-6.18,0-11.39.11,3.15-.02-.6.08,1.09.12-3.99,0-.99-.04-2.23-.12-2.17,0-2.97-.07-4.97.02-3.52-.04.53-.09-1.25-.15,1.3-.09,9.8.11,8.84-.17,1.84,0,4.08-.11,6.73-.1-2.31-.04-5.62-.13-8.48-.06l-.14.16c-2.17,0-2.62.11-4.18.1.83-.04-.67-.11-2.42-.1.5.02,1.19.02,1,.04-3.23.01-3.68.12-7.53.15,3.18.04,3.83.09,6.8.15-.8.11-2.09.02-3.84.03.26-.01.63-.02.11-.04l-1.86.05c-3.96-.05.49-.16-2.77-.21-2.26-.09-3.09.05-4.82,0,.11.01.23.02.34.03-.38,0-.66,0-.86,0,.01,0,.03,0,.03,0-2.1.02-4.36,0-4.95.09-.22-.04-1.84.01-2.52.04-1.17.03-3.97.13-5.72,0,.05,0,.09,0,.13,0-2.62-.02-4.66-.06-4.09-.1l-4.22-.03.45-.11c-3.85.03-3.46.09-6.1.2-2.76-.06-7.58-.01-9.4.03-.3,0-.77,0-1.53,0l1.61.04c-3,0-2.64.05-4.62.05.41,0,.47.02-.64,0-.34,0-.7,0-1.14,0,.1-.01.54,0,.99,0l-.36-.04c-2.4-.11-3.68.06-6.25.02.25,0,.66-.01.92-.01-1.44-.03-3.51-.18-4.11-.09-.33-.01-.84,0-1.34.03l-1.06-.02c.44,0,.77.01,1.05.02-.66.03-1.28.07-1.37.05l-3.69-.02c-.7-.02-1.65,0-2.42.01l-.63-.04c-1.34,0-1.35-.02-1.19-.03-4.66-.15-7.21.08-12.25-.05-.96.07,1.12.11,1.28.15-.79.06-3.67.11-5.11.15-2.24-.1-9.13-.19-8.02-.34-4.15-.01,1.29.09-.79.14h-.48c1.43.01,2.56.06,3.36.12.31.08-3.35.1-4.48.08l.79-.11c-3.83.04-3.03.21-5.42.32-3.05-.04-1.29-.15-1.94-.25l-3.2.03v-.08c-2.08.02-2.57.1-5.45.07,2.08-.08-4.32-.08-1.44-.19-1.6-.03-2.06.13-2.88.02-1.11.09,1.44.04,2.24.07.65.13-3.52.06-5.44.1-.16-.07,1.28-.08-.98-.12-.46.05-1.9.09-3.19.03,0,.08-2.57.02-3.85.01,1.44.02,3.53.08,2.58.15-1.12.03-2.09.05-4.65.04l1.76.04c-2.23.12-3.69-.09-6.73-.05,1.28-.05,2.08-.05,3.2-.11-1.44.04-4.16.1-6.4.14l-2.57-.12c-.32.06-2.88,0-2.88.08-3.19-.06,2.57-.1,2.88-.16-4.01-.06-3.21.14-7.05.01l1.28-.08c-1.28,0-3.84.04-4,0,0,.03.64.02,1.44.02-.79.17-5.91.12-5.44.29h1.77c-2.71.05-4.63.16-6.72.1-1.6-.06,1.12-.12,2.07-.16-2.55-.01-2.07.19-5.11.17,1.6.03,1.29.09.33.14,1.76.01,5.44.04,4.79-.03l-.64-.02c.16-.05,1.12-.06,1.6-.08,2.41,0,1.12.08,1.6.11,4,.03.33-.17,3.99-.17l.48.03c1.76-.04,4.49-.05,4.97-.16,1.6.11,4.15-.04,5.91.02.33.25-6.23-.02-8.32.12,1.92.05-1.1.12-1.91.17l6.07-.11c.48.03,2.26.16,3.36.07h-.48c2.41-.03,1.76-.14,3.84-.1.32.02-.32.06-.48.08,1.92.02,1.6-.06,2.88-.08,1.92.02-.96.1.64.13,2.23-.1,3.52.02,5.45.02-.82-.14,7.67-.19,3.5-.31l4.63-.1c1.44.07-3.19.2-1.9.31h-3.69c.61.17,7.72-.12,10.17.08,1.97,0,1.49-.02,5.21.07l-.64-.16c1.93.04,2.56.12,2.65.15,1.13-.01,2.15,0,3.21,0-.28.02-.67.04-1.36.05,1.46.09,1.88.05,2.39,0,.79-.04,1.98-.03,3.19-.03l-1.09.06c.74-.01,1.65-.03,1.73-.06.5,0,.98,0,1.43-.01-.32-.03-1.12-.12-2.86-.16,4.48.06,8,.03,11.84.16-.14.04-1.75.1-1.27.11,1.92.02,4.01-.06,3.83-.12.43,0,.77,0,1.06,0,.37.04.82.08,1.73.09.21.01.56.03,1.21.03.64-.12,4.32-.06,5.12-.12-.87-.01-1.93-.01-3.01,0,1.55-.08,2.93-.18,4.12-.11-2.87.08,3.06.13-1.26.16,3.04.16,1.59-.11,4.8-.06l2.08.06c-.32.09-3.37.05-2.88.08h1.44c-1.44.06-6.89.01-10.24.11l6.73.05c8.48-.11,19.05.02,26.25-.18-.1,0-.2,0-.31,0,.13,0,.19-.03.29-.06l.32.02,1.42-.07c1.62.08,4.65.1,7.23.17q-1.62-.06-1.78-.12c.32-.09.57-.13,2.98-.1.03.06-1.46.06.32.11-.92-.03-.1-.08.95-.08,1.35.04,3.61.05,3.64.11-.63.02-1.13,0-1.56-.01-.63.02,2.55.06.69.11l2.45-.02c1.43.05-.95.08-.38.12,4.07-.04,6.15-.19,9.83-.23-.17.03-.21.18-.17.14,2.83.04,6.07-.16,9.3-.17-.47.04-1.68.03-2.65.05,9.86.05,17.93.06,27.18.19l2.41-.15,2.42.1c9.73.09,17.2,0,26.45-.05,2.88,0,1.73.1,3.09.14,6.32.02,7.87-.15,13.89-.18-.83.05-2.24.17.35.18.48-.04.8-.11,2.44-.08l-.83.04c1.5.07,2.94,0,6.04.03,5.48,0,10.7-.11,15.21-.27,4.84.01-.5.16.42.19-3.42-.05-2.37.03-3.11.08,1.81-.04,3.99-.07,4.92.04,2.52,0,3.66,0,6.14-.07-1.25.04-2.33-.02-1.15-.07,2.06.04,7.3,0,7.01.13,11.93-.03,25.27,0,38.04,0,2.15-.07-1.63-.03-.45-.07,3.13-.09,2.47.05,4.98-.02l-1.03.07c3.73.01,7.69-.12,11.3-.19-.6.08,2.97.07-.03.12,1.77-.01,3.91.35,5.27.28l-1.99-.34c.1-.03,2.58-.01,2.33-.04,1.54.07,3.44.15,4.5.15.52.09-2.16.07-3.63.07-.22.14,4.95.09,2.82.22,3.15-.02-.45-.07,1.43-.13l2.75.03-2.12-.05c2.29-.04,3.08-.15,6.14-.07l3.18-.14c.32.11,2.32.02,3.95.05l-1.02.07c2.17,0,3.01.02,4.37.06-1.22.1-1.97-.02-2.49.07l2.39.03c-.01-.06,1.51-.11-.2-.15,2.21-.12,3.42-.22,8.97-.21,2.51.11-2.7.1-1.65.2,5.76.05,7.04-.28,10.41-.27,4.29.04,4.05-.06,8.4-.06-1.38.07,3.04.08,3.84.15l-1.72.08c1.32-.02,2.59,0,2.2.06-.25-.1,5.65-.09,8.65-.14l-.52-.09c2.35-.03,5.6-.08,8.08-.06,3.7-.03,2.86-.1,5.71-.2,1.57.08,1.4.17.88.26-.99-.04-2.67-.02-4.3-.04-4.68.07-8.31.26-12.98.21-2.02.21,3.15-.02,5.42.05-.07.01-.23.02-.4.02.2,0,.38,0,.57,0-1.67.03-4.4.06-4.85.17,2.8-.02,2.03-.21,5.51-.12,2.58-.06,4.68.11,6.24.12,1.72-.08,1.79-.24,6.01-.21l-1.85.12c4.78,0,2.24-.17,6.67-.17-1.56-.01,1.5-.11-1.45-.12,1.45-.06,4.68-.07,7.08-.04.63-.02.13-.04.25-.08-2.66-.08-4.21.08-6.39-.04l-1.85.13c-2.47-.05-2.73-.15-1.21-.2-.7,0-1.31.02-1.82,0-.42-.19,2.97.07,3.83-.09h-1.75c-.76-.11,4.08-.09,6.34-.09,2.55.06,4.88.08,5.05.17l-3.42.04c1.77.07,4.37-.04,6.36-.04.13.01.32.02.56.03-.1,0-.16-.02-.16-.02.42,0,.8.02,1.12.04,1.75,0,4.31-.05,5.94-.02l-.2-.08-.22.04c-1.6,0-3.77-.05-2.56-.11,3.61-.06,4.34.1,5.2.17-.83.12-3.52,0-5.36.04,1.11.12,3.67.01,7.4.09-1.49.13-4.32,0-5.14.12,3,.02,3.79-.07,6.95-.04-.4.06-3.48.07-3.28.15l2.03.04c-4.98,0,.87.16-3.01.2,1.83.05,2.56-.11,5.17-.02-.73-.06-2.81-.16-.31-.21l2.82.04c1.18.06-2.94.14-1.11.19l2.95-.05c-.1-.04-1.51-.06-.63-.11,1.71.04,2.8-.15,4.81-.21,1.6,0,2.87.01,3.44.06,4.03-.12,9.15-.11,12.86-.22-2.54.08.1.13,1.62.19-2.92.02-2.94.14-2.74.22,1.78-.01,2.94-.14,2.04-.18,2.97.05,2.05-.09,4.66,0,1.69.04-.84.12-.26.17,3.21,0,.87-.15,4.36-.12-.19.02-.51.02-.23.04,1.88.03,3.9-.03,4.31-.09,2,.16,5.64-.02,5.25.14,4.55-.04-.68-.09.22-.14,1.86-.07,5.3-.01,6.38.01-1.12,0-2.15.05-3.23.02l.96.11c5.66.08,3.59-.25,9.05-.15-2.81.06-.94.08-2.33.16.85-.03,5.13,0,2.54-.08,2.05,0,3.48.03,4.89.05,1.82-.04,3.8-.07,4.86-.14,2.87.01,5,.09,6.37.14,6.04-.08,11.62.06,17.99-.03h-.47c4.94.01-2.19-.15,2.95-.15-.69.13,3.07.09,4.73.16,6.29.07,10.88-.1,16.68,0-.05.03-.42.06-1.54.06,4.43.04,7.99.02,11.99.02l-.17.02c6.4.11,12.21-.02,18.83-.05-.54.02-.68.07-1.09.08,3.34.03,8.67.05,11.01-.07,3.96.13,2.62-.04,7.72.09.29.02-.51.02-.84.03,2.5.04,4.28.03,6.82.05,5.59-.08,6.98-.26,13.48-.2.33.18-3.99.04-4.14.19,1.29-.03,2.42-.07,4.21-.03-1.07.07-.23.04-.97.11,1.37.05,5.52-.19,5.49-.17.07-.03-.4-.05-1.68-.05,1.52-.11,6.38,0,9.53-.05-1.02,0-4.24-.04-3.03-.12,4.22.04,5.63-.14,8.58-.21,3.89.08-2.87.15-2.14.28.65.05,2.21.15.58.2,3.5.03,6.01-.08,9.13-.11l-.09.04c4.36-.01,9-.17,12.66-.1l-1.94-.04c.72-.02,2.91-.01,4.12-.08-.13.06,2.71.11,1.55.16,1.94-.19,9.9-.12,12.08-.3,1.16.05.23.13-.12.17-2.75-.02-3.68-.05-5.12.02,2.29,0,3.96.05,3.61.09,2.29-.12,7.74-.17,8.89-.28,1.67.06,3.26.09,2.68.19,7.02-.06-3.47-.31,4.46-.3,3.61.1-3.53.13,1.46.16l-.92.02c3.6.26,2.52-.18,6.6-.17.54.14-2.84.1-.03.2,3.73-.04,5.36-.24,9.09-.2l-.58.06c2.39-.01,7.02.02,9.4,0,.11.03-.23.02-.69.03,4.4.05,1.84-.07,5.44.02l1.03-.07c-1.81-.05-5.3-.12-7.59-.04,2.28-.08-3.58-.18-2.45-.29l-.45.05c-5.97-.2-13.66-.23-21.23-.31-4.78.14-8.13-.06-13.26.04-.8.16-.96.03-5.36.07,2.33-.02.28-.12-1.2-.15-.86.04-1.9.06-2.95.07-.89-.06-6.44-.19-8.47-.08-2.68-.05.63-.05,1.21-.09-1.09-.08-2.18.07-3.07,0,0,0,.04-.02.32-.03-4.1,0-6.55-.04-10.81-.06-.35.16-4.19.06-6.09.12.62-.05-2.4-.06-3.61-.09l-2.28.12c-2.26.1-3.15-.07-6.07-.02l.71.03c-2.14.05-7.76-.05-9.86-.13-19.74.31-30.53-.18-51.33-.09-1.35.05.99.08-.07.15-2.11.02-2.59.01-4.52.01,1.7.04,1.43-.01,1.21.03l2.95-.04c.14.01-.18.02.1.04.99-.01,2.15-.05,3.42-.04-1.82.04-2.33.16-4.83.11.19-.02.51-.02,1.17-.03-2.06,0-2.16.05-3.71.02-1.89-.03-1.43.01-1.67-.04l-5.87-.06c-2.93.14-6.54,0-7.49,0,.64-.11,3.89-.03,5.33-.14l-2.12-.08-.13.08-3.02-.02.17-.02c-.36.03-.73.07-1.5.04-.13-.01-.42-.03-.09-.04l-2.15.05c1.25-.09-1.89-.03-1.57-.13-7.02-.05-8.93.14-15.1,0,1,.05-1.96.16-3.86.14-1.1-.02-1.37-.05-.68-.09l-2.49.05c-3.12-.16-6.16-.06-10.73-.11l.24-.04c-1.69.05-3.52.09-6.06.08l.46-.09c-3.11-.06-2.38.19-5.81.13.02.1,2.18.14,2.52.24-.81-.1-4.5-.11-3.64-.04-3.42.04-2.37,0-2.67-.03l-2.01.06c-2.41,0-.77-.13.12-.18-2.24.1-4.69.03-7.24.01l1.03-.04-3.35-.02c-2.19.07-5.25.08-8.07.04l1.95-.13c-1.98-.07-1.02.04-1.54.06-3.13.06-3.8-.02-5.46-.09-5.01.13-9.98-.21-14.28-.02Zm-345.72.49l.46.02c-1.05.02-1.65.04-.46-.02Zm27.54.04c-3.32.05-2.26-.01-2.52-.04,3.26.03,5.08,0,7.97.04-.46-.03-.55-.06-.7-.08,1.15,0,2.3.03,2.7.1-1.43.13-8.88-.08-7.45,0Zm-62,.62c.11,0,.25-.02.39-.03h.02l-.41.03Zm16.41-.11c.23.03.64.04,1.13.05-.3-.03-.6-.06-1.13-.05Zm32.67.16c.76.05,2.48.04,3.73.02-.59,0-1.64-.02-3.73-.02Zm206.11-.06c-.99.02-2.85.07-1.15.11.82-.05,2.39.03,3.08-.04.1,0,.11,0,.17,0-.99-.04-1.81-.08-2.1-.08Zm96.89-.43c-.18.05-.91.11-.44.15-.08,0-.19,0-.28,0,.25.02.45.03.26.04.79.01,1.62.02,2.17,0,.27-.17,1.93-.2-1.72-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1519.74,40.03c.38,0,.67,0,.9,0-.25,0-.53,0-.9,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1553.66,39.53c.07-.01-.86-.03-2-.05.23.02.79.04,2,.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1146.6,39.21l.96-.02-1.92-.05c-3.2.06-3.36.13-4.15.21,2.87-.08,4.63-.04,8.32-.06l-3.2-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1148.23,39.77c.32.02,1.13.08,1.61.08l.48-.05-2.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1186.19,40.02l-3.04-.04c-.96.04,2.57.12,3.04.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1172.68,39.13l-1.6.06c1.44.05,3.36.04,3.68-.02-1.92.03-.48-.03-2.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1194.36,40.03c.95-.1,3.04.05,3.67-.05-.8.03-3.52-.05-3.67.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1192.22,39.06c-.96-.1-2.56-.01-4.49-.03,1.6,0,3.85.1,4.49.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1210.67,39.74c-.16.07-1.44.07-2.88.05.48-.02.8-.06,1.44-.07-2.4.06-2.57.04-4.49.08,1.92.05,4.81.08,4.5.17,1.43-.07,3.19-.17,1.43-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1196.85,39.05c-1.6-.03-2.57-.1-4.49-.09.33.05.97.12,3.22.11l-.8.08c2.08.06-.82-.11,2.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1219.49,39.94l-.97-.04c-2.24.07-5.12.03-6.39.14,2.71,0,6.07-.05,7.36-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1204.72,39.21l.3-.12c-2.24-.02.16.04-.64.07-.64-.02-1.6-.03-2.07,0,2.55-.02.16.1,2.41.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1212.07,39.08l2.87-.05-2.24-.13c-3.36.04-.16.07-.63.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1215.6,39.16l.32.02,4.31-.17c-2.57.07-2.72.06-4.63.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1267.81,39.93c.48-.05-2.04-.11-.96-.06-.48.04,2.88.11.96.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1257.52,38.98c1.23.04,5.25-.03,7-.07-2.1.02-7.3,0-7,.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1265.24,38.9c-.14,0-.41,0-.72.01.32,0,.55,0,.72-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1339.24,38.64c.19,0,.38,0,.54-.01-.18,0-.35,0-.54.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1337.48,38.67c-1.19-.02-3.56.01-3.97.07,1.88-.03,3.54-.04,5.74-.1-.83,0-1.84-.03-1.77.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1354.48,38.69c-.88.03-2.09.02-1.79.06.5.02,2.38-.03,1.79-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1468.96,40.17c1.63.03,2.59,0,2.15-.07-1.83,0-.83.05-2.15.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1473.22 40.09 1473.44 40.12 1474.51 40.18 1473.22 40.09"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1484.49,40.19c-.08.01-.37.02-.68.03.64-.01,1.18-.02.68-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1483.49,40.23c.1,0,.22,0,.32,0-.1,0-.22,0-.32,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1482.74,40.21l-.13.04c.18,0,.53-.01.87-.02-.3,0-.63,0-.74-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1487.87,40.21l-2.15-.11c-2.23.06,2.54.06.34.18l1.81-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1495.36,40.18c2.05.04,5.01-.14,6.17,0,5.81-.07-1.34-.22,5.31-.27-6.29-.07-3.2.26-8.77.18,2.7.08-1.81.07-2.71.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1494.37,39.95c-.33.07,2.27.07,3.08.03-.76,0-2.06-.1-3.08-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1506.72 40.12 1508.49 40.17 1508.96 40.12 1506.72 40.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1513.46,40.14l-1.73.08c.57-.03,3.16-.02,1.73-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1522.84,40.24c1.63.03,3.1-.15-.34-.11h.78c-.2.03,1.65.1-.45.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1544.56,39.96c-1.12,0-2.45.02-2.21.06l3.07-.04-.86-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1544.1,39.53c-1.03-.11-2.88,0-4.92-.03,2.32.02,2.04.04,4.92.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1548.07,40.11c-.83.04-2.11.02-2.88,0,.38.06,2.49.05,2.88,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1552.96,40.08c1,.04-.22.06.54.09,2.15.05,4.42.04,5.64-.02-.57-.05-1.34-.17-.45-.23-3.44.04-5.2.24-6.87.08l-2.87.19c2.75.03,2.11-.13,4.02-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1546.01,39.72l1.84.06c-.37-.06,1.03-.07,2.01-.09-.48-.14-2.8.02-3.85.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1572.03 39.99 1575.93 39.96 1574.66 39.95 1572.03 39.99"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1574.53 40.04 1574.63 40.08 1577.62 40 1574.53 40.04"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1578.62 40.08 1578.16 40.08 1575.86 40.11 1578.62 40.08"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1586.77,40.11l-.72-.06c-.99.02-2.97-.05-2.78.03.86-.03,2.91-.02,3.5.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1613.75,38.63c-.71.04-.28.07.14.11l1.12-.1c-.33,0-.99.01-1.26,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1618.46,38.79l2.9-.11c-3.34-.02-3.81.07-6.72.09,1.23.04,2.96-.05,4.52-.01l-.7.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1676.52,38.88c-.26.07.39.06-1.76.11,2.95-.04,5.49-.03,8.87-.04-.57-.05,1.95-.12.65-.11l-3.77.04.57-.05c-2.65-.06-1.73.08-4.56.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1828.21,39.65c-.35.04.1.07.56.1,2.25-.04-1.01-.09-.56-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.57,83.55c-.19-.78-.06.26-.04,1.21l.04-1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.53,84.76l-.03.86c.03-.23.03-.53.03-.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.4,92.77c-.15-1.84.06-4.04-.17-5.19-.13,1.86-.08,4.73.17,5.19Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.55 90 1873.43 89.77 1873.62 91.39 1873.55 90"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.66 88.85 1873.62 89.08 1873.74 91.61 1873.66 88.85"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.32,99l-.03-1.85c.17-1.73.22,1.14.34-.01,0-2.3-.35-.79-.29-3.67-.16.23,0,4.61-.25,4.15-.08,2.42.15.12.24,1.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.65,210.11c0,.1-.02.18-.02.26.03-.1.05-.21.02-.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.83,240.54c-.02.42-.03.84-.05,1.24.03-.12.05-.28.07-.49l-.02-.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.19,191.05c.02-.44.04-.84.06-1.2-.03.23-.06.59-.06,1.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.29,384.88c-.02-.07-.04-.13-.07-.16,0,.01,0,.03,0,.06l.07.34v-.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.21,274.61c0,.48.02.95.03,1.37,0-.8,0-1.18-.03-1.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.17,180.07c0,.17,0,.31,0,.46,0-.15.02-.34.03-.57l-.02.09v.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.16,230.6c-.02.41-.03.79-.03,1.1.02-.38.03-.74.03-1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.04,127.22c-.02.52,0,.96.02,1.34.04-.33.04-.76-.02-1.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.07,138.1v-.06c-.03.06-.02.1,0,.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.04,145.06s0-.08,0-.12c-.02.08-.03.12,0,.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.06,128.56c-.1.9-.41,1.17-.07,2.33l.05-.23c-.08.7.06,1.73.07,2.54.03-.08.06-.18.08-.29,0-.41.02-.94.04-1.77.07-.98-.09-1.62-.17-2.58Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.59,209.99c.06-.1.03-.83,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.33,200.61c0,.31,0,.61-.01.92.01-.3.02-.59.01-.92Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.42,165.26c0,.06,0,.11-.01.17.04.05.03-.09.01-.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.32,202.38v-.85c0,.26-.02.53,0,.85Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.23,175.87c0,.05,0,.1,0,.15,0-.03,0-.09,0-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.19,530.23c-.03-.71.06-1.13.09-1.8-.23-1.51,0,3.11-.21.92,0,.67.03,1.2.06,1.69l.21-.95c-.08-1.32-.07.88-.16.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.85,393.72l.02-.3c-.1.21-.13.02-.18,1.19.15.99.37-.56.54,1.18-.02-.34,0-.84.01-1.31-.13.71-.27,0-.39-.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.24,394.47s0-.03.01-.05c.02-.07.04-.16.05-.25,0-.25,0-.49.02-.69-.04.19-.07.57-.09,1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.29,506.63c0-.29.01-.55.02-.79-.04.39-.04.62-.02.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.47,272.42c-.02-.34-.05-.68-.07-.95.01.52.04.79.07.95Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.06,376.92c.01-.27.02-.54.03-.84,0-.18,0-.32-.01-.53l-.02,1.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.13,432.9c-.24-.6.02.46-.12,1.65l.13,1.11c.04-1.02,0-1.96,0-2.77Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.12,531.11s.01,0,.02.01c0-.03,0-.05,0-.09l-.02.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.18,465.79c-.01.19-.02.36-.03.54.01-.11.03-.28.03-.54Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.34,387.88v-4.23s-.05,1.24-.05,1.24c.12.59-.1,2.41.05,3Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.27,414.84l.15-.38c-.32-4.21.14-9.04-.31-12.4.52-5.13-.47-3.37,0-8.07l-.07.16c.09-15.47.36-31.88.11-46.34l.1.03c.18-23.31-.04-46,.04-69.1-.1-2.15-.33-.86-.44-2.71,0-.81,0-2.63.12-2.64.07,1.56.18.68.23,1.22-.01-2.6.13-5.95-.02-8.27l-.17,1.94c-.07-.9-.02-2.32-.01-3.13.08.34.27-.84.31-.14-.41-4.89.18-3.82.01-7.93-.35-.82-.64-5.97-.89-9.37l.09-1.78c0,2.37.26-.04.24,2.89.1-2.45-.05-4.73,0-7.04-.09.45-.2.34-.24-.6.05-1.43.22-1.55.24-3.18l.11,1.61c.13-1.08-.04-2.01-.06-3.02.15-.33.17-2.76.34-2.33-.2-2.19-.09-2.97-.21-5.32-.15,2.45-.19-.63-.32-.35l.06,2.76c.1-3.9.03,1.27.28.97-.12,1.83-.41-2.51-.37.55-.13-3.67-.02-4.44-.22-8.19.05,2.26-.16-.43-.24.78,0-2.87.09-.71.25-1.6,0-1.56.14-2.14-.05-3.58.08-2.53.19.38.29-.9.17.94-.21,7.05.34,6.36,0,1.32.22,2.94.21,4.84.07-1.66.25-4.04.13-6.1l-.31-.1c0-1.56-.22-1.88-.19-3.01.09.6.22-.48.2-1.74-.04.36-.03.86-.09.72-.02-2.33-.24-2.65-.29-5.42-.08,2.28-.17,2.76-.31,4.89-.22-.57-.03-1.51-.06-2.76.03.19.04.45.08.08l-.1-1.34c.09-2.85.32.36.42-1.99.18-1.62-.1-2.22,0-3.47-.02.08-.04.17-.06.24,0-.28.01-.47.02-.62,0,0,0,.02-.02.02-.03-1.51-.01-3.13-.18-3.56.07-.16-.02-1.32-.07-1.82-.07-.84-.26-2.86,0-4.12,0,.03,0,.06,0,.09.03-1.88.11-3.35.2-2.94l.07-3.04.21.33c-.06-2.77-.18-2.49-.4-4.39.13-1.98.02-5.45-.05-6.76,0-.22,0-.55,0-1.1l-.08,1.16c0-2.16-.1-1.9-.1-3.32-.02.3-.03.34,0-.46,0-.24,0-.5.02-.82.02.07.02.39,0,.71l.07-.26c.22-1.73-.13-2.65-.05-4.5,0,.18.02.47.02.66.06-1.04.36-2.53.17-2.96.02-.24-.01-.61-.06-.96l.03-.76c-.01.31-.02.55-.03.75-.06-.47-.14-.92-.09-.99l.04-2.65c.03-.5,0-1.19-.03-1.74l.09-.45c-.01-.97.04-.97.06-.86.3-3.36-.16-5.19.11-8.82-.15-.69-.21.81-.29.92-.11-.57-.21-2.64-.29-3.68.2-1.61.38-6.57.67-5.77.02-2.99-.18.93-.28-.56v-.34c-.02,1.03-.12,1.84-.23,2.42-.16.23-.2-2.41-.16-3.22l.22.57c-.08-2.76-.42-2.18-.64-3.9.09-2.19.29-.93.49-1.39l-.06-2.31h.17c-.04-1.5-.2-1.85-.14-3.92.16,1.5.16-3.11.37-1.04.06-1.15-.27-1.48-.04-2.07-.18-.8-.09,1.03-.15,1.61-.26.47-.12-2.53-.19-3.91.13-.12.16.92.25-.71-.1-.33-.18-1.37-.06-2.29-.17,0-.03-1.85-.02-2.77-.03,1.04-.16,2.54-.3,1.86-.07-.81-.1-1.5-.08-3.34l-.08,1.27c-.25-1.61.18-2.65.1-4.84.1.92.1,1.5.22,2.3-.08-1.03-.2-3-.28-4.61l.25-1.85c-.12-.23.01-2.08-.16-2.08.11-2.3.2,1.85.33,2.08.11-2.88-.28-2.31-.02-5.07l.16.92c.01-.92-.08-2.76,0-2.88-.06,0-.03.46-.03,1.04-.34-.57-.24-4.25-.58-3.91l-.02,1.27c-.07-1.95-.3-3.33-.18-4.83.11-1.15.24.81.33,1.49.02-1.83-.38-1.49-.35-3.68-.06,1.15-.18.93-.27.24-.02,1.27-.09,3.91.06,3.45l.03-.46c.09.12.12.81.17,1.15,0,1.73-.16.81-.22,1.15-.06,2.88.35.23.34,2.87l-.07.34c.09,1.27.1,3.23.32,3.57-.23,1.15.09,2.99-.04,4.25-.49.24.03-4.48-.24-5.98-.1,1.38-.24-.79-.35-1.37l.21,4.37c-.07.35-.31,1.63-.13,2.42v-.34c.07,1.73.27,1.27.2,2.76-.04.23-.12-.23-.16-.34-.05,1.38.11,1.15.16,2.07-.04,1.38-.2-.69-.26.46.19,1.6-.04,2.53-.03,3.92.28-.59.38,5.52.63,2.52l.19,3.33c-.15,1.04-.39-2.29-.63-1.37v-2.65c-.34.44.24,5.56-.15,7.31-.02,1.42.03,1.07-.14,3.75l.31-.46c-.07,1.39-.24,1.84-.3,1.91.02.82.01,1.55,0,2.31-.05-.2-.09-.48-.1-.98-.17,1.05-.11,1.35-.02,1.72.08.57.07,1.43.07,2.3l-.12-.78c.03.53.06,1.18.12,1.24,0,.36,0,.7.03,1.03.05-.23.24-.81.32-2.06-.12,3.23-.06,5.75-.31,8.52-.09-.1-.2-1.26-.21-.91-.05,1.38.11,2.88.25,2.76,0,.31,0,.55.01.76-.08.26-.16.59-.17,1.24-.03.15-.05.4-.06.87.25.46.12,3.11.24,3.69.03-.62.02-1.39.02-2.17.16,1.11.35,2.11.22,2.97-.16-2.06-.26,2.2-.33-.91-.31,2.19.22,1.14.11,3.46l-.12,1.5c-.18-.23-.09-2.42-.16-2.07l.02,1.04c-.14-1.04-.05-4.96-.25-7.37l-.1,4.84c.21,6.1-.03,13.71.36,18.89v-.22c.01.09.05.13.11.21l-.05.23.14,1.02c-.17,1.16-.2,3.34-.34,5.2q.11-1.16.25-1.28c.18.23.26.41.19,2.14-.13.02-.12-1.05-.23.23.06-.66.15-.07.17.68-.08.97-.1,2.6-.23,2.62-.03-.45,0-.81.03-1.12-.03-.45-.12,1.83-.22.49l.04,1.76c-.11,1.03-.17-.68-.24-.27.09,2.93.38,4.42.47,7.07-.07-.12-.35-.15-.27-.12-.09,2.04.31,4.37.33,6.69-.08-.34-.05-1.21-.09-1.91-.11,7.09-.11,12.9-.39,19.55l.29,1.73-.2,1.74c-.19,7,0,12.37.09,19.03.02,2.07-.2,1.24-.29,2.22-.03,4.55.3,5.66.36,10-.09-.6-.34-1.61-.35.25.08.35.22.58.17,1.75l-.09-.6c-.13,1.08,0,2.12-.06,4.35,0,3.94.21,7.7.54,10.94-.03,3.48-.32-.36-.38.3.11-2.46-.05-1.71-.15-2.24.08,1.3.13,2.87-.08,3.54.01,1.81,0,2.63.14,4.42-.07-.9.04-1.67.14-.83-.07,1.48,0,5.25-.25,5.04,0,8.58,0,18.18,0,27.37.14,1.55.05-1.18.15-.32.18,2.25-.09,1.78.05,3.58l-.14-.74c-.02,2.68.24,5.53.38,8.13-.16-.43-.13,2.14-.23-.02.03,1.27-.7,2.81-.55,3.79l.68-1.43c.07.07.03,1.85.07,1.67-.13,1.11-.29,2.47-.29,3.24-.17.37-.13-1.56-.13-2.61-.29-.16-.18,3.56-.45,2.03.05,2.27.15-.32.25,1.03l-.06,1.98.1-1.53c.09,1.65.3,2.22.14,4.42l.28,2.28c-.23.23-.04,1.67-.09,2.84l-.14-.74c0,1.56-.03,2.17-.11,3.15-.2-.88.05-1.41-.14-1.79l-.07,1.72c.13,0,.23,1.08.31-.15.24,1.59.44,2.46.42,6.45-.22,1.8-.19-1.94-.41-1.19-.09,4.14.57,5.07.54,7.49-.09,3.09.11,2.91.13,6.04-.15-1-.16,2.19-.3,2.77l-.15-1.24c.05.95-.01,1.87-.12,1.58.2-.18.19,4.06.28,6.22l.17-.38c.06,1.69.17,4.03.12,5.82.06,2.66.21,2.06.39,4.11-.16,1.13-.34,1.01-.53.63.09-.71.04-1.92.09-3.09-.15-3.37-.51-5.98-.43-9.34-.42-1.46.05,2.26-.1,3.9-.02-.05-.03-.17-.04-.29,0,.15,0,.27-.01.41-.05-1.2-.12-3.17-.33-3.49.04,2.01.42,1.46.24,3.96.12,1.85-.21,3.36-.24,4.49.16,1.24.49,1.29.43,4.33l-.23-1.33c0,3.44.34,1.61.33,4.8.03-1.12.23,1.08.24-1.05.12,1.05.15,3.36.08,5.09.04.45.08.09.16.18.16-1.91-.16-3.03.08-4.6l-.25-1.33c.09-1.78.29-1.96.39-.87-.01-.5-.05-.94,0-1.31.38-.3-.13,2.14.19,2.75l-.03-1.26c.25-.54.22,2.94.2,4.56-.12,1.83-.16,3.51-.34,3.64l-.08-2.46c-.14,1.28.08,3.14.08,4.58-.02.09-.04.23-.06.4.02-.07.03-.12.05-.12,0,.3-.03.58-.07.81,0,1.26.1,3.1.04,4.27l.16-.15-.09-.16c0-1.15.1-2.71.22-1.84.11,2.6-.2,3.12-.33,3.74-.24-.6,0-2.53-.08-3.85-.24.8-.03,2.64-.18,5.32-.26-1.07,0-3.11-.24-3.7-.05,2.16.14,2.73.08,5-.12-.29-.13-2.51-.29-2.36l-.08,1.46c-.02-3.58-.33.63-.39-2.17-.11,1.32.22,1.84.05,3.72.11-.52.32-2.02.43-.23l-.08,2.03c-.13.85-.28-2.12-.39-.8l.09,2.12c.08-.07.12-1.09.23-.45-.09,1.23.3,2.01.42,3.46,0,1.15-.02,2.07-.11,2.47.23,2.9.23,6.58.45,9.25-.16-1.82-.27.07-.39,1.16-.03-2.1-.28-2.12-.44-1.97.03,1.28.28,2.12.36,1.47-.1,2.14.17,1.47,0,3.35-.09,1.22-.24-.61-.34-.19-.01,2.31.3.63.24,3.13-.03-.14-.04-.37-.09-.17-.05,1.35.06,2.81.19,3.1-.32,1.44.03,4.06-.28,3.77.08,3.27.17-.49.28.16.14,1.34.02,3.82-.02,4.59,0-.81-.09-1.55-.04-2.33l-.22.69c-.16,4.07.49,2.58.3,6.51-.11-2.02-.16-.67-.32-1.68.05.61,0,3.69.16,1.82-.02,1.48-.06,2.5-.1,3.52.08,1.31.14,2.73.29,3.5-.02,2.07-.18,3.6-.27,4.58.16,4.35-.11,8.36.06,12.94v-.34c-.03,3.55.3-1.57.29,2.12-.27-.49-.18,2.21-.32,3.4-.14,4.53.2,7.83.02,12-.06-.03-.12-.3-.13-1.11-.08,3.18-.03,5.75-.04,8.62l-.03-.12c-.22,4.6.04,8.78.11,13.55-.03-.39-.13-.49-.17-.79-.06,2.4-.1,6.24.14,7.92-.26,2.85.08,1.89-.17,5.55-.05.21-.04-.36-.05-.61-.09,1.8-.06,3.08-.09,4.9.17,4.02.51,5.02.41,9.69-.36.24-.09-2.87-.38-2.98.06.93.14,1.74.05,3.03-.14-.77-.09-.17-.22-.7-.05.49.05,1.48.15,2.35.05.43.1.84.14,1.13.04.29.06.48.05.47.07.05.11-.28.1-1.21.22,1.09.02,4.59.11,6.86,0-.74.08-3.05.25-2.18-.08,3.04.27,4.05.42,6.17-.16,2.8-.3-2.06-.56-1.54-.09.47-.3,1.59-.39.42-.05,2.52.16,4.33.22,6.57l-.07-.06c.03,3.13.34,6.48.2,9.11l.08-1.4c.04.51.02,2.09.17,2.97-.12-.09-.23,1.95-.33,1.11.38,1.39.23,7.12.59,8.69-.1.84-.25.17-.34-.09.03-1.98.11-2.65-.04-3.69,0,1.65-.09,2.85-.18,2.6.24,1.65.33,5.57.57,6.39-.12,1.2-.18,2.35-.38,1.93.12,5.05.61-2.49.61,3.21-.19,2.6-.26-2.54-.33,1.05l-.03-.66c-.51,2.59.36,1.82.35,4.75-.28.39-.2-2.04-.4-.02.07,2.68.48,3.86.39,6.54l-.12-.42c0,1.72,0,5.05-.01,6.76-.05.08-.05-.17-.06-.49-.11,3.16.14,1.32-.05,3.91l.13.74c.1-1.3.23-3.82.07-5.46.16,1.64.35-2.58.59-1.76l-.1-.33c.41-4.29.46-9.83.61-15.28-.28-3.44.11-5.85-.08-9.54-.32-.58-.07-.69-.13-3.86.04,1.68.25.2.29-.86-.08-.62-.11-1.37-.14-2.12.11-.64.37-4.63.15-6.09.1-1.93.1.45.17.87.17-.78-.13-1.57-.02-2.21,0,0,.04.03.05.23-.01-2.95.07-4.71.11-7.78-.32-.25-.12-3.02-.23-4.38.1.44.12-1.73.18-2.6l-.24-1.64c-.2-1.63.14-2.26.03-4.37l-.06.51c-.1-1.54.1-5.58.27-7.09-.62-14.2.35-21.96.18-36.93-.1-.97-.16.71-.3-.05-.04-1.52-.02-1.87-.03-3.25-.09,1.22.02,1.03-.07.87l.09,2.12c-.02.1-.03-.13-.08.07.03.71.09,1.55.08,2.46-.08-1.31-.32-1.68-.23-3.47.03.14.04.37.06.84.02-1.48-.09-1.55-.03-2.67.05-1.36-.02-1.03.08-1.2l.13-4.22c-.28-2.11-.01-4.7.01-5.39.21.46.06,2.8.27,3.84l.15-1.52-.17-.09.05-2.17.03.12c-.07-.26-.13-.52-.07-1.08.02-.09.07-.31.08-.06l-.09-1.55c.17.9.05-1.36.25-1.13.1-5.05-.27-6.42,0-10.86-.09.72-.32-1.41-.28-2.77.05-.79.09-.99.17-.49l-.1-1.79c.31-2.24.11-4.43.22-7.72l.09.17c-.1-1.22-.19-2.53-.16-4.36l.18.33c.12-2.24-.37-1.71-.26-4.18-.19.01-.29,1.57-.47,1.81.19-.58.22-3.24.08-2.62-.08-2.46,0-1.71.05-1.92l-.12-1.45c0-1.73.25-.55.36.09-.21-1.61-.06-3.37-.03-5.21l.09.74.03-2.41c-.15-1.57-.16-3.77-.08-5.8l.25,1.4c.13-1.43-.09-.73-.13-1.11-.12-2.25.05-2.74.19-3.93-.26-3.61.41-7.18.03-10.27Zm-.97-248.73l-.04.33c-.04-.75-.08-1.18.04-.33Zm-.07,19.81c-.1-2.39.02-1.63.09-1.81-.07,2.35.01,3.66-.07,5.73.05-.33.12-.4.16-.51-.01.83-.07,1.66-.2,1.94-.25-1.03.16-6.39.02-5.36Zm-1.24-44.6c.02.08.04.18.06.28h0s-.06-.28-.06-.28Zm.22,11.81c-.05.17-.08.46-.1.82.07-.22.12-.43.1-.82Zm-.31,23.51c-.11.54-.07,1.78-.05,2.68.01-.42.04-1.18.05-2.68Zm.11,148.29c-.04-.71-.15-2.05-.22-.83.09.59-.07,1.72.07,2.22,0,.07,0,.08-.01.12.09-.71.16-1.3.16-1.51Zm.86,69.71c-.1-.13-.22-.65-.29-.32,0-.06,0-.14,0-.2-.04.18-.06.33-.09.19-.02.57-.05,1.16-.02,1.56.34.19.39,1.39.39-1.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.48,371.35c0,.27,0,.48,0,.65,0-.18,0-.38,0-.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.48,395.75c.02.05.05-.62.09-1.44-.04.17-.08.57-.09,1.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.13,102.9l.03.69.1-1.38c-.11-2.31-.26-2.42-.43-2.99.16,2.07.08,3.33.12,5.98l.17-2.3Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873,104.07c-.04.23-.16.81-.17,1.16l.1.34.07-1.5Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.51,131.37l.09-2.19c-.09-.69-.25,1.85-.09,2.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.29,121.66l-.11-1.15c-.09,1.03-.08,2.42.04,2.65-.07-1.38.07-.34.07-1.5Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.49,137.25c.2.68-.09,2.19.1,2.64-.06-.58.1-2.53-.1-2.64Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.41,135.72c.19-.69.02-1.84.07-3.23,0,1.15-.2,2.77-.07,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.06,148.99c-.14-.11-.13-1.03-.1-2.07.04.35.11.58.13,1.04-.11-1.73-.09-1.85-.16-3.23-.1,1.38-.17,3.46-.35,3.24.14,1.03.34,2.3.47,1.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.44,139.05c.06-1.15.19-1.85.18-3.23-.1.24-.25.7-.22,2.31l-.17-.58c-.12,1.5.22-.59.21,1.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.67,155.33l.08-.7c-.14-1.61-.07-3.69-.28-4.6.01,1.95.1,4.37.2,5.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.12,144.71l.24.22c.03-1.61-.08.12-.14-.46.03-.46.06-1.15.01-1.49.03,1.83-.19.12-.11,1.73Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.38,150l.1,2.06.26-1.61c-.09-2.42-.15-.12-.36-.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.22,152.54l-.05.23.35,3.1c-.15-1.85-.12-1.96-.3-3.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.69,190.1c.1.35.23-1.47.11-.69-.08-.35-.21,2.07-.11.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.58,182.69c-.08.88.07,3.77.14,5.04-.05-1.51,0-5.25-.14-5.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.74,188.25c0-.1-.02-.29-.03-.52,0,.23.02.4.03.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.26,241.49c0,.14.01.27.03.39,0-.13-.02-.25-.03-.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.21,240.22c.03-.86-.03-2.56-.14-2.86.05,1.35.08,2.55.2,4.13-.01-.59.06-1.32-.06-1.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.15,252.45c-.06-.64-.03-1.51-.13-1.29-.04.36.06,1.71.13,1.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.2,334.81c-.05,1.18-.01,1.87.14,1.55,0-1.32-.09-.6-.14-1.55Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1872.37 337.87 1872.3 338.03 1872.18 338.81 1872.37 337.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.15,345.98c-.02-.06-.05-.27-.06-.49.02.46.04.85.06.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.08,345.26c0,.07,0,.16,0,.23,0-.07,0-.16,0-.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.13,344.73l-.08-.09c0,.13.02.38.03.63,0-.22,0-.45.05-.53Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.13,348.42l.22-1.55c-.11-1.61-.11,1.83-.35.25l.13,1.3Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.19,353.8c-.07,1.48.28,3.6.01,4.44.14,4.18.44-.97.54,3.82.14-4.52-.51-2.3-.36-6.31-.16,1.94-.13-1.3-.19-1.95Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.64,353.09c-.13-.24-.15,1.63-.06,2.22.01-.54.2-1.49.06-2.22Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1872.31 361.98 1872.21 363.25 1872.29 363.59 1872.31 361.98"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.26,366.83l-.15-1.24c.06.41.05,2.28.15,1.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.06,373.58c-.05,1.17.3,2.23.23-.24v.56c-.07-.15-.19,1.19-.23-.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.62,389.2c0-.81-.04-1.76-.11-1.59l.07,2.21.04-.62Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.49,388.87c.22-.74-.02-2.07.05-3.54-.04,1.67-.07,1.47-.05,3.54Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.32,391.73c-.09-.6-.03-1.52-.02-2.07-.12.27-.09,1.79.02,2.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.39,395.25c-.09.72-.12-.16-.18.39-.1,1.55-.08,3.18.03,4.06.09-.41.34-.97.45-.33-.08-2.47-.48-3.74-.17-4.94l-.38-2.07c-.06,1.98.26,1.52.24,2.89Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.11,390.25l-.13,1.32c.12-.27.14.74.18,1.44.28-.35-.04-2.01-.06-2.77Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1872.56 408.96 1872.62 411.77 1872.64 410.86 1872.56 408.96"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1872.47 410.77 1872.39 410.84 1872.54 412.99 1872.47 410.77"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1872.37 413.71 1872.39 413.38 1872.32 411.72 1872.37 413.71"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.32,419.57l.12-.52c-.03-.71.1-2.14-.06-2,.05.62.03,2.1-.06,2.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1875.28,438.98c-.08-.51-.14-.2-.21.1l.2.81c-.01-.24-.03-.71.02-.91Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.95,442.37l.23,2.09c.03-2.4-.14-2.74-.18-4.83-.07.89.09,2.13.03,3.25l-.08-.5Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.78,484.14c-.15-.19-.12.28-.22-1.27.09,2.12.06,3.95.08,6.38.09-.41.25,1.4.21.47l-.09-2.71.1.41c.11-1.91-.16-1.24-.08-3.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.24,593.27c-.07-.25-.13.07-.2.4.08,1.62.18-.73.2-.4Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.63,781c-.09-.04-.03.01-.02.07l.02-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.61,781.07v.05s0-.03,0-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.55,781.52c-.07-.1.03-.23-.08-.29-.07.1-.04.27.08.29Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.62 781.37 1873.56 781.35 1873.65 781.45 1873.62 781.37"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.68 781.3 1873.65 781.31 1873.72 781.46 1873.68 781.3"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.5,781.88l-.02-.1c.08-.1.11.06.17,0,0-.13-.17-.04-.15-.21-.08.01,0,.26-.12.23-.04.14.07,0,.12.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.17,788.17s0,0-.01.01c.01,0,.02-.01.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.26,789.89s-.02.05-.03.07c.01,0,.02-.02.03-.03v-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.94,787.09s.02-.05.03-.07c-.02.01-.03.03-.03.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.49,798.07s-.02,0-.04,0c0,0,0,0,0,0l.03.02h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.45,791.82s0,.05.01.08c0-.05,0-.07-.01-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.93,786.47s0,.02,0,.03c0,0,0-.02.01-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.42,789.33s-.02.04-.01.06c.01-.02.01-.04.01-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.36,783.47s0,.05.01.08c.02-.02.02-.04-.01-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.38,784.09s0,0,0,0c-.01,0-.01,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.37,784.48s0,0,0,0c-.01,0-.01,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.38,783.55c-.05.05-.21.07-.03.13h.02s.03.08.03.13c.02,0,.03-.01.04-.02,0-.02,0-.05.02-.1.04-.06-.05-.09-.08-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.14,788.16s.02-.05,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.01,787.63s0,.03,0,.05c0-.02.01-.03,0-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.05,785.63s0,0,0,0c.02,0,.02,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874,787.73s0-.03,0-.05c0,.01-.01.03,0,.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.96,786.23s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.94,806.3s.03-.06.04-.1c-.11-.09,0,.18-.1.05,0,.04.02.07.03.1l.11-.05c-.04-.07-.04.05-.08,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.27,798.57v-.02s-.05,0-.08.07c.07.06.19-.03.27.07,0-.02,0-.05,0-.07-.07.04-.14,0-.19-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.46,798.61s0,0,0,0c.01,0,.02,0,.03-.01,0-.01,0-.03.01-.04-.02.01-.04.03-.04.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.99,804.96s0-.03.01-.04c-.02.02-.02.03-.01.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.08,791.7s-.02-.04-.03-.05c0,.03.02.04.03.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.37,797.62s.01-.03.02-.05c0-.01,0-.02,0-.03v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.41,800.79c-.12-.03,0,.03-.06.09l.06.06c.02-.06,0-.11,0-.16Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1872.91 806.35 1872.92 806.35 1872.91 806.34 1872.91 806.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.44,802.65s-.01.02-.02.03c0,0,.01-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.51,798.24v-.24s-.02.07-.02.07c.06.03-.05.14.02.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.48,799.76l.07-.02c-.16-.24.07-.51-.15-.7.26-.29-.23-.19,0-.46h-.04c.04-.87.18-1.8.05-2.62h.05c.09-1.32-.02-2.6.02-3.91-.05-.12-.16-.05-.22-.15,0-.05,0-.15.06-.15.04.09.09.04.12.07,0-.15.07-.34-.01-.47l-.08.11c-.03-.05-.01-.13,0-.18.04.02.13-.05.15,0-.21-.28.09-.22,0-.45-.18-.05-.32-.34-.45-.53l.05-.1c0,.13.13,0,.12.16.05-.14-.02-.27,0-.4-.04.03-.1.02-.12-.03.02-.08.11-.09.12-.18l.06.09c.07-.06-.02-.11-.03-.17.07-.02.09-.16.17-.13-.1-.12-.04-.17-.11-.3-.08.14-.1-.04-.16-.02l.03.16c.05-.22.01.07.14.06-.06.1-.21-.14-.19.03-.06-.21,0-.25-.11-.46.02.13-.08-.02-.12.04,0-.16.04-.04.12-.09,0-.09.07-.12-.02-.2.04-.14.09.02.15-.05.09.05-.11.4.17.36,0,.07.11.17.1.27.04-.09.13-.23.06-.35h-.16c0-.09-.11-.11-.1-.18.04.03.11-.03.1-.1-.02.02-.02.05-.04.04-.01-.13-.12-.15-.15-.31-.04.13-.09.16-.15.28-.11-.03-.02-.09-.03-.16.01.01.02.03.04,0l-.05-.08c.05-.16.16.02.21-.11.09-.09-.05-.13,0-.2-.01,0-.02,0-.03.01,0-.02,0-.03,0-.03,0,0,0,0,0,0-.02-.09,0-.18-.09-.2.04,0-.01-.07-.04-.1-.03-.05-.13-.16,0-.23,0,0,0,0,0,0,.02-.11.06-.19.1-.17l.03-.17.11.02c-.03-.16-.09-.14-.2-.25.06-.11.01-.31-.03-.38,0-.01,0-.03,0-.06l-.04.07c0-.12-.05-.11-.05-.19-.01.02-.02.02,0-.03,0-.01,0-.03,0-.05.01,0,0,.02,0,.04h.04c.11-.11-.06-.16-.02-.27,0,.01.01.03.01.04.03-.06.18-.14.09-.17.01-.01,0-.03-.03-.05l.02-.04s-.01.03-.02.04c-.03-.03-.07-.05-.05-.06l.02-.15s0-.07-.01-.1l.04-.03c0-.05.02-.06.03-.05.15-.19-.08-.29.05-.5-.07-.04-.11.05-.15.05-.06-.03-.11-.15-.15-.21.1-.09.19-.37.34-.33.01-.17-.09.05-.14-.03v-.02c-.01.06-.06.1-.12.14-.08.01-.1-.14-.08-.18l.11.03c-.04-.16-.21-.12-.32-.22.04-.12.15-.05.25-.08l-.03-.13h.08c-.02-.08-.1-.1-.07-.22.08.08.08-.18.19-.06.03-.07-.13-.08-.02-.12-.09-.05-.04.06-.07.09-.13.03-.06-.14-.1-.22.07,0,.08.05.12-.04-.05-.02-.09-.08-.03-.13-.08,0-.02-.1-.01-.16-.02.06-.08.14-.15.11-.03-.05-.05-.09-.04-.19l-.04.07c-.12-.09.09-.15.05-.27.05.05.05.08.11.13-.04-.06-.1-.17-.14-.26l.12-.1c-.06-.01,0-.12-.08-.12.06-.13.1.1.16.12.06-.16-.14-.13-.01-.29l.08.05c0-.05-.04-.16,0-.16-.03,0-.02.03-.02.06-.17-.03-.12-.24-.29-.22v.07c-.04-.11-.16-.19-.1-.27.06-.07.12.05.16.08.01-.1-.19-.08-.17-.21-.03.07-.09.05-.13.01-.01.07-.04.22.03.2l.02-.03s.06.05.08.06c0,.1-.08.05-.11.07-.03.16.17.01.17.16l-.03.02c.04.07.05.18.16.2-.11.07.04.17-.02.24-.25.01.02-.25-.12-.34-.05.08-.12-.04-.17-.08l.11.25s-.16.09-.07.14v-.02c.03.1.14.07.1.16-.02.01-.06-.01-.08-.02-.02.08.06.07.08.12-.02.08-.1-.04-.13.03.1.09-.02.14-.02.22.14-.03.19.31.31.14l.1.19c-.07.06-.2-.13-.31-.08v-.15c-.17.02.12.31-.08.41,0,.08.02.06-.07.21l.16-.03c-.04.08-.12.1-.15.11.01.05,0,.09,0,.13-.02-.01-.04-.03-.05-.06-.09.06-.05.08,0,.1.04.03.03.08.03.13l-.06-.04s.03.07.06.07c0,.02,0,.04.01.06.03-.01.12-.05.16-.12-.06.18-.03.33-.16.48-.05,0-.1-.07-.11-.05-.02.08.06.16.12.16,0,.02,0,.03,0,.04-.04.01-.08.03-.09.07-.01,0-.03.02-.03.05.12.03.06.18.12.21.01-.04.01-.08,0-.12.08.06.18.12.11.17-.08-.12-.13.12-.16-.05-.16.12.11.06.06.2l-.06.08c-.09-.01-.04-.14-.08-.12v.06c-.06-.06-.01-.28-.11-.42l-.05.27c.11.35-.02.78.18,1.07,0,0,0,0,0-.01,0,0,.03,0,.06.01h-.02s.07.07.07.07c-.08.07-.1.19-.17.29q.06-.07.12-.07c.09.01.13.02.09.12-.06,0-.06-.06-.11.01.03-.04.08,0,.08.04-.04.06-.05.15-.11.15-.02-.03,0-.05.01-.06-.02-.03-.06.1-.11.03l.02.1c-.05.06-.08-.04-.12-.02.04.17.19.25.23.4-.03,0-.18,0-.14,0-.04.12.16.25.17.38-.04-.02-.03-.07-.05-.11-.05.4-.06.73-.19,1.11l.15.1-.1.1c-.09.4,0,.7.04,1.08,0,.12-.1.07-.14.13-.02.26.15.32.18.57-.04-.03-.17-.09-.18.01.04.02.11.03.08.1l-.04-.03c-.07.06,0,.12-.03.25,0,.22.11.44.27.62-.01.2-.16-.02-.19.02.05-.14-.03-.1-.08-.13.04.07.07.16-.04.2,0,.1,0,.15.07.25-.04-.05.02-.09.07-.05-.04.08,0,.3-.13.29.03.49,0,1.03,0,1.55.07.09.03-.07.07-.02.09.13-.05.1.02.2l-.07-.04c-.01.15.12.31.19.46-.08-.02-.07.12-.12,0,.01.07-.35.16-.28.21l.34-.08s.01.1.04.09c-.07.06-.15.14-.15.18-.09.02-.07-.09-.07-.15-.14,0-.09.2-.22.11.02.13.07-.02.13.06l-.03.11.05-.09c.04.09.15.13.07.25l.14.13c-.11.01-.02.09-.05.16l-.07-.04c0,.09-.02.12-.06.18-.1-.05.02-.08-.07-.1l-.03.1c.06,0,.11.06.15,0,.12.09.22.14.21.37-.11.1-.1-.11-.2-.07-.05.23.28.29.27.42-.04.17.06.16.06.34-.07-.06-.08.12-.15.16l-.08-.07c.02.05,0,.11-.06.09.1-.01.09.23.14.35l.09-.02c.03.1.08.23.06.33.03.15.1.12.2.23-.08.06-.17.06-.26.04.04-.04.02-.11.04-.18-.07-.19-.26-.34-.21-.53-.21-.08.02.13-.05.22-.01,0-.02,0-.02-.02,0,0,0,.02,0,.02-.03-.07-.06-.18-.17-.2.02.11.21.08.12.22.06.1-.11.19-.12.25.08.07.24.07.21.24l-.12-.08c0,.19.17.09.17.27.01-.06.11.06.12-.06.06.06.07.19.04.29.02.03.04,0,.08.01.08-.11-.08-.17.04-.26l-.13-.08c.05-.1.15-.11.2-.05,0-.03-.02-.05,0-.07.19-.02-.07.12.09.16v-.07c.11-.03.09.17.09.26-.06.1-.08.2-.17.21l-.04-.14c-.07.07.04.18.04.26-.01,0-.02.01-.03.02,0,0,.02,0,.02,0,0,.02-.02.03-.04.05,0,.07.05.18.02.24h.08s-.04-.02-.04-.02c0-.07.05-.15.11-.1.06.15-.1.18-.17.21-.12-.03,0-.14-.04-.22-.12.05-.01.15-.09.3-.13-.06,0-.18-.12-.21-.02.12.07.15.04.28-.06-.02-.07-.14-.15-.13l-.04.08c0-.2-.16.04-.2-.12-.05.07.11.1.02.21.06-.03.16-.11.21-.01l-.04.11c-.06.05-.14-.12-.19-.04l.04.12s.06-.06.11-.03c-.04.07.15.11.21.2,0,.07-.01.12-.06.14.12.16.11.37.22.52-.08-.1-.13,0-.19.07-.02-.12-.14-.12-.22-.11.01.07.14.12.18.08-.05.12.09.08,0,.19-.04.07-.12-.03-.17-.01,0,.13.15.04.12.18-.02,0-.02-.02-.04,0-.03.08.03.16.09.18-.16.08.02.23-.14.21.04.19.09-.03.14,0,.07.08.01.22-.01.26,0-.05-.05-.09-.02-.13l-.11.04c-.08.23.25.15.15.37-.06-.11-.08-.04-.16-.09.03.03,0,.21.08.1,0,.08-.03.14-.05.2.04.07.07.15.14.2-.01.12-.09.2-.14.26.08.25-.06.47.03.73v-.02c-.01.2.15-.09.15.12-.13-.03-.09.13-.16.19-.07.26.1.44,0,.68-.03,0-.06-.02-.06-.06-.04.18-.02.33-.02.49h-.02c-.11.25.02.49.05.76-.02-.02-.07-.03-.08-.04-.03.14-.05.35.07.45-.13.16.04.11-.09.31-.02.01-.02-.02-.03-.03-.04.1-.03.17-.05.28.08.23.26.28.2.55-.18.01-.04-.16-.19-.17.03.05.07.1.03.17-.07-.04-.04,0-.11-.04-.05.06.19.22.17.22.03,0,.05-.02.05-.07.11.06,0,.26.05.39,0-.04.04-.17.12-.12-.04.17.14.23.21.35-.08.16-.15-.12-.28-.09-.05.03-.15.09-.2.02-.03.14.08.24.11.37h-.04c.01.17.17.36.1.51l.04-.08s.01.12.08.17c-.06,0-.11.11-.16.06.19.08.12.4.3.49-.05.05-.13,0-.17,0,.02-.11.05-.15-.02-.21,0,.09-.05.16-.09.15.12.09.17.32.28.36-.06.07-.09.13-.19.11.06.29.31-.14.3.18-.1.15-.13-.14-.16.06l-.02-.04c-.26.15.18.1.17.27-.14.02-.1-.12-.2,0,.04.15.24.22.2.37l-.06-.02c.01.1-.02.29,0,.38-.03,0-.02,0-.03-.03-.05.18.07.07-.03.22l.07.04c.05-.07.12-.22.04-.31.08.09.18-.15.29-.1l-.05-.02c.2-.24.23-.56.31-.86-.14-.19.06-.33-.04-.54-.16-.03-.03-.04-.07-.22.02.09.12.01.15-.05-.04-.04-.06-.08-.07-.12.06-.04.19-.26.08-.34.05-.11.05.03.09.05.08-.04-.07-.09,0-.13,0,0,.02,0,.03.01,0-.17.04-.27.06-.44-.16-.01-.06-.17-.12-.25.05.02.06-.1.09-.15l-.12-.09c-.1-.09.07-.13.02-.25l-.03.03c-.05-.09.05-.32.13-.4-.31-.8.18-1.24.09-2.09-.05-.06-.08.04-.15,0-.02-.09-.01-.11-.01-.18-.04.07.01.06-.03.05l.04.12s-.02,0-.04,0c.01.04.05.09.04.14-.04-.07-.16-.1-.11-.2.02,0,.02.02.03.05,0-.08-.05-.09-.02-.15.03-.08-.01-.06.04-.07l.06-.24c-.14-.12,0-.27,0-.3.11.03.03.16.14.22l.08-.09h-.08s.02-.13.02-.13h.02s-.07-.02-.04-.05c.01,0,.03-.02.04,0l-.05-.09c.09.05.03-.08.13-.06.05-.29-.14-.36,0-.62-.05.04-.16-.08-.14-.16.02-.04.05-.06.09-.03l-.05-.1c.16-.13.06-.25.11-.44h.04c-.05-.06-.09-.13-.08-.24l.09.02c.06-.13-.19-.1-.13-.24-.1,0-.14.09-.24.1.1-.03.11-.18.04-.15-.04-.14,0-.1.03-.11l-.06-.08c0-.1.13-.03.18,0-.1-.09-.03-.19-.01-.29l.04.04.02-.14c-.07-.09-.08-.21-.04-.33l.13.08c.07-.08-.04-.04-.06-.06-.06-.13.02-.15.09-.22-.13-.2.21-.41.02-.58Zm-.49-14.09l-.02.02s-.04-.07.02-.02Zm-.04,1.12c-.05-.14.01-.09.05-.1-.03.13,0,.21-.04.32.02-.02.06-.02.08-.03,0,.05-.03.09-.1.11-.13-.06.08-.36,0-.3Zm-.62-2.53s.02.01.03.02h0s-.03-.02-.03-.02Zm.11.67s-.04.03-.05.05c.03-.01.06-.02.05-.05Zm-.16,1.33c-.05.03-.04.1-.02.15,0-.02.02-.07.02-.15Zm.06,8.4s-.07-.12-.11-.05c.05.03-.03.1.04.13,0,0,0,0,0,0,.04-.04.08-.07.08-.09Zm.43,3.95c-.05,0-.11-.04-.15-.02,0,0,0,0,0-.01-.02.01-.03.02-.04.01-.01.03-.02.07,0,.09.17.01.2.08.19-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.08,797.3s0,.03,0,.04c0-.01,0-.02,0-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.58,798.68s.03-.03.05-.08c-.02,0-.04.03-.05.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.91,782.1l.02.04.05-.08c-.06-.13-.13-.14-.21-.17.08.12.04.19.06.34l.08-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.35,782.16s-.08.05-.08.07l.05.02.03-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.1,783.71l.04-.12s-.12.1-.04.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.99,783.16l-.06-.07c-.04.06-.04.14.02.15-.03-.08.03-.02.03-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.09,784.04c.1.04-.04.12.05.15-.03-.03.05-.14-.05-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.05,783.96c.1-.04.01-.1.03-.18,0,.07-.1.16-.03.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.38,784.71c-.07,0-.07-.06-.05-.12.02.02.06.03.07.06-.06-.1-.04-.1-.08-.18-.05.08-.08.2-.17.18.07.06.17.13.24.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.06,784.14c.03-.07.09-.1.09-.18-.05.01-.12.04-.11.13l-.08-.03c-.06.08.11-.03.11.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.18,785.07l.04-.04c-.07-.09-.03-.21-.14-.26,0,.11.05.25.1.3Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.91,784.46h.12c.02-.08-.04.02-.07-.01.02-.03.03-.07,0-.08.02.1-.1,0-.06.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.04,784.76l.05.12.13-.09c-.04-.14-.07,0-.18-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.96,784.91h-.02s.17.19.17.19c-.07-.1-.06-.11-.15-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.19,787.04c.05.02.11-.08.06-.04-.04-.02-.11.12-.06.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.13,786.62s.03.21.07.29c-.02-.09,0-.3-.07-.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.22,786.93s0-.02-.01-.03c0,.01,0,.02.01.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.48,789.95s0,.02.01.02c0,0,0-.01-.01-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.45,789.87s-.01-.15-.07-.16c.03.08.04.14.1.23,0-.03.03-.07-.03-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.42,790.57s-.02-.09-.06-.07c-.02.02.03.1.06.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.95,795.23c-.03.07,0,.11.07.09,0-.07-.05-.03-.07-.09Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.03 795.4 1872.99 795.41 1872.94 795.46 1873.03 795.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.92,795.86s-.02-.02-.03-.03c.01.03.02.05.03.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.89,795.82s0,0,0,.01c0,0,0,0,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.91,795.79h-.04s.01.02.02.03c0-.01,0-.03.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.91,796l.11-.09c-.06-.09-.06.1-.18.01l.06.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.94,796.31c-.04.08.14.2,0,.25.07.24.22-.05.27.22.07-.26-.26-.13-.18-.36-.08.11-.07-.07-.1-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.16,796.27c-.07-.01-.07.09-.03.13,0-.03.1-.08.03-.13Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873 796.77 1872.95 796.84 1872.99 796.86 1873 796.77"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.97,797.04l-.08-.07s.02.13.08.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.88,797.43c-.03.07.15.13.11-.01v.03s-.1.07-.11-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.16,798.31s-.02-.1-.06-.09l.04.13.02-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.59,798.29c.11-.04,0-.12.03-.2-.02.09-.04.08-.03.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873,798.45s-.02-.09,0-.12c-.06.02-.05.1,0,.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.04,798.65s-.06,0-.09.02c-.05.09-.04.18.02.23.05-.02.17-.05.23-.02-.04-.14-.24-.21-.08-.28l-.19-.12c-.03.11.13.09.12.16Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.4,798.37l-.06.07c.06-.02.07.04.09.08.14-.02-.02-.11-.03-.16Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.12 799.43 1873.16 799.59 1873.16 799.54 1873.12 799.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.08 799.53 1873.04 799.54 1873.11 799.66 1873.08 799.53"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.03 799.7 1873.04 799.68 1873 799.59 1873.03 799.7"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.01,800.03l.06-.03s.05-.12-.03-.11c.03.03.02.12-.03.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.48,801.13s-.07-.01-.11,0l.1.05s-.01-.04,0-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.32,801.32l.11.12c.02-.14-.07-.16-.09-.27-.04.05.04.12.01.18l-.04-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.24,803.69c-.07-.01-.06.02-.11-.07.05.12.03.22.04.36.05-.02.13.08.11.03l-.04-.15.05.02c.06-.11-.08-.07-.04-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.47,809.87s-.07,0-.1.02c.04.09.09-.04.1-.02Z"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.12 821.19 1872.96 821.24 1873.17 821.51 1873.12 821.19"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.94,823.96c.18.25.3.72.65.73l-.31-.45c.26-.06.25-.36.16-.62l.02.3c-.04-.08-.2-.03-.24-.1.13-.45-.23-.57.06-.98l.03.02-.17-.33c.04-.1.16-.06.21-.03-.14-.29-.28-.52-.27-.91-.48.31.37.87-.11,1.18l-.03-.02c.18.38-.13.83,0,1.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.34,822.49s0,.02.01.03c.01,0,0-.01-.01-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.66,838.44l.08.02s-.05-.05-.08-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1873.61,833.56s0,.02,0,.02c.11.03.08.01,0-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.77,864.91l-.11.1c.1-.02.12-.06.11-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.68,871.45h0s0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.16,868.47h.1c-.05-.03-.08-.02-.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.35,870.58c-.02.06-.04.12-.05.18.05-.04.07-.11.05-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.64,871.39s.03.04.04.06c-.01-.02-.02-.05-.04-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.34,865.29l.25-.08c-.08,0-.17.04-.25.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.56,871.11s-.07.07-.09.11c.05-.02.09-.06.09-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1872.96,824.39c0-.06,0-.13-.04-.21-.02.08,0,.15.04.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.57,853.39s.06.03.1.04c-.02-.05-.06-.05-.1-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.53,860.36v.02s.03-.01.05-.03h-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.49,858.33s.03.02.05.03c-.02-.02-.04-.02-.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.79,861.9s.05.05.09.07l-.09-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.53,863.37c.09-.07.17,0,.26.07.12-.37-.19-.49.03-.87l-.12.18c-.18-.25-.22-.7.02-.92l.08.07c-.2-.24.17-.6,0-.71-.11.1-.17,0-.28.15l-.21-.6.34-.04-.11-.31c-.14.08.11-.42-.21-.43.12-.18.26.07.39.14-.1-.18.05-.2-.15-.36l.3-.17-.21-.46s.05,0,.08.02c-.25-.21.15-.54-.29-.8.02.01.03,0,.05.01-.23-.15-.06-.51-.01-.64-.06-.24-.29-.1-.41-.11.08-.69.06-.47-.3-1.05.37-.35.6.41.86-.03-.18-.06-.32-.36-.4-.71.13-.32.23-.84.48-1.15l-.24.03-.14-.44.35.25c-.08-.07-.24-.29-.36-.44-.21-.46.53-.26.16-.62.03-.01.05-.03.08-.03-.19-.12-.12-.42-.19-.77l.31.12-.07.23c.3-.12-.05-.37-.03-.59-.11-.23-.36-.12-.45-.24.01-.08-.08-.21.01-.27.1-.2.37-.02.5.04-.32-.17-.28-.23-.41-.62.15-.02.22,0,.25.06-.04-.08-.11-.15-.24-.2l.18-.13c.26-.44-.58-.44-.48-.97.17.14-.04-.46.16-.62.05.18.46-.09.65.02.11-.42-.37-.17-.44-.51l.39.14c-.17-.33-.21-.08-.33-.42.11.09.1-.15.23.05.04-.44,0-.33.05-.71l-.38-.03c-.04-.13.12-.18.19-.22,0,.05,0,.14.04.13.32-.15-.18-.25.11-.42-.12.04-.28.09-.31-.07.23.05.21-.25.31-.26-.16.1-.07-.34-.32-.36.17-.19.18.06.31.07-.29-.15-.04-.65-.21-.79.02,0,.04-.01.05-.01-.18-.2-.22-.52-.48-.91l.22.13c.09-.39-.45-.24-.45-.56.31.07-.03-.54.32-.39-.18-.19-.25-.4-.52-.53.17-.19.42.35.51.1l-.16-.28.17-.05c-.12-.01-.13-.25-.23-.24.2-.04.34-.15.49-.14-.06-.17.13-.42-.05-.57h.1c-.37-.18-.07-.55-.46-.63l.21-.11c-.04-.27-.42-.22-.52-.34-.01-.11-.06-.24-.02-.35.25.35.3-.18.43-.25,0-.14-.03-.54-.21-.65.2.16.35.06.37.36.37-.16-.09-.45-.04-.78h.17c-.12-.47-.41-.48-.72-.69.21-.06.27,0,.49.13.13-.32-.02-.81,0-1.17.15-.11.24-.04.31.08-.17-.37.04-.82-.35-1.05.15.09.1-.15.17-.28-.08,0-.18-.03-.17-.04-.15-.22-.3-.72-.16-.98l.11.09c.06-.61-.59-.87-.31-1.53.08-.12.31.12.3-.12-.14-.12-.43-.08-.35-.39l.25.02-.25-.21c-.21.11-.13.45-.37.21.23-.28-.23-.24.04-.58.03.08.22.18.32.23.29-.7-.24-.98.07-1.7-.2-.35-.24-.81-.42-1.06.25.02.47.02.67.18.03-.3-.53-.45-.17-.66-.34-.15-.22-.84-.7-.91.1-.01,0-.33.27,0-.16-.41.42-.54.41-.73-.01-.11-.3.12-.31-.12.02-.03.07-.04.09-.07l-.11-.09c.11-.1.24.11.36.11.1-.34-.28-.56-.31-.96l.08.07.02-.41.03.02-.17-.33h.12c-.03-.07-.11-.08-.13-.19l.15.03c-.24-.1-.37-.49-.37-.68l.07-.04-.31-.45c.16-.24.36.3.25-.17l.31.12c-.12-.34.05-.39-.06-.62-.16.1-.14.26-.28.15.36-.26-.09-.42-.24-.68,0,.13,0,.22.19.3,0,.14-.17.05-.18.13l.18.19-.21.05.17.33c-.25-.02-.03.3-.3.17.11.23-.07.36.18.57-.15.16-.18-.25-.21-.08.2.92.16,1.88.08,2.84l-.11-.09c.11.09.2.22.29.29-.2.16-.46.79-.08,1.02-.02.03-.08-.02-.1-.04.05.32-.22.9-.18,1.35.4.19-.25.69.29.86l-.11-.09c.15-.16.38.22.51.29-.35.13-.27,0-.59.16l.12-.18-.29.04c.75.58-.34,1.08.2,1.44-.03-.02-.08-.02-.1-.04-.16.24.2.41.3.58-.15.02-.24-.1-.35-.2-.11.42.28,1.13.05,1.59.2.16.26-.06.41.11-.05.14-.21.25-.31.07-.36.4.24,1.33-.1,1.94.22.32.31.12.46.62-.14-.12-.48.12-.49-.18l-.15-.03c-.03.49-.09,1.15.35,1.42-.32.02-.06.09-.23.28.04.08.05,0,.07-.04.27.18-.01.27.03.4l-.06-.05.2.35c-.04.06-.1.15-.2.16h.22c0,.19-.28.09-.23.33l.17-.05c-.1.15.13.39-.11.42-.05,0-.03-.02-.04-.08-.34.24.11.61-.05.9l.36-.07c.11.28-.07.17-.2.16,0,.19-.11.23-.15.48.09.12.13.06.24.1l-.09.26-.2-.16c.52.39-.06.98.42,1.25-.1.15-.22-.13-.28-.04-.23.47.34,1.04.08,1.43-.26.63,0,1.36-.18,2.06h.1s-.08.49-.08.49c.22.13.12.47.37.68-.08-.02-.19.03-.25-.02.03.21.14.44,0,.57l-.08-.07c-.06.47-.07,1.12.12,1.37.02.16-.15.16-.27.2-.01.27.09.45.24.67-.04.06-.08.12-.17.19l.24.1c-.03.11-.19.03-.26.12.28.42.03.92.05,1.22l.12-.04c.09.12-.07.36-.19.22-.14.59.37.87.31,1.67-.43.11.13.72-.35.83.12.34-.07.55.21.79-.05,0-.07.04-.08-.02-.18.13-.04.58.08.91l-.14.02c.31.12.22.7.54.82-.07.04-.13-.06-.19-.11-.3.18.14.31.08.53-.08-.02-.17.05-.22,0-.34.75.23,1.84,0,2.82-.01.27.33-.1.31.26-.16.1-.32-.17-.39.05.2.16.16.22.14.44-.1-.04-.17,0-.24-.16-.13.13.25.54-.01.79.1-.01.15.03.21.08.27.37-.28.85-.12.89,0,0,.04.13.08.02,0,.14-.05.33-.21.3.08.07.22.13.23.24l-.18-.06c.04.06.15.13.18.19l.11-.1c-.15.16.21.46-.13.45v-.05s-.16.29-.16.29c.14.12.28.23.23.43-.36.08-.08.5-.12.75h-.13c.17.18.1.68.16.59,0,.19-.09.45-.2.35.07.15.07.48.28.56l-.3.31c.45.19-.16.62.31.64-.07.17-.18.13-.26.25.23.24.19.49.15.74h-.05c-.04.26.2.55.22.9l-.36.07c.05.18.33.23.25.4-.06.04-.07,0-.09-.04.07.17-.02.4-.11.53.26.26.16.47.44.7-.32.21-.14-.31-.44-.13-.17.38,0,.76.16,1.17-.07.04-.12-.01-.2-.03,0,0,.86.84,1.21.68.24.1.38.22.57-.13-.14-.12-.31-.45-.05-.51l-.25-.02c-.12-.47.51-.04.51-.61l-.08.12c-.01-.11-.17-.19-.09-.31.07-.04.1.04.16.09l-.34-.47c.15-.02.22,0,.33.09-.01-.43-.46.09-.36-.44.11-.1.15.03.24.1.21-.24.02-.41-.12-.66.22,0,.2.16.34-.04-.12.04-.31.07-.33-.09.22.08.12-.12.18-.28-.08.03-.18.02-.22-.04-.04-.08.05-.14.04-.25l-.22.19c-.21-.27.11-.42.21-.63.04.02.07.05.08.09.09-.22.27-.44.08-.71l.03.02c-.22-.51-.37.16-.58-.44.05-.2.73.09.47-.36-.19.21-.46-.29-.55-.55l.43.27c0-.1-.12-.29-.07-.34h-.1c-.37.03.05-.32-.17-.51.5.23.41.25.9.29-.27-.18-.52-.39-.47-.72l.38.27c.09-.44-.48-.97-.8-1.33.29.1.39-.05.63.11l-.06-.43.31.12c-.32-.17-.1-.37-.52-.34.06.05.1.04.09.12-.13-.01-.38-.08-.36-.31.1-.15.16.09.28.05-.17-.14.1-.15-.02-.3l-.18.13c-.24-.1,0-.24-.13-.39.1.17.24.12.39.05h-.03c-.01-.1-.18-.24-.04-.31l.33.09-.24-.16c.04-.06.16-.1.22,0,.2-.49-.71.01-.41-.62.13.01.21.08.14.25.2.03.32-.01.39-.19.02,0,.03,0,.04,0,0-.33.02-.76-.2-.98Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.73,864.36c0,.18,0,.33.04.4.06-.03.17-.41-.04-.4Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.37,838.19s.02.04.03.07c-.01-.02-.02-.04-.03-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.27,836.78s-.06.04-.07.07c.07,0,.12-.02.07-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.49,851.35s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.58,843.34c-.11-.12-.2-.17-.28-.18.03.08.1.14.28.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.45,846.04s.03.04.05.05c-.02-.04-.03-.05-.05-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.65,851.77c-.11-.12-.1-.29-.16-.42.06.12-.05.34.16.42Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.91 835.07 1874.08 835.21 1873.96 835.06 1873.91 835.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1874.02,836.38c-.04.06.06.29.15.22-.08-.07-.12-.15-.15-.22Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1873.86 841.42 1874.05 841.48 1873.91 841.36 1873.86 841.42"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1558.61 955.51 1558.8 955.67 1559.83 955.46 1558.61 955.51"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1569.14,955.69c.94-.18,2.74-.3,2.77-.65l-1.71.31c-.24-.26-1.36-.25-2.35-.16l1.12-.02c-.29.04-.11.2-.4.24-1.72-.13-2.16.23-3.75-.06l.09-.03-1.25.17c-.4-.04-.24-.16-.11-.21-1.12.14-1.97.28-3.48.27,1.17.48,3.33-.37,4.5.11l-.09.03c1.46-.18,3.17.13,4.65,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1563.56,955.29h.1s-.05-.02-.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.26,955.97l.06-.08c-.09.03-.17.05-.06.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1605.71,955.02h.09c.12-.1.06-.07-.09,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1725.06,955.86l.36.11c-.09-.1-.22-.12-.36-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1749.96,955.95h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1738.62,954.47l-.05-.1c-.05.05-.02.08.05.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1746.66,954.28c.22.02.44.04.67.05-.15-.05-.44-.07-.67-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1749.71,955.99c.07-.02.16-.03.24-.04-.09.01-.19.02-.24.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1726.52,954.29l-.31-.25c0,.08.16.17.31.25Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1748.64,954.07c.11.05.26.07.42.09-.08-.05-.22-.09-.42-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1570.77,955.67c-.23,0-.49,0-.8.04.3.02.56,0,.8-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1681.17,954.06c.06-.03.11-.06.14-.1-.18.02-.19.06-.14.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1707.74,954.1h.09s-.06-.03-.11-.05l.02.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.98,954.14s.07-.03.1-.05c-.08.02-.1.04-.1.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1713.6,953.84c.1-.02.19-.05.27-.09l-.27.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1719.2,954.1c-.25-.09.02-.17.28-.26-1.4-.12-1.86.19-3.32-.03l.68.12c-.94.18-2.68.22-3.52-.02l.26-.08c-.9.2-2.3-.17-2.68,0,.37.11-.02.17.55.28l-2.28.21-.17-.34-1.2.11c.29.14-1.6-.11-1.63.21-.68-.12.28-.26.52-.39-.67.1-.75-.05-1.37.15l-.67-.3-1.75.21c.09-.03-.02-.05.06-.08-.8.25-2.04-.15-3.06.29.05-.02.04-.03.05-.05-.56.23-1.94.06-2.45.01-.91.06-.38.29-.41.41-2.62-.08-1.79-.06-3.99.3-1.32-.37,1.56-.6-.12-.86-.22.18-1.39.32-2.7.4-1.2-.13-3.21-.23-4.37-.48l.12.24-1.69.14.96-.35c-.27.08-1.12.24-1.68.36-1.75.21-.99-.53-2.35-.16-.05-.03-.1-.05-.13-.08-.44.19-1.59.12-2.91.19l.46-.31.86.07c-.46-.3-1.42.05-2.26.03-.87.11-.44.36-.91.45-.32-.01-.79.08-1.04-.01-.77-.1-.08-.37.16-.5-.66.32-.89.28-2.38.41-.08-.15.03-.22.23-.25-.31.04-.58.11-.74.24l-.5-.18c-1.69-.26-1.67.58-3.69.48.54-.17-1.74.04-2.35-.16.7-.05-.33-.46.09-.65-1.61-.11-.64.37-1.95.44l.53-.39c-1.26.17-.31.21-1.59.33.35-.11-.57-.1.19-.23-1.67-.03-1.23-.02-2.71-.05l-.12.37c-.49.04-.68-.12-.82-.19.2,0,.52,0,.49-.04-.58-.32-.94.18-1.61-.11.16.12.35.28-.26.31.2-.23-.93-.21-.98-.31.39.16-1.31.07-1.39.32-.71-.17.22-.18.26-.31-.58.29-2.46.04-3,.21-.01-.02-.04-.04-.04-.05-.74.18-1.98.22-3.46.48l.51-.22c-1.5-.09-.91.45-2.15.45.26-.31-2.05.03-1.5-.32-.74.18-1.53.25-2.01.52-.71-.17,1.34-.42.36-.51l-1.05.16-.19-.17c-.04.12-.97.13-.92.23-.16-.2-.59-.34-.54-.49-.67.06-1.6-.13-2.16.05l-.05-.1c-.64.37-2.03.07-2.35.46l-.41-.21c-1.02.04-.82.42-1.29.52-.41.01-.9.06-1.33.02,1.32-.25-.67-.3-.94-.43-.52,0-2.05.03-2.47.21.63-.2.24-.35,1.36-.37-.6-.37-1.71.09-2.98.04v-.17c-1.79.12-1.84.42-2.62.72-.21-.21-.04-.27.48-.49-1.2-.13-3.09.02-4.45,0-.43-.15-.15-.24.3-.31-1.4.17-3.13-.04-4,.35.34-.15-.56-.1-1.08-.17,0,.08-.1.18-.16.17-.85.15-2.74.3-3.74.16l.36-.11c-2.31-.06-3.32.59-5.84.31-.45-.08.47-.31-.46-.3-.45.14-.3.43-1.48.35l.08-.25-.8.25c.41.21,1.72.13.8.37-1.05-.23-.92.23-2.19-.04.3-.03.68-.22.89-.32-2.68-.29-3.75.24-6.46-.07-1.35.2-3.09.24-4.02.42.08-.25.07-.47.69-.67-1.15-.03-1.69.53-2.5.17-.55.34-3.2.22-3.47.7-.05-.1-1.24,0-.03-.27-1.57.16-2.07-.42-2.79-.41-.4.01.46.3-.46.31-.11-.02-.14-.07-.25-.09l-.35.11c-.37-.11.4-.24.44-.36-1.29-.1-2.13.28-3.66.31l.26-.08-1.56-.02.09-.03-1.26.17.04-.12c-.29.04-.36.11-.76.13l.13-.15c-.4.24-1.88.37-2.61.37l-.14-.07-1.7.31c-.91-.16,1.16-.36-.64-.25l.46-.31c-1.28.12-1.47-.04-2.35.06.4.16,1,.14.55.28-1.01-.36-1.61.09-2.57.24.49,0,.82,0,1.16-.19.52,0,.19.17.5.18l.74-.18.21.21,1.26-.17c-.08.25,1.16.03.67.3.88-.11,1.38.07,2.18-.18.59.15-.94.18-.31.21,3.52-.2,7.15-.16,10.81-.08l-.36.11c.36-.11.83-.2,1.09-.29.62.2,3.02.46,3.87.08.12.02-.07.08-.15.1,1.22-.04,3.42.22,5.15.18.73-.4,2.61.25,3.27-.29l-.36.11c-.59-.15.84-.38,1.09-.51.49.35.03.27.61.6l-.69-.12.15.29c2.2-.75,4.1.34,5.48-.2-.08.03-.06.08-.15.1.91.16,1.55-.2,2.22-.3.08.15-.4.24-.75.35,1.6.11,4.3-.28,6.07-.05.62-.2-.24-.26.41-.41.55.05.93.21.26.31,1.53.36,5.05-.24,7.39.1,1.23-.22.46-.31,2.35-.46-.44.14.45.48-.68.49l-.13.15c1.88.03,4.38.09,5.41-.35.06.32.34.06,1.05.23.29-.04-.03-.05-.14-.07.69-.27,1.04.01,1.53-.03l-.18.06,1.35-.2c.22.04.56.1.61.2v-.22c.72,0,.34.28,1.25.23l-.19-.17c.57.1,1.49-.13,1.61.11.02.05-.09.03-.29.04.9.34,2.32-.11,3.43.05l-.28-.36c1.08-.11.66.07.62.2.72,0,.88.11,1.83.15.47-.09.25-.13.4-.24l.97.09-.62.2c1.49-.52,3.75.06,4.75-.42.57.1-.51.22-.17.28,1.77.23,3.96-.34,5.44-.08,2.4.26,5.17,0,7.84.18l-.05-.1,1.9.08c.51-.22,1.8-.12,2.61-.37-.07.08.1.19-.08.25.81-.03,1.69-.14,2.17,0l-.27.08c1.79.06,4.27.06,5.21-.12.61-.02.6.15.76.27,1.03.01,1.71-.09,2.56-.24.22.04.46.08.71.17l.39-.24c.43.03.1.19.44.26,1.61-.28,3.5-.03,4.63-.05l-.16-.12c.47-.09,1.38.07.82.19,2.24.14,3.32-.37,6.35-.31.42.43,2.73-.13,3.18.35,1.28-.12,2.1.07,2.99-.21.03.05.14.07-.07.08.51.18,2.19.04,3.47-.08l.07.14c.46-.31,2.68-.22,3.14-.54.14.07-.24.13-.42.19.67.3,1.17-.14,2.03-.08-.07.08.19.17,0,.22,2.86.34,7.02-.23,10.75,0,1.04.01-.38-.33.98-.31.39.16-.66.32.2.39.62-.2.85-.16,1.69-.14-.15.1-.02.17-.6.25.48.13,2.05-.25,3,.01-.05-.1.13-.15.31-.21,1.41-.27,3.24.27,3.37.12,0,0,.49-.04.06-.08.52,0,1.27.05,1.14.21.27-.08.51-.22.92-.23l-.22.18c.24-.04.51-.15.74-.18l-.37-.11c.59.15,1.76-.21,1.72.13h-.2s1.11.16,1.11.16c.44-.14.89-.28,1.64-.23.29.36,1.9.08,2.85.12l-.04.13c.74-.17,2.64-.1,2.3-.16.72,0,1.7.09,1.34.2.59-.07,1.83-.07,2.14-.28l1.18.3c.71-.45,2.36.16,2.43-.31.66.07.51.18.96.26.92-.23,1.86-.19,2.81-.15l.03.05c.95.04,2.07-.2,3.4-.22l.28.36c.7-.05.87-.33,1.53-.25.15.06,0,.07-.17.09.65-.07,1.53.02,2.02.11,1.01-.26,1.78-.16,2.67-.44.78.32-1.17.14-.5.44,1.43.17,2.89,0,4.46-.16.14.07-.04.12-.11.2,0,0,3.19-.87,2.6-1.21.39-.24.84-.38-.5-.57-.45.14-1.71.31-1.94.05l-.08.25c-1.8.12-.16-.51-2.32-.51l.46.08c-.41.02-.74.17-1.19.09-.14-.07.16-.1.33-.16l-1.79.34c-.08-.15,0-.22.35-.33-1.65.01.33.46-1.68.36-.36-.11.13-.15.39-.24-.93-.21-1.56-.02-2.52.12-.01-.22.62-.2-.17-.34.16.12.26.31-.35.33.29-.23-.46-.12-1.06-.18.12.08.07.18-.16.22-.29.04-.54-.05-.95-.04l.73.22c-1.02.21-1.6-.11-2.38-.21.06-.04.2-.07.35-.08-.82-.09-1.67-.27-2.7-.08l.09-.03c-1.95.22.6.37-1.67.58-.75-.05.36-.73-1.37-.47.82.19-1.11.46-2.1.55l1.02-.43c-.4,0-1.09.12-1.3.07l.05.1c.07.37-1.27-.05-1.99.17.89-.5.94-.4,1.1-.9-.69.27-1.49.52-2.76.47l1.04-.38c-1.69-.09-3.68.48-5.07.8.37-.29-.2-.39.41-.63l-1.62.06.46-.31c-.66.32-1.39.1-1.29.52.18-.06.15-.1.47-.09-.04.13-.32.38-1.16.36-.57-.1.33-.16.18-.28-.54.17-.57-.1-1.13.02l.5.18c-.39.24-.93,0-1.48.13.67-.1.45-.24.2-.39l.04.03c-.4.01-.94.18-1.22.04l.34-.33-.6.24c-.23-.04-.39-.16,0-.22-1.86-.2.05.71-2.38.41.04-.13.31-.21.97-.14.11-.2-.06-.32-.71-.39-.01-.02,0-.03,0-.04-1.26,0-2.91-.02-3.74.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1722.95,953.9c.68,0,1.25,0,1.51-.04-.13-.06-1.54-.17-1.51.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1623.33,954.25l.25-.03c-.09.01-.17.02-.25.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1617.96,954.35c.06.04.16.06.28.07,0-.07-.07-.12-.28-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1673.41,954.14h-.02s.02,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1642.92,954.05c-.47.11-.64.2-.67.28.3-.03.54-.1.67-.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1653.2,954.18l.19-.05c-.15.02-.19.03-.19.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1675.02,953.98c-.45.11-1.09.1-1.61.16.44-.06,1.3.05,1.61-.16Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1611.43 954.72 1611.96 954.55 1611.4 954.67 1611.43 954.72"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1616.44,954.61c.22.04,1.1-.06.85-.15-.27.08-.56.12-.85.15Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1635.63 954.76 1635.85 954.58 1635.4 954.72 1635.63 954.76"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1467.48 955.51 1467.67 955.67 1468.7 955.46 1467.48 955.51"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1478.01,955.69c.94-.18,2.74-.3,2.77-.65l-1.71.31c-.24-.26-1.36-.25-2.35-.16l1.12-.02c-.29.04-.11.2-.4.24-1.72-.13-2.16.23-3.75-.06l.09-.03-1.25.17c-.4-.04-.24-.16-.11-.21-1.12.14-1.97.28-3.48.27,1.17.48,3.33-.37,4.5.11l-.09.03c1.46-.18,3.17.13,4.65,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1472.43,955.29h.1s-.05-.02-.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1533.13,955.97l.06-.08c-.09.03-.17.05-.06.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1514.58,955.02h.09c.12-.1.06-.07-.09,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1633.93,955.86l.36.11c-.09-.1-.22-.12-.36-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1658.83,955.95h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1647.49,954.47l-.05-.1c-.05.05-.02.08.05.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1655.53,954.28c.22.02.44.04.67.05-.15-.05-.44-.07-.67-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1658.59,955.99c.07-.02.16-.03.24-.04-.09.01-.19.02-.24.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1635.39,954.29l-.31-.25c0,.08.16.17.31.25Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1657.52,954.07c.11.05.26.07.42.09-.08-.05-.22-.09-.42-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1479.65,955.67c-.23,0-.49,0-.8.04.3.02.56,0,.8-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1590.05,954.06c.06-.03.11-.06.14-.1-.18.02-.19.06-.14.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1616.61,954.1h.09s-.06-.03-.11-.05l.02.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1608.86,954.14s.07-.03.1-.05c-.07.02-.09.04-.1.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1622.47,953.84c.09-.02.19-.05.27-.09l-.27.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1628.08,954.1c-.25-.09.02-.17.28-.26-1.4-.12-1.86.19-3.32-.03l.68.12c-.94.18-2.68.22-3.52-.02l.26-.08c-.9.2-2.3-.17-2.68,0,.37.11-.02.17.55.28l-2.28.21-.17-.34-1.2.11c.29.14-1.6-.11-1.63.21-.68-.12.28-.26.52-.39-.67.1-.75-.05-1.37.15l-.67-.3-1.75.21c.09-.03-.02-.05.06-.08-.8.25-2.04-.15-3.06.29.05-.02.04-.03.05-.05-.56.23-1.94.06-2.45.01-.91.06-.38.29-.41.41-2.62-.08-1.79-.06-3.99.3-1.32-.37,1.56-.6-.12-.86-.22.18-1.39.32-2.7.4-1.2-.13-3.21-.23-4.37-.48l.12.24-1.69.14.96-.35c-.27.08-1.12.24-1.68.36-1.75.21-.99-.53-2.35-.16-.05-.03-.1-.05-.13-.08-.44.19-1.59.12-2.91.19l.46-.31.86.07c-.46-.3-1.42.05-2.26.03-.87.11-.44.36-.91.45-.32-.01-.79.08-1.04-.01-.77-.1-.08-.37.16-.5-.66.32-.89.28-2.38.41-.08-.15.03-.22.23-.25-.31.04-.58.11-.74.24l-.5-.18c-1.69-.26-1.67.58-3.69.48.54-.17-1.74.04-2.35-.16.7-.05-.33-.46.09-.65-1.61-.11-.64.37-1.95.44l.53-.39c-1.26.17-.31.21-1.59.33.35-.11-.57-.1.19-.23-1.67-.03-1.23-.02-2.71-.05l-.12.37c-.49.04-.68-.12-.82-.19.2,0,.52,0,.49-.04-.58-.32-.94.18-1.61-.11.16.12.35.28-.26.31.2-.23-.93-.21-.98-.31.39.16-1.31.07-1.39.32-.71-.17.22-.18.26-.31-.58.29-2.46.04-3,.21-.01-.02-.04-.04-.04-.05-.74.18-1.98.22-3.46.48l.51-.22c-1.5-.09-.91.45-2.15.45.26-.31-2.05.03-1.5-.32-.74.18-1.53.25-2.01.52-.71-.17,1.34-.42.36-.51l-1.05.16-.19-.17c-.04.12-.97.13-.92.23-.16-.2-.59-.34-.54-.49-.67.06-1.6-.13-2.16.05l-.05-.1c-.64.37-2.03.07-2.35.46l-.41-.21c-1.02.04-.82.42-1.29.52-.41.01-.9.06-1.33.02,1.32-.25-.67-.3-.94-.43-.52,0-2.05.03-2.47.21.63-.2.24-.35,1.36-.37-.6-.37-1.71.09-2.98.04v-.17c-1.79.12-1.84.42-2.62.72-.21-.21-.04-.27.48-.49-1.2-.13-3.09.02-4.45,0-.43-.15-.15-.24.3-.31-1.4.17-3.13-.04-4,.35.34-.15-.56-.1-1.08-.17,0,.08-.1.18-.16.17-.85.15-2.74.3-3.74.16l.36-.11c-2.31-.06-3.32.59-5.84.31-.45-.08.47-.31-.46-.3-.45.14-.3.43-1.48.35l.08-.25-.8.25c.41.21,1.72.13.8.37-1.05-.23-.92.23-2.19-.04.3-.03.68-.22.89-.32-2.68-.29-3.75.24-6.46-.07-1.35.2-3.09.24-4.02.42.08-.25.07-.47.69-.67-1.15-.03-1.69.53-2.5.17-.55.34-3.2.22-3.47.7-.05-.1-1.24,0-.03-.27-1.57.16-2.07-.42-2.79-.41-.4.01.46.3-.46.31-.11-.02-.14-.07-.25-.09l-.35.11c-.37-.11.4-.24.44-.36-1.29-.1-2.13.28-3.66.31l.26-.08-1.56-.02.09-.03-1.26.17.04-.12c-.29.04-.36.11-.76.13l.13-.15c-.4.24-1.88.37-2.61.37l-.14-.07-1.7.31c-.91-.16,1.16-.36-.64-.25l.46-.31c-1.28.12-1.47-.04-2.35.06.4.16,1,.14.55.28-1.01-.36-1.61.09-2.57.24.49,0,.82,0,1.16-.19.52,0,.19.17.5.18l.74-.18.21.21,1.26-.17c-.08.25,1.16.03.67.3.88-.11,1.38.07,2.18-.18.59.15-.94.18-.31.21,3.52-.2,7.15-.16,10.81-.08l-.36.11c.36-.11.83-.2,1.09-.29.62.2,3.02.46,3.87.08.12.02-.07.08-.15.1,1.22-.04,3.42.22,5.15.18.73-.4,2.61.25,3.27-.29l-.36.11c-.59-.15.84-.38,1.09-.51.49.35.03.27.61.6l-.69-.12.15.29c2.2-.75,4.1.34,5.48-.2-.08.03-.06.08-.15.1.91.16,1.55-.2,2.22-.3.08.15-.4.24-.75.35,1.6.11,4.3-.28,6.07-.05.62-.2-.24-.26.41-.41.55.05.93.21.26.31,1.53.36,5.05-.24,7.39.1,1.23-.22.46-.31,2.35-.46-.44.14.45.48-.68.49l-.13.15c1.88.03,4.38.09,5.41-.35.06.32.34.06,1.05.23.29-.04-.03-.05-.14-.07.69-.27,1.04.01,1.53-.03l-.18.06,1.35-.2c.22.04.56.1.61.2v-.22c.72,0,.34.28,1.25.23l-.19-.17c.57.1,1.49-.13,1.61.11.02.05-.09.03-.29.04.9.34,2.32-.11,3.43.05l-.28-.36c1.08-.11.66.07.62.2.72,0,.88.11,1.83.15.47-.09.25-.13.4-.24l.97.09-.62.2c1.49-.52,3.75.06,4.75-.42.57.1-.51.22-.17.28,1.77.23,3.96-.34,5.44-.08,2.4.26,5.17,0,7.84.18l-.05-.1,1.9.08c.51-.22,1.8-.12,2.61-.37-.07.08.1.19-.08.25.81-.03,1.69-.14,2.17,0l-.27.08c1.79.06,4.27.06,5.21-.12.61-.02.6.15.76.27,1.03.01,1.71-.09,2.56-.24.22.04.46.08.71.17l.39-.24c.43.03.1.19.44.26,1.61-.28,3.5-.03,4.63-.05l-.16-.12c.47-.09,1.38.07.82.19,2.24.14,3.32-.37,6.35-.31.42.43,2.73-.13,3.18.35,1.28-.12,2.1.07,2.99-.21.03.05.14.07-.07.08.51.18,2.19.04,3.47-.08l.07.14c.46-.31,2.68-.22,3.14-.54.14.07-.24.13-.42.19.67.3,1.17-.14,2.03-.08-.07.08.19.17,0,.22,2.86.34,7.02-.23,10.75,0,1.04.01-.38-.33.98-.31.39.16-.66.32.2.39.62-.2.85-.16,1.69-.14-.15.1-.02.17-.6.25.48.13,2.05-.25,3.01.01-.05-.1.13-.15.31-.21,1.41-.27,3.24.27,3.37.12,0,0,.49-.04.07-.08.52,0,1.26.05,1.14.21.27-.08.51-.22.92-.23l-.22.18c.24-.04.51-.15.74-.18l-.37-.11c.59.15,1.76-.21,1.72.13h-.2s1.11.16,1.11.16c.44-.14.89-.28,1.64-.23.29.36,1.9.08,2.85.12l-.04.13c.74-.17,2.64-.1,2.3-.16.72,0,1.7.09,1.34.2.59-.07,1.83-.07,2.14-.28l1.18.3c.71-.45,2.36.16,2.43-.31.66.07.51.18.96.26.92-.23,1.86-.19,2.81-.15l.02.05c.95.04,2.07-.2,3.4-.22l.28.36c.7-.05.87-.33,1.53-.25.15.06,0,.07-.17.09.65-.07,1.53.02,2.02.11,1.01-.26,1.78-.16,2.66-.44.78.32-1.17.14-.5.44,1.43.17,2.89,0,4.46-.16.14.07-.04.12-.11.2,0,0,3.19-.87,2.6-1.21.39-.24.84-.38-.5-.57-.45.14-1.71.31-1.94.05l-.08.25c-1.8.12-.16-.51-2.32-.51l.46.08c-.41.02-.74.17-1.19.09-.14-.07.16-.1.33-.16l-1.79.34c-.08-.15,0-.22.35-.33-1.65.01.33.46-1.68.36-.36-.11.13-.15.39-.24-.93-.21-1.56-.02-2.52.12-.01-.22.62-.2-.17-.34.16.12.26.31-.35.33.29-.23-.46-.12-1.06-.18.12.08.08.18-.16.22-.29.04-.54-.05-.95-.04l.73.22c-1.02.21-1.6-.11-2.38-.21.06-.04.2-.07.35-.08-.82-.09-1.67-.27-2.7-.08l.09-.03c-1.95.22.6.37-1.67.58-.75-.05.36-.73-1.37-.47.82.19-1.11.46-2.1.55l1.02-.43c-.4,0-1.09.12-1.3.07l.05.1c.07.37-1.27-.05-1.99.17.89-.5.94-.4,1.1-.9-.69.27-1.49.52-2.76.47l1.04-.38c-1.69-.09-3.68.48-5.07.8.37-.29-.2-.39.41-.63l-1.62.06.46-.31c-.66.32-1.39.1-1.29.52.18-.06.15-.1.47-.09-.04.13-.32.38-1.16.36-.57-.1.33-.16.18-.28-.54.17-.57-.1-1.13.02l.5.18c-.39.24-.93,0-1.48.13.67-.1.45-.24.2-.39l.04.03c-.4.01-.94.18-1.22.04l.34-.33-.6.24c-.23-.04-.39-.16,0-.22-1.86-.2.05.71-2.38.41.04-.13.31-.21.97-.14.11-.2-.06-.32-.71-.39-.01-.02,0-.03,0-.04-1.26,0-2.91-.02-3.74.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1631.82,953.9c.68,0,1.25,0,1.51-.04-.13-.06-1.54-.17-1.51.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1532.2,954.25l.25-.03c-.09.01-.17.02-.25.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1526.84,954.35c.06.04.16.06.28.07,0-.07-.07-.12-.28-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1582.29,954.14h-.02s.02,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1551.79,954.05c-.47.11-.64.2-.67.28.3-.03.54-.1.67-.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1562.08,954.18l.19-.05c-.15.02-.19.03-.19.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1583.89,953.98c-.45.11-1.09.1-1.61.16.44-.06,1.3.05,1.61-.16Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1520.3 954.72 1520.84 954.55 1520.27 954.67 1520.3 954.72"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1525.31,954.61c.22.04,1.1-.06.85-.15-.27.08-.56.12-.85.15Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1544.51 954.76 1544.72 954.58 1544.28 954.72 1544.51 954.76"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1458.52,954.88c.3-.09-.1-.03-.47-.02l.47.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1458.05,954.86h-.33c.09,0,.21,0,.33,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1454.97,954.8c.71-.07,1.55.03,2-.08-.72-.07-1.82-.04-2,.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1456.03 954.87 1456.12 954.81 1455.5 954.9 1456.03 954.87"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1456.48 954.93 1456.39 954.9 1455.42 954.97 1456.48 954.93"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.57,954.75l.71-.02c.67.08-.44.11,0,.17.89,0,.31-.17,1.41-.15-.09-.08-1.78,0-1.6-.12-.93-.04-.05.07-.53.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1409.78,955.42s-.07,0-.1-.01c.04.01.08.02.1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1398.07,955.51c-.16,0-.32-.02-.48-.03.05.01.11.02.19.03h.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1417.12,955.19c.17.01.32.02.46.03-.09-.02-.23-.03-.46-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1342.48,954.74s.05-.02.06-.04c0,0-.01,0-.02,0l-.13.03h.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1384.94,955.7c-.18,0-.36,0-.53.01.31,0,.46,0,.53-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1421.35,955.18c-.06,0-.12,0-.18,0,.06,0,.13,0,.22.01h-.03s0-.01,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.89,955.68c-.16,0-.3-.01-.42-.02.15.01.29.01.42.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1441.7,954.62c-.2-.01-.37,0-.52.01.13.02.29.02.52-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1437.51,954.63h.02s-.04-.01-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1434.83,954.62h.05s-.05-.02-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1441.19,954.63c-.35-.05-.45-.21-.9-.03l.09.02c-.27-.04-.67.03-.98.03.03.02.07.03.11.04.16,0,.36,0,.68.02.38.04.62-.05.99-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1409.83,955.39s.32.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1413.44,955.26c-.12,0-.23,0-.36,0,.11,0,.23.01.36,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1427.06,955.31s-.04,0-.06,0c-.02.02.03.02.06,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.76,955.25h.33c-.1,0-.21,0-.33,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1422.97,955.21s-.04,0-.06,0c.01,0,.03,0,.06,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1286.51,954.19c.27-.01.44.03.69.04.58-.11-1.2,0-.36-.1-.26,0-.46.02-.65.03l.37.11c.51-.04-.34-.04-.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1339.08,954.52h.12c-.08-.04,0-.05-.46-.08-.38.07.21.19-.46.27.13,0,.32,0,.5,0-.27-.07,0-.14.29-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1338.79,954.71h.02s.06.02.1.03c.1,0,.19,0,.27.01-.07-.02-.22-.04-.38-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.6,954.24c.11,0,.21,0,.31.01-.15-.02-.24-.02-.31-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1385.79,954.33c.13-.01.26-.02.37-.03-.2,0-.3.02-.37.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.55,954.63c.11,0,.21.01.32.02.07,0,.12,0,.2,0h-.53Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1323.99,955.66c.23-.12-.18,0-.64-.06l-.43.07c.39.02.75,0,1.06,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1286.17,954.16s0,0,0,.01c.01,0,.02,0,.03,0h-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1311.32,955.69c-.07,0-.14-.01-.21-.02.04,0,.11.01.21.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1341.32,954.77h1.63s-.48-.02-.48-.02c-.23.06-.93-.05-1.15.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1330.94,955.73l.15.07c1.62-.16,3.48.07,4.77-.15,1.98.26,1.3-.23,3.11,0l-.06-.04c5.96.04,12.28.18,17.84.05v.05c8.96.09,17.7-.02,26.6.02.83-.05.33-.16,1.04-.22.31,0,1.01,0,1.02.06-.6.04-.26.09-.47.12,1,0,2.29.07,3.18-.01l-.75-.08c.35-.03.89-.01,1.21,0-.13.04.32.13.05.15,1.88-.21,1.47.09,3.05,0,.32-.18,2.3-.32,3.61-.45l.69.05c-.91,0,.02.13-1.11.12.94.05,1.82-.02,2.71,0-.17-.04-.13-.1.23-.12.55.02.6.11,1.22.12l-.62.06c.42.07.78-.02,1.16-.03.13.07,1.06.09.9.17.84-.1,1.14-.04,2.05-.11-.94-.08.24-.1.14-.16l-1.06.03c1.5.05-.49.01-.38.14-.71-.06.97-.21-.21-.19,1.41-.06,1.71,0,3.15-.11-.87.02.17-.08-.3-.12,1.11,0,.27.04.62.12.6,0,.82.07,1.38-.02.98.04-.15.09.35.15-.36.09-2.72-.11-2.45.17-.51,0-1.13.11-1.86.1.64.04,1.56.13,2.35.06l.04-.16c.6,0,.73-.11,1.16-.1-.23.04.19.11.67.1-.14-.02-.33-.02-.28-.04.9-.01,1.02-.12,2.09-.15-.88-.04-1.06-.09-1.88-.15.22-.11.58-.02,1.06-.03-.07.02-.17.02-.03.04l.52-.05c1.1.05-.14.16.77.21.62.09.86-.05,1.34,0-.03,0-.07-.02-.09-.03.11,0,.18,0,.24,0h0c.58-.02,1.21-.01,1.37-.1.06.04.51-.01.7-.04.32-.03,1.1-.13,1.59,0h-.04c.73.02,1.29.06,1.13.1l1.17.03-.13.11c1.07-.03.96-.09,1.69-.2.76.06,2.1.01,2.6-.03.08,0,.21,0,.42,0l-.44-.04c.83,0,.73-.05,1.28-.05-.11,0-.13-.02.18,0,.09,0,.19,0,.32,0-.03.01-.15,0-.27,0l.1.04c.67.11,1.02-.06,1.73-.02-.07,0-.18,0-.25.01.4.03.97.18,1.14.09.09.01.23,0,.37-.03l.29.02c-.12,0-.21-.01-.29-.02.18-.03.36-.07.38-.05l1.02.02c.19.02.46,0,.67-.01l.17.04c.37,0,.38.02.33.03,1.29.15,2-.08,3.39.05.27-.07-.31-.11-.35-.15.22-.06,1.02-.11,1.42-.15.62.1,2.53.19,2.22.34,1.15.01-.36-.09.22-.14h.13c-.4-.01-.71-.06-.93-.12-.09-.08.93-.1,1.24-.08l-.22.11c1.06-.04.84-.21,1.5-.32.84.04.36.15.54.25l.89-.03v.08c.58-.02.71-.1,1.51-.07-.58.08,1.2.08.4.19.44.03.57-.13.8-.02.31-.09-.4-.04-.62-.07-.18-.13.97-.06,1.51-.1.04.07-.35.08.27.12.13-.05.53-.09.88-.03,0-.08.71-.02,1.07-.01-.4-.02-.98-.08-.72-.15.31-.03.58-.05,1.29-.04l-.49-.04c.62-.12,1.02.09,1.86.05-.36.05-.58.05-.89.11.41-.03,1.16-.09,1.77-.14l.71.12c.09-.06.8,0,.8-.08.88.06-.71.1-.8.16,1.11.06.89-.14,1.95-.01l-.35.08c.35,0,1.06-.04,1.11,0,0-.03-.18-.02-.4-.02.22-.17,1.64-.12,1.51-.29h-.49c.75-.05,1.28-.16,1.86-.1.44.06-.31.12-.57.16.71.01.57-.19,1.42-.17-.44-.03-.36-.09-.09-.13-.49-.01-1.51-.04-1.33.03l.18.02s-.31.06-.44.08c-.67,0-.31-.08-.44-.11-1.11-.03-.09.17-1.11.17l-.13-.03c-.49.04-1.24.05-1.38.16-.44-.11-1.15.04-1.64-.02-.09-.25,1.73.02,2.3-.12-.53-.05.31-.12.53-.17l-1.68.11c-.13-.03-.63-.16-.93-.07h.13c-.67.03-.49.13-1.06.1-.09-.02.09-.06.13-.08-.53-.02-.44.06-.8.08-.53-.02.27-.1-.18-.13-.62.1-.98-.02-1.51-.02.23.14-2.12.19-.97.31l-1.28.1c-.4-.07.88-.2.53-.31h1.02c-.17-.17-2.14.12-2.82-.08-.55,0-.41.02-1.44-.07l.18.16c-.54-.04-.71-.12-.73-.15-.31.01-.6,0-.89,0,.08-.02.19-.04.38-.05-.4-.09-.52-.05-.66,0-.22.04-.55.03-.88.03l.3-.06c-.2.01-.46.03-.48.06-.14,0-.27,0-.4.01.09.03.31.12.79.16-1.24-.06-2.22-.03-3.28-.16.04-.04.48-.1.35-.11-.53-.02-1.11.06-1.06.12-.12,0-.21,0-.29,0-.1-.04-.23-.08-.48-.09-.06-.01-.15-.03-.34-.03-.18.12-1.2.06-1.42.12.24.01.53.01.83,0-.43.08-.81.18-1.14.11.79-.08-.85-.13.35-.16-.84-.16-.44.11-1.33.06l-.58-.06c.09-.09.93-.05.8-.08h-.4c.4-.06,1.91-.01,2.84-.11l-1.86-.05c-2.35.11-5.28-.02-7.27.18h.08s-.05.02-.08.06l-.09-.02-.39.07c-.45-.08-1.29-.1-2-.17q.45.06.49.12c-.09.09-.16.13-.82.1,0-.06.4-.06-.09-.11.25.03.03.08-.26.08-.38-.04-1-.05-1.01-.11.17-.02.31,0,.43.01.17-.02-.71-.06-.19-.11l-.68.02c-.4-.05.26-.08.11-.12-1.13.04-1.7.19-2.72.23.05-.03.06-.18.05-.14-.78-.04-1.68.16-2.58.17.13-.04.47-.03.74-.05-2.73-.05-4.97-.06-7.53-.19l-.67.15-.67-.1c-2.7-.09-4.77,0-7.33.04-.8,0-.48-.1-.85-.14-1.75-.02-2.18.15-3.85.18.23-.04.62-.17-.1-.18-.13.04-.22.11-.68.08l.23-.05c-.41-.07-.81,0-1.67-.03-1.52,0-2.97.11-4.21.27-1.34-.01.14-.16-.12-.19.95.05.66-.03.86-.08-.5.04-1.11.07-1.36-.04-.7,0-1.01,0-1.7.07.35-.04.64.02.32.07-.57-.04-2.02,0-1.94-.13-3.31,0-7,0-10.54,0-.6.07.45.03.12.07-.87.09-.69-.05-1.38.02l.29-.07c-1.03-.01-2.13.12-3.13.19.17-.08-.82-.07,0-.12-.49.01-1.08-.35-1.46-.28l.55.34s-.71.01-.64.04c-.43-.07-.95-.15-1.25-.15-.14-.09.6-.07,1.01-.07.06-.14-1.37-.09-.78-.22-.87.02.12.07-.4.13l-.76-.03.59.05c-.64.04-.85.15-1.7.07l-.88.14c-.09-.11-.64-.02-1.09-.05l.28-.07c-.6,0-.83-.02-1.21-.06.34-.1.54.02.69-.07l-.66-.03c0,.06-.42.11.06.15-.61.12-.95.22-2.49.21-.69-.11.75-.1.46-.21-1.6-.05-1.95.28-2.88.27-1.19-.04-1.12.06-2.33.06.38-.07-.84-.08-1.06-.15l.48-.08c-.37.02-.72,0-.61-.06.07.1-1.56.09-2.4.14l.15.09c-.65.03-1.55.08-2.24.06-1.03.03-.79.1-1.58.2-.44-.08-.39-.17-.24-.26.27.04.74.02,1.19.04,1.3-.07,2.3-.26,3.6-.21.56-.21-.87.02-1.5-.05.02-.01.06-.02.11-.02-.06,0-.1,0-.16,0,.46-.03,1.22-.06,1.34-.17-.78.02-.56.21-1.53.12-.71.06-1.3-.11-1.73-.12-.48.08-.5.24-1.67.21l.51-.12c-1.32,0-.62.17-1.85.17.43.01-.42.11.4.12-.4.06-1.3.07-1.96.04-.17.02-.04.04-.07.08.74.08,1.17-.08,1.77.04l.51-.13c.69.05.76.15.34.2.19,0,.36-.02.5,0,.12.19-.82-.07-1.06.09h.48c.21.11-1.13.09-1.76.09-.71-.06-1.35-.08-1.4-.17l.95-.04c-.49-.07-1.21.04-1.76.04-.04-.01-.09-.02-.15-.03.03,0,.04.02.04.02-.12,0-.22-.02-.31-.04-.48,0-1.2.05-1.65.02l.06.08.06-.04c.44,0,1.04.05.71.11-1,.06-1.2-.1-1.44-.17.23-.12.98,0,1.48-.04-.31-.12-1.02-.01-2.05-.09.41-.13,1.2,0,1.43-.12-.83-.02-1.05.07-1.93.04.11-.06.97-.07.91-.15l-.56-.04c1.38,0-.24-.16.83-.2-.51-.05-.71.11-1.43.02.2.06.78.16.09.21l-.78-.04c-.33-.06.81-.14.31-.19l-.82.04s.42.06.17.11c-.47-.04-.78.15-1.33.21-.44,0-.8-.01-.95-.06-1.12.12-2.53.11-3.56.22.7-.08-.03-.14-.45-.19.81-.02.81-.14.76-.22-.49.01-.81.14-.57.18-.82-.05-.57.09-1.29,0-.47-.04.23-.12.07-.17-.89,0-.24.15-1.21.12.05-.02.14-.02.06-.04-.52-.03-1.08.03-1.19.09-.55-.16-1.56.02-1.45-.14-1.26.04.19.09-.06.14-.52.07-1.47.01-1.77-.01.31,0,.6-.05.9-.02l-.27-.11c-1.57-.08-.99.25-2.51.15.78-.06.26-.08.65-.16-.23.03-1.42,0-.7.08-.57,0-.96-.03-1.36-.05-.51.04-1.05.07-1.35.14-.8-.01-1.39-.09-1.77-.14-1.67.08-3.22-.06-4.98.03h.13c-1.37-.01.61.15-.82.15.19-.13-.85-.09-1.31-.16-1.74-.07-3.01.1-4.62,0,.01-.03.12-.06.43-.06-1.23-.04-2.21-.02-3.32-.02l.05-.02c-1.77-.11-3.38.02-5.22.05.15-.02.19-.07.3-.08-.92-.03-2.4-.05-3.05.07-1.1-.13-.73.04-2.14-.09-.08-.02.14-.02.23-.03-.69-.04-1.19-.03-1.89-.05-1.55.08-1.93.26-3.73.21-.09-.18,1.11-.04,1.15-.19-.36.03-.67.07-1.17.03.3-.07.06-.04.27-.11-.19-.02-.57.02-.91.07-.33.05-.62.1-.62.1-.02.04.11.05.47.05-.42.11-1.77,0-2.64.05.28,0,1.17.04.84.12-1.17-.04-1.56.14-2.38.21-1.08-.08.79-.15.59-.28-.18-.05-.61-.15-.16-.2-.97-.03-1.67.08-2.53.11l.02-.04c-1.21.01-2.49.17-3.51.1l.54.04c-.2.02-.81.01-1.14.08.04-.06-.75-.11-.43-.16-.54.19-2.74.12-3.35.3-.32-.05-.06-.13.03-.17.76.02,1.02.05,1.42-.02-.63,0-1.1-.05-1-.09-.63.12-2.14.17-2.46.28-.46-.06-.9-.09-.74-.19-1.94.06.96.31-1.23.3-1-.1.98-.13-.4-.16l.25-.02c-1-.26-.7.18-1.83.17-.15-.14.79-.1,0-.2-1.03.04-1.49.24-2.52.2l.16-.06c-.66,0-1.94,0-2.6,0-.03-.03.06-.02.19-.03-1.22-.05-.51.07-1.51-.02l-.29.07c.5.05,1.47.12,2.1.04-.63.08.99.18.68.29l.13-.05c1.65.2,3.78.23,5.88.31,1.32-.14,2.25.06,3.67-.04.22-.16.27-.03,1.49-.07-.65.02-.08.12.33.15.24-.04.53-.06.82-.07.25.06,1.78.19,2.35.08.74.05-.17.05-.34.09.3.08.6-.06.85,0,0,0-.01.02-.09.03,1.14,0,1.81.04,3,.06.1-.16,1.16-.06,1.69-.12-.17.05.67.06,1,.09l.63-.12c.63-.1.87.07,1.68.02l-.2-.03c.59-.05,2.15.05,2.73.13,5.47-.31,8.46.17,14.22.09.37-.05-.27-.08.02-.15.59-.02.72-.01,1.25-.01-.47-.04-.4.01-.33-.03l-.82.04s.05-.02-.03-.04c-.27.02-.6.05-.95.04.5-.04.65-.16,1.34-.11-.05.02-.14.02-.32.03.57,0,.6-.05,1.03-.02.52.03.39-.01.46.04l1.63.06c.81-.14,1.81,0,2.07,0-.18.11-1.08.03-1.48.14l.59.08.03-.08.84.02-.05.02c.1-.03.2-.07.41-.04.04.01.12.03.02.04l.6-.05c-.35.09.52.03.44.13,1.94.05,2.47-.14,4.18,0-.28-.05.54-.16,1.07-.14.3.02.38.05.19.09l.69-.05c.86.16,1.71.06,2.97.11l-.07.04c.47-.05.97-.09,1.68-.08l-.13.09c.86.06.66-.19,1.61-.13,0-.1-.6-.14-.7-.23.22.1,1.25.11,1.01.04.95-.04.66,0,.74.03l.56-.06c.67,0,.21.12-.03.18.62-.1,1.3-.03,2-.01l-.29.04.93.02c.61-.07,1.45-.08,2.24-.04l-.54.13c.55.07.28-.04.43-.06.87-.06,1.05.02,1.51.1,1.39-.13,2.77.21,3.96.02Zm95.78-.49l-.13-.02c.29-.02.46-.04.13.02Zm-7.63-.04c.92-.05.63.01.7.04-.9-.03-1.41,0-2.21-.04.13.02.15.06.19.08-.32,0-.64-.03-.75-.1.4-.13,2.46.08,2.06,0Zm17.18-.62s-.07.02-.11.03h0l.11-.03Zm-4.55.11c-.06-.03-.18-.04-.31-.05.08.03.17.06.31.05Zm-9.05-.16c-.21-.05-.69-.04-1.03-.02.16,0,.45.02,1.03.02Zm-57.1.06c.27-.02.79-.07.32-.11-.23.05-.66-.03-.85.04-.03,0-.03,0-.05,0,.27.04.5.08.58.08Zm-26.84.43c.05-.05.25-.11.12-.15.02,0,.05,0,.08,0-.07-.02-.13-.03-.07-.04-.22-.01-.45-.02-.6,0-.07.17-.54.2.48.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.69,954.34c-.1,0-.18,0-.25,0,.07,0,.15,0,.25,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1338.29,954.84s.24.03.55.05c-.06-.02-.22-.04-.55-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1451.07,955.16l-.27.02.53.05c.89-.06.93-.13,1.15-.21-.8.08-1.28.04-2.3.06l.89.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1450.62,954.6c-.09-.02-.31-.08-.45-.08l-.13.05.58.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1440.1,954.35l.84.04c.27-.04-.71-.12-.84-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1443.84,955.24l.44-.06c-.4-.04-.93-.04-1.02.02.53-.03.13.03.58.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1437.84,954.34c-.26.1-.84-.04-1.02.05.22-.03.98.05,1.02-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1438.43,955.3c.27.1.71.01,1.24.03-.44,0-1.07-.1-1.24-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1433.32,954.63c.04-.07.4-.07.8-.05-.13.02-.22.06-.4.07.67-.06.71-.04,1.24-.08-.53-.05-1.33-.08-1.25-.17-.4.07-.88.17-.4.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1437.15,955.31c.44.03.71.1,1.24.09-.09-.05-.27-.12-.89-.11l.22-.08c-.58-.06.23.11-.57.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1430.88,954.43l.27.04c.62-.07,1.42-.03,1.77-.14-.75,0-1.68.05-2.04.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1434.97,955.16l-.08.12c.62.02-.04-.04.18-.07.18.02.44.03.57,0-.71.02-.05-.1-.67-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1432.93,955.29l-.79.05.62.13c.93-.04.04-.07.17-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1431.95,955.21l-.09-.02-1.19.17c.71-.07.75-.06,1.28-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1417.49,954.44c-.13.05.56.11.27.06.13-.04-.8-.11-.27-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1420.34,955.39c-.34-.04-1.45.03-1.94.07.58-.02,2.02,0,1.94-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1418.2,955.47s.11,0,.2-.01c-.09,0-.15.01-.2.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1397.7,955.73c-.05,0-.1,0-.15.01.05,0,.1,0,.15-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1398.19,955.7c.33.02.99-.01,1.1-.07-.52.03-.98.04-1.59.1.23,0,.51.03.49-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1393.48,955.67c.24-.03.58-.02.5-.06-.14-.02-.66.03-.5.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.76,954.2c-.45-.03-.72,0-.6.07.51,0,.23-.04.6-.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1360.58 954.28 1360.52 954.24 1360.22 954.19 1360.58 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.46,954.17s.1-.02.19-.03c-.18,0-.33.02-.19.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.74,954.14s-.06,0-.09,0c.03,0,.06,0,.09,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.94,954.16l.04-.04c-.05,0-.15,0-.24.02.08,0,.17,0,.21.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1356.52,954.16l.6.11c.62-.06-.7-.06-.09-.18l-.5.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1354.45,954.19c-.57-.04-1.39.14-1.71,0-1.61.07.37.22-1.47.27,1.74.07.89-.26,2.43-.18-.75-.08.5-.07.75-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1354.72,954.41c.09-.07-.63-.07-.85-.03.21,0,.57.1.85.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1351.3 954.25 1350.81 954.2 1350.68 954.24 1351.3 954.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.43,954.22l.48-.08c-.16.03-.88.02-.48.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.83,954.13c-.45-.03-.86.15.09.11h-.22c.06-.03-.46-.1.12-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1340.82,954.41c.31,0,.68-.02.61-.06l-.85.04.24.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1340.94,954.84c.29.11.8,0,1.36.03-.64-.02-.57-.04-1.36-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1339.84,954.25c.23-.04.59-.02.8,0-.1-.06-.69-.05-.8,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1338.49,954.29c-.28-.04.06-.06-.15-.09-.6-.05-1.22-.04-1.56.02.16.05.37.17.13.23.95-.04,1.44-.24,1.9-.08l.8-.19c-.76-.03-.58.13-1.11.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1340.41,954.65l-.51-.06c.1.06-.28.07-.56.09.13.14.77-.02,1.07-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1333.21 954.37 1332.12 954.41 1332.48 954.41 1333.21 954.37"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1332.51 954.33 1332.48 954.29 1331.66 954.36 1332.51 954.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1331.38 954.28 1331.51 954.29 1332.14 954.25 1331.38 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1329.12,954.26l.2.06c.27-.02.82.05.77-.03-.24.03-.81.02-.97-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1321.65,955.73c.2-.04.08-.07-.04-.11l-.31.1c.09,0,.27-.01.35,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1320.34,955.57l-.8.11c.93.02,1.05-.07,1.86-.09-.34-.04-.82.05-1.25.01l.19-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1304.26,955.49c.07-.07-.11-.06.49-.11-.82.04-1.52.03-2.46.04.16.05-.54.12-.18.11l1.04-.04-.16.05c.73.06.48-.08,1.26-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1262.23,954.72c.1-.04-.03-.07-.15-.1-.62.04.28.09.15.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m576.46,954.88c.22-.09-.07-.03-.34-.02l.34.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m576.12,954.86h-.24c.06,0,.15,0,.24,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m573.89,954.8c.51-.07,1.13.03,1.45-.08-.52-.07-1.32-.04-1.45.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "574.66 954.87 574.72 954.81 574.27 954.9 574.66 954.87"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "574.98 954.93 574.92 954.9 574.21 954.97 574.98 954.93"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.15,954.75l.51-.02c.48.08-.32.11,0,.17.64,0,.22-.17,1.03-.15-.06-.08-1.29,0-1.16-.12-.68-.04-.03.07-.39.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m541.15,955.42s-.05,0-.07-.01c.03.01.06.02.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m532.66,955.51c-.12,0-.24-.02-.35-.03.03.01.08.02.14.03h.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m546.47,955.19c.13.01.24.02.34.03-.06-.02-.16-.03-.34-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m492.39,954.74s.04-.02.04-.04c0,0,0,0-.02,0l-.09.03h.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m523.15,955.7c-.13,0-.26,0-.38.01.22,0,.33,0,.38-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m549.53,955.18s-.09,0-.13,0c.04,0,.1,0,.16.01h-.02s0-.01,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m535.43,955.68c-.12,0-.22-.02-.31-.02.11.01.21.01.31.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m564.28,954.62c-.15-.01-.27,0-.37.01.09.02.21.02.37-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m561.24,954.63h.02s-.03-.01-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.3,954.62h.03s-.03-.02-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m563.9,954.63c-.25-.05-.33-.21-.65-.03l.06.02c-.19-.04-.48.03-.71.03.02.02.05.03.08.04.11,0,.26,0,.49.02.27.04.45-.05.72-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m541.18,955.39s.23.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m543.8,955.26h-.26c.08,0,.16,0,.26,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m553.66,955.31h-.05s.02,0,.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m543.31,955.25h.24c-.07,0-.15,0-.24,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m550.7,955.21s-.03,0-.04,0c0,0,.02,0,.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m451.84,954.19c.2-.01.32.03.5.04.42-.11-.87,0-.26-.1-.19,0-.33.02-.47.03l.27.11c.37-.04-.25-.04-.04-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m489.92,954.52h.08c-.06-.04,0-.05-.33-.08-.28.07.16.19-.33.27.09,0,.23,0,.37,0-.2-.07,0-.14.21-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m489.71,954.71s0,0,.01,0c.02.01.04.02.07.03.07,0,.14,0,.19.01-.05-.02-.16-.04-.28-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m458.42,954.24c.08,0,.15,0,.22.01-.11-.02-.17-.02-.22-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m523.76,954.33c.09-.01.19-.02.27-.03-.15,0-.22.02-.27.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m494.61,954.63c.08,0,.15.01.23.02.05,0,.09,0,.15,0h-.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m478.99,955.66c.17-.12-.13,0-.46-.06l-.31.07c.28.02.55,0,.77,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m451.59,954.16s0,0,0,.01c0,0,.01,0,.02,0h-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m469.81,955.69c-.05,0-.1-.01-.15-.02.03,0,.08.01.15.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m491.55,954.77h1.18s-.34-.02-.34-.02c-.16.06-.67-.05-.84.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m484.03,955.73l.11.07c1.17-.16,2.52.07,3.46-.15,1.43.26.94-.23,2.25,0l-.04-.04c4.32.04,8.89.18,12.93.05v.05c6.49.09,12.83-.02,19.27.02.6-.05.24-.16.76-.22.23,0,.73,0,.74.06-.44.04-.19.09-.34.12.72,0,1.66.07,2.31-.01l-.54-.08c.25-.03.65-.01.87,0-.1.04.23.13.04.15,1.36-.21,1.06.09,2.21,0,.23-.18,1.67-.32,2.61-.45l.5.05c-.66,0,.01.13-.81.12.68.05,1.32-.02,1.97,0-.13-.04-.09-.1.17-.12.4.02.43.11.89.12l-.45.06c.3.07.56-.02.84-.03.09.07.77.09.65.17.61-.1.83-.04,1.49-.11-.68-.08.18-.1.1-.16l-.77.03c1.09.05-.35.01-.27.14-.51-.06.7-.21-.15-.19,1.02-.06,1.24,0,2.29-.11-.63.02.12-.08-.22-.12.8,0,.2.04.45.12.44,0,.6.07,1-.02.71.04-.11.09.25.15-.26.09-1.97-.11-1.77.17-.37,0-.82.11-1.35.1.46.04,1.13.13,1.7.06l.03-.16c.44,0,.53-.11.84-.1-.17.04.13.11.48.1-.1-.02-.24-.02-.2-.04.65-.01.74-.12,1.51-.15-.64-.04-.77-.09-1.37-.15.16-.11.42-.02.77-.03-.05.02-.13.02-.02.04l.37-.05c.8.05-.1.16.56.21.45.09.62-.05.97,0-.02,0-.05-.02-.07-.03.08,0,.13,0,.17,0h0c.42-.02.87-.01.99-.1.04.04.37-.01.51-.04.24-.03.8-.13,1.15,0h-.03c.53.02.93.06.82.1l.85.03-.09.11c.77-.03.7-.09,1.23-.2.55.06,1.52.01,1.89-.03.06,0,.15,0,.31,0l-.32-.04c.6,0,.53-.05.93-.05-.08,0-.09-.02.13,0,.07,0,.14,0,.23,0-.02.01-.11,0-.2,0l.07.04c.48.11.74-.06,1.25-.02-.05,0-.13.01-.18.01.29.03.71.18.83.09.07.01.17,0,.27-.03l.21.02c-.09,0-.15-.01-.21-.02.13-.03.26-.07.27-.05l.74.02c.14.02.33,0,.48-.01l.13.04c.27,0,.27.02.24.03.94.15,1.45-.08,2.46.05.19-.07-.23-.11-.26-.15.16-.06.74-.11,1.03-.15.45.1,1.83.19,1.61.34.83.01-.26-.09.16-.14h.1c-.29-.01-.51-.06-.67-.12-.06-.08.67-.1.9-.08l-.16.11c.77-.04.61-.21,1.09-.32.61.04.26.15.39.25l.64-.03v.08c.42-.02.51-.1,1.09-.07-.42.08.87.08.29.19.32.03.41-.13.58-.02.22-.09-.29-.04-.45-.07-.13-.13.71-.06,1.09-.1.03.07-.26.08.2.12.09-.05.38-.09.64-.03,0-.08.51-.02.77-.01-.29-.02-.71-.08-.52-.15.23-.03.42-.05.93-.04l-.35-.04c.45-.12.74.09,1.35.05-.26.05-.42.05-.64.11.29-.04.84-.1,1.29-.14l.51.12c.06-.06.58,0,.58-.08.64.06-.51.1-.58.16.8.06.64-.14,1.41-.01l-.26.08c.26,0,.77-.04.8,0,0-.03-.13-.02-.29-.02.16-.17,1.19-.12,1.09-.29h-.35c.54-.05.93-.16,1.35-.1.32.06-.23.12-.42.16.51.01.42-.19,1.03-.17-.32-.03-.26-.09-.07-.13-.35-.01-1.09-.04-.96.03l.13.02s-.23.06-.32.08c-.48,0-.23-.08-.32-.11-.8-.03-.07.17-.8.17l-.1-.03c-.35.04-.9.05-1,.16-.32-.11-.83.04-1.19-.02-.07-.25,1.25.02,1.67-.12-.39-.05.22-.12.38-.17l-1.22.11c-.1-.03-.45-.16-.68-.07h.1c-.48.03-.35.13-.77.1-.06-.02.06-.06.1-.08-.39-.02-.32.06-.58.08-.39-.02.19-.1-.13-.13-.45.1-.71-.02-1.09-.02.16.14-1.54.19-.7.31l-.93.1c-.29-.07.64-.2.38-.31h.74c-.12-.17-1.55.12-2.04-.08-.4,0-.3.02-1.05-.07l.13.16c-.39-.04-.51-.12-.53-.15-.23.01-.43,0-.64,0,.06-.02.13-.04.27-.05-.29-.09-.38-.05-.48,0-.16.04-.4.03-.64.03l.22-.06c-.15.01-.33.03-.35.06-.1,0-.2,0-.29.01.06.03.23.12.57.16-.9-.06-1.61-.03-2.38-.16.03-.04.35-.1.25-.11-.39-.02-.8.06-.77.12-.09,0-.15,0-.21,0-.07-.04-.16-.08-.35-.09-.04-.01-.11-.03-.24-.03-.13.12-.87.06-1.03.12.17.01.39.01.6,0-.31.08-.59.18-.83.11.58-.08-.61-.13.25-.16-.61-.16-.32.11-.96.06l-.42-.06c.06-.09.68-.05.58-.08h-.29c.29-.06,1.38-.01,2.06-.11l-1.35-.05c-1.7.11-3.82-.02-5.27.18h.06s-.04.02-.06.06l-.06-.02-.29.07c-.32-.08-.93-.1-1.45-.17q.32.06.36.12c-.06.09-.11.13-.6.1,0-.06.29-.06-.06-.11.18.03.02.08-.19.08-.27-.04-.72-.05-.73-.11.13-.02.23,0,.31.01.13-.02-.51-.06-.14-.11l-.49.02c-.29-.05.19-.08.08-.12-.82.04-1.23.19-1.97.23.03-.03.04-.18.03-.14-.57-.04-1.22.16-1.87.17.1-.04.34-.03.53-.05-1.98-.05-3.6-.06-5.46-.19l-.48.15-.49-.1c-1.95-.09-3.45,0-5.31.04-.58,0-.35-.1-.62-.14-1.27-.02-1.58.15-2.79.18.17-.04.45-.17-.07-.18-.1.04-.16.11-.49.08l.17-.05c-.3-.07-.59,0-1.21-.03-1.1,0-2.15.11-3.05.27-.97-.01.1-.16-.08-.19.69.05.48-.03.63-.08-.36.04-.8.07-.99-.04-.51,0-.73,0-1.23.07.25-.04.47.02.23.07-.41-.04-1.47,0-1.41-.13-2.4,0-5.07,0-7.64,0-.43.07.33.03.09.07-.63.09-.5-.05-1,.02l.21-.07c-.75-.01-1.54.12-2.27.19.12-.08-.6-.07,0-.12-.35.01-.79-.35-1.06-.28l.4.34s-.52.01-.47.04c-.31-.07-.69-.15-.9-.15-.1-.09.43-.07.73-.07.04-.14-.99-.09-.57-.22-.63.02.09.07-.29.13l-.55-.03.43.05c-.46.04-.62.15-1.23.07l-.64.14c-.06-.11-.47-.02-.79-.05l.21-.07c-.44,0-.6-.02-.88-.06.25-.1.39.02.5-.07l-.48-.03c0,.06-.3.11.04.15-.44.12-.69.22-1.8.21-.5-.11.54-.1.33-.21-1.16-.05-1.41.28-2.09.27-.86-.04-.81.06-1.69.06.28-.07-.61-.08-.77-.15l.35-.08c-.27.02-.52,0-.44-.06.05.1-1.13.09-1.74.14l.11.09c-.47.03-1.12.08-1.62.06-.74.03-.57.1-1.15.2-.32-.08-.28-.17-.18-.26.2.04.54.02.86.04.94-.07,1.67-.26,2.61-.21.41-.21-.63.02-1.09-.05.01-.01.05-.02.08-.02-.04,0-.07,0-.11,0,.34-.03.88-.06.97-.17-.56.02-.41.21-1.11.12-.52.06-.94-.11-1.25-.12-.34.08-.36.24-1.21.21l.37-.12c-.96,0-.45.17-1.34.17.31.01-.3.11.29.12-.29.06-.94.07-1.42.04-.13.02-.03.04-.05.08.53.08.84-.08,1.28.04l.37-.13c.5.05.55.15.24.2.14,0,.26-.02.37,0,.08.19-.6-.07-.77.09h.35c.15.11-.82.09-1.27.09-.51-.06-.98-.08-1.01-.17l.69-.04c-.36-.07-.88.04-1.28.04-.03-.01-.06-.02-.11-.03.02,0,.03.02.03.02-.08,0-.16-.02-.23-.04-.35,0-.87.05-1.19.02l.04.08.04-.04c.32,0,.76.05.51.11-.72.06-.87-.1-1.04-.17.17-.12.71,0,1.08-.04-.22-.12-.74-.01-1.49-.09.3-.13.87,0,1.03-.12-.6-.02-.76.07-1.4.04.08-.06.7-.07.66-.15l-.41-.04c1,0-.18-.16.6-.2-.37-.05-.51.11-1.04.02.15.06.56.16.06.21l-.57-.04c-.24-.06.59-.14.22-.19l-.59.04s.3.06.13.11c-.34-.04-.56.15-.97.21-.32,0-.58-.01-.69-.06-.81.12-1.84.11-2.58.22.51-.08-.02-.14-.32-.19.59-.02.59-.14.55-.22-.36.01-.59.14-.41.18-.6-.05-.41.09-.93,0-.34-.04.17-.12.05-.17-.64,0-.18.15-.87.12.04-.02.1-.02.05-.04-.38-.03-.78.03-.86.09-.4-.16-1.13.02-1.05-.14-.91.04.14.09-.04.14-.37.07-1.06.01-1.28-.01.23,0,.43-.05.65-.02l-.19-.11c-1.14-.08-.72.25-1.82.15.56-.06.19-.08.47-.16-.17.03-1.03,0-.51.08-.41,0-.7-.03-.98-.05-.37.04-.76.07-.98.14-.58-.01-1-.09-1.28-.14-1.21.08-2.33-.06-3.61.03h.09c-.99-.01.44.15-.59.15.14-.13-.62-.09-.95-.16-1.26-.07-2.18.1-3.35,0,0-.03.08-.06.31-.06-.89-.04-1.6-.02-2.41-.02l.03-.02c-1.28-.11-2.45.02-3.78.05.11-.02.14-.07.22-.08-.67-.03-1.74-.05-2.21.07-.8-.13-.53.04-1.55-.09-.06-.02.1-.02.17-.03-.5-.04-.86-.03-1.37-.05-1.12.08-1.4.26-2.7.21-.07-.18.8-.04.83-.19-.26.03-.49.07-.84.03.22-.07.05-.04.2-.11-.14-.02-.41.02-.66.07-.24.05-.45.1-.45.1-.02.04.08.05.34.05-.3.11-1.28,0-1.91.05.21,0,.85.04.61.12-.85-.04-1.13.14-1.72.21-.78-.08.58-.15.43-.28-.13-.05-.44-.15-.12-.2-.7-.03-1.21.08-1.83.11l.02-.04c-.87.01-1.81.17-2.54.1l.39.04c-.14.02-.58.01-.83.08.03-.06-.54-.11-.31-.16-.39.19-1.99.12-2.42.3-.23-.05-.05-.13.02-.17.55.02.74.05,1.03-.02-.46,0-.8-.05-.72-.09-.46.12-1.55.17-1.78.28-.34-.06-.66-.09-.54-.19-1.41.06.7.31-.89.3-.72-.1.71-.13-.29-.16l.18-.02c-.72-.26-.51.18-1.32.17-.11-.14.57-.1,0-.2-.75.04-1.08.24-1.82.2l.12-.06c-.48,0-1.41,0-1.89,0-.02-.03.05-.02.14-.03-.88-.05-.37.07-1.09-.02l-.21.07c.36.05,1.06.12,1.52.04-.46.08.72.18.49.29l.09-.05c1.2.2,2.74.23,4.26.31.96-.14,1.63.06,2.66-.04.16-.16.19-.03,1.08-.07-.47.02-.06.12.24.15.17-.04.38-.06.59-.07.18.06,1.29.19,1.7.08.54.05-.13.05-.24.09.22.08.44-.06.62,0,0,0,0,.02-.06.03.82,0,1.31.04,2.17.06.07-.16.84-.06,1.22-.12-.12.05.48.06.72.09l.46-.12c.45-.1.63.07,1.22.02l-.14-.03c.43-.05,1.56.05,1.98.13,3.96-.31,6.13.17,10.3.09.27-.05-.2-.08.01-.15.42-.02.52-.01.91-.01-.34-.04-.29.01-.24-.03l-.59.04s.04-.02-.02-.04c-.2.02-.43.05-.69.04.37-.04.47-.16.97-.11-.04.02-.1.02-.23.03.41,0,.43-.05.74-.02.38.03.29-.01.33.04l1.18.06c.59-.14,1.31,0,1.5,0-.13.11-.78.03-1.07.14l.42.08.03-.08.61.02-.03.02c.07-.03.15-.07.3-.04.03.01.09.03.02.04l.43-.05c-.25.09.38.03.32.13,1.41.05,1.79-.14,3.03,0-.2-.05.39-.16.77-.14.22.02.28.05.14.09l.5-.05c.63.16,1.24.06,2.15.11l-.05.04c.34-.05.71-.09,1.22-.08l-.09.09c.62.06.48-.19,1.17-.13,0-.1-.44-.14-.51-.23.16.1.9.11.73.04.69-.04.48,0,.54.03l.4-.06c.48,0,.15.12-.02.18.45-.1.94-.03,1.45-.01l-.21.04.67.02c.44-.07,1.05-.08,1.62-.04l-.39.13c.4.07.2-.04.31-.06.63-.06.76.02,1.1.1,1.01-.13,2,.21,2.87.02Zm69.4-.49l-.09-.02c.21-.02.33-.04.09.02Zm-5.53-.04c.67-.05.45.01.5.04-.66-.03-1.02,0-1.6-.04.09.02.11.06.14.08-.23,0-.46-.03-.54-.1.29-.13,1.78.08,1.49,0Zm12.44-.62l-.08.03h0l.08-.03Zm-3.29.11s-.13-.04-.23-.05c.06.03.12.06.23.05Zm-6.56-.16c-.15-.05-.5-.04-.75-.02.12,0,.33.02.75.02Zm-41.37.06c.2-.02.57-.07.23-.11-.16.05-.48-.03-.62.04-.02,0-.02,0-.03,0,.2.04.36.08.42.08Zm-19.45.43c.04-.05.18-.11.09-.15.02,0,.04,0,.06,0-.05-.02-.09-.03-.05-.04-.16-.01-.32-.02-.44,0-.05.17-.39.2.34.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m496.17,954.34c-.08,0-.13,0-.18,0,.05,0,.11,0,.18,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m489.36,954.84s.17.03.4.05c-.05-.02-.16-.04-.4-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m571.06,955.16l-.19.02.39.05c.64-.06.68-.13.83-.21-.58.08-.93.04-1.67.06l.64.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.74,954.6c-.06-.02-.23-.08-.32-.08l-.1.05.42.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m563.12,954.35l.61.04c.19-.04-.52-.12-.61-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m565.83,955.24l.32-.06c-.29-.04-.68-.04-.74.02.39-.03.1.03.42.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m561.48,954.34c-.19.1-.61-.04-.74.05.16-.03.71.05.74-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m561.91,955.3c.19.1.51.01.9.03-.32,0-.77-.1-.9-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m558.2,954.63c.03-.07.29-.07.58-.05-.1.02-.16.06-.29.07.48-.06.51-.04.9-.08-.39-.05-.97-.08-.9-.17-.29.07-.64.17-.29.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.98,955.31c.32.03.51.1.9.09-.07-.05-.2-.12-.65-.11l.16-.08c-.42-.06.16.11-.42.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m556.43,954.43l.19.04c.45-.07,1.03-.03,1.28-.14-.54,0-1.22.05-1.48.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.4,955.16l-.06.12c.45.02-.03-.04.13-.07.13.02.32.03.42,0-.51.02-.03-.1-.48-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m557.92,955.29l-.58.05.45.13c.68-.04.03-.07.13-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m557.21,955.21l-.06-.02-.86.17c.51-.07.55-.06.93-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m546.73,954.44c-.1.05.41.11.19.06.1-.04-.58-.11-.19-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m548.8,955.39c-.25-.04-1.05.03-1.41.07.42-.02,1.46,0,1.41-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m547.25,955.47s.08,0,.14-.01c-.06,0-.11,0-.14.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m532.39,955.73s-.08,0-.11.01c.04,0,.07,0,.11-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m532.75,955.7c.24.02.72-.01.8-.07-.38.03-.71.04-1.15.1.17,0,.37.03.35-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m529.34,955.67c.18-.03.42-.02.36-.06-.1-.02-.48.03-.36.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m506.36,954.2c-.33-.03-.52,0-.43.07.37,0,.17-.04.43-.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "505.5 954.28 505.46 954.24 505.24 954.19 505.5 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m503.24,954.17s.08-.02.14-.03c-.13,0-.24.02-.14.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m503.44,954.14s-.04,0-.06,0h.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m503.59,954.16l.03-.04s-.11,0-.17.02c.06,0,.13,0,.15.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m502.56,954.16l.43.11c.45-.06-.51-.06-.07-.18l-.36.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m501.06,954.19c-.41-.04-1.01.14-1.24,0-1.17.07.27.22-1.07.27,1.26.07.64-.26,1.76-.18-.54-.08.36-.07.54-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m501.26,954.41c.07-.07-.46-.07-.62-.03.15,0,.41.1.62.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "498.78 954.25 498.42 954.2 498.33 954.24 498.78 954.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m497.43,954.22l.35-.08c-.11.03-.63.02-.35.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m495.54,954.13c-.33-.03-.62.15.07.11h-.16s-.33-.1.09-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m491.18,954.41c.23,0,.49-.02.44-.06l-.62.04.17.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m491.27,954.84c.21.11.58,0,.99.03-.47-.02-.41-.04-.99-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m490.48,954.25c.17-.04.42-.02.58,0-.08-.06-.5-.05-.58,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m489.5,954.29c-.2-.04.04-.06-.11-.09-.43-.05-.89-.04-1.13.02.11.05.27.17.09.23.69-.04,1.04-.24,1.38-.08l.58-.19c-.55-.03-.42.13-.81.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m490.89,954.65l-.37-.06c.07.06-.21.07-.4.09.1.14.56-.02.77-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "485.67 954.37 484.89 954.41 485.14 954.41 485.67 954.37"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "485.17 954.33 485.15 954.29 484.55 954.36 485.17 954.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "484.35 954.28 484.44 954.29 484.9 954.25 484.35 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m482.71,954.26l.14.06c.2-.02.6.05.56-.03-.17.03-.58.02-.7-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m477.29,955.73c.14-.04.06-.07-.03-.11l-.23.1c.07,0,.2-.01.25,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m476.35,955.57l-.58.11c.67.02.76-.07,1.35-.09-.25-.04-.59.05-.91.01l.14-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m464.7,955.49c.05-.07-.08-.06.35-.11-.59.04-1.1.03-1.78.04.12.05-.39.12-.13.11l.76-.04-.11.05c.53.06.35-.08.91-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m434.25,954.72c.07-.04-.02-.07-.11-.1-.45.04.2.09.11.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.92,954.88c.27-.09-.09-.03-.42-.02l.42.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.5,954.86h-.29c.08,0,.18,0,.29,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1230.76,954.8c.63-.07,1.38.03,1.77-.08-.64-.07-1.62-.04-1.77.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1231.71 954.87 1231.79 954.81 1231.24 954.9 1231.71 954.87"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1232.1 954.93 1232.02 954.9 1231.16 954.97 1232.1 954.93"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1228.63,954.75l.63-.02c.59.08-.39.11,0,.17.79,0,.27-.17,1.26-.15-.08-.08-1.58,0-1.42-.12-.83-.04-.04.07-.47.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1190.63,955.42s-.06,0-.09-.01c.03.01.07.02.09.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1180.22,955.51c-.14-.01-.29-.02-.43-.03.04.01.1.02.17.03h.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1197.15,955.19c.15.01.29.02.41.03-.08-.02-.2-.03-.41-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1130.85,954.74s.05-.02.05-.04c0,0-.01,0-.02,0l-.11.03h.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1168.56,955.7c-.16,0-.33,0-.47.01.27,0,.41,0,.47-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1200.9,955.18c-.06,0-.11,0-.16,0,.05,0,.12,0,.19.01h-.03s0-.01,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1183.62,955.68c-.14,0-.27-.02-.38-.02.13.01.25.01.38.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1218.98,954.62c-.18-.01-.33,0-.46.01.11.02.26.02.46-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1215.26,954.63s.01,0,.02,0c-.02-.02-.03-.01-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1212.88,954.62s.03,0,.04,0c-.03-.01-.04-.01-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1218.52,954.63c-.31-.05-.4-.21-.8-.03l.08.02c-.24-.04-.59.03-.87.03.03.02.06.03.1.04.14,0,.32,0,.61.02.34.04.56-.05.88-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1190.67,955.39s.29.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1193.88,955.26c-.1,0-.21,0-.32,0,.1,0,.2.01.32,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1205.97,955.31s-.04,0-.06,0c-.02.02.03.02.06,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1193.27,955.25c.1,0,.19,0,.29,0-.09,0-.18-.01-.29,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1202.34,955.21s-.03,0-.05,0c.01,0,.03,0,.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.13,954.19c.24-.01.39.03.62.04.52-.11-1.06,0-.32-.1-.23,0-.41.02-.58.03l.33.11c.45-.04-.3-.04-.05-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1127.82,954.52h.1c-.07-.04,0-.05-.41-.08-.34.07.19.19-.4.27.11,0,.29,0,.45,0-.24-.07,0-.14.26-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1127.57,954.71s.01,0,.02,0c.03.01.05.02.09.03.09,0,.17,0,.24.01-.06-.02-.19-.04-.34-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.2,954.24c.1,0,.19,0,.27.01-.13-.02-.21-.02-.27-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1169.31,954.33c.12-.01.23-.02.33-.03-.18,0-.27.02-.33.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1133.57,954.63c.09,0,.19.01.29.02.06,0,.11,0,.18,0h-.47Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1114.42,955.66c.21-.12-.16,0-.57-.06l-.38.07c.35.02.67,0,.95,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1080.83,954.16s0,0,0,.01c.01,0,.02,0,.03,0h-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.17,955.69c-.06,0-.12-.01-.18-.02.04,0,.09.01.18.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1129.82,954.77h1.45s-.42-.02-.42-.02c-.2.06-.82-.05-1.03.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1120.6,955.73l.13.07c1.44-.16,3.09.07,4.24-.15,1.76.26,1.15-.23,2.76,0l-.05-.04c5.29.04,10.9.18,15.85.05v.05c7.96.09,15.73-.02,23.63.02.74-.05.29-.16.93-.22.28,0,.9,0,.9.06-.53.04-.23.09-.42.12.89,0,2.04.07,2.83-.01l-.66-.08c.31-.03.79-.01,1.07,0-.12.04.29.13.05.15,1.67-.21,1.31.09,2.71,0,.28-.18,2.04-.32,3.2-.45l.61.05c-.81,0,.01.13-.99.12.84.05,1.62-.02,2.41,0-.15-.04-.11-.1.2-.12.49.02.53.11,1.09.12l-.55.06c.37.07.69-.02,1.03-.03.11.07.94.09.8.17.75-.1,1.01-.04,1.82-.11-.84-.08.22-.1.12-.16l-.95.03c1.33.05-.43.01-.33.14-.63-.06.86-.21-.19-.19,1.25-.06,1.52,0,2.8-.11-.77.02.15-.08-.27-.12.98,0,.24.04.55.12.53,0,.73.07,1.22-.02.87.04-.13.09.31.15-.32.09-2.41-.11-2.18.17-.45,0-1,.11-1.66.1.57.04,1.38.13,2.09.06l.04-.16c.53,0,.64-.11,1.03-.1-.2.04.16.11.59.1-.12-.02-.29-.02-.25-.04.8-.01.91-.12,1.85-.15-.78-.04-.94-.09-1.67-.15.2-.11.52-.02.95-.03-.06.02-.15.02-.03.04l.46-.05c.97.05-.12.16.68.21.56.09.76-.05,1.19,0-.03,0-.06-.02-.08-.03.09,0,.16,0,.21,0,0,0,0,0,0,0,.52-.02,1.07,0,1.22-.09.05.04.45-.01.62-.04.29-.03.98-.13,1.41,0-.01,0-.02,0-.03,0,.64.02,1.15.06,1.01.1l1.04.03-.11.11c.95-.03.85-.09,1.5-.2.68.06,1.86.01,2.31-.03.07,0,.19,0,.38,0l-.4-.04c.74,0,.65-.05,1.14-.05-.1,0-.12-.02.16,0,.08,0,.17,0,.28,0-.02.01-.13,0-.24,0l.09.04c.59.11.91-.06,1.54-.02-.06,0-.16.01-.23.01.35.03.86.18,1.01.09.08.01.21,0,.33-.03l.26.02c-.11,0-.19-.01-.26-.02.16-.03.32-.07.34-.05l.91.02c.17.02.41,0,.59-.01l.15.04c.33,0,.33.02.29.03,1.15.15,1.77-.08,3.02.05.24-.07-.28-.11-.32-.15.19-.06.9-.11,1.26-.15.55.1,2.25.19,1.97.34,1.02.01-.32-.09.19-.14h.12c-.35-.01-.63-.06-.83-.12-.08-.08.83-.1,1.1-.08l-.19.11c.94-.04.75-.21,1.33-.32.75.04.32.15.48.25l.79-.03v.08c.51-.02.63-.1,1.34-.07-.51.08,1.06.08.36.19.39.03.51-.13.71-.02.27-.09-.35-.04-.55-.07-.16-.13.87-.06,1.34-.1.04.07-.32.08.24.12.11-.05.47-.09.78-.03,0-.08.63-.02.95-.01-.36-.02-.87-.08-.64-.15.28-.03.51-.05,1.14-.04l-.43-.04c.55-.12.91.09,1.66.05-.32.05-.51.05-.79.11.35-.04,1.02-.1,1.58-.14l.63.12c.08-.06.71,0,.71-.08.79.06-.63.1-.71.16.99.06.79-.14,1.73-.01l-.31.08c.31,0,.95-.04.98,0,0-.03-.16-.02-.35-.02.19-.17,1.45-.12,1.34-.29h-.43c.67-.05,1.14-.16,1.65-.1.39.06-.28.12-.51.16.63.01.51-.19,1.26-.17-.39-.03-.32-.09-.08-.13-.43-.01-1.34-.04-1.18.03l.16.02s-.28.06-.39.08c-.59,0-.28-.08-.39-.11-.99-.03-.08.17-.98.17l-.12-.03c-.43.04-1.1.05-1.22.16-.39-.11-1.02.04-1.45-.02-.08-.25,1.53.02,2.05-.12-.47-.05.27-.12.47-.17l-1.49.11c-.12-.03-.56-.16-.83-.07h.12c-.59.03-.43.13-.95.1-.08-.02.08-.06.12-.08-.47-.02-.39.06-.71.08-.47-.02.24-.1-.16-.13-.55.1-.87-.02-1.34-.02.2.14-1.89.19-.86.31l-1.14.1c-.36-.07.78-.2.47-.31h.91c-.15-.17-1.9.12-2.5-.08-.48,0-.37.02-1.28-.07l.16.16c-.48-.04-.63-.12-.65-.15-.28.01-.53,0-.79,0,.07-.02.16-.04.33-.05-.36-.09-.46-.05-.59,0-.19.04-.49.03-.79.03l.27-.06c-.18.01-.41.03-.43.06-.12,0-.24,0-.35.01.08.03.28.12.7.16-1.1-.06-1.97-.03-2.91-.16.04-.04.43-.1.31-.11-.47-.02-.99.06-.94.12-.11,0-.19,0-.26,0-.09-.04-.2-.08-.43-.09-.05-.01-.14-.03-.3-.03-.16.12-1.06.06-1.26.12.21.01.48.01.74,0-.38.08-.72.18-1.01.11.71-.08-.75-.13.31-.16-.75-.16-.39.11-1.18.06l-.51-.06c.08-.09.83-.05.71-.08h-.36c.36-.06,1.7-.01,2.52-.11l-1.66-.05c-2.09.11-4.69-.02-6.46.18.03,0,.05,0,.08,0-.03,0-.05.03-.07.06l-.08-.02-.35.07c-.4-.08-1.14-.1-1.78-.17q.4.06.44.12c-.08.09-.14.13-.73.1,0-.06.36-.06-.08-.11.23.03.02.08-.23.08-.33-.04-.89-.05-.9-.11.15-.02.28,0,.38.01.15-.02-.63-.06-.17-.11l-.6.02c-.35-.05.23-.08.09-.12-1,.04-1.51.19-2.42.23.04-.03.05-.18.04-.14-.7-.04-1.49.16-2.29.17.12-.04.41-.03.65-.05-2.43-.05-4.41-.06-6.69-.19l-.59.15-.59-.1c-2.39-.09-4.23,0-6.51.04-.71,0-.43-.1-.76-.14-1.56-.02-1.94.15-3.42.18.2-.04.55-.17-.09-.18-.12.04-.2.11-.6.08l.2-.05c-.37-.07-.72,0-1.49-.03-1.35,0-2.63.11-3.74.27-1.19-.01.12-.16-.1-.19.84.05.58-.03.77-.08-.45.04-.98.07-1.21-.04-.62,0-.9,0-1.51.07.31-.04.57.02.28.07-.51-.04-1.8,0-1.73-.13-2.93.03-6.22,0-9.36,0-.53.07.4.03.11.07-.77.09-.61-.05-1.23.02l.25-.07c-.92-.01-1.89.12-2.78.19.15-.08-.73-.07,0-.12-.43.01-.96-.35-1.3-.28l.49.34s-.63.01-.57.04c-.38-.07-.85-.15-1.11-.15-.13-.09.53-.07.89-.07.05-.14-1.22-.09-.69-.22-.78.02.11.07-.35.13l-.68-.03.52.05c-.56.04-.76.15-1.51.07l-.78.14c-.08-.11-.57-.02-.97-.05l.25-.07c-.53,0-.74-.02-1.08-.06.3-.1.48.02.61-.07l-.59-.03c0,.06-.37.11.05.15-.54.12-.84.22-2.21.21-.62-.11.66-.1.41-.21-1.42-.05-1.73.28-2.56.27-1.06-.04-1,.06-2.07.06.34-.07-.75-.08-.95-.15l.42-.08c-.33.02-.64,0-.54-.06.06.1-1.39.09-2.13.14l.13.09c-.58.03-1.38.08-1.99.06-.91.03-.7.1-1.41.2-.39-.08-.34-.17-.22-.26.24.04.66.02,1.06.04,1.15-.07,2.05-.26,3.19-.21.5-.21-.77.02-1.33-.05.02-.01.06-.02.1-.02-.05,0-.09,0-.14,0,.41-.03,1.08-.06,1.19-.17-.69.02-.5.21-1.35.12-.63.06-1.15-.11-1.53-.12-.42.08-.44.24-1.48.21l.46-.12c-1.18,0-.55.17-1.64.17.38.01-.37.11.36.12-.36.06-1.15.07-1.74.04-.15.02-.03.04-.06.08.66.08,1.04-.08,1.57.04l.46-.13c.61.05.67.15.3.2.17,0,.32-.02.45,0,.1.19-.73-.07-.94.09h.43c.19.11-1,.09-1.56.09-.63-.06-1.2-.08-1.24-.17l.84-.04c-.44-.07-1.08.04-1.57.04-.03-.01-.08-.02-.14-.03.03,0,.04.02.04.02-.1,0-.2-.02-.28-.04-.43,0-1.06.05-1.46.02l.05.08.05-.04c.39,0,.93.05.63.11-.89.06-1.07-.1-1.28-.17.2-.12.87,0,1.32-.04-.27-.12-.9-.01-1.82-.09.37-.13,1.06,0,1.27-.12-.74-.02-.93.07-1.71.04.1-.06.86-.07.81-.15l-.5-.04c1.23,0-.21-.16.74-.2-.45-.05-.63.11-1.27.02.18.06.69.16.08.21l-.69-.04c-.29-.06.72-.14.27-.19l-.73.04s.37.06.15.11c-.42-.04-.69.15-1.18.21-.39,0-.71-.01-.85-.06-.99.12-2.25.11-3.17.22.62-.08-.02-.14-.4-.19.72-.02.72-.14.67-.22-.44.01-.72.14-.5.18-.73-.05-.5.09-1.15,0-.42-.04.21-.12.06-.17-.79,0-.21.15-1.07.12.05-.02.12-.02.06-.04-.46-.03-.96.03-1.06.09-.49-.16-1.39.02-1.29-.14-1.12.04.17.09-.05.14-.46.07-1.31.01-1.57-.01.28,0,.53-.05.8-.02l-.24-.11c-1.39-.08-.88.25-2.23.15.69-.06.23-.08.57-.16-.21.03-1.26,0-.62.08-.51,0-.86-.03-1.2-.05-.45.04-.94.07-1.2.14-.71-.01-1.23-.09-1.57-.14-1.49.08-2.86-.06-4.43.03h.12c-1.22-.01.54.15-.73.15.17-.13-.76-.09-1.16-.16-1.55-.07-2.68.1-4.1,0,.01-.03.1-.06.38-.06-1.09-.04-1.97-.02-2.95-.02l.04-.02c-1.57-.11-3,.02-4.63.05.13-.02.17-.07.27-.08-.82-.03-2.13-.05-2.71.07-.98-.13-.65.04-1.9-.09-.07-.02.12-.02.21-.03-.62-.04-1.05-.03-1.68-.05-1.38.08-1.72.26-3.32.21-.08-.18.98-.04,1.02-.19-.32.03-.59.07-1.04.03.26-.07.06-.04.24-.11-.34-.05-1.36.19-1.35.17-.02.04.1.05.41.05-.37.11-1.57,0-2.35.05.25,0,1.04.04.75.12-1.04-.04-1.38.14-2.11.21-.96-.08.71-.15.53-.28-.16-.05-.54-.15-.14-.2-.86-.03-1.48.08-2.25.11l.02-.04c-1.07.01-2.22.17-3.11.1l.48.04c-.18.02-.72.01-1.01.08.03-.06-.67-.11-.38-.16-.48.19-2.44.12-2.97.3-.29-.05-.06-.13.03-.17.68.02.91.05,1.26-.02-.56,0-.97-.05-.89-.09-.56.12-1.9.17-2.19.28-.41-.06-.8-.09-.66-.19-1.73.06.85.31-1.1.3-.89-.1.87-.13-.36-.16l.23-.02c-.89-.26-.62.18-1.62.17-.13-.14.7-.1,0-.2-.92.04-1.32.24-2.24.2l.14-.06c-.59.01-1.73-.02-2.31,0-.03-.03.06-.02.17-.03-1.08-.05-.45.07-1.34-.02l-.25.07c.44.05,1.31.12,1.87.04-.56.08.88.18.6.29l.11-.05c1.47.2,3.36.23,5.23.31,1.18-.14,2,.06,3.26-.04.2-.16.24-.03,1.32-.07-.57.02-.07.12.29.15.21-.04.47-.06.73-.07.22.06,1.58.19,2.08.08.66.05-.15.05-.3.09.27.08.54-.06.76,0,0,0-.01.02-.08.03,1.01,0,1.61.04,2.66.06.09-.16,1.03-.06,1.5-.12-.15.05.59.06.89.09l.56-.12c.56-.1.77.07,1.49.02l-.17-.03c.53-.05,1.91.05,2.43.13,4.86-.31,7.51.17,12.63.09.33-.05-.24-.08.02-.15.52-.02.64-.01,1.11-.01-.42-.04-.35.01-.3-.03l-.72.04s.04-.02-.02-.04c-.24.02-.53.05-.84.04.45-.04.57-.16,1.19-.11-.05.02-.13.02-.29.03.51,0,.53-.05.91-.02.46.03.35-.01.41.04l1.45.06c.72-.14,1.61,0,1.84,0-.16.11-.96.03-1.31.14l.52.08.03-.08.74.02-.04.02c.09-.03.18-.07.37-.04.03.01.1.03.02.04l.53-.05c-.31.09.46.03.39.13,1.73.05,2.2-.14,3.72,0-.25-.05.48-.16.95-.14.27.02.34.05.17.09l.61-.05c.77.16,1.52.06,2.64.11l-.06.04c.42-.05.87-.09,1.49-.08l-.11.09c.77.06.58-.19,1.43-.13,0-.1-.54-.14-.62-.23.2.1,1.11.11.9.04.84-.04.58,0,.66.03l.49-.06c.59,0,.19.12-.03.18.55-.1,1.15-.03,1.78-.01l-.25.04.82.02c.54-.07,1.29-.08,1.99-.04l-.48.13c.49.07.25-.04.38-.06.77-.06.94.02,1.34.1,1.23-.13,2.46.21,3.51.02Zm85.08-.49l-.11-.02c.26-.02.41-.04.11.02Zm-6.78-.04c.82-.05.56.01.62.04-.8-.03-1.25,0-1.96-.04.11.02.14.06.17.08-.28,0-.57-.03-.66-.1.35-.13,2.19.08,1.83,0Zm15.26-.62s-.06.02-.1.03h0l.1-.03Zm-4.04.11c-.06-.03-.16-.04-.28-.05.07.03.15.06.28.05Zm-8.04-.16c-.19-.05-.61-.04-.92-.02.14,0,.4.02.92.02Zm-50.72.06c.24-.02.7-.07.28-.11-.2.05-.59-.03-.76.04-.02,0-.03,0-.04,0,.24.04.44.08.52.08Zm-23.84.43c.04-.05.22-.11.11-.15.02,0,.05,0,.07,0-.06-.02-.11-.03-.06-.04-.19-.01-.4-.02-.53,0-.07.17-.48.2.42.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1135.48,954.34c-.09,0-.16,0-.22,0,.06,0,.13,0,.22,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1127.13,954.84s.21.03.49.05c-.06-.02-.19-.04-.49-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1227.3,955.16l-.24.02.47.05c.79-.06.83-.13,1.02-.21-.71.08-1.14.04-2.05.06l.79.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1226.9,954.6c-.08-.02-.28-.08-.4-.08l-.12.05.51.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1217.56,954.35l.75.04c.24-.04-.63-.12-.75-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1220.88,955.24l.39-.06c-.35-.04-.83-.04-.91.02.47-.03.12.03.51.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1215.55,954.34c-.23.1-.75-.04-.9.05.2-.03.87.05.9-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1216.07,955.3c.24.1.63.01,1.1.03-.39,0-.95-.1-1.1-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1211.53,954.63c.04-.07.35-.07.71-.05-.12.02-.2.06-.35.07.59-.06.63-.04,1.1-.08-.47-.05-1.18-.08-1.11-.17-.35.07-.79.17-.35.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1214.93,955.31c.39.03.63.1,1.1.09-.08-.05-.24-.12-.79-.11l.2-.08c-.51-.06.2.11-.51.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1209.36,954.43l.24.04c.55-.07,1.26-.03,1.57-.14-.67,0-1.49.05-1.81.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1213,955.16l-.07.12c.55.02-.04-.04.16-.07.16.02.39.03.51,0-.63.02-.04-.1-.59-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1211.19,955.29l-.71.05.55.13c.83-.04.04-.07.15-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1210.32,955.21l-.08-.02-1.06.17c.63-.07.67-.06,1.14-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1197.47,954.44c-.12.05.5.11.24.06.12-.04-.71-.11-.24-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1200.01,955.39c-.3-.04-1.29.03-1.72.07.52-.02,1.8,0,1.72-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1198.1,955.47s.1,0,.18-.01c-.08,0-.14,0-.18.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1179.89,955.73s-.09,0-.13.01c.05,0,.09,0,.13-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1180.33,955.7c.29.02.88-.01.98-.07-.46.03-.87.04-1.41.1.2,0,.45.03.43-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1176.15,955.67c.22-.03.52-.02.44-.06-.12-.02-.59.03-.44.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1147.97,954.2c-.4-.03-.64,0-.53.07.45,0,.2-.04.53-.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1146.92 954.28 1146.87 954.24 1146.61 954.19 1146.92 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1144.15,954.17s.09-.02.17-.03c-.16,0-.29.02-.17.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1144.4,954.14s-.05,0-.08,0c.03,0,.05,0,.08,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1144.58,954.16l.03-.04s-.13.01-.21.02c.07,0,.15,0,.18.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1143.32,954.16l.53.11c.55-.06-.63-.06-.08-.18l-.45.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1141.48,954.19c-.51-.04-1.23.14-1.52,0-1.43.07.33.22-1.31.27,1.55.07.79-.26,2.16-.18-.66-.08.45-.07.67-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1141.72,954.41c.08-.07-.56-.07-.76-.03.19,0,.51.1.76.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1138.68 954.25 1138.24 954.2 1138.13 954.24 1138.68 954.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1137.02,954.22l.43-.08c-.14.03-.78.02-.43.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1134.71,954.13c-.4-.03-.76.15.08.11h-.19s-.41-.1.11-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1129.37,954.41c.28,0,.6-.02.54-.06l-.76.04.21.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1129.48,954.84c.25.11.71,0,1.21.03-.57-.02-.5-.04-1.21-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1128.51,954.25c.2-.04.52-.02.71,0-.09-.06-.61-.05-.71,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1127.3,954.29c-.25-.04.05-.06-.13-.09-.53-.05-1.09-.04-1.39.02.14.05.33.17.11.23.85-.04,1.28-.24,1.69-.08l.71-.19c-.68-.03-.52.13-.99.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1129.01,954.65l-.45-.06c.09.06-.25.07-.49.09.12.14.69-.02.95-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1122.61 954.37 1121.65 954.41 1121.96 954.41 1122.61 954.37"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1121.99 954.33 1121.97 954.29 1121.23 954.36 1121.99 954.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1120.99 954.28 1121.1 954.29 1121.66 954.25 1120.99 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1118.98,954.26l.18.06c.24-.02.73.05.68-.03-.21.03-.72.02-.86-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1112.34,955.73c.17-.04.07-.07-.03-.11l-.28.1c.08,0,.24-.01.31,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1111.18,955.57l-.71.11c.82.02.94-.07,1.65-.09-.3-.04-.73.05-1.11.01l.17-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.89,955.49c.06-.07-.1-.06.43-.11-.73.04-1.35.03-2.18.04.14.05-.48.12-.16.11l.93-.04-.14.05c.65.06.43-.08,1.12-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1059.57,954.72c.09-.04-.03-.07-.14-.1-.55.04.25.09.14.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1019.56,955c-.11.09.04.03.17.02l-.17-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1019.73,955.02h.12s-.07,0-.12,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1020.83,955.08c-.25.07-.55-.03-.71.08.26.07.65.04.71-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1020.45 955.01 1020.41 955.07 1020.64 954.98 1020.45 955.01"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1020.29 954.95 1020.32 954.98 1020.67 954.91 1020.29 954.95"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1021.68,955.13l-.25.02c-.24-.08.16-.11,0-.17-.32,0-.11.17-.5.15.03.08.63,0,.57.12.33.04.02-.07.19-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.95,954.46s.02,0,.04.01c-.01-.01-.03-.02-.04-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.13,954.37c.06.01.11.02.17.03-.02-.01-.04-.02-.07-.03h-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.33,954.69c-.06-.01-.11-.02-.17-.03.03.02.08.03.17.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1060.97,955.14s-.02.02-.02.04c0,0,0,0,0,0l.05-.03h-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1045.82,954.18c.07,0,.13,0,.19-.01-.11,0-.16,0-.19.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1032.82,954.7s.04,0,.06,0c-.02,0-.05,0-.08-.01h.01s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1039.77,954.21c.06,0,.11.02.15.01-.05-.01-.1-.01-.15-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1025.56,955.26c.07.01.13,0,.18-.01-.05-.02-.1-.02-.18.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.06,955.25s0,0,0,0c0,.01.01.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.01,955.26s-.01,0-.02,0c.01.01.02.01.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1025.74,955.25c.12.05.16.21.32.03l-.03-.02c.1.04.24-.03.35-.03-.01-.02-.02-.03-.04-.04-.06,0-.13,0-.24-.02-.14-.04-.22.05-.35.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1036.93,954.49s-.11-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1035.65,954.62s.08,0,.13,0c-.04,0-.08-.01-.13,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1030.79,954.58s.02,0,.02,0c0-.02-.01-.02-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1035.89,954.63s-.08,0-.12,0c.04,0,.07.01.12,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1032.25,954.67s.01,0,.02,0c0,0-.01,0-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1080.94,955.69c-.1.02-.16-.03-.25-.04-.21.11.43,0,.13.1.09,0,.16-.02.23-.03l-.13-.11c-.18.04.12.04.02.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1062.18,955.36h-.04s0,.05.16.08c.14-.07-.08-.19.16-.27-.05,0-.11,0-.18,0,.1.07,0,.14-.1.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1062.29,955.17s0,0,0,0c-.01-.01-.02-.02-.03-.03-.03,0-.07,0-.09-.01.03.02.08.04.14.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1077.7,955.64s-.08,0-.11-.01c.05.02.08.02.11.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1045.51,955.55s-.09.02-.13.03c.07,0,.11-.02.13-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1059.87,955.26s-.07-.01-.12-.02c-.02,0-.04,0-.07,0h.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1067.57,954.22c-.08.12.06,0,.23.06l.15-.06c-.14-.02-.27,0-.38,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1081.06,955.72s0,0,0-.01c0,0,0,0-.01,0h.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1072.09,954.19s.05.01.07.02c-.01,0-.04-.01-.07-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1061.38,955.11h-.58s.17.02.17.02c.08-.06.33.05.41-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1065.09,954.15l-.05-.07c-.58.16-1.24-.07-1.7.15-.71-.26-.46.23-1.11,0l.02.04c-2.13-.04-4.38-.18-6.37-.05v-.05c-3.2-.09-6.32.02-9.49-.02-.3.05-.12.16-.37.22-.11,0-.36,0-.36-.06.21-.04.09-.09.17-.12-.36,0-.82-.07-1.14.01l.27.08c-.12.03-.32.01-.43,0,.05-.04-.12-.13-.02-.15-.67.21-.52-.09-1.09,0-.11.18-.82.32-1.29.45l-.24-.05c.33,0,0-.13.4-.12-.34-.05-.65.02-.97,0,.06.04.05.1-.08.12-.2-.02-.21-.11-.44-.12l.22-.06c-.15-.07-.28.02-.41.03-.04-.07-.38-.09-.32-.17-.3.1-.41.04-.73.11.34.08-.09.1-.05.16l.38-.03c-.54-.05.17-.01.13-.14.25.06-.35.21.08.19-.5.06-.61,0-1.13.11.31-.02-.06.08.11.12-.39,0-.1-.04-.22-.12-.21,0-.29-.07-.49.02-.35-.04.05-.09-.12-.15.13-.09.97.11.87-.17.18,0,.4-.11.67-.1-.23-.04-.56-.13-.84-.06v.16c-.23,0-.27.11-.43.1.08-.04-.07-.11-.24-.1.05.02.12.02.1.04-.32.01-.36.12-.74.15.31.04.38.09.67.15-.08.11-.21.02-.38.03.03-.01.06-.02.01-.04l-.18.05c-.39-.05.05-.16-.27-.21-.22-.09-.31.05-.48,0,.01,0,.02.02.03.03-.04,0-.07,0-.09,0,0,0,0,0,0,0-.21.02-.43,0-.49.09-.02-.04-.18.01-.25.04-.12.03-.39.13-.57,0,0,0,0,0,.01,0-.26-.02-.46-.06-.4-.1l-.42-.03.04-.11c-.38.03-.34.09-.6.2-.27-.06-.75-.01-.93.03-.03,0-.08,0-.15,0l.16.04c-.3,0-.26.05-.46.05.04,0,.05.02-.06,0-.03,0-.07,0-.11,0,.01-.01.05,0,.1,0l-.04-.04c-.24-.11-.36.06-.62.02.02,0,.06-.01.09-.01-.14-.03-.35-.18-.41-.09-.03-.01-.08,0-.13.03l-.1-.02s.08.01.1.02c-.07.03-.13.07-.14.05l-.36-.02c-.07-.02-.16,0-.24.01l-.06-.04c-.13,0-.13-.02-.12-.03-.46-.15-.71.08-1.21-.05-.1.07.11.11.13.15-.08.06-.36.11-.51.15-.22-.1-.9-.19-.79-.34-.41-.01.13.09-.08.14h-.05c.14.01.25.06.33.12.03.08-.33.1-.44.08l.08-.11c-.38.04-.3.21-.54.32-.3-.04-.13-.15-.19-.25l-.32.03v-.08c-.21.02-.25.1-.54.07.21-.08-.43-.08-.14-.19-.16-.03-.2.13-.28.02-.11.09.14.04.22.07.06.13-.35.06-.54.1-.02-.07.13-.08-.1-.12-.05.05-.19.09-.31.03,0,.08-.25.02-.38.01.14.02.35.08.26.15-.11.03-.21.05-.46.04l.17.04c-.22.12-.36-.09-.67-.05.13-.05.21-.05.32-.11-.14.04-.41.1-.63.14l-.25-.12c-.03.06-.29,0-.29.08-.32-.06.25-.1.29-.16-.4-.06-.32.14-.7.01l.13-.08c-.13,0-.38.04-.4,0,0,.03.06.02.14.02-.08.17-.58.12-.54.29h.17c-.27.04-.46.16-.66.1-.16-.06.11-.12.2-.16-.25-.01-.2.19-.51.17.16.03.13.09.03.13.17.01.54.04.47-.03l-.06-.02s.11-.06.16-.08c.24,0,.11.08.16.11.4.03.03-.17.39-.17l.05.03c.17-.04.44-.05.49-.16.16.11.41-.04.58.02.03.25-.62-.02-.82.12.19.05-.11.12-.19.17l.6-.11s.22.16.33.07h-.05c.24-.03.17-.14.38-.1.03.02-.03.06-.05.08.19.02.16-.06.28-.08.19.02-.09.1.06.13.22-.1.35.02.54.02-.08-.14.76-.19.35-.31l.46-.1c.14.07-.31.2-.19.31h-.36c.06.17.76-.12,1.01.08.19,0,.15-.02.52.07l-.06-.16c.19.04.25.12.26.15.11,0,.21,0,.32,0-.03.02-.07.04-.13.05.14.09.19.05.24,0,.08-.04.2-.03.32-.03l-.11.06c.07-.01.16-.03.17-.06.05,0,.1,0,.14-.01-.03-.03-.11-.12-.28-.16.44.06.79.03,1.17.16-.01.05-.17.1-.12.11.19.02.4-.06.38-.12.04,0,.08,0,.1,0,.04.04.08.08.17.09.02.01.05.03.12.03.06-.12.43-.06.51-.12-.09-.01-.19-.01-.3,0,.15-.08.29-.18.41-.11-.28.08.3.13-.12.16.3.16.16-.11.47-.06l.21.06c-.03.09-.33.04-.28.08h.14c-.14.06-.68.01-1.01.11l.67.05c.84-.11,1.88.02,2.6-.18-.01,0-.02,0-.03,0,.01,0,.02-.03.03-.06l.03.02.14-.07c.16.08.46.1.71.17q-.16-.06-.18-.12c.03-.09.06-.13.29-.09,0,.06-.14.06.03.11-.09-.03-.01-.08.09-.08.13.04.36.05.36.11-.06.02-.11,0-.15-.01-.06.02.25.06.07.11l.24-.02c.14.05-.09.08-.04.12.4-.04.61-.19.97-.23-.02.03-.02.18-.02.14.28.04.6-.16.92-.17-.05.04-.17.03-.26.05.97.05,1.77.06,2.69.19l.24-.15.24.1c.96.09,1.7,0,2.62-.04.28,0,.17.1.31.14.62.02.78-.15,1.37-.18-.08.04-.22.17.03.18.05-.04.08-.11.24-.08l-.08.04c.15.07.29,0,.6.03.54,0,1.06-.11,1.5-.27.48.02-.05.16.04.19-.34-.05-.23.03-.31.08.18-.04.39-.07.49.04.25,0,.36,0,.61-.07-.12.04-.23-.02-.11-.07.2.04.72,0,.69.13,1.18-.03,2.5,0,3.76,0,.21-.07-.16-.03-.04-.07.31-.09.24.05.49-.02l-.1.07c.37.01.76-.12,1.12-.19-.06.08.29.07,0,.12.17-.01.39.35.52.28l-.2-.34s.25-.01.23-.04c.15.07.34.15.45.15.05.09-.21.07-.36.07-.02.14.49.09.28.22.31-.02-.04-.07.14-.13l.27.03-.21-.05c.23-.04.3-.15.61-.07l.31-.14c.03.11.23.02.39.05l-.1.07c.21,0,.3.02.43.06-.12.1-.19-.02-.25.07l.24.03c0-.06.15-.11-.02-.15.22-.12.34-.22.89-.21.25.11-.27.1-.16.21.57.05.7-.28,1.03-.27.42.04.4-.06.83-.06-.14.07.3.08.38.15l-.17.08c.13-.02.26,0,.22.06-.02-.1.56-.09.85-.14l-.05-.09c.23-.03.55-.08.8-.06.37-.03.28-.1.56-.2.16.08.14.17.09.26-.1-.04-.26-.02-.42-.04-.46.07-.82.26-1.28.21-.2.21.31-.02.54.05,0,.01-.02.02-.04.02.02,0,.04,0,.06,0-.17.03-.44.06-.48.17.28-.02.2-.21.54-.12.25-.06.46.11.62.12.17-.08.18-.25.59-.21l-.18.12c.47,0,.22-.17.66-.17-.15-.01.15-.11-.14-.12.14-.06.46-.07.7-.04.06-.02.01-.04.02-.08-.26-.08-.42.08-.63-.04l-.18.13c-.24-.05-.27-.15-.12-.2-.07,0-.13.02-.18,0-.04-.19.29.07.38-.09h-.17c-.07-.11.4-.09.63-.09.25.06.48.08.5.17l-.34.04c.18.07.43-.04.63-.04.01.01.03.02.05.03-.01,0-.02-.02-.02-.02.04,0,.08.02.11.04.17,0,.43-.05.59-.02l-.02-.08-.02.04c-.16,0-.37-.05-.25-.11.36-.06.43.1.51.17-.08.12-.35,0-.53.04.11.12.36.01.73.09-.15.13-.43,0-.51.12.3.02.37-.07.69-.04-.04.06-.34.07-.32.15l.2.04c-.49,0,.09.16-.3.2.18.05.25-.11.51-.02-.07-.06-.28-.16-.03-.21l.28.04c.12.06-.29.14-.11.19l.29-.05s-.15-.06-.06-.11c.17.04.28-.15.48-.21.16,0,.28.01.34.06.4-.12.9-.11,1.27-.22-.25.08,0,.13.16.19-.29.02-.29.14-.27.22.18-.01.29-.14.2-.18.29.05.2-.09.46,0,.17.04-.08.12-.03.17.32,0,.09-.15.43-.12-.02.02-.05.02-.02.04.19.03.39-.03.43-.09.2.16.56-.02.52.14.45-.04-.07-.09.02-.14.18-.07.52-.01.63.01-.11,0-.21.05-.32.02l.09.11c.56.08.35-.25.89-.15-.28.06-.09.08-.23.16.08-.03.51,0,.25-.08.2,0,.34.03.48.05.18-.04.38-.07.48-.14.28.01.49.09.63.14.6-.08,1.15.06,1.78-.03h-.05c.49.01-.22-.15.29-.15-.07.13.3.09.47.16.62.07,1.08-.1,1.65,0,0,.03-.04.06-.15.06.44.04.79.02,1.19.02l-.02.02c.63.11,1.21-.02,1.86-.05-.05.02-.07.07-.11.08.33.03.86.05,1.09-.07.39.13.26-.04.76.09.03.02-.05.02-.08.03.25.04.42.03.67.05.55-.08.69-.26,1.33-.21.03.18-.39.04-.41.19.13-.03.24-.07.42-.03-.11.07-.02.04-.1.11.14.05.55-.19.54-.17,0-.03-.04-.05-.17-.05.15-.11.63,0,.94-.05-.1,0-.42-.04-.3-.12.42.04.56-.14.85-.21.38.08-.28.15-.21.28.06.05.22.15.06.2.35.03.59-.08.9-.11v.04c.42-.02.88-.17,1.24-.1l-.19-.04c.07-.02.29-.01.41-.08-.01.06.27.11.15.16.19-.19.98-.12,1.19-.3.11.05.02.12-.01.17-.27-.02-.36-.05-.51.02.23,0,.39.05.36.09.23-.12.76-.17.88-.28.17.06.32.09.27.19.69-.06-.34-.31.44-.3.36.1-.35.13.14.16l-.09.02c.36.26.25-.18.65-.17.05.14-.28.1,0,.2.37-.04.53-.24.9-.2l-.06.06c.24-.01.69.02.93,0,.01.03-.02.02-.07.03.43.05.18-.07.54.02l.1-.07c-.18-.05-.52-.12-.75-.04.23-.08-.35-.18-.24-.29l-.04.05c-.59-.2-1.35-.23-2.1-.31-.47.14-.8-.06-1.31.04-.08.16-.09.03-.53.06.23-.02.03-.12-.12-.15-.08.04-.19.06-.29.07-.09-.06-.64-.19-.84-.08-.26-.05.06-.05.12-.09-.11-.08-.22.07-.3,0,0,0,0-.02.03-.03-.41,0-.65-.04-1.07-.06-.03.16-.41.06-.6.12.06-.05-.24-.06-.36-.09l-.23.12c-.22.1-.31-.07-.6-.02l.07.03c-.21.05-.77-.05-.97-.13-1.95.31-3.02-.18-5.07-.09-.13.05.1.08,0,.15-.21.02-.26.01-.45.01.17.04.14-.01.12.03l.29-.04s-.02.02,0,.04c.1-.01.21-.05.34-.04-.18.04-.23.16-.48.11.02-.02.05-.02.12-.03-.2,0-.21.05-.37.02-.19-.03-.14.01-.17-.04l-.58-.06c-.29.14-.65,0-.74,0,.06-.11.38-.03.53-.14l-.21-.08v.08s-.31-.02-.31-.02l.02-.02s-.07.07-.15.04c-.01-.01-.04-.03,0-.04l-.21.05c.12-.09-.19-.03-.16-.13-.69-.05-.88.14-1.49,0,.1.05-.19.16-.38.14-.11-.02-.14-.05-.07-.09l-.25.05c-.31-.16-.61-.06-1.06-.11l.02-.04c-.17.05-.35.09-.6.08l.05-.09c-.31-.06-.23.19-.57.13,0,.1.22.14.25.23-.08-.1-.44-.11-.36-.04-.34.04-.23,0-.26-.03l-.2.06c-.24,0-.08-.12.01-.18-.22.1-.46.03-.72.01l.1-.04-.33-.02c-.22.07-.52.08-.8.04l.19-.13c-.2-.07-.1.04-.15.06-.31.06-.38-.02-.54-.1-.5.13-.99-.21-1.41-.02Zm-34.18.49l.05.02c-.1.02-.16.04-.05-.02Zm2.72.04c-.33.05-.22-.01-.25-.04.32.03.5,0,.79.04-.05-.02-.05-.06-.07-.08.11,0,.23.03.27.1-.14.13-.88-.08-.74,0Zm-6.13.62s.02-.02.04-.03h0l-.04.03Zm1.62-.11s.06.04.11.05c-.03-.03-.06-.06-.11-.05Zm3.23.16c.07.05.24.04.37.02-.06,0-.16-.02-.37-.02Zm20.38-.06c-.1.02-.28.07-.11.11.08-.04.24.03.3-.04,0,0,.01,0,.02,0-.1-.04-.18-.08-.21-.08Zm9.58-.43c-.02.05-.09.11-.04.15,0,0-.02,0-.03,0,.02.02.04.03.03.04.08.01.16.02.21,0,.03-.17.19-.2-.17-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1059.11,955.54s.07,0,.09,0c-.02,0-.05,0-.09,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1062.46,955.04s-.08-.03-.2-.05c.02.02.08.04.2.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1022.22,954.72l.09-.02-.19-.05c-.32.06-.33.13-.41.21.28-.08.46-.04.82-.06l-.32-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1022.38,955.28s.11.08.16.08l.05-.05-.21-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1026.13,955.53l-.3-.04c-.09.04.25.12.3.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1024.8,954.64l-.16.06c.14.04.33.04.36-.02-.19.03-.05-.03-.21-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1026.94,955.54c.09-.1.3.04.36-.05-.08.03-.35-.05-.36.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1026.73,954.58c-.1-.1-.25-.01-.44-.03.16,0,.38.1.44.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.55,955.25c-.02.07-.14.07-.28.05.05-.02.08-.06.14-.07-.24.06-.25.04-.44.08.19.05.48.08.44.17.14-.07.32-.17.14-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.19,954.57c-.16-.03-.25-.1-.44-.09.03.05.1.12.32.11l-.08.08c.21.06-.08-.11.2-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1029.42,955.45l-.1-.04c-.22.07-.51.03-.63.14.27,0,.6-.05.73-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1027.96,954.72l.03-.12c-.22-.02.02.04-.06.07-.06-.02-.16-.03-.2,0,.25-.02.02.1.24.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1028.69,954.59l.28-.05-.22-.13c-.33.04-.02.07-.06.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1029.04,954.67l.03.02.43-.17c-.25.07-.27.06-.46.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1034.2,955.44c.05-.05-.2-.11-.09-.06-.05.04.28.11.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1033.18,954.49c.12.04.52-.03.69-.07-.21.02-.72,0-.69.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1033.95,954.41s-.04,0-.07.01c.03,0,.05,0,.07-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.26,954.15s.04,0,.05-.01c-.02,0-.03,0-.05.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1041.09,954.18c-.12-.02-.35.01-.39.07.19-.03.35-.04.57-.1-.08,0-.18-.03-.17.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1042.77,954.21c-.09.03-.21.02-.18.06.05.02.24-.03.18-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1054.09,955.68c.16.03.26,0,.21-.07-.18,0-.08.05-.21.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1054.51 955.6 1054.53 955.64 1054.64 955.69 1054.51 955.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1055.62,955.71s-.04.02-.07.03c.06-.01.12-.02.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1055.52,955.74s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1055.45,955.72v.04s.04-.01.07-.02c-.03,0-.06,0-.07-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1055.96,955.72l-.21-.11c-.22.06.25.06.03.18l.18-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1056.7,955.69c.2.04.5-.14.61,0,.57-.07-.13-.22.52-.27-.62-.07-.32.26-.87.18.27.08-.18.07-.27.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1056.6,955.47c-.03.07.22.07.31.03-.07,0-.2-.1-.31-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1057.82 955.63 1058 955.68 1058.04 955.64 1057.82 955.63"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1058.49,955.66l-.17.08c.06-.03.31-.02.17-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1059.42,955.75c.16.03.31-.15-.03-.11h.08s.16.1-.04.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1061.56,955.47c-.11,0-.24.02-.22.06l.3-.04-.08-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1061.52,955.04c-.1-.11-.28,0-.49-.03.23.02.2.04.49.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1061.91,955.63c-.08.04-.21.02-.28,0,.04.06.25.05.28,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1062.39,955.59c.1.04-.02.06.05.09.21.05.44.04.56-.02-.06-.05-.13-.17-.04-.23-.34.04-.51.24-.68.08l-.28.19c.27.03.21-.13.4-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1061.71,955.23l.18.06c-.04-.06.1-.07.2-.09-.05-.14-.28.02-.38.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1064.28 955.51 1064.66 955.47 1064.54 955.47 1064.28 955.51"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1064.53 955.55 1064.54 955.59 1064.83 955.52 1064.53 955.55"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1064.93 955.6 1064.89 955.59 1064.66 955.63 1064.93 955.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1065.74,955.62l-.07-.06c-.1.02-.29-.05-.27.03.08-.03.29-.02.35.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1068.4,954.15c-.07.04-.03.07.01.11l.11-.1s-.1.01-.12,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1068.87,954.31l.29-.11c-.33-.02-.38.07-.66.09.12.04.29-.04.45-.01l-.07.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1074.61,954.39c-.03.07.04.06-.17.11.29-.04.54-.03.88-.04-.06-.05.19-.12.06-.11l-.37.04.06-.05c-.26-.06-.17.08-.45.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.61,955.16s.01.07.06.1c.22-.04-.1-.09-.06-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m836.72,954.88c.33-.09-.11-.03-.52-.02l.52.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m836.21,954.86h-.37c.1,0,.23,0,.37,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m832.8,954.8c.78-.07,1.72.03,2.21-.08-.79-.07-2.01-.04-2.21.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "833.98 954.87 834.07 954.81 833.39 954.9 833.98 954.87"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "834.47 954.93 834.37 954.9 833.29 954.97 834.47 954.93"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m830.15,954.75l.79-.02c.74.08-.49.11,0,.17.98,0,.34-.17,1.56-.15-.1-.08-1.96,0-1.77-.12-1.03-.04-.05.07-.59.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m782.83,955.42s-.07,0-.11-.01c.04.01.09.02.11.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m769.87,955.51c-.18,0-.36-.02-.53-.03.05.01.12.02.21.03h.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m790.94,955.19c.19.01.36.02.51.03-.1-.02-.25-.03-.51-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m708.4,954.74s.06-.02.07-.04c0,0-.01,0-.02,0l-.14.03h.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m755.36,955.7c-.2,0-.4,0-.58.01.34,0,.5,0,.58-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m795.62,955.18c-.07,0-.13,0-.2,0,.06,0,.15,0,.24.01h-.04s0-.01,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.1,955.68c-.18,0-.34-.01-.47-.02.16,0,.32.01.47.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.13,954.62c-.22-.01-.41,0-.57.01.14.02.32.02.57-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.49,954.63h.03s-.04-.01-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.53,954.62h.05s-.05-.02-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m817.56,954.63c-.38-.05-.5-.21-.99-.03l.1.02c-.3-.04-.74.03-1.08.03.04.02.08.03.12.04.17,0,.4,0,.75.02.42.04.69-.05,1.1-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m782.88,955.39s.36.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.87,955.26c-.13,0-.26,0-.39,0,.13,0,.25.01.39,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m801.93,955.31s-.05,0-.07,0c-.02.02.04.02.07,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.12,955.25h.36c-.11,0-.23,0-.36,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m797.41,955.21s-.04,0-.06,0c.02,0,.04,0,.06,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m646.5,954.19c.3-.01.48.03.77.04.64-.11-1.32,0-.39-.1-.28,0-.51.02-.72.03l.41.11c.56-.04-.38-.04-.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m704.63,954.52h.13c-.09-.04,0-.05-.5-.08-.42.07.24.19-.5.27.14,0,.36,0,.56,0-.3-.07,0-.14.32-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m704.31,954.71h.02s.11.03.11.03c.11,0,.21,0,.29.01-.08-.02-.24-.04-.42-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m656.55,954.24c.12,0,.24,0,.34.01-.16-.02-.26-.02-.34-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m756.29,954.33c.15-.01.29-.02.41-.03-.22,0-.33.02-.41.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m711.79,954.63c.12,0,.23.01.36.02.07,0,.14,0,.23,0h-.58Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m687.95,955.66c.26-.12-.2,0-.7-.06l-.47.07c.43.02.83,0,1.18,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m646.13,954.16s0,0,0,.01c.01,0,.02,0,.04,0h-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m673.94,955.69c-.08,0-.15-.01-.23-.02.05,0,.12.01.23.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m707.12,954.77h1.8s-.53-.02-.53-.02c-.25.06-1.03-.05-1.28.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m695.64,955.73l.16.07c1.79-.16,3.85.07,5.28-.15,2.18.26,1.43-.23,3.44,0l-.07-.04c6.59.04,13.58.18,19.73.05v.05c9.91.09,19.58-.02,29.42.02.92-.05.36-.16,1.16-.22.34,0,1.12,0,1.12.06-.67.04-.29.09-.52.12,1.11,0,2.54.07,3.52-.01l-.83-.08c.38-.03.99-.01,1.33,0-.15.04.36.13.06.15,2.08-.21,1.62.09,3.38,0,.35-.18,2.54-.32,3.99-.45l.76.05c-1.01,0,.02.13-1.23.12,1.04.05,2.01-.02,3,0-.19-.04-.14-.1.25-.12.61.02.66.11,1.35.12l-.68.06c.46.07.86-.02,1.29-.03.14.07,1.17.09.99.17.93-.1,1.26-.04,2.27-.11-1.04-.08.27-.1.15-.16l-1.18.03c1.66.05-.54.01-.42.14-.78-.06,1.07-.21-.24-.19,1.56-.06,1.89,0,3.49-.11-.96.02.18-.08-.33-.12,1.22,0,.3.04.68.12.67,0,.91.07,1.52-.02,1.08.04-.16.09.38.15-.4.09-3-.11-2.71.17-.56,0-1.25.11-2.06.1.71.04,1.72.13,2.6.06l.04-.16c.67,0,.8-.11,1.28-.1-.25.04.2.11.74.1-.15-.02-.37-.02-.31-.04.99-.01,1.13-.12,2.31-.15-.97-.04-1.17-.09-2.08-.15.24-.11.64-.02,1.18-.03-.08.02-.19.02-.03.04l.57-.05c1.21.05-.15.16.85.21.69.09.95-.05,1.48,0-.04,0-.07-.02-.1-.03.12,0,.2,0,.26,0h0c.64-.02,1.33-.01,1.52-.1.07.04.56-.01.77-.04.36-.03,1.22-.13,1.75,0h-.04c.8.02,1.43.06,1.25.1l1.29.03-.14.11c1.18-.03,1.06-.09,1.87-.2.84.06,2.32.01,2.88-.03.09,0,.24,0,.47,0l-.49-.04c.92,0,.81-.05,1.42-.05-.13,0-.14-.02.2,0,.1,0,.21,0,.35,0-.03.01-.17,0-.3,0l.11.04c.74.11,1.13-.06,1.91-.02-.08,0-.2,0-.28.01.44.03,1.08.18,1.26.09.1.01.26,0,.41-.03l.33.02c-.13,0-.23-.01-.32-.02.2-.03.39-.07.42-.05l1.13.02c.21.02.51,0,.74-.01l.19.04c.41,0,.41.02.37.03,1.43.15,2.21-.08,3.75.05.29-.07-.34-.11-.39-.15.24-.06,1.12-.11,1.57-.15.69.1,2.8.19,2.46.34,1.27.01-.4-.09.24-.14h.15c-.44-.01-.78-.06-1.03-.12-.1-.08,1.03-.1,1.37-.08l-.24.11c1.17-.04.93-.21,1.66-.32.93.04.4.15.59.25l.98-.03v.08c.64-.02.79-.1,1.67-.07-.64.08,1.32.08.44.19.49.03.63-.13.88-.02.34-.09-.44-.04-.69-.07-.2-.13,1.08-.06,1.67-.1.05.07-.39.08.3.12.14-.05.58-.09.98-.03,0-.08.79-.02,1.18-.01-.44-.02-1.08-.08-.79-.15.34-.03.64-.05,1.42-.04l-.54-.04c.68-.12,1.13.09,2.06.05-.39.05-.64.05-.98.11.45-.03,1.28-.09,1.96-.14l.79.12c.1-.06.88,0,.88-.08.98.06-.79.1-.88.16,1.23.06.98-.14,2.16-.01l-.39.08c.39,0,1.18-.04,1.23,0,0-.03-.2-.02-.44-.02.24-.17,1.81-.12,1.67-.29h-.54c.83-.05,1.42-.16,2.06-.1.49.06-.34.12-.63.16.78.01.63-.19,1.57-.17-.49-.03-.4-.09-.1-.13-.54-.01-1.67-.04-1.47.03l.2.02s-.34.06-.49.08c-.74,0-.34-.08-.49-.11-1.23-.03-.1.17-1.22.17l-.15-.03c-.54.04-1.37.05-1.52.16-.49-.11-1.27.04-1.81-.02-.1-.25,1.91.02,2.55-.12-.59-.05.34-.12.58-.17l-1.86.11c-.15-.03-.69-.16-1.03-.07h.15c-.74.03-.54.13-1.18.1-.1-.02.1-.06.15-.08-.59-.02-.49.06-.88.08-.59-.02.29-.1-.2-.13-.68.1-1.08-.02-1.67-.02.25.14-2.35.19-1.07.31l-1.42.1c-.44-.07.98-.2.58-.31h1.13c-.19-.17-2.37.12-3.11-.08-.6,0-.46.02-1.6-.07l.2.16c-.59-.04-.78-.12-.81-.15-.35.01-.66,0-.98,0,.08-.02.21-.04.42-.05-.45-.09-.58-.05-.73,0-.24.04-.61.03-.98.03l.33-.06c-.23.01-.5.03-.53.06-.15,0-.3,0-.44.01.1.03.34.12.88.16-1.37-.06-2.45-.03-3.63-.16.04-.04.54-.1.39-.11-.59-.02-1.23.06-1.17.12-.13,0-.24,0-.33,0-.11-.04-.25-.08-.53-.09-.06-.01-.17-.03-.37-.03-.2.12-1.32.06-1.57.12.27.01.59.01.92,0-.47.08-.9.18-1.26.11.88-.08-.94-.13.39-.16-.93-.16-.49.11-1.47.06l-.64-.06c.1-.09,1.03-.05.88-.08h-.44c.44-.06,2.11-.01,3.14-.11l-2.06-.05c-2.6.11-5.84-.02-8.04.18h.09s-.06.02-.09.06l-.1-.02-.44.07c-.5-.08-1.42-.1-2.21-.17q.5.06.54.12c-.1.09-.18.13-.91.1,0-.06.45-.06-.1-.11.28.03.03.08-.29.08-.41-.04-1.11-.05-1.11-.11.19-.02.35,0,.48.01.19-.02-.78-.06-.21-.11l-.75.02c-.44-.05.29-.08.12-.12-1.25.04-1.88.19-3.01.23.05-.03.07-.18.05-.14-.87-.04-1.86.16-2.85.17.15-.04.51-.03.81-.05-3.02-.05-5.49-.06-8.33-.19l-.74.15-.74-.1c-2.98-.09-5.27,0-8.1.04-.88,0-.53-.1-.95-.14-1.94-.02-2.41.15-4.26.18.25-.04.69-.17-.11-.18-.15.04-.24.11-.75.08l.25-.05c-.46-.07-.9,0-1.85-.03-1.68,0-3.28.11-4.66.27-1.48-.01.15-.16-.13-.19,1.05.05.73-.03.95-.08-.55.04-1.22.07-1.51-.04-.77,0-1.12,0-1.88.07.38-.04.71.02.35.07-.63-.04-2.24,0-2.15-.13-3.66,0-7.74,0-11.66,0-.66.07.5.03.14.07-.96.09-.76-.05-1.53.02l.32-.07c-1.14-.01-2.36.12-3.46.19.18-.08-.91-.07.01-.12-.54.01-1.2-.35-1.62-.28l.61.34s-.79.01-.71.04c-.47-.07-1.05-.15-1.38-.15-.16-.09.66-.07,1.11-.07.07-.14-1.52-.09-.86-.22-.96.02.14.07-.44.13l-.84-.03.65.05c-.7.04-.94.15-1.88.07l-.97.14c-.1-.11-.71-.02-1.21-.05l.31-.07c-.67,0-.92-.02-1.34-.06.37-.1.6.02.76-.07l-.73-.03c0,.06-.46.11.06.15-.68.12-1.05.22-2.75.21-.77-.11.83-.1.51-.21-1.76-.05-2.16.28-3.19.27-1.32-.04-1.24.06-2.57.06.42-.07-.93-.08-1.18-.15l.53-.08c-.41.02-.79,0-.68-.06.08.1-1.73.09-2.65.14l.16.09c-.72.03-1.71.08-2.48.06-1.13.03-.88.1-1.75.2-.48-.08-.43-.17-.27-.26.3.04.82.02,1.32.04,1.43-.07,2.55-.26,3.98-.21.62-.21-.96.02-1.66-.05.02-.01.07-.02.12-.02-.06,0-.11,0-.17,0,.51-.03,1.35-.06,1.49-.17-.86.02-.62.21-1.69.12-.79.06-1.43-.11-1.91-.12-.53.08-.55.24-1.84.21l.57-.12c-1.46,0-.69.17-2.04.17.48.01-.46.11.45.12-.45.06-1.43.07-2.17.04-.19.02-.04.04-.08.08.82.08,1.29-.08,1.96.04l.57-.13c.76.05.84.15.37.2.21,0,.4-.02.56,0,.13.19-.91-.07-1.17.09h.54c.23.11-1.25.09-1.94.09-.78-.06-1.5-.08-1.55-.17l1.05-.04c-.54-.07-1.34.04-1.95.04-.04-.01-.1-.02-.17-.03.03,0,.05.02.05.02-.13,0-.24-.02-.34-.04-.54,0-1.32.05-1.82.02l.06.08.07-.04c.49,0,1.16.05.78.11-1.11.06-1.33-.1-1.59-.17.25-.12,1.08,0,1.64-.04-.34-.12-1.12-.01-2.27-.09.46-.13,1.32,0,1.58-.12-.92-.02-1.16.07-2.13.04.12-.06,1.07-.07,1.01-.15l-.62-.04c1.53,0-.27-.16.92-.2-.56-.05-.78.11-1.58.02.22.06.86.16.1.21l-.86-.04c-.36-.06.9-.14.34-.19l-.9.04s.46.06.19.11c-.52-.04-.86.15-1.47.21-.49,0-.88-.01-1.05-.06-1.24.12-2.8.11-3.94.22.78-.08-.03-.14-.5-.19.89-.02.9-.14.84-.22-.54.01-.9.14-.63.18-.91-.05-.63.09-1.43,0-.52-.04.26-.12.08-.17-.98,0-.27.15-1.33.12.06-.02.16-.02.07-.04-.58-.03-1.2.03-1.32.09-.61-.16-1.73.02-1.61-.14-1.39.04.21.09-.07.14-.57.07-1.62.01-1.95-.01.34,0,.66-.05.99-.02l-.29-.11c-1.73-.08-1.1.25-2.77.15.86-.06.29-.08.71-.16-.26.03-1.57,0-.78.08-.63,0-1.07-.03-1.5-.05-.56.04-1.16.07-1.49.14-.88-.01-1.53-.09-1.95-.14-1.85.08-3.56-.06-5.51.03h.14c-1.51-.01.67.15-.9.15.21-.13-.94-.09-1.45-.16-1.93-.07-3.33.1-5.11,0,.01-.03.13-.06.47-.06-1.36-.04-2.45-.02-3.67-.02l.05-.02c-1.96-.11-3.74.02-5.77.05.16-.02.21-.07.33-.08-1.02-.03-2.66-.05-3.37.07-1.21-.13-.8.04-2.37-.09-.09-.02.16-.02.26-.03-.77-.04-1.31-.03-2.09-.05-1.71.08-2.14.26-4.13.21-.1-.18,1.22-.04,1.27-.19-.4.03-.74.07-1.29.03.33-.07.07-.04.3-.11-.21-.02-.63.02-1,.07-.37.05-.68.1-.68.1-.02.04.12.05.51.05-.46.11-1.96,0-2.92.05.31,0,1.3.04.93.12-1.29-.04-1.72.14-2.63.21-1.19-.08.88-.15.65-.28-.2-.05-.68-.15-.18-.2-1.07-.03-1.84.08-2.8.11l.03-.04c-1.33.01-2.76.17-3.88.1l.59.04c-.22.02-.89.01-1.26.08.04-.06-.83-.11-.47-.16-.59.19-3.03.12-3.7.3-.36-.05-.07-.13.04-.17.84.02,1.13.05,1.57-.02-.7,0-1.21-.05-1.11-.09-.7.12-2.37.17-2.72.28-.51-.06-1-.09-.82-.19-2.15.06,1.06.31-1.36.3-1.11-.1,1.08-.13-.45-.16l.28-.02c-1.1-.26-.77.18-2.02.17-.17-.14.87-.1,0-.2-1.14.04-1.64.24-2.79.2l.18-.06c-.73,0-2.15,0-2.88,0-.03-.03.07-.02.21-.03-1.35-.05-.56.07-1.67-.02l-.32.07c.55.05,1.62.12,2.32.04-.7.08,1.1.18.75.29l.14-.05c1.83.2,4.19.23,6.51.31,1.46-.14,2.49.06,4.06-.04.24-.16.29-.03,1.64-.07-.71.02-.08.12.37.15.26-.04.58-.06.9-.07.27.06,1.97.19,2.59.08.82.05-.19.05-.37.09.33.08.67-.06.94,0,0,0-.01.02-.1.03,1.26,0,2.01.04,3.31.06.11-.16,1.28-.06,1.87-.12-.19.05.74.06,1.11.09l.7-.12c.69-.1.96.07,1.86.02l-.22-.03c.66-.05,2.38.05,3.02.13,6.05-.31,9.35.17,15.73.09.41-.05-.3-.08.02-.15.65-.02.79-.01,1.38-.01-.52-.04-.44.01-.37-.03l-.9.04s.06-.02-.03-.04c-.3.02-.66.05-1.05.04.56-.04.71-.16,1.48-.11-.06.02-.16.02-.36.03.63,0,.66-.05,1.14-.02.58.03.44-.01.51.04l1.8.06c.9-.14,2,0,2.29,0-.2.11-1.19.03-1.63.14l.65.08.04-.08.92.02-.05.02c.11-.03.22-.07.46-.04.04.01.13.03.03.04l.66-.05c-.38.09.58.03.48.13,2.15.05,2.73-.14,4.63,0-.31-.05.6-.16,1.18-.14.34.02.42.05.21.09l.76-.05c.96.16,1.89.06,3.29.11l-.07.04c.52-.05,1.08-.09,1.86-.08l-.14.09c.95.06.73-.19,1.78-.13,0-.1-.67-.14-.77-.23.25.1,1.38.11,1.12.04,1.05-.04.73,0,.82.03l.62-.06c.74,0,.24.12-.04.18.69-.1,1.44-.03,2.22-.01l-.32.04,1.03.02c.67-.07,1.61-.08,2.47-.04l-.6.13c.61.07.31-.04.47-.06.96-.06,1.16.02,1.67.1,1.54-.13,3.06.21,4.38.02Zm105.92-.49l-.14-.02c.32-.02.5-.04.14.02Zm-8.44-.04c1.02-.05.69.01.77.04-1-.03-1.56,0-2.44-.04.14.02.17.06.22.08-.35,0-.71-.03-.83-.1.44-.13,2.72.08,2.28,0Zm19-.62s-.08.02-.12.03h0l.12-.03Zm-5.03.11c-.07-.03-.2-.04-.35-.05.09.03.18.06.35.05Zm-10.01-.16c-.23-.05-.76-.04-1.14-.02.18,0,.5.01,1.14.02Zm-63.15.06c.3-.02.87-.07.35-.11-.25.05-.73-.03-.94.04-.03,0-.03,0-.05,0,.3.04.55.08.64.08Zm-29.69.43c.05-.05.28-.11.13-.15.03,0,.06,0,.08,0-.08-.02-.14-.03-.08-.04-.24-.01-.5-.02-.67,0-.08.17-.59.2.53.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m714.16,954.34c-.12,0-.2,0-.28,0,.08,0,.16,0,.28,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m703.77,954.84s.26.03.61.05c-.07-.02-.24-.04-.61-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m828.49,955.16l-.29.02.59.05c.98-.06,1.03-.13,1.27-.21-.88.08-1.42.04-2.55.06l.98.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.99,954.6c-.1-.02-.34-.08-.49-.08l-.15.05.64.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m816.36,954.35l.93.04c.29-.04-.79-.12-.93-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.49,955.24l.49-.06c-.44-.04-1.03-.04-1.13.02.59-.03.15.03.64.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.85,954.34c-.29.1-.93-.04-1.12.05.24-.03,1.08.05,1.12-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.51,955.3c.3.1.79.01,1.38.03-.49,0-1.18-.1-1.38-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.86,954.63c.05-.07.44-.07.88-.05-.15.02-.24.06-.44.07.74-.06.79-.04,1.37-.08-.59-.05-1.47-.08-1.38-.17-.44.07-.98.17-.44.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.09,955.31c.49.03.79.1,1.37.09-.1-.05-.3-.12-.99-.11l.25-.08c-.64-.06.25.11-.63.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m806.15,954.43l.3.04c.69-.07,1.57-.03,1.96-.14-.83,0-1.86.05-2.25.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.68,955.16l-.09.12c.69.02-.05-.04.2-.07.2.02.49.03.63,0-.78.02-.05-.1-.74-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m808.43,955.29l-.88.05.69.13c1.03-.04.05-.07.19-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m807.35,955.21l-.1-.02-1.32.17c.79-.07.83-.06,1.42-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m791.35,954.44c-.15.05.62.11.29.06.15-.04-.88-.11-.29-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m794.5,955.39c-.38-.04-1.61.03-2.15.07.64-.02,2.24,0,2.15-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m792.14,955.47s.13,0,.22-.01c-.1,0-.17.01-.22.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m769.46,955.73c-.06,0-.11,0-.16.01.06,0,.11,0,.16-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m770,955.7c.37.02,1.09-.01,1.22-.07-.58.03-1.08.04-1.76.1.25,0,.56.03.54-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m764.8,955.67c.27-.03.64-.02.55-.06-.15-.02-.73.03-.55.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m729.72,954.2c-.5-.03-.79,0-.66.07.56,0,.25-.04.66-.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "728.42 954.28 728.35 954.24 728.02 954.19 728.42 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m724.96,954.17s.11-.02.21-.03c-.2,0-.36.02-.21.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m725.27,954.14s-.07,0-.1,0c.03,0,.07,0,.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m725.5,954.16l.04-.04c-.06,0-.16,0-.27.02.09,0,.19,0,.23.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m723.93,954.16l.66.11c.68-.06-.78-.06-.1-.18l-.55.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m721.63,954.19c-.63-.04-1.54.14-1.89,0-1.78.07.41.22-1.63.27,1.93.07.98-.26,2.69-.18-.83-.08.55-.07.83-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m721.94,954.41c.1-.07-.7-.07-.95-.03.23,0,.63.1.95.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "718.15 954.25 717.61 954.2 717.46 954.24 718.15 954.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m716.09,954.22l.53-.08c-.17.03-.97.02-.53.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m713.21,954.13c-.5-.03-.95.15.1.11h-.24c.06-.03-.5-.1.14-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m706.56,954.41c.34,0,.75-.02.68-.06l-.94.04.26.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m706.7,954.84c.32.11.88,0,1.51.03-.71-.02-.63-.04-1.51-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m705.48,954.25c.25-.04.65-.02.88,0-.12-.06-.76-.05-.88,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m703.98,954.29c-.31-.04.07-.06-.16-.09-.66-.05-1.35-.04-1.73.02.17.05.41.17.14.23,1.05-.04,1.59-.24,2.11-.08l.88-.19c-.84-.03-.65.13-1.23.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m706.11,954.65l-.56-.06c.11.06-.31.07-.61.09.15.14.86-.02,1.18-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "698.14 954.37 696.95 954.41 697.33 954.41 698.14 954.37"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "697.37 954.33 697.34 954.29 696.43 954.36 697.37 954.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "696.12 954.28 696.26 954.29 696.97 954.25 696.12 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m693.63,954.26l.22.06c.3-.02.91.05.85-.03-.26.03-.89.02-1.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m685.36,955.73c.22-.04.09-.07-.04-.11l-.34.1c.1,0,.3-.01.39,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m683.91,955.57l-.89.11c1.02.02,1.17-.07,2.06-.09-.38-.04-.91.05-1.38.01l.21-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m666.13,955.49c.08-.07-.12-.06.54-.11-.9.04-1.68.03-2.72.04.18.05-.6.12-.2.11l1.16-.04-.17.05c.81.06.53-.08,1.4-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.65,954.72c.11-.04-.03-.07-.17-.1-.69.04.31.09.17.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m600.3,954.88c.02-.09,0-.03-.03-.02l.03.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m600.27,954.86h-.02s.01,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m600.05,954.8c.05-.07.11.03.14-.08-.05-.07-.13-.04-.14.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "600.13 954.87 600.13 954.81 600.09 954.9 600.13 954.87"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "600.16 954.93 600.15 954.9 600.08 954.97 600.16 954.93"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.89,954.75l.05-.02c.05.08-.03.11,0,.17.06,0,.02-.17.1-.15,0-.08-.12,0-.11-.12-.06-.04,0,.07-.04.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m596.93,955.42s0,0,0-.01c0,.01,0,.02,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m596.11,955.51s-.02-.02-.03-.03c0,.01,0,.02.01.03h.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.43,955.19s.02.02.03.03c0-.02-.02-.03-.03-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.27,954.74s0-.02,0-.04c0,0,0,0,0,0v.03s0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m595.21,955.7s-.03,0-.04.01c.02,0,.03,0,.04-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.73,955.18s0,0-.01,0c0,0,0,0,.02.01h0s0-.01,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m596.38,955.68s-.02-.02-.03-.02c.01.01.02.01.03.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.14,954.62s-.03,0-.04.01c0,.02.02.02.04-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.85,954.63s0,0,0,0c0-.02,0-.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.66,954.62s0,0,0,0c0-.01,0-.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.1,954.63s-.03-.21-.06-.03v.02s-.04.03-.06.03c0,.02,0,.03,0,.04.01,0,.03,0,.05.02.03.04.04-.05.07-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m596.93,955.39s.02.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.18,955.26s-.02,0-.02,0c0,0,.02.01.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.12,955.31s0,0,0,0c0,.02,0,.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.13,955.25s.02,0,.02,0c0,0-.01-.01-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.84,955.21s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m588.39,954.19s.03.03.05.04c.04-.11-.08,0-.02-.1-.02,0-.03.02-.04.03l.03.11s-.02-.04,0-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.03,954.52h0s0-.05-.03-.08c-.03.07.01.19-.03.27,0,0,.02,0,.03,0-.02-.07,0-.14.02-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.01,954.71s0,0,0,0c0,.01,0,.02,0,.03,0,0,.01,0,.02.01,0-.02-.02-.04-.03-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m589.02,954.24s.01,0,.02.01c-.01-.02-.02-.02-.02-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m595.26,954.33s.02-.02.03-.03c-.01,0-.02.02-.03.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.48,954.63s.01.01.02.02c0,0,0,0,.01,0h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m590.99,955.66c.02-.12-.01,0-.04-.06l-.03.07s.05,0,.07,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m588.37,954.16s0,0,0,.01c0,0,0,0,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m590.11,955.69s0-.01-.01-.02c0,0,0,.01.01.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.19,954.77h.11s-.03-.02-.03-.02c-.02.06-.06-.05-.08.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m591.47,955.73v.07c.12-.16.25.07.34-.15.14.26.09-.23.22,0v-.04c.41.04.85.18,1.23.05v.05c.62.09,1.23-.02,1.84.02.06-.05.02-.16.07-.22.02,0,.07,0,.07.06-.04.04-.02.09-.03.12.07,0,.16.07.22-.01l-.05-.08s.06-.01.08,0c0,.04.02.13,0,.15.13-.21.1.09.21,0,.02-.18.16-.32.25-.45l.05.05c-.06,0,0,.13-.08.12.07.05.13-.02.19,0-.01-.04,0-.1.02-.12.04.02.04.11.08.12l-.04.06c.03.07.05-.02.08-.03,0,.07.07.09.06.17.06-.1.08-.04.14-.11-.07-.08.02-.1,0-.16l-.07.03c.1.05-.03.01-.03.14-.05-.06.07-.21-.01-.19.1-.06.12,0,.22-.11-.06.02.01-.08-.02-.12.08,0,.02.04.04.12.04,0,.06.07.1-.02.07.04-.01.09.02.15-.02.09-.19-.11-.17.17-.04,0-.08.11-.13.1.04.04.11.13.16.06v-.16s.05-.11.08-.1c-.02.04.01.11.05.1,0-.02-.02-.02-.02-.04.06-.01.07-.12.14-.15-.06-.04-.07-.09-.13-.15.02-.11.04-.02.07-.03,0,.02-.01.02,0,.04l.04-.05c.08.05,0,.16.05.21.04.09.06-.05.09,0,0,0,0-.02,0-.03,0,0,.01,0,.02,0,0,0,0,0,0,0,.04-.02.08,0,.09-.09,0,.04.04-.01.05-.04.02-.03.08-.13.11,0,0,0,0,0,0,0,.05.02.09.06.08.1l.08.03v.11c.07-.03.06-.09.11-.2.05.06.15.01.18-.03,0,0,.01,0,.03,0l-.03-.04c.06,0,.05-.05.09-.05,0,0,0-.02.01,0,0,0,.01,0,.02,0,0,.01-.01,0-.02,0v.04c.05.11.08-.06.13-.02,0,0-.01.01-.02.01.03.03.07.18.08.09,0,.01.02,0,.03-.03l.02.02s-.01-.01-.02-.02c.01-.03.02-.07.03-.05l.07.02s.03,0,.05-.01v.04s.04.02.03.03c.09.15.14-.08.24.05.02-.07-.02-.11-.02-.15.02-.06.07-.11.1-.15.04.1.18.19.15.34.08.01-.02-.09.02-.14h0s-.05-.06-.06-.12c0-.08.06-.1.09-.08l-.02.11c.07-.04.06-.21.1-.32.06.04.02.15.04.25l.06-.03v.08s.05-.1.1-.07c-.04.08.08.08.03.19.03.03.04-.13.06-.02.02-.09-.03-.04-.04-.07-.01-.13.07-.06.1-.1,0,.07-.02.08.02.12,0-.05.04-.09.06-.03,0-.08.05-.02.07-.01-.03-.02-.07-.08-.05-.15.02-.03.04-.05.09-.04l-.03-.04c.04-.12.07.09.13.05-.02.05-.04.05-.06.11.03-.04.08-.1.12-.14l.05.12c0-.06.06,0,.06-.08.06.06-.05.1-.06.16.08.06.06-.14.14-.01l-.02.08s.07-.04.08,0c0-.03-.01-.02-.03-.02.01-.17.11-.12.1-.29h-.03c.05-.05.09-.16.13-.1.03.06-.02.12-.04.16.05.01.04-.19.1-.17-.03-.03-.02-.09,0-.13-.03-.01-.1-.04-.09.03v.02s0,.06-.02.08c-.05,0-.02-.08-.03-.11-.08-.03,0,.17-.08.17v-.03s-.1.05-.1.16c-.03-.11-.08.04-.11-.02,0-.25.12.02.16-.12-.04-.05.02-.12.04-.17l-.12.11s-.04-.16-.06-.07h0s-.03.13-.07.1c0-.02,0-.06,0-.08-.04-.02-.03.06-.06.08-.04-.02.02-.1-.01-.13-.04.1-.07-.02-.1-.02.02.14-.15.19-.07.31l-.09.1c-.03-.07.06-.2.04-.31h.07c-.01-.17-.15.12-.19-.08-.04,0-.03.02-.1-.07v.16s-.04-.12-.04-.15c-.02.01-.04,0-.06,0,0-.02.01-.04.03-.05-.03-.09-.04-.05-.05,0-.01.04-.04.03-.06.03l.02-.06s-.03.03-.03.06c0,0-.02,0-.03.01,0,.03.02.12.05.16-.09-.06-.15-.03-.23-.16,0-.04.03-.1.02-.11-.04-.02-.08.06-.07.12,0,0-.01,0-.02,0,0-.04-.02-.08-.03-.09,0-.01-.01-.03-.02-.03-.01.12-.08.06-.1.12.02.01.04.01.06,0-.03.08-.06.18-.08.11.06-.08-.06-.13.02-.16-.06-.16-.03.11-.09.06l-.04-.06c0-.09.06-.05.06-.08h-.03c.03-.06.13-.01.2-.11l-.13-.05c-.16.11-.37-.02-.5.18,0,0,0,0,0,0,0,0,0,.03,0,.06v-.02s-.03.07-.03.07c-.03-.08-.09-.1-.14-.17q.03.06.03.12c0,.09-.01.13-.06.1,0-.06.03-.06,0-.11.02.03,0,.08-.02.08-.03-.04-.07-.05-.07-.11.01-.02.02,0,.03.01.01-.02-.05-.06-.01-.11l-.05.02c-.03-.05.02-.08,0-.12-.08.04-.12.19-.19.23,0-.03,0-.18,0-.14-.05-.04-.12.16-.18.17,0-.04.03-.03.05-.05-.19-.05-.34-.06-.52-.19l-.05.15-.05-.1c-.19-.09-.33,0-.51.04-.06,0-.03-.1-.06-.14-.12-.02-.15.15-.27.18.02-.04.04-.17,0-.18,0,.04-.02.11-.05.08l.02-.05c-.03-.07-.06,0-.12-.03-.1,0-.21.11-.29.27-.09-.01,0-.16,0-.19.07.05.05-.03.06-.08-.03.04-.08.07-.09-.04-.05,0-.07,0-.12.07.02-.04.04.02.02.07-.04-.04-.14,0-.13-.13-.23.03-.48,0-.73,0-.04.07.03.03,0,.07-.06.09-.05-.05-.1.02l.02-.07c-.07-.01-.15.12-.22.19.01-.08-.06-.07,0-.12-.03.01-.08-.35-.1-.28l.04.34s-.05.01-.04.04c-.03-.07-.07-.15-.09-.15-.01-.09.04-.07.07-.07,0-.14-.09-.09-.05-.22-.06.02,0,.07-.03.13l-.05-.03.04.05s-.06.15-.12.07l-.06.14c0-.11-.04-.02-.08-.05l.02-.07s-.06-.02-.08-.06c.02-.1.04.02.05-.07l-.05-.03c0,.06-.03.11,0,.15-.04.12-.07.22-.17.21-.05-.11.05-.1.03-.21-.11-.05-.14.28-.2.27-.08-.04-.08.06-.16.06.03-.07-.06-.08-.07-.15l.03-.08s-.05,0-.04-.06c0,.1-.11.09-.17.14v.09s-.1.08-.15.06c-.07.03-.05.1-.11.2-.03-.08-.03-.17-.02-.26.02.04.05.02.08.04.09-.07.16-.26.25-.21.04-.21-.06.02-.1-.05,0-.01,0-.02,0-.02,0,0,0,0-.01,0,.03-.03.08-.06.09-.17-.05.02-.04.21-.11.12-.05.06-.09-.11-.12-.12-.03.08-.03.24-.12.21l.04-.12c-.09,0-.04.17-.13.17.03.01-.03.11.03.12-.03.06-.09.07-.14.04-.01.02,0,.04,0,.08.05.08.08-.08.12.04l.04-.13s.05.15.02.2c.01,0,.02-.02.03,0,0,.19-.06-.07-.07.09h.03c.01.11-.08.09-.12.09-.05-.06-.09-.08-.1-.17l.07-.04c-.03-.07-.08.04-.12.04,0-.01,0-.02-.01-.03,0,0,0,.02,0,.02,0,0-.02-.02-.02-.04-.03,0-.08.05-.11.02v.08s0-.04,0-.04c.03,0,.07.05.05.11-.07.06-.08-.1-.1-.17.02-.12.07,0,.1-.04-.02-.12-.07-.01-.14-.09.03-.13.08,0,.1-.12-.06-.02-.07.07-.13.04,0-.06.07-.07.06-.15l-.04-.04c.1,0-.02-.16.06-.2-.04-.05-.05.11-.1.02.01.06.05.16,0,.21l-.05-.04c-.02-.06.06-.14.02-.19l-.06.04s.03.06.01.11c-.03-.04-.05.15-.09.21-.03,0-.06-.01-.07-.06-.08.12-.18.11-.25.22.05-.08,0-.14-.03-.19.06-.02.06-.14.05-.22-.03.01-.06.14-.04.18-.06-.05-.04.09-.09,0-.03-.04.02-.12,0-.17-.06,0-.02.15-.08.12,0-.02,0-.02,0-.04-.04-.03-.07.03-.08.09-.04-.16-.11.02-.1-.14-.09.04.01.09,0,.14-.04.07-.1.01-.12-.01.02,0,.04-.05.06-.02l-.02-.11c-.11-.08-.07.25-.17.15.05-.06.02-.08.04-.16-.02.03-.1,0-.05.08-.04,0-.07-.03-.09-.05-.03.04-.07.07-.09.14-.05-.01-.1-.09-.12-.14-.12.08-.22-.06-.34.03h0c-.09-.01.04.15-.06.15.01-.13-.06-.09-.09-.16-.12-.07-.21.1-.32,0,0-.03,0-.06.03-.06-.08-.04-.15-.02-.23-.02v-.02c-.12-.11-.23.02-.36.05.01-.02.01-.07.02-.08-.06-.03-.17-.05-.21.07-.08-.13-.05.04-.15-.09,0-.02,0-.02.02-.03-.05-.04-.08-.03-.13-.05-.11.08-.13.26-.26.21,0-.18.08-.04.08-.19-.02.03-.05.07-.08.03.02-.07,0-.04.02-.11-.03-.05-.11.19-.11.17,0,.04,0,.05.03.05-.03.11-.12,0-.18.05.02,0,.08.04.06.12-.08-.04-.11.14-.16.21-.07-.08.05-.15.04-.28-.01-.05-.04-.15-.01-.2-.07-.03-.12.08-.18.11v-.04c-.08.01-.17.17-.24.1l.04.04s-.06.01-.08.08c0-.06-.05-.11-.03-.16-.04.19-.19.12-.23.3-.02-.05,0-.13,0-.17.05.02.07.05.1-.02-.04,0-.08-.05-.07-.09-.04.12-.15.17-.17.28-.03-.06-.06-.09-.05-.19-.13.06.07.31-.09.3-.07-.1.07-.13-.03-.16l.02-.02c-.07-.26-.05.18-.13.17-.01-.14.05-.1,0-.2-.07.04-.1.24-.17.2v-.06s-.12-.02-.17,0c0-.03,0-.02.01-.03-.08-.05-.04.07-.1-.02l-.02.07s.1.12.15.04c-.04.08.07.18.05.29v-.05c.12.2.27.23.42.31.09-.14.16.06.25-.04.02-.16.02-.03.1-.07-.04.02,0,.12.02.15.02-.04.04-.06.06-.07.02.06.12.19.16.08.05.05-.01.05-.02.09.02.08.04-.06.06,0,0,0,0,.02,0,.03.08,0,.13.04.21.06,0-.16.08-.06.12-.12-.01.05.05.06.07.09l.04-.12c.04-.1.06.07.12.02v-.03s.14.05.18.13c.38-.31.59.17.98.09.03-.05-.02-.08,0-.15.04-.02.05-.01.09-.01-.03-.04-.03.01-.02-.03l-.06.04s0-.02,0-.04c-.02.02-.04.05-.07.04.03-.04.04-.16.09-.11,0,.02,0,.02-.02.03.04,0,.04-.05.07-.02.04.03.03-.01.03.04l.11.06c.06-.14.13,0,.14,0-.01.11-.07.03-.1.14l.04.08v-.08s.06.02.06.02v.02s.01-.07.03-.04c0,.01,0,.03,0,.04l.04-.05c-.02.09.04.03.03.13.13.05.17-.14.29,0-.02-.05.04-.16.07-.14.02.02.03.05.01.09l.05-.05c.06.16.12.06.21.11v.04c.03-.05.06-.09.11-.08v.09c.05.06.04-.19.1-.13,0-.1-.04-.14-.05-.23.02.1.09.11.07.04.07-.04.05,0,.05.03l.04-.06s.01.12,0,.18c.04-.1.09-.03.14-.01l-.02.04.06.02c.04-.07.1-.08.15-.04l-.04.13c.04.07.02-.04.03-.06.06-.06.07.02.1.1.1-.13.19.21.27.02Zm6.63-.49v-.02s.02-.04,0,.02Zm-.53-.04c.06-.05.04.01.05.04-.06-.03-.1,0-.15-.04,0,.02.01.06.01.08-.02,0-.04-.03-.05-.1.03-.13.17.08.14,0Zm1.19-.62s0,.02,0,.03h0v-.03Zm-.31.11s-.01-.04-.02-.05c0,.03.01.06.02.05Zm-.63-.16c-.01-.05-.05-.04-.07-.02.01,0,.03.02.07.02Zm-3.95.06s.05-.07.02-.11c-.02.05-.05-.03-.06.04,0,0,0,0,0,0,.02.04.03.08.04.08Zm-1.86.43c0-.05.02-.11,0-.15,0,0,0,0,0,0,0-.02,0-.03,0-.04-.02-.01-.03-.02-.04,0,0,.17-.04.2.03.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.63,954.34s-.01,0-.02,0c0,0,.01,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m591.98,954.84s.02.03.04.05c0-.02-.02-.04-.04-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.78,955.16l-.02.02.04.05c.06-.06.06-.13.08-.21-.06.08-.09.04-.16.06l.06.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.75,954.6s-.02-.08-.03-.08v.05s.03.03.03.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.02,954.35l.06.04s-.05-.12-.06-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m599.28,955.24l.03-.06s-.06-.04-.07.02c.04-.03,0,.03.04.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.87,954.34c-.02.1-.06-.04-.07.05.02-.03.07.05.07-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.91,955.3c.02.1.05.01.09.03-.03,0-.07-.1-.09-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.56,954.63c0-.07.03-.07.06-.05,0,.02-.02.06-.03.07.05-.06.05-.04.09-.08-.04-.05-.09-.08-.09-.17-.03.07-.06.17-.03.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.82,955.31s.05.1.09.09c0-.05-.02-.12-.06-.11l.02-.08c-.04-.06.02.11-.04.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.39,954.43l.02.04c.04-.07.1-.03.12-.14-.05,0-.12.05-.14.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.67,955.16v.12s0-.04,0-.07c.01.02.03.03.04,0-.05.02,0-.1-.05-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.53,955.29l-.06.05.04.13c.06-.04,0-.07.01-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m598.46,955.21v-.02s-.09.17-.09.17c.05-.07.05-.06.09-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.46,954.44c0,.05.04.11.02.06,0-.04-.06-.11-.02-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.66,955.39s-.1.03-.13.07c.04-.02.14,0,.13-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m597.51,955.47s0,0,.01-.01c0,0-.01,0-.01.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m596.09,955.73s0,0-.01.01c0,0,0,0,.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m596.12,955.7s.07-.01.08-.07c-.04.03-.07.04-.11.1.02,0,.04.03.03-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m595.8,955.67s.04-.02.03-.06c0-.02-.05.03-.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.6,954.2s-.05,0-.04.07c.04,0,.02-.04.04-.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "593.52 954.28 593.52 954.24 593.49 954.19 593.52 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.3,954.17s0-.02.01-.03c-.01,0-.02.02-.01.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.32,954.14s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.34,954.16v-.04s0,.01-.01.02c0,0,.01,0,.01.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.24,954.16l.04.11c.04-.06-.05-.06,0-.18l-.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.1,954.19s-.1.14-.12,0c-.11.07.03.22-.1.27.12.07.06-.26.17-.18-.05-.08.03-.07.05-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m593.11,954.41c0-.07-.04-.07-.06-.03.01,0,.04.1.06.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "592.88 954.25 592.84 954.2 592.83 954.24 592.88 954.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.75,954.22l.03-.08s-.06.02-.03.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.57,954.13s-.06.15,0,.11h-.02s-.03-.1,0-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.15,954.41s.05-.02.04-.06l-.06.04.02.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.16,954.84c.02.11.06,0,.09.03-.04-.02-.04-.04-.09-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.08,954.25s.04-.02.06,0c0-.06-.05-.05-.06,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m591.99,954.29s0-.06-.01-.09c-.04-.05-.08-.04-.11.02.01.05.03.17,0,.23.07-.04.1-.24.13-.08l.06-.19c-.05-.03-.04.13-.08.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m592.12,954.65l-.04-.06c0,.06-.02.07-.04.09,0,.14.05-.02.07-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "591.62 954.37 591.55 954.41 591.57 954.41 591.62 954.37"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "591.58 954.33 591.57 954.29 591.52 954.36 591.58 954.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "591.5 954.28 591.51 954.29 591.55 954.25 591.5 954.28"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m591.34,954.26v.06s.07.05.07-.03c-.02.03-.06.02-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m590.82,955.73s0-.07,0-.11l-.02.1s.02-.01.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m590.73,955.57l-.06.11c.06.02.07-.07.13-.09-.02-.04-.06.05-.09.01v-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m589.62,955.49c0-.07,0-.06.03-.11-.06.04-.11.03-.17.04.01.05-.04.12-.01.11l.07-.04v.05c.04.06.02-.08.08-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m586.71,954.72s0-.07-.01-.1c-.04.04.02.09.01.1Z"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "424.16 952.84 424.06 952.72 423.79 953.05 424.16 952.84"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m422.39,953.57c.05.06.03.16.08.22l1.04-.93c-.46-.53-.81,1.07-1.12.71Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m422.09,953.47c-.4-.22-.57.22-.66.37.14-.34.75.1.66-.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m386.57,953.69s.09-.01.13-.03c-.06-.01-.1,0-.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m377.31,955.17l-.1.35c1.73-.62,3.68.01,5.51-.26l-.12.12c4.64.14,8.92-.45,13.52-.71-.07.04-.1.14-.17.18.22-.12.47-.34.72-.31.06.08-.07.16-.15.2.97.58,2.86-.37,3.46.08.27-.06.39-.3.24-.48,3.6-.15,7.46-.26,11.13-.71.18.08.21.24.16.43,3.14-.94,6.42-.56,9.63-.41.12-.25-.33-.26-.01-.52-1.03-.31-1.89.6-2.83.15l.12-.24c-.68-.15-.14.6-.84.29-.28-.2.07-.3-.06-.32-1.45.1-2.96-.12-4.32.46-.34-.52-1.55-.02-2.09-.51-.37.2-.75.15-.89.49-5.06-.27-10.24.23-15.43.19-2.43,1-5.34-.19-8.22.14-.02-.04-.02-.07,0-.1-.94.25-2.31.36-3.43.24l-.95.42c-6.75-.87-13.64-.26-20.5-.62-7.79-.25-14.61-.97-22.19.35.01-.1-.05-.15.14-.19-2.19.2-4.18-.16-6.24.05v-.1c-5.11.82-10.64-.11-15.57.78-6-.09-12.79,0-19.14.25v-.2c-5.07.42-9.98-.63-15.05-.31-5.22-.45-10.73,1.13-15.99.53-3.25-.97-7.53,1.11-10.59.1-6.28-1.52-12.37-.54-18.65.37-5.79-.54-11.58.85-17.19-.25-2.66.71-5.59-.87-8.55-.67l.11.24c-1.06-.74-2.37,1.04-3.03-.06l.11-.05c-.56-.56-1.31,1.32-1.65.65l-.09.28c-.68.08-.08-.31-.61-.42-.2.03-.08.5-.49.35-.09-1.13-1.67.25-1.71-1.03.37,0-.58-.49.25-.76-.24-.13-1.38-.07-1.28.47-.1.57-.54,1.07.15,1.52l.14-.42c.23.42.18.21.26.52.91.06,1.03.66,1.68.91,0-.01-.01-.02,0-.04.44-.5,1.06-.2,1.41-.13l.14.23c.21.49,1.03-.95.76-.12,1.84-.21,3.95-.2,6.01-.21.29-.32,1.58.03,1.13-.58.52.7,2.05.87,2.61.85-.02.06-.05.14-.13.11,1.1.9,1.31-.84,2.34.27.16-.78,1.88.25,2.46-.67.13.17.17.33.12.47,1.86.02,3.92.3,5.49.33,1.35-.68,3.26.31,4.41-.63.96.2,2.51.59,3.85.21l-.13.12c1.51-.06,3.4-.1,4.43-.7.45.9,1.1.72,1.75,1.01,1.01-.42,3.04-.3,4.58-.68.24.42,1.27-.18,1.35.43,4.31-1.17,9.64-.76,14.24.12l-.07.04c.6-.33,1.29-1.07,1.89-1.5.06.05.05.15-.07.15.84-.11,1.63.48,2.47.37q0,.1-.14.2c.79-.27,1.63.48,2.56.02l.05.16.59-.22c-.01.2-.04.5-.35.44,7.22.2,14.67-.84,22.07-.69l-.27.19,1.44-.34c0,.1-.08.15-.14.2,1.83.34,3.73-.23,5.51-.14,0,.1-.28.29-.03.4,1.32-.55,2.12.71,2.78-.42.06.05.1.31-.03.4,3.67-.38,7.44-.35,11.14-.17,3.08-1.03,6.53-.1,9.73-.91l-.02.2c4.14-.72,8.54.05,12.84-.09,1.78.08,2.99-.16,4.78-.17l.05.26c3.02-.97,6.34.87,9.49-.2l-.22.35c.49-.54,1.9.19,1.72-.73l.56.28c2.14-1.22,3.89.56,6.51-.23l-.17.22c.7-.17,1.51-.3,2.03-.1-.08.03-.04.1-.21.15,2.18.87,4.61-.09,6.91-.06l-.26.41c1.11-.48,3.15-.03,4.62-.25l-.09.19.74-.27.02.39c1.9.03,3.7-.31,5.55-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m396.51,954.73s-.01,0-.02-.01c-.06.03-.03.03.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m206.75,956.71c-.09-.02-.16-.05-.23-.08.02.08.16.06.23.08Z"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "128.34 955.51 128.39 955.68 128.65 955.46 128.34 955.51"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.06,955.69c.24-.18.71-.3.72-.65l-.44.31c-.06-.26-.35-.25-.61-.16l.29-.02c-.07.04-.03.2-.1.24-.44-.13-.56.23-.97-.06l.02-.03-.32.17c-.1-.04-.06-.16-.03-.21-.29.14-.51.28-.9.27.3.48.86-.37,1.16.11l-.02.03c.38-.18.82.13,1.2,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m129.62,955.29s.02,0,.03-.01c0-.01-.01,0-.03.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m145.29,955.98l.02-.08s-.04.06-.02.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m140.5,955.02s.02,0,.02,0c.03-.1.01-.08-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m171.33,955.86l.09.11c-.02-.1-.06-.12-.09-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m177.76,955.95s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m174.83,954.47v-.1c-.02.05-.02.08,0,.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m176.91,954.28c.06.02.11.04.17.05-.04-.05-.11-.07-.17-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m177.69,955.99s.04-.03.06-.04c-.02.01-.05.02-.06.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m171.7,954.29l-.08-.25c0,.08.04.17.08.25Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m177.42,954.08s.07.07.11.09c-.02-.05-.06-.09-.11-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m131.48,955.67c-.06,0-.13,0-.21.04.08.02.14,0,.21-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m159.99,954.06s.03-.06.04-.1c-.05.02-.05.06-.04.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m166.85,954.1h.02s-.01-.03-.03-.05v.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m164.85,954.14s.02-.03.03-.05c-.02.02-.02.04-.03.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m168.37,953.84s.05-.05.07-.09l-.07.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m169.81,954.1c-.06-.09,0-.17.07-.26-.36-.12-.48.19-.86-.03l.18.12c-.24.18-.69.22-.91-.02l.07-.08c-.23.2-.59-.17-.69,0,.09.11,0,.17.14.28l-.59.21-.04-.34-.31.11c.08.14-.41-.11-.42.21-.18-.12.07-.26.14-.39-.17.1-.19-.05-.35.15l-.17-.3-.45.21s0-.05.02-.08c-.21.25-.53-.15-.79.29.01-.02,0-.03.01-.05-.14.23-.5.06-.63.01-.23.06-.1.29-.11.41-.68-.08-.46-.06-1.03.3-.34-.37.4-.6-.03-.86-.06.18-.36.32-.7.4-.31-.13-.83-.23-1.13-.48l.03.24-.44.14.25-.35c-.07.08-.29.24-.43.36-.45.21-.26-.53-.61-.16-.01-.03-.03-.05-.03-.08-.11.19-.41.12-.75.19l.12-.31.22.07c-.12-.3-.37.05-.58.03-.23.11-.11.36-.23.45-.08-.01-.2.08-.27-.01-.2-.1-.02-.37.04-.5-.17.32-.23.28-.61.41-.02-.15,0-.22.06-.25-.08.04-.15.11-.19.24l-.13-.18c-.44-.26-.43.58-.95.48.14-.17-.45.04-.61-.16.18-.05-.09-.46.02-.65-.42-.11-.17.37-.5.44l.14-.39c-.32.17-.08.21-.41.33.09-.11-.15-.1.05-.23-.43-.04-.32,0-.7-.05l-.03.37c-.13.04-.18-.12-.21-.19.05,0,.14,0,.13-.04-.15-.32-.24.18-.42-.11.04.12.09.28-.07.31.05-.23-.24-.21-.25-.31.1.16-.34.07-.36.32-.18-.17.06-.18.07-.31-.15.29-.64.04-.77.21,0-.02-.01-.04-.01-.05-.19.18-.51.22-.89.48l.13-.22c-.39-.09-.23.45-.56.45.07-.31-.53.03-.39-.32-.19.18-.39.25-.52.52-.18-.17.35-.42.09-.51l-.27.16-.05-.17c-.01.12-.25.13-.24.23-.04-.2-.15-.34-.14-.49-.17.06-.41-.13-.56.05v-.1c-.18.37-.54.07-.62.46l-.11-.21c-.26.04-.21.42-.33.52-.1.01-.23.06-.34.02.34-.25-.17-.3-.24-.43-.13,0-.53.03-.64.21.16-.2.06-.35.35-.37-.16-.37-.44.09-.77.04v-.17c-.46.12-.48.42-.68.72-.06-.21,0-.27.12-.49-.31-.13-.8.02-1.15,0-.11-.15-.04-.24.08-.31-.36.17-.81-.04-1.03.35.09-.15-.15-.1-.28-.17,0,.08-.03.18-.04.17-.22.15-.71.3-.97.16l.09-.11c-.6-.06-.86.59-1.51.31-.12-.08.12-.31-.12-.3-.12.14-.08.43-.38.35l.02-.25-.21.25c.11.21.44.13.21.37-.27-.23-.24.23-.57-.04.08-.03.18-.22.23-.32-.69-.29-.97.24-1.67-.07-.35.2-.8.24-1.04.42.02-.25.02-.47.18-.67-.3-.03-.44.53-.65.17-.14.34-.83.22-.9.7-.01-.1-.32,0,0-.27-.41.16-.53-.42-.72-.41-.1.01.12.3-.12.31-.03-.02-.04-.07-.07-.09l-.09.11c-.09-.11.1-.24.11-.36-.33-.1-.55.28-.95.31l.07-.08-.4-.02.02-.03-.32.17v-.12c-.07.04-.08.11-.19.13l.03-.15c-.1.24-.49.37-.67.37l-.04-.07-.44.31c-.23-.16.3-.36-.17-.25l.12-.31c-.33.12-.38-.04-.61.06.1.16.26.14.14.28-.26-.36-.42.09-.66.24.13,0,.21,0,.3-.19.13,0,.05.17.13.18l.19-.18.05.21.33-.17c-.02.25.3.03.17.3.23-.11.36.07.56-.18.15.15-.24.18-.08.21.91-.2,1.85-.16,2.79-.08l-.09.11c.09-.11.21-.2.28-.29.16.2.78.46,1,.08.03.02-.02.08-.04.1.31-.04.88.22,1.33.18.19-.4.67.25.84-.29l-.09.11c-.15-.15.22-.38.28-.51.13.35,0,.27.16.6l-.18-.12.04.29c.57-.75,1.06.34,1.41-.2-.02.03-.02.08-.04.1.24.16.4-.2.57-.3.02.15-.1.24-.19.35.41.11,1.11-.28,1.57-.05.16-.2-.06-.26.11-.41.14.05.24.21.07.31.39.36,1.3-.24,1.91.1.32-.22.12-.31.61-.46-.11.14.12.48-.18.49l-.03.15c.48.03,1.13.09,1.4-.35.02.32.09.06.27.23.07-.04,0-.05-.04-.07.18-.27.27.01.4-.03l-.05.06.35-.2c.06.04.15.1.16.2v-.22c.19,0,.09.28.32.23l-.05-.17c.15.1.38-.13.42.11,0,.05-.02.03-.08.04.23.34.6-.11.89.05l-.07-.36c.28-.11.17.07.16.2.19,0,.23.11.47.15.12-.09.06-.13.1-.24l.25.09-.16.2c.39-.52.97.06,1.23-.42.15.1-.13.22-.04.28.46.23,1.02-.34,1.4-.08.62.26,1.34,0,2.02.18v-.1s.48.08.48.08c.13-.22.47-.12.67-.37-.02.08.03.19-.02.25.21-.03.44-.14.56,0l-.07.08c.46.06,1.1.06,1.35-.12.16-.02.15.15.2.27.27.01.44-.09.66-.24.06.04.12.08.18.17l.1-.24c.11.03.03.19.11.26.42-.28.9-.03,1.2-.05l-.04-.12c.12-.09.36.07.21.19.58.14.86-.37,1.64-.31.11.43.7-.13.82.35.33-.12.54.07.77-.21,0,.05.04.07-.02.08.13.18.57.04.9-.08l.02.14c.12-.31.69-.22.81-.53.04.07-.06.13-.11.19.17.3.3-.14.52-.08-.02.08.05.17,0,.22.74.34,1.81-.23,2.78,0,.27.01-.1-.33.25-.31.1.16-.17.32.05.39.16-.2.22-.16.44-.14-.04.1,0,.17-.16.25.12.13.53-.25.78.01-.01-.1.03-.15.08-.21.36-.27.84.27.87.12,0,0,.13-.04.02-.08.13,0,.33.05.29.21.07-.08.13-.22.24-.23l-.06.18c.06-.04.13-.15.19-.18l-.09-.11c.15.15.45-.21.45.13h-.05s.29.16.29.16c.11-.14.23-.28.42-.23.07.36.49.08.74.12v.13c.18-.17.67-.1.58-.16.19,0,.44.09.35.2.15-.07.47-.07.55-.28l.3.3c.18-.45.61.16.63-.31.17.07.13.18.25.26.24-.23.48-.19.73-.15v.05c.25.04.54-.2.89-.22l.07.36c.18-.05.22-.33.4-.25.04.06,0,.07-.04.09.17-.07.4.02.52.11.26-.26.46-.16.69-.44.2.32-.3.14-.13.44.37.17.75,0,1.15-.16.03.07-.01.12-.03.2,0,0,.82-.87.67-1.21.1-.24.22-.38-.13-.57-.12.14-.44.31-.5.05l-.02.25c-.46.12-.04-.51-.6-.51l.12.08c-.11.02-.19.18-.31.09-.04-.07.04-.1.09-.16l-.46.34c-.02-.15,0-.22.09-.33-.43.01.09.46-.43.36-.09-.11.03-.15.1-.24-.24-.21-.4-.02-.65.12,0-.22.16-.2-.04-.34.04.12.07.31-.09.33.08-.22-.12-.12-.27-.18.03.08.02.18-.04.22-.08.04-.14-.05-.24-.04l.19.22c-.26.21-.41-.11-.62-.21.02-.04.05-.07.09-.08-.21-.09-.43-.27-.7-.08l.02-.03c-.5.22.16.37-.43.58-.19-.05.09-.73-.35-.47.21.19-.29.46-.54.55l.26-.43c-.1,0-.28.12-.34.07v.1c.03.37-.32-.05-.5.17.23-.5.24-.4.28-.9-.18.27-.39.52-.71.47l.27-.38c-.44-.08-.95.48-1.31.8.1-.29-.05-.39.11-.63l-.42.06.12-.31c-.17.32-.36.1-.33.52.05-.06.04-.1.12-.09-.01.13-.08.38-.3.36-.15-.1.09-.16.05-.28-.14.17-.15-.1-.29.02l.13.18c-.1.24-.24.01-.38.13.17-.1.12-.24.05-.39v.03c-.09.01-.23.18-.31.04l.09-.33-.15.24c-.06-.04-.1-.16,0-.22-.48-.2.01.71-.61.41.01-.13.08-.21.25-.13.03-.2-.01-.32-.18-.39,0-.02,0-.03,0-.04-.33,0-.75-.02-.97.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m170.78,953.9c.17,0,.32,0,.39-.04-.03-.06-.4-.17-.39.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m145.05,954.26s.04-.02.06-.03c-.02.01-.04.02-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.67,954.36s.04.06.07.07c0-.07-.02-.12-.07-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m157.99,954.14s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m150.11,954.05c-.12.11-.17.2-.17.28.08-.03.14-.1.17-.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m152.77,954.18s.04-.03.05-.05c-.04.02-.05.03-.05.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m158.4,953.98c-.12.11-.28.1-.42.16.11-.06.33.05.42-.16Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "141.98 954.72 142.12 954.55 141.97 954.67 141.98 954.72"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m143.27,954.61c.06.04.29-.06.22-.15-.07.08-.15.12-.22.15Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "148.23 954.77 148.29 954.58 148.17 954.72 148.23 954.77"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m424.16,128.95c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m424.23,128.97h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m424.63,129.04c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "424.49 128.96 424.48 129.03 424.56 128.93 424.49 128.96"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "424.43 128.91 424.44 128.93 424.57 128.87 424.43 128.91"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m424.94,129.08l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m430.51,128.41s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m432.03,128.33s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m429.55,128.65s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.27,129.09s0,.02,0,.04h0s.02-.03.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m433.74,128.13s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m429,128.66s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m431.53,128.16s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.35,129.22s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.9,129.21s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m427.25,129.22s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.42,129.21s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m430.5,128.45s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m430.03,128.57s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m428.26,128.53s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m430.12,128.58s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m428.79,128.62s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m446.55,129.64s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.71,129.32h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.75,129.12s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m445.37,129.6s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m433.63,129.5s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m438.87,129.21s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m441.67,128.18c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m446.6,129.68s0,0,0-.01c0,0,0,0,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m443.32,128.15s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.42,129.07h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m440.77,128.1l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m438.59,129.5s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.81,129s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m425.13,128.68l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m425.19,129.24s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.56,129.48l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.07,128.6l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.86,129.5c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.78,128.53c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m427.44,129.21c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m426.95,128.52c-.06-.03-.09-.1-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m427.76,129.4l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m427.23,128.68v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m427.49,128.55l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m427.62,128.63v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m429.5,129.39c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m429.13,128.45s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m429.41,128.37s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m432.08,128.11s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m432.02,128.14s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m432.63,128.16s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m436.76,129.64c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "436.91 129.55 436.92 129.59 436.96 129.65 436.91 129.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m437.32,129.66s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m437.28,129.7s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m437.25,129.68v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m437.44,129.68l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m437.71,129.64c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m437.67,129.42c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "438.12 129.58 438.18 129.64 438.2 129.59 438.12 129.58"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m438.36,129.61l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m438.7,129.71c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.48,129.43s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.47,128.99c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.61,129.58s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.79,129.54s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m439.54,129.19l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "440.47 129.46 440.61 129.43 440.57 129.42 440.47 129.46"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "440.56 129.51 440.57 129.55 440.68 129.47 440.56 129.51"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "440.71 129.55 440.7 129.55 440.61 129.58 440.71 129.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m441.01,129.58l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m441.98,128.1s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m442.15,128.26l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m444.24,128.35c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m449.71,129.12s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m457.53,186.27c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m457.59,186.29h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m457.99,186.35c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "457.85 186.28 457.84 186.34 457.92 186.24 457.85 186.28"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "457.79 186.22 457.8 186.24 457.93 186.18 457.79 186.22"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m458.3,186.4l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m463.87,185.73s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m465.39,185.64s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m462.91,185.96s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.63,186.41s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m467.1,185.45s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m462.36,185.97s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m464.9,185.47s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m459.71,186.53s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.26,186.52s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.61,186.53s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m459.78,186.52s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m463.86,185.76s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m463.39,185.89s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m461.62,185.84s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m463.48,185.89s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m462.15,185.94s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m479.91,186.96s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m473.07,186.63h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m473.11,186.44s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m478.73,186.91s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m466.99,186.82s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.23,186.52s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m475.03,185.49c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "479.96 186.99 479.96 186.98 479.95 186.98 479.96 186.99"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m476.68,185.46s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.78,186.38h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m474.13,185.42l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.14-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.07-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.14.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0,0,.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.05.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m471.95,186.81s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m473.17,186.31s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m458.5,185.99l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m458.55,186.55s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m459.92,186.8l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m459.44,185.91l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.22,186.81c.03-.1.11.05.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.14,185.85c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.81,186.52c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.31,185.84c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m461.12,186.72l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.59,185.99v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.86,185.86l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m460.98,185.94v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m462.87,186.71c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m462.49,185.76s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m462.77,185.68s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m465.44,185.42s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m465.38,185.45s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m465.99,185.48s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m470.12,186.95c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "470.27 186.87 470.28 186.9 470.32 186.96 470.27 186.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m470.68,186.98s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m470.64,187.01s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m470.62,186.99v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m470.8,186.99l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m471.07,186.96c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m471.03,186.73c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "471.48 186.9 471.54 186.95 471.56 186.91 471.48 186.9"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m471.72,186.92l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.06,187.02c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.84,186.74s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.83,186.31c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.97,186.9s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m473.15,186.86s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m472.9,186.5l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "473.83 186.77 473.98 186.74 473.93 186.74 473.83 186.77"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "473.93 186.82 473.93 186.86 474.04 186.79 473.93 186.82"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "474.07 186.87 474.06 186.86 473.97 186.89 474.07 186.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m474.37,186.89l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m475.34,185.42s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m475.51,185.58l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m477.6,185.66c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m483.07,186.43s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m811.73,106.18c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m811.79,106.2h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m812.19,106.26c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "812.05 106.19 812.04 106.25 812.12 106.16 812.05 106.19"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "811.99 106.13 812.01 106.16 812.13 106.09 811.99 106.13"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m812.5,106.31l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.07,105.64s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.6,105.55s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m817.12,105.87s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m826.83,106.32s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m821.3,105.36s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m816.57,105.88s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.1,105.39s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.92,106.44s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.46,106.43s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.81,106.44s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.98,106.43s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m818.07,105.67s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m817.6,105.8s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m815.82,105.76s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m817.68,105.81s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m816.36,105.85s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m834.11,106.87s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.27,106.54h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.31,106.35s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m832.93,106.82s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m821.19,106.73s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m826.43,106.44s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m829.24,105.4c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "834.16 106.9 834.16 106.89 834.16 106.9 834.16 106.9"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m830.89,105.37s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m826.98,106.29h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m828.33,105.33l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.04.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.03.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m826.15,106.72s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.38,106.22s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m812.7,105.9l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m812.76,106.46s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.12,106.71l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m813.64,105.82l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.42,106.72c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.34,105.76c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m815.01,106.43c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.51,105.75c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m815.33,106.63l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m814.79,105.9v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m815.06,105.77l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m815.19,105.85v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m817.07,106.62c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m816.7,105.67s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m816.98,105.59s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.64,105.33s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m819.58,105.36s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m820.19,105.39s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m824.32,106.86c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "824.47 106.78 824.48 106.82 824.52 106.87 824.47 106.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m824.88,106.89s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m824.84,106.92s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m824.82,106.9v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m825,106.9l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m825.27,106.87c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m825.24,106.65c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "825.68 106.81 825.75 106.86 825.76 106.82 825.68 106.81"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m825.93,106.84l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m826.26,106.93c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.05,106.65s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.03,106.22c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.17,106.81s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.35,106.77s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m827.1,106.41l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "828.04 106.69 828.18 106.65 828.13 106.65 828.04 106.69"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "828.13 106.73 828.13 106.77 828.24 106.7 828.13 106.73"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "828.28 106.78 828.26 106.77 828.18 106.81 828.28 106.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m828.57,106.8l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m829.54,105.33s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m829.71,105.49l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m831.81,105.57c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m837.27,106.34s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m603.47,240.42c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m603.53,240.44h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m603.93,240.5c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "603.79 240.43 603.78 240.49 603.86 240.39 603.79 240.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "603.73 240.37 603.74 240.39 603.87 240.33 603.73 240.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m604.24,240.55l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m609.81,239.88s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m611.33,239.79s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m608.85,240.11s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.57,240.56s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m613.04,239.6s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m608.3,240.12s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m610.84,239.62s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m605.65,240.68s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.2,240.67s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.55,240.68s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m605.72,240.67s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m609.8,239.91s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m609.33,240.04s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m607.56,239.99s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m609.42,240.05s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m608.09,240.09s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m625.85,241.11s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.01,240.78h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.05,240.59s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m624.67,241.06s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m612.93,240.97s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.17,240.67s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.97,239.64c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "625.9 241.14 625.9 241.13 625.89 241.13 625.9 241.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m622.62,239.61s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.72,240.53h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.07,239.57l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.16.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.89,240.96s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.11,240.46s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m604.44,240.14l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m604.49,240.7s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m605.86,240.95l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m605.38,240.06l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.16,240.96c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.08,240c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.75,240.67c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.25,239.99c-.06-.03-.09-.09-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m607.06,240.87l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.53,240.14v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.8,240.01l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m606.92,240.09v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m608.81,240.86c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m608.43,239.91s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m608.71,239.83s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m611.38,239.57s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m611.32,239.6s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m611.93,239.63s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.06,241.1c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "616.21 241.02 616.22 241.06 616.26 241.11 616.21 241.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.62,241.13s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.58,241.16s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.56,241.14v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.74,241.14l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.01,241.11c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.97,240.89c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "617.42 241.05 617.48 241.1 617.5 241.06 617.42 241.05"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.66,241.07l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618,241.17c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.78,240.89s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.77,240.46c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.91,241.05s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.09,241.01s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.84,240.65l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "619.77 240.93 619.92 240.89 619.87 240.89 619.77 240.93"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "619.87 240.97 619.87 241.01 619.98 240.94 619.87 240.97"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "620.01 241.02 620 241.01 619.91 241.04 620.01 241.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.31,241.04l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m621.28,239.57s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m621.45,239.73l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m623.54,239.81c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m629.01,240.58s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m557.18,379.14c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m557.24,379.16h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m557.64,379.23c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "557.5 379.16 557.49 379.22 557.57 379.12 557.5 379.16"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "557.44 379.1 557.46 379.12 557.58 379.06 557.44 379.1"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m557.95,379.27l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m563.52,378.6s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m565.05,378.52s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m562.57,378.84s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.28,379.28s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m566.75,378.32s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m562.02,378.85s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m564.55,378.35s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.37,379.41s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.91,379.4s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.26,379.41s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.43,379.4s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m563.51,378.64s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m563.04,378.76s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m561.27,378.72s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m563.13,378.77s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m561.8,378.81s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m579.56,379.83s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.72,379.51h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.76,379.31s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m578.38,379.79s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m566.64,379.69s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m571.88,379.4s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m574.69,378.37c-.03.12.02,0,.08.06l.06-.07c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m579.61,379.87s0,0,0-.01c0,0,0,0,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m576.34,378.34s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.43,379.26h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m573.78,378.29l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.06-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m571.6,379.69s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.82,379.19s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m558.15,378.87l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m558.21,379.43s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.57,379.68l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.09,378.79l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.87,379.69c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.79,378.72c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.46,379.4c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m559.96,378.71c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.78,379.59l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.24,378.87v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.51,378.74l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m560.64,378.82v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m562.52,379.58c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m562.15,378.64s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m562.43,378.56s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m565.09,378.3s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m565.03,378.33s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m565.64,378.35s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m569.77,379.83c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "569.92 379.74 569.93 379.78 569.97 379.84 569.92 379.74"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.33,379.85s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.29,379.89s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.27,379.87v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.45,379.87l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.72,379.83c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m570.69,379.61c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "571.13 379.77 571.2 379.83 571.21 379.78 571.13 379.77"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m571.38,379.8l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m571.71,379.9c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.5,379.62s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.48,379.19c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.62,379.77s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.8,379.73s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m572.55,379.38l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "573.49 379.65 573.63 379.62 573.58 379.61 573.49 379.65"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "573.58 379.7 573.58 379.74 573.69 379.66 573.58 379.7"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "573.73 379.74 573.71 379.74 573.63 379.77 573.73 379.74"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m574.02,379.77l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m574.99,378.29s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m575.16,378.45l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m577.25,378.54c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m582.72,379.31s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.85,448.45c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.91,448.47h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.31,448.53c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1090.17 448.46 1090.16 448.52 1090.24 448.42 1090.17 448.46"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1090.11 448.4 1090.12 448.42 1090.25 448.36 1090.11 448.4"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.62,448.57l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.19,447.91s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1097.71,447.82s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.23,448.14s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.95,448.58s0,.02,0,.04h0s.02-.03.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1099.42,447.63s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.68,448.15s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1097.22,447.65s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.03,448.71s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.58,448.7s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.93,448.71s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.1,448.7s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.18,447.94s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.71,448.07s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.94,448.02s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.8,448.07s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.47,448.12s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1112.23,449.14s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.39,448.81h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.43,448.61s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1111.05,449.09s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1099.31,449s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.55,448.7s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1107.35,447.67c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1112.28 449.17 1112.28 449.16 1112.27 449.16 1112.28 449.17"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1109,447.64s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.1,448.56h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.45,447.6l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.27,448.99s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.49,448.49s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.82,448.17l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.87,448.73s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.24,448.98l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.76,448.09l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.54,448.99c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.46,448.03c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.13,448.7c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.63,448.01c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.44,448.9l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.91,448.17v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.18,448.04l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.3,448.12v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.19,448.89c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.81,447.94s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.09,447.86s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1097.76,447.6s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1097.7,447.63s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1098.31,447.66s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.44,449.13c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1102.59 449.05 1102.6 449.08 1102.64 449.14 1102.59 449.05"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103,449.15s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.96,449.19s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.94,449.17v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.12,449.17l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.39,449.14c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.35,448.91c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1103.8 449.08 1103.86 449.13 1103.88 449.09 1103.8 449.08"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.04,449.1l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.38,449.2c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.16,448.92s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.15,448.49c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.29,449.07s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.47,449.04s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.22,448.68l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1106.16 448.95 1106.3 448.92 1106.25 448.91 1106.16 448.95"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1106.25 449 1106.25 449.04 1106.36 448.96 1106.25 449"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1106.39 449.04 1106.38 449.04 1106.29 449.07 1106.39 449.04"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.69,449.07l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1107.66,447.59s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1107.83,447.75l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1109.92,447.84c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1115.39,448.61s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1251.28,482.84c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1251.34,482.86h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1251.75,482.92c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1251.61 482.85 1251.6 482.91 1251.68 482.82 1251.61 482.85"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1251.55 482.79 1251.56 482.82 1251.69 482.75 1251.55 482.79"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1252.06,482.97l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1257.63,482.3s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1259.15,482.21s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1256.67,482.53s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.39,482.98s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1260.86,482.02s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1256.12,482.54s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1258.65,482.05s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.47,483.11s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.02,483.09s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.37,483.1s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.54,483.09s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1257.62,482.33s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1257.15,482.46s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1255.38,482.42s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1257.24,482.47s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1255.91,482.51s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1273.67,483.53s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.83,483.2h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.87,483.01s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1272.49,483.48s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1260.75,483.39s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1265.99,483.1s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1268.79,482.06c-.03.12.02,0,.08.06l.06-.07c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1273.71,483.57s0,0,0-.01c0,0,0,0,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1270.44,482.04s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.54,482.96h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1267.89,481.99l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1265.71,483.39s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.93,482.89s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1252.25,482.56l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1252.31,483.12s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.68,483.37l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.19,482.48l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.97,483.38c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1253.9,482.42c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.56,483.09c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.06,482.41c-.06-.03-.09-.1-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.88,483.29l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.35,482.56v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.61,482.44l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1254.74,482.51v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1256.62,483.28c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1256.25,482.34s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1256.53,482.25s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1259.2,481.99s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1259.14,482.02s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1259.75,482.05s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1263.88,483.52c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1264.03 483.44 1264.04 483.48 1264.08 483.53 1264.03 483.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1264.44,483.55s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1264.4,483.58s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1264.37,483.56v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1264.56,483.56l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1264.83,483.53c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1264.79,483.31c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1265.24 483.47 1265.3 483.52 1265.32 483.48 1265.24 483.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1265.48,483.5l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1265.82,483.59c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.6,483.31s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.59,482.88c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.73,483.47s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.91,483.43s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1266.65,483.07l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1267.59 483.35 1267.73 483.32 1267.69 483.31 1267.59 483.35"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1267.68 483.39 1267.69 483.43 1267.79 483.36 1267.68 483.39"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1267.83 483.44 1267.81 483.43 1267.73 483.47 1267.83 483.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1268.12,483.47l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1269.1,481.99s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1269.27,482.15l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1271.36,482.23c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1276.83,483s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.26,386.59c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.32,386.61h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1295.72,386.68c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1295.58 386.6 1295.57 386.67 1295.65 386.57 1295.58 386.6"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1295.53 386.55 1295.54 386.57 1295.66 386.51 1295.53 386.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1296.04,386.72l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.6,386.05s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.13,385.97s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.65,386.29s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.36,386.73s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1304.84,385.77s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.1,386.3s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1302.63,385.8s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.45,386.86s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298,386.85s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.34,386.86s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.52,386.85s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.6,386.08s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.13,386.21s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.36,386.17s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.22,386.22s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.89,386.26s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1317.65,387.28s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.81,386.96h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.84,386.76s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1316.46,387.23s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1304.73,387.14s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1309.96,386.85s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.77,385.81c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1317.69 387.32 1317.69 387.31 1317.69 387.31 1317.69 387.32"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1314.42,385.79s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.51,386.71h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1311.86,385.74l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.07-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.14.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0,0,.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.05.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1309.68,387.14s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.91,386.64s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1296.23,386.32l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1296.29,386.88s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.66,387.12l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.17,386.24l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.95,387.14c.03-.1.11.05.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.88,386.17c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.54,386.85c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.04,386.16c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.86,387.04l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.33,386.32v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.59,386.19l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.72,386.27v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.6,387.03c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.23,386.09s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.51,386.01s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.18,385.75s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.11,385.78s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.73,385.8s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1307.85,387.28c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1308.01 387.19 1308.02 387.23 1308.05 387.29 1308.01 387.19"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1308.41,387.3s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1308.38,387.34s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1308.35,387.31v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1308.54,387.31l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1308.81,387.28c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1308.77,387.06c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1309.22 387.22 1309.28 387.28 1309.3 387.23 1309.22 387.22"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1309.46,387.25l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1309.8,387.35c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.58,387.07s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.56,386.63c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.71,387.22s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.88,387.18s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.63,386.83l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1311.57 387.1 1311.71 387.07 1311.67 387.06 1311.57 387.1"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1311.66 387.14 1311.66 387.18 1311.77 387.11 1311.66 387.14"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1311.81 387.19 1311.79 387.19 1311.71 387.22 1311.81 387.19"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.1,387.22l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1313.07,385.74s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1313.24,385.9l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1315.34,385.99c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1320.81,386.76s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1088.68,289.14c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1088.74,289.16h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.14,289.23c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1089 289.15 1088.99 289.21 1089.07 289.12 1089 289.15"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1088.94 289.1 1088.96 289.12 1089.08 289.06 1088.94 289.1"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.45,289.27l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.02,288.6s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.55,288.51s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.07,288.83s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.78,289.28s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1098.25,288.32s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.52,288.84s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.05,288.35s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.87,289.41s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.41,289.39s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.76,289.41s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.93,289.4s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1095.01,288.63s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.54,288.76s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.77,288.72s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.63,288.77s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.3,288.81s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1111.06,289.83s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.22,289.5h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.26,289.31s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1109.88,289.78s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1098.14,289.69s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.38,289.4s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.19,288.36c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1111.11 289.87 1111.11 289.86 1111.1 289.86 1111.11 289.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1107.83,288.34s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.93,289.26h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.28,288.29l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.1,289.69s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.32,289.19s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.65,288.87l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1089.71,289.43s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.07,289.67l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1090.59,288.78l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.37,289.68c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.29,288.72c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.96,289.4c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.46,288.71c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.28,289.59l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1091.74,288.87v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.01,288.74l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1092.14,288.82v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1094.02,289.58c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.65,288.64s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1093.93,288.56s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.59,288.3s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1096.53,288.32s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1097.14,288.35s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.27,289.83c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1101.42 289.74 1101.43 289.78 1101.47 289.84 1101.42 289.74"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.83,289.85s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.79,289.89s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.77,289.86v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1101.95,289.86l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.22,289.83c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.19,289.61c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1102.63 289.77 1102.7 289.82 1102.71 289.78 1102.63 289.77"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1102.87,289.8l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.21,289.9c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104,289.62s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1103.98,289.18c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.12,289.77s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.3,289.73s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1104.05,289.37l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1104.99 289.65 1105.13 289.62 1105.08 289.61 1104.99 289.65"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1105.08 289.69 1105.08 289.73 1105.19 289.66 1105.08 289.69"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1105.22 289.74 1105.21 289.73 1105.13 289.77 1105.22 289.74"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1105.52,289.77l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.49,288.29s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1106.66,288.45l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1108.75,288.54c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1114.22,289.31s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1220.5,246.27c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1220.56,246.29h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1220.96,246.35c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1220.82 246.28 1220.81 246.34 1220.89 246.25 1220.82 246.28"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1220.77 246.22 1220.78 246.25 1220.91 246.18 1220.77 246.22"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1221.28,246.4l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1226.84,245.73s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1228.37,245.64s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1225.89,245.96s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.6,246.41s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1230.08,245.45s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1225.34,245.97s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1227.87,245.48s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1222.69,246.53s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.24,246.52s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.58,246.53s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1222.76,246.52s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1226.84,245.76s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1226.37,245.89s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1224.6,245.85s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1226.46,245.9s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1225.13,245.94s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1242.89,246.96s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1236.05,246.63h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1236.08,246.44s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1241.71,246.91s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1229.97,246.82s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.2,246.53s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1238.01,245.49c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1242.93 246.99 1242.93 246.98 1242.93 246.99 1242.93 246.99"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1239.66,245.46s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.75,246.38h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1237.11,245.42l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1234.93,246.81s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1236.15,246.31s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1221.47,245.99l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1221.53,246.55s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1222.9,246.8l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1222.41,245.91l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.19,246.81c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.12,245.85c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.78,246.52c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.28,245.84c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1224.1,246.72l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.57,245.99v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.83,245.86l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1223.96,245.94v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1225.84,246.71c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1225.47,245.76s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1225.75,245.68s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1228.42,245.42s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1228.35,245.45s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1228.97,245.48s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.09,246.95c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1233.25 246.87 1233.26 246.91 1233.29 246.96 1233.25 246.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.65,246.98s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.62,247.01s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.59,246.99v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1233.78,246.99l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1234.05,246.96c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1234.01,246.74c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1234.46 246.9 1234.52 246.95 1234.54 246.91 1234.46 246.9"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1234.7,246.93l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.04,247.02c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.82,246.74s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.8,246.31c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.95,246.9s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1236.12,246.86s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1235.87,246.5l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1236.81 246.78 1236.95 246.74 1236.91 246.74 1236.81 246.78"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1236.9 246.82 1236.9 246.86 1237.01 246.79 1236.9 246.82"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1237.05 246.87 1237.03 246.86 1236.95 246.9 1237.05 246.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1237.34,246.89l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1238.31,245.42s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1238.48,245.58l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1240.58,245.66c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1246.05,246.43s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.25,246.27c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.31,246.29h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1297.71,246.35c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1297.58 246.28 1297.56 246.34 1297.64 246.25 1297.58 246.28"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1297.52 246.22 1297.53 246.25 1297.66 246.18 1297.52 246.22"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.03,246.4l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.59,245.73s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1305.12,245.64s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1302.64,245.96s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.35,246.41s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1306.83,245.45s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1302.09,245.97s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1304.62,245.48s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.44,246.53s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.99,246.52s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.33,246.53s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.51,246.52s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.59,245.76s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.12,245.89s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.35,245.85s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1303.21,245.9s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1301.88,245.94s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1319.64,246.96s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.8,246.63h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.83,246.44s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1318.46,246.91s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1306.72,246.82s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1311.95,246.53s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1314.76,245.49c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1319.68 246.99 1319.68 246.98 1319.68 246.99 1319.68 246.99"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1316.41,245.46s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.5,246.38h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1313.86,245.42l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1311.68,246.81s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.9,246.31s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.22,245.99l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1298.28,246.55s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.65,246.8l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.16,245.91l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.94,246.81c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1299.87,245.85c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.53,246.52c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.03,245.84c-.06-.03-.09-.09-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.85,246.72l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.32,245.99v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.58,245.86l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1300.71,245.94v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1302.59,246.71c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1302.22,245.76s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1302.5,245.68s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1305.17,245.42s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1305.1,245.45s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1305.72,245.48s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1309.84,246.95c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1310 246.87 1310.01 246.91 1310.04 246.96 1310 246.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.4,246.98s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.37,247.01s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.34,246.99v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.53,246.99l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.8,246.96c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1310.76,246.74c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1311.21 246.9 1311.27 246.95 1311.29 246.91 1311.21 246.9"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1311.45,246.93l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1311.79,247.02c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.57,246.74s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.55,246.31c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.7,246.9s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.87,246.86s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1312.62,246.5l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1313.56 246.78 1313.7 246.74 1313.66 246.74 1313.56 246.78"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1313.65 246.82 1313.65 246.86 1313.76 246.79 1313.65 246.82"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1313.8 246.87 1313.78 246.86 1313.7 246.9 1313.8 246.87"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1314.09,246.89l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1315.07,245.42s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1315.24,245.58l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1317.33,245.66c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1322.8,246.43s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1344.53,185.16c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1344.6,185.18h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345,185.24c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1344.86 185.17 1344.85 185.23 1344.93 185.13 1344.86 185.17"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1344.8 185.11 1344.81 185.13 1344.94 185.07 1344.8 185.11"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.31,185.28l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.88,184.62s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1352.4,184.53s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.92,184.85s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.64,185.29s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1354.11,184.34s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.37,184.86s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1351.9,184.36s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.72,185.42s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.27,185.41s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.62,185.42s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.79,185.41s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.87,184.65s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.4,184.78s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1348.63,184.73s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.49,184.78s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.16,184.83s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1366.92,185.84s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.08,185.52h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.12,185.32s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1365.74,185.8s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1354,185.7s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.24,185.41s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.04,184.38c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1366.97 185.88 1366.97 185.87 1366.96 185.87 1366.97 185.88"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.69,184.35s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.79,185.27h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.14,184.31l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.96,185.7s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.18,185.2s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.5,184.88l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.56,185.44s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.93,185.69l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.44,184.8l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.23,185.7c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.15,184.74c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.81,185.41c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.32,184.72c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1348.13,185.61l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.6,184.88v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.86,184.75l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.99,184.83v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.87,185.6c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.5,184.65s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.78,184.57s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1352.45,184.31s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1352.39,184.34s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1353,184.37s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.13,185.84c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1357.28 185.76 1357.29 185.79 1357.33 185.85 1357.28 185.76"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.69,185.86s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.65,185.9s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.62,185.88v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.81,185.88l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.08,185.85c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.11.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.04,185.62c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1358.49 185.79 1358.55 185.84 1358.57 185.8 1358.49 185.79"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.73,185.81l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.07,185.91c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.85,185.63s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.84,185.2c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.98,185.78s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.16,185.75s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.91,185.39l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1360.84 185.66 1360.98 185.63 1360.94 185.62 1360.84 185.66"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1360.93 185.71 1360.94 185.75 1361.05 185.67 1360.93 185.71"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1361.08 185.75 1361.06 185.75 1360.98 185.78 1361.08 185.75"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.37,185.78l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.35,184.3s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.52,184.46l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1364.61,184.55c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1370.08,185.32s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1399.23,121.37c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1399.29,121.39h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1399.69,121.45c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1399.55 121.38 1399.54 121.44 1399.62 121.35 1399.55 121.38"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1399.49 121.32 1399.5 121.35 1399.63 121.28 1399.49 121.32"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1400,121.5l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1405.57,120.83s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1407.09,120.74s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1404.61,121.06s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.33,121.51s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1408.8,120.55s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1404.06,121.07s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1406.59,120.58s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.41,121.64s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.96,121.62s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.31,121.63s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.48,121.62s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1405.56,120.86s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1405.09,120.99s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1403.32,120.95s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1405.18,121s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1403.85,121.04s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1421.61,122.06s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.77,121.73h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.81,121.54s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1420.43,122.01s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1408.69,121.92s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1413.93,121.63s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1416.73,120.59c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1421.66 122.09 1421.66 122.08 1421.65 122.09 1421.66 122.09"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1418.38,120.56s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.48,121.48h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1415.83,120.52l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.04.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1413.65,121.91s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.87,121.41s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1400.19,121.09l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1400.25,121.65s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.62,121.9l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.14,121.01l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.92,121.91c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1401.84,120.95c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.5,121.62c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.01,120.94c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.82,121.82l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.29,121.09v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.56,120.96l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1402.68,121.04v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1404.57,121.81c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1404.19,120.86s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1404.47,120.78s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1407.14,120.52s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1407.08,120.55s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1407.69,120.58s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1411.82,122.05c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1411.97 121.97 1411.98 122.01 1412.02 122.06 1411.97 121.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.38,122.08s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.34,122.11s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.31,122.09v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.5,122.09l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.77,122.06c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1412.73,121.84c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1413.18 122 1413.24 122.05 1413.26 122.01 1413.18 122"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1413.42,122.03l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1413.76,122.12c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.54,121.84s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.53,121.41c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.67,122s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.85,121.96s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1414.6,121.6l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1415.53 121.88 1415.68 121.84 1415.63 121.84 1415.53 121.88"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1415.62 121.92 1415.63 121.96 1415.74 121.89 1415.62 121.92"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1415.77 121.97 1415.76 121.96 1415.67 122 1415.77 121.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1416.07,121.99l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1417.04,120.52s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1417.21,120.68l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1419.3,120.76c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1424.77,121.53s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1449.85,155.31c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1449.91,155.33h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1450.31,155.4c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1450.17 155.32 1450.16 155.39 1450.24 155.29 1450.17 155.32"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1450.11 155.27 1450.12 155.29 1450.25 155.23 1450.11 155.27"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1450.62,155.44l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1456.19,154.77s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1457.72,154.69s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1455.24,155.01s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1464.95,155.45s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1459.42,154.49s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1454.69,155.02s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1457.22,154.52s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.04,155.58s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.58,155.57s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.93,155.58s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.1,155.57s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1456.18,154.81s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1455.71,154.93s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1453.94,154.89s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1455.8,154.94s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1454.47,154.98s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1472.23,156s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.39,155.68h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.43,155.48s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1471.05,155.96s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1459.31,155.86s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1464.55,155.57s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1467.36,154.54c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1472.28 156.04 1472.28 156.03 1472.27 156.03 1472.28 156.04"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1469,154.51s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.1,155.43h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1466.45,154.46l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.04.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.03.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1464.27,155.86s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.49,155.36s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1450.82,155.04l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1450.88,155.6s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.24,155.84l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1451.76,154.96l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.54,155.86c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.46,154.89c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1453.13,155.57c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.63,154.88c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1453.45,155.76l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1452.91,155.04v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1453.18,154.91l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1453.3,154.99v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1455.19,155.75c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1454.82,154.81s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1455.09,154.73s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1457.76,154.47s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1457.7,154.5s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1458.31,154.52s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1462.44,156c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1462.59 155.91 1462.6 155.95 1462.64 156.01 1462.59 155.91"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1463,156.02s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1462.96,156.06s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1462.94,156.04v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1463.12,156.04l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1463.39,156c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1463.36,155.78c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1463.8 155.94 1463.87 156 1463.88 155.95 1463.8 155.94"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1464.04,155.97l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1464.38,156.07c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.17,155.79s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.15,155.35c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.29,155.94s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.47,155.9s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1465.22,155.55l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1466.16 155.82 1466.3 155.79 1466.25 155.78 1466.16 155.82"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1466.25 155.87 1466.25 155.91 1466.36 155.83 1466.25 155.87"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1466.39 155.91 1466.38 155.91 1466.29 155.94 1466.39 155.91"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1466.69,155.94l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1467.66,154.46s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1467.83,154.62l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1469.92,154.71c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1475.39,155.48s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1684.12,178.47c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1684.19,178.49h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1684.59,178.56c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1684.45 178.48 1684.44 178.55 1684.52 178.45 1684.45 178.48"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1684.39 178.43 1684.4 178.45 1684.53 178.39 1684.39 178.43"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1684.9,178.6l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1690.47,177.93s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1691.99,177.85s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1689.51,178.17s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.23,178.61s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1693.7,177.65s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1688.96,178.18s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1691.49,177.68s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.31,178.74s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.86,178.73s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1687.21,178.74s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.38,178.73s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1690.46,177.97s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1689.99,178.09s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1688.22,178.05s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1690.08,178.1s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1688.75,178.14s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1706.51,179.16s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.67,178.84h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.71,178.64s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1705.33,179.12s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1693.59,179.02s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1698.83,178.73s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1701.63,177.7c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1706.56 179.2 1706.56 179.19 1706.55 179.19 1706.56 179.2"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1703.28,177.67s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.38,178.59h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1700.73,177.62l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.05.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1698.55,179.02s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.77,178.52s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1685.09,178.2l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1685.15,178.76s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.52,179.01l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.03,178.12l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.82,179.02c.03-.1.11.05.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.74,178.05c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1687.4,178.73c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1686.91,178.04c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1687.72,178.92l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1687.19,178.2v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1687.45,178.07l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1687.58,178.15v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1689.46,178.91c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1689.09,177.97s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1689.37,177.89s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1692.04,177.63s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1691.98,177.66s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1692.59,177.68s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1696.72,179.16c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1696.87 179.07 1696.88 179.11 1696.92 179.17 1696.87 179.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1697.28,179.18s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1697.24,179.22s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1697.21,179.2v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1697.4,179.2l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1697.67,179.16c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1697.63,178.94c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1698.08 179.1 1698.14 179.16 1698.16 179.11 1698.08 179.1"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1698.32,179.13l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1698.66,179.23c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.44,178.95s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.43,178.52c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.57,179.1s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.75,179.06s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1699.5,178.71l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1700.43 178.98 1700.57 178.95 1700.53 178.94 1700.43 178.98"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1700.52 179.03 1700.53 179.07 1700.64 178.99 1700.52 179.03"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1700.67 179.07 1700.66 179.07 1700.57 179.1 1700.67 179.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1700.97,179.1l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1701.94,177.62s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1702.11,177.78l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1704.2,177.87c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1709.67,178.64s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1748.73,106.18c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1748.79,106.2h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1749.19,106.26c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1749.05 106.19 1749.04 106.25 1749.12 106.16 1749.05 106.19"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1748.99 106.13 1749.01 106.16 1749.13 106.09 1748.99 106.13"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1749.5,106.31l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1755.07,105.64s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1756.6,105.55s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1754.12,105.87s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1763.83,106.32s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1758.3,105.36s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1753.57,105.88s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1756.1,105.39s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1750.92,106.44s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.46,106.43s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.81,106.44s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1750.98,106.43s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1755.07,105.67s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1754.6,105.8s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1752.82,105.76s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1754.69,105.81s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1753.36,105.85s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1771.12,106.87s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.27,106.54h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.31,106.35s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1769.93,106.82s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1758.2,106.73s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1763.43,106.44s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1766.24,105.4c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1771.16 106.9 1771.16 106.89 1771.16 106.9 1771.16 106.9"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1767.89,105.37s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1763.98,106.29h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1765.33,105.33l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.07-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0,0,.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1763.15,106.72s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.38,106.22s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1749.7,105.9l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1749.76,106.46s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.13,106.71l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1750.64,105.82l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.42,106.72c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.34,105.76c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1752.01,106.43c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.51,105.75c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1752.33,106.63l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1751.79,105.9v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1752.06,105.77l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1752.19,105.85v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1754.07,106.62c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1753.7,105.67s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1753.98,105.59s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1756.65,105.33s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1756.58,105.36s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1757.19,105.39s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1761.32,106.86c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1761.48 106.78 1761.48 106.82 1761.52 106.87 1761.48 106.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1761.88,106.89s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1761.85,106.92s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1761.82,106.9v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1762,106.9l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1762.27,106.87c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1762.24,106.65c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1762.68 106.81 1762.75 106.86 1762.76 106.82 1762.68 106.81"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1762.93,106.84l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1763.26,106.93c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.05,106.65s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.03,106.22c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.17,106.81s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.35,106.77s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1764.1,106.41l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1765.04 106.69 1765.18 106.65 1765.13 106.65 1765.04 106.69"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1765.13 106.73 1765.13 106.77 1765.24 106.7 1765.13 106.73"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1765.28 106.78 1765.26 106.77 1765.18 106.81 1765.28 106.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1765.57,106.8l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1766.54,105.33s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1766.71,105.49l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1768.81,105.57c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1774.28,106.34s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.56,186.29c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.62,186.31h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.03,186.37c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1793.89 186.3 1793.88 186.36 1793.96 186.26 1793.89 186.3"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1793.83 186.24 1793.84 186.26 1793.97 186.2 1793.83 186.24"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.34,186.41l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1799.91,185.75s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1801.43,185.66s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.95,185.98s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.67,186.43s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1803.14,185.47s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.4,185.99s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1800.93,185.49s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.75,186.55s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.3,186.54s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.65,186.55s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.82,186.54s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1799.9,185.78s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1799.43,185.91s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1797.66,185.86s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1799.52,185.91s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.19,185.96s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1815.95,186.98s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1809.11,186.65h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1809.15,186.45s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1814.77,186.93s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1803.03,186.84s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.27,186.54s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1811.07,185.51c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1815.99 187.01 1816 187 1815.99 187 1815.99 187.01"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1812.72,185.48s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.82,186.4h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1810.17,185.44l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.14.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.05.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.04.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.17.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1807.99,186.83s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1809.21,186.33s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.53,186.01l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.59,186.57s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.96,186.82l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.47,185.93l-.06.06c.05.05.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.26,186.83c.03-.1.11.05.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.18,185.87c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.84,186.54c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.35,185.85c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1797.16,186.74l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.63,186.01v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.89,185.88l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1797.02,185.96v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.9,186.73c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.53,185.78s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.81,185.7s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1801.48,185.44s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1801.42,185.47s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1802.03,185.5s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.16,186.97c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1806.31 186.89 1806.32 186.92 1806.36 186.98 1806.31 186.89"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.72,187s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.68,187.03s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.65,187.01v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.84,187.01l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1807.11,186.98c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1807.07,186.75c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1807.52 186.92 1807.58 186.97 1807.6 186.93 1807.52 186.92"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1807.76,186.94l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.1,187.04c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.88,186.76s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.87,186.33c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1809.01,186.91s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1809.19,186.88s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.94,186.52l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1809.87 186.79 1810.01 186.76 1809.97 186.75 1809.87 186.79"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1809.96 186.84 1809.97 186.88 1810.07 186.8 1809.96 186.84"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1810.11 186.89 1810.09 186.88 1810.01 186.91 1810.11 186.89"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1810.4,186.91l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1811.38,185.43s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1811.55,185.6l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1813.64,185.68c0,.07.01.06-.06.11.11-.04.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1819.11,186.45s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1342.44,824.76c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1342.5,824.78h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1342.9,824.84c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1342.76 824.77 1342.75 824.83 1342.83 824.73 1342.76 824.77"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1342.7 824.71 1342.72 824.73 1342.84 824.67 1342.7 824.71"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1343.21,824.89l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1348.78,824.22s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.31,824.13s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.83,824.45s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.54,824.9s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1352.01,823.94s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.28,824.46s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1349.81,823.96s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1344.63,825.02s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.17,825.01s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.52,825.02s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1344.69,825.01s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1348.77,824.25s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1348.3,824.38s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.53,824.33s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1348.39,824.39s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.06,824.43s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1364.82,825.45s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.98,825.12h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.02,824.93s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1363.64,825.4s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1351.9,825.31s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.14,825.01s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.95,823.98c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1364.87 825.48 1364.87 825.47 1364.86 825.47 1364.87 825.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1361.6,823.95s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.69,824.87h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.04,823.91l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.16.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1356.86,825.3s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.08,824.8s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1343.41,824.48l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1343.47,825.04s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1344.83,825.29l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1344.35,824.4l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.13,825.3c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.05,824.34c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.72,825.01c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.22,824.33c-.06-.03-.09-.09-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1346.04,825.21l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.5,824.48v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.77,824.35l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1345.9,824.43v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.78,825.2c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.41,824.25s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1347.69,824.17s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.35,823.91s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.29,823.94s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1350.9,823.97s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.03,825.44c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1355.18 825.36 1355.19 825.4 1355.23 825.45 1355.18 825.36"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.59,825.47s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.55,825.5s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.53,825.48v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.71,825.48l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.98,825.45c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1355.95,825.22c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1356.39 825.39 1356.46 825.44 1356.47 825.4 1356.39 825.39"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1356.64,825.42l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1356.97,825.51c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.76,825.23s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.74,824.8c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.88,825.39s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1358.06,825.35s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1357.81,824.99l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1358.75 825.27 1358.89 825.23 1358.84 825.23 1358.75 825.27"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1358.84 825.31 1358.84 825.35 1358.95 825.28 1358.84 825.31"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1358.98 825.36 1358.97 825.35 1358.89 825.38 1358.98 825.36"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1359.28,825.38l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.25,823.91s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1360.42,824.07l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1362.51,824.15c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1367.98,824.92s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1790.9,805.74c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1790.96,805.76h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1791.36,805.82c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1791.22 805.75 1791.21 805.81 1791.29 805.72 1791.22 805.75"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1791.16 805.7 1791.17 805.72 1791.3 805.66 1791.16 805.7"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1791.67,805.87l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1797.24,805.2s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.76,805.11s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.28,805.43s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806,805.88s0,.02,0,.04h0s.02-.03.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1800.47,804.92s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.73,805.44s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.27,804.95s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.08,806.01s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.63,805.99s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.98,806.01s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.15,806s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1797.23,805.23s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.76,805.36s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.99,805.32s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.85,805.37s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.52,805.41s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1813.28,806.43s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.44,806.1h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.48,805.91s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1812.1,806.38s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1800.36,806.29s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1805.6,806s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.4,804.96c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1813.33 806.47 1813.33 806.46 1813.32 806.46 1813.33 806.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1810.05,804.94s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.15,805.86h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1807.5,804.89l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.14-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.13-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1805.32,806.29s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.54,805.79s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1791.87,805.46l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1791.92,806.03s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.29,806.27l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1792.81,805.38l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.59,806.28c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.51,805.32c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.18,806c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.68,805.31c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.49,806.19l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1793.96,805.47v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.23,805.34l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1794.35,805.42v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.24,806.18c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1795.86,805.24s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1796.14,805.15s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.81,804.89s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1798.75,804.92s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1799.36,804.95s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1803.49,806.43c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1803.64 806.34 1803.65 806.38 1803.69 806.44 1803.64 806.34"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1804.05,806.45s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1804.01,806.49s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1803.99,806.46v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1804.17,806.46l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1804.44,806.43c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1804.4,806.21c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1804.85 806.37 1804.91 806.42 1804.93 806.38 1804.85 806.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1805.09,806.4l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1805.43,806.49c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.21,806.22s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.2,805.78c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.34,806.37s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.52,806.33s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1806.27,805.97l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1807.2 806.25 1807.35 806.22 1807.3 806.21 1807.2 806.25"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1807.3 806.29 1807.3 806.33 1807.41 806.26 1807.3 806.29"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1807.44 806.34 1807.43 806.33 1807.34 806.37 1807.44 806.34"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1807.74,806.37l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.71,804.89s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1808.88,805.05l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1810.97,805.14c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1816.44,805.91s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1622.69,625.05c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1622.75,625.07h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1623.15,625.14c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1623.01 625.06 1623 625.13 1623.08 625.03 1623.01 625.06"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1622.96 625.01 1622.97 625.03 1623.09 624.97 1622.96 625.01"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1623.46,625.18l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.03,624.51s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.56,624.43s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1628.08,624.75s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.79,625.19s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1632.27,624.23s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.53,624.76s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.06,624.26s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.88,625.32s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.42,625.31s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.77,625.32s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.95,625.31s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1629.03,624.54s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1628.56,624.67s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.79,624.63s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1628.65,624.68s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.32,624.72s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1645.08,625.74s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.24,625.42h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.27,625.22s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1643.89,625.69s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1632.16,625.6s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.39,625.31s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1640.2,624.27c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1645.12 625.78 1645.12 625.77 1645.12 625.77 1645.12 625.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1641.85,624.25s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.94,625.17h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.29,624.2l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.11,625.6s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.34,625.1s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1623.66,624.78l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1623.72,625.34s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.09,625.58l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1624.6,624.7l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.38,625.59c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.31,624.63c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.97,625.31c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.05-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.47,624.62c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.29,625.5l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1625.76,624.78v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.02,624.65l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1626.15,624.73v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1628.03,625.49c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.66,624.55s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1627.94,624.47s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.61,624.21s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1630.54,624.24s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1631.16,624.26s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1635.28,625.74c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1635.44 625.65 1635.45 625.69 1635.48 625.75 1635.44 625.65"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1635.84,625.76s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1635.81,625.8s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1635.78,625.77v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1635.97,625.77l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1636.24,625.74c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1636.2,625.52c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1636.65 625.68 1636.71 625.74 1636.73 625.69 1636.65 625.68"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1636.89,625.71l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.23,625.81c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.01,625.53s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1637.99,625.09c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.14,625.68s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.31,625.64s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1638.06,625.29l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1639 625.56 1639.14 625.53 1639.09 625.52 1639 625.56"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1639.09 625.6 1639.09 625.64 1639.2 625.57 1639.09 625.6"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "1639.24 625.65 1639.22 625.65 1639.14 625.68 1639.24 625.65"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1639.53,625.68l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1640.5,624.2s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1640.67,624.36l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1642.77,624.45c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1648.24,625.22s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m771.1,696.52c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m771.16,696.54h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m771.57,696.61c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "771.43 696.53 771.42 696.6 771.5 696.5 771.43 696.53"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "771.37 696.48 771.38 696.5 771.51 696.44 771.37 696.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m771.88,696.65l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.45,695.98s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m778.97,695.9s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.49,696.22s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.21,696.66s0,.02,0,.04h0s.02-.03.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m780.68,695.7s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m775.94,696.23s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m778.47,695.73s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.29,696.79s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.84,696.78s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.19,696.79s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.36,696.78s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.44,696.02s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.97,696.14s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m775.2,696.1s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m777.06,696.15s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m775.73,696.19s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m793.49,697.21s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.65,696.89h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.69,696.69s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m792.31,697.17s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m780.57,697.07s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.81,696.78s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m788.61,695.75c-.03.12.02-.01.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "793.53 697.25 793.53 697.24 793.53 697.24 793.53 697.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m790.26,695.72s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.36,696.64h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787.71,695.67l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.05c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.14-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.05-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02,0-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.53,697.07s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.75,696.57s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m772.07,696.25l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m772.13,696.81s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.5,697.05l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.01,696.17l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.79,697.07c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.72,696.1c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.38,696.78c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m773.88,696.09c-.06-.03-.09-.09-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.7,696.97l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.17,696.25v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.43,696.12l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m774.56,696.2v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.44,696.96c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.07,696.02s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m776.35,695.94s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m779.02,695.68s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m778.96,695.71s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m779.57,695.73s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m783.7,697.21c.06.03.09,0,.08-.07-.07,0-.03.04-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "783.85 697.12 783.86 697.16 783.9 697.22 783.85 697.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.26,697.23s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.22,697.27s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.19,697.25v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.38,697.25l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.65,697.21c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m784.61,696.99c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "785.06 697.15 785.12 697.21 785.14 697.16 785.06 697.15"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.3,697.18l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m785.64,697.28c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.42,697s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.41,696.56c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.55,697.15s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.73,697.11s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m786.47,696.76l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "787.41 697.03 787.55 697 787.51 696.99 787.41 697.03"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "787.5 697.08 787.51 697.12 787.61 697.04 787.5 697.08"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "787.65 697.12 787.63 697.12 787.55 697.15 787.65 697.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m787.94,697.15l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m788.92,695.67s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m789.09,695.83l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m791.18,695.92c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m796.65,696.69s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m871.4,726.93c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m871.46,726.95h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m871.87,727.01c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "871.73 726.94 871.72 727 871.8 726.9 871.73 726.94"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "871.67 726.88 871.68 726.9 871.81 726.84 871.67 726.88"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m872.18,727.05l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m877.75,726.39s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m879.27,726.3s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m876.79,726.62s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.51,727.07s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m880.98,726.11s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m876.24,726.63s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m878.77,726.13s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m873.59,727.19s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.14,727.18s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.49,727.19s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m873.66,727.18s.06.21.12.03v-.02s.07-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m877.74,726.42s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m877.27,726.55s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m875.5,726.5s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m877.36,726.55s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m876.03,726.6s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m893.79,727.62s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.95,727.29h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.99,727.09s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m892.61,727.57s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m880.87,727.48s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.11,727.18s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m888.91,726.15c-.03.12.02,0,.08.06l.06-.07c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "893.83 727.65 893.83 727.64 893.83 727.64 893.83 727.65"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m890.56,726.12s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.66,727.04h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m888.01,726.08l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,0,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01,0,.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.05-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.04-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.08.06c-.01.09-.12.05-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.1,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.05.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.21.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.16.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.05s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.14.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.21.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.02l.04-.07c-.06-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.23-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.12,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.04.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m885.83,727.47s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m887.05,726.97s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m872.37,726.65l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m872.43,727.21s.04.08.06.08l.02-.05-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m873.8,727.46l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m873.31,726.57l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.09,727.47c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.02,726.51c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.68,727.18c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.19,726.5c-.06-.03-.09-.1-.16-.09.01.05.04.12.12.11l-.03.08c.08.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m875,727.38l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.47,726.65v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.73,726.52l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m874.86,726.6v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m876.74,727.37c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m876.37,726.42s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m876.65,726.34s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m879.32,726.08s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m879.26,726.11s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m879.87,726.14s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884,727.61c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "884.15 727.53 884.16 727.56 884.2 727.62 884.15 727.53"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884.56,727.64s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884.52,727.67s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884.49,727.65v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884.68,727.65l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884.95,727.62c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m884.91,727.39c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "885.36 727.56 885.42 727.61 885.44 727.57 885.36 727.56"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m885.6,727.58l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m885.94,727.68c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.72,727.4s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.71,726.97c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.85,727.55s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m887.03,727.52s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m886.77,727.16l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "887.71 727.43 887.85 727.4 887.81 727.39 887.71 727.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "887.8 727.48 887.81 727.52 887.91 727.45 887.8 727.48"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "887.95 727.53 887.93 727.52 887.85 727.55 887.95 727.53"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m888.24,727.55l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m889.22,726.07s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m889.39,726.24l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.05.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m891.48,726.32c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.12.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m896.95,727.09s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m901.32,670.1c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m901.38,670.12h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m901.78,670.18c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "901.64 670.11 901.63 670.17 901.71 670.07 901.64 670.11"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "901.59 670.05 901.6 670.08 901.72 670.01 901.59 670.05"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m902.1,670.23l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m907.66,669.56s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m909.19,669.47s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m906.71,669.79s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.42,670.24s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m910.9,669.28s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m906.16,669.8s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m908.69,669.3s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m903.51,670.36s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.06,670.35s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.4,670.36s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m903.58,670.35s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m907.66,669.59s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m907.19,669.72s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m905.42,669.67s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m907.28,669.73s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m905.95,669.77s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m923.71,670.79s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.87,670.46h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.9,670.27s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m922.52,670.74s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m910.79,670.65s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.02,670.35s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m918.83,669.32c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "923.75 670.82 923.75 670.81 923.75 670.82 923.75 670.82"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m920.48,669.29s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.57,670.21h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m917.92,669.25l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.1.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.07.02-.09.1-.2.07.07-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.12-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.04.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.12-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.05-.08.17.01.18.02-.04.03-.11.09-.08l-.03.04c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.02.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.15.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.16-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.24.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.03-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.02-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.07-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m915.74,670.64s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.97,670.14s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m902.29,669.82l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m902.35,670.38s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m903.72,670.63l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m903.23,669.74l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.01,670.64c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m903.94,669.68c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.6,670.35c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.11-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.1,669.67c-.06-.03-.09-.09-.16-.09.01.05.04.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.92,670.55l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.39,669.82v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.65,669.69l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m904.78,669.77v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m906.66,670.54c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m906.29,669.59s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m906.57,669.51s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m909.24,669.25s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m909.17,669.28s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m909.79,669.31s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m913.91,670.78c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "914.07 670.7 914.08 670.74 914.11 670.79 914.07 670.7"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m914.47,670.81s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m914.44,670.84s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m914.41,670.82v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m914.6,670.82l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m914.87,670.79c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.11.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m914.83,670.57c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "915.28 670.73 915.34 670.78 915.36 670.74 915.28 670.73"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m915.52,670.76l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m915.86,670.85c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.64,670.57s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.62,670.14c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.77,670.73s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.94,670.69s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.15-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m916.69,670.33l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "917.63 670.61 917.77 670.57 917.73 670.57 917.63 670.61"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "917.72 670.65 917.72 670.69 917.83 670.62 917.72 670.65"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "917.87 670.7 917.85 670.69 917.77 670.73 917.87 670.7"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m918.16,670.72l-.03-.06s-.11-.05-.1.03c.03-.03.1-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m919.13,669.25s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m919.3,669.41l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m921.4,669.49c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m926.87,670.26s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m614.75,96.96c-.04.09.01.03.06.02l-.06-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m614.81,96.98h.04s-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m615.21,97.04c-.09.07-.2-.03-.26.08.09.07.24.04.26-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "615.07 96.97 615.06 97.03 615.14 96.93 615.07 96.97"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "615.01 96.91 615.03 96.93 615.15 96.87 615.01 96.91"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m615.52,97.08l-.09.02c-.09-.08.06-.11,0-.17-.12,0-.04.17-.18.15.01.08.23,0,.21.12.12.04,0-.07.07-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m621.09,96.42s0,0,.01.01c0-.01-.01-.02-.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m622.62,96.33s.04.02.06.03c0-.01-.01-.02-.02-.03h-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.14,96.65s-.04-.02-.06-.03c.01.02.03.03.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m629.85,97.09s0,.02,0,.04c0,0,0,0,0,0l.02-.03h-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m624.32,96.14s.05,0,.07-.01c-.04,0-.06,0-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.59,96.66s.02,0,.02,0c0,0-.02,0-.03-.01h0s0,.01,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m622.12,96.16s.04.02.06.01c-.02-.01-.04-.01-.06-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.94,97.22s.05,0,.07-.01c-.02-.02-.04-.02-.07.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.48,97.21s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.83,97.22s0,0,0,0c0,.01,0,.01,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617,97.21s.06.21.12.03v-.02s.08-.03.12-.03c0-.02,0-.03-.01-.04-.02,0-.05,0-.09-.02-.05-.04-.08.05-.13.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m621.08,96.45s-.04-.02,0,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.61,96.58s.03,0,.05,0c-.01,0-.03-.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.84,96.53s0,0,0,0c0-.02,0-.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.7,96.58s-.03,0-.04,0c.01,0,.03.01.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.37,96.63s0,0,0,0c0,0,0,0,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m637.13,97.65s-.06-.03-.09-.04c-.08.11.16,0,.05.1.03,0,.06-.02.08-.03l-.05-.11c-.07.04.04.04,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.29,97.32h-.02s0,.05.06.08c.05-.07-.03-.19.06-.27-.02,0-.04,0-.07,0,.04.07,0,.14-.04.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.33,97.12s0,0,0,0c0-.01,0-.02-.01-.03-.01,0-.02,0-.03-.01,0,.02.03.04.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m635.95,97.6s-.03,0-.04-.01c.02.02.03.02.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m624.21,97.5s-.03.02-.05.03c.03,0,.04-.02.05-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m629.45,97.21s-.03-.01-.04-.02c0,0-.02,0-.03,0h.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m632.26,96.18c-.03.12.02,0,.08.06l.06-.06c-.05-.02-.1,0-.14,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "637.18 97.68 637.18 97.67 637.18 97.67 637.18 97.68"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m633.91,96.15s.02.01.03.02c0,0-.01-.01-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630,97.07h-.21s.06.02.06.02c.03-.06.12.05.15-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m631.35,96.11l-.02-.07c-.21.16-.45-.07-.62.15-.26-.26-.17.23-.4,0v.04c-.77-.04-1.59-.18-2.31-.05v-.05c-1.17-.09-2.3.02-3.46-.02-.11.05-.04.16-.14.22-.04,0-.13,0-.13-.06.08-.04.03-.09.06-.12-.13,0-.3-.07-.41.01l.1.08s-.12.01-.16,0c.02-.04-.04-.13,0-.15-.25.21-.19-.09-.4,0-.04.18-.3.32-.47.45l-.09-.05c.12,0,0-.13.15-.12-.12-.05-.24.02-.35,0,.02.04.02.1-.03.12-.07-.02-.08-.11-.16-.12l.08-.06c-.05-.07-.1.02-.15.03-.02-.07-.14-.09-.12-.17-.11.1-.15.04-.27.11.12.08-.03.1-.02.16l.14-.03c-.2-.05.06-.01.05-.14.09.06-.13.21.03.19-.18.06-.22,0-.41.11.11-.02-.02.08.04.12-.14,0-.04-.04-.08-.12-.08,0-.11-.07-.18.02-.13-.04.02-.09-.05-.15.05-.09.35.11.32-.17.07,0,.15-.11.24-.1-.08-.04-.2-.13-.31-.06v.16c-.08,0-.1.11-.16.1.03-.04-.02-.11-.09-.1.02.02.04.02.04.04-.12.01-.13.12-.27.15.11.04.14.09.25.15-.03.11-.08.02-.14.03,0-.01.02-.02,0-.04l-.07.05c-.14-.05.02-.16-.1-.21-.08-.09-.11.05-.17,0,0,.01,0,.02.01.03-.01,0-.02,0-.03,0,0,0,0,0,0,0-.08.02-.16,0-.18.09,0-.04-.07.01-.09.04-.04.03-.14.13-.21,0,0,0,0,0,0,0-.09-.02-.17-.06-.15-.1l-.15-.03.02-.11c-.14.03-.12.09-.22.2-.1-.06-.27-.01-.34.03-.01,0-.03,0-.06,0l.06.04c-.11,0-.09.05-.17.05.01.01.02.02-.02,0-.01,0-.03,0-.04,0,0-.01.02,0,.04,0v-.04c-.1-.11-.15.06-.24.02,0,0,.02-.01.03-.01-.05-.03-.13-.18-.15-.09-.01-.01-.03,0-.05.03l-.04-.02s.03.01.04.02c-.02.03-.05.07-.05.05l-.13-.02s-.06,0-.09.01l-.02-.04s-.05-.02-.04-.03c-.17-.15-.26.08-.44-.05-.03.07.04.11.05.15-.03.06-.13.11-.18.15-.08-.1-.33-.19-.29-.34-.15-.01.05.09-.03.14h-.02c.05.01.09.06.12.12.01.08-.12.1-.16.08l.03-.11c-.14.04-.11.21-.2.32-.11-.04-.05-.15-.07-.25l-.12.03v-.08c-.08.02-.09.1-.2.07.08-.08-.16-.08-.05-.19-.06-.03-.07.13-.1.02-.04.09.05.04.08.07.02.13-.13.06-.2.1,0-.07.05-.08-.04-.12-.02.05-.07.09-.11.03,0,.08-.09.02-.14.01.05.02.13.08.09.15-.04.03-.08.05-.17.04l.06.04c-.08.12-.13-.09-.24-.05.05-.05.08-.05.12-.11-.05.04-.15.1-.23.14l-.09-.12c-.01.06-.1,0-.1.08-.11-.06.09-.1.1-.16-.14-.06-.12.14-.25.01l.05-.08s-.14.04-.14,0c0,.03.02.02.05.02-.03.17-.21.12-.2.29h.06c-.1.04-.17.16-.24.1-.06-.06.04-.12.07-.16-.09-.01-.07.19-.18.17.06.03.05.09.01.13.06.01.2.04.17-.03l-.02-.02s.04-.06.06-.08c.09,0,.04.08.06.11.14.03.01-.17.14-.17l.02.03c.06-.05.16-.05.18-.16.06.11.15-.04.21.02.01.25-.22-.02-.3.12.07.05-.04.12-.07.17l.22-.11s.08.16.12.07h-.02c.09-.03.06-.14.14-.1.01.02-.01.06-.02.08.07.02.06-.06.1-.08.07.02-.03.1.02.13.08-.1.13.02.2.02-.03-.14.28-.19.13-.31l.17-.1c.05.07-.11.2-.07.31h-.13c.02.17.28-.12.37.08.07,0,.05-.02.19.07l-.02-.16c.07.04.09.12.1.15.04-.01.08,0,.12,0-.01.02-.02.04-.05.05.05.09.07.05.09,0,.03-.04.07-.03.11-.03l-.04.06s.06-.03.06-.06c.02,0,.04,0,.05-.01-.01-.03-.04-.12-.1-.16.16.06.29.03.43.16,0,.05-.06.1-.05.11.07.02.14-.06.14-.12.02,0,.03,0,.04,0,.01.04.03.08.06.09,0,.01.02.03.04.03.02-.12.16-.06.18-.12-.03-.01-.07-.01-.11,0,.06-.08.11-.18.15-.11-.1.08.11.13-.05.16.11.16.06-.11.17-.06l.07.06c-.01.09-.12.04-.1.08h.05c-.05.06-.25.01-.37.11l.24.05c.31-.11.69.02.95-.18,0,0,0,0-.01,0,0,0,0-.03.01-.06v.02s.06-.07.06-.07c.06.08.17.1.26.17q-.06-.06-.06-.12c.01-.09.02-.13.11-.09,0,.06-.05.06.01.11-.03-.03,0-.08.03-.08.05.04.13.05.13.11-.02.02-.04,0-.06-.01-.02.02.09.06.02.11l.09-.02c.05.05-.03.08-.01.12.15-.04.22-.19.35-.23,0,.03,0,.18,0,.14.1.04.22-.16.34-.17-.02.04-.06.03-.1.05.36.05.65.06.98.19l.09-.15.09.1c.35.09.62,0,.95-.04.1,0,.06.1.11.14.23.02.28-.15.5-.18-.03.04-.08.17.01.18.02-.04.03-.11.09-.08l-.03.05c.05.07.11,0,.22.03.2,0,.39-.11.55-.27.17.01-.02.16.01.19-.12-.05-.09.03-.11.08.07-.04.14-.07.18.04.09,0,.13,0,.22-.07-.05.04-.08-.02-.04-.07.07.04.26,0,.25.13.43-.03.91,0,1.37,0,.08-.07-.06-.03-.02-.07.11-.09.09.05.18-.02l-.04.07c.13.01.28-.12.41-.19-.02.08.11.07,0,.12.06-.01.14.35.19.28l-.07-.34s.09-.01.08-.04c.06.07.12.15.16.15.02.09-.08.07-.13.07,0,.14.18.09.1.22.11-.02-.02-.07.05-.13l.1.03-.08-.05c.08-.04.11-.15.22-.07l.11-.14c.01.11.08.02.14.05l-.04.07c.08,0,.11.02.16.06-.04.1-.07-.02-.09.07l.09.03c0-.06.05-.11,0-.15.08-.12.12-.22.32-.21.09.11-.1.1-.06.2.21.05.25-.28.38-.27.16.04.15-.06.3-.06-.05.07.11.08.14.15l-.06.08s.09,0,.08.06c0-.1.2-.09.31-.14l-.02-.09c.08-.03.2-.08.29-.06.13-.03.1-.1.21-.2.06.08.05.17.03.26-.04-.04-.1-.02-.15-.04-.17.07-.3.26-.47.21-.07.21.11-.02.2.05,0,.01,0,.02-.01.02,0,0,.01,0,.02,0-.06.03-.16.06-.18.17.1-.02.07-.21.2-.12.09-.06.17.11.22.12.06-.08.06-.25.22-.21l-.07.12c.17,0,.08-.17.24-.17-.06-.01.05-.11-.05-.12.05-.06.17-.07.26-.04.02-.02,0-.04,0-.08-.1-.08-.15.08-.23-.04l-.07.13c-.09-.05-.1-.15-.04-.2-.03,0-.05.02-.07,0-.02-.19.11.07.14-.09h-.06c-.03-.11.15-.09.23-.09.09.06.18.08.18.17l-.12.04c.06.07.16-.04.23-.04,0,.01.01.02.02.03,0,0,0-.02,0-.02.02,0,.03.02.04.04.06,0,.16-.05.21-.02v-.08s-.02.04-.02.04c-.06,0-.14-.05-.09-.11.13-.06.16.1.19.17-.03.12-.13,0-.19.04.04.12.13.01.27.09-.05.13-.16,0-.19.12.11.02.14-.07.25-.04-.01.06-.13.07-.12.15l.07.04c-.18,0,.03.16-.11.2.07.05.09-.11.19-.02-.03-.06-.1-.16-.01-.21l.1.04c.04.06-.11.14-.04.19l.11-.04s-.05-.06-.02-.11c.06.04.1-.15.17-.21.06,0,.1.01.12.06.15-.12.33-.11.46-.22-.09.08,0,.13.06.19-.11.02-.11.14-.1.22.06-.01.11-.14.07-.18.11.05.07-.09.17,0,.06.04-.03.12,0,.17.12,0,.03-.15.16-.12,0,.02-.02.02,0,.04.07.03.14-.03.16-.09.07.16.2-.02.19.14.16-.04-.02-.09,0-.14.07-.07.19-.01.23.01-.04,0-.08.05-.12.02l.03.11c.2.08.13-.25.33-.15-.1.06-.03.08-.08.16.03-.03.18,0,.09-.08.07,0,.13.03.18.05.07-.04.14-.07.18-.14.1.01.18.09.23.14.22-.08.42.06.65-.03h-.02c.18.01-.08-.15.11-.15-.02.13.11.09.17.16.23.07.39-.1.6,0,0,.03-.02.06-.06.06.16.04.29.02.43.02v.02c.22.11.43-.02.67-.05-.02.02-.02.07-.04.08.12.03.31.05.4-.07.14.13.09-.04.28.09.01.02-.02.02-.03.03.09.04.15.03.25.05.2-.08.25-.26.49-.2.01.18-.14.04-.15.19.05-.03.09-.07.15-.03-.04.07,0,.04-.04.11.05.05.2-.19.2-.17,0-.04-.01-.05-.06-.05.05-.11.23,0,.34-.05-.04,0-.15-.04-.11-.12.15.04.2-.14.31-.21.14.08-.1.15-.08.28.02.05.08.15.02.2.13.03.22-.08.33-.11v.04c.15-.01.32-.17.45-.1l-.07-.04s.1-.01.15-.08c0,.06.1.11.06.16.07-.19.36-.12.44-.3.04.05,0,.13,0,.17-.1-.02-.13-.05-.18.02.08,0,.14.05.13.09.08-.12.28-.17.32-.28.06.06.12.09.1.19.25-.06-.12-.31.16-.3.13.1-.13.13.05.16l-.03.02c.13.26.09-.18.24-.17.02.14-.1.1,0,.2.13-.04.19-.24.33-.2l-.02.06c.09-.01.25.02.34,0,0,.03,0,.02-.02.03.16.05.07-.07.2.03l.04-.07c-.07-.05-.19-.12-.27-.04.08-.08-.13-.18-.09-.29l-.02.05c-.22-.2-.49-.23-.77-.31-.17.14-.29-.06-.48.04-.03.16-.03.03-.19.07.08-.02.01-.12-.04-.15-.03.04-.07.06-.11.07-.03-.06-.23-.19-.31-.08-.1-.05.02-.05.04-.09-.04-.08-.08.07-.11,0,0,0,0-.02.01-.03-.15,0-.24-.04-.39-.06-.01.16-.15.06-.22.12.02-.05-.09-.06-.13-.09l-.08.12c-.08.1-.11-.07-.22-.02l.03.03c-.08.05-.28-.05-.36-.13-.71.31-1.1-.18-1.85-.09-.05.05.04.08,0,.15-.08.02-.09.01-.16.01.06.04.05-.01.04.03l.11-.04s0,.02,0,.04c.04-.01.08-.05.12-.04-.07.04-.08.16-.17.11,0-.02.02-.02.04-.03-.07,0-.08.05-.13.02-.07-.03-.05.01-.06-.04l-.21-.06c-.11.14-.24,0-.27,0,.02-.11.14-.03.19-.14l-.08-.08v.08s-.11-.02-.11-.02v-.02s-.02.07-.05.04c0-.01-.02-.03,0-.04l-.08.05c.05-.09-.07-.03-.06-.13-.25-.05-.32.14-.54,0,.04.05-.07.16-.14.14-.04-.02-.05-.05-.02-.09l-.09.05c-.11-.16-.22-.06-.39-.11v-.04c-.05.05-.12.09-.21.08l.02-.09c-.11-.06-.09.19-.21.13,0,.1.08.14.09.24-.03-.1-.16-.11-.13-.04-.12.04-.09,0-.1-.03l-.07.06c-.09,0-.03-.13,0-.18-.08.1-.17.03-.26.01l.04-.04-.12-.02c-.08.07-.19.08-.29.04l.07-.13c-.07-.07-.04.04-.06.06-.11.06-.14-.02-.2-.09-.18.13-.36-.21-.51-.02Zm-12.47.49l.02.02s-.06.04-.02-.02Zm.99.04c-.12.05-.08-.01-.09-.05.12.03.18,0,.29.04-.02-.03-.02-.06-.03-.08.04,0,.08.03.1.1-.05.13-.32-.08-.27,0Zm-2.24.62s0-.02.01-.03h0v.03Zm.58-.11s.02.04.04.05c-.01-.03-.02-.06-.04-.05Zm1.18.16c.03.05.09.04.13.02-.02,0-.06-.02-.13-.02Zm7.43-.06s-.1.07-.04.11c.03-.05.09.03.11-.04,0,0,0,0,0,0-.04-.04-.06-.08-.08-.08Zm3.49-.43c0,.05-.03.11-.02.15,0,0,0,0-.01,0,0,.02.02.03,0,.04.03.01.06.02.08,0,0-.17.07-.2-.06-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m629.17,97.5s.02,0,.03,0c0,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.4,97s-.03-.03-.07-.05c0,.02.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m615.72,96.68l.03-.02-.07-.05c-.12.06-.12.13-.15.21.1-.08.17-.04.3-.06l-.12-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m615.78,97.24s.04.08.06.08l.02-.05-.08-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.14,97.49l-.11-.04s.09.12.11.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m616.66,96.6l-.06.06c.05.04.12.04.13-.02-.07.03-.02-.03-.07-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.44,97.5c.03-.1.11.04.13-.05-.03.03-.13-.05-.13.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.36,96.54c-.03-.1-.09-.01-.16-.03.06,0,.14.1.16.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.03,97.21c0,.07-.05.07-.1.05.02-.02.03-.06.05-.07-.09.06-.09.04-.16.08.07.05.17.08.16.17.05-.07.12-.17.05-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.53,96.52c-.06-.03-.09-.09-.16-.09.01.05.03.12.12.11l-.03.08c.07.06-.03-.11.07-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.35,97.41l-.03-.04c-.08.07-.18.03-.23.14.1,0,.22-.05.27-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m617.81,96.68v-.12c-.07-.02.02.04-.01.07-.02-.02-.06-.03-.07,0,.09-.02,0,.1.09.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.08,96.55l.1-.05-.08-.13c-.12.04,0,.07-.02.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m618.21,96.63v.02s.17-.17.17-.17c-.09.07-.1.06-.17.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620.09,97.4c.02-.05-.07-.11-.03-.06-.02.04.1.11.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m619.72,96.45s.19-.03.25-.07c-.08.02-.26,0-.25.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m620,96.37s-.01,0-.03.01c.01,0,.02,0,.03-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m622.66,96.11s.01,0,.02-.01c0,0-.01,0-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m622.6,96.14s-.13.01-.14.07c.07-.03.13-.04.21-.1-.03,0-.07-.03-.06.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m623.21,96.17s-.08.02-.06.06c.02.02.09-.03.06-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m627.34,97.64c.06.03.09,0,.08-.07-.07,0-.03.05-.08.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "627.49 97.56 627.5 97.59 627.54 97.65 627.49 97.56"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m627.9,97.66s-.01.02-.02.03c.02-.01.04-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m627.86,97.7s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m627.84,97.68v.04s.01-.01.03-.02c-.01,0-.02,0-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m628.02,97.68l-.08-.11c-.08.06.09.06.01.18l.07-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m628.29,97.65c.07.04.18-.14.22,0,.21-.07-.05-.22.19-.27-.23-.07-.12.26-.32.18.1.08-.07.07-.1.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m628.26,97.42c-.01.07.08.07.11.03-.03,0-.07-.1-.11-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "628.7 97.59 628.77 97.64 628.78 97.6 628.7 97.59"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m628.95,97.61l-.06.08s.11-.02.06-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m629.28,97.71c.06.03.11-.15-.01-.11h.03s.06.1-.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.07,97.43s-.09.02-.08.06l.11-.04-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.05,97c-.04-.11-.1,0-.18-.03.08.02.07.04.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.19,97.58s-.08.02-.1,0c.01.06.09.05.1,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.37,97.55s0,.06.02.09c.08.05.16.04.2-.02-.02-.05-.05-.17-.02-.23-.12.04-.19.24-.25.08l-.1.19c.1.03.08-.13.14-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m630.12,97.19l.07.06c-.01-.06.04-.07.07-.09-.02-.14-.1.02-.14.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "631.06 97.46 631.2 97.43 631.15 97.42 631.06 97.46"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "631.15 97.51 631.15 97.55 631.26 97.47 631.15 97.51"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "631.29 97.55 631.28 97.55 631.2 97.58 631.29 97.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m631.59,97.58l-.03-.06s-.11-.05-.1.03c.03-.03.11-.02.13.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m632.56,96.1s-.01.07,0,.11l.04-.1s-.04.01-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m632.73,96.26l.1-.11c-.12-.02-.14.07-.24.09.04.04.11-.04.16-.01l-.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m634.82,96.35c0,.07.01.06-.06.11.11-.05.2-.03.32-.04-.02-.05.07-.13.02-.11l-.14.04.02-.05c-.1-.06-.06.08-.16.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m640.29,97.12s0,.07.02.1c.08-.04-.04-.09-.02-.1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m118.08,954.54s0-.02,0-.03c0,.01-.01.02,0,.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113.99,954.31l.05-.02s-.04,0-.05.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.53,954.63s0,0,0,0c.04,0,.09,0,.17,0h-.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m105.28,954.07h.05s-.04,0-.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.44,954.23s-.04.02-.07.02c.03,0,.06,0,.07-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m121.82,955.37l-.07-.05s.03.04.07.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m124.31,955.17s0,0,0-.01c0,0,0,0,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.34,954.97s-.05.01-.07.02c.03,0,.07,0,.07-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m123.23,955s.02,0,.03-.01c-.02,0-.03,0-.03.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m73.61,954.31c-.07,0-.13.04-.2.07l.2-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m97.38,954.04l.02-.02s-.02.01-.02.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m73.52,954.75h-.05s.03,0,.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.51,955.5c-.07.05-.22,0-.22.04.08,0,.18.03.22-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m95.71,955.88h-.05s.04,0,.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m73.52,954.75h.06s-.01,0-.02-.01c-.01,0-.03.01-.04.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m89.16,954.02h0s.01,0,.02,0h-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m88.73,953.94s.06,0,.09-.02c-.05,0-.08,0-.09.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m73.41,954.38l-.11.04s.08-.02.11-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m84.03,954.01s.03,0,.04,0c-.02,0-.03,0-.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.77,954.26s.03,0,.04.01c0-.01,0-.02-.04-.01Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "107.53 955.56 107.53 955.56 107.53 955.56 107.53 955.56"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m107.7,955.5c-.05-.01-.13.02-.17.06.05,0,.11-.01.17-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m107.15,955.54s.01,0,.02,0c0,0-.01,0-.02,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "110.64 955.63 110.64 955.63 110.64 955.63 110.64 955.63"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m109.95,955.64s-.03-.02-.05-.02c.01,0,.03.02.05.02Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "105.43 955.67 105.44 955.67 105.43 955.67 105.43 955.67"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m98.92,956.04c.65-.03,1.5-.13,2.15-.1.14-.1.35-.1.55-.13l.02.13.17-.04c.07.04-.13.03,0,.08l.07-.08s.44.03.15.13h.67c.15,0,.09-.11.25-.08.03.04-.06.03-.05.07.49.1.57-.26,1.03-.2l-.04.02c.08-.04.23-.03.23-.05-.06-.13-.08.07-.22,0,.01-.11.17-.06.17-.15.11.04.17-.02.26-.03.16.07.39.02.51.11.08-.04.17-.15.33-.15.12.09-.03.08.14.12l.03-.07c.13.01.11.03.11.06.14,0,.12-.09.3-.05l-.1.06c.13-.02.19-.01.37,0,0,.04-.08.04-.13.02.1.1.17-.04.23-.03-.02-.03-.14-.04-.08-.11.09.01.2-.09.26-.01l-.1.06c.19-.05.1-.08.32-.06-.01,0,0,.02-.01.04.14-.08.32,0,.53,0l-.04.02c.08-.02.13-.08.17-.08-.12-.04-.09-.06-.1-.12.16.11.24-.13.49-.06,0,.04-.07.08-.13.04-.09.11-.1.21-.25.26.1-.03.21-.04.19,0l.03-.1c.06,0,.1,0,.15,0,.02-.07-.12-.11.02-.15.15-.03.08.11.1.06.21-.04.09-.11.29-.08-.02,0-.06.03-.08.02.14.04.35-.02.4.11-.02.03-.03.07-.08.05v-.02c-.16.09.13-.02.09.09-.01-.07.19-.05.28-.04l-.03-.08c.3-.23-.02.15.28.12.19-.05-.07-.02.05-.07.13.01.18.08.37.05.05.03.16.07.17.16.11-.03.35.04.41-.04-.2-.07-.2.09-.42-.02l.06-.08c.16,0,.36-.04.47,0-.02-.02-.03-.04-.02-.06.23-.03.29-.12.51-.09.03.08-.1.06-.19.07.14.06.15,0,.37.03.01.07-.15,0-.17.06l.24-.02s0,0,0,.01c.04-.11.19.01.34-.02.35,0,.41-.15.6-.24.05.03.07.06.05.09-.09-.05-.07-.01-.1.02.12-.01.26.11.19.16.19-.03-.07-.06.05-.09h.26s-.12-.06.01-.11c.11-.02.17,0,.32,0-.02.03.05.09-.06.08.07.02.18.02.23-.03-.16-.05.27-.05.14-.14l.16.05s-.04.04-.1.03c.05.09.13-.02.19-.03.06.02.21.02.22.06.05-.02.18,0,.2.04.08-.02,0-.06.03-.08h.26c.01.06.04.19,0,.21.1-.04.04-.14.18-.14-.08.09.2.07.07.18.08.07.33.07.46.04.08-.07-.14-.04-.14-.12.37-.03.4-.24.67-.2l-.07-.02c.17-.04.15-.03.25-.1-.05.09.19.25.48.23.02-.05-.16-.09-.11-.16h.19s0,0-.03.02c.17-.03.31.12.36.01l.17.14-.07-.06s.21-.06.25-.08c.19-.05.26-.01.37.05-.03-.04-.12-.13.03-.14,0,.15.32.06.31.14.06,0,.17.05.18-.02v.09c0-.13.23-.13.4-.15-.04.18.19-.01.26.15.03-.12.3-.05.33-.15.13,0,.12.11.15.15l.06-.05c.07.06.31.07.46.1l.14-.11.05.05s.14-.04.06-.08h.07c0-.11.1-.03.25-.08.03.02.02.05,0,.06.07,0,.04.06.08.1-.05-.03.26-.21.07-.26-.01-.05.1-.08.17-.06l.04.11.09-.11c.11-.02.16.05.25.06-.09,0-.21.2.03.2-.13.01-.19.07-.26.09.05,0,.07.01,0,.06.19-.03.06-.06.25-.08-.01.09.04.12.21.16l-.12-.07s.01-.02.02-.03c-.05-.01-.06-.02-.07-.06.04,0,.22-.12.25-.06-.19-.15.33-.11.21-.2.02-.03.15-.03.17.01-.16.07.12.11.09.17.06-.03-.12-.07-.04-.11.09,0,.16.05.21.08l-.04.02.14.04s-.14-.08,0-.1c.03.02.17,0,.16.03-.06.06-.02.15-.13.17.09,0,.39-.02.27-.11h.11c-.07-.04-.27-.11-.04-.12v.02s.15-.07.15-.07l.07.05s.02-.05.08-.04c.02.03.07.04.07.08.17,0,.15-.05.18-.08.09,0,.13.01.09.07.13.01.35,0,.44.05.17-.04-.04-.02.07-.08.15.17.57.06.85.04-.08-.14.08-.02.13-.15-.06.05.27.11.02.15l.15-.02c.1.08-.25.06-.09.17.17,0,.28-.16.48-.11-.07.1.15-.03.1.08-.04.04-.1.03-.15.03l.03.02c.37.03.11-.12.3-.19.22-.01.18.08.19.13.03.02.15,0,.21-.02-.14.06-.25-.06-.19-.13.1.12.33,0,.39-.04-.32-.12-.22,0-.52-.14-.04.04-.03.14-.22.1.11-.05,0-.06-.04-.08.03.06-.13.03-.18.05-.05-.05.11-.14-.07-.16l-.03.14c-.07-.02.03-.1-.12-.07.08-.07-.02-.11.18-.14-.25-.12-.38.06-.57.12.02,0,.02-.03.04-.04-.04.04-.12.03-.17.04-.13-.03.1-.06.07-.1h-.2s0,0,0,0c-.05.02-.11.03-.12,0,.06-.05.08-.09.13-.13l-.22.1s-.18-.08-.02-.11l-.32.02-.03-.1c-.08.02-.08.04.01.05-.11-.02-.48.17-.42-.02-.25.08-.34.05-.64.09.23-.09-.27-.11-.02-.15-.14-.04-.17.06-.29.08-.11-.04-.06-.13.06-.17l-.14.04v-.02s-.11.05-.11.05c-.12-.05-.03-.1-.16-.11l-.03.08-.09-.05s-.04.06-.14.06v-.02s-.11.02-.11.02c.11-.05-.1-.02-.05-.08-.1,0-.1,0-.27.01l.03.06c-.23.05,0-.09-.19-.09v.07c-.26-.11-.44.06-.64,0,.11-.02.08-.09.08-.07-.17.02-.45,0-.62.09-.06-.1-.08-.12-.26-.17-.13,0-.15.01-.19.07-.13-.04-.37.02-.37-.05-.03.06-.11-.01-.18.04v-.03s0,.07,0,.07c-.23-.15-.38.08-.61-.05l.04-.02-.1.03s.02-.05.03-.08h-.45s.09.04.09.04c-.09,0-.16.07-.26.03.18-.1-.15,0-.18-.08l.1-.03q-.13,0-.12.07c-.17.02-.12-.13-.27-.06h.11s-.05.1-.12.09c-.02-.01-.07-.04-.01-.05-.13.03-.33,0-.39.02-.07-.02-.05-.07,0-.09-.29.06-.13-.01-.41.04v-.04s-.09.04-.09.04l-.14-.08.05.05c-.09,0-.15.03-.26.01l.04-.06c-.26.03-.31-.09-.56-.02-.02-.01.02-.03.04-.04-.23.09-.18-.1-.41,0,.01-.02-.01-.04,0-.06l-.11.04v-.08s-.08.11-.08.11l-.07-.08-.04.04c-.11-.15-.27-.04-.43-.15l.03.1c-.39.2-.9-.11-1.37-.02v-.08s-.19.09-.19.09c-.1-.06.06-.06.03-.1-.21.04-.09.11-.33.13-.12-.05.04-.06.1-.08-.23.04-.57.08-.73.04,0,.01-.01.02,0,.03-.15.03-.35,0-.52,0,0-.03.05-.04.09-.05-.06,0-.14-.03-.19,0l.06-.06c-.13-.01-.38.05-.41-.03.02.03,0,.09-.1.08-.06-.12-.3.05-.48-.01.02-.03.15-.03.12-.03-.09-.03-.17.02-.25.06l.02-.05-.42.06c-.06-.12-.39.02-.36-.07-.15,0,.12.05-.06.06-.05-.05-.17.02-.16-.05h.02s-.13,0-.13,0l.08-.07c-.11.02-.2.09-.2.15-.11-.04-.26,0-.31-.08l.04-.02c-.3.03-.5-.2-.73-.08-.02-.01-.02-.03.02-.03h-.19s.04-.06.04-.06l-.31.09v-.04c-.2-.02-.52,0-.78.02l.04-.02c-.29.06-.28-.04-.48,0,0,0,.01-.01.02-.02h-.19s.04-.04.04-.04c-.14.08-.4-.11-.31-.04-.08.04-.21.08-.24.13-.2,0-.05-.05-.18-.08-.15,0-.17.06-.37.03v-.04c-.09,0-.15.03-.28.04l.04-.02c-.21.08-.27-.11-.43.05-.09-.03-.26,0-.25-.08-.27.05-.47.07-.74.1-.04-.12-.06,0-.22-.06v.07c-.36,0-.79-.16-1.2-.13v-.07s-.09.07-.09.07c-.44-.03-1.02-.06-1.37-.06-.12.03-.29.11-.48.09h.02c-.32.03-.66.06-1.01.02.02-.03-.01-.05.03-.07-.08.07-.2,0-.28,0l.09.05c-.1.06-.24,0-.29-.05l-.16.07s-.03-.02-.03-.03l-.03.04-.08-.09s-.25.04-.31.12c-.02-.03-.16-.05-.05-.07l-.57-.03.09.03c.01.07-.16.11-.25.08.12-.05,0-.09-.04-.14-.08.04.07.06.03.1-.1.04-.31.07-.36.04l.06-.03c-.13.02-.19-.09-.33-.09-.12.05-.2,0-.18.12-.17.02-.07-.08-.12-.09-.08.05-.32.02-.35-.04-.09.17-.46-.06-.49.08l-.14-.08s-.03.12-.15.14c-.11-.04-.08-.11-.11-.15l-.07.14c-.61-.15-1.43-.05-2.1-.17-.3.03-.68.09-1.03.08l.04-.02-.35-.04.25.06c-.08.02-.14.04-.21.04-.38-.06-.89-.13-1.37-.06-.31.16-.2-.14-.5-.03.03-.01.03-.04.06-.05-.32.05-.49.08-.8.18.04-.16-.21,0-.18-.08l-.03.07c-.07-.04-.24-.05-.21-.1l-.14.08v-.07c-.2,0-.59.05-.69-.09-.46.1-1.18.07-1.75.04-.08.05-.25.06-.38.06l-.14-.08c-.13.02-.27.12-.4.07,0,0,0-.02.01-.02-.14.02-.26-.03-.39.05-.15,0-.29-.05-.25-.12-.01.13-.31-.02-.31-.02,0,0-7.61-.32-9.47.4-.06.06-.24.11-.17.19-.13.02-.19-.09-.22-.03.18.04-.06.17.12.25l-.11.02s.15-.05.13.03l.03-.12c.09.02.14.04.18.09.09-.05.14-.21.35-.14h-.06c.17,0,.1.09.14.11h-.04s.14.06.14.06c-.11-.04-.28.06-.19.05.2.03-.05-.03.1-.04.09,0,.07.06.06.1h.17c0,.05-.11,0-.04.05l.21-.06c.04.14.23-.07.33.07-.15.03.01.05-.01.09h.37s-.1.04-.04.03c.07.04.12-.04.15-.03.03.04.28,0,.27.09.25.06.11-.12.34-.07.03.06-.19.01-.08.07l.24-.02s-.05.09-.14.08c.66.08,1.02.38,1.62.3.09.07-.06.05-.12.09.44-.09.62.15.99.14v-.06c.53.18,1.15.07,1.74.14l-.07-.04c.08-.05.21-.06.31-.09.01.03-.07.12.1.1-.04-.02-.11-.04-.09-.07.5.15,1.57.11,2.4.18,1.12-.04,2.34.07,3.44.03-.17,0-.1-.14.03-.1.35.24.6-.04.95.12.64-.08,1.21.13,1.81-.05v.07c.1.03.12-.02.22-.02v.02c.22.03.49-.04.61-.01v-.08c.14,0,.08.06.21.02v.04s.15-.07.15-.07c-.02.13.37.01.48.07.17-.02.49-.08.75-.05.05.07.36.07.57.1.39-.02.95-.04,1.45-.02v-.09s.12,0,.12,0c0,.02.02.03,0,.04.1.1.3-.03.41.03-.07-.08-.09-.01-.17-.01-.11-.04,0-.12.14-.08v.02s.1-.04.1-.04c.01.07.1.1.11.16.43-.02.72-.13,1.16-.1-.05.07.32-.02.23.11.27-.05-.04-.1.08-.2.07,0,.15-.03.17.01-.03.03.06.08,0,.09h.18s-.02.02-.04.03c.36-.07.64.08.97,0,.02-.05-.13-.01-.11-.06.33-.09.29.08.59.02l-.06.06c.1-.04.14-.1.3-.05.03.08-.14.06-.22.1.11,0,.39-.02.31-.09.13-.03.18.04.25.06,0-.02-.12-.05-.05-.09.18.04.46.04.68.05,0,.02.01.05,0,.06.18-.1.16.07.4.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m110.73,955.65h-.09s0,.02-.05.04l.13-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m106.49,955.6s-.02.01-.03.02c.02,0,.03-.01.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m105.46,955.73c.07-.02,0-.04-.03-.06,0,.02,0,.03.03.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m113.14,955.44s-.03.02-.02.03c.02-.01.03-.02.02-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.77,955.5s-.02,0-.03-.01c0,0,.01,0,.03.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.41,955.38s-.04,0-.07.01c.03,0,.06,0,.07-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m111.53,955.47s-.05,0-.07.02c.04,0,.06-.01.07-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.25,955.41h-.09s0,0,0,0h.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m119.89,955.51s-.09,0-.12,0c.05.02.08.02.12,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m115.57,955.35s0,0,0,0c-.07.03-.03.02,0,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m118.85,955.54s0,0-.01,0l-.03.02.04-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m120.29,955.54s-.03,0-.05.01c.01,0,.03,0,.05,0,0,0,0-.02,0-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m116.96,955.46s.04-.05.04-.06c-.03,0-.05.01-.04.06Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.57,937.94s.02.01.03.02c-.01-.01-.02-.02-.03-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.76,931.4v.08s0-.07,0-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.49,941.86s0,0,0,0c0,.06,0,.14,0,.28v-.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.97,917.44v.09s0-.07,0-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.83,925.71s-.02-.07-.02-.11c0,.05,0,.1.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.85,943.93l.04-.11s-.04.04-.04.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.02,947.91s0,0,0-.01c0,0,0,0,0,.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.2,946.36s-.01-.07-.02-.11c0,.05,0,.11.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.17,946.19s0,.04.01.05c0-.03,0-.05-.01-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.76,866.74c0-.11-.03-.21-.06-.32l.06.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48,904.8l.02.02s-.01-.03-.02-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.39,866.59v-.08s0,.06,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.74,941.83c-.04-.12,0-.35-.03-.35,0,.12-.03.29.03.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.41,902.13v-.08s0,.06,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.39,866.59v.09s0-.02.01-.03c0-.02-.01-.04-.01-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.02,891.64h0s0,.02,0,.03v-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.09,890.94s0,.1.01.15c0-.08,0-.12-.01-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.7,866.42l-.03-.18c0,.06.02.12.03.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.02,883.42s0,.05,0,.07c0-.03,0-.05,0-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.81,926.24s0,.04,0,.06c0,0,.02,0,0-.06Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.68 921.04 46.68 921.04 46.68 921.04 46.68 921.04"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.73,921.32c0-.09-.02-.21-.05-.28,0,.09,0,.17.05.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.7,920.44s0,.02,0,.03c0-.01,0-.02,0-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.62 926.03 46.62 926.03 46.62 926.03 46.62 926.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.61,924.92s.01-.05.02-.08c0,.02-.02.04-.02.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.58 917.69 46.59 917.69 46.59 917.69 46.58 917.69"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.27,907.26c.02,1.05.11,2.4.09,3.44.09.23.09.55.11.89l-.12.04.04.28c-.03.11-.02-.21-.07-.01l.07.1s-.03.71-.11.25v1.07c0,.24.1.14.07.4-.03.05-.02-.09-.06-.07-.09.79.22.91.17,1.64l-.02-.06c.03.12.03.36.04.37.12-.09-.06-.13,0-.36.1.02.05.28.13.26-.04.17.02.27.03.42-.06.25-.02.62-.09.81.03.12.13.26.13.53-.08.19-.07-.05-.1.22l.06.04c0,.21-.02.18-.05.17,0,.23.08.19.04.48l-.06-.16c.02.21.01.3,0,.6-.03,0-.03-.13-.02-.21-.08.16.04.28.03.36.02-.02.04-.23.09-.13-.01.15.08.31,0,.42l-.05-.16c.04.31.07.16.05.52,0-.02-.02,0-.03-.02.07.22,0,.52,0,.84l-.02-.06c.02.13.07.21.07.28.03-.19.05-.14.1-.15-.09.25.11.38.05.79-.03,0-.07-.1-.04-.22-.1-.14-.18-.16-.22-.4.02.15.04.33,0,.3l.09.05c0,.09,0,.17,0,.24.06.04.09-.19.13.03.03.24-.09.13-.05.17.04.33.1.14.07.46,0-.03-.02-.1-.01-.12-.04.23.02.57-.09.64-.02-.03-.06-.04-.05-.13h.02c-.08-.25.02.22-.08.14.06-.02.04.31.03.45l.07-.05c.2.49-.13-.03-.11.46.04.31.02-.12.06.07-.01.21-.07.28-.04.59-.03.08-.06.26-.14.27.03.18-.03.56.04.66.06-.31-.08-.31.02-.68l.07.1c0,.25.03.58,0,.76.01-.04.03-.05.05-.03.03.36.1.47.08.82-.07.05-.05-.16-.06-.31-.05.23,0,.24-.03.59-.06.02,0-.24-.05-.28l.02.39s0,0-.01,0c.1.06,0,.3.02.54,0,.57.13.65.21.97-.03.08-.05.11-.07.07.04-.14,0-.11-.02-.16,0,.19-.09.42-.13.31.03.3.05-.11.08.08v.42s.05-.2.09.02c.01.18,0,.27,0,.51-.02-.03-.08.07-.07-.1-.02.11-.02.29.03.36.05-.26.04.43.12.23l-.05.26c0-.06-.03-.07-.02-.15-.08.07.02.21.03.3-.01.09-.02.33-.05.35.02.08,0,.28-.03.32.01.12.05,0,.07.05v.41s-.16.06-.18,0c.04.16.12.06.12.29-.08-.14-.06.31-.16.12-.06.14-.06.52-.04.74.06.13.04-.23.1-.22.02.6.2.64.17,1.08l.02-.11c.04.27.03.24.08.4-.08-.08-.22.31-.2.76.04.04.08-.25.14-.18v.3s0-.01-.02-.05c.03.27-.11.5-.01.58l-.12.27.05-.11s.05.34.07.4c.04.31,0,.42-.04.59.03-.05.11-.19.12.06-.13,0-.05.51-.12.5,0,.1-.04.27.02.28l-.08-.02c.11.02.11.38.13.65-.16-.06.01.3-.13.42.11.05.04.48.13.53,0,.21-.09.19-.13.24l.04.1c-.05.11-.06.5-.09.73l.09.22-.04.08s.04.22.07.1v.12c.1,0,.02.17.07.4-.02.05-.04.04-.05-.01,0,.12-.05.07-.09.13.03-.08.18.42.23.11.04-.02.07.16.05.28l-.09.07.1.14c.01.18-.05.26-.06.41,0-.15-.18-.33-.17.05-.01-.2-.06-.3-.08-.41,0,.08-.01.12-.05,0,.03.3.06.1.07.4-.08-.02-.11.07-.14.33l.06-.2s.02.02.02.04c0-.07.02-.1.05-.11,0,.06.1.35.05.4.13-.3.1.53.18.33.02.03.03.24-.01.27-.06-.25-.09.19-.15.15.02.09.06-.2.09-.07,0,.15-.05.26-.07.34l-.02-.06-.04.23s.07-.22.09-.01c-.02.06,0,.27-.03.26-.06-.1-.13-.03-.14-.21,0,.15.02.63.09.44v.18c.03-.11.09-.43.1-.07h-.02s.06.25.06.25l-.04.11s.04.04.04.13c-.02.02-.03.11-.07.1,0,.27.05.25.07.28,0,.15-.01.21-.06.14-.01.21,0,.57-.04.71.04.28.02-.06.07.1-.14.24-.06.91-.04,1.36.12-.12.01.12.13.21-.04-.1-.1.43-.13.03v.24c-.06.16-.04-.4-.13-.15,0,.27.14.45.09.76-.09-.11.03.24-.07.17-.03-.07-.02-.15-.03-.24l-.02.06c-.03.59.1.17.16.48.01.36-.07.28-.11.3-.02.06,0,.24.02.33-.05-.22.06-.41.11-.3-.1.16,0,.53.03.63.11-.51,0-.36.12-.84-.03-.07-.12-.06-.08-.35.04.18.05-.01.06-.06-.05.06-.02-.2-.04-.29.04-.08.12.17.14-.12l-.12-.06c.02-.11.09.05.06-.2.06.13.1-.04.12.29.1-.39-.06-.61-.1-.91,0,.03.02.04.03.07-.03-.07-.03-.18-.04-.28.03-.2.06.16.09.11v-.33s0,0,0,0c-.02-.09-.03-.17,0-.2.04.1.08.14.11.2l-.08-.34s.07-.28.1-.04l-.02-.51.08-.04c-.01-.12-.03-.13-.04.02.02-.17-.14-.77.02-.68-.07-.4-.04-.54-.08-1.03.08.37.1-.43.13-.03.04-.23-.05-.28-.07-.46.04-.17.12-.09.15.09l-.04-.22h.02s-.05-.18-.05-.18c.04-.2.08-.04.09-.25l-.07-.04.04-.14c-.03.05-.05-.07-.05-.22h.02s-.01-.18-.01-.18c.04.18.02-.17.07-.08,0-.16,0-.16-.01-.44l-.05.05c-.04-.37.07-.02.08-.31l-.06.02c.1-.43-.05-.73,0-1.04.01.18.08.14.06.13-.02-.27,0-.72-.07-1,.08-.1.11-.13.15-.42,0-.21-.01-.24-.06-.31.03-.2-.02-.59.05-.6-.05-.05,0-.18-.03-.3l.02-.02-.06.02c.13-.36-.07-.61.04-.97l.02.06-.02-.15s.04.04.07.05v-.71s-.03.14-.03.14c0-.15-.06-.25-.03-.42.09.29,0-.24.07-.28l.02.15q0-.21-.06-.19c-.02-.27.11-.19.05-.44v.18c-.04.05-.08-.08-.08-.19,0-.03.03-.11.04-.02-.02-.21,0-.53-.02-.63.02-.12.06-.08.07-.02-.05-.46.01-.21-.04-.66h.03s-.04-.15-.04-.15l.07-.22-.04.08c0-.15-.03-.24,0-.42l.05.07c-.03-.42.08-.49.01-.89,0-.03.02.03.03.07-.08-.37.09-.28,0-.66.02.02.04-.02.05,0l-.03-.17h.07s-.1-.13-.1-.13l.07-.1-.03-.07c.13-.18.03-.44.13-.69l-.08.04c-.17-.63.1-1.44.02-2.2h.07s-.08-.3-.08-.3c.05-.17.06.1.09.05-.04-.34-.1-.14-.11-.53.04-.2.05.07.07.16-.03-.37-.07-.91-.03-1.16,0,0-.02-.02-.02,0-.03-.24,0-.57,0-.83.03,0,.03.07.04.14,0-.1.02-.23,0-.31l.06.1c.01-.21-.04-.6.03-.65-.03.02-.07.01-.07-.16.1-.1-.04-.49.01-.77.02.03.03.24.03.18.03-.14-.02-.27-.05-.4l.04.04-.06-.67c.1-.1-.01-.63.06-.58,0-.24-.04.2-.06-.1.04-.08-.02-.27.04-.26v.03s0-.21,0-.21l.06.13c-.01-.18-.08-.31-.13-.32.04-.17,0-.42.06-.49l.02.06c-.03-.48.18-.8.07-1.18,0-.03.03-.02.02.03v-.3s.05.07.05.07l-.07-.49h.03c.01-.32,0-.83-.01-1.25l.02.06c-.05-.46.03-.44,0-.77,0,.01.01.02.01.04v-.3s.03.07.03.07c-.07-.22.09-.64.03-.5-.03-.13-.07-.34-.11-.38,0-.33.04-.08.07-.28,0-.24-.05-.28-.02-.6h.03c0-.14-.03-.24-.03-.45l.02.06c-.07-.34.1-.43-.05-.69.03-.14,0-.42.07-.4-.04-.43-.06-.76-.09-1.18.11-.07,0-.09.05-.35l-.06.02c0-.6.14-1.28.11-1.94l.06-.02-.06-.13c.03-.71.05-1.63.05-2.19-.03-.19-.1-.47-.08-.76v.03c-.03-.51-.05-1.05-.02-1.61.02.03.04-.02.06.04-.06-.13,0-.33,0-.45l-.04.14c-.05-.16,0-.39.04-.47l-.06-.25s.01-.04.02-.05l-.03-.04.08-.13c-.02-.06-.03-.39-.11-.5.03-.02.05-.26.06-.08l.02-.92-.03.14c-.06.02-.09-.26-.07-.4.05.19.08.02.12-.06-.03-.12-.05.11-.08.04-.04-.16-.06-.49-.03-.57l.02.09c-.02-.21.08-.31.07-.52-.05-.19,0-.33-.1-.29-.02-.27.07-.1.08-.19-.05-.13-.02-.51.03-.56-.15-.15.05-.73-.07-.79l.07-.22s-.11-.05-.12-.23c.04-.17.09-.13.13-.18l-.12-.11c.13-.98.04-2.28.15-3.36-.03-.48-.08-1.09-.06-1.65l.02.06.03-.56-.06.41c-.01-.12-.04-.22-.04-.34.05-.61.11-1.43.05-2.19-.14-.49.12-.33.02-.79.01.04.03.06.05.09-.05-.5-.07-.78-.15-1.28.14.06,0-.33.07-.28l-.06-.04c.03-.11.05-.38.09-.34l-.07-.22.06-.02c0-.3-.04-.93.07-1.09-.09-.73-.06-1.89-.04-2.81-.05-.13-.05-.4-.06-.61l.07-.22c-.02-.21-.11-.44-.06-.64,0,0,.01,0,.02.02-.01-.22.02-.42-.04-.62,0-.24.04-.47.1-.4-.11-.02.02-.5.02-.5,0,0,.28-12.18-.34-15.15-.06-.1-.09-.38-.16-.27-.02-.21.08-.31.02-.35-.04.29-.15-.09-.22.19v-.18c-.05-.04.03.25-.04.2l.11.05c-.02.15-.04.23-.07.28.04.14.18.23.12.56v-.09c0,.27-.07.17-.09.22v-.06s-.05.23-.05.23c.04-.17-.05-.46-.04-.31-.03.32.03-.08.04.16,0,.15-.05.11-.08.1v.27s0-.18-.04-.07l.05.34c-.12.06.06.37-.06.52-.03-.24-.04.02-.08-.02v.6c-.01.06-.03-.16-.02-.07-.03.11.03.18.03.25-.03.05,0,.45-.08.43-.06.4.1.17.06.55-.05.05-.01-.3-.06-.13l.02.39s-.08-.08-.07-.22c-.07,1.06-.33,1.63-.26,2.6-.06.14-.04-.1-.08-.19.08.7-.13.98-.12,1.58h.05c-.15.84-.06,1.84-.12,2.78l.03-.11c.05.13.05.34.07.49-.02.02-.1-.11-.08.16.02-.06.04-.17.06-.14-.13.81-.1,2.51-.16,3.84.04,1.79-.06,3.74-.03,5.5,0-.27.12-.15.09.05-.21.55.03.96-.11,1.53.07,1.03-.11,1.94.05,2.9l-.06.02c-.03.14.01.18.02.33h-.02c-.02.35.04.78,0,.98h.07c0,.22-.05.12-.01.34h-.03s.06.25.06.25c-.11-.02,0,.59-.06.76.02.27.07.79.05,1.2-.06.08-.06.58-.09.9.01.63.03,1.52.01,2.32h.07s0,.19,0,.19c-.02,0-.02.03-.03,0-.08.16.03.48-.03.65.07-.1.01-.15.01-.27.04-.17.11,0,.07.22h-.02s.04.15.04.15c-.06.02-.08.16-.14.18.01.69.11,1.15.09,1.86-.06-.07.02.51-.1.37.04.43.09-.07.17.12,0,.12.03.24-.01.27-.03-.06-.07.1-.08,0v.28s-.02-.04-.02-.07c.06.58-.07,1.03,0,1.55.04.04.01-.21.05-.17.08.52-.07.46-.01.95l-.06-.1c.04.16.09.23.04.49-.07.04-.05-.22-.08-.34,0,.18.01.63.07.49.02.21-.04.29-.06.41.02,0,.04-.2.07-.07-.04.29-.04.74-.04,1.09-.02,0-.04.02-.05,0,.09.29-.06.26-.04.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.61,926.17v-.14s-.02,0-.04-.07l.04.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.65,919.38s-.01-.04-.02-.05c0,.03.01.05.02.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.54,917.74c.01.12.03.01.05-.04-.01,0-.03,0-.05.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.78,930.02s-.02-.04-.03-.04c.01.03.02.04.03.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.74,940.65s0-.03,0-.04c0,0,0,.02,0,.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.84,940.06s0-.07,0-.12c0,.05,0,.09,0,.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.76,927.44s0-.08-.02-.11c0,.06.01.09.02.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.82,939.82v-.15s0,0,0,0v.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.73,940.84c0-.06,0-.14,0-.19-.02.07-.02.13,0,.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.87,933.92s0-.01,0-.02c-.03-.12-.02-.04,0,.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.7,939.17s0-.01,0-.02l-.02-.04.02.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.7,941.48s0-.05-.01-.07c0,.02,0,.05,0,.08,0,0,.01,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.77,936.15s.04.06.05.06c0-.05-.01-.08-.05-.06Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.87,813.64s-.02-.01-.03-.02c.01.01.02.02.03.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.68,820.19v-.08s0,.07,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.95,809.72s0,0,0,0c0-.06,0-.14,0-.28v.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.46,834.15v-.09s0,.07,0,.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.61,825.88s.02.07.02.11c0-.05,0-.1-.02-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.59,807.65l-.04.11s.04-.04.04-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,803.67s0,0,0,.01c0,0,0,0,0-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.24,805.23s.01.07.02.11c0-.05,0-.11-.02-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.27,805.39s0-.04-.01-.05c0,.03,0,.05.01.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.68,884.85c0,.11.03.21.06.32l-.06-.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.44,846.79l-.02-.03s.01.03.02.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.05,884.99v.08s0-.06,0-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.7,809.76c.04.11,0,.35.03.35,0-.12.03-.29-.03-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.03,849.46v.08s0-.06,0-.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.05,884.99v-.09s0,.02-.01.03c0,.02.01.04.01.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.42,859.95h0s0-.02,0-.03v.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.35,860.64s0-.1-.01-.15c0,.08,0,.12.01.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.73,885.16l.03.18c0-.06-.02-.12-.03-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.41,868.17s0-.05,0-.07c0,.03,0,.05,0,.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.63,825.34s0-.04,0-.06c0,0-.02,0,0,.06Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "47.76 830.54 47.76 830.55 47.76 830.55 47.76 830.54"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.7,830.27c0,.09.02.21.05.28,0-.09,0-.17-.05-.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.73,831.14s0-.02,0-.03c0,.01,0,.02,0,.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "47.82 825.55 47.81 825.55 47.82 825.56 47.82 825.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.83,826.66s-.01.05-.02.08c0-.02.02-.04.02-.08Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "47.85 833.89 47.85 833.89 47.85 833.9 47.85 833.89"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.17,844.32c-.02-1.05-.11-2.4-.09-3.44-.09-.23-.09-.55-.11-.89l.12-.04-.04-.28c.03-.11.02.21.07.01l-.07-.1s.03-.71.11-.25v-1.07c0-.24-.1-.14-.07-.4.03-.05.02.09.06.07.09-.79-.22-.91-.17-1.64l.02.06c-.03-.12-.03-.36-.04-.37-.12.09.06.13,0,.36-.1-.02-.05-.28-.13-.26.04-.17-.02-.27-.03-.42.06-.25.02-.62.09-.81-.03-.12-.13-.26-.13-.53.08-.19.07.05.1-.22l-.06-.04c0-.21.02-.18.05-.17,0-.23-.08-.19-.04-.48l.06.16c-.02-.21-.01-.3,0-.6.03,0,.03.13.02.21.08-.16-.04-.28-.03-.36-.02.02-.04.23-.09.13.01-.15-.08-.31,0-.42l.05.16c-.04-.31-.07-.16-.05-.52,0,.02.02,0,.03.02-.07-.22,0-.51,0-.84l.02.06c-.02-.13-.07-.21-.07-.28-.03.19-.05.14-.1.15.09-.25-.11-.38-.05-.79.03,0,.07.1.04.22.1.14.18.16.22.4-.02-.15-.04-.33,0-.3l-.09-.05c0-.09,0-.17,0-.24-.06-.04-.09.19-.13-.03-.03-.24.09-.13.05-.17-.04-.33-.1-.14-.07-.46,0,.03.02.09.01.12.04-.23-.02-.57.09-.64.02.03.06.04.05.13h-.02c.08.25-.02-.22.08-.14-.06.02-.04-.31-.03-.45l-.07.05c-.2-.49.13.03.11-.46-.04-.31-.02.12-.06-.07.01-.21.07-.28.04-.59.03-.08.06-.26.14-.27-.03-.18.03-.56-.04-.66-.06.31.08.31-.02.68l-.07-.1c0-.25-.03-.58,0-.76-.01.04-.03.05-.05.03-.03-.36-.1-.47-.08-.82.07-.05.05.16.06.31.05-.23,0-.24.03-.59.06-.02,0,.24.05.28l-.02-.39s0,0,.01,0c-.1-.06,0-.3-.02-.54,0-.57-.13-.65-.21-.97.03-.08.05-.11.08-.07-.04.14,0,.11.02.16,0-.19.09-.42.13-.31-.03-.3-.05.11-.08-.08v-.42s-.05.2-.09-.02c-.01-.18,0-.27,0-.51.02.03.08-.07.07.1.02-.11.02-.29-.03-.36-.05.26-.04-.43-.12-.23l.05-.26c0,.06.03.07.02.15.07-.07-.02-.21-.03-.3.01-.09.02-.33.05-.35-.02-.08,0-.28.03-.32-.01-.12-.05,0-.07-.05v-.41s.16-.06.18,0c-.04-.16-.12-.06-.12-.29.08.14.06-.31.16-.12.06-.14.06-.52.04-.74-.06-.13-.04.23-.1.22-.02-.6-.2-.64-.17-1.08l-.02.11c-.04-.27-.03-.24-.08-.4.08.08.22-.31.2-.76-.04-.04-.08.25-.14.18v-.3s0,.01.02.05c-.03-.27.11-.5.01-.58l.12-.27-.05.11s-.05-.34-.07-.4c-.04-.31,0-.42.04-.59-.03.05-.11.19-.12-.06.13,0,.05-.51.12-.5,0-.1.04-.27-.02-.28l.08.02c-.11-.02-.11-.38-.13-.65.16.06-.01-.3.13-.42-.11-.05-.04-.48-.13-.53,0-.21.09-.19.13-.24l-.04-.1c.05-.11.06-.5.09-.73l-.09-.22.04-.08s-.04-.22-.07-.1v-.12c-.1,0-.02-.17-.07-.4.02-.05.04-.04.05.01,0-.12.05-.07.09-.13-.03.08-.18-.42-.23-.11-.04.02-.07-.16-.05-.28l.09-.07-.1-.14c-.01-.18.05-.26.06-.41,0,.15.18.33.17-.05.01.2.06.3.08.41,0-.08.01-.12.05,0-.03-.3-.06-.1-.07-.4.08.02.11-.07.14-.33l-.06.2s-.02-.02-.02-.04c0,.07-.02.1-.05.11,0-.06-.1-.35-.05-.4-.13.3-.1-.53-.18-.33-.02-.03-.03-.24.01-.27.06.25.09-.19.15-.15-.02-.09-.06.2-.09.07,0-.15.05-.26.07-.34l.02.06.04-.23s-.07.22-.09.01c.02-.06,0-.27.03-.26.06.1.13.03.14.21,0-.15-.02-.63-.09-.44v-.18c-.03.11-.09.43-.1.07h.02s-.06-.25-.06-.25l.04-.11s-.04-.04-.04-.13c.02-.02.03-.11.07-.1,0-.27-.05-.25-.07-.28,0-.15.01-.21.06-.14.01-.21,0-.57.04-.71-.04-.28-.02.06-.07-.1.14-.24.06-.91.04-1.36-.12.12-.01-.12-.13-.21.04.1.1-.43.13-.03v-.24c.06-.16.04.4.13.15,0-.27-.14-.45-.09-.76.09.11-.03-.24.07-.17.03.07.02.15.03.24l.02-.06c.03-.59-.1-.17-.16-.48-.01-.36.07-.28.11-.3.02-.06,0-.24-.02-.33.05.22-.06.41-.11.3.1-.16,0-.53-.03-.63-.11.51,0,.36-.12.84.03.07.12.06.08.34-.04-.18-.05.01-.06.06.05-.06.02.2.04.29-.04.08-.12-.17-.14.12l.12.06c-.02.11-.09-.05-.06.2-.06-.13-.1.04-.12-.29-.1.39.06.61.1.91,0-.03-.02-.03-.03-.07.03.07.03.18.04.28-.03.2-.06-.16-.09-.11v.33s0,0,0,0c.02.09.03.17,0,.2-.04-.1-.08-.14-.11-.2l.08.34s-.07.28-.1.04l.02.51-.08.04c.01.12.03.13.04-.02-.02.17.14.77-.02.68.07.4.04.54.08,1.03-.08-.37-.1.43-.13.03-.04.23.05.28.07.46-.04.17-.12.09-.15-.09l.04.22h-.02s.05.18.05.18c-.04.2-.08.04-.09.25l.07.04-.04.14c.03-.05.05.07.05.22h-.02s.01.18.01.18c-.04-.18-.02.17-.07.08,0,.16,0,.16.01.44l.05-.05c.04.37-.07.02-.08.31l.06-.02c-.1.43.05.73,0,1.04-.01-.18-.08-.14-.06-.13.02.27,0,.72.07,1-.08.1-.11.13-.15.42,0,.21.01.24.06.31-.03.2.02.59-.05.6.05.05,0,.18.03.3l-.02.02.06-.02c-.13.36.07.61-.04.97l-.02-.06.02.15s-.04-.04-.07-.05v.71s.03-.14.03-.14c0,.15.06.25.03.42-.09-.29,0,.24-.07.28l-.02-.15q0,.21.06.19c.02.27-.11.19-.05.44v-.18c.04-.05.08.08.08.19,0,.03-.03.11-.04.02.02.21,0,.53.01.63-.02.12-.06.08-.07.01.05.46-.01.21.04.66h-.03s.04.15.04.15l-.07.22.04-.08c0,.15.03.24,0,.42l-.05-.07c.03.42-.08.49-.01.89,0,.03-.02-.04-.03-.07.08.37-.09.28,0,.66-.02-.02-.04.02-.05,0l.03.17h-.07s.1.13.1.13l-.07.1.03.07c-.13.18-.03.44-.13.69l.08-.04c.17.63-.1,1.44-.02,2.2h-.07s.08.3.08.3c-.05.17-.06-.1-.09-.05.04.34.1.14.11.53-.04.2-.05-.07-.07-.16.03.37.07.91.03,1.16,0,0,.02.02.02,0,.03.24,0,.57,0,.83-.03,0-.03-.07-.04-.14,0,.1-.02.23,0,.31l-.06-.1c-.01.21.04.6-.03.65.03-.02.07-.01.07.16-.1.1.04.49-.01.77-.02-.03-.03-.24-.03-.18-.03.14.02.27.05.4l-.04-.04.06.67c-.1.1.01.63-.06.58,0,.24.04-.2.06.1-.04.08.02.27-.04.26v-.03s0,.21,0,.21l-.06-.13c.01.18.08.31.13.32-.04.17,0,.42-.06.49l-.02-.06c.03.48-.18.8-.07,1.18,0,.03-.03.02-.02-.03v.3s-.05-.07-.05-.07l.07.49h-.03c-.01.32,0,.83.01,1.25l-.02-.06c.05.46-.03.44,0,.77,0-.01-.01-.02-.01-.04v.3s-.03-.07-.03-.07c.07.22-.09.64-.03.5.03.13.07.34.11.38,0,.33-.04.08-.07.28,0,.24.05.28.02.6h-.03c0,.14.03.24.03.45l-.02-.06c.07.34-.1.43.05.69-.03.14,0,.42-.07.4.04.43.06.76.09,1.18-.11.07,0,.09-.05.35l.06-.02c0,.6-.13,1.28-.11,1.94l-.06.02.06.13c-.03.71-.05,1.63-.05,2.19.03.19.1.47.08.76v-.03c.03.51.05,1.05.02,1.61-.02-.03-.04.02-.06-.04.06.13,0,.33,0,.45l.04-.14c.05.16,0,.39-.04.47l.06.25s-.01.04-.02.05l.03.04-.08.13c.02.06.03.39.11.5-.03.02-.05.26-.06.08l-.02.92.03-.14c.06-.02.09.26.07.4-.05-.19-.08-.02-.12.06.03.12.05-.11.08-.04.04.16.06.49.03.57l-.02-.09c.02.21-.08.31-.07.52.05.19,0,.33.1.29.02.27-.07.1-.08.19.05.13.02.51-.03.56.15.15-.05.73.07.79l-.07.22s.11.05.12.23c-.04.17-.09.13-.13.18l.12.11c-.13.98-.04,2.28-.15,3.36.03.48.08,1.09.06,1.65l-.02-.06-.03.56.06-.41c.01.12.04.22.04.34-.05.61-.11,1.43-.05,2.19.14.49-.12.32-.02.79-.01-.04-.03-.06-.05-.09.05.5.07.78.15,1.28-.14-.06,0,.33-.07.28l.06.04c-.03.11-.05.38-.09.34l.07.22-.06.02c0,.3.04.93-.07,1.09.09.73.06,1.89.04,2.81.05.13.05.4.06.61l-.07.22c.02.21.11.44.06.64,0,0-.01,0-.02-.02.01.22-.02.42.04.62,0,.24-.04.47-.1.4.11.02-.02.5-.02.5,0,0-.28,12.18.34,15.15.06.1.09.38.16.27.02.21-.08.31-.02.35.04-.29.15.09.22-.19v.18c.05.04-.03-.25.04-.2l-.11-.05c.02-.15.04-.23.07-.28-.04-.14-.18-.23-.12-.56v.09c0-.27.07-.17.09-.22v.06s.05-.23.05-.23c-.04.17.05.46.04.31.03-.32-.03.08-.04-.16,0-.15.05-.11.08-.1v-.27s0,.18.04.07l-.05-.34c.12-.06-.06-.37.06-.52.03.24.04-.02.08.02v-.6c.01-.06.03.16.02.07.03-.11-.03-.18-.03-.25.03-.05,0-.45.08-.43.06-.4-.1-.17-.06-.55.05-.05.01.3.06.13l-.02-.39s.08.08.07.22c.07-1.06.33-1.63.26-2.6.06-.14.04.1.08.19-.08-.7.13-.98.12-1.58h-.05c.15-.84.06-1.84.12-2.78l-.03.11c-.05-.13-.05-.34-.07-.49.02-.02.1.11.08-.16-.02.06-.04.17-.06.14.13-.81.1-2.51.16-3.84-.04-1.79.06-3.74.03-5.5,0,.27-.12.15-.09-.05.21-.55-.03-.96.11-1.53-.07-1.03.11-1.94-.05-2.9l.06-.02c.03-.14-.01-.18-.02-.33h.02c.02-.35-.04-.78,0-.98h-.07c0-.22.05-.12.01-.34h.03s-.06-.25-.06-.25c.11.02,0-.59.06-.76-.02-.27-.07-.79-.05-1.2.06-.08.06-.58.09-.9-.01-.63-.03-1.52-.01-2.32h-.07s0-.19,0-.19c.02,0,.02-.02.03,0,.08-.16-.03-.48.03-.65-.07.11-.01.15-.01.27-.04.17-.11,0-.07-.22h.02s-.04-.15-.04-.15c.06-.02.08-.16.14-.18-.01-.69-.11-1.15-.09-1.86.06.07-.02-.51.1-.37-.04-.43-.09.07-.17-.12,0-.12-.03-.24.01-.27.03.06.07-.1.08,0v-.28s.02.04.02.07c-.06-.58.07-1.03,0-1.55-.04-.04-.01.21-.05.17-.08-.52.07-.46.01-.95l.06.1c-.04-.16-.09-.23-.04-.49.07-.05.05.22.08.34,0-.18-.01-.63-.07-.49-.02-.21.04-.29.06-.41-.02,0-.04.2-.07.07.04-.29.04-.74.04-1.09.02,0,.04-.02.05,0-.09-.28.06-.25.04-.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.83,825.41v.14s.02,0,.04.07l-.04-.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.79,832.2s.01.04.02.05c0-.03-.01-.05-.02-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.9,833.85c-.01-.12-.03-.01-.05.04.01,0,.03,0,.05-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.65,821.56s.02.04.03.04c-.01-.03-.02-.04-.03-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.7,810.93s0,.03-.01.04c0,0,0-.02.01-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.6,811.52s0,.07,0,.12c0-.05,0-.09,0-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.68,824.14s0,.08.02.11c0-.06-.01-.09-.02-.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.62,811.77v.15s0,0,0,0v-.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.71,810.75c0,.06,0,.14,0,.19.02-.07.02-.13,0-.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.57,817.66s0,.01,0,.02c.03.12.02.04,0-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.74,812.41s0,.01,0,.02l.02.04-.02-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.74,810.11s0,.05.01.07c0-.02,0-.05,0-.08,0,0-.01.01-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.67,815.44s-.04-.06-.05-.06c0,.05.01.08.05.06Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.62,744.69s.02.05.03.06c-.01-.06-.02-.07-.03-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.84,717.31l.02.32c0-.21,0-.29-.02-.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.53,761.1s0-.02,0-.04c0,.25,0,.6,0,1.15v-1.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.09,658.89v.37c0-.17,0-.27,0-.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.93,693.51c-.01-.11-.02-.29-.02-.46,0,.22,0,.4.02.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.79,769.77l.05-.47s-.04.17-.05.47Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.99,786.42s0-.02.01-.04c0-.03,0,0-.01.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.19,779.92c0-.14-.01-.3-.02-.47,0,.2,0,.45.02.47Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.16,779.23c0,.07,0,.15.01.22,0-.12,0-.23-.01-.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.85,446.71c0-.48-.04-.89-.07-1.32l.07,1.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.12,606l.02.1c0-.1-.01-.12-.02-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,446.11v-.34c0,.12,0,.23,0,.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,760.96c-.05-.48,0-1.47-.04-1.46,0,.51-.03,1.23.04,1.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.28,594.82v-.32c0,.15,0,.25,0,.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,446.11v.39s0-.08.01-.12c0-.09-.01-.18-.01-.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.14,550.92v.02s0,.07,0,.11v-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.22,548c0,.2.01.4.02.62,0-.33,0-.5-.02-.62Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.78,445.39l-.04-.75c0,.27.02.52.04.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.15,516.5c0,.1,0,.2,0,.29,0-.13,0-.22,0-.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.9,695.73c0,.07,0,.17-.01.25.01.03.02.01.01-.25Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.6 673.97 46.6 673.96 46.6 673.96 46.6 673.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,675.13c.01-.36-.02-.88-.06-1.16,0,.37.01.71.06,1.16Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,671.48s0,.08,0,.14c0-.05,0-.09,0-.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.53,694.85s0,0,0,0c0,0,0-.01,0-.01h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.52,690.22c0-.08.02-.2.02-.32,0,.08-.02.18-.02.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.49,659.95s0,0,0,0c0-.01,0-.01,0-.02,0,0,0,.01,0,.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.12,616.31c.03,4.38.13,10.05.1,14.4.1.94.1,2.32.13,3.71l-.13.15.04,1.15c-.04.47-.02-.89-.08-.06l.08.44c-.05.09-.03,2.96-.13,1.03v4.49c0,.99.11.58.08,1.68-.04.22-.03-.39-.07-.3-.1,3.29.26,3.8.2,6.87l-.02-.26c.04.52.03,1.52.05,1.53.13-.39-.07-.55,0-1.49.11.08.06,1.17.15,1.11-.04.72.02,1.14.03,1.77-.07,1.07-.02,2.6-.11,3.41.04.52.15,1.11.15,2.23-.09.81-.08-.19-.12.91l.07.18c-.01.9-.03.76-.06.73,0,.96.09.8.05,2.01l-.06-.67c.03.89.01,1.26,0,2.5-.04-.03-.04-.53-.02-.89-.1.67.04,1.16.03,1.52.03-.1.04-.96.11-.54-.01.62.09,1.31.01,1.75l-.06-.67c.05,1.29.08.69.06,2.16,0-.08-.02-.04-.04-.07.08.93,0,2.15,0,3.53l-.02-.26c.02.56.08.86.08,1.16.04-.79.06-.57.12-.64-.11,1.04.13,1.59.06,3.29-.04-.03-.08-.44-.04-.9-.11-.58-.21-.65-.26-1.69.03.64.04,1.4,0,1.24l.1.2c0,.39,0,.7,0,.99.07.17.11-.79.15.12.03,1.02-.11.54-.06.7.04,1.4.11.58.08,1.93,0-.14-.03-.4-.02-.51-.04.97.02,2.38-.11,2.66-.03-.14-.07-.17-.05-.54l.02.02c-.09-1.06.02.89-.09.56.07-.07.05,1.29.04,1.9l.08-.19c.23,2.04-.15-.11-.12,1.91.05,1.28.02-.48.07.3-.01.87-.08,1.19-.05,2.45-.03.35-.07,1.07-.16,1.13.03.77-.04,2.34.04,2.77.07-1.31-.09-1.31.02-2.85l.08.43c0,1.06.04,2.43,0,3.16.02-.15.04-.21.06-.12.03,1.52.11,1.95.09,3.43-.08.19-.06-.67-.07-1.3-.06.95,0,.99-.03,2.47-.07.08,0-.99-.06-1.16l.02,1.63s0,0-.01,0c.11.24,0,1.25.02,2.25,0,2.37.15,2.73.24,4.04-.03.35-.06.46-.09.31.05-.58.01-.48-.02-.68.01.8-.11,1.75-.15,1.3.03,1.27.06-.46.09.32v1.74c.05-.21.06-.82.11.08.02.76,0,1.12,0,2.12-.03-.14-.09.31-.08-.43-.02.48-.02,1.23.03,1.52.05-1.09.05,1.78.14.97l-.05,1.08c0-.25-.04-.28-.03-.64-.09.31.02.89.03,1.27-.02.38-.02,1.37-.06,1.46.02.34,0,1.18-.04,1.34.02.51.06.04.08.19v1.74c-.06.09-.19.24-.21-.02.04.66.14.24.14,1.23-.09-.57-.07,1.31-.18.49-.07.57-.07,2.19-.04,3.08.07.55.04-.97.12-.91.03,2.51.24,2.66.2,4.5l.02-.48c.04,1.15.03,1.02.1,1.69-.09-.32-.25,1.3-.23,3.19.05.16.09-1.06.16-.75v1.25c0,.09,0-.05-.02-.21.03,1.12-.12,2.09-.01,2.42l-.14,1.14.06-.45c.05.16.06,1.42.08,1.68.05,1.29.01,1.75-.05,2.46.04-.22.13-.78.14.23-.15-.01-.06,2.12-.14,2.09,0,.41-.05,1.13.02,1.18l-.09-.07c.13.1.13,1.58.15,2.73-.18-.26.01,1.25-.15,1.76.12.21.05,2.03.15,2.23,0,.88-.11.79-.15,1.01l.05.41c-.06.44-.07,2.09-.11,3.07l.11.91-.05.34c.03.15.04.9.08.43v.49c.11.04.03.69.08,1.68-.02.23-.05.17-.06-.05,0,.49-.06.28-.1.55.03-.35.21,1.77.26.45.05-.09.08.68.06,1.17l-.11.29.11.58c.02.76-.05,1.08-.06,1.69,0-.63-.2-1.4-.2.23-.01-.85-.07-1.27-.09-1.71,0,.34-.01.5-.06-.02.03,1.27.06.42.08,1.68-.09-.07-.12.28-.16,1.38l.07-.82s.02.09.03.16c.01-.31.03-.4.06-.46,0,.25.12,1.45.06,1.66.15-1.26.11,2.2.2,1.4.03.14.03,1.02-.01,1.11-.07-1.05-.11.79-.17.62.03.39.07-.82.11-.3,0,.62-.05,1.08-.08,1.43l-.02-.26-.04.97c.05.16.08-.94.1-.05-.02.23,0,1.12-.03,1.1-.06-.42-.15-.12-.17-.87,0,.63.02,2.63.11,1.82v.75c.04-.47.11-1.79.12-.28h-.02s.07,1.03.07,1.03l-.05.46s.05.15.04.54c-.03.1-.04.47-.08.44,0,1.13.05,1.03.08,1.18,0,.63-.01.87-.07.57-.01.86,0,2.37-.05,2.95.04,1.15.02-.24.08.44-.17,1-.06,3.81-.04,5.69.14-.51.02.51.15.86-.05-.41-.11,1.79-.15.14v1.01c-.06.69-.04-1.66-.15-.62,0,1.13.16,1.87.11,3.19-.1-.45.03,1.02-.08.69-.04-.28-.03-.64-.03-1.02l-.02.23c-.03,2.47.12.71.19,2.01.01,1.51-.08,1.19-.13,1.27-.02.23,0,.99.02,1.39-.06-.92.06-1.7.13-1.28-.12.66,0,2.23.04,2.64.12-2.15,0-1.49.14-3.51-.04-.28-.14-.23-.1-1.44.05.76.06-.05.08-.27-.06.23-.02-.84-.05-1.21.05-.34.14.73.16-.5l-.14-.23c.02-.48.1.2.07-.82.07.55.11-.17.14,1.22.12-1.65-.06-2.54-.12-3.82,0,.13.03.15.04.28-.04-.28-.03-.77-.04-1.15.03-.85.06.67.1.45v-1.37s0-.03,0-.03c-.02-.36-.03-.7,0-.83.05.41.09.57.13.84l-.1-1.44c.05.16.08-1.19.11-.16l-.02-2.13.1-.18c-.02-.51-.04-.52-.05.09.02-.73-.17-3.23.02-2.85-.08-1.67-.05-2.28-.09-4.3.09,1.56.11-1.79.15-.14.04-.97-.06-1.17-.08-1.93.04-.71.13-.4.17.38l-.04-.91.02.02-.05-.79c.05-.83.1-.18.11-1.04l-.08-.19.05-.58c-.04.22-.06-.29-.06-.92h.02s-.02-.75-.02-.75c.05.75.02-.7.08-.35,0-.65,0-.67-.01-1.84l-.06.21c-.05-1.53.09-.06.09-1.31l-.07.08c.11-1.79-.06-3.03,0-4.35.02.76.09.57.07.55-.02-1.14,0-2.99-.09-4.17.1-.43.13-.53.17-1.74,0-.88-.01-1.01-.07-1.3.04-.85-.02-2.45.05-2.49-.06-.2.01-.77-.04-1.24l.03-.1-.07.07c.15-1.51-.08-2.55.05-4.08l.02.26-.03-.64c.03-.1.05.16.08.19v-2.98s-.04.59-.04.59c0-.63-.07-1.05-.03-1.77.1,1.19,0-.99.08-1.18l.03.64q0-.87-.07-.8c-.02-1.13.13-.78.06-1.82v.74c-.04.22-.1-.32-.09-.81.01-.12.04-.47.05-.09-.03-.89,0-2.23-.02-2.63.02-.48.07-.32.09-.06-.06-1.91.01-.86-.04-2.78l.04.03-.05-.66.08-.94-.05.34c0-.63-.03-1.02-.01-1.75l.06.29c-.03-1.77.09-2.05.02-3.73.01-.11.03.15.04.28-.09-1.56.1-1.18,0-2.75.02.1.04-.07.06-.01l-.04-.71.08.06-.11-.58.08-.44-.04-.28c.15-.76.04-1.84.14-2.88l-.1.18c-.2-2.64.11-6.02.02-9.2l.08.06-.09-1.31c.06-.7.06.42.1.2-.04-1.4-.11-.59-.13-2.22.05-.84.06.29.08.68-.04-1.53-.08-3.79-.04-4.87-.01-.02-.02-.09-.03-.03-.03-1.02,0-2.37,0-3.49.03.03.04.31.05.59,0-.4.03-.96,0-1.3l.07.42c.01-.86-.05-2.53.03-2.72-.03.1-.09.06-.08-.68.12-.41-.05-2.03.01-3.23.03.14.03,1.02.03.77.03-.6-.02-1.14-.06-1.67l.05.16-.06-2.79c.12-.41-.02-2.63.07-2.44,0-1-.05.84-.06-.42.05-.34-.02-1.14.05-1.09v.13s0-.88,0-.88l.07.55c-.02-.76-.09-1.31-.15-1.35.04-.72,0-1.74.08-2.06l.02.27c-.03-2.02.2-3.34.08-4.92.01-.12.03-.1.03.14v-1.25s.06.3.06.3l-.09-2.06.04.03c.02-1.36,0-3.49-.02-5.24l.02.26c-.06-1.91.04-1.84,0-3.24.01.05.01.1.02.15v-1.26s.04.28.04.28c-.08-.93.11-2.66.04-2.09-.04-.53-.08-1.43-.13-1.59,0-1.37.05-.34.08-1.19,0-.99-.06-1.17-.03-2.51l.04.03c0-.63-.03-1.02-.04-1.9l.02.26c-.08-1.43.11-1.78-.05-2.9.03-.6,0-1.74.08-1.68-.05-1.78-.07-3.17-.1-4.93.12-.28,0-.38.06-1.45l-.07.08c0-2.5.16-5.37.13-8.13l.07-.08-.07-.55c.03-2.97.06-6.81.06-9.17-.03-.77-.12-1.95-.09-3.18v.13c-.03-2.14-.06-4.41-.02-6.75.03.15.05-.09.07.18-.07-.56,0-1.37,0-1.87l-.05.59c-.06-.67,0-1.62.05-1.96l-.07-1.05c0-.07.02-.18.03-.19l-.04-.19.09-.56c-.02-.26-.04-1.65-.12-2.09.03-.1.05-1.08.07-.32l.03-3.84-.03.6c-.07.07-.11-1.08-.08-1.68.05.78.09.06.14-.27-.04-.52-.06.45-.1.18-.04-.66-.07-2.04-.04-2.39l.03.39c-.02-.89.09-1.3.09-2.18-.05-.79,0-1.37-.12-1.21-.02-1.14.08-.44.09-.81-.05-.54-.02-2.13.04-2.33-.17-.62.06-3.07-.08-3.3l.08-.94s-.12-.22-.14-.98c.04-.71.11-.54.15-.76l-.14-.48c.15-4.12.05-9.56.17-14.07-.03-2.01-.09-4.55-.07-6.91l.02.26.04-2.34-.06,1.7c-.02-.51-.04-.91-.04-1.4.06-2.57.13-5.99.06-9.15-.16-2.05.14-1.36.03-3.32.01.17.04.23.05.38-.05-2.11-.08-3.26-.18-5.37.16.24,0-1.38.08-1.19l-.07-.18c.04-.47.05-1.58.1-1.42l-.08-.93.07-.08c0-1.24-.05-3.89.09-4.54-.1-3.06-.07-7.9-.04-11.74-.05-.54-.06-1.66-.06-2.54l.08-.94c-.02-.89-.12-1.84-.07-2.67,0,0,.02.04.02.1-.02-.91.03-1.77-.05-2.62,0-.99.05-1.96.12-1.65-.13-.1.02-2.1.02-2.1,0,0,.32-50.98-.4-63.42-.06-.42-.11-1.58-.18-1.13-.02-.89.09-1.3.03-1.48-.04,1.21-.17-.38-.25.81l-.02-.76c-.05-.16.05,1.04-.03.85l.12.21c-.02.62-.04.96-.09,1.17.05.58.21.95.14,2.34v-.38c0,1.13-.09.69-.11.93v-.25s-.06.95-.06.95c.04-.72-.06-1.91-.05-1.29-.03,1.35.03-.35.04.66,0,.63-.06.45-.1.42v1.12c-.05-.04,0-.74-.05-.29l.06,1.42c-.14.26.07,1.54-.07,2.19-.03-1.02-.05.09-.09-.07v2.5c-.01.24-.04-.66-.03-.28-.04.47.03.77.03,1.03-.04.22,0,1.86-.09,1.8-.06,1.69.12.71.07,2.29-.06.21-.01-1.25-.07-.55l.02,1.64c-.03-.15-.09-.32-.08-.93-.08,4.43-.38,6.82-.3,10.86-.07.57-.05-.41-.09-.82.09,2.93-.15,4.12-.14,6.62l.06.04c-.18,3.48-.07,7.67-.14,11.6l.04-.47c.05.54.06,1.41.09,2.06-.03.1-.12-.47-.1.67.02-.24.04-.72.07-.57-.15,3.38-.11,10.51-.18,16.06.04,7.51-.07,15.65-.03,23.02,0-1.12.14-.65.1.2-.24,2.32.04,4.02-.12,6.38.08,4.29-.13,8.13.05,12.12l-.07.08c-.03.6.02.76.02,1.38h-.02c-.03,1.47.04,3.26.01,4.11l.08.05c0,.88-.06.46-.02,1.36l-.04-.03.07,1.05c-.13-.1-.01,2.48-.07,3.19.02,1.14.08,3.3.05,5.02-.07.32-.07,2.44-.1,3.79.02,2.63.04,6.38.01,9.73l.09-.06v.87s-.02.1-.03-.03c-.1.68.03,2.01-.03,2.72.08-.44.01-.61.01-1.11.04-.72.12-.03.08.94l-.02-.02.05.66c-.07.07-.1.67-.16.75.02,2.88.13,4.83.1,7.8-.07-.31.02,2.13-.11,1.54.05,1.78.1-.29.2.52,0,.5.03,1.02-.01,1.11-.03-.23-.08.4-.09,0v1.19c0,.11-.02-.15-.03-.28.07,2.42-.08,4.3,0,6.47.05.16.01-.86.06-.7.1,2.19-.08,1.93-.02,3.97l-.06-.42c.04.66.1.95.05,2.03-.08.19-.06-.92-.1-1.44,0,.74.02,2.63.09,2.05.02.89-.04,1.22-.06,1.7.02.02.05-.83.09-.31-.04,1.21-.04,3.09-.05,4.57-.02-.01-.05.09-.06-.04.1,1.19-.07,1.07-.05,2.7Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.51,695.45v-.6s-.02-.03-.04-.3l.04.9Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.56,667.04c0-.07-.01-.15-.02-.21,0,.14.01.19.02.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.43,660.14c.02.49.04.05.06-.19-.02-.01-.03,0-.06.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.72,711.55c0-.1-.02-.17-.03-.15.01.14.02.17.03.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,756.04c0-.06,0-.11.01-.18,0,.03,0,.1-.01.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.78,753.57c0-.12,0-.28-.01-.5,0,.22,0,.38.01.5Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.69,700.77c0-.17,0-.33-.02-.47,0,.25.01.38.02.47Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.75,752.56v-.62s0-.01,0-.01v.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.65,756.82c0-.24,0-.57,0-.78-.02.31-.02.55,0,.78Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.81,727.88s0-.04,0-.07c-.03-.48-.02-.18,0,.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,749.84s0-.06,0-.08l-.02-.18.02.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,759.5c0-.12,0-.22-.01-.31,0,.1,0,.21,0,.35,0-.03.02-.04.02-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.7,737.19c.03.18.05.24.06.25,0-.21-.01-.34-.06-.25Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.81,383.9s-.02-.01-.03-.02c.01.02.02.02.03.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.59,391.54l-.02-.09c0,.06,0,.08.02.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.91,379.32s0,0,0,.01c0-.07,0-.17,0-.32v.31Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.35,407.83v-.1s0,.08,0,.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.51,398.18s.02.08.02.13c0-.06,0-.11-.02-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.65,376.9l-.05.13s.04-.05.05-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.44,372.26s0,0-.01.01c0,0,0,0,.01-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.24,374.08s.01.08.02.13c0-.06,0-.13-.02-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.28,374.27s0-.04-.01-.06c0,.03,0,.06.01.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.59,467.01c0,.13.04.25.07.37l-.07-.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.32,422.58l-.02-.03s.01.03.02.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.03,467.18v.09s0-.07,0-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.78,379.36c.05.13,0,.41.04.41,0-.14.03-.34-.04-.41Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.16,425.7v.09s0-.07,0-.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.03,467.18v-.11s0,.02-.01.03c0,.02.01.05.01.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.3,437.95h0s0-.02,0-.04v.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.22,438.76c0-.06-.01-.11-.02-.17,0,.09,0,.14.02.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,467.38l.04.21c0-.08-.02-.14-.04-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.29,447.54s0-.05,0-.08c0,.03,0,.06,0,.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.54,397.56s0-.05.01-.07c-.01,0-.02,0-.01.07Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "47.84 403.62 47.84 403.63 47.84 403.63 47.84 403.62"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.78,403.3c-.01.1.02.25.06.32,0-.1-.01-.2-.06-.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.82,404.32s0-.02,0-.04c0,.01,0,.03,0,.04Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "47.91 397.8 47.91 397.8 47.91 397.8 47.91 397.8"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.92,399.09s-.02.05-.02.09c0-.02.02-.05.02-.09Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "47.95 407.54 47.95 407.53 47.95 407.54 47.95 407.54"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.31,419.71c-.03-1.22-.13-2.8-.1-4.02-.1-.26-.1-.65-.13-1.03l.13-.04-.04-.32c.04-.13.03.25.08.02l-.08-.12s.03-.83.13-.29v-1.25c0-.28-.11-.16-.08-.47.04-.06.03.11.07.08.1-.92-.26-1.06-.2-1.92l.02.07c-.04-.15-.03-.42-.05-.43-.13.11.07.15,0,.41-.11-.02-.06-.33-.15-.31.04-.2-.02-.32-.03-.49.07-.3.02-.73.11-.95-.04-.15-.15-.31-.15-.62.09-.22.08.05.12-.25l-.07-.05c.01-.25.03-.21.06-.2,0-.27-.09-.22-.05-.56l.06.19c-.03-.25-.01-.35,0-.7.04,0,.04.15.02.25.1-.19-.04-.32-.03-.42-.03.03-.04.27-.11.15.01-.17-.09-.37-.01-.49l.06.19c-.05-.36-.08-.19-.06-.6,0,.02.02.01.04.02-.08-.26,0-.6,0-.99l.02.07c-.02-.16-.08-.24-.08-.32-.04.22-.06.16-.12.18.11-.29-.13-.44-.06-.92.04,0,.08.12.04.25.11.16.21.18.26.47-.03-.18-.04-.39,0-.35l-.1-.06c0-.11,0-.19,0-.28-.07-.05-.11.22-.15-.03-.03-.28.11-.15.06-.2-.04-.39-.11-.16-.08-.54,0,.04.03.11.02.14.04-.27-.02-.66.11-.74.03.04.07.05.05.15h-.02c.09.29-.02-.25.09-.16-.07.02-.05-.36-.04-.53l-.08.05c-.23-.57.15.03.12-.53-.05-.36-.02.14-.07-.08.01-.24.08-.33.05-.68.03-.1.07-.3.16-.32-.03-.21.04-.65-.04-.77-.07.37.09.37-.02.79l-.08-.12c0-.3-.04-.68,0-.88-.02.04-.04.06-.06.03-.03-.42-.11-.54-.09-.96.08-.05.06.19.07.36.06-.27,0-.28.03-.69.07-.02,0,.28.06.32l-.02-.46s0,0,.01,0c-.11-.07,0-.35-.02-.63,0-.66-.15-.76-.24-1.13.03-.1.06-.13.09-.09-.05.16-.01.13.02.19-.01-.22.11-.49.15-.36-.03-.35-.06.13-.09-.09v-.48c-.05.06-.06.23-.11-.02-.02-.21,0-.31,0-.59.03.04.09-.09.08.12.02-.13.02-.34-.03-.42-.05.3-.05-.5-.14-.27l.05-.3c0,.07.04.08.03.18.09-.09-.02-.25-.03-.35.02-.11.02-.38.06-.41-.02-.1,0-.33.04-.37-.02-.14-.06-.01-.08-.05v-.48c.06-.03.19-.07.21,0-.04-.18-.14-.07-.14-.34.09.16.07-.37.18-.14.07-.16.07-.61.04-.86-.07-.15-.04.27-.12.25-.03-.7-.24-.74-.2-1.26l-.02.13c-.04-.32-.03-.28-.1-.47.09.09.25-.36.23-.89-.05-.04-.09.29-.16.21v-.35s0,.01.02.06c-.03-.31.12-.58.01-.67l.14-.32-.06.13s-.06-.4-.08-.47c-.05-.36-.01-.49.05-.69-.04.06-.13.22-.14-.06.15,0,.06-.59.14-.58,0-.11.05-.32-.02-.33l.09.02c-.13-.03-.13-.44-.15-.76.18.07-.01-.35.15-.49-.12-.06-.05-.56-.15-.62,0-.25.11-.22.15-.28l-.05-.11c.06-.12.07-.58.11-.86l-.11-.25.05-.09s-.04-.25-.08-.12v-.14c-.11-.01-.03-.19-.08-.47.02-.06.05-.05.06.01,0-.14.06-.08.1-.15-.03.1-.21-.49-.26-.12-.05.03-.08-.19-.06-.33l.11-.08-.11-.16c-.02-.21.05-.3.06-.47,0,.17.2.39.2-.06.01.24.07.35.09.48,0-.09.01-.14.06,0-.03-.35-.06-.12-.08-.47.09.02.12-.08.16-.38l-.07.23s-.02-.03-.03-.04c-.01.09-.03.11-.06.13,0-.07-.12-.41-.06-.46-.15.35-.11-.61-.2-.39-.03-.04-.03-.28.01-.31.07.29.11-.22.17-.17-.03-.11-.07.23-.11.08,0-.17.05-.3.08-.4l.02.07.04-.27s-.08.26-.1.01c.02-.07,0-.31.03-.31.06.12.15.03.17.24,0-.18-.02-.73-.11-.51v-.21c-.04.13-.11.5-.12.08h.02s-.07-.29-.07-.29l.05-.13s-.05-.04-.04-.15c.03-.03.04-.13.08-.12,0-.31-.05-.29-.08-.33,0-.18.01-.24.07-.16.01-.24,0-.66.05-.82-.04-.32-.02.07-.08-.12.17-.28.06-1.06.04-1.59-.14.14-.02-.14-.15-.24.05.11.11-.5.15-.04v-.28c.06-.19.04.46.15.17,0-.31-.16-.52-.11-.89.1.12-.03-.29.08-.19.04.08.03.18.03.28l.02-.06c.03-.69-.12-.2-.19-.56-.01-.42.08-.33.13-.36.02-.07,0-.28-.02-.39.06.26-.06.47-.13.36.12-.18,0-.62-.04-.74-.12.6,0,.42-.14.98.04.08.14.06.1.4-.05-.21-.06.01-.08.07.06-.06.03.23.05.34-.05.09-.14-.2-.16.14l.14.06c-.02.13-.1-.06-.07.23-.07-.15-.11.05-.14-.34-.12.46.06.71.12,1.06,0-.04-.03-.04-.04-.08.04.08.03.22.04.32-.03.24-.06-.19-.1-.13v.38s0,0,0,0c.02.1.03.2,0,.23-.05-.11-.09-.16-.13-.24l.1.4s-.08.33-.11.05l.02.59-.1.05c.02.14.04.15.05-.02-.02.2.17.9-.02.79.08.47.05.64.09,1.2-.09-.43-.11.5-.15.04-.04.27.06.33.08.54-.04.2-.13.11-.17-.1l.04.25h-.02s.05.22.05.22c-.05.23-.1.05-.11.29l.08.05-.05.16c.04-.06.06.08.06.26h-.02s.02.21.02.21c-.05-.21-.02.19-.08.1,0,.18,0,.19.01.51l.06-.06c.05.43-.09.02-.09.36l.07-.02c-.11.5.06.85,0,1.21-.02-.21-.09-.16-.07-.15.02.32,0,.83.09,1.16-.1.12-.13.15-.17.49,0,.25.01.28.07.36-.04.24.02.68-.05.7.06.06-.01.21.04.34l-.03.03.07-.02c-.15.42.08.71-.05,1.14l-.02-.07.03.18s-.05-.04-.08-.05v.83s.04-.16.04-.16c0,.18.07.29.03.49-.1-.33,0,.28-.08.33l-.03-.18q0,.24.07.22c.02.32-.13.22-.06.51v-.21c.04-.06.1.09.09.23-.01.03-.04.13-.05.03.03.25,0,.62.02.73-.02.14-.07.09-.09.02.06.53-.01.24.04.77h-.04s.05.17.05.17l-.08.26.05-.09c0,.17.03.28.01.49l-.06-.08c.03.49-.09.57-.02,1.04-.01.03-.03-.04-.04-.08.09.44-.1.33,0,.77-.02-.03-.04.02-.06,0l.04.2-.08-.02.11.16-.08.12.04.08c-.15.21-.04.51-.14.8l.1-.05c.2.74-.11,1.68-.02,2.57l-.08-.02.09.37c-.06.2-.06-.12-.1-.06.04.39.11.16.13.62-.05.23-.06-.08-.08-.19.04.43.08,1.06.04,1.36.01,0,.02.03.03.01.03.28,0,.66,0,.97-.03,0-.04-.09-.05-.16,0,.11-.03.27,0,.36l-.07-.12c-.01.24.05.7-.03.76.03-.03.09-.02.08.19-.12.11.05.57-.01.9-.03-.04-.03-.28-.03-.22-.03.17.02.32.06.46l-.05-.05.06.78c-.12.11.02.73-.07.68,0,.28.05-.23.06.12-.05.09.02.32-.05.3v-.04s0,.25,0,.25l-.07-.15c.02.21.09.37.15.38-.04.2,0,.48-.08.58l-.02-.07c.03.56-.2.93-.08,1.37-.01.03-.03.03-.03-.04v.35s-.06-.08-.06-.08l.09.57h-.04c-.02.37,0,.97.02,1.45l-.02-.07c.06.53-.04.51,0,.9,0-.01-.01-.03-.02-.04v.35s-.04-.08-.04-.08c.08.26-.11.74-.04.58.04.15.08.4.13.44,0,.38-.05.09-.08.33,0,.28.06.33.03.7h-.04c0,.17.03.28.04.52l-.02-.07c.08.4-.11.5.05.81-.03.17,0,.48-.08.47.05.5.07.88.1,1.38-.12.08,0,.11-.06.4l.07-.02c0,.7-.16,1.5-.13,2.27l-.07.02.07.15c-.03.83-.06,1.9-.06,2.56.04.22.12.54.09.89v-.04c.03.6.06,1.23.02,1.88-.03-.04-.05.02-.07-.05.07.15,0,.38,0,.52l.05-.16c.06.19,0,.45-.05.55l.07.29s-.02.05-.03.05l.04.05-.09.16c.02.07.04.46.12.58-.03.03-.05.3-.07.09l-.03,1.07.03-.17c.07-.02.11.3.08.47-.05-.22-.09-.02-.14.08.04.15.06-.13.1-.05.04.18.07.57.04.67l-.03-.11c.02.25-.09.36-.09.61.05.22,0,.38.12.34.02.32-.08.12-.09.23.05.15.02.59-.04.65.17.17-.06.86.08.92l-.08.26s.12.06.14.27c-.04.2-.11.15-.15.21l.14.13c-.15,1.15-.05,2.67-.17,3.92.03.56.09,1.27.07,1.93l-.02-.07-.04.65.06-.47c.02.14.04.25.04.39-.06.72-.13,1.67-.06,2.55.16.57-.14.38-.03.93-.01-.05-.04-.06-.05-.11.05.59.08.91.18,1.5-.16-.07,0,.38-.08.33l.07.05c-.04.13-.05.44-.1.4l.08.26-.07.02c0,.34.05,1.09-.09,1.27.1.85.07,2.2.04,3.27.05.15.06.46.06.71l-.08.26c.02.25.12.51.07.74,0,0-.02-.01-.02-.03.02.25-.03.49.05.73,0,.28-.05.55-.12.46.13.03-.02.59-.02.59,0,0-.32,14.22.4,17.69.06.12.11.44.19.32.02.25-.09.36-.03.41.04-.34.17.1.25-.23l.02.21s-.05-.29.03-.24l-.12-.06c.02-.17.04-.27.09-.33-.05-.16-.21-.27-.14-.65v.11c0-.31.09-.19.11-.26v.07s.06-.27.06-.27c-.04.2.06.53.05.36.03-.38-.03.1-.04-.18,0-.17.06-.13.1-.12v-.31c.05.01,0,.21.05.08l-.06-.4c.14-.07-.07-.43.07-.61.03.28.05-.03.09.02v-.7c.01-.07.04.18.03.08.04-.13-.03-.22-.03-.29.04-.06,0-.52.09-.5.06-.47-.12-.2-.07-.64.06-.06.01.35.07.15l-.02-.46s.09.09.08.26c.08-1.23.38-1.9.3-3.03.07-.16.05.11.09.23-.09-.82.15-1.15.14-1.85h-.06c.18-.98.07-2.15.14-3.25l-.04.13c-.05-.15-.06-.39-.09-.57.03-.03.12.13.1-.19-.02.07-.04.2-.07.16.15-.94.11-2.93.18-4.48-.04-2.09.07-4.36.03-6.42,0,.31-.14.18-.1-.06.24-.65-.04-1.12.12-1.78-.08-1.2.13-2.27-.05-3.38l.07-.02c.03-.17-.02-.21-.02-.39h.02c.03-.41-.04-.91-.01-1.15l-.08-.02c0-.25.06-.13.02-.38h.04s-.07-.29-.07-.29c.13.03.01-.69.07-.89-.02-.32-.08-.92-.05-1.4.07-.09.07-.68.1-1.06-.02-.73-.04-1.78-.01-2.71l-.09.02v-.24s.02-.03.03,0c.1-.19-.03-.56.03-.76-.08.12-.01.17-.01.31-.04.2-.12,0-.08-.26h.02s-.04-.18-.04-.18c.07-.02.1-.19.16-.21-.02-.8-.13-1.35-.1-2.17.07.09-.02-.59.11-.43-.05-.5-.11.08-.2-.15,0-.14-.03-.28.01-.31.03.07.08-.11.09,0v-.33s.02.04.03.08c-.07-.68.08-1.2,0-1.8-.05-.05-.01.24-.06.2-.09-.61.08-.54.02-1.11l.06.12c-.04-.18-.1-.26-.05-.57.08-.05.06.26.1.4,0-.21-.02-.73-.09-.57-.03-.25.04-.34.06-.47-.02,0-.05.23-.09.09.04-.34.04-.86.05-1.28.02,0,.05-.03.06.01-.1-.33.07-.3.05-.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.92,397.63v.17s.02,0,.04.08l-.04-.25Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.88,405.56s.01.04.02.06c0-.04-.01-.05-.02-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.01,407.48c-.02-.14-.04-.02-.06.05.02,0,.03,0,.06-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.72,393.14s.02.05.03.04c-.01-.04-.02-.05-.03-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.78,380.74s0,.03-.01.05c0,0,0-.03.01-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.66,381.42s0,.08.01.14c0-.06,0-.1-.01-.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.75,396.15s0,.09.02.13c0-.07-.01-.11-.02-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.69,381.71v.17s0,0,0,0v-.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.79,380.52c0,.07,0,.16,0,.22.02-.09.02-.15,0-.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.63,388.59s0,.01,0,.02c.03.14.02.05,0-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.82,382.46s0,.02,0,.02l.02.05-.02-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.82,379.77s0,.06.01.09c0-.03,0-.06,0-.1,0,0-.02.01-.02.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.74,385.99s-.05-.07-.06-.07c0,.06.01.09.06.07Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.62,327.59s.02.02.03.03c-.01-.02-.02-.03-.03-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.84,315.48l.02.14c0-.09,0-.13-.02-.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.53,334.84s0-.01,0-.02c0,.11,0,.26,0,.51v-.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.09,289.65v.16c0-.07,0-.12,0-.16Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.93,304.95s-.02-.13-.02-.21c0,.1,0,.18.02.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.79,338.68l.05-.21s-.04.08-.05.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.99,346.04s0,0,.01-.02c0-.01,0,0-.01.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.19,343.16c0-.06-.01-.13-.02-.21,0,.09,0,.2.02.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.16,342.86v.1c.01-.05,0-.1,0-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.85,195.82c0-.21-.04-.39-.07-.58l.07.58Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.12,266.26l.02.05s-.01-.05-.02-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,195.56v-.15c0,.05,0,.1,0,.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,334.78c-.05-.21,0-.65-.04-.65,0,.23-.03.54.04.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.28,261.31v-.14c0,.07,0,.11,0,.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,195.56v.17s.01-.05.01-.05c0-.04-.01-.08-.01-.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.14,241.9h0s0,.04,0,.06v-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.22,240.61c0,.09.01.18.02.28,0-.15,0-.22-.02-.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.78,195.24l-.04-.33c0,.12.02.23.04.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.15,226.69v.13c0-.06,0-.1,0-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.9,305.94s0,.08-.01.11c.01.01.02,0,.01-.11Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.6 296.31 46.6 296.31 46.6 296.31 46.6 296.31"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,296.83c.01-.16-.02-.39-.06-.51,0,.16.01.31.06.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,295.21s0,.04,0,.06c0-.02,0-.04,0-.06Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.53 305.55 46.53 305.55 46.53 305.54 46.53 305.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.52,303.5s.02-.09.02-.14c0,.03-.02.08-.02.14Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.49 290.11 46.49 290.12 46.49 290.11 46.49 290.11"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.12,270.82c.03,1.94.13,4.45.1,6.37.1.42.1,1.03.13,1.64l-.13.06.04.51c-.04.21-.02-.39-.08-.03l.08.19s-.03,1.31-.13.45v1.98c0,.44.11.26.08.74-.04.1-.03-.17-.07-.13-.1,1.46.26,1.68.2,3.04l-.02-.12c.04.23.03.67.05.68.13-.17-.07-.24,0-.66.11.04.06.52.15.49-.04.32.02.5.03.78-.07.47-.02,1.15-.11,1.51.04.23.15.49.15.99-.09.36-.08-.08-.12.4l.07.08c-.01.4-.03.34-.06.32,0,.43.09.35.05.89l-.06-.3c.03.39.01.56,0,1.1-.04-.01-.04-.23-.02-.39-.1.3.04.51.03.67.03-.05.04-.43.11-.24-.01.27.09.58.01.77l-.06-.3c.05.57.08.3.06.96,0-.04-.02-.02-.04-.03.08.41,0,.95,0,1.56l-.02-.12c.02.25.08.38.08.51.04-.35.06-.25.12-.28-.11.46.13.7.06,1.45-.04-.01-.08-.19-.04-.4-.11-.26-.21-.29-.26-.75.03.28.04.62,0,.55l.1.09c0,.17,0,.31,0,.44.07.07.11-.35.15.05.03.45-.11.24-.06.31.04.62.11.26.08.85,0-.06-.03-.18-.02-.23-.04.43.02,1.05-.11,1.18-.03-.06-.07-.08-.05-.24h.02c-.09-.46.02.4-.09.25.07-.03.05.57.04.84l.08-.09c.23.9-.15-.05-.12.84.05.57.02-.21.07.13-.01.38-.08.53-.05,1.09-.03.16-.07.47-.16.5.03.34-.04,1.03.04,1.23.07-.58-.09-.58.02-1.26l.08.19c0,.47.04,1.07,0,1.4.02-.07.04-.09.06-.05.03.67.11.86.09,1.52-.08.09-.06-.3-.07-.57-.06.42,0,.44-.03,1.09-.07.03,0-.44-.06-.51l.02.72h-.01c.11.1,0,.55.02.99,0,1.05.15,1.21.24,1.79-.03.16-.06.2-.09.14.05-.26.01-.21-.02-.3.01.35-.11.77-.15.58.03.56.06-.2.09.14v.77c.05-.09.06-.36.11.04.02.34,0,.5,0,.94-.03-.06-.09.14-.08-.19-.02.21-.02.54.03.67.05-.48.05.79.14.43l-.05.48c0-.11-.04-.12-.03-.28-.09.14.02.39.03.56-.02.17-.02.61-.06.64.02.15,0,.52-.04.59.02.23.06.02.08.08v.77c-.06.04-.19.1-.21-.01.04.29.14.1.14.54-.09-.25-.07.58-.18.22-.07.25-.07.97-.04,1.36.07.24.04-.43.12-.4.03,1.11.24,1.18.2,1.99l.02-.21c.04.51.03.45.1.75-.09-.14-.25.58-.23,1.41.05.07.09-.47.16-.33v.55s0-.02-.02-.09c.03.5-.12.92-.01,1.07l-.14.5.06-.2c.05.07.06.63.08.74.05.57.01.78-.05,1.09.04-.1.13-.35.14.1-.15,0-.06.94-.14.92,0,.18-.05.5.02.52l-.09-.03c.13.04.13.7.15,1.21-.18-.11.01.55-.15.78.12.09.05.9.15.98,0,.39-.11.35-.15.45l.05.18c-.06.2-.07.92-.11,1.36l.11.4-.05.15c.03.06.04.4.08.19v.22c.11.02.03.31.08.74-.02.1-.05.07-.06-.02,0,.22-.06.12-.1.24.03-.15.21.78.26.2.05-.04.08.3.06.52l-.11.13.11.26c.02.34-.05.48-.06.75,0-.28-.2-.62-.2.1-.01-.38-.07-.56-.09-.76,0,.15-.01.22-.06,0,.03.56.06.19.08.74-.09-.03-.12.12-.16.61l.07-.36s.02.04.03.07c.01-.14.03-.18.06-.21,0,.11.12.64.06.74.15-.56.11.97.2.62.03.06.03.45-.01.49-.07-.46-.11.35-.17.27.03.17.07-.36.11-.13,0,.28-.05.48-.08.63l-.02-.12-.04.43c.05.07.08-.41.1-.02-.02.1,0,.5-.03.49-.06-.19-.15-.05-.17-.39,0,.28.02,1.16.11.81v.33c.04-.21.11-.79.12-.13h-.02s.07.46.07.46l-.05.2s.05.07.04.24c-.03.04-.04.21-.08.19,0,.5.05.46.08.52,0,.28-.01.38-.07.25-.01.38,0,1.05-.05,1.31.04.51.02-.1.08.19-.17.44-.06,1.69-.04,2.52.14-.23.02.23.15.38-.05-.18-.11.79-.15.06v.44c-.06.3-.04-.73-.15-.28,0,.5.16.83.11,1.41-.1-.2.03.45-.08.31-.04-.12-.03-.28-.03-.45l-.02.1c-.03,1.09.12.32.19.89.01.67-.08.52-.13.56-.02.1,0,.44.02.61-.06-.41.06-.75.13-.56-.12.29,0,.99.04,1.17.12-.95,0-.66.14-1.55-.04-.12-.14-.1-.1-.64.05.34.06-.02.08-.12-.06.1-.02-.37-.05-.54.05-.15.14.32.16-.22l-.14-.1c.02-.21.1.09.07-.36.07.24.11-.07.14.54.12-.73-.06-1.12-.12-1.69,0,.06.03.06.04.12-.04-.12-.03-.34-.04-.51.03-.37.06.3.1.2v-.61s0-.02,0-.02c-.02-.16-.03-.31,0-.37.05.18.09.25.13.37l-.1-.64c.05.07.08-.53.11-.07l-.02-.94.1-.08c-.02-.23-.04-.23-.05.04.02-.32-.17-1.43.02-1.26-.08-.74-.05-1.01-.09-1.9.09.69.11-.79.15-.06.04-.43-.06-.52-.08-.85.04-.32.13-.18.17.17l-.04-.4h.02s-.05-.34-.05-.34c.05-.37.1-.08.11-.46l-.08-.08.05-.26c-.04.1-.06-.13-.06-.41h.02s-.02-.33-.02-.33c.05.33.02-.31.08-.15,0-.29,0-.29-.01-.81l-.06.09c-.05-.68.09-.03.09-.58l-.07.03c.11-.79-.06-1.34,0-1.93.02.33.09.25.07.24-.02-.5,0-1.32-.09-1.84.1-.19.13-.23.17-.77,0-.39-.01-.45-.07-.57.04-.38-.02-1.08.05-1.1-.06-.09.01-.34-.04-.55l.03-.04-.07.03c.15-.67-.08-1.13.05-1.8l.02.12-.03-.28s.05.07.08.08v-1.32s-.04.26-.04.26c0-.28-.07-.46-.03-.78.1.53,0-.44.08-.52l.03.28q0-.39-.07-.35c-.02-.5.13-.34.06-.81v.33c-.04.1-.1-.14-.09-.36.01-.05.04-.21.05-.04-.03-.4,0-.99-.02-1.16.02-.21.07-.14.09-.03-.06-.84.01-.38-.04-1.23h.04s-.05-.28-.05-.28l.08-.41-.05.15c0-.28-.03-.45-.01-.77l.06.13c-.03-.78.09-.91.02-1.65.01-.05.03.06.04.12-.09-.69.1-.52,0-1.22.02.04.04-.03.06,0l-.04-.32.08.02-.11-.26.08-.19-.04-.12c.15-.34.04-.81.14-1.28l-.1.08c-.2-1.17.11-2.66.02-4.07l.08.03-.09-.58c.06-.31.06.19.1.09-.04-.62-.11-.26-.13-.98.05-.37.06.13.08.3-.04-.68-.08-1.68-.04-2.15-.01-.01-.02-.04-.03-.02-.03-.45,0-1.05,0-1.54.03.01.04.14.05.26,0-.18.03-.42,0-.58l.07.19c.01-.38-.05-1.12.03-1.2-.03.05-.09.03-.08-.3.12-.18-.05-.9.01-1.43.03.06.03.45.03.34.03-.27-.02-.5-.06-.74l.05.07-.06-1.23c.12-.18-.02-1.16.07-1.08,0-.44-.05.37-.06-.19.05-.15-.02-.5.05-.48v.06s0-.39,0-.39l.07.25c-.02-.34-.09-.58-.15-.6.04-.32,0-.77.08-.91l.02.12c-.03-.89.2-1.48.08-2.18.01-.05.03-.05.03.06v-.55s.06.13.06.13l-.09-.91h.04c.02-.59,0-1.53-.02-2.31l.02.12c-.06-.84.04-.82,0-1.43.01.02.01.04.02.07v-.56s.04.12.04.12c-.08-.41.11-1.18.04-.92-.04-.23-.08-.63-.13-.7,0-.61.05-.15.08-.52,0-.44-.06-.52-.03-1.11h.04c0-.27-.03-.44-.04-.83l.02.12c-.08-.63.11-.79-.05-1.28.03-.27,0-.77.08-.74-.04-.8-.07-1.4-.1-2.18.12-.13,0-.17.06-.64l-.07.03c0-1.11.16-2.37.13-3.59l.07-.03-.07-.24c.02-1.32.04-3.01.06-4.06-.03-.34-.12-.86-.09-1.41v.06c-.03-.95-.06-1.95-.02-2.98.03.06.05-.04.07.08-.07-.25,0-.61,0-.83l-.05.26c-.06-.29,0-.72.05-.87l-.07-.47s.02-.08.03-.08l-.04-.08.09-.25c-.02-.12-.04-.73-.12-.92.03-.04.05-.48.07-.14l.03-1.7-.03.26c-.07.03-.11-.48-.08-.74.05.35.09.03.14-.12-.04-.23-.06.2-.1.08-.04-.29-.07-.9-.04-1.06l.03.17c-.02-.39.09-.58.09-.96-.05-.35,0-.61-.12-.53-.02-.5.08-.19.09-.36-.05-.24-.02-.94.04-1.03-.17-.28.06-1.36-.08-1.46l.08-.41s-.12-.1-.14-.43c.04-.32.11-.24.15-.34l-.14-.21c.15-1.82.05-4.23.17-6.22-.03-.89-.09-2.01-.07-3.05l.02.12.04-1.03-.06.75c-.02-.23-.04-.4-.04-.62.06-1.13.13-2.65.06-4.05-.16-.91.14-.6.03-1.47.01.07.04.1.05.17-.05-.93-.08-1.44-.18-2.38.16.11,0-.61.08-.52l-.07-.08c.04-.21.05-.7.1-.63l-.08-.41.07-.04c0-.55-.05-1.72.09-2.01-.1-1.35-.07-3.49-.04-5.19-.05-.24-.06-.74-.06-1.12l.08-.41c-.02-.39-.12-.81-.07-1.18,0,0,.02.02.02.04-.02-.4.03-.78-.05-1.16,0-.44.05-.87.12-.73-.13-.04.02-.93.02-.93,0,0,.32-22.54-.4-28.04-.06-.18-.11-.7-.18-.5-.02-.4.09-.58.03-.65-.04.54-.17-.17-.25.36l-.02-.34c-.05-.07.05.46-.03.38l.12.09c-.02.27-.04.42-.09.52.05.26.21.42.14,1.03v-.17c0,.5-.09.31-.11.41v-.11s-.06.42-.06.42c.04-.32-.06-.84-.05-.57-.03.59.03-.15.04.29,0,.28-.06.2-.1.19v.5c-.05-.02,0-.33-.05-.13l.06.63c-.14.12.07.68-.07.97-.03-.45-.05.04-.09-.03v1.1c-.01.1-.04-.29-.03-.12-.04.21.03.34.03.45-.04.1,0,.82-.09.79-.06.75.12.32.07,1.01-.06.09-.01-.55-.07-.24l.02.72c-.03-.07-.09-.14-.08-.41-.08,1.96-.38,3.01-.3,4.8-.07.25-.05-.18-.09-.36.09,1.3-.15,1.82-.14,2.93l.06.02c-.18,1.54-.07,3.39-.14,5.13l.04-.21c.05.24.06.63.09.91-.03.04-.12-.21-.1.3.02-.1.04-.32.07-.25-.15,1.49-.11,4.65-.18,7.1.04,3.32-.07,6.92-.03,10.18,0-.5.14-.29.1.09-.24,1.02.04,1.78-.12,2.82.08,1.9-.13,3.59.05,5.36l-.07.03c-.03.26.02.34.02.61h-.02c-.03.65.04,1.44.01,1.82l.08.02c0,.39-.06.2-.02.6h-.04s.07.45.07.45c-.13-.04-.01,1.1-.07,1.41.02.5.08,1.46.05,2.22-.07.14-.07,1.08-.1,1.67.02,1.16.04,2.82.01,4.3l.09-.03v.39s-.02.05-.03-.01c-.1.3.03.89-.03,1.2.08-.2.01-.27.01-.49.04-.32.12-.01.08.41h-.02s.05.28.05.28c-.07.03-.1.3-.16.33.02,1.27.13,2.14.1,3.45-.07-.14.02.94-.11.68.05.79.1-.13.2.23,0,.22.03.45-.01.49-.03-.1-.08.18-.09,0v.53c0,.05-.02-.07-.03-.12.07,1.07-.08,1.9,0,2.86.05.07.01-.38.06-.31.1.97-.08.85-.02,1.76l-.06-.19c.04.29.1.42.05.9-.08.08-.06-.41-.1-.64,0,.33.02,1.16.09.91.02.39-.04.54-.06.75.02,0,.05-.37.09-.14-.04.54-.04,1.37-.05,2.02-.02,0-.05.04-.06-.02.1.53-.07.47-.05,1.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.51,305.81v-.27s-.02-.01-.04-.13l.04.4Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.56,293.25s-.01-.06-.02-.09c0,.06.01.09.02.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.43,290.2c.02.22.04.02.06-.08-.02,0-.03,0-.06.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.72,312.93s-.02-.07-.03-.07c.01.06.02.08.03.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,332.6s0-.05.01-.08c0,.01,0,.04-.01.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.78,331.51c0-.05,0-.12-.01-.22,0,.1,0,.17.01.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.69,308.16c0-.07,0-.14-.02-.21,0,.11.01.17.02.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.75 331.06 46.76 330.79 46.75 330.78 46.75 331.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.65,332.95c0-.11,0-.25,0-.35-.02.14-.02.24,0,.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.81,320.15v-.03c-.03-.21-.02-.08,0,.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.62 329.86 46.62 329.83 46.6 329.75 46.62 329.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,334.13c0-.05,0-.1-.01-.14,0,.04,0,.09,0,.16,0-.01.02-.02.02-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.7,324.27c.03.08.05.11.06.11,0-.09-.01-.15-.06-.11Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.62,172.95s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.84,169.76l.02.04s0-.03-.02-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.53,174.86s0,0,0,0c0,.03,0,.07,0,.13v-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.09,162.95v.04s0-.03,0-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.93,166.98s-.02-.03-.02-.05c0,.03,0,.05.02.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.79,175.87l.05-.05s-.04.02-.05.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.99,177.81s0,0,.01,0c0,0,0,0-.01,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.19,177.05s-.01-.04-.02-.05c0,.02,0,.05.02.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.16,176.97s0,.02.01.03c0-.01,0-.03-.01-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.85,138.23c0-.06-.04-.1-.07-.15l.07.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.12,156.79h.02s-.01,0-.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,138.16v-.04s0,.03,0,.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,174.84c-.05-.06,0-.17-.04-.17,0,.06-.03.14.04.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.28,155.49v-.04s0,.03,0,.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.41,138.16v.05s0,0,.01-.01c0-.01-.01-.02-.01-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.14,150.37h0s0,.01,0,.02v-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.22,150.03s.01.05.02.07c0-.04,0-.06-.02-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.78,138.08l-.04-.09s.02.06.04.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m48.15,146.36s0,.02,0,.03c0-.01,0-.03,0-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m47.9,167.24s0,.02-.01.03c.01,0,.02,0,.01-.03Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.6 164.71 46.6 164.71 46.6 164.71 46.6 164.71"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,164.84s-.02-.1-.06-.14c0,.04.01.08.06.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,164.42s0,0,0,.02c0,0,0-.01,0-.02Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.53 167.14 46.53 167.14 46.53 167.14 46.53 167.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.52,166.6s.02-.02.02-.04c0,0-.02.02-.02.04Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.49 163.07 46.49 163.07 46.49 163.07 46.49 163.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.12,157.99c.03.51.13,1.17.1,1.68.1.11.1.27.13.43l-.13.02.04.13c-.04.05-.02-.1-.08,0l.08.05s-.03.35-.13.12v.52c0,.12.11.07.08.2-.04.03-.03-.05-.07-.04-.1.38.26.44.2.8l-.02-.03c.04.06.03.18.05.18.13-.05-.07-.06,0-.17.11,0,.06.14.15.13-.04.08.02.13.03.21-.07.12-.02.3-.11.4.04.06.15.13.15.26-.09.09-.08-.02-.12.11l.07.02c-.01.1-.03.09-.06.08,0,.11.09.09.05.23l-.06-.08c.03.1.01.15,0,.29-.04,0-.04-.06-.02-.1-.1.08.04.13.03.18.03-.01.04-.11.11-.06-.01.07.09.15.01.2l-.06-.08c.05.15.08.08.06.25,0,0-.02,0-.04,0,.08.11,0,.25,0,.41l-.02-.03c.02.06.08.1.08.14.04-.09.06-.07.12-.07-.11.12.13.19.06.38-.04,0-.08-.05-.04-.11-.11-.07-.21-.08-.26-.2.03.07.04.16,0,.14l.1.02s0,.08,0,.12c.07.02.11-.09.15.01.03.12-.11.06-.06.08.04.16.11.07.08.22,0-.02-.03-.05-.02-.06-.04.11.02.28-.11.31-.03-.02-.07-.02-.05-.06h.02c-.09-.12.02.11-.09.07.07,0,.05.15.04.22l.08-.02c.23.24-.15-.01-.12.22.05.15.02-.06.07.04-.01.1-.08.14-.05.29-.03.04-.07.12-.16.13.03.09-.04.27.04.32.07-.15-.09-.15.02-.33l.08.05c0,.12.04.28,0,.37.02-.02.04-.02.06-.01.03.18.11.23.09.4-.08.02-.06-.08-.07-.15-.06.11,0,.12-.03.29-.07,0,0-.12-.06-.14l.02.19s0,0-.01,0c.11.03,0,.15.02.26,0,.28.15.32.24.47-.03.04-.06.05-.09.04.05-.07.01-.06-.02-.08.01.09-.11.2-.15.15.03.15.06-.05.09.04v.2s.06-.1.11,0c.02.09,0,.13,0,.25-.03-.02-.09.04-.08-.05-.02.06-.02.14.03.18.05-.13.05.21.14.11l-.05.13s-.04-.03-.03-.07c-.09.04.02.1.03.15-.02.04-.02.16-.06.17.02.04,0,.14-.04.16.02.06.06,0,.08.02v.2c-.06.01-.19.03-.21,0,.04.08.14.03.14.14-.09-.07-.07.15-.18.06-.07.07-.07.26-.04.36.07.06.04-.11.12-.11.03.29.24.31.2.52l.02-.06c.04.13.03.12.1.2-.09-.04-.25.15-.23.37.05.02.09-.12.16-.09v.15s0,0-.02-.02c.03.13-.12.24-.01.28l-.14.13.06-.05s.06.17.08.2c.05.15.01.2-.05.29.04-.03.13-.09.14.03-.15,0-.06.25-.14.24,0,.05-.05.13.02.14h-.09c.13,0,.13.18.15.31-.18-.03.01.15-.15.2.12.02.05.24.15.26,0,.1-.11.09-.15.12l.05.05c-.06.05-.07.24-.11.36l.11.11-.05.04s.04.11.08.05v.06c.11,0,.03.08.08.2-.02.03-.05.02-.06,0,0,.06-.06.03-.1.06.03-.04.21.21.26.05.05-.01.08.08.06.14l-.11.03.11.07c.02.09-.05.13-.06.2,0-.07-.2-.16-.2.03-.01-.1-.07-.15-.09-.2,0,.04-.01.06-.06,0,.03.15.06.05.08.2-.09,0-.12.03-.16.16l.07-.1s.02.01.03.02c.01-.04.03-.05.06-.05,0,.03.12.17.06.19.15-.15.11.26.2.16.03.02.03.12-.01.13-.07-.12-.11.09-.17.07.03.05.07-.1.11-.03,0,.07-.05.13-.08.17l-.02-.03-.04.11s.08-.11.1,0c-.02.03,0,.13-.03.13-.06-.05-.15-.01-.17-.1,0,.07.02.31.11.21v.09c.04-.05.11-.21.12-.03h-.02s.07.12.07.12l-.05.05s.05.02.04.06c-.03.01-.04.05-.08.05,0,.13.05.12.08.14,0,.07-.01.1-.07.07-.01.1,0,.28-.05.34.04.13.02-.03.08.05-.17.12-.06.44-.04.66.14-.06.02.06.15.1-.05-.05-.11.21-.15.02v.12c-.06.08-.04-.19-.15-.07,0,.13.16.22.11.37-.1-.05.03.12-.08.08-.04-.03-.03-.08-.03-.12l-.02.03c-.03.29.12.08.19.23.01.18-.08.14-.13.15-.02.03,0,.12.02.16-.06-.11.06-.2.13-.15-.12.08,0,.26.04.31.12-.25,0-.17.14-.41-.04-.03-.14-.03-.1-.17.05.09.06,0,.08-.03-.06.03-.02-.1-.05-.14.05-.04.14.08.16-.06l-.14-.03c.02-.06.1.02.07-.1.07.06.11-.02.14.14.12-.19-.06-.3-.12-.44,0,.02.03.02.04.03-.04-.03-.03-.09-.04-.13.03-.1.06.08.1.05v-.16s0,0,0,0c-.02-.04-.03-.08,0-.1.05.05.09.07.13.1l-.1-.17s.08-.14.11-.02l-.02-.25.1-.02c-.02-.06-.04-.06-.05.01.02-.08-.17-.38.02-.33-.08-.2-.05-.27-.09-.5.09.18.11-.21.15-.02.04-.11-.06-.14-.08-.22.04-.08.13-.05.17.04l-.04-.11h.02s-.05-.09-.05-.09c.05-.1.1-.02.11-.12l-.08-.02.05-.07s-.06-.03-.06-.11h.02s-.02-.09-.02-.09c.05.09.02-.08.08-.04,0-.08,0-.08-.01-.21l-.06.02c-.05-.18.09,0,.09-.15h-.07c.11-.2-.06-.34,0-.5.02.09.09.07.07.06-.02-.13,0-.35-.09-.49.1-.05.13-.06.17-.2,0-.1-.01-.12-.07-.15.04-.1-.02-.29.05-.29-.06-.02.01-.09-.04-.14h.03s-.07,0-.07,0c.15-.18-.08-.3.05-.48l.02.03-.03-.07s.05.02.08.02v-.35s-.04.07-.04.07c0-.07-.07-.12-.03-.21.1.14,0-.12.08-.14l.03.07q0-.1-.07-.09c-.02-.13.13-.09.06-.21v.09s-.1-.04-.09-.09c.01-.01.04-.05.05-.01-.03-.1,0-.26-.02-.31.02-.06.07-.04.09,0-.06-.22.01-.1-.04-.32h.04s-.05-.07-.05-.07l.08-.11-.05.04c0-.07-.03-.12-.01-.2l.06.03c-.03-.21.09-.24.02-.43.01-.01.03.02.04.03-.09-.18.1-.14,0-.32.02.01.04,0,.06,0l-.04-.08h.08s-.11-.06-.11-.06l.08-.05-.04-.03c.15-.09.04-.21.14-.34l-.1.02c-.2-.31.11-.7.02-1.07h.08s-.09-.15-.09-.15c.06-.08.06.05.1.02-.04-.16-.11-.07-.13-.26.05-.1.06.03.08.08-.04-.18-.08-.44-.04-.57-.01,0-.02-.01-.03,0-.03-.12,0-.28,0-.41.03,0,.04.04.05.07,0-.05.03-.11,0-.15l.07.05c.01-.1-.05-.29.03-.32-.03.01-.09,0-.08-.08.12-.05-.05-.24.01-.38.03.02.03.12.03.09.03-.07-.02-.13-.06-.19l.05.02-.06-.32c.12-.05-.02-.31.07-.28,0-.12-.05.1-.06-.05.05-.04-.02-.13.05-.13v.02s0-.1,0-.1l.07.06c-.02-.09-.09-.15-.15-.16.04-.08,0-.2.08-.24l.02.03c-.03-.24.2-.39.08-.57.01-.01.03-.01.03.02v-.15s.06.03.06.03l-.09-.24h.04c.02-.16,0-.4-.02-.61l.02.03c-.06-.22.04-.21,0-.38.01,0,.01.01.02.02v-.15s.04.03.04.03c-.08-.11.11-.31.04-.24-.04-.06-.08-.17-.13-.19,0-.16.05-.04.08-.14,0-.12-.06-.14-.03-.29h.04c0-.07-.03-.12-.04-.22l.02.03c-.08-.17.11-.21-.05-.34.03-.07,0-.2.08-.2-.05-.21-.07-.37-.1-.57.12-.03,0-.04.06-.17h-.07c0-.28.16-.62.13-.94h.07s-.07-.07-.07-.07c.03-.35.06-.79.06-1.07-.03-.09-.12-.23-.09-.37h0c-.04-.23-.07-.5-.03-.77.03.02.05-.01.07.02-.07-.06,0-.16,0-.22l-.05.07c-.06-.08,0-.19.05-.23l-.07-.12s.02-.02.03-.02l-.04-.02.09-.07s-.04-.19-.12-.24c.03-.01.05-.13.07-.04l.03-.45-.03.07c-.07,0-.11-.13-.08-.2.05.09.09,0,.14-.03-.04-.06-.06.05-.1.02-.04-.08-.07-.24-.04-.28l.03.05c-.02-.1.09-.15.09-.25-.05-.09,0-.16-.12-.14-.02-.13.08-.05.09-.09-.05-.06-.02-.25.04-.27-.17-.07.06-.36-.08-.39l.08-.11s-.12-.02-.14-.11c.04-.08.11-.06.15-.09l-.14-.06c.15-.48.05-1.11.17-1.64-.03-.23-.09-.53-.07-.8l.02.03.04-.27-.06.2c-.02-.06-.04-.11-.04-.16.06-.3.13-.7.06-1.07-.16-.24.14-.16.03-.39.01.02.04.03.05.04-.05-.25-.08-.38-.18-.63.16.03,0-.16.08-.14l-.07-.02c.04-.05.05-.18.1-.17l-.08-.11h.07c0-.15-.05-.46.09-.54-.1-.36-.07-.92-.04-1.37-.05-.06-.06-.19-.06-.3l.08-.11c-.02-.1-.12-.21-.07-.31,0,0,.02,0,.02.01-.02-.11.03-.21-.05-.3,0-.12.05-.23.12-.19-.13-.01.02-.25.02-.25,0,0,.32-5.94-.4-7.39-.06-.05-.11-.18-.18-.13-.02-.1.09-.15.03-.17-.04.14-.17-.04-.25.09l-.02-.09s.05.12-.03.1l.12.02c-.02.07-.04.11-.09.14.05.07.21.11.14.27v-.04c0,.13-.09.08-.11.11v-.03s-.06.11-.06.11c.04-.08-.06-.22-.05-.15-.03.16.03-.04.04.08,0,.07-.06.05-.1.05v.13c-.05,0,0-.09-.05-.03l.06.17c-.14.03.07.18-.07.26-.03-.12-.05.01-.09,0v.29s-.04-.08-.03-.03c-.04.05.03.09.03.12-.04.03,0,.22-.09.21-.06.2.12.08.07.27-.06.02-.01-.15-.07-.06l.02.19s-.09-.04-.08-.11c-.08.52-.38.79-.3,1.27-.07.07-.05-.05-.09-.09.09.34-.15.48-.14.77h.06c-.18.41-.07.9-.14,1.36l.04-.05c.05.06.06.16.09.24-.03.01-.12-.05-.1.08.02-.03.04-.08.07-.07-.15.39-.11,1.22-.18,1.87.04.87-.07,1.82-.03,2.68,0-.13.14-.08.1.02-.24.27.04.47-.12.74.08.5-.13.95.05,1.41h-.07c-.03.08.02.1.02.17h-.02c-.03.17.04.38.01.48h.08c0,.11-.06.06-.02.16h-.04s.07.12.07.12c-.13-.01-.01.29-.07.37.02.13.08.38.05.59-.07.04-.07.28-.1.44.02.31.04.74.01,1.13h.09s0,.09,0,.09c-.02,0-.03.01-.04,0-.1.08.03.23-.03.32.08-.05.01-.07.01-.13.04-.08.12,0,.08.11h-.02s.05.07.05.07c-.07,0-.1.08-.16.09.02.33.13.56.1.91-.07-.04.02.25-.11.18.05.21.1-.03.2.06,0,.06.03.12-.01.13-.03-.03-.08.05-.09,0v.14s-.02-.02-.03-.03c.07.28-.08.5,0,.75.05.02.01-.1.06-.08.1.25-.08.23-.02.46l-.06-.05c.04.08.1.11.05.24-.08.02-.06-.11-.1-.17,0,.09.02.31.09.24.02.1-.04.14-.06.2.02,0,.05-.1.09-.04-.04.14-.04.36-.05.53-.02,0-.05.01-.06,0,.1.14-.07.12-.05.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.51,167.21v-.07s-.02,0-.04-.04l.04.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.56,163.9s-.01-.02-.02-.03c0,.02.01.02.02.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.43,163.1c.02.06.04,0,.06-.02-.02,0-.03,0-.06.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.72,169.08s-.02-.02-.03-.02c.01.02.02.02.03.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.66,174.27s0-.01.01-.02c0,0,0,.01-.01.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.78,173.98s0-.03-.01-.06c0,.03,0,.04.01.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.69,167.83s0-.04-.02-.05c0,.03.01.04.02.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.75,173.86v-.07s0,0,0,0v.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.65,174.36s0-.07,0-.09c-.02.04-.02.06,0,.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.81,170.99s0,0,0,0c-.03-.06-.02-.02,0,0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "points": "46.62 173.55 46.62 173.54 46.6 173.52 46.62 173.55"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.62,174.67s0-.03-.01-.04c0,.01,0,.02,0,.04,0,0,.02,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m46.7,172.07s.05.03.06.03c0-.02-.01-.04-.06-.03Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m948.52,39.02c.09,0,.15-.02.18-.03-.16.01-.2.02-.18.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m871.13,38.8l.9-.02c-.59,0-.82,0-.9.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m994.89,39.11c-.06,0-.06,0-.11,0,.72,0,1.68,0,3.26,0h-3.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m706.05,38.55h1.04c-.47,0-.77,0-1.04,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m803.88,38.72c-.3.01-.82.02-1.31.02.63,0,1.14,0,1.31-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1019.39,39.85l-1.32-.05s.49.04,1.32.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1066.43,39.65s-.05,0-.12-.01c-.07,0,0,0,.12.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1048.05,39.45c-.4,0-.86.01-1.32.02.56,0,1.27,0,1.32-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m1046.1,39.49c.2,0,.42,0,.63-.01-.35,0-.64,0-.63.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m106.45,38.8c-1.35,0-2.51.04-3.73.07l3.73-.07Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m556.58,38.52l.3-.02c-.28,0-.33.01-.3.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m104.77,39.23h-.96c.35,0,.66,0,.96,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m994.48,39.99c-1.36.05-4.15,0-4.12.04,1.44,0,3.48.03,4.12-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m524.99,40.37h-.9c.43,0,.7,0,.9,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m104.77,39.23h1.11c-.09,0-.22,0-.33-.01-.24,0-.5.01-.77.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m400.94,38.5h.05c.11,0,.2,0,.31,0h-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m392.68,38.42c.58,0,1.14-.01,1.76-.02-.93,0-1.42,0-1.76.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m102.72,38.87l-2.13.04c.77,0,1.46-.02,2.13-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m303.69,38.49c.28,0,.55,0,.82,0-.35,0-.62,0-.82,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m810.16,38.75c.2,0,.48,0,.72.01.08-.01.03-.02-.72-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m748.66,40.05h-.02s.02,0,.02,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m751.94,39.99c-1.03-.01-2.49.02-3.28.06,1.03,0,2-.01,3.28-.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m741.61,40.02c.13,0,.23,0,.39,0-.14,0-.26,0-.39,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m807.68,40.12s0,0,0,0c-.02,0-.03,0-.04,0h.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m794.59,40.13c-.23,0-.55-.02-.9-.02.22,0,.52.02.9.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m709.04,40.16s.01,0,.01,0c-.03,0-.04,0-.07,0,.02,0,.04,0,.05,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m585.73,40.52c12.38-.03,28.41-.13,40.69-.1,2.67-.1,6.56-.1,10.47-.13l.41.13,3.26-.04c1.33.04-2.51.03-.16.08l1.23-.08c.26.05,8.38.03,2.91.13h12.68c2.8,0,1.64-.11,4.74-.08.63.04-1.11.03-.86.07,9.3.1,10.75-.26,19.42-.2l-.74.02c1.48-.04,4.28-.03,4.32-.05-1.11-.14-1.56.07-4.2,0,.23-.11,3.3-.06,3.13-.15,2.03.04,3.22-.02,4.99-.03,3.02.07,7.35.02,9.62.11,1.48-.04,3.13-.15,6.31-.15,2.28.09-.54.08,2.56.12l.5-.07c2.54.01,2.14.03,2.05.06,2.72,0,2.26-.09,5.67-.05l-1.9.06c2.52-.03,3.55-.01,7.06,0-.08.04-1.49.04-2.52.02,1.91.1,3.26-.04,4.29-.03-.29-.03-2.73-.04-1.54-.11,1.74.01,3.71-.09,4.95-.01l-1.9.06c3.64-.05,1.94-.08,6.11-.06-.23,0-.12.02-.21.04,2.64-.08,6.09,0,9.99,0l-.74.02c1.57-.02,2.44-.08,3.29-.08-2.22-.04-1.62-.06-1.82-.12,2.94.11,4.49-.13,9.29-.06-.08.04-1.23.08-2.55.04-1.64.11-1.84.21-4.77.26,1.82-.03,3.96-.04,3.51,0l.57-.1c1.1,0,1.97,0,2.8,0,.47-.07-2.23-.11.33-.15,2.88-.03,1.53.11,1.98.06,3.96-.04,1.64-.11,5.45-.08-.38,0-1.12.03-1.45.02,2.73.04,6.72-.02,7.52.11-.41.03-.48.07-1.52.05l.04-.02c-3.01.09,2.51-.02,1.57.09-.21-.07,3.64-.05,5.37-.04l-.55-.08c5.77-.23-.31.15,5.39.12,3.62-.05-1.37-.02.85-.07,2.45.01,3.36.08,6.94.05,1,.03,3.03.07,3.2.16,2.17-.03,6.6.04,7.84-.04-3.71-.07-3.7.09-8.05-.02l1.22-.08c3.01,0,6.86-.04,8.93,0-.42-.02-.61-.04-.34-.06,4.28-.03,5.52-.11,9.69-.09.55.08-1.89.06-3.67.07,2.69.06,2.81,0,6.98.03.22.07-2.81,0-3.29.06l4.62-.02s0,0,0,.01c.67-.11,3.52,0,6.34-.02,6.69,0,7.71-.15,11.42-.24,1,.03,1.29.06.87.09-1.64-.05-1.35-.01-1.92.02,2.26-.01,4.94.11,3.68.16,3.59-.03-1.29-.06.9-.09h4.91c-.58-.05-2.31-.06.23-.11,2.14-.02,3.18,0,5.98,0-.41.03.88.09-1.22.08,1.35.02,3.47.02,4.29-.03-3.07-.05,5.03-.05,2.74-.14l3.06.05c-.7,0-.78.04-1.81.03.87.09,2.51-.02,3.58-.03,1.08.02,3.88.02,4.12.06.97-.02,3.34,0,3.78.04,1.44-.02.12-.06.54-.08h4.9c.26.06.67.19-.07.21,1.86-.04.66-.14,3.47-.14-1.61.09,3.71.07,1.37.18,1.6.07,6.19.07,8.71.04,1.56-.07-2.73-.04-2.57-.12,7.09-.03,7.53-.24,12.73-.2l-1.35-.02c3.25-.04,2.88-.03,4.78-.1-.9.09,3.69.25,9.02.23.45-.05-2.98-.09-2.11-.16h3.54c.26,0-.13,0-.59.02,3.18-.03,5.91.12,6.83.01l3.22.14-1.28-.06c.44-.05,4-.06,4.74-.08,3.64-.05,4.95-.01,6.94.05-.63-.04-2.21-.13.65-.14-.03.15,6,.06,5.91.14,1.16,0,3.2.05,3.34-.02l-.19.09c.27-.13,4.48-.13,7.7-.15-.73.18,3.54-.01,4.97.15.61-.12,5.72-.05,6.29-.15,2.48,0,2.23.11,2.87.15l1.16-.05c1.25.06,5.91.07,8.68.11l2.58-.11.96.05c.41-.03,2.55-.04,1.23-.08h1.39c.12-.11,1.96-.03,4.75-.08.64.02.47.05-.13.06,1.39,0,.79.06,1.56.1-.99-.03,5.01-.21,1.26-.26-.26-.05,1.93-.08,3.3-.06l.83.11,1.64-.11c2.14-.02,3.06.05,4.79.06-1.77,0-3.95.2.64.2-2.41.01-3.59.07-4.84.09.95,0,1.42.01-.05.06,3.58-.03,1.2-.06,4.74-.08-.2.09.8.12,3.89.16l-2.32-.07c.11-.01.27-.02.44-.03-.88-.01-1.13-.03-1.31-.06.7,0,4.11-.12,4.7-.06-3.56-.15,6.22-.11,3.94-.2.4-.03,2.88-.03,3.14.01-2.96.07,2.23.11,1.75.17,1.1-.03-2.33-.07-.84-.11,1.77,0,3.06.05,4.04.08l-.74.02,2.73.04c.45-.05-2.64-.08-.13-.1.66.02,3.18,0,3.1.03-1.2.06-.33.15-2.47.17,1.78,0,7.43-.02,5.15-.11h2.12c-1.33-.04-5.05-.11-.8-.12l-.04.02,2.96-.07,1.29.05s.43-.05,1.52-.04c.29.03,1.32.04,1.24.08,3.18,0,2.92-.05,3.34-.08,1.78,0,2.45.01,1.61.07,2.44.01,6.69,0,8.35.05,3.26-.04-.67-.02,1.23-.08,2.82.17,10.77.06,16.09.04-1.44-.14,1.45-.02,2.43-.15-1.15.05,5.05.11.39.15h2.84c1.94.06-4.7.04-1.76.15,3.19,0,5.27-.16,9.02-.11-1.26.1,2.89-.03,1.95.08-.78.04-1.82.03-2.88.03l.66.02c6.98.03,2.02-.12,5.68-.19,4.25-.01,3.35.08,3.6.13.66.02,2.8,0,3.92-.02-2.6.06-4.8-.06-3.61-.13,1.87.12,6.31,0,7.47-.04-6.07-.12-4.21,0-9.92-.14-.78.04-.65.14-4.08.1,2.15-.05-.15-.06-.75-.07.66.06-2.38.02-3.42.05-.95-.05,2.05-.14-1.42-.16l-.65.14c-1.36-.02.58-.1-2.31-.07,1.56-.07-.47-.11,3.44-.14-4.66-.12-7.16.06-10.79.12.37,0,.41-.03.78-.04-.78.04-2.18.03-3.25.04-2.39-.03,1.89-.06,1.27-.1h-3.88c-.08,0-.1,0-.1,0-1.02.02-1.99.03-2.35,0,1.15-.05,1.61-.09,2.38-.13l-4.07.1c.45-.05-3.36-.08-.46-.11l-6.02.02-.51-.1c-1.44.02-1.48.04.24.05-2.06-.02-9.13.17-8.05-.02-4.73.08-6.44.05-12.16.09,4.4-.09-5.05-.11-.38-.15-2.73-.04-3.3.06-5.45.08-2.02-.04-1.12-.13,1.06-.17l-2.56.04.05-.02-2.23.05c-2.36-.05-.5-.1-2.94-.11l-.53.08-1.65-.05c.62.04-.82.06-2.59.06l.04-.02-2.15.02c2.13-.05-1.96-.02-.99-.08-1.84,0-1.88,0-5.2.01l.58.06c-4.33.05-.18-.09-3.69-.09l.22.07c-5.05-.11-8.57.06-12.3,0,2.14-.02,1.6-.09,1.56-.07-3.22.02-8.46,0-11.79.09-1.21-.1-1.5-.13-4.92-.17-2.49,0-2.85.01-3.67.07-2.41-.04-6.93.02-7.04-.05-.56.06-2.17-.01-3.49.04l-.28-.03.21.07c-4.27-.15-7.21.08-11.52-.05l.74-.02-1.82.03c-.29-.03.45-.05.54-.08h-8.43s1.66.04,1.66.04c-1.77,0-2.97.07-5,.03,3.37-.1-2.8,0-3.34-.08l1.81-.03q-2.47,0-2.27.07c-3.21.02-2.2-.13-5.15-.06h2.1c.62.04-.89.1-2.3.09-.33-.01-1.33-.04-.26-.05-2.52.03-6.31,0-7.43.02-1.37-.02-.92-.07-.18-.09-5.4.06-2.44-.01-7.85.04l.09-.04-1.86.05-2.65-.08.95.05c-1.77,0-2.88.03-4.95.01l.83-.06c-5,.03-5.79-.09-10.54-.02-.33-.01.41-.03.79-.04-4.41.09-3.33-.1-7.77,0,.27-.02-.21-.04-.04-.06l-2.02.04.16-.08-1.65.11-1.24-.08-.78.04c-2.15-.15-5.2-.04-8.15-.14l.5.1c-7.45.2-17.01-.11-26-.02l.16-.08-3.71.09c-1.99-.06,1.2-.06.58-.1-3.97.04-1.65.11-6.27.13-2.36-.05.82-.06,1.93-.08-4.32.04-10.71.08-13.77.04-.07.01-.26.02-.1.03-2.89.03-6.69,0-9.87,0,.08-.03.86-.04,1.66-.05-1.14,0-2.7-.03-3.68,0l1.2-.07c-2.44-.01-7.14.05-7.68-.03.29.03.17.09-1.94.08-1.16-.12-5.74.05-9.12-.01.4-.03,2.88-.03,2.18-.03-1.7-.03-3.22.02-4.71.06l.46-.05-7.88.06c-1.17-.12-7.43.02-6.89-.07-2.81,0,2.36.05-1.2.06-.95-.05-3.22.02-3.07-.05h.38s-2.48,0-2.48,0l1.57-.07c-2.14.02-3.71.09-3.82.15-2.03-.04-4.91,0-5.83-.08l.75-.02c-5.7.03-9.43-.2-13.92-.08-.33-.01-.29-.03.41-.03h-3.52s.84-.06.84-.06l-5.82.09.08-.04c-3.84-.02-9.86,0-14.81.02l.74-.02c-5.4.06-5.21-.04-9.16,0,.14-.01.27-.01.42-.02h-3.55s.78-.04.78-.04c-2.63.08-7.52-.11-5.9-.04-1.49.04-4.05.08-4.5.13-3.88,0-.95-.05-3.35-.08-2.8,0-3.3.06-7.1.03l.08-.04c-1.78,0-2.88.03-5.36.04l.74-.02c-4.04.08-5.04-.11-8.21.05-1.69-.03-4.91,0-4.75-.08-5.03.05-8.94.07-13.94.1-.8-.12-1.07,0-4.1-.06l.22.07c-7.06,0-15.17-.16-22.96-.13l-.22-.07-1.56.07c-8.39-.03-19.24-.06-25.92-.06-2.19.03-5.51.11-8.99.09h.36c-6.06.03-12.46.06-19.06.02.41-.03-.24-.05.5-.07-1.57.07-3.87,0-5.29,0l1.66.05c-1.88.06-4.57,0-5.53-.05l-2.97.07c-.19,0-.5-.02-.54-.03l-.53.04-1.58-.09c-.74.02-4.67.04-5.89.12-.29-.03-3.06-.05-.91-.07l-10.85-.03,1.69.03c.21.07-3.05.11-4.74.08,2.21-.05.18-.09-.76-.14-1.47.04,1.28.06.5.1-1.86.04-5.78.07-6.76.04l1.11-.03c-2.52.02-3.68-.09-6.16-.09-2.23.05-3.88,0-3.42.12-3.22.02-1.24-.08-2.29-.09-1.51.05-6.02.02-6.59-.04-1.76.17-8.67-.06-9.33.08l-2.64-.08c-.09.04-.61.12-2.76.14-2.02-.04-1.54-.11-2.15-.15l-1.36.14c-11.64-.15-27-.05-39.76-.17-5.69.03-12.87.09-19.52.07l.74-.02-6.61-.04,4.8.06c-1.44.02-2.57.04-3.96.04-7.25-.06-16.93-.13-25.87-.06-5.78.16-3.84-.14-9.38-.03.47-.01.65-.04,1.08-.05-5.97.05-9.2.08-15.18.18.69-.16-3.89,0-3.35-.08l-.5.07c-1.33-.04-4.46-.05-4.01-.1l-2.64.08-.23-.07c-3.49,0-11,.05-12.83-.09-8.66.1-22.32.07-33.17.04-1.53.05-4.7.06-7.18.06l-2.65-.08c-2.52.02-5.2.12-7.54.07.01,0,.11-.02.28-.02-2.56.02-5-.03-7.39.05-2.8,0-5.53-.05-4.67-.12-.27.13-5.94-.02-5.94-.02,0,0-144.07-.32-179.23.4-1.18.06-4.45.11-3.2.18-2.52.02-3.68-.09-4.17-.03,3.43.04-1.06.17,2.29.25l-2.15.02c-.44.05,2.93-.05,2.4.03l.61-.12c1.75.02,2.7.04,3.32.09,1.64-.05,2.69-.21,6.6-.14h-1.08c3.19,0,1.95.09,2.62.11h-.71s2.69.06,2.69.06c-2.04-.04-5.4.06-3.64.05,3.8.03-.99-.03,1.87-.04,1.77,0,1.27.06,1.19.1h3.18c-.11.05-2.1,0-.82.05l4.01-.06c.75.14,4.36-.07,6.19.07-2.88.03.26.05-.2.09h7.06c.67.01-1.86.04-.78.03,1.33.04,2.18-.03,2.9-.03.61.04,5.27,0,5.07.09,4.79.06,2.01-.12,6.47-.07.59.06-3.54.01-1.56.07l4.63-.02c-.42.03-.9.09-2.64.08,12.51.08,19.26.38,30.69.3,1.61.07-1.16.05-2.31.09,8.28-.09,11.65.15,18.71.14l.13-.06c9.83.18,21.67.07,32.78.14l-1.33-.04c1.53-.05,4-.06,5.82-.09.28.03-1.32.12,1.9.1-.67-.02-2.03-.04-1.62-.07,9.55.15,29.69.11,45.38.18,21.21-.04,44.22.07,65.05.03-3.18,0-1.82-.14.57-.1,6.54.24,11.35-.04,18.04.12,12.14-.08,22.97.13,34.26-.05l.22.07c1.69.03,2.14-.02,3.91-.02l-.04.02c4.18.03,9.25-.04,11.65-.01l.15-.08c2.49,0,1.29.06,3.84.02l-.07.04,2.97-.07c-.29.13,7.01.01,9,.07,3.22-.02,9.32-.08,14.2-.05.91.07,6.89.07,10.7.1,7.43-.02,18.03-.04,27.48-.01l-.17-.09h2.47s.3.02-.08.03c1.91.1,5.69-.03,7.68.03-1.25-.08-1.73-.01-3.14-.01-2.02-.04-.09-.12,2.64-.08l-.05.02,1.87-.04c.21.07,1.9.1,2.12.16,8.12-.02,13.65-.13,22.03-.1-.86.07,6.02-.02,4.34.11,5.03-.05-.83-.1,1.47-.2,1.41,0,2.88-.03,3.14.01-.66.03,1.14.08,0,.09h3.36c.32,0-.42.02-.79.03,6.85-.07,12.15.08,18.29,0,.46-.05-2.44-.01-1.99-.06,6.18-.1,5.46.08,11.23.02l-1.19.06c1.86-.04,2.68-.1,5.74-.05.54.08-2.6.06-4.08.1,2.1,0,7.43-.02,5.8-.09,2.52-.03,3.44.04,4.8.06.04-.02-2.35-.05-.88-.09,3.43.04,8.73.04,12.92.05-.04.02.26.05-.11.06,3.37-.1,3.02.07,7.64.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m809.37,40.13h-1.69s-.08.02-.86.04l2.55-.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m729.08,40.08c-.21,0-.42.01-.61.02.41,0,.54-.01.61-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m709.57,40.22c1.39-.02.15-.04-.53-.06-.03.02,0,.03.53.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m854.85,39.93c-.3,0-.48.02-.43.03.4-.01.48-.02.43-.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m980.57,39.98c-.16,0-.31,0-.5-.01.09,0,.27,0,.5.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m973.6,39.87c-.34,0-.78,0-1.42.01.62,0,1.06,0,1.42-.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m824.38,39.96c-.47,0-.92,0-1.32.02.72,0,1.08-.01,1.32-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m970.74,39.89h-1.75s-.03,0-.03,0h1.78Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m982.77,39.99c-.68,0-1.61,0-2.21,0,.87.02,1.56.02,2.21,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m901,39.83c-.05,0-.12,0-.19,0-1.37.03-.51.02.19,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m963.07,40.02c-.07,0-.16,0-.24,0l-.51.02.75-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m990.35,40.02c-.33,0-.64,0-.88.01.27,0,.59,0,1,0-.1,0-.12-.02-.12-.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#817267"
	    },
	    attrs: {
	      "d": "m927.32,39.95c.5-.03.68-.05.7-.06-.58,0-.96.01-.7.06Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m205.92,284.41c-49.48,0-89.74-40.26-89.74-89.74s40.26-89.74,89.74-89.74,89.74,40.25,89.74,89.74-40.26,89.74-89.74,89.74Zm0-173.97c-46.45,0-84.23,37.79-84.23,84.23s37.79,84.23,84.23,84.23,84.23-37.79,84.23-84.23-37.79-84.23-84.23-84.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m205.92,269.04c-41.01,0-74.37-33.36-74.37-74.37s33.36-74.37,74.37-74.37,74.37,33.36,74.37,74.37-33.36,74.37-74.37,74.37Zm0-144.62c-38.73,0-70.25,31.51-70.25,70.25s31.51,70.25,70.25,70.25,70.25-31.51,70.25-70.25-31.51-70.25-70.25-70.25Z"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "275.34 264.09 227.28 194.67 205.92 194.67 275.34 264.09 275.34 264.09"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m276.24,263.47l-1.67,1.39-71.28-71.28h24.57l48.39,69.89Zm-67.68-67.71l59,59-40.84-59h-18.15Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m274.71,264.98l-69.89-48.39v-24.56l71.28,71.28-1.39,1.67Zm-67.71-49.53l59,40.84-59-59v18.15Z"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "136.5 264.09 205.92 216.03 205.92 194.67 136.5 264.09 136.5 264.09"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m207.01,216.6l-69.89,48.39-1.39-1.67,71.28-71.28v24.57Zm-61.18,39.7l59-40.84v-18.15l-59,59Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m208.55,193.58l-71.28,71.28-1.67-1.39,48.39-69.89h24.57Zm-64.27,61.18l59-59h-18.15s-40.84,59-40.84,59Z"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "275.34 125.25 205.92 173.31 205.92 194.67 275.34 125.25 275.34 125.25"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m276.11,126.02l-71.28,71.28v-24.56l69.89-48.39,1.39,1.67Zm-69.1,66.01l59-59-59,40.84v18.15Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m227.85,195.76h-24.57l71.28-71.28,1.67,1.39-48.39,69.89Zm-19.29-2.18h18.15l40.84-59-59,59Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "207.01 215.46 266.01 256.3 207.01 197.3 207.01 215.46"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "136.5 125.24 184.56 194.67 205.92 194.66 136.51 125.25 136.5 125.24"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m135.61,125.87l1.67-1.39,71.28,71.28h-24.57s-48.39-69.89-48.39-69.89Zm67.68,67.71l-59-59,40.84,59h18.15Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m137.13,124.35l69.89,48.38v24.57l-71.28-71.28,1.39-1.67Zm67.71,49.53l-59-40.85,59,59v-18.15Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "204.83 173.88 145.83 133.03 204.83 192.03 204.83 173.88"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "185.13 195.76 144.29 254.76 203.29 195.76 185.13 195.76"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "226.71 193.58 267.55 134.58 208.55 193.58 226.71 193.58"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "205.92 318.43 224.96 213.71 205.92 194.67 205.92 318.42 205.92 318.43"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m207.27,318.67l-2.73-.25v-127.08l21.9,21.89-19.17,105.43Zm.02-120.68v105.18l16.18-89-16.18-16.18Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m204.57,318.67l-19.17-105.43,21.9-21.89v127.07l-2.73.25Zm-16.2-104.5l16.18,89v-105.18l-16.18,16.18Z"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "82.16 194.67 186.88 213.71 205.92 194.67 82.16 194.67 82.16 194.67"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m187.34,215.19l-105.43-19.17.25-2.73h127.08l-21.9,21.9Zm-89.92-19.14l89,16.18,16.18-16.18h-105.18Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m209.24,196.05h-127.08l-.25-2.73,105.43-19.17,21.9,21.9Zm-111.82-2.75h105.18l-16.18-16.18-89,16.18Z"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "329.68 194.67 224.96 175.63 205.92 194.67 329.67 194.67 329.68 194.67"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m329.68,196.04h-127.08l21.9-21.9,105.43,19.17-.25,2.73Zm-120.44-2.75h105.18l-89-16.18-16.18,16.18Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m224.49,215.19l-21.9-21.9h127.08l.25,2.73-105.43,19.17Zm-15.25-19.14l16.18,16.18,89-16.18h-105.18Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "188.36 214.17 204.54 303.17 204.54 197.99 188.36 214.17"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "points": "205.93 70.91 186.89 175.63 205.93 194.67 205.93 70.91 205.93 70.91"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m204.57,70.67l2.73.25v127.08s-21.9-21.89-21.9-21.89l19.17-105.43Zm-.02,120.68v-105.18s-16.18,89-16.18,89l16.18,16.18Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m207.28,70.67l19.17,105.43-21.9,21.9v-127.08s2.73-.25,2.73-.25Zm16.2,104.5l-16.18-89v105.18s16.18-16.18,16.18-16.18Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "223.48 175.17 207.3 86.17 207.3 191.35 223.48 175.17"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "186.42 177.11 97.42 193.29 202.6 193.29 186.42 177.11"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "points": "225.42 212.23 314.42 196.05 209.24 196.05 225.42 212.23"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "205.92",
	      "cy": "194.67",
	      "r": "20.92"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fde7d3"
	    },
	    attrs: {
	      "d": "m199.09,194.67c0-3.77,3.06-6.83,6.83-6.83s6.83,3.06,6.83,6.83-3.06,6.83-6.83,6.83-6.83-3.06-6.83-6.83Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "174.06",
	      "y": "113.44",
	      "width": "3.13",
	      "height": "15.73",
	      "transform": "translate(-33 76.21) rotate(-22.44)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "228.5",
	      "y": "119.81",
	      "width": "15.73",
	      "height": "3.13",
	      "transform": "translate(33.54 293.03) rotate(-67.42)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "271.41",
	      "y": "162.81",
	      "width": "15.73",
	      "height": "3.13",
	      "transform": "translate(-41.61 119.15) rotate(-22.46)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "277.64",
	      "y": "217.25",
	      "width": "3.13",
	      "height": "15.73",
	      "transform": "translate(-35.85 396.5) rotate(-67.42)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "234.65",
	      "y": "260.16",
	      "width": "3.13",
	      "height": "15.73",
	      "transform": "translate(-84.38 110.37) rotate(-22.42)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "167.6",
	      "y": "266.39",
	      "width": "15.73",
	      "height": "3.13",
	      "transform": "translate(-139.3 327.2) rotate(-67.44)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "124.7",
	      "y": "223.39",
	      "width": "15.73",
	      "height": "3.13",
	      "transform": "translate(-75.77 67.55) rotate(-22.42)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "131.06",
	      "y": "156.35",
	      "width": "3.13",
	      "height": "15.73",
	      "transform": "translate(-69.92 223.63) rotate(-67.42)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m121.95,140.4c0-1.52,1.23-2.74,2.74-2.74s2.74,1.23,2.74,2.74-1.23,2.74-2.74,2.74-2.74-1.23-2.74-2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m109.14,171.42c0-1.51,1.23-2.74,2.74-2.74s2.74,1.23,2.74,2.74-1.23,2.74-2.74,2.74-2.74-1.23-2.74-2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m182.33,98.3c1.07-1.07,2.81-1.07,3.88,0,1.07,1.07,1.07,2.81,0,3.88-1.07,1.07-2.81,1.07-3.88,0-1.07-1.07-1.07-2.81,0-3.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m151.33,111.18c1.07-1.07,2.81-1.07,3.88,0,1.07,1.07,1.07,2.81,0,3.88-1.07,1.07-2.81,1.07-3.88,0-1.07-1.07-1.07-2.81,0-3.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m257.28,109.71c1.51,0,2.74,1.23,2.74,2.74,0,1.51-1.23,2.74-2.74,2.74s-2.75-1.23-2.74-2.74c0-1.52,1.23-2.74,2.74-2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m226.25,96.9c1.52,0,2.74,1.23,2.74,2.74,0,1.51-1.23,2.74-2.74,2.74-1.52,0-2.74-1.23-2.74-2.74,0-1.52,1.23-2.75,2.74-2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m301.73,171.26c1.07,1.07,1.07,2.81,0,3.88-1.07,1.07-2.81,1.07-3.88,0-1.07-1.07-1.07-2.81,0-3.88,1.07-1.07,2.81-1.07,3.88,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m288.85,140.26c1.07,1.07,1.07,2.81,0,3.88-1.07,1.07-2.81,1.07-3.88,0-1.07-1.07-1.07-2.81,0-3.88,1.07-1.07,2.81-1.07,3.88,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m290.32,246.21c0,1.51-1.23,2.74-2.74,2.74-1.52,0-2.74-1.23-2.74-2.74s1.23-2.75,2.74-2.74c1.52,0,2.74,1.23,2.74,2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m303.13,215.19c0,1.52-1.23,2.74-2.74,2.74-1.51,0-2.74-1.23-2.74-2.74,0-1.51,1.23-2.74,2.74-2.74,1.51,0,2.75,1.23,2.74,2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m229.95,290.66c-1.07,1.07-2.81,1.07-3.88,0-1.07-1.07-1.07-2.81,0-3.88,1.07-1.07,2.81-1.07,3.88,0,1.07,1.07,1.07,2.81,0,3.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m260.94,277.78c-1.07,1.07-2.81,1.07-3.88,0-1.07-1.07-1.07-2.81,0-3.88,1.07-1.07,2.81-1.07,3.88,0,1.07,1.07,1.07,2.81,0,3.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m153.82,280.43c-1.51,0-2.74-1.23-2.74-2.74,0-1.52,1.23-2.74,2.74-2.74s2.75,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m184.84,293.24c-1.51,0-2.74-1.23-2.74-2.74,0-1.52,1.23-2.74,2.74-2.74,1.52,0,2.75,1.23,2.74,2.74,0,1.51-1.23,2.74-2.74,2.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m109.37,218.88c-1.07-1.07-1.07-2.81,0-3.88,1.07-1.07,2.81-1.07,3.88,0,1.07,1.07,1.07,2.81,0,3.88-1.07,1.07-2.81,1.07-3.88,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m122.25,249.87c-1.07-1.07-1.07-2.81,0-3.88,1.07-1.07,2.81-1.07,3.88,0,1.07,1.07,1.07,2.81,0,3.88-1.07,1.07-2.81,1.07-3.88,0Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1812.16",
	      "cy": "594.85",
	      "r": "33.06",
	      "transform": "translate(815.45 2221) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1809.49",
	      "y": "604.75",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1154.02",
	      "cy": "176.33",
	      "r": "33.06",
	      "transform": "translate(716.33 1258.59) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1151.35",
	      "y": "186.23",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1226.74",
	      "cy": "326.3",
	      "r": "33.06",
	      "transform": "translate(626.36 1444.73) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1224.08",
	      "y": "336.19",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1259.8",
	      "cy": "139.18",
	      "r": "33.06",
	      "transform": "translate(833.87 1332.93) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1257.13",
	      "y": "149.08",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "786.51",
	      "cy": "586.76",
	      "r": "33.06",
	      "transform": "translate(34.19 1216.77) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "783.84",
	      "y": "596.66",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "916.36",
	      "cy": "824.7",
	      "r": "33.06",
	      "transform": "translate(-97.42 1526.19) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "913.7",
	      "y": "834.6",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "896.27",
	      "cy": "486.27",
	      "r": "33.06",
	      "transform": "translate(216.43 1246.25) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "893.6",
	      "y": "496.16",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1193.69",
	      "cy": "849.19",
	      "r": "33.06",
	      "transform": "translate(92.12 1814.88) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1191.02",
	      "y": "859.09",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1430.88",
	      "cy": "490.2",
	      "r": "33.06",
	      "transform": "translate(623.93 1769.47) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1428.21",
	      "y": "500.1",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1803.97",
	      "cy": "316.42",
	      "r": "33.06",
	      "transform": "translate(1080.09 1998.8) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1801.3",
	      "y": "326.31",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "385.68",
	      "cy": "274.25",
	      "r": "33.06",
	      "transform": "translate(29.88 586.29) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "383.01",
	      "y": "284.15",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "125.09",
	      "cy": "726.44",
	      "r": "27.14",
	      "transform": "translate(-610.62 680.64) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "122.9",
	      "y": "734.57",
	      "width": "4.38",
	      "height": "35.24"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "545.2",
	      "cy": "114.47",
	      "r": "33.06",
	      "transform": "translate(308.1 618.58) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "542.54",
	      "y": "124.37",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "cx": "1608.71",
	      "cy": "96.24",
	      "r": "33.06",
	      "transform": "translate(1144.1 1639.41) rotate(-76.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#724e49"
	    },
	    attrs: {
	      "x": "1606.05",
	      "y": "106.14",
	      "width": "5.34",
	      "height": "42.92"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "scene_intro"
	    }
	  }, [_h('rect', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "id": "intro_rectangle",
	      "x": "240.83",
	      "y": "335.19",
	      "width": "409.55",
	      "height": "221.51"
	    }
	  }), _h('g', {
	    attrs: {
	      "id": "intro_complete"
	    }
	  }, [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c2bfbe"
	    },
	    attrs: {
	      "x": "303.51",
	      "y": "407.71",
	      "width": "3.17",
	      "height": "12.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8e7e8"
	    },
	    attrs: {
	      "x": "305.09",
	      "y": "407.71",
	      "width": "1.59",
	      "height": "12.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f5f5f6"
	    },
	    attrs: {
	      "x": "284.25",
	      "y": "389.35",
	      "width": "41.68",
	      "height": "22.61"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#1d4b94"
	    },
	    attrs: {
	      "x": "285.3",
	      "y": "390.37",
	      "width": "39.53",
	      "height": "20.58"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#2a72b8"
	    },
	    attrs: {
	      "x": "292.39",
	      "y": "390.36",
	      "width": "1.19",
	      "height": "20.59"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#2a72b8"
	    },
	    attrs: {
	      "x": "300.6",
	      "y": "390.36",
	      "width": "1.19",
	      "height": "20.59"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#2a72b8"
	    },
	    attrs: {
	      "x": "309.07",
	      "y": "390.37",
	      "width": "1.19",
	      "height": "20.58"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#2a72b8"
	    },
	    attrs: {
	      "x": "317.28",
	      "y": "390.37",
	      "width": "1.19",
	      "height": "20.58"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#2a72b8"
	    },
	    attrs: {
	      "x": "285.3",
	      "y": "396.44",
	      "width": "39.53",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#2a72b8"
	    },
	    attrs: {
	      "x": "285.3",
	      "y": "403.76",
	      "width": "39.53",
	      "height": "1.19"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#00ae42"
	    },
	    attrs: {
	      "x": "442.87",
	      "y": "338.54",
	      "width": "39.22",
	      "height": "26.54"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m439.66,404.47v-35.6l.94-.95v-30.37c-.57-.4-.94-1.06-.94-1.8,0-1.21.98-2.19,2.19-2.19s2.19.98,2.19,2.19c0,.74-.37,1.4-.94,1.8v30.37l.94.95v35.6h-4.39Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e27232"
	    },
	    attrs: {
	      "x": "380.49",
	      "y": "389.09",
	      "width": "124.92",
	      "height": "167.54"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "367.47",
	      "y": "389.09",
	      "width": "13.02",
	      "height": "167.54"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "505.42",
	      "y": "389.09",
	      "width": "13.02",
	      "height": "167.54"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d5cfb7"
	    },
	    attrs: {
	      "x": "367.47",
	      "y": "539.27",
	      "width": "150.97",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bcb6a6"
	    },
	    attrs: {
	      "x": "367.47",
	      "y": "539.27",
	      "width": "13.02",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bcb6a6"
	    },
	    attrs: {
	      "x": "505.42",
	      "y": "539.27",
	      "width": "13.02",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "414.43",
	      "y": "486.2",
	      "width": "28.53",
	      "height": "53.07"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "442.95",
	      "y": "486.2",
	      "width": "28.53",
	      "height": "53.07"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bfbba6"
	    },
	    attrs: {
	      "x": "367.47",
	      "y": "389.01",
	      "width": "150.97",
	      "height": "1.42"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e27232"
	    },
	    attrs: {
	      "x": "242.55",
	      "y": "428.96",
	      "width": "124.92",
	      "height": "127.67"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "249.55",
	      "y": "434.54",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "251.76",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "278.16",
	      "y": "434.54",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "280.38",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "306.78",
	      "y": "434.54",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "308.99",
	      "y": "436.76",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "335.4",
	      "y": "434.54",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "337.61",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "385.58",
	      "y": "395.18",
	      "width": "26.4",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "387.79",
	      "y": "397.39",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "414.2",
	      "y": "395.18",
	      "width": "26.4",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "416.41",
	      "y": "397.39",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "442.81",
	      "y": "395.18",
	      "width": "26.31",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "445.03",
	      "y": "397.39",
	      "width": "21.89",
	      "height": "63.21"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "471.43",
	      "y": "395.18",
	      "width": "26.4",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "473.64",
	      "y": "397.39",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "249.55",
	      "y": "486.29",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "251.76",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "278.16",
	      "y": "486.29",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "280.38",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "306.78",
	      "y": "486.29",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "308.99",
	      "y": "488.51",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "335.4",
	      "y": "486.29",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "337.61",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#d7d0ba"
	    },
	    attrs: {
	      "x": "238.56",
	      "y": "539.27",
	      "width": "128.91",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdefe6"
	    },
	    attrs: {
	      "x": "237.32",
	      "y": "414.79",
	      "width": "130.15",
	      "height": "12.85"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bfbba6"
	    },
	    attrs: {
	      "x": "242.55",
	      "y": "427.46",
	      "width": "124.92",
	      "height": "1.51"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e27232"
	    },
	    attrs: {
	      "x": "518.44",
	      "y": "428.96",
	      "width": "124.92",
	      "height": "127.67"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d7d0ba"
	    },
	    attrs: {
	      "x": "518.44",
	      "y": "539.27",
	      "width": "128.91",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdefe6"
	    },
	    attrs: {
	      "x": "518.44",
	      "y": "414.79",
	      "width": "130.06",
	      "height": "12.85"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bfbba6"
	    },
	    attrs: {
	      "x": "518.44",
	      "y": "427.46",
	      "width": "124.92",
	      "height": "1.51"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d5cfb7"
	    },
	    attrs: {
	      "x": "407.78",
	      "y": "468.12",
	      "width": "70.88",
	      "height": "18.07"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#f5f5f6"
	    },
	    attrs: {
	      "x": "395.45",
	      "y": "545.02",
	      "width": "96.21",
	      "height": "5.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfdede"
	    },
	    attrs: {
	      "x": "395.45",
	      "y": "547.92",
	      "width": "96.21",
	      "height": "2.9"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f5f5f6"
	    },
	    attrs: {
	      "x": "399.39",
	      "y": "539.26",
	      "width": "87.64",
	      "height": "5.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfdede"
	    },
	    attrs: {
	      "x": "399.39",
	      "y": "542.16",
	      "width": "87.64",
	      "height": "2.9"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f5f5f6"
	    },
	    attrs: {
	      "x": "390.86",
	      "y": "550.83",
	      "width": "105.03",
	      "height": "5.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfdede"
	    },
	    attrs: {
	      "x": "390.86",
	      "y": "553.73",
	      "width": "105.03",
	      "height": "2.9"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fdefe6"
	    },
	    attrs: {
	      "x": "365.08",
	      "y": "376.34",
	      "width": "157.08",
	      "height": "12.76"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "points": "409.77 434 409.77 417.69 395.81 397.39 387.79 397.39 387.79 402.04 409.77 434"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "points": "416.41 413.11 438.39 445.07 438.39 397.39 416.41 397.39 416.41 413.11"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "points": "416.41 427.34 416.41 443.65 428.06 460.59 438.39 460.59 438.39 459.3 416.41 427.34"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "points": "466.92 397.39 445.03 397.39 445.03 454.72 449.07 460.59 466.92 460.59 466.92 397.39"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "473.64",
	      "y": "397.39",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "points": "409.77 403.46 409.77 397.39 405.6 397.39 409.77 403.46"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "302.36 436.76 280.38 436.76 280.38 446.63 291.08 462.19 302.36 462.19 302.36 436.76"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "337.61",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "308.99",
	      "y": "436.76",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "273.74 452.81 262.7 436.76 251.76 436.76 251.76 445.05 263.55 462.19 273.74 462.19 273.74 452.81"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "302.36 494.43 298.28 488.51 281.64 488.51 299.13 513.94 302.36 513.94 302.36 494.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "330.88 488.51 309.17 488.51 326.67 513.94 330.88 513.94 330.88 488.51"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "337.61",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "308.99 504.08 308.99 513.94 315.78 513.94 308.99 504.08"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "273.74 436.98 273.74 436.76 273.59 436.76 273.74 436.98"
	    }
	  })]), _h('g', [_h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "523.67",
	      "y": "434.54",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "525.88",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "552.29",
	      "y": "434.54",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "554.5",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "580.91",
	      "y": "434.54",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "583.12",
	      "y": "436.76",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "609.52",
	      "y": "434.54",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "611.73",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "523.67",
	      "y": "486.29",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "525.88",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "552.29",
	      "y": "486.29",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "554.5",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "580.91",
	      "y": "486.29",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "583.12",
	      "y": "488.51",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "609.52",
	      "y": "486.29",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "611.73",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "576.48 436.76 554.5 436.76 554.5 446.63 565.2 462.19 576.48 462.19 576.48 436.76"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "611.73",
	      "y": "436.76",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "583.12",
	      "y": "436.76",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "547.86 452.81 536.82 436.76 525.88 436.76 525.88 445.05 537.67 462.19 547.86 462.19 547.86 452.81"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "576.48 494.43 572.41 488.51 555.77 488.51 573.26 513.94 576.48 513.94 576.48 494.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "605.01 488.51 583.3 488.51 600.79 513.94 605.01 513.94 605.01 488.51"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "x": "611.73",
	      "y": "488.51",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "583.12 504.08 583.12 513.94 589.9 513.94 583.12 504.08"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "547.86 436.98 547.86 436.76 547.71 436.76 547.86 436.98"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "445.17",
	      "y": "488.41",
	      "width": "24.1",
	      "height": "48.65"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#99d4e1"
	    },
	    attrs: {
	      "x": "416.64",
	      "y": "488.41",
	      "width": "24.1",
	      "height": "48.65"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "445.17 502.08 469.22 537.05 469.27 537.05 469.27 488.41 445.17 488.41 445.17 502.08"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "440.74 495.64 440.74 488.41 435.77 488.41 440.74 495.64"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "463.45 537.05 445.17 510.46 445.17 526.04 452.74 537.05 463.45 537.05"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#addcec"
	    },
	    attrs: {
	      "points": "440.74 519.61 440.74 504.03 430 488.41 419.29 488.41 440.74 519.61"
	    }
	  })])])]), _h('rect', {
	    staticStyle: {
	      "fill": "#bcb0a5"
	    },
	    attrs: {
	      "x": "437.15",
	      "y": "509.5",
	      "width": "1.95",
	      "height": "7.53"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bcb0a5"
	    },
	    attrs: {
	      "x": "446.74",
	      "y": "509.5",
	      "width": "1.95",
	      "height": "7.53"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "271.01",
	      "y": "470.55",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "266.69",
	      "y": "474.15",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "276.02",
	      "y": "474.15",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "300.63",
	      "y": "521.8",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "305.64",
	      "y": "525.41",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "484.16",
	      "y": "492.15",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "489.17",
	      "y": "495.76",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "338.4",
	      "y": "479.13",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m451.6,351.78c0-5.92,4.8-10.72,10.72-10.72s10.72,4.8,10.72,10.72-4.8,10.72-10.72,10.72-10.72-4.8-10.72-10.72h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m461.47,349.23c0-.52.43-.95.95-.95s.95.43.95.95-.43.95-.95.95-.95-.43-.95-.95h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42"
	    },
	    attrs: {
	      "d": "m464.28,349.22c.06-.05.1-.1.19-.11.13,0,.24.09.24.22v1.06s-1.76,1.75-1.76,1.75v5.85h-1.14v-5.85l-1.76-1.69v-1.14c0-.13.1-.24.23-.24.08,0,.15.05.21.1l1.87,1.87,1.91-1.84h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m461.32,343.86c0-.19.05-.28.2-.22l.61.57.28-.87.32.84.58-.52s.16-.1.21.1c0,0,.03,1.04-.72,1.66,0,0-.34.33-.88-.1,0,0-.57-.51-.58-1.47h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m466.24,344.9c.11-.16.21-.2.29-.06l.16.82.74-.54-.23.87.77-.08s.19.02.11.2c0,0-.59.86-1.56.92,0,0-.47.07-.66-.6,0,0-.16-.75.39-1.53h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m463.94,344c.06-.18.14-.25.26-.14l.38.75.56-.72.02.9.72-.29s.19-.03.16.16c0,0-.33.99-1.25,1.32,0,0-.44.19-.8-.4,0,0-.36-.68-.05-1.58h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m462.61,345.89c.06-.18.14-.25.26-.14l.38.75.56-.72.02.9.72-.29s.19-.03.16.16c0,0-.33.99-1.25,1.32,0,0-.44.19-.8-.4,0,0-.36-.68-.05-1.58h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m464.96,346.91c.11-.16.21-.2.29-.06l.16.82.74-.54-.23.87.77-.08s.19.02.11.2c0,0-.59.86-1.56.92,0,0-.47.07-.66-.6,0,0-.16-.75.39-1.53h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m468.35,346.46c.16-.1.27-.11.29.05l-.16.82.88-.22-.54.72.74.21s.17.09.03.23c0,0-.87.58-1.79.27,0,0-.46-.12-.38-.8,0,0,.13-.76.93-1.27h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m456.74,346.21c-.12-.15-.14-.25.01-.3l.83.06-.33-.85.78.45.12-.77s.07-.18.22-.05c0,0,.68.79.49,1.75,0,0-.06.47-.75.48,0,0-.77-.04-1.38-.77h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m457.91,348.2c-.12-.15-.14-.25.01-.3l.83.06-.33-.85.78.45.12-.77s.07-.18.22-.05c0,0,.68.79.49,1.75,0,0-.06.47-.75.48,0,0-.77-.04-1.38-.77h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m458.68,344.66c-.06-.18-.04-.28.12-.27l.76.35v-.91s.56.7.56.7l.39-.67s.13-.14.23.03c0,0,.35.98-.17,1.81,0,0-.22.42-.87.18,0,0-.7-.31-1.01-1.21h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m459.93,346.58c-.06-.18-.04-.28.12-.27l.76.35v-.91s.56.7.56.7l.39-.67s.13-.14.23.03c0,0,.35.98-.17,1.81,0,0-.22.42-.87.18,0,0-.7-.31-1.01-1.21h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#00ae42",
	      "stroke": "#00ae42",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".06px"
	    },
	    attrs: {
	      "d": "m455.25,348.35c-.16-.1-.21-.19-.08-.28l.81-.22-.59-.7.88.17-.13-.76s0-.19.19-.12c0,0,.9.53,1.03,1.49,0,0,.1.47-.55.7,0,0-.74.21-1.55-.28h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#005cb9",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".15px"
	    },
	    attrs: {
	      "d": "m464.17,358.97s0-7.68,0-7.68c0,0,2.13-2.37,5.55-1.18v7.35s-3.26-1.15-5.55,1.51h0Zm.04.02s1.81-2.09,5.5-1.28m-5.53,1.28s2.16-1.73,5.58-.88"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#005cb9",
	      "stroke": "#005cb9",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".15px"
	    },
	    attrs: {
	      "d": "m460.46,358.97s0-7.68,0-7.68c0,0-2.13-2.37-5.55-1.18v7.35s3.26-1.15,5.55,1.51h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#005cb9",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".15px"
	    },
	    attrs: {
	      "d": "m460.42,358.99s-1.81-2.09-5.5-1.28m5.53,1.28s-2.16-1.73-5.58-.88"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "intro_inactive"
	    }
	  }, [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c2bfbe"
	    },
	    attrs: {
	      "x": "303.97",
	      "y": "407.7",
	      "width": "3.17",
	      "height": "12.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8e7e8"
	    },
	    attrs: {
	      "x": "305.56",
	      "y": "407.7",
	      "width": "1.59",
	      "height": "12.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f5f5f6"
	    },
	    attrs: {
	      "x": "284.72",
	      "y": "389.34",
	      "width": "41.68",
	      "height": "22.61"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "285.77",
	      "y": "390.36",
	      "width": "39.53",
	      "height": "20.58"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "292.86",
	      "y": "390.34",
	      "width": "1.19",
	      "height": "20.59"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "301.06",
	      "y": "390.34",
	      "width": "1.19",
	      "height": "20.59"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "309.54",
	      "y": "390.36",
	      "width": "1.19",
	      "height": "20.58"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "317.74",
	      "y": "390.36",
	      "width": "1.19",
	      "height": "20.58"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "285.77",
	      "y": "396.43",
	      "width": "39.53",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "285.77",
	      "y": "403.74",
	      "width": "39.53",
	      "height": "1.19"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "443.33",
	      "y": "338.53",
	      "width": "39.22",
	      "height": "26.54"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m440.13,404.45v-35.6l.94-.95v-30.37c-.57-.4-.94-1.06-.94-1.8,0-1.21.98-2.19,2.19-2.19s2.19.98,2.19,2.19c0,.74-.37,1.4-.94,1.8v30.37l.94.95v35.6h-4.39Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "380.96",
	      "y": "389.08",
	      "width": "124.92",
	      "height": "167.54"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "367.94",
	      "y": "389.08",
	      "width": "13.02",
	      "height": "167.54"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "505.88",
	      "y": "389.08",
	      "width": "13.02",
	      "height": "167.54"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "367.94",
	      "y": "539.25",
	      "width": "150.97",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#4c3322"
	    },
	    attrs: {
	      "x": "367.94",
	      "y": "539.25",
	      "width": "13.02",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#4c3322"
	    },
	    attrs: {
	      "x": "505.88",
	      "y": "539.25",
	      "width": "13.02",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "414.89",
	      "y": "486.18",
	      "width": "28.53",
	      "height": "53.07"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "443.42",
	      "y": "486.18",
	      "width": "28.53",
	      "height": "53.07"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "367.94",
	      "y": "388.99",
	      "width": "150.97",
	      "height": "1.42"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "243.01",
	      "y": "428.95",
	      "width": "124.92",
	      "height": "127.67"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "250.01",
	      "y": "434.53",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "252.22",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "278.63",
	      "y": "434.53",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "280.84",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "307.25",
	      "y": "434.53",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "309.46",
	      "y": "436.74",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "335.86",
	      "y": "434.53",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "338.08",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "386.05",
	      "y": "395.17",
	      "width": "26.4",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "388.26",
	      "y": "397.38",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "414.66",
	      "y": "395.17",
	      "width": "26.4",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "416.88",
	      "y": "397.38",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "443.28",
	      "y": "395.17",
	      "width": "26.31",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "445.49",
	      "y": "397.38",
	      "width": "21.89",
	      "height": "63.21"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "471.9",
	      "y": "395.17",
	      "width": "26.4",
	      "height": "67.63"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "474.11",
	      "y": "397.38",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "250.01",
	      "y": "486.28",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "252.22",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "278.63",
	      "y": "486.28",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "280.84",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "307.25",
	      "y": "486.28",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "309.46",
	      "y": "488.49",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "335.86",
	      "y": "486.28",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "338.08",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "239.03",
	      "y": "539.25",
	      "width": "128.91",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "237.79",
	      "y": "414.78",
	      "width": "130.15",
	      "height": "12.85"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "243.01",
	      "y": "427.44",
	      "width": "124.92",
	      "height": "1.51"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "518.9",
	      "y": "428.95",
	      "width": "124.92",
	      "height": "127.67"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "518.9",
	      "y": "539.25",
	      "width": "128.91",
	      "height": "17.36"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "518.9",
	      "y": "414.78",
	      "width": "130.06",
	      "height": "12.85"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "518.9",
	      "y": "427.44",
	      "width": "124.92",
	      "height": "1.51"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "408.25",
	      "y": "468.11",
	      "width": "70.88",
	      "height": "18.07"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "395.91",
	      "y": "545.01",
	      "width": "96.21",
	      "height": "5.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "395.91",
	      "y": "547.91",
	      "width": "96.21",
	      "height": "2.9"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "399.86",
	      "y": "539.25",
	      "width": "87.64",
	      "height": "5.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "399.86",
	      "y": "542.15",
	      "width": "87.64",
	      "height": "2.9"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "391.33",
	      "y": "550.82",
	      "width": "105.03",
	      "height": "5.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "391.33",
	      "y": "553.72",
	      "width": "105.03",
	      "height": "2.9"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "365.54",
	      "y": "376.32",
	      "width": "157.08",
	      "height": "12.76"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "points": "410.24 433.99 410.24 417.68 396.28 397.38 388.26 397.38 388.26 402.03 410.24 433.99"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "points": "416.88 413.09 438.86 445.06 438.86 397.38 416.88 397.38 416.88 413.09"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "points": "416.88 427.33 416.88 443.64 428.53 460.58 438.86 460.58 438.86 459.29 416.88 427.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "points": "467.38 397.38 445.49 397.38 445.49 454.71 449.53 460.58 467.38 460.58 467.38 397.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "474.11",
	      "y": "397.38",
	      "width": "21.98",
	      "height": "63.21"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "points": "410.24 403.44 410.24 397.38 406.07 397.38 410.24 403.44"
	    }
	  })]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "302.82 436.74 280.84 436.74 280.84 446.62 291.54 462.18 302.82 462.18 302.82 436.74"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "338.08",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "309.46",
	      "y": "436.74",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "274.21 452.8 263.16 436.74 252.22 436.74 252.22 445.04 264.01 462.18 274.21 462.18 274.21 452.8"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "302.82 494.41 298.75 488.49 282.11 488.49 299.6 513.93 302.82 513.93 302.82 494.41"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "331.35 488.49 309.64 488.49 327.13 513.93 331.35 513.93 331.35 488.49"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "338.08",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "309.46 504.07 309.46 513.93 316.24 513.93 309.46 504.07"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "274.21 436.96 274.21 436.74 274.05 436.74 274.21 436.96"
	    }
	  })]), _h('g', [_h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "524.14",
	      "y": "434.53",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "526.35",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "552.75",
	      "y": "434.53",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "554.97",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "581.37",
	      "y": "434.53",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "583.58",
	      "y": "436.74",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "609.99",
	      "y": "434.53",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "612.2",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "524.14",
	      "y": "486.28",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "526.35",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "552.75",
	      "y": "486.28",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "554.97",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "581.37",
	      "y": "486.28",
	      "width": "26.31",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "583.58",
	      "y": "488.49",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fdd491"
	    },
	    attrs: {
	      "x": "609.99",
	      "y": "486.28",
	      "width": "26.4",
	      "height": "29.86"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "612.2",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  })])]), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "576.95 436.74 554.97 436.74 554.97 446.62 565.67 462.18 576.95 462.18 576.95 436.74"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "612.2",
	      "y": "436.74",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "583.58",
	      "y": "436.74",
	      "width": "21.89",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "548.33 452.8 537.29 436.74 526.35 436.74 526.35 445.04 538.14 462.18 548.33 462.18 548.33 452.8"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "576.95 494.41 572.87 488.49 556.23 488.49 573.72 513.93 576.95 513.93 576.95 494.41"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "605.47 488.49 583.77 488.49 601.26 513.93 605.47 513.93 605.47 488.49"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "612.2",
	      "y": "488.49",
	      "width": "21.98",
	      "height": "25.44"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "583.58 504.07 583.58 513.93 590.37 513.93 583.58 504.07"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "548.33 436.96 548.33 436.74 548.18 436.74 548.33 436.96"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "445.63",
	      "y": "488.4",
	      "width": "24.1",
	      "height": "48.65"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c7743e"
	    },
	    attrs: {
	      "x": "417.1",
	      "y": "488.4",
	      "width": "24.1",
	      "height": "48.65"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "445.63 502.06 469.69 537.04 469.74 537.04 469.74 488.4 445.63 488.4 445.63 502.06"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "441.21 495.63 441.21 488.4 436.23 488.4 441.21 495.63"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "463.92 537.04 445.63 510.45 445.63 526.03 453.21 537.04 463.92 537.04"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "points": "441.21 519.6 441.21 504.02 430.47 488.4 419.75 488.4 441.21 519.6"
	    }
	  })])])]), _h('rect', {
	    staticStyle: {
	      "fill": "#bcb0a5"
	    },
	    attrs: {
	      "x": "437.62",
	      "y": "509.49",
	      "width": "1.95",
	      "height": "7.53"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#bcb0a5"
	    },
	    attrs: {
	      "x": "447.21",
	      "y": "509.49",
	      "width": "1.95",
	      "height": "7.53"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "271.47",
	      "y": "470.54",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "267.15",
	      "y": "474.14",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "276.49",
	      "y": "474.14",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "301.09",
	      "y": "521.79",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "306.11",
	      "y": "525.4",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "484.62",
	      "y": "492.14",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "489.63",
	      "y": "495.75",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "338.86",
	      "y": "479.12",
	      "width": "8.64",
	      "height": "2.88"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m452.06,351.77c0-5.92,4.8-10.72,10.72-10.72s10.72,4.8,10.72,10.72-4.8,10.72-10.72,10.72-10.72-4.8-10.72-10.72h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m461.93,349.21c0-.52.43-.95.95-.95s.95.43.95.95-.43.95-.95.95-.95-.43-.95-.95h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m464.74,349.21c.06-.05.1-.1.19-.11.13,0,.24.09.24.22v1.06s-1.76,1.75-1.76,1.75v5.85h-1.14v-5.85l-1.76-1.69v-1.14c0-.13.1-.24.23-.24.08,0,.15.05.21.1l1.87,1.87,1.91-1.84h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m461.79,343.85c0-.19.05-.28.2-.22l.61.57.28-.87.32.84.58-.52s.16-.1.21.1c0,0,.03,1.04-.72,1.66,0,0-.34.33-.88-.1,0,0-.57-.51-.58-1.47h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m466.71,344.88c.11-.16.21-.2.29-.06l.16.82.74-.54-.23.87.77-.08s.19.02.11.2c0,0-.59.86-1.56.92,0,0-.47.07-.66-.6,0,0-.16-.75.39-1.53h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m464.41,343.99c.06-.18.14-.25.26-.14l.38.75.56-.72.02.9.72-.29s.19-.03.16.16c0,0-.33.99-1.25,1.32,0,0-.44.19-.8-.4,0,0-.36-.68-.05-1.58h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m463.08,345.88c.06-.18.14-.25.26-.14l.38.75.56-.72.02.9.72-.29s.19-.03.16.16c0,0-.33.99-1.25,1.32,0,0-.44.19-.8-.4,0,0-.36-.68-.05-1.58h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m465.42,346.9c.11-.16.21-.2.29-.06l.16.82.74-.54-.23.87.77-.08s.19.02.11.2c0,0-.59.86-1.56.92,0,0-.47.07-.66-.6,0,0-.16-.75.39-1.53h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m468.81,346.45c.16-.1.27-.11.29.05l-.16.82.88-.22-.54.72.74.21s.17.09.03.23c0,0-.87.58-1.79.27,0,0-.46-.12-.38-.8,0,0,.13-.76.93-1.27h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m457.2,346.2c-.12-.15-.14-.25.01-.3l.83.06-.33-.85.78.45.12-.77s.07-.18.22-.05c0,0,.68.79.49,1.75,0,0-.06.47-.75.48,0,0-.77-.04-1.38-.77h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m458.38,348.19c-.12-.15-.14-.25.01-.3l.83.06-.33-.85.78.45.12-.77s.07-.18.22-.05c0,0,.68.79.49,1.75,0,0-.06.47-.75.48,0,0-.77-.04-1.38-.77h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m459.15,344.65c-.06-.18-.04-.28.12-.27l.76.35v-.91s.56.7.56.7l.39-.67s.13-.14.23.03c0,0,.35.98-.17,1.81,0,0-.22.42-.87.18,0,0-.7-.31-1.01-1.21h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m460.4,346.57c-.06-.18-.04-.28.12-.27l.76.35v-.91s.56.7.56.7l.39-.67s.13-.14.23.03c0,0,.35.98-.17,1.81,0,0-.22.42-.87.18,0,0-.7-.31-1.01-1.21h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m455.71,348.34c-.16-.1-.21-.19-.08-.28l.81-.22-.59-.7.88.17-.13-.76s0-.19.19-.12c0,0,.9.53,1.03,1.49,0,0,.1.47-.55.7,0,0-.74.21-1.55-.28h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#70461f",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".15px"
	    },
	    attrs: {
	      "d": "m464.63,358.96s0-7.68,0-7.68c0,0,2.13-2.37,5.55-1.18v7.35s-3.26-1.15-5.55,1.51h0Zm.04.02s1.81-2.09,5.5-1.28m-5.53,1.28s2.16-1.73,5.58-.88"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f",
	      "stroke": "#70461f",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".15px"
	    },
	    attrs: {
	      "d": "m460.93,358.96s0-7.68,0-7.68c0,0-2.13-2.37-5.55-1.18v7.35s3.26-1.15,5.55,1.51h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#70461f",
	      "stroke-miterlimit": "3.86",
	      "stroke-width": ".15px"
	    },
	    attrs: {
	      "d": "m460.89,358.98s-1.81-2.09-5.5-1.28m5.53,1.28s-2.16-1.73-5.58-.88"
	    }
	  })])])]), _h('g', {
	    attrs: {
	      "id": "scene_school-grounds"
	    }
	  }, [_h('rect', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "id": "school-grounds_rectangle",
	      "x": "267.87",
	      "y": "636.41",
	      "width": "372.41",
	      "height": "239.19"
	    }
	  }), _h('g', {
	    attrs: {
	      "id": "school-grounds_complete"
	    }
	  }, [_h('line', {
	    staticStyle: {
	      "fill": "#9c8865"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "800.52",
	      "x2": "359.6",
	      "y2": "800.52"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "717.05",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "717.05",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "348.24",
	      "y": "717.05",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "348.24",
	      "y": "717.05",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "547.13",
	      "y": "716.87",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "348.22",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "611.97",
	      "y": "716.87",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#73532c"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "800.32",
	      "width": "338.26",
	      "height": "75.55"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9c6d40"
	    },
	    attrs: {
	      "x": "399.9",
	      "y": "836.64",
	      "width": "7.09",
	      "height": "29.93",
	      "transform": "translate(806.88 1703.21) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9c6d40"
	    },
	    attrs: {
	      "x": "489.4",
	      "y": "836.64",
	      "width": "7.09",
	      "height": "29.93",
	      "transform": "translate(985.89 1703.21) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "447.92",
	      "y": "717.05",
	      "width": "9.68",
	      "height": "149.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "447.92",
	      "y": "717.05",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "447.91",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "547.11",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "611.97",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "547.13",
	      "y": "716.87",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "x": "354.44",
	      "y": "833.74",
	      "width": "195.92",
	      "height": "5.84",
	      "transform": "translate(904.81 1673.31) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ac6b41"
	    },
	    attrs: {
	      "x": "354.44",
	      "y": "831.63",
	      "width": "195.92",
	      "height": "4",
	      "transform": "translate(904.81 1667.25) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#856034"
	    },
	    attrs: {
	      "x": "333.74",
	      "y": "865.98",
	      "width": "281.36",
	      "height": "8.3"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m461.03,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m601.2,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m595.78,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m592.59,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m561.42,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m585.85,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m566.71,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m581.24,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m581.24,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "582.86 806.86 595.87 805.63 592.56 816.6 581.24 816.6 582.86 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "579.62 806.86 566.61 805.63 569.92 816.6 581.24 816.6 579.62 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m582.86,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m567.26,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m568.13,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m568.8,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m595.23,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m594.35,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m593.69,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m588.36,835.33h-14.12c-2.33,0-4.23-2.26-4.23-5.02v-2.52h22.59v2.52c0,2.76-1.9,5.02-4.23,5.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "582.06",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(1172.19 1693.75) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "572.97",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m590.13,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m581.04,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m577.32,859.38h-.79s-3.56,0-3.56,0c-.99,2.36-2.27,4.22-1.99,7.07h5.55s.79,0,.79,0h5.55c.28-2.85-.83-4.71-1.82-7.07h-3.73Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m586.4,859.38h-.79s-3.56,0-3.56,0c-.99,2.36-2.27,4.22-1.99,7.07h5.55s.79,0,.79,0h5.55c.28-2.85-.83-4.71-1.82-7.07h-3.73Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9c8865"
	    },
	    attrs: {
	      "x": "283.82",
	      "y": "799.89",
	      "width": "75.35",
	      "height": "76.2",
	      "transform": "translate(1159.49 516.5) rotate(90)"
	    }
	  }), _h('g', [_h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "813.29",
	      "x2": "359.6",
	      "y2": "813.29"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "825.58",
	      "x2": "359.6",
	      "y2": "825.58"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "837.86",
	      "x2": "359.6",
	      "y2": "837.86"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "850.15",
	      "x2": "359.6",
	      "y2": "850.15"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "862.43",
	      "x2": "359.6",
	      "y2": "862.43"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#603914"
	    },
	    attrs: {
	      "x": "318.99",
	      "y": "861.41",
	      "width": "30.09",
	      "height": "12.47",
	      "transform": "translate(668.07 1735.28) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#754d24"
	    },
	    attrs: {
	      "d": "m321.89,816.62h24.29c3.4,0,6.15,2.76,6.15,6.15v33.8c0,5.34-4.34,9.68-9.68,9.68h-17.24c-5.34,0-9.68-4.34-9.68-9.68v-33.8c0-3.4,2.76-6.15,6.15-6.15Z",
	      "transform": "translate(668.07 1682.88) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "x": "311.68",
	      "y": "821.78",
	      "width": "44.7",
	      "height": "4.96",
	      "rx": "1.99",
	      "ry": "1.99",
	      "transform": "translate(668.07 1648.52) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#603914"
	    },
	    attrs: {
	      "x": "315.73",
	      "y": "826.74",
	      "width": "36.6",
	      "height": "3.68",
	      "transform": "translate(668.07 1657.16) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#603914"
	    },
	    attrs: {
	      "x": "327.84",
	      "y": "818.17",
	      "width": "12.39",
	      "height": "2.07",
	      "transform": "translate(668.07 1638.4) rotate(-180)"
	    }
	  }), _h('rect', {
	    attrs: {
	      "x": "349.08",
	      "y": "867.64",
	      "width": "3.9",
	      "height": "9.1",
	      "rx": "1.57",
	      "ry": "1.57",
	      "transform": "translate(702.05 1744.38) rotate(-180)"
	    }
	  }), _h('rect', {
	    attrs: {
	      "x": "315.09",
	      "y": "867.64",
	      "width": "3.9",
	      "height": "9.1",
	      "rx": "1.57",
	      "ry": "1.57",
	      "transform": "translate(634.08 1744.38) rotate(180)"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "611.97",
	      "y": "716.87",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#73532c"
	    },
	    attrs: {
	      "points": "635.1 718.62 271.35 718.62 453.22 638.07 635.1 718.62"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "points": "453.22 638.07 453.22 718.62 635.1 718.62 453.22 638.07"
	    }
	  }), _h('g', {
	    staticStyle: {
	      "clip-path": "url(#clippath)"
	    }
	  }, [_h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "704.85",
	      "x2": "633.07",
	      "y2": "704.85"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "692.53",
	      "x2": "633.07",
	      "y2": "692.53"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "680.22",
	      "x2": "633.07",
	      "y2": "680.22"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "667.9",
	      "x2": "633.07",
	      "y2": "667.9"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "655.58",
	      "x2": "633.07",
	      "y2": "655.58"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "643.26",
	      "x2": "633.07",
	      "y2": "643.26"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#9c8865"
	    },
	    attrs: {
	      "x": "545.89",
	      "y": "799.89",
	      "width": "75.35",
	      "height": "76.2",
	      "transform": "translate(1421.55 254.43) rotate(90)"
	    }
	  }), _h('g', [_h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "813.29",
	      "x2": "621.66",
	      "y2": "813.29"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "825.58",
	      "x2": "621.66",
	      "y2": "825.58"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "837.86",
	      "x2": "621.66",
	      "y2": "837.86"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "850.15",
	      "x2": "621.66",
	      "y2": "850.15"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "862.43",
	      "x2": "621.66",
	      "y2": "862.43"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#63922f"
	    },
	    attrs: {
	      "d": "m262.32,838.59c-.22,5.97,3.3,8.18,8.61,8.61-.48-6.24-3.51-8.88-8.61-8.61Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8cbf33",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m271.37,847.2c5.31-.43,8.83-2.65,8.61-8.61-5.1-.27-8.13,2.38-8.61,8.61Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#8cbf33",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m272.36,855.84v-24.3c0-.65-.53-1.19-1.19-1.19-.66,0-1.19.53-1.19,1.19v24.3c0,.66.53,1.19,1.19,1.19s1.19-.53,1.19-1.19h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#56822e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m271.11,830.36c-.62.04-1.12.55-1.12,1.18v24.3c0,.63.5,1.15,1.12,1.18v-26.66Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m270.18,829.8c-4.94,11.92-13.02,3.84-1.1-1.1-11.92,4.94-11.92-6.5,0-1.56-11.92-4.94-3.84-13.02,1.1-1.1-4.94-11.92,6.5-11.92,1.56,0,4.94-11.92,13.02-3.84,1.1,1.1,11.92-4.94,11.92,6.5,0,1.56,11.92,4.94,3.84,13.02-1.1,1.1,4.94,11.92-6.5,11.92-1.56,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada"
	    },
	    attrs: {
	      "d": "m270.92,817.1c-1.61.06-3.18,3.03-.73,8.94-4.94-11.92-13.02-3.84-1.1,1.1-11.92-4.94-11.92,6.5,0,1.56-11.92,4.94-3.84,13.02,1.1,1.1-2.45,5.9-.87,8.88.73,8.94v-21.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fab216"
	    },
	    attrs: {
	      "d": "m270.93,831c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fecc04"
	    },
	    attrs: {
	      "d": "m270.93,824.88c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#63922f"
	    },
	    attrs: {
	      "d": "m277.25,841.47c-.18,4.75,2.62,6.51,6.85,6.85-.38-4.96-2.8-7.07-6.85-6.85Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8cbf33",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m284.44,848.32c4.22-.34,7.03-2.11,6.85-6.85-4.05-.21-6.47,1.89-6.85,6.85Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#8cbf33",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m285.24,855.19v-19.33c0-.52-.42-.95-.95-.95s-.95.43-.95.95v19.33c0,.52.42.95.95.95s.95-.42.95-.95h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#56822e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m284.24,834.92c-.5.03-.89.44-.89.94v19.33c0,.5.4.91.89.94v-21.21Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#63922f"
	    },
	    attrs: {
	      "d": "m289.15,838.59c-.22,5.97,3.3,8.18,8.61,8.61-.48-6.24-3.51-8.88-8.61-8.61Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8cbf33",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m298.19,847.2c5.31-.43,8.83-2.65,8.61-8.61-5.1-.27-8.13,2.38-8.61,8.61Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#8cbf33",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m299.19,855.84v-24.3c0-.65-.53-1.19-1.19-1.19-.66,0-1.19.53-1.19,1.19v24.3c0,.66.53,1.19,1.19,1.19s1.19-.53,1.19-1.19h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#56822e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m297.93,830.36c-.62.04-1.12.55-1.12,1.18v24.3c0,.63.5,1.15,1.12,1.18v-26.66Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e6007e"
	    },
	    attrs: {
	      "d": "m291.32,833.17c1.21-.41,1.11-1.07-.22-1.25,1.27-.65,1.1-1.34-.29-1.27.99-.82.69-1.41-.59-1.11.92-1.05.49-1.62-.78-1.04.65-1.13.17-1.59-.91-.88.45-1.29-.16-1.65-1.14-.63.22-1.32-.4-1.59-1.15-.55-.06-1.34-.76-1.43-1.29-.12-.27-1.34-.95-1.38-1.27-.14-.54-1.2-1.22-1.02-1.23.39-.74-1.17-1.4-.97-1.25.31-.93-.9-1.49-.49-1,.81-1.13-.83-1.68-.4-1.06.75-1.18-.49-1.56.07-.65,1.1-1.37-.37-1.72.25-.69,1.1-1.28-.04-1.44.62-.26,1.24-1.4.16-1.49.87-.19,1.29-1.22.43-1.15,1.09.15,1.25-1.24.66-1.04,1.35.35,1.25-1.01.84-.72,1.44.53,1.14-.89,1.06-.44,1.62.84.99-.67,1.17-.19,1.64.86.93-.43,1.29.2,1.63,1.17.56-.22,1.36.39,1.65,1.12.61.08,1.34.78,1.4,1.3.05.27,1.38.95,1.45,1.27.21.55,1.19,1.22.99,1.22-.46.76,1.22,1.43,1.04,1.28-.24.93.9,1.48.47.96-.87,1.16.88,1.72.46,1.1-.69,1.18.5,1.53-.09.6-1.14,1.4.4,1.77-.2.75-1.07,1.27.04,1.41-.62.19-1.26,1.44-.13,1.55-.84.26-1.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a9005d"
	    },
	    attrs: {
	      "d": "m284.22,825.33c-.2.07-.39.35-.53.87-.54-1.2-1.22-1.02-1.23.39-.74-1.17-1.4-.97-1.25.31-.93-.9-1.49-.49-1,.81-1.13-.83-1.68-.4-1.06.75-1.18-.49-1.56.07-.65,1.1-1.37-.37-1.72.25-.69,1.1-1.28-.04-1.44.62-.26,1.24-1.4.16-1.49.87-.19,1.29-1.22.43-1.15,1.09.15,1.25-1.24.66-1.04,1.35.35,1.25-1.01.84-.72,1.44.53,1.14-.89,1.06-.44,1.62.84.99-.67,1.17-.19,1.64.86.93-.43,1.29.2,1.63,1.17.56-.22,1.36.39,1.65,1.12.61.08,1.34.78,1.4,1.3.05.12.6.31.93.52,1.04v-15.68Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fab216"
	    },
	    attrs: {
	      "d": "m284.25,835.63c-1.35,0-2.44-1.09-2.44-2.44s1.09-2.44,2.44-2.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fecc04"
	    },
	    attrs: {
	      "d": "m284.25,830.76c1.35,0,2.44,1.09,2.44,2.44s-1.09,2.44-2.44,2.44"
	    }
	  })])]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m297.01,829.8c-4.94,11.92-13.02,3.84-1.1-1.1-11.92,4.94-11.92-6.5,0-1.56-11.92-4.94-3.84-13.02,1.1-1.1-4.94-11.92,6.5-11.92,1.56,0,4.94-11.92,13.02-3.84,1.1,1.1,11.92-4.94,11.92,6.5,0,1.56,11.92,4.94,3.84,13.02-1.1,1.1,4.94,11.92-6.5,11.92-1.56,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada"
	    },
	    attrs: {
	      "d": "m297.75,817.1c-1.61.06-3.18,3.03-.73,8.94-4.94-11.92-13.02-3.84-1.1,1.1-11.92-4.94-11.92,6.5,0,1.56-11.92,4.94-3.84,13.02,1.1,1.1-2.45,5.9-.87,8.88.73,8.94v-21.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fab216"
	    },
	    attrs: {
	      "d": "m297.76,831c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fecc04"
	    },
	    attrs: {
	      "d": "m297.76,824.88c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d19166"
	    },
	    attrs: {
	      "points": "266.61 875.41 301.63 875.41 305.26 854.78 262.98 854.78 266.61 875.41"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#bc7846"
	    },
	    attrs: {
	      "points": "264.22 861.83 262.98 854.78 305.26 854.78 304.02 861.83 264.22 861.83"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#bc7846"
	    },
	    attrs: {
	      "points": "283.96 854.78 283.96 875.41 266.61 875.41 262.98 854.78 283.96 854.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d19166"
	    },
	    attrs: {
	      "d": "m259.57,856.97c0,.73.49,1.33,1.09,1.33h46.98c.6,0,1.09-.59,1.09-1.33v-5.3c0-.73-.49-1.33-1.09-1.33h-46.98c-.6,0-1.09.59-1.09,1.33v5.3Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m396.34,795.45c3.72,4.32,7.97,9.77,9.72,13.72.7,1.58,1.05,3.02.91,4.23-.22,1.85-1.27,3.08-3.36,3.47-1.42.26-3.46,0-6.26-.98l1.5-4.35c1.63.57,2.77.82,3.5.83-.08-.35-.24-.81-.48-1.35-1.53-3.43-5.49-8.49-9-12.57l3.48-3.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m373.64,795.45c-3.72,4.32-7.97,9.77-9.72,13.72-.7,1.58-1.05,3.02-.91,4.23.22,1.85,1.27,3.08,3.36,3.47,1.42.26,3.46,0,6.26-.98l-1.5-4.35c-1.63.57-2.77.82-3.5.83.08-.35.24-.81.48-1.35,1.53-3.43,5.49-8.49,9-12.57l-3.48-3.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m370.97,789.72c.41-.26.79-.78.79-1.26v-13.51c0-6.86,5.73-12.42,12.81-12.47h0s.03,0,.05,0c.02,0,.03,0,.05,0h0c7.09.06,12.81,5.62,12.81,12.47v13.51c0,.48.37,1,.79,1.26,1.39.86,2.31,2.37,2.31,4.08,0,2.68-2.25,4.85-5.02,4.85-.36,0-21.52,0-21.88,0-2.77,0-5.02-2.17-5.02-4.85,0-1.71.92-3.22,2.31-4.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m404.94,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m399.53,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m396.34,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m365.17,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "x": "381.16",
	      "y": "790.93",
	      "width": "6.91",
	      "height": "6.96"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m376.95,782.16c0,1.87-1.51,3.38-3.38,3.38-1.87,0-3.38-1.51-3.38-3.38s1.51-3.38,3.38-3.38c1.87,0,3.38,1.51,3.38,3.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m399.05,782.16c0,1.87-1.51,3.38-3.38,3.38-1.87,0-3.38-1.51-3.38-3.38,0-1.87,1.51-3.38,3.38-3.38,1.87,0,3.38,1.51,3.38,3.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m375.6,782.16c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03,0-1.12.91-2.03,2.03-2.03,1.12,0,2.03.91,2.03,2.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m397.7,782.16c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03,0-1.12.91-2.03,2.03-2.03,1.12,0,2.03.91,2.03,2.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m396.05,781.87c0,6.36-5.15,11.51-11.51,11.51-6.36,0-11.51-5.15-11.51-11.51v-7.73c0-6.36,5.15-7.87,11.51-7.87,11.95,0,11.51,4.7,11.51,11.51v4.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m389.6,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#decc86"
	    },
	    attrs: {
	      "d": "m388.07,795.33c0,1.41-1.55,2.56-3.45,2.56s-3.45-1.14-3.45-2.56v-.34h6.91v.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197"
	    },
	    attrs: {
	      "d": "m384.53,766.26h0v27.11c-6.36,0-11.51-5.15-11.51-11.51v-7.73c0-6.36,5.15-7.87,11.51-7.87Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m372.38,776.46l-.06.04c0-7.26,5.5-13.14,12.29-13.14,6.64,0,12.05,5.64,12.27,12.68.08.67.12,1.36.12,2.06,0,.13-.23.53-.24.65-.02.42-4.54-2.21-7.55-6.45-.75.74-3.66,3-7.1,4.42-4.23,1.74-7.55,2.44-8.93,2.43-1.26,0-.89-.93-.89-1.05,0-.56.03-1.11.08-1.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d48963",
	      "opacity": ".8"
	    },
	    attrs: {
	      "d": "m384.53,790.23c-1.12,0-2.21-.47-2.79-1.2-.14-.18-.11-.45.07-.59.18-.14.45-.11.59.07.42.53,1.26.88,2.13.88,1.08,0,1.81-.45,2.13-.87.14-.18.41-.22.59-.08.18.14.22.41.08.59-.58.75-1.63,1.2-2.8,1.2Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "389.81",
	      "cy": "783.62",
	      "r": "1.38"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "379.26",
	      "cy": "783.62",
	      "r": "1.38"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m370.45,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m384.99,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m384.99,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "386.61 806.86 399.62 805.63 396.31 816.6 384.99 816.6 386.61 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "383.36 806.86 370.35 805.63 373.66 816.6 384.99 816.6 383.36 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m386.61,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m371.01,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m371.88,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m372.55,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m398.97,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m398.1,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m397.43,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m392.11,835.33h-14.12c-2.33,0-4.23-2.26-4.23-5.02v-2.52h22.59v2.52c0,2.76-1.9,5.02-4.23,5.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "385.81",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(779.68 1693.75) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "376.72",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m393.87,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m384.78,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m386.65,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m395.74,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m466.67,800.25c2.43,3.13,4.64,6.35,5.78,8.93.7,1.58,1.05,3.02.91,4.23-.22,1.85-1.27,3.08-3.36,3.47-1.42.26-3.46,0-6.26-.98l1.5-4.35c1.63.57,2.77.82,3.5.83-.08-.35-.24-.81-.48-1.35-1.01-2.28-3.1-5.28-5.42-8.23-1.17-1.49,2.55-4.21,3.84-2.55Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m436.03,800.34c-2.4,3.1-4.58,6.28-5.71,8.83-.7,1.58-1.05,3.02-.91,4.23.22,1.85,1.27,3.08,3.36,3.47,1.42.26,3.46,0,6.26-.98l-1.5-4.35c-1.63.57-2.77.82-3.5.83.08-.35.24-.81.48-1.35,1.03-2.31,3.15-5.35,5.51-8.34,1.14-1.45-2.69-4.04-4-2.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m471.34,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m465.92,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m462.74,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m431.57,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m456,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m451.38,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m451.38,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "453.01 806.86 466.02 805.63 462.71 816.6 451.38 816.6 453.01 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "449.76 806.86 436.75 805.63 440.06 816.6 451.38 816.6 449.76 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m453.01,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m437.41,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m438.28,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m438.94,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m465.37,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m464.5,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m463.83,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m458.5,835.87h-14.12c-2.33,0-4.23-2.42-4.23-5.38v-2.7h22.59v2.7c0,2.96-1.9,5.38-4.23,5.38Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#66635b"
	    },
	    attrs: {
	      "x": "453.99",
	      "y": "831.04",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(916.04 1695.15) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#66635b"
	    },
	    attrs: {
	      "x": "441.33",
	      "y": "831.04",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m459.07,781.11c0,1.68,1.36,3.05,3.05,3.05,1.68,0,3.05-1.36,3.05-3.05,0-1.68-1.36-3.05-3.05-3.05-1.68,0-3.05,1.36-3.05,3.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197"
	    },
	    attrs: {
	      "d": "m436.5,781.11c0,1.68,1.36,3.05,3.05,3.05,1.68,0,3.05-1.36,3.05-3.05s-1.36-3.05-3.05-3.05c-1.68,0-3.05,1.36-3.05,3.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m460.29,781.11c0,1.01.82,1.83,1.83,1.83,1.01,0,1.83-.82,1.83-1.83s-.82-1.83-1.83-1.83c-1.01,0-1.83.82-1.83,1.83Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d9c883"
	    },
	    attrs: {
	      "d": "m437.72,781.11c0,1.01.82,1.83,1.83,1.83,1.01,0,1.83-.82,1.83-1.83,0-1.01-.82-1.83-1.83-1.83-1.01,0-1.83.82-1.83,1.83Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#decc86"
	    },
	    attrs: {
	      "x": "447.69",
	      "y": "786.42",
	      "width": "6.26",
	      "height": "8.81"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#decc86",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m450.82,798.27c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13-3.13,1.41-3.13,3.13,1.41,3.13,3.13,3.13h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m450.82,763.65h0c6.21,0,11.29,5,11.29,11.12v8.89c0,6.11-5.08,11.12-11.29,11.12h0c-6.21,0-11.29-5-11.29-11.12v-8.89c0-6.11,5.08-11.12,11.29-11.12h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m450.82,763.65v31.13c6.21,0,11.29-5,11.29-11.12v-8.89c0-6.11-5.08-11.12-11.29-11.12Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "445.93",
	      "cy": "781.4",
	      "r": "1.26"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "455.76",
	      "cy": "781.4",
	      "r": "1.26"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m447.57,787.1h6.52c.13,0,.23.1.23.23,0,1.41-1.63,2.65-3.49,2.65-2.09,0-3.49-1.37-3.49-2.65,0-.13.1-.23.23-.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#713b27",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m462.1,781.34c-.71-6-1.07-6.08-1.42-6.61-2.41-3.28-15.13-3.75-16.1-6.25-4.17,4.08-5,12.77-5,12.77-1.47-6.42.53-14.13,4-15.87-.73-1.09-1.33-2.14-.61-4.44,1.06,1.28,1.7,1.87,3.76,3.39-1.23-1.24-2.54-3.48-1.87-6.17.55.88,3.52,3.51,4.82,4.81-.72-1.85-.68-2.27-.65-3.08,10.21,6.13,15.06,8.14,13.07,21.45Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m451.27,865.99c-.07-2.23-1.01-3.89-1.86-5.91h-8.09c-.85,2.02-1.91,3.68-2.02,5.91h11.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m463.92,865.99c-.07-2.23-1.01-3.89-1.86-5.91h-8.09c-.85,2.02-1.91,3.68-2.02,5.91h11.96Z"
	    }
	  })]), _h('g', [_h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m531.22,799.3c2.72,3.42,5.27,7.03,6.53,9.87.7,1.58,1.05,3.02.91,4.23-.22,1.85-1.27,3.08-3.36,3.47-1.42.26-3.46,0-6.26-.98l1.5-4.35c1.63.57,2.77.82,3.5.83-.08-.35-.24-.81-.48-1.35-1.04-2.33-3.19-5.41-5.57-8.42-1.12-1.42,2.19-4.64,3.25-3.31Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m501.45,800.18c-2.45,3.15-4.68,6.4-5.84,9-.7,1.58-1.05,3.02-.91,4.23.22,1.85,1.27,3.08,3.36,3.47,1.42.26,3.46,0,6.26-.98l-1.5-4.35c-1.63.57-2.77.82-3.5.83.08-.35.24-.81.48-1.35,1.03-2.33,3.19-5.4,5.56-8.41,1.13-1.43-2.65-4.08-3.92-2.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m536.63,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m531.22,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m528.03,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m496.86,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m521.29,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m502.14,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.68,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.68,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "518.3 806.86 531.31 805.63 528 816.6 516.68 816.6 518.3 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "515.05 806.86 502.04 805.63 505.35 816.6 516.68 816.6 515.05 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m518.3,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m502.7,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m503.57,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m504.24,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m530.66,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m529.79,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m529.12,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m523.79,835.33h-14.12c-2.33,0-4.23-2.26-4.23-5.02v-2.52h22.59v2.52c0,2.76-1.9,5.02-4.23,5.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "517.5",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(1043.06 1693.75) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "508.41",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m525.56,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.47,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m518.34,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m527.43,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#4c3322"
	    },
	    attrs: {
	      "d": "m500.04,781.46c0,7.41,7.05,12.16,15.74,12.16,8.69,0,15.74-4.75,15.74-12.16,0-7.41-4.9-18.3-15.74-18.3-11,0-15.74,10.89-15.74,18.3Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e0b268"
	    },
	    attrs: {
	      "x": "512.85",
	      "y": "786.03",
	      "width": "6.44",
	      "height": "9.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e0b268",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.07,798.23c-1.78,0-3.22-1.44-3.22-3.22s1.44-3.22,3.22-3.22,3.22,1.45,3.22,3.22-1.45,3.22-3.22,3.22h0Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m504.29,782.23c0,6.36,5.16,11.52,11.52,11.52,6.37,0,11.52-5.16,11.52-11.52v-7.74c0-6.37-5.16-7.88-11.52-7.88-11.96,0-11.52,4.7-11.52,11.52v4.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ecbb6d",
	      "opacity": ".8"
	    },
	    attrs: {
	      "d": "m515.81,766.61v27.14c-6.36,0-11.52-5.16-11.52-11.52v-4.1c0-6.82-.44-11.52,11.52-11.52Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#4c3322"
	    },
	    attrs: {
	      "d": "m504.06,775.04c0-6.53,5.29-11.83,11.83-11.83,6.39,0,11.6,5.07,11.81,11.42.08.6-.15,3.52-.36,4.16,0,0-3.87-1.75-7.01-7.52-.72.67-3.76,3.38-6.9,4.37-3.11.98-5.36.83-6.96.83l-2.17,2.33h-.25c-.1-.02.02-3.75.02-3.75Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "521.24",
	      "cy": "781.98",
	      "r": "1.42"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "510.19",
	      "cy": "781.98",
	      "r": "1.42"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m519.29,786.61h-7.11c-.14,0-.25.11-.25.25,0,1.54,1.78,2.89,3.81,2.89,2.28,0,3.81-1.5,3.81-2.89,0-.14-.11-.25-.25-.25Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#6e2f16"
	    },
	    attrs: {
	      "d": "m576.95,790.93v3.68c0,2.05,1.66,3.71,3.71,3.71s3.71-1.66,3.71-3.71v-3.68h-7.43Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78341a"
	    },
	    attrs: {
	      "d": "m572.93,783.02c0,1.84-1.5,3.34-3.34,3.34-1.85,0-3.34-1.5-3.34-3.34s1.5-3.34,3.34-3.34c1.84,0,3.34,1.5,3.34,3.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a64724"
	    },
	    attrs: {
	      "d": "m595.4,783.02c0,1.84-1.5,3.34-3.34,3.34s-3.34-1.5-3.34-3.34,1.5-3.34,3.34-3.34c1.84,0,3.34,1.5,3.34,3.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#4f2214"
	    },
	    attrs: {
	      "d": "m571.6,783.02c0,1.11-.9,2-2,2-1.11,0-2-.9-2-2s.9-2,2-2c1.11,0,2,.9,2,2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78341a"
	    },
	    attrs: {
	      "d": "m594.06,783.02c0,1.11-.9,2-2,2-1.11,0-2-.9-2-2,0-1.11.9-2,2-2,1.11,0,2,.9,2,2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78341a"
	    },
	    attrs: {
	      "d": "m592.07,783.07c0,6.28-5.09,11.37-11.37,11.37-6.28,0-11.37-5.09-11.37-11.37v-7.64c0-6.28,5.09-7.78,11.37-7.78,11.81,0,11.37,4.64,11.37,11.37v4.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a64724"
	    },
	    attrs: {
	      "d": "m580.69,767.66v26.79c6.28,0,11.37-5.09,11.37-11.37v-4.04c0-6.73.43-11.37-11.37-11.37Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#000100"
	    },
	    attrs: {
	      "cx": "575.69",
	      "cy": "782.01",
	      "r": "1.32"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#000100"
	    },
	    attrs: {
	      "cx": "586",
	      "cy": "782.01",
	      "r": "1.32"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m577.39,787.6h6.64c.13,0,.24.11.24.24,0,1.44-1.66,2.7-3.56,2.7-2.13,0-3.56-1.4-3.56-2.7,0-.13.11-.24.24-.24Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#000100",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m592.01,779.77c2.87-10.29-4.23-15.15-11.35-15.15-7.12,0-14.21,4.85-11.35,15.15.05-2.16.18-4.79,1.2-6.2,1.7-2.38,5.83-3.94,10.15-3.78,4.32-.16,8.45,1.39,10.15,3.78,1.02,1.41,1.14,4.03,1.2,6.2Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ef7c4e"
	    },
	    attrs: {
	      "d": "m281.87,766.94h7.91v8.17c0,1.76-1.43,3.18-3.18,3.18h-1.55c-1.76,0-3.18-1.43-3.18-3.18v-8.17h0Z",
	      "transform": "translate(571.65 1545.22) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ef7c4e"
	    },
	    attrs: {
	      "d": "m280.8,778.51h8.58c1.7,0,3.08-1.38,3.08-3.08h0c0-1.7-1.38-3.08-3.08-3.08h-8.58s0,6.16,0,6.16Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f8ec68"
	    },
	    attrs: {
	      "d": "m289.97,774.85c.15.15.24.36.24.58,0,.46-.37.82-.82.82-.23,0-.43-.09-.58-.24-.15-.15-.24-.36-.24-.58,0-.23.09-.43.24-.58.15-.15.36-.24.58-.24.23,0,.43.09.58.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ef7c4e"
	    },
	    attrs: {
	      "d": "m287.77,772.38v7.91h-7.39c-2.18,0-3.96-1.77-3.96-3.96h0c0-2.18,1.77-3.96,3.96-3.96h7.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f8ec68"
	    },
	    attrs: {
	      "d": "m279.5,777.21c.23.23.54.36.88.36.69,0,1.24-.56,1.24-1.24,0-.34-.14-.65-.36-.88-.22-.22-.54-.36-.88-.36s-.65.14-.88.36c-.22.22-.36.54-.36.88,0,.34.14.65.36.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ef7c4e"
	    },
	    attrs: {
	      "d": "m281.57,774.06h9.19v6.16h-9.19c-1.37,0-2.48-1.11-2.48-2.48v-1.21c0-1.37,1.11-2.48,2.48-2.48Z",
	      "transform": "translate(-492.22 1062.06) rotate(-90)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f8ec68"
	    },
	    attrs: {
	      "d": "m284.34,780.48c.15.15.36.24.58.24.46,0,.82-.37.82-.82,0-.23-.09-.43-.24-.58s-.36-.24-.58-.24-.43.09-.58.24-.24.36-.24.58c0,.23.09.43.24.58Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f8ec68"
	    },
	    attrs: {
	      "d": "m286.7,770.01c.23.23.36.54.36.88,0,.69-.56,1.24-1.24,1.24-.34,0-.65-.14-.88-.36-.22-.22-.36-.54-.36-.88,0-.34.14-.65.36-.88s.54-.36.88-.36.65.14.88.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".1"
	    },
	    attrs: {
	      "d": "m285.82,766.94c-2.18,0-3.96,1.77-3.96,3.96v.42s-.02,0-.02,0v1.04s6.16,6.16,6.16,6.16h1.38c1.7,0,3.08-1.38,3.08-3.08,0-1.56-1.17-2.84-2.68-3.04v-1.5c0-2.18-1.77-3.96-3.96-3.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m287.25,777.76h0c-.31.31-.81.31-1.12,0l-3.76-3.76c-.31-.31-.31-.81,0-1.12h0c.31-.31.81-.31,1.12,0l3.76,3.76c.31.31.31.81,0,1.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m283.57,774.08h0c-.77.77-2.03.77-2.8,0h0c-.77-.77-.77-2.03,0-2.8h0c.77-.77,2.03-.77,2.8,0h0c.77.77.77,2.03,0,2.8Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#343434",
	      "stroke-linecap": "round",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".53px"
	    },
	    attrs: {
	      "d": "m281.49,764.16c-1.97,1.97-1.97,5.17,0,7.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#343434",
	      "stroke-linecap": "round",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".53px"
	    },
	    attrs: {
	      "d": "m273.64,772c1.97-1.97,5.17-1.97,7.14,0"
	    }
	  })])]), _h('g', [_h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#efac0a"
	    },
	    attrs: {
	      "d": "m559.44,839.92c-1.78,1.78-5.02,1.44-5.02,1.44,0,0-.35-3.24,1.44-5.02,1.78-1.78,5.02-1.44,5.02-1.44,0,0,.35,3.24-1.44,5.02Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m556.21,841.32c.47-.06,1-.17,1.51-.35l-2.91-2.91c-.18.51-.29,1.04-.35,1.51l1.75,1.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m555.85,836.34c-.15.15-.29.32-.41.49l3.51,3.51c.17-.12.34-.26.49-.41.16-.16.31-.34.44-.52l-3.5-3.5c-.18.13-.36.27-.52.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m559.52,834.9c-.56.04-1.24.15-1.91.38l2.88,2.88c.23-.67.34-1.35.38-1.91l-1.35-1.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "opacity": ".1"
	    },
	    attrs: {
	      "d": "m559.44,839.92c.85-.85,1.22-2.03,1.37-3.04.17-.07.34-.18.48-.32.2-.2.33-.44.39-.7.4-.02.79-.18,1.1-.49.66-.66.66-1.72,0-2.37l-8.35,8.35s3.24.35,5.02-1.44Z"
	    }
	  })])]), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m562.77,835.38c-.66.66-1.72.66-2.37,0-.66-.66-.66-1.72,0-2.37.66-.66,1.72-.66,2.37,0,.66.66.66,1.72,0,2.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m561.28,836.57c-.57.57-1.5.57-2.07,0s-.57-1.5,0-2.07,1.5-.57,2.07,0,.57,1.5,0,2.07Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#bfbfbf"
	    },
	    attrs: {
	      "d": "m562.28,838.5c-.38-1.41-1.87-2.23-1.87-2.23,0,0-.88,1.46-.51,2.87.38,1.41,1.22,2.41,1.87,2.23.66-.18.88-1.46.51-2.87Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e5e5e5"
	    },
	    attrs: {
	      "d": "m564.68,840.58c-.55.55-1.51.49-2.7-.69-1.19-1.19-1.59-3.6-1.59-3.6,0,0,2.41.41,3.6,1.59,1.19,1.19,1.25,2.15.69,2.7Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#bfbfbf"
	    },
	    attrs: {
	      "d": "m557.36,833.58c1.41.38,2.23,1.87,2.23,1.87,0,0-1.46.88-2.87.51-1.41-.38-2.41-1.22-2.23-1.87.18-.66,1.46-.88,2.87-.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e5e5e5"
	    },
	    attrs: {
	      "d": "m555.28,831.18c-.55.55-.49,1.51.69,2.7,1.19,1.19,3.6,1.59,3.6,1.59,0,0-.41-2.41-1.59-3.6-1.19-1.19-2.15-1.25-2.7-.69Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#343434",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "stroke-width": ".23px"
	    },
	    attrs: {
	      "d": "m564.68,833.39c-.57-.57-1.49-.57-2.06,0"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#343434",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "stroke-width": ".23px"
	    },
	    attrs: {
	      "d": "m562.39,831.09c.57.57.57,1.49,0,2.06"
	    }
	  })])]), _h('text', {
	    staticStyle: {
	      "fill": "#1e1400",
	      "font-family": "Stencil, Stencil",
	      "font-size": "6.81px"
	    },
	    attrs: {
	      "transform": "translate(321.17 847.52)"
	    }
	  }, [_h('tspan', {
	    staticStyle: {
	      "letter-spacing": "0em"
	    },
	    attrs: {
	      "x": "0",
	      "y": "0"
	    }
	  }, ["c"]), _h('tspan', {
	    attrs: {
	      "x": "3.01",
	      "y": "0"
	    }
	  }, ["ompost"])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#646060"
	    },
	    attrs: {
	      "x": "608.23",
	      "y": "800.52",
	      "width": "31.93",
	      "height": "8.46",
	      "rx": "2.19",
	      "ry": "2.19"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#646060"
	    },
	    attrs: {
	      "d": "m640.08,804.18h-31.89c-4.95,1.65-8.28,6.28-8.28,11.49v51.85c0,4.46,3.62,8.08,8.08,8.08h32.31c4.46,0,8.08-3.62,8.08-8.08v-51.85c0-5.21-3.34-9.84-8.28-11.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".1"
	    },
	    attrs: {
	      "d": "m640.08,804.18h-15.86v71.42h16.06c4.46,0,8.08-3.62,8.08-8.08v-51.85c0-5.21-3.34-9.84-8.28-11.49Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#535050"
	    },
	    attrs: {
	      "x": "597.88",
	      "y": "815.88",
	      "width": "52.5",
	      "height": "8.08",
	      "rx": "2.02",
	      "ry": "2.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#6d6969"
	    },
	    attrs: {
	      "d": "m648.37,815.88h-48.46c-1.12,0-2.02.9-2.02,2.02h52.5c0-1.12-.9-2.02-2.02-2.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#535050"
	    },
	    attrs: {
	      "x": "597.88",
	      "y": "836.07",
	      "width": "52.5",
	      "height": "8.08",
	      "rx": "2.02",
	      "ry": "2.02"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#535050"
	    },
	    attrs: {
	      "x": "597.88",
	      "y": "856.27",
	      "width": "52.5",
	      "height": "8.08",
	      "rx": "2.02",
	      "ry": "2.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#6d6969"
	    },
	    attrs: {
	      "d": "m648.37,836.07h-48.46c-1.12,0-2.02.9-2.02,2.02h52.5c0-1.12-.9-2.02-2.02-2.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#6d6969"
	    },
	    attrs: {
	      "d": "m648.37,856.27h-48.46c-1.12,0-2.02.9-2.02,2.02h52.5c0-1.12-.9-2.02-2.02-2.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#767373"
	    },
	    attrs: {
	      "d": "m640.15,804.14v-1.43c0-1.21-.98-2.19-2.19-2.19h-27.55c-1.21,0-2.19.98-2.19,2.19v1.43h31.93Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#646060"
	    },
	    attrs: {
	      "x": "453.01",
	      "y": "718.62",
	      "width": "182.1",
	      "height": "6.89"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#535050"
	    },
	    attrs: {
	      "x": "270.66",
	      "y": "718.62",
	      "width": "182.1",
	      "height": "6.89"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#767373"
	    },
	    attrs: {
	      "x": "621.66",
	      "y": "725.51",
	      "width": "4.94",
	      "height": "75.02"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#646060"
	    },
	    attrs: {
	      "x": "621.66",
	      "y": "725.51",
	      "width": "2.47",
	      "height": "75.02"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m453.22,638.1c1.24-2.79,4.5-4.05,7.29-2.81s4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m463.33,642.58c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m473.43,647.06c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m483.53,651.54c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m493.63,656.02c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m503.73,660.5c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m513.83,664.98c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m523.94,669.46c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m534.04,673.94c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m544.14,678.42c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m554.24,682.9c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m564.34,687.38c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m574.45,691.86c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m584.55,696.34c1.24-2.79,4.5-4.05,7.29-2.81s4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m594.65,700.82c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m604.75,705.3c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m614.85,709.78c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m624.95,714.26c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m452.86,638.1c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m442.76,642.58c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m432.66,647.06c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m422.56,651.54c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m412.45,656.02c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m402.35,660.5c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m392.25,664.98c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m382.15,669.46c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m372.05,673.94c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m361.95,678.42c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m351.84,682.9c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m341.74,687.38c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m331.64,691.86c-1.24-2.79-4.5-4.05-7.29-2.81s-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m321.54,696.34c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m311.44,700.82c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m301.34,705.3c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m291.23,709.78c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78bb57"
	    },
	    attrs: {
	      "d": "m281.13,714.26c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "school-grounds_inactive"
	    }
	  }, [_h('line', {
	    staticStyle: {
	      "fill": "#9c8865"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "800.52",
	      "x2": "359.6",
	      "y2": "800.52"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "717.05",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "717.05",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "348.24",
	      "y": "717.05",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "348.24",
	      "y": "717.05",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "547.13",
	      "y": "716.87",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "348.22",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "611.97",
	      "y": "716.87",
	      "width": "9.68",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#73532c"
	    },
	    attrs: {
	      "x": "283.39",
	      "y": "800.32",
	      "width": "338.26",
	      "height": "75.55"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9c6d40"
	    },
	    attrs: {
	      "x": "399.9",
	      "y": "836.64",
	      "width": "7.09",
	      "height": "29.93",
	      "transform": "translate(806.88 1703.21) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9c6d40"
	    },
	    attrs: {
	      "x": "489.4",
	      "y": "836.64",
	      "width": "7.09",
	      "height": "29.93",
	      "transform": "translate(985.89 1703.21) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#aa5f3c"
	    },
	    attrs: {
	      "x": "447.92",
	      "y": "717.05",
	      "width": "9.68",
	      "height": "149.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "447.92",
	      "y": "717.05",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "447.91",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "547.11",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "611.97",
	      "y": "716.44",
	      "width": "9.68",
	      "height": "4.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "547.13",
	      "y": "716.87",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "x": "354.44",
	      "y": "833.74",
	      "width": "195.92",
	      "height": "5.84",
	      "transform": "translate(904.81 1673.31) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ac6b41"
	    },
	    attrs: {
	      "x": "354.44",
	      "y": "831.63",
	      "width": "195.92",
	      "height": "4",
	      "transform": "translate(904.81 1667.25) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#856034"
	    },
	    attrs: {
	      "x": "333.74",
	      "y": "865.98",
	      "width": "281.36",
	      "height": "8.3"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m461.03,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m601.2,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m595.78,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m592.59,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m561.42,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m585.85,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m566.71,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m581.24,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m581.24,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "582.86 806.86 595.87 805.63 592.56 816.6 581.24 816.6 582.86 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "579.62 806.86 566.61 805.63 569.92 816.6 581.24 816.6 579.62 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m582.86,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m567.26,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m568.13,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m568.8,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m595.23,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m594.35,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m593.69,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#70461f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m588.36,835.33h-14.12c-2.33,0-4.23-2.26-4.23-5.02v-2.52h22.59v2.52c0,2.76-1.9,5.02-4.23,5.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "582.06",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(1172.19 1693.75) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "572.97",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m590.13,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m581.04,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03s-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m577.32,859.38h-.79s-3.56,0-3.56,0c-.99,2.36-2.27,4.22-1.99,7.07h5.55s.79,0,.79,0h5.55c.28-2.85-.83-4.71-1.82-7.07h-3.73Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m586.4,859.38h-.79s-3.56,0-3.56,0c-.99,2.36-2.27,4.22-1.99,7.07h5.55s.79,0,.79,0h5.55c.28-2.85-.83-4.71-1.82-7.07h-3.73Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9c8865"
	    },
	    attrs: {
	      "x": "283.82",
	      "y": "799.89",
	      "width": "75.35",
	      "height": "76.2",
	      "transform": "translate(1159.49 516.5) rotate(90)"
	    }
	  }), _h('g', [_h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "813.29",
	      "x2": "359.6",
	      "y2": "813.29"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "825.58",
	      "x2": "359.6",
	      "y2": "825.58"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "837.86",
	      "x2": "359.6",
	      "y2": "837.86"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "850.15",
	      "x2": "359.6",
	      "y2": "850.15"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "283.39",
	      "y1": "862.43",
	      "x2": "359.6",
	      "y2": "862.43"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#603914"
	    },
	    attrs: {
	      "x": "318.99",
	      "y": "861.41",
	      "width": "30.09",
	      "height": "12.47",
	      "transform": "translate(668.07 1735.28) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#754d24"
	    },
	    attrs: {
	      "d": "m321.89,816.62h24.29c3.4,0,6.15,2.76,6.15,6.15v33.8c0,5.34-4.34,9.68-9.68,9.68h-17.24c-5.34,0-9.68-4.34-9.68-9.68v-33.8c0-3.4,2.76-6.15,6.15-6.15Z",
	      "transform": "translate(668.07 1682.88) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "x": "311.68",
	      "y": "821.78",
	      "width": "44.7",
	      "height": "4.96",
	      "rx": "1.99",
	      "ry": "1.99",
	      "transform": "translate(668.07 1648.52) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#603914"
	    },
	    attrs: {
	      "x": "315.73",
	      "y": "826.74",
	      "width": "36.6",
	      "height": "3.68",
	      "transform": "translate(668.07 1657.16) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#603914"
	    },
	    attrs: {
	      "x": "327.84",
	      "y": "818.17",
	      "width": "12.39",
	      "height": "2.07",
	      "transform": "translate(668.07 1638.4) rotate(-180)"
	    }
	  }), _h('rect', {
	    attrs: {
	      "x": "349.08",
	      "y": "867.64",
	      "width": "3.9",
	      "height": "9.1",
	      "rx": "1.57",
	      "ry": "1.57",
	      "transform": "translate(702.05 1744.38) rotate(-180)"
	    }
	  }), _h('rect', {
	    attrs: {
	      "x": "315.09",
	      "y": "867.64",
	      "width": "3.9",
	      "height": "9.1",
	      "rx": "1.57",
	      "ry": "1.57",
	      "transform": "translate(634.08 1744.38) rotate(180)"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#9d5837",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "611.97",
	      "y": "716.87",
	      "width": "4.84",
	      "height": "158.81"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#73532c"
	    },
	    attrs: {
	      "points": "635.1 718.62 271.35 718.62 453.22 638.07 635.1 718.62"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "points": "453.22 638.07 453.22 718.62 635.1 718.62 453.22 638.07"
	    }
	  }), _h('g', {
	    staticStyle: {
	      "clip-path": "url(#clippath-1)"
	    }
	  }, [_h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "704.85",
	      "x2": "633.07",
	      "y2": "704.85"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "692.53",
	      "x2": "633.07",
	      "y2": "692.53"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "680.22",
	      "x2": "633.07",
	      "y2": "680.22"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "667.9",
	      "x2": "633.07",
	      "y2": "667.9"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "655.58",
	      "x2": "633.07",
	      "y2": "655.58"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".63px"
	    },
	    attrs: {
	      "x1": "271.78",
	      "y1": "643.26",
	      "x2": "633.07",
	      "y2": "643.26"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#9c8865"
	    },
	    attrs: {
	      "x": "545.89",
	      "y": "799.89",
	      "width": "75.35",
	      "height": "76.2",
	      "transform": "translate(1421.55 254.43) rotate(90)"
	    }
	  }), _h('g', [_h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "813.29",
	      "x2": "621.66",
	      "y2": "813.29"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "825.58",
	      "x2": "621.66",
	      "y2": "825.58"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "837.86",
	      "x2": "621.66",
	      "y2": "837.86"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "850.15",
	      "x2": "621.66",
	      "y2": "850.15"
	    }
	  }), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "mix-blend-mode": "multiply",
	      "opacity": ".3",
	      "stroke": "#9c8865",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".65px"
	    },
	    attrs: {
	      "x1": "545.46",
	      "y1": "862.43",
	      "x2": "621.66",
	      "y2": "862.43"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m262.32,838.59c-.22,5.97,3.3,8.18,8.61,8.61-.48-6.24-3.51-8.88-8.61-8.61Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m271.37,847.2c5.31-.43,8.83-2.65,8.61-8.61-5.1-.27-8.13,2.38-8.61,8.61Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m272.36,855.84v-24.3c0-.65-.53-1.19-1.19-1.19-.66,0-1.19.53-1.19,1.19v24.3c0,.66.53,1.19,1.19,1.19s1.19-.53,1.19-1.19h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m271.11,830.36c-.62.04-1.12.55-1.12,1.18v24.3c0,.63.5,1.15,1.12,1.18v-26.66Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m270.18,829.8c-4.94,11.92-13.02,3.84-1.1-1.1-11.92,4.94-11.92-6.5,0-1.56-11.92-4.94-3.84-13.02,1.1-1.1-4.94-11.92,6.5-11.92,1.56,0,4.94-11.92,13.02-3.84,1.1,1.1,11.92-4.94,11.92,6.5,0,1.56,11.92,4.94,3.84,13.02-1.1,1.1,4.94,11.92-6.5,11.92-1.56,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m270.92,817.1c-1.61.06-3.18,3.03-.73,8.94-4.94-11.92-13.02-3.84-1.1,1.1-11.92-4.94-11.92,6.5,0,1.56-11.92,4.94-3.84,13.02,1.1,1.1-2.45,5.9-.87,8.88.73,8.94v-21.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m270.93,831c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m270.93,824.88c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m277.25,841.47c-.18,4.75,2.62,6.51,6.85,6.85-.38-4.96-2.8-7.07-6.85-6.85Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m284.44,848.32c4.22-.34,7.03-2.11,6.85-6.85-4.05-.21-6.47,1.89-6.85,6.85Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m285.24,855.19v-19.33c0-.52-.42-.95-.95-.95s-.95.43-.95.95v19.33c0,.52.42.95.95.95.52,0,.95-.42.95-.95h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m284.24,834.92c-.5.03-.89.44-.89.94v19.33c0,.5.4.91.89.94v-21.21Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m289.15,838.59c-.22,5.97,3.3,8.18,8.61,8.61-.48-6.24-3.51-8.88-8.61-8.61Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m298.19,847.2c5.31-.43,8.83-2.65,8.61-8.61-5.1-.27-8.13,2.38-8.61,8.61Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m299.19,855.84v-24.3c0-.65-.53-1.19-1.19-1.19-.66,0-1.19.53-1.19,1.19v24.3c0,.66.53,1.19,1.19,1.19s1.19-.53,1.19-1.19h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m297.93,830.36c-.62.04-1.12.55-1.12,1.18v24.3c0,.63.5,1.15,1.12,1.18v-26.66Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m291.32,833.17c1.21-.41,1.11-1.07-.22-1.25,1.27-.65,1.1-1.34-.29-1.27.99-.82.69-1.41-.59-1.11.92-1.05.49-1.62-.78-1.04.65-1.13.17-1.59-.91-.88.45-1.29-.16-1.65-1.14-.63.22-1.32-.4-1.59-1.15-.55-.06-1.34-.76-1.43-1.29-.12-.27-1.34-.95-1.38-1.27-.14-.54-1.2-1.22-1.02-1.23.39-.74-1.17-1.4-.97-1.25.31-.93-.9-1.49-.49-1,.81-1.13-.83-1.68-.4-1.06.75-1.18-.49-1.56.07-.65,1.1-1.37-.37-1.72.25-.69,1.1-1.28-.04-1.44.62-.26,1.24-1.4.16-1.49.87-.19,1.29-1.22.43-1.15,1.09.15,1.25-1.24.66-1.04,1.35.35,1.25-1.01.84-.72,1.44.53,1.14-.89,1.06-.44,1.62.84.99-.67,1.17-.19,1.64.86.93-.43,1.29.2,1.63,1.17.56-.22,1.36.39,1.65,1.12.61.08,1.34.78,1.4,1.3.05.27,1.38.95,1.45,1.27.21.55,1.19,1.22.99,1.22-.46.76,1.22,1.43,1.04,1.28-.24.93.9,1.48.47.96-.87,1.16.88,1.72.46,1.1-.69,1.18.5,1.53-.09.6-1.14,1.4.4,1.77-.2.75-1.07,1.27.04,1.41-.62.19-1.26,1.44-.13,1.55-.84.26-1.28Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m284.22,825.33c-.2.07-.39.35-.53.87-.54-1.2-1.22-1.02-1.23.39-.74-1.17-1.4-.97-1.25.31-.93-.9-1.49-.49-1,.81-1.13-.83-1.68-.4-1.06.75-1.18-.49-1.56.07-.65,1.1-1.37-.37-1.72.25-.69,1.1-1.28-.04-1.44.62-.26,1.24-1.4.16-1.49.87-.19,1.29-1.22.43-1.15,1.09.15,1.25-1.24.66-1.04,1.35.35,1.25-1.01.84-.72,1.44.53,1.14-.89,1.06-.44,1.62.84.99-.67,1.17-.19,1.64.86.93-.43,1.29.2,1.63,1.17.56-.22,1.36.39,1.65,1.12.61.08,1.34.78,1.4,1.3.05.12.6.31.93.52,1.04v-15.68Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m284.25,835.63c-1.35,0-2.44-1.09-2.44-2.44s1.09-2.44,2.44-2.44"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m284.25,830.76c1.35,0,2.44,1.09,2.44,2.44s-1.09,2.44-2.44,2.44"
	    }
	  })])]), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m297.01,829.8c-4.94,11.92-13.02,3.84-1.1-1.1-11.92,4.94-11.92-6.5,0-1.56-11.92-4.94-3.84-13.02,1.1-1.1-4.94-11.92,6.5-11.92,1.56,0,4.94-11.92,13.02-3.84,1.1,1.1,11.92-4.94,11.92,6.5,0,1.56,11.92,4.94,3.84,13.02-1.1,1.1,4.94,11.92-6.5,11.92-1.56,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m297.75,817.1c-1.61.06-3.18,3.03-.73,8.94-4.94-11.92-13.02-3.84-1.1,1.1-11.92-4.94-11.92,6.5,0,1.56-11.92,4.94-3.84,13.02,1.1,1.1-2.45,5.9-.87,8.88.73,8.94v-21.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m297.76,831c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m297.76,824.88c1.69,0,3.06,1.37,3.06,3.06s-1.37,3.06-3.06,3.06"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d19166"
	    },
	    attrs: {
	      "points": "266.61 875.41 301.63 875.41 305.26 854.78 262.98 854.78 266.61 875.41"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#bc7846"
	    },
	    attrs: {
	      "points": "264.22 861.83 262.98 854.78 305.26 854.78 304.02 861.83 264.22 861.83"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#bc7846"
	    },
	    attrs: {
	      "points": "283.96 854.78 283.96 875.41 266.61 875.41 262.98 854.78 283.96 854.78"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d19166"
	    },
	    attrs: {
	      "d": "m259.57,856.97c0,.73.49,1.33,1.09,1.33h46.98c.6,0,1.09-.59,1.09-1.33v-5.3c0-.73-.49-1.33-1.09-1.33h-46.98c-.6,0-1.09.59-1.09,1.33v5.3Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m396.34,795.45c3.72,4.32,7.97,9.77,9.72,13.72.7,1.58,1.05,3.02.91,4.23-.22,1.85-1.27,3.08-3.36,3.47-1.42.26-3.46,0-6.26-.98l1.5-4.35c1.63.57,2.77.82,3.5.83-.08-.35-.24-.81-.48-1.35-1.53-3.43-5.49-8.49-9-12.57l3.48-3.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m373.64,795.45c-3.72,4.32-7.97,9.77-9.72,13.72-.7,1.58-1.05,3.02-.91,4.23.22,1.85,1.27,3.08,3.36,3.47,1.42.26,3.46,0,6.26-.98l-1.5-4.35c-1.63.57-2.77.82-3.5.83.08-.35.24-.81.48-1.35,1.53-3.43,5.49-8.49,9-12.57l-3.48-3.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m370.97,789.72c.41-.26.79-.78.79-1.26v-13.51c0-6.86,5.73-12.42,12.81-12.47h0s.03,0,.05,0c.02,0,.03,0,.05,0h0c7.09.06,12.81,5.62,12.81,12.47v13.51c0,.48.37,1,.79,1.26,1.39.86,2.31,2.37,2.31,4.08,0,2.68-2.25,4.85-5.02,4.85-.36,0-21.52,0-21.88,0-2.77,0-5.02-2.17-5.02-4.85,0-1.71.92-3.22,2.31-4.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m404.94,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m399.53,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m396.34,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m365.17,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "x": "381.16",
	      "y": "790.93",
	      "width": "6.91",
	      "height": "6.96"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m376.95,782.16c0,1.87-1.51,3.38-3.38,3.38-1.87,0-3.38-1.51-3.38-3.38,0-1.87,1.51-3.38,3.38-3.38,1.87,0,3.38,1.51,3.38,3.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m399.05,782.16c0,1.87-1.51,3.38-3.38,3.38-1.87,0-3.38-1.51-3.38-3.38,0-1.87,1.51-3.38,3.38-3.38s3.38,1.51,3.38,3.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m375.6,782.16c0,1.12-.91,2.03-2.03,2.03-1.12,0-2.03-.91-2.03-2.03,0-1.12.91-2.03,2.03-2.03,1.12,0,2.03.91,2.03,2.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m397.7,782.16c0,1.12-.91,2.03-2.03,2.03s-2.03-.91-2.03-2.03c0-1.12.91-2.03,2.03-2.03s2.03.91,2.03,2.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m396.05,781.87c0,6.36-5.15,11.51-11.51,11.51-6.36,0-11.51-5.15-11.51-11.51v-7.73c0-6.36,5.15-7.87,11.51-7.87,11.95,0,11.51,4.7,11.51,11.51v4.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m389.6,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#decc86"
	    },
	    attrs: {
	      "d": "m388.07,795.33c0,1.41-1.55,2.56-3.45,2.56-1.91,0-3.45-1.14-3.45-2.56v-.34h6.91v.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197"
	    },
	    attrs: {
	      "d": "m384.53,766.26h0v27.11c-6.36,0-11.51-5.15-11.51-11.51v-7.73c0-6.36,5.15-7.87,11.51-7.87Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m372.38,776.46l-.06.04c0-7.26,5.5-13.14,12.29-13.14,6.64,0,12.05,5.64,12.27,12.68.08.67.12,1.36.12,2.06,0,.13-.23.53-.24.65-.02.42-4.54-2.21-7.55-6.45-.75.74-3.66,3-7.1,4.42-4.23,1.74-7.55,2.44-8.93,2.43-1.26,0-.89-.93-.89-1.05,0-.56.03-1.11.08-1.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d48963",
	      "opacity": ".8"
	    },
	    attrs: {
	      "d": "m384.53,790.23c-1.12,0-2.21-.47-2.79-1.2-.14-.18-.11-.45.07-.59.18-.14.45-.11.59.07.42.53,1.26.88,2.13.88,1.08,0,1.81-.45,2.13-.87.14-.18.41-.22.59-.08.18.14.22.41.08.59-.58.75-1.63,1.2-2.8,1.2Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "389.81",
	      "cy": "783.62",
	      "r": "1.38"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "379.26",
	      "cy": "783.62",
	      "r": "1.38"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m370.45,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m384.99,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m384.99,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "386.61 806.86 399.62 805.63 396.31 816.6 384.99 816.6 386.61 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "383.36 806.86 370.35 805.63 373.66 816.6 384.99 816.6 383.36 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m386.61,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m371.01,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m371.88,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m372.55,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m398.97,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m398.1,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m397.43,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#70461f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m392.11,835.33h-14.12c-2.33,0-4.23-2.26-4.23-5.02v-2.52h22.59v2.52c0,2.76-1.9,5.02-4.23,5.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "385.81",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(779.68 1693.75) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "376.72",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m393.87,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m384.78,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03s-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m386.65,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m395.74,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m466.67,800.25c2.43,3.13,4.64,6.35,5.78,8.93.7,1.58,1.05,3.02.91,4.23-.22,1.85-1.27,3.08-3.36,3.47-1.42.26-3.46,0-6.26-.98l1.5-4.35c1.63.57,2.77.82,3.5.83-.08-.35-.24-.81-.48-1.35-1.01-2.28-3.1-5.28-5.42-8.23-1.17-1.49,2.55-4.21,3.84-2.55Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m436.03,800.34c-2.4,3.1-4.58,6.28-5.71,8.83-.7,1.58-1.05,3.02-.91,4.23.22,1.85,1.27,3.08,3.36,3.47,1.42.26,3.46,0,6.26-.98l-1.5-4.35c-1.63.57-2.77.82-3.5.83.08-.35.24-.81.48-1.35,1.03-2.31,3.15-5.35,5.51-8.34,1.14-1.45-2.69-4.04-4-2.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m471.34,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m465.92,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m462.74,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m431.57,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m456,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m451.38,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m451.38,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "453.01 806.86 466.02 805.63 462.71 816.6 451.38 816.6 453.01 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "449.76 806.86 436.75 805.63 440.06 816.6 451.38 816.6 449.76 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m453.01,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m437.41,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m438.28,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m438.94,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m465.37,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m464.5,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m463.83,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#70461f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m458.5,835.87h-14.12c-2.33,0-4.23-2.42-4.23-5.38v-2.7h22.59v2.7c0,2.96-1.9,5.38-4.23,5.38Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "453.99",
	      "y": "831.04",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(916.04 1695.15) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "441.33",
	      "y": "831.04",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m459.07,781.11c0,1.68,1.36,3.05,3.05,3.05,1.68,0,3.05-1.36,3.05-3.05,0-1.68-1.36-3.05-3.05-3.05-1.68,0-3.05,1.36-3.05,3.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197"
	    },
	    attrs: {
	      "d": "m436.5,781.11c0,1.68,1.36,3.05,3.05,3.05,1.68,0,3.05-1.36,3.05-3.05s-1.36-3.05-3.05-3.05c-1.68,0-3.05,1.36-3.05,3.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m460.29,781.11c0,1.01.82,1.83,1.83,1.83,1.01,0,1.83-.82,1.83-1.83s-.82-1.83-1.83-1.83c-1.01,0-1.83.82-1.83,1.83Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d9c883"
	    },
	    attrs: {
	      "d": "m437.72,781.11c0,1.01.82,1.83,1.83,1.83,1.01,0,1.83-.82,1.83-1.83,0-1.01-.82-1.83-1.83-1.83-1.01,0-1.83.82-1.83,1.83Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#decc86"
	    },
	    attrs: {
	      "x": "447.69",
	      "y": "786.42",
	      "width": "6.26",
	      "height": "8.81"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#decc86",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m450.82,798.27c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13-3.13,1.41-3.13,3.13,1.41,3.13,3.13,3.13h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m450.82,763.65h0c6.21,0,11.29,5,11.29,11.12v8.89c0,6.11-5.08,11.12-11.29,11.12h0c-6.21,0-11.29-5-11.29-11.12v-8.89c0-6.11,5.08-11.12,11.29-11.12h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m450.82,763.65v31.13c6.21,0,11.29-5,11.29-11.12v-8.89c0-6.11-5.08-11.12-11.29-11.12Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "445.93",
	      "cy": "781.4",
	      "r": "1.26"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "455.76",
	      "cy": "781.4",
	      "r": "1.26"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m447.57,787.1h6.52c.13,0,.23.1.23.23,0,1.41-1.63,2.65-3.49,2.65-2.09,0-3.49-1.37-3.49-2.65,0-.13.1-.23.23-.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#713b27",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m462.1,781.34c-.71-6-1.07-6.08-1.42-6.61-2.41-3.28-15.13-3.75-16.1-6.25-4.17,4.08-5,12.77-5,12.77-1.47-6.42.53-14.13,4-15.87-.73-1.09-1.33-2.14-.61-4.44,1.06,1.28,1.7,1.87,3.76,3.39-1.23-1.24-2.54-3.48-1.87-6.17.55.88,3.52,3.51,4.82,4.81-.72-1.85-.68-2.27-.65-3.08,10.21,6.13,15.06,8.14,13.07,21.45Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m451.27,865.99c-.07-2.23-1.01-3.89-1.86-5.91h-8.09c-.85,2.02-1.91,3.68-2.02,5.91h11.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m463.92,865.99c-.07-2.23-1.01-3.89-1.86-5.91h-8.09c-.85,2.02-1.91,3.68-2.02,5.91h11.96Z"
	    }
	  })]), _h('g', [_h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m531.22,799.3c2.72,3.42,5.27,7.03,6.53,9.87.7,1.58,1.05,3.02.91,4.23-.22,1.85-1.27,3.08-3.36,3.47-1.42.26-3.46,0-6.26-.98l1.5-4.35c1.63.57,2.77.82,3.5.83-.08-.35-.24-.81-.48-1.35-1.04-2.33-3.19-5.41-5.57-8.42-1.12-1.42,2.19-4.64,3.25-3.31Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m501.45,800.18c-2.45,3.15-4.68,6.4-5.84,9-.7,1.58-1.05,3.02-.91,4.23.22,1.85,1.27,3.08,3.36,3.47,1.42.26,3.46,0,6.26-.98l-1.5-4.35c-1.63.57-2.77.82-3.5.83.08-.35.24-.81.48-1.35,1.03-2.33,3.19-5.4,5.56-8.41,1.13-1.43-2.65-4.08-3.92-2.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m536.63,806.82l-6.1,2.45c-1.3-3.01-4.9-3.8-6.09-6.43-.79-1.74-.41-5.35-1.03-7.46,4.53-.17,9.9,4.37,13.7,9.86.39.56.15,1.33-.48,1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m531.22,808.46l.8,2.61c.29,1.19-1.51,1.64-1.8.44l-.81-2.61c-.28-1.05,1.44-1.77,1.81-.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m528.03,830.35h-22.59v-30.22c0-2.06,1.2-3.79,2.99-4.55.61-.17,1.42-.22,2.11-.22l12.2-.03c.71,0,1.58.14,2.28.21,1.76.78,3.01,2.55,3.01,4.59v30.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m496.86,806.88l5.96,2.39c1.3-3.01,4.9-3.8,6.09-6.43.79-1.74.41-5.35,1.03-7.46-4.5-.16-9.82,4.3-13.62,9.74-.43.62-.17,1.48.53,1.76Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m521.29,795.34l-.84,4.7c-.11.58-.76.86-1.26.55l-3.09-1.9-3.09,1.9c-.5.31-1.15.02-1.26-.55l-.85-4.7h10.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m502.14,808.46l-.8,2.61c-.29,1.19,1.51,1.64,1.8.44l.81-2.61c.28-1.05-1.44-1.77-1.81-.44Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.68,807.49c1.6-4.22,11.56-2.25,13.96-2.82-.14.63-.32.95-.19,1.65.12.71-13.15,1.56-13.18,1.37-.03-.19-.52.16-.59-.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.68,807.49c-1.6-4.22-11.56-2.25-13.96-2.82.14.63.32.95.19,1.65-.12.71,13.15,1.56,13.18,1.37.03-.19.52.16.59-.21Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "518.3 806.86 531.31 805.63 528 816.6 516.68 816.6 518.3 806.86"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "515.05 806.86 502.04 805.63 505.35 816.6 516.68 816.6 515.05 806.86"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m518.3,806.86l-.74,9.74h-.89s-.89,0-.89,0c-.3-3.25-.43-6.49-.74-9.74,1.04.84,2.21.84,3.24,0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m502.7,812.29l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m503.57,814.06l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m504.24,815.92l4.33-1.93c.51-.22.74-.82.51-1.32h0c-.22-.51-.82-.74-1.32-.51l-4.33,1.93c-.51.22-.74.82-.51,1.32h0c.22.51.82.74,1.32.51Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m530.66,812.29l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m529.79,814.06l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m529.12,815.92l-4.33-1.93c-.51-.22-.74-.82-.51-1.32h0c.22-.51.82-.74,1.32-.51l4.33,1.93c.51.22.74.82.51,1.32h0c-.22.51-.82.74-1.32.51Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#70461f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m523.79,835.33h-14.12c-2.33,0-4.23-2.26-4.23-5.02v-2.52h22.59v2.52c0,2.76-1.9,5.02-4.23,5.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "517.5",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "3.24",
	      "ry": "3.24",
	      "transform": "translate(1043.06 1693.75) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "x": "508.41",
	      "y": "830.34",
	      "width": "8.06",
	      "height": "33.07",
	      "rx": "4.03",
	      "ry": "4.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m525.56,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03-2.22,0-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.47,855.47v3.9c0,2.22-1.81,4.03-4.03,4.03s-4.03-1.81-4.03-4.03v-3.9h8.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m518.34,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m527.43,866.01c.06-2.48-.95-4.23-1.86-6.4h-8.09c-.91,2.16-2.06,3.92-2.03,6.4h11.97Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#4c3322"
	    },
	    attrs: {
	      "d": "m500.04,781.46c0,7.41,7.05,12.16,15.74,12.16,8.69,0,15.74-4.75,15.74-12.16,0-7.41-4.9-18.3-15.74-18.3-11,0-15.74,10.89-15.74,18.3Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e0b268"
	    },
	    attrs: {
	      "x": "512.85",
	      "y": "786.03",
	      "width": "6.44",
	      "height": "9.06"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e0b268",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m516.07,798.23c-1.78,0-3.22-1.44-3.22-3.22,0-1.77,1.44-3.22,3.22-3.22,1.77,0,3.22,1.45,3.22,3.22,0,1.78-1.45,3.22-3.22,3.22h0Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m504.29,782.23c0,6.36,5.16,11.52,11.52,11.52,6.37,0,11.52-5.16,11.52-11.52v-7.74c0-6.37-5.16-7.88-11.52-7.88-11.96,0-11.52,4.7-11.52,11.52v4.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ecbb6d",
	      "opacity": ".8"
	    },
	    attrs: {
	      "d": "m515.81,766.61v27.14c-6.36,0-11.52-5.16-11.52-11.52v-4.1c0-6.82-.44-11.52,11.52-11.52Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#4c3322"
	    },
	    attrs: {
	      "d": "m504.06,775.04c0-6.53,5.29-11.83,11.83-11.83,6.39,0,11.6,5.07,11.81,11.42.08.6-.15,3.52-.36,4.16,0,0-3.87-1.75-7.01-7.52-.72.67-3.76,3.38-6.9,4.37-3.11.98-5.36.83-6.96.83l-2.17,2.33h-.25c-.1-.02.02-3.75.02-3.75Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "521.24",
	      "cy": "781.98",
	      "r": "1.42"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#694932"
	    },
	    attrs: {
	      "cx": "510.19",
	      "cy": "781.98",
	      "r": "1.42"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m519.29,786.61h-7.11c-.14,0-.25.11-.25.25,0,1.54,1.78,2.89,3.81,2.89,2.28,0,3.81-1.5,3.81-2.89,0-.14-.11-.25-.25-.25Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#6e2f16"
	    },
	    attrs: {
	      "d": "m576.95,790.93v3.68c0,2.05,1.66,3.71,3.71,3.71s3.71-1.66,3.71-3.71v-3.68h-7.43Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78341a"
	    },
	    attrs: {
	      "d": "m572.93,783.02c0,1.84-1.5,3.34-3.34,3.34-1.85,0-3.34-1.5-3.34-3.34s1.5-3.34,3.34-3.34c1.84,0,3.34,1.5,3.34,3.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a64724"
	    },
	    attrs: {
	      "d": "m595.4,783.02c0,1.84-1.5,3.34-3.34,3.34s-3.34-1.5-3.34-3.34,1.5-3.34,3.34-3.34c1.84,0,3.34,1.5,3.34,3.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#4f2214"
	    },
	    attrs: {
	      "d": "m571.6,783.02c0,1.11-.9,2-2,2-1.11,0-2-.9-2-2s.9-2,2-2c1.11,0,2,.9,2,2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78341a"
	    },
	    attrs: {
	      "d": "m594.06,783.02c0,1.11-.9,2-2,2-1.11,0-2-.9-2-2,0-1.11.9-2,2-2,1.11,0,2,.9,2,2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78341a"
	    },
	    attrs: {
	      "d": "m592.07,783.07c0,6.28-5.09,11.37-11.37,11.37-6.28,0-11.37-5.09-11.37-11.37v-7.64c0-6.28,5.09-7.78,11.37-7.78,11.81,0,11.37,4.64,11.37,11.37v4.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a64724"
	    },
	    attrs: {
	      "d": "m580.69,767.66v26.79c6.28,0,11.37-5.09,11.37-11.37v-4.04c0-6.73.43-11.37-11.37-11.37Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#000100"
	    },
	    attrs: {
	      "cx": "575.69",
	      "cy": "782.01",
	      "r": "1.32"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#000100"
	    },
	    attrs: {
	      "cx": "586",
	      "cy": "782.01",
	      "r": "1.32"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m577.39,787.6h6.64c.13,0,.24.11.24.24,0,1.44-1.66,2.7-3.56,2.7-2.13,0-3.56-1.4-3.56-2.7,0-.13.11-.24.24-.24Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#000100",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m592.01,779.77c2.87-10.29-4.23-15.15-11.35-15.15-7.12,0-14.21,4.85-11.35,15.15.05-2.16.18-4.79,1.2-6.2,1.7-2.38,5.83-3.94,10.15-3.78,4.32-.16,8.45,1.39,10.15,3.78,1.02,1.41,1.14,4.03,1.2,6.2Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "d": "m281.87,766.94h7.91v8.17c0,1.76-1.43,3.18-3.18,3.18h-1.55c-1.76,0-3.18-1.43-3.18-3.18v-8.17h0Z",
	      "transform": "translate(571.65 1545.22) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "d": "m280.8,778.51h8.58c1.7,0,3.08-1.38,3.08-3.08h0c0-1.7-1.38-3.08-3.08-3.08h-8.58s0,6.16,0,6.16Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m289.97,774.85c.15.15.24.36.24.58,0,.46-.37.82-.82.82-.23,0-.43-.09-.58-.24-.15-.15-.24-.36-.24-.58,0-.23.09-.43.24-.58.15-.15.36-.24.58-.24.23,0,.43.09.58.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "d": "m287.77,772.38v7.91h-7.39c-2.18,0-3.96-1.77-3.96-3.96h0c0-2.18,1.77-3.96,3.96-3.96h7.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m279.5,777.21c.23.23.54.36.88.36.69,0,1.24-.56,1.24-1.24,0-.34-.14-.65-.36-.88-.22-.22-.54-.36-.88-.36s-.65.14-.88.36c-.22.22-.36.54-.36.88,0,.34.14.65.36.88Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8c633a"
	    },
	    attrs: {
	      "d": "m281.57,774.06h9.19v6.16h-9.19c-1.37,0-2.48-1.11-2.48-2.48v-1.21c0-1.37,1.11-2.48,2.48-2.48Z",
	      "transform": "translate(-492.22 1062.06) rotate(-90)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m284.34,780.48c.15.15.36.24.58.24.46,0,.82-.37.82-.82,0-.23-.09-.43-.24-.58s-.36-.24-.58-.24-.43.09-.58.24-.24.36-.24.58c0,.23.09.43.24.58Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m286.7,770.01c.23.23.36.54.36.88,0,.69-.56,1.24-1.24,1.24-.34,0-.65-.14-.88-.36-.22-.22-.36-.54-.36-.88,0-.34.14-.65.36-.88s.54-.36.88-.36.65.14.88.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m287.25,777.76h0c-.31.31-.81.31-1.12,0l-3.76-3.76c-.31-.31-.31-.81,0-1.12h0c.31-.31.81-.31,1.12,0l3.76,3.76c.31.31.31.81,0,1.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m283.57,774.08h0c-.77.77-2.03.77-2.8,0h0c-.77-.77-.77-2.03,0-2.8h0c.77-.77,2.03-.77,2.8,0h0c.77.77.77,2.03,0,2.8Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#432918",
	      "stroke-linecap": "round",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".53px"
	    },
	    attrs: {
	      "d": "m281.49,764.16c-1.97,1.97-1.97,5.17,0,7.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#432918",
	      "stroke-linecap": "round",
	      "stroke-miterlimit": "10",
	      "stroke-width": ".53px"
	    },
	    attrs: {
	      "d": "m273.64,772c1.97-1.97,5.17-1.97,7.14,0"
	    }
	  })])]), _h('g', [_h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m559.44,839.92c-1.78,1.78-5.02,1.44-5.02,1.44,0,0-.35-3.24,1.44-5.02,1.78-1.78,5.02-1.44,5.02-1.44,0,0,.35,3.24-1.44,5.02Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m556.21,841.32c.47-.06,1-.17,1.51-.35l-2.91-2.91c-.18.51-.29,1.04-.35,1.51l1.75,1.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m555.85,836.34c-.15.15-.29.32-.41.49l3.51,3.51c.17-.12.34-.26.49-.41.16-.16.31-.34.44-.52l-3.5-3.5c-.18.13-.36.27-.52.44Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "d": "m559.52,834.9c-.56.04-1.24.15-1.91.38l2.88,2.88c.23-.67.34-1.35.38-1.91l-1.35-1.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#343434",
	      "opacity": ".1"
	    },
	    attrs: {
	      "d": "m559.44,839.92c.85-.85,1.22-2.03,1.37-3.04.17-.07.34-.18.48-.32.2-.2.33-.44.39-.7.4-.02.79-.18,1.1-.49.66-.66.66-1.72,0-2.37l-8.35,8.35s3.24.35,5.02-1.44Z"
	    }
	  })])]), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m562.77,835.38c-.66.66-1.72.66-2.37,0s-.66-1.72,0-2.37c.66-.66,1.72-.66,2.37,0s.66,1.72,0,2.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m561.28,836.57c-.57.57-1.5.57-2.07,0-.57-.57-.57-1.5,0-2.07.57-.57,1.5-.57,2.07,0,.57.57.57,1.5,0,2.07Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#bfbfbf"
	    },
	    attrs: {
	      "d": "m562.28,838.5c-.38-1.41-1.87-2.23-1.87-2.23,0,0-.88,1.46-.51,2.87.38,1.41,1.22,2.41,1.87,2.23.66-.18.88-1.46.51-2.87Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e5e5e5"
	    },
	    attrs: {
	      "d": "m564.68,840.58c-.55.55-1.51.49-2.7-.69-1.19-1.19-1.59-3.6-1.59-3.6,0,0,2.41.41,3.6,1.59,1.19,1.19,1.25,2.15.69,2.7Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#bfbfbf"
	    },
	    attrs: {
	      "d": "m557.36,833.58c1.41.38,2.23,1.87,2.23,1.87,0,0-1.46.88-2.87.51-1.41-.38-2.41-1.22-2.23-1.87.18-.66,1.46-.88,2.87-.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e5e5e5"
	    },
	    attrs: {
	      "d": "m555.28,831.18c-.55.55-.49,1.51.69,2.7,1.19,1.19,3.6,1.59,3.6,1.59,0,0-.41-2.41-1.59-3.6-1.19-1.19-2.15-1.25-2.7-.69Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#343434",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "stroke-width": ".23px"
	    },
	    attrs: {
	      "d": "m564.68,833.39c-.57-.57-1.49-.57-2.06,0"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#343434",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "stroke-width": ".23px"
	    },
	    attrs: {
	      "d": "m562.39,831.09c.57.57.57,1.49,0,2.06"
	    }
	  })])]), _h('text', {
	    staticStyle: {
	      "fill": "#1e1400",
	      "font-family": "Stencil, Stencil",
	      "font-size": "6.81px"
	    },
	    attrs: {
	      "transform": "translate(321.17 847.52)"
	    }
	  }, [_h('tspan', {
	    staticStyle: {
	      "letter-spacing": "0em"
	    },
	    attrs: {
	      "x": "0",
	      "y": "0"
	    }
	  }, ["c"]), _h('tspan', {
	    attrs: {
	      "x": "3.01",
	      "y": "0"
	    }
	  }, ["ompost"])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#7b695e"
	    },
	    attrs: {
	      "x": "608.23",
	      "y": "800.52",
	      "width": "31.93",
	      "height": "8.46",
	      "rx": "2.19",
	      "ry": "2.19"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7b695e"
	    },
	    attrs: {
	      "d": "m640.08,804.18h-31.89c-4.95,1.65-8.28,6.28-8.28,11.49v51.85c0,4.46,3.62,8.08,8.08,8.08h32.31c4.46,0,8.08-3.62,8.08-8.08v-51.85c0-5.21-3.34-9.84-8.28-11.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".1"
	    },
	    attrs: {
	      "d": "m640.08,804.18h-15.86v71.42h16.06c4.46,0,8.08-3.62,8.08-8.08v-51.85c0-5.21-3.34-9.84-8.28-11.49Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "597.88",
	      "y": "815.88",
	      "width": "52.5",
	      "height": "8.08",
	      "rx": "2.02",
	      "ry": "2.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#857469"
	    },
	    attrs: {
	      "d": "m648.37,815.88h-48.46c-1.12,0-2.02.9-2.02,2.02h52.5c0-1.12-.9-2.02-2.02-2.02Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "597.88",
	      "y": "836.07",
	      "width": "52.5",
	      "height": "8.08",
	      "rx": "2.02",
	      "ry": "2.02"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "597.88",
	      "y": "856.27",
	      "width": "52.5",
	      "height": "8.08",
	      "rx": "2.02",
	      "ry": "2.02"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#857469"
	    },
	    attrs: {
	      "d": "m648.37,836.07h-48.46c-1.12,0-2.02.9-2.02,2.02h52.5c0-1.12-.9-2.02-2.02-2.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#857469"
	    },
	    attrs: {
	      "d": "m648.37,856.27h-48.46c-1.12,0-2.02.9-2.02,2.02h52.5c0-1.12-.9-2.02-2.02-2.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#8e7f75"
	    },
	    attrs: {
	      "d": "m640.15,804.14v-1.43c0-1.21-.98-2.19-2.19-2.19h-27.55c-1.21,0-2.19.98-2.19,2.19v1.43h31.93Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#7b695e"
	    },
	    attrs: {
	      "x": "453.01",
	      "y": "718.62",
	      "width": "182.1",
	      "height": "6.89"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "270.66",
	      "y": "718.62",
	      "width": "182.1",
	      "height": "6.89"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#8e7f75"
	    },
	    attrs: {
	      "x": "621.66",
	      "y": "725.51",
	      "width": "4.94",
	      "height": "75.02"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#7b695e"
	    },
	    attrs: {
	      "x": "621.66",
	      "y": "725.51",
	      "width": "2.47",
	      "height": "75.02"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m453.22,638.1c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m463.33,642.58c1.24-2.79,4.5-4.05,7.29-2.81s4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m473.43,647.06c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m483.53,651.54c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m493.63,656.02c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m503.73,660.5c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m513.83,664.98c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m523.94,669.46c1.24-2.79,4.5-4.05,7.29-2.81s4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m534.04,673.94c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m544.14,678.42c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m554.24,682.9c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m564.34,687.38c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m574.45,691.86c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m584.55,696.34c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m594.65,700.82c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m604.75,705.3c1.24-2.79,4.5-4.05,7.29-2.81s4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m614.85,709.78c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m624.95,714.26c1.24-2.79,4.5-4.05,7.29-2.81,2.79,1.24,4.05,4.5,2.81,7.29"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m452.86,638.1c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m442.76,642.58c-1.24-2.79-4.5-4.05-7.29-2.81s-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m432.66,647.06c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m422.56,651.54c-1.24-2.79-4.5-4.05-7.29-2.81s-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m412.45,656.02c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m402.35,660.5c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m392.25,664.98c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m382.15,669.46c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m372.05,673.94c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m361.95,678.42c-1.24-2.79-4.5-4.05-7.29-2.81s-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m351.84,682.9c-1.24-2.79-4.5-4.05-7.29-2.81s-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m341.74,687.38c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m331.64,691.86c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m321.54,696.34c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m311.44,700.82c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m301.34,705.3c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m291.23,709.78c-1.24-2.79-4.5-4.05-7.29-2.81-2.79,1.24-4.05,4.5-2.81,7.29"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m281.13,714.26c-1.24-2.79-4.5-4.05-7.29-2.81s-4.05,4.5-2.81,7.29"
	    }
	  })])])]), _h('g', {
	    attrs: {
	      "id": "scene_classroom"
	    }
	  }, [_h('rect', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "id": "classroom_rectangle",
	      "x": "672.6",
	      "y": "143.27",
	      "width": "323.7",
	      "height": "243.26"
	    }
	  }), _h('g', {
	    attrs: {
	      "id": "classroom_complete"
	    }
	  }, [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#27231f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "787.89",
	      "y": "284.44",
	      "width": "194.04",
	      "height": "2.37"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "787.84",
	      "y": "142.5",
	      "width": "194.13",
	      "height": "142.78"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfdfdf"
	    },
	    attrs: {
	      "x": "745.39",
	      "y": "205.39",
	      "width": "122.48",
	      "height": "30.63",
	      "transform": "translate(1027.33 -585.93) rotate(90)"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#748fc9"
	    },
	    attrs: {
	      "x": "791.32",
	      "y": "145.55",
	      "width": "187.18",
	      "height": "9.7"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c8d1ec",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "793.62 147.64 841.43 147.64 841.43 153.21 793.62 153.21 793.62 147.64 793.62 147.64"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#809ad0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "976.54 153.19 970.88 153.19 970.88 147.53 976.54 147.53 976.54 153.19 976.54 153.19"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#809ad0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "970.08 153.19 964.42 153.19 964.42 147.53 970.08 147.53 970.08 153.19 970.08 153.19"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#809ad0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "963.61 153.19 957.95 153.19 957.95 147.53 963.61 147.53 963.61 153.19 963.61 153.19"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c8d1ec",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "972.08 151.47 973.33 150.22 972.08 148.97 972.56 148.5 973.81 149.75 975.06 148.5 975.53 148.97 974.28 150.22 975.53 151.47 975.06 151.95 973.81 150.7 972.56 151.95 972.08 151.47 972.08 151.47"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c8d1ec",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "958.73 151.66 962.94 151.66 962.94 152.33 958.73 152.33 958.73 151.66 958.73 151.66"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#c8d1ec",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "965.16 152.33 969.26 152.33 969.26 149.86 965.16 149.86 965.16 152.33 965.16 152.33"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#8fc044"
	    },
	    attrs: {
	      "d": "m685.42,278.5s-2.57,2.85-2.43,6.24c.14,3.38,2.93,6.01,2.93,6.01,0,0,2.57-2.85,2.43-6.24-.14-3.38-2.93-6.01-2.93-6.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7eb139"
	    },
	    attrs: {
	      "d": "m679.63,284.86s.15,2.61,1.86,4.16c1.71,1.55,4.32,1.46,4.32,1.46,0,0-.15-2.61-1.86-4.16-1.71-1.55-4.32-1.46-4.32-1.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7eb139"
	    },
	    attrs: {
	      "d": "m687.96,286.32c-1.71,1.55-1.86,4.16-1.86,4.16,0,0,2.61.09,4.32-1.46,1.71-1.55,1.86-4.16,1.86-4.16,0,0-2.61-.09-4.32,1.46Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d17e48"
	    },
	    attrs: {
	      "points": "682.53 299.63 689.68 299.63 691.77 290.49 680.44 290.49 682.53 299.63"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#e6d9d6"
	    },
	    attrs: {
	      "x": "672.52",
	      "y": "305.52",
	      "width": "7.71",
	      "height": "79.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#845454"
	    },
	    attrs: {
	      "x": "672.52",
	      "y": "383.35",
	      "width": "7.71",
	      "height": "2.13"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fef1ee"
	    },
	    attrs: {
	      "x": "667.76",
	      "y": "299.41",
	      "width": "164.74",
	      "height": "6.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e6d9d6"
	    },
	    attrs: {
	      "x": "672.47",
	      "y": "305.52",
	      "width": "152.34",
	      "height": "39.62"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e6d9d6"
	    },
	    attrs: {
	      "x": "818.6",
	      "y": "305.52",
	      "width": "7.71",
	      "height": "79.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#231f20",
	      "opacity": ".22"
	    },
	    attrs: {
	      "x": "672.47",
	      "y": "305.52",
	      "width": "153.84",
	      "height": "3.06"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#845454"
	    },
	    attrs: {
	      "x": "818.6",
	      "y": "383.35",
	      "width": "7.71",
	      "height": "2.13"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "d": "m768.88,229.29c0,2.43,1.97,4.4,4.4,4.4s4.4-1.97,4.4-4.4-1.97-4.4-4.4-4.4c-2.43,0-4.4,1.97-4.39,4.4Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "d": "m770.63,229.29c0,1.46,1.18,2.64,2.64,2.64,1.46,0,2.64-1.18,2.64-2.64,0-1.46-1.18-2.64-2.64-2.64-1.46,0-2.64,1.18-2.64,2.64Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "d": "m806.53,229.29c0,2.43,1.97,4.4,4.4,4.4s4.4-1.97,4.4-4.4-1.97-4.4-4.4-4.4c-2.43,0-4.4,1.97-4.39,4.4Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d4a15e"
	    },
	    attrs: {
	      "d": "m808.29,229.29c0,1.46,1.18,2.64,2.64,2.64,1.46,0,2.64-1.18,2.64-2.64,0-1.46-1.18-2.64-2.64-2.64-1.46,0-2.64,1.18-2.64,2.64Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "785.23",
	      "y": "265.23",
	      "width": "13.43",
	      "height": "36.62"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "x": "775.75",
	      "y": "291.94",
	      "width": "32.38",
	      "height": "2.78"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#452211"
	    },
	    attrs: {
	      "cx": "792.18",
	      "cy": "201.63",
	      "r": "14.4",
	      "transform": "translate(-24.87 176.39) rotate(-12.51)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m799.4,245.98h-14.77s0,13.32,0,13.32c0,9.77,14.77,9.77,14.77,0v-13.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m792.18,201.63c4.73.1,18.98.56,19.22,17.17.25,16.61-3.31,22.7-5.55,25.19-2.24,2.48-4.58,4.73-9.18,5.93-1.2,1.2-2.47,1.66-4.49,1.92-2.02-.26-3.29-.72-4.49-1.92-4.6-1.19-6.94-3.44-9.18-5.93-2.24-2.48-5.8-8.58-5.55-25.19.25-16.61,14.49-17.07,19.22-17.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m792.18,201.63c4.73.1,18.98.56,19.22,17.17.25,16.61-3.31,22.7-5.55,25.19-2.24,2.48-4.58,4.73-9.18,5.93-1.2,1.2-2.47,1.66-4.49,1.92v-50.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m802.49,211.05c1.88,3.86,1.73,10.01,9.11,13.99,4.9-18.09-7.78-26.46-19.95-26.2-12.87.28-24.47,8.96-20.78,26.73,8.62-1.81,13.2-6.15,17.32-10.97-1.37,4.11-4.06,6.17-3.35,6,8.3-2.01,11.27-2.48,17.64-9.56Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "d": "m846.54,236.37l-4.01.79.59,2.54,3.9-.77c.7-.13,1.17-.81,1.04-1.52-.13-.7-.82-1.17-1.52-1.04Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "cx": "843.44",
	      "cy": "240.46",
	      "r": "3.41"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "points": "839.36 250.18 846.13 243.13 840.94 238.18 834.17 245.23 839.36 250.18"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "835.23 242.63 841.7 248.43 838.08 252.57 832.09 246.23 835.23 242.63"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ea5232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m802.42,376.9c-6.06,0-1.75,0-7.81,0-1.02,2.91-.63,5.51-.04,8.72h1.97s0-1.22,0-1.22c0-.83.68-1.51,1.51-1.51h0c.83,0,1.51.68,1.51,1.51v1.22s11.9,0,11.9,0c.03-1.98-1.18-3.53-2.69-4.78-2.1-1.75-5.57-2.93-6.35-3.93Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m794.5,301.85h9.01s-.62,75.06-.62,75.06c.77,1,3.75,2.18,5.85,3.91-5.13.93-10.36-.35-14.13-3.91l-.11-38.12v-36.93Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ea5232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m781.46,376.9c6.06,0,1.75,0,7.81,0,1.02,2.91.63,5.51.04,8.72h-1.97v-1.22c0-.83-.68-1.51-1.51-1.51h0c-.83,0-1.51.68-1.51,1.51v1.22h-11.9c-.03-1.98,1.18-3.53,2.69-4.78,2.1-1.75,5.57-2.93,6.35-3.93Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m789.38,301.85h-9.01s.62,75.06.62,75.06c-.77,1-3.75,2.18-5.85,3.91,5.13.93,10.36-.35,14.13-3.91l.11-38.12v-36.93Z"
	    }
	  })])]), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#936037",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "stroke-width": "1.09px"
	    },
	    attrs: {
	      "x1": "852.76",
	      "y1": "184.34",
	      "x2": "844.75",
	      "y2": "252.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "x": "840.37",
	      "y": "239.33",
	      "width": "8.43",
	      "height": "2.45",
	      "rx": ".76",
	      "ry": ".76",
	      "transform": "translate(1655.89 576.67) rotate(-173.39)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "x": "840.11",
	      "y": "241.72",
	      "width": "8.43",
	      "height": "2.45",
	      "rx": ".76",
	      "ry": ".76",
	      "transform": "translate(1655.1 581.39) rotate(-173.39)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "x": "839.79",
	      "y": "244.09",
	      "width": "8.43",
	      "height": "2.45",
	      "rx": ".76",
	      "ry": ".76",
	      "transform": "translate(1654.18 586.07) rotate(-173.39)"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9acdcd"
	    },
	    attrs: {
	      "d": "m795.22,262.59l-.24.43s.13.07.24.13v-.56Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9acdcd"
	    },
	    attrs: {
	      "d": "m833.38,244.01c-11.64,14.2-23.71,13.62-29.8,12.05v9.8c1.92.35,4.11.58,6.51.57,7.94-.04,19.7-2.92,30.71-16.34l-7.42-6.08Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#699"
	    },
	    attrs: {
	      "x": "775.75",
	      "y": "294.72",
	      "width": "32.38",
	      "height": "46.43"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9acdcd",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m809.69,302.31v-38.62c0-4.2-3.34-7.66-7.5-7.85h0s-.37,0-.37,0l-6.82,9.41h3.64v37.08s3.54,0,3.54,0h0s7.5,0,7.5,0h0Zm-24.46-37.08h3.75s-6.93-9.41-6.93-9.41h-.21s0,0,0,0c-4.23.11-7.65,3.61-7.65,7.86v38.62s7.65,0,7.65,0h3.39s0-37.08,0-37.08Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m769.35,312.5l-.62-1.68.22,6.02c.03.81-.61,1.5-1.42,1.53h0c-.81.03-1.5-.6-1.53-1.41l-.03-.8c-.08.02-.17.03-.26.03h0c-.81.03-1.5-.6-1.53-1.41l-.03-.84c-.41-.25-.7-.69-.72-1.21l-.34-9.15c0-.21.03-.42.1-.6l.28-2.59,6.95,2.94.02,3.68,1.65,4.46c.28.76-.12,1.61-.88,1.89h0c-.76.28-1.61-.12-1.89-.88Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "762.99 302.96 770.83 302.96 770.83 308 762.99 307.34 762.99 302.96"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9acdcd",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m762.31,303.72l8.67,1.61,7.83-48.65c-6.52-1.12-9.69,5.02-10.17,7.98l-6.32,39.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m787.57,239.06h9.2c.18,0,.33.15.33.33,0,1.99-2.3,3.74-4.93,3.74-2.95,0-4.93-1.93-4.93-3.74,0-.18.15-.33.33-.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#301b0f"
	    },
	    attrs: {
	      "d": "m784.23,230c-1.08,0-1.95-.87-1.95-1.95s.87-1.95,1.95-1.95,1.95.87,1.95,1.95-.87,1.95-1.95,1.95Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#301b0f"
	    },
	    attrs: {
	      "cx": "800.04",
	      "cy": "228.05",
	      "r": "1.95"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "784.63 255.85 792.02 266.62 799.4 255.85 801.91 255.85 805.34 267.09 798.73 265.23 794.75 269.35 789.29 269.35 785.3 265.23 778.69 267.09 782.13 255.85 784.63 255.85"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9e9c9c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m700.16,263.34h48.2c1.31,0,2.38,1.07,2.38,2.38v29.11c0,1.31-1.07,2.38-2.38,2.38h-48.2c-1.31,0-2.38-1.07-2.38-2.38v-29.11c0-1.31,1.07-2.38,2.38-2.38h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70706f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m697.98,297.19h52.66c.09,0,.16.07.16.16v1.91c0,.09-.07.16-.16.16h-52.66c-.09,0-.16-.07-.16-.16v-1.91c0-.09.07-.16.16-.16h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#878787",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m748.36,263.34h-24.26v33.88h24.26c1.31,0,2.38-1.07,2.38-2.38v-29.11c0-1.31-1.07-2.38-2.38-2.38Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m719.17,279.23h10.19c.16,0,.29.13.29.29v3.05c0,.16-.13.29-.29.29h-10.19c-.16,0-.29-.13-.29-.29v-3.05c0-.16.13-.29.29-.29h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c7c6c7",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m719.02,281.05h10.48c.08,0,.15.07.15.15v1.53c0,.08-.07.15-.15.15h-10.48c-.08,0-.15-.07-.15-.15v-1.53c0-.08.07-.15.15-.15h0Z"
	    }
	  })])]), _h('text', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "font-family": "ClassicComic, &apos",
	      "font-size": "11.67px"
	    },
	    attrs: {
	      "transform": "translate(863.73 185.77)"
	    }
	  }, [_h('tspan', {
	    attrs: {
	      "x": "0",
	      "y": "0"
	    }
	  }, ["Eco-code"])]), _h('g', {
	    staticStyle: {
	      "opacity": ".7"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#89bb3f"
	    },
	    attrs: {
	      "d": "m920.89,217.29c0,.85.77,1.54,1.73,1.54h0c.95,0,1.73-.69,1.73-1.54v-12.03c0-.85-.77-1.54-1.73-1.54h0c-.95,0-1.73.69-1.73,1.54v12.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#93c24c"
	    },
	    attrs: {
	      "d": "m933.91,217.58h-20.42v-2.23c0-.51-.42-.93-.93-.93h-5.23c-.51,0-.93.42-.93.93v11.91c0,.51.42.93.93.93h5.23c.51,0,.93-.42.93-.93v-2.23h19.49v6.12h7.45v-7.05c0-3.59-2.92-6.51-6.52-6.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#89bb3f"
	    },
	    attrs: {
	      "d": "m940.42,228.21v-4.12c0-3.59-2.92-6.51-6.52-6.51h-8.37v-3.71c0-1.04-1.31-1.88-2.93-1.88s-2.93.84-2.93,1.88v3.71h-6.2v-2.23c0-.51-.42-.93-.93-.93h-5.23c-.51,0-.93.42-.93.93v11.91c0,.51.42.93.93.93h5.23c.51,0,.93-.42.93-.93v-2.23h6.22c.15.95,1.4,1.68,2.91,1.68s2.76-.74,2.91-1.68h7.45v3.2c-.38.17-.67.9-.67,1.78,0,1.01.37,1.82.84,1.82h7.17c.46,0,.84-.81.84-1.82,0-.92-.32-1.68-.73-1.8Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#89bb3f"
	    },
	    attrs: {
	      "d": "m906.39,227.26c0,.51.42.93.93.93h5.23c.51,0,.93-.42.93-.93v-2.23h6.22c.15.95,1.4,1.68,2.91,1.68s2.76-.74,2.91-1.68h7.45v3.2c-.38.17-.67.9-.67,1.78,0,1.01.37,1.82.84,1.82h7.17c.46,0,.84-.81.84-1.82,0-.92-.32-1.68-.73-1.8v-4.12c0-1.18-.32-2.29-.88-3.25h-33.16v6.41Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m936.54,233.34s-7.48,10.95-8.04,17.18c-1.14,12.67,17.23,12.67,16.09,0-.56-6.22-8.05-17.18-8.05-17.18Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#89bb3f"
	    },
	    attrs: {
	      "d": "m915.89,207.26c0,.87.79,1.58,1.77,1.58h9.9c.98,0,1.77-.71,1.77-1.58h0c0-.87-.79-1.58-1.77-1.58h-9.9c-.98,0-1.77.71-1.77,1.58h0Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "206.19",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "192.88",
	      "width": "77.12",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "195.8",
	      "width": "77.12",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "198.71",
	      "width": "50.6",
	      "height": "1.38"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "209.19",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "212.24",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "215.33",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.8",
	      "y": "218.29",
	      "width": "29.55",
	      "height": "1.38"
	    }
	  }), _h('g', {
	    staticStyle: {
	      "opacity": ".7"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m871.41,234.44c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m871.51,242.49c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m871.39,238.33c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "864.7",
	      "y": "235.29",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "864.7",
	      "y": "239.18",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m870.9,233.51c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m867.85,232.36c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m867.33,230.06h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m868.37,231.21h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m885.11,234.44c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m885.21,242.49c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m885.09,238.33c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "878.39",
	      "y": "235.29",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "878.39",
	      "y": "239.18",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m884.6,233.51c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m881.55,232.36c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m881.03,230.06h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m882.07,231.21h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.81,234.44c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.91,242.49c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.79,238.33c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "892.09",
	      "y": "235.29",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "892.09",
	      "y": "239.18",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.3,233.51c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m895.25,232.36c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m894.73,230.06h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m895.77,231.21h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })])]), _h('g', {
	    staticStyle: {
	      "opacity": ".7"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m871.41,251.06c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m871.51,259.11c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m871.39,254.95c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "864.7",
	      "y": "251.91",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "864.7",
	      "y": "255.79",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m870.9,250.13c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m867.85,248.98c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m867.33,246.68h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m868.37,247.82h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m885.11,251.06c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m885.21,259.11c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m885.09,254.95c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "878.39",
	      "y": "251.91",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "878.39",
	      "y": "255.79",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m884.6,250.13c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m881.55,248.98c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m881.03,246.68h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m882.07,247.82h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.81,251.06c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.91,259.11c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.79,254.95c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "892.09",
	      "y": "251.91",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "x": "892.09",
	      "y": "255.79",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m898.3,250.13c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m895.25,248.98c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m894.73,246.68h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#74c9e1"
	    },
	    attrs: {
	      "d": "m895.77,247.82h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#91989f"
	    },
	    attrs: {
	      "d": "m911.79,345.69c0,1.64,1.33,2.98,2.98,2.98h27.22c4.65,0,8.56-3.63,8.91-8.26l2.54-36.37c.12-1.64-1.11-3.07-2.74-3.19h0c-1.64-.12-3.07,1.11-3.19,2.74l-2.54,36.37c-.12,1.54-1.42,2.75-2.97,2.75h-27.22c-1.64,0-2.98,1.33-2.98,2.98h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#632914"
	    },
	    attrs: {
	      "d": "m913.32,342.72h68.42c1.64,0,2.98,1.34,2.98,2.98v.6h-26.31c-2.22,0-4.34.93-5.85,2.57h0c-1.28,1.4-3.09,2.19-4.98,2.19h-34.26c-1.64,0-2.98-1.34-2.98-2.98v-2.38c0-1.64,1.34-2.98,2.98-2.98Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#91989f"
	    },
	    attrs: {
	      "x": "928.77",
	      "y": "342.87",
	      "width": "5.43",
	      "height": "41.67",
	      "rx": "1.7",
	      "ry": "1.7",
	      "transform": "translate(1862.96 727.41) rotate(180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#91989f"
	    },
	    attrs: {
	      "d": "m864.42,385.58h0c1.53,0,2.78-1.24,2.78-2.78v-52.59c0-4.49,3.64-8.14,8.14-8.14h20.84c1.53,0,2.78-1.24,2.78-2.78h0c0-1.53-1.24-2.78-2.78-2.78h-20.84c-7.56,0-13.69,6.13-13.69,13.69v52.59c0,1.53,1.24,2.78,2.78,2.78Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#91989f"
	    },
	    attrs: {
	      "x": "854.77",
	      "y": "380.42",
	      "width": "82.29",
	      "height": "5.16",
	      "rx": "1.61",
	      "ry": "1.61",
	      "transform": "translate(1791.82 766) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#adb4bd"
	    },
	    attrs: {
	      "d": "m954.52,345.69c0,1.64,1.33,2.98,2.98,2.98h27.22c4.65,0,8.56-3.63,8.91-8.26l2.54-36.37c.12-1.64-1.11-3.07-2.74-3.19h0c-1.64-.12-3.07,1.11-3.19,2.74l-2.54,36.37c-.12,1.54-1.42,2.75-2.97,2.75h-27.22c-1.64,0-2.98,1.33-2.98,2.98h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m924.21,344.51c-.44,1.56-.68,3.21-.68,4.91v31.41h11.77v-31.41c0-1.73.71-3.31,1.85-4.45.16-.16.33-.31.51-.46h-13.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m968.14,281.65c-.57-.35-1.08-1.08-1.08-1.73v-18.59c0-9.44-7.88-17.09-17.63-17.16h0s-.05,0-.07,0c-.02,0-.05,0-.07,0h0c-9.75.08-17.63,7.73-17.63,17.17v18.59c0,.65-.51,1.38-1.09,1.73-1.91,1.19-3.17,3.26-3.17,5.61,0,3.68,3.09,6.67,6.91,6.67h30.12c3.81,0,6.91-2.99,6.91-6.67,0-2.36-1.27-4.43-3.18-5.61Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#632914"
	    },
	    attrs: {
	      "d": "m949.4,324.75h40.74c1.16,0,2.12-.9,2.19-2.06l1.34-20.87c.08-1.27-.92-2.34-2.19-2.34h-40.74c-1.16,0-2.12.9-2.19,2.06l-1.34,20.87c-.08,1.27.92,2.34,2.19,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m903.41,349.42v31.41h11.77v-31.41c0-1.73.71-3.31,1.85-4.45h-13.07c-.36,1.42-.56,2.92-.56,4.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#83331a"
	    },
	    attrs: {
	      "d": "m947.99,324.75h40.74c1.16,0,2.12-.9,2.19-2.06l1.34-20.87c.08-1.27-.92-2.34-2.19-2.34h-40.74c-1.16,0-2.12.9-2.19,2.06l-1.34,20.87c-.08,1.27.92,2.34,2.19,2.34Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#adb4bd"
	    },
	    attrs: {
	      "x": "971.49",
	      "y": "342.87",
	      "width": "5.43",
	      "height": "41.67",
	      "rx": "1.7",
	      "ry": "1.7",
	      "transform": "translate(1948.41 727.41) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m956.83,331.73h-35.38c-4.98,0-9.5,2.03-12.78,5.31-3.05,3.05-5.02,7.19-5.28,11.76h31.95c.22-1.32.85-2.51,1.76-3.43,1.15-1.15,2.73-1.86,4.46-1.86h16.54c5.98,0,10.87-5.3,10.87-11.77h-12.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "d": "m943.49,288.42h13.96c6.36,0,11.53,5.17,11.53,11.53v31.78h-37.17v-31.62c0-6.45,5.24-11.69,11.69-11.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#3e1810"
	    },
	    attrs: {
	      "d": "m910.34,353.89c0,.94.51,1.69,1.15,1.69s1.15-.76,1.15-1.69c0-.94-.51-1.69-1.15-1.69s-1.15.76-1.15,1.69Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#83331a"
	    },
	    attrs: {
	      "x": "864.16",
	      "y": "328.73",
	      "width": "46.04",
	      "height": "32.64",
	      "rx": "6.25",
	      "ry": "6.25",
	      "transform": "translate(1774.36 690.1) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#632914"
	    },
	    attrs: {
	      "d": "m947.71,311.83c-.02,1,.45,1.83,1.06,1.84.6.01,1.11-.79,1.13-1.8s-.45-1.83-1.06-1.84c-.6-.01-1.11.79-1.13,1.8Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m920.82,305.3h18.98c6.56,0,11.45-1.6,14.54-4.74,2.19-2.23,3.09-4.89,3.45-6.73,2.34,1.42,4.76,2.68,7.22,3.88-.81,2.59-2.26,5.61-4.87,8.31-4.64,4.81-11.49,7.25-20.34,7.25h-18.98v-7.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "d": "m958.4,309.64l-6.57-8.64c1.05-.61,6.21-9.42,6.21-9.42.06-.08.13-.17.2-.25,3.02-3.59,8.87-.88,8.31,3.78-.52,4.32-2.3,10.87-8.16,14.53Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#adb4bd"
	    },
	    attrs: {
	      "d": "m910.86,385.58h0c1.53,0,2.78-1.24,2.78-2.78v-52.59c0-4.49,3.64-8.14,8.14-8.14h20.84c1.53,0,2.78-1.24,2.78-2.78h0c0-1.53-1.24-2.78-2.78-2.78h-20.84c-7.56,0-13.69,6.13-13.69,13.69v52.59c0,1.53,1.24,2.78,2.78,2.78Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m937.44,299.23c.18,0,.31,0,.38,0l-.06-4.43-.03-4.44c-.74,0-18.38-.28-22.97-23.36l-8.7,1.73c3.13,15.75,11.49,23.22,17.94,26.71,6.26,3.38,11.86,3.75,13.43,3.79Z"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "x": "905.63",
	      "y": "263.1",
	      "width": "8.94",
	      "height": "10.02",
	      "rx": "2.45",
	      "ry": "2.45",
	      "transform": "translate(1857.13 325.52) rotate(167.05)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m911.42,265.99l2.55-.49-1.66-8.74c-.13-.7-.81-1.17-1.52-1.03h0c-.7.13-1.17.81-1.03,1.52l1.66,8.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m908.23,265.89l2.53-.58-1.99-8.67c-.16-.7-.86-1.13-1.56-.97h0c-.7.16-1.13.86-.97,1.56l1.99,8.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m905.68,268.39l2.5-.71-2.43-8.55c-.2-.69-.91-1.09-1.6-.89h0c-.69.2-1.09.91-.89,1.6l2.43,8.55Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m911.12,270.44l2.4.99,3.73-9.02c.27-.66-.04-1.42-.7-1.69h0c-.66-.27-1.42.04-1.69.7l-3.73,9.02Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m943.08,288.4l1.04,6.69c.14.71.94,1.06,1.55.68l3.8-2.34,3.79,2.34c.61.38,1.42.03,1.55-.68l1.04-6.69h-12.77Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "d": "m923.06,295.24l3.36-7.12c.6-1.27,2.07-1.88,3.38-1.39,4.95,1.84,8.85,1.72,8.89,1.72,0,0,.64,0,1.67,0l4.63,15.3-11.8-2.44c-2.42-.4-5.42-1.11-8.69-2.4-1.45-.57-2.11-2.27-1.44-3.68Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#decc86"
	    },
	    attrs: {
	      "x": "945.02",
	      "y": "276.33",
	      "width": "8.86",
	      "height": "12.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#decc86",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m949.45,293.11c2.45,0,4.43-1.98,4.43-4.43s-1.98-4.43-4.43-4.43-4.43,1.99-4.43,4.43,1.99,4.43,4.43,4.43h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "x": "911.24",
	      "y": "304.06",
	      "width": "10.42",
	      "height": "8.87",
	      "rx": "2.77",
	      "ry": "2.77"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m892.95,301.96h-32.43v7.09h32.43c-.86-2.15-.8-4.53,0-7.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m892.35,305.07h-31.83v-3.11h32.43c-.33,1.07-.54,2.11-.6,3.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e27232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m863.43,300.8h30.21v2.69h-30.21c-.68,0-1.3.28-1.75.72h0c-.45.45-.73,1.07-.73,1.75h0c0,.68.28,1.3.73,1.75.45.45,1.07.73,1.75.73h30.21v2.69h-30.21c-1.42,0-2.71-.58-3.65-1.51-.93-.93-1.51-2.22-1.51-3.65h0c0-1.42.58-2.71,1.51-3.65h0c.93-.93,2.22-1.51,3.64-1.51Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#adb4bd"
	    },
	    attrs: {
	      "x": "901.2",
	      "y": "380.42",
	      "width": "89.04",
	      "height": "5.16",
	      "rx": "1.61",
	      "ry": "1.61",
	      "transform": "translate(1891.44 766) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m959.9,271.39c0,2.57,2.08,4.65,4.65,4.65,2.57,0,4.65-2.08,4.65-4.65s-2.08-4.65-4.65-4.65c-2.57,0-4.65,2.08-4.65,4.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m929.49,271.39c0,2.57,2.08,4.65,4.65,4.65s4.65-2.08,4.65-4.65c0-2.57-2.08-4.65-4.65-4.65s-4.65,2.08-4.65,4.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m961.77,271.39c0,1.54,1.25,2.79,2.79,2.79,1.54,0,2.79-1.25,2.79-2.79s-1.25-2.79-2.79-2.79-2.79,1.25-2.79,2.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m931.35,271.39c0,1.54,1.25,2.79,2.79,2.79s2.79-1.25,2.79-2.79c0-1.54-1.25-2.79-2.79-2.79s-2.79,1.25-2.79,2.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m933.62,271.47c0,8.75,7.09,15.84,15.84,15.84,8.75,0,15.84-7.09,15.84-15.84v-10.64c0-8.75-7.09-10.84-15.84-10.84-16.45,0-15.84,6.46-15.84,15.84v5.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197"
	    },
	    attrs: {
	      "d": "m949.47,249.99h0v37.32c8.75,0,15.84-7.09,15.84-15.84v-10.64c0-8.75-7.09-10.84-15.84-10.84Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m966.2,261.74l.08.05c0-9.62-7.57-17.42-16.91-17.42s-16.59,7.47-16.89,16.81c-.11.89-.17,1.8-.17,2.74,0,.17.32.7.33.86.03.55,6.25-2.93,10.39-8.56,1.03.99,5.04,3.98,9.77,5.86,5.82,2.3,10.39,3.23,12.3,3.23,1.74,0,1.22-1.24,1.22-1.39,0-.74-.04-1.47-.11-2.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d48963",
	      "opacity": ".8"
	    },
	    attrs: {
	      "d": "m949.47,282.45c1.54,0,3.05-.65,3.84-1.65.2-.25.16-.61-.09-.81-.25-.2-.61-.16-.81.09-.58.73-1.74,1.21-2.94,1.21-1.48,0-2.49-.62-2.94-1.2-.19-.25-.56-.3-.81-.1-.25.2-.3.56-.1.81.8,1.04,2.24,1.65,3.85,1.65Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "942.21",
	      "cy": "271.26",
	      "r": "1.89"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "956.72",
	      "cy": "271.26",
	      "r": "1.89"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#49bdcc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m891.43,284.21s-.23,1-1.25,1.38c-1.03.38.54,1.51.54,1.51.83,0,1.44.02,1.88,0h0s2.45,0,2.45,0c.09,0,.18,0,.28,0h.02c.39,0,.87-.01,1.46-.01,0,0,1.57-1.13.54-1.51-1.03-.38-1.25-1.38-1.25-1.38h-4.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#23b1be",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m893.77,287.12h1.28c.09,0,.18,0,.28,0h.02c.39,0,.87-.01,1.46,0,0,0,1.57-1.13.54-1.51-1.03-.38-1.25-1.38-1.25-1.38h-2.34v2.91h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#67c5d7",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m894.14,285.32c1.53,0,4.63-.1,4.63,1.82v4.13c0,1.92-3.1,1.81-4.63,1.81-.25,0-.5,0-.75,0-1.53,0-4.63.1-4.63-1.81v-4.13c0-1.92,3.1-1.81,4.63-1.82.25,0,.5,0,.75,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#49bdcc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m894.14,285.32c1.53,0,4.63-.1,4.63,1.82v4.13c0,1.92-3.1,1.81-4.63,1.81h-.37v-7.76h.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#67c5d7",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m888.76,296.28c0-1.92,3.1-1.81,4.63-1.82.25,0,.5,0,.75,0,1.53,0,4.63-.1,4.63,1.82v14.85c0,1.92-3.1,1.81-4.63,1.81-.25,0-.5,0-.75,0-1.53,0-4.63.1-4.63-1.81v-14.85h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#49bdcc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m893.77,294.47h.37c1.53,0,4.63-.1,4.63,1.81v14.85c0,1.92-3.1,1.81-4.63,1.81h-.37v-18.48h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#49bdcc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "889.63 292.6 897.9 292.6 897.9 294.95 889.63 294.95 889.63 292.6 889.63 292.6"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#23b1be",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "893.77 292.6 897.9 292.6 897.9 294.95 893.77 294.95 893.77 292.6 893.77 292.6"
	    }
	  })]), _h('polygon', {
	    staticStyle: {
	      "fill": "#ebeeed",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "892.96 281.07 894.58 281.07 894.58 281.93 892.96 281.93 892.96 281.07 892.96 281.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m895.04,281.07v-1.06h0c0-.14-.06-.27-.15-.37,0,0,0-.02-.02-.02s-.02,0-.02-.02c-.1-.09-.22-.15-.37-.15h-1.44c-.3,0-.55.25-.55.55v1.07h2.54Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#bdc7cd",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "893.77 281.07 894.58 281.07 894.58 281.93 893.77 281.93 893.77 281.07 893.77 281.07"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e47b3d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m896.29,281.93h-5.03c-.33,0-.59.27-.59.59v1.17c0,.33.27.59.59.59h5.03c.33,0,.59-.27.59-.59h0v-1.17c0-.33-.27-.59-.59-.59Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#83331a"
	    },
	    attrs: {
	      "x": "852.52",
	      "y": "311.1",
	      "width": "59.68",
	      "height": "5.82",
	      "rx": "1.82",
	      "ry": "1.82",
	      "transform": "translate(1764.71 628.01) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#632914"
	    },
	    attrs: {
	      "x": "904.37",
	      "y": "311.1",
	      "width": "56.1",
	      "height": "5.82",
	      "rx": "1.82",
	      "ry": "1.82",
	      "transform": "translate(1864.84 628.01) rotate(-180)"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "classroom_inactive"
	    }
	  }, [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#27231f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "788.02",
	      "y": "284.4",
	      "width": "194.04",
	      "height": "2.37"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "787.97",
	      "y": "142.46",
	      "width": "194.13",
	      "height": "142.78"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dfdfdf"
	    },
	    attrs: {
	      "x": "745.52",
	      "y": "205.34",
	      "width": "122.48",
	      "height": "30.63",
	      "transform": "translate(1027.42 -586.1) rotate(90)"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "791.45",
	      "y": "145.51",
	      "width": "187.18",
	      "height": "9.7"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fdd491",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "793.75 147.6 841.56 147.6 841.56 153.17 793.75 153.17 793.75 147.6 793.75 147.6"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "976.67 153.15 971.01 153.15 971.01 147.49 976.67 147.49 976.67 153.15 976.67 153.15"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "970.2 153.15 964.54 153.15 964.54 147.49 970.2 147.49 970.2 153.15 970.2 153.15"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "963.74 153.15 958.08 153.15 958.08 147.49 963.74 147.49 963.74 153.15 963.74 153.15"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fdd491",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "972.21 151.43 973.46 150.18 972.21 148.93 972.68 148.45 973.93 149.7 975.18 148.45 975.66 148.93 974.41 150.18 975.66 151.43 975.18 151.91 973.93 150.66 972.68 151.91 972.21 151.43 972.21 151.43"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fdd491",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "958.86 151.62 963.07 151.62 963.07 152.29 958.86 152.29 958.86 151.62 958.86 151.62"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fdd491",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "965.29 152.29 969.39 152.29 969.39 149.82 965.29 149.82 965.29 152.29 965.29 152.29"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m685.55,278.45s-2.57,2.85-2.43,6.24c.14,3.38,2.93,6.01,2.93,6.01,0,0,2.57-2.85,2.43-6.24-.14-3.38-2.93-6.01-2.93-6.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m679.76,284.82s.15,2.61,1.86,4.16c1.71,1.55,4.32,1.46,4.32,1.46,0,0-.15-2.61-1.86-4.16-1.71-1.55-4.32-1.46-4.32-1.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m688.09,286.28c-1.71,1.55-1.86,4.16-1.86,4.16,0,0,2.61.09,4.32-1.46,1.71-1.55,1.86-4.16,1.86-4.16,0,0-2.61-.09-4.32,1.46Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#d17e48"
	    },
	    attrs: {
	      "points": "682.66 299.59 689.81 299.59 691.9 290.44 680.57 290.44 682.66 299.59"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "672.65",
	      "y": "305.48",
	      "width": "7.71",
	      "height": "79.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#845454"
	    },
	    attrs: {
	      "x": "672.65",
	      "y": "383.31",
	      "width": "7.71",
	      "height": "2.13"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "667.89",
	      "y": "299.37",
	      "width": "164.74",
	      "height": "6.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "672.6",
	      "y": "305.48",
	      "width": "152.34",
	      "height": "39.62"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "818.72",
	      "y": "305.48",
	      "width": "7.71",
	      "height": "79.95"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#231f20",
	      "opacity": ".22"
	    },
	    attrs: {
	      "x": "672.6",
	      "y": "305.48",
	      "width": "153.84",
	      "height": "3.06"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#845454"
	    },
	    attrs: {
	      "x": "818.72",
	      "y": "383.31",
	      "width": "7.71",
	      "height": "2.13"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392"
	    },
	    attrs: {
	      "d": "m769,229.25c0,2.43,1.97,4.4,4.4,4.4s4.4-1.97,4.4-4.4-1.97-4.4-4.4-4.4c-2.43,0-4.4,1.97-4.39,4.4Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "d": "m770.76,229.24c0,1.46,1.18,2.64,2.64,2.64,1.46,0,2.64-1.18,2.64-2.64,0-1.46-1.18-2.64-2.64-2.64-1.46,0-2.64,1.18-2.64,2.64Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "d": "m806.66,229.25c0,2.43,1.97,4.4,4.4,4.4s4.4-1.97,4.4-4.4-1.97-4.4-4.4-4.4c-2.43,0-4.4,1.97-4.39,4.4Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d4a15e"
	    },
	    attrs: {
	      "d": "m808.42,229.24c0,1.46,1.18,2.64,2.64,2.64,1.46,0,2.64-1.18,2.64-2.64,0-1.46-1.18-2.64-2.64-2.64-1.46,0-2.64,1.18-2.64,2.64Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "785.36",
	      "y": "265.18",
	      "width": "13.43",
	      "height": "36.62"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#343434"
	    },
	    attrs: {
	      "x": "775.88",
	      "y": "291.9",
	      "width": "32.38",
	      "height": "2.78"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#452211"
	    },
	    attrs: {
	      "cx": "792.3",
	      "cy": "201.59",
	      "r": "14.4",
	      "transform": "translate(-24.86 176.42) rotate(-12.51)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m799.53,245.94h-14.77s0,13.32,0,13.32c0,9.77,14.77,9.77,14.77,0v-13.32Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m792.3,201.59c4.73.1,18.98.56,19.22,17.17.25,16.61-3.31,22.7-5.55,25.19-2.24,2.48-4.58,4.73-9.18,5.93-1.2,1.2-2.47,1.66-4.49,1.92-2.02-.26-3.29-.72-4.49-1.92-4.6-1.19-6.94-3.44-9.18-5.93-2.24-2.48-5.8-8.58-5.55-25.19.25-16.61,14.49-17.07,19.22-17.17Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m792.3,201.59c4.73.1,18.98.56,19.22,17.17.25,16.61-3.31,22.7-5.55,25.19-2.24,2.48-4.58,4.73-9.18,5.93-1.2,1.2-2.47,1.66-4.49,1.92v-50.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m802.62,211.01c1.88,3.86,1.73,10.01,9.11,13.99,4.9-18.09-7.78-26.46-19.95-26.2-12.87.28-24.47,8.96-20.78,26.73,8.62-1.81,13.2-6.15,17.32-10.97-1.37,4.11-4.06,6.17-3.35,6,8.3-2.01,11.27-2.48,17.64-9.56Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "d": "m846.67,236.33l-4.01.79.59,2.54,3.9-.77c.7-.13,1.17-.81,1.04-1.52-.13-.7-.82-1.17-1.52-1.04Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "cx": "843.57",
	      "cy": "240.42",
	      "r": "3.41"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "points": "839.49 250.14 846.26 243.08 841.07 238.13 834.3 245.19 839.49 250.14"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "835.36 242.58 841.82 248.39 838.21 252.53 832.22 246.18 835.36 242.58"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ea5232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m802.54,376.86c-6.06,0-1.75,0-7.81,0-1.02,2.91-.63,5.51-.04,8.72h1.97s0-1.22,0-1.22c0-.83.68-1.51,1.51-1.51h0c.83,0,1.51.68,1.51,1.51v1.22s11.9,0,11.9,0c.03-1.98-1.18-3.53-2.69-4.78-2.1-1.75-5.57-2.93-6.35-3.93Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m794.63,301.81h9.01s-.62,75.06-.62,75.06c.77,1,3.75,2.18,5.85,3.91-5.13.93-10.36-.35-14.13-3.91l-.11-38.12v-36.93Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ea5232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m781.59,376.86c6.06,0,1.75,0,7.81,0,1.02,2.91.63,5.51.04,8.72h-1.97v-1.22c0-.83-.68-1.51-1.51-1.51h0c-.83,0-1.51.68-1.51,1.51v1.22h-11.9c-.03-1.98,1.18-3.53,2.69-4.78,2.1-1.75,5.57-2.93,6.35-3.93Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m789.51,301.81h-9.01s.62,75.06.62,75.06c-.77,1-3.75,2.18-5.85,3.91,5.13.93,10.36-.35,14.13-3.91l.11-38.12v-36.93Z"
	    }
	  })])]), _h('line', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#936037",
	      "stroke-linecap": "round",
	      "stroke-linejoin": "round",
	      "stroke-width": "1.09px"
	    },
	    attrs: {
	      "x1": "852.89",
	      "y1": "184.3",
	      "x2": "844.88",
	      "y2": "251.97"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "x": "840.5",
	      "y": "239.29",
	      "width": "8.43",
	      "height": "2.45",
	      "rx": ".76",
	      "ry": ".76",
	      "transform": "translate(1656.14 576.6) rotate(-173.39)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "x": "840.24",
	      "y": "241.68",
	      "width": "8.43",
	      "height": "2.45",
	      "rx": ".76",
	      "ry": ".76",
	      "transform": "translate(1655.36 581.32) rotate(-173.39)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edba68"
	    },
	    attrs: {
	      "x": "839.92",
	      "y": "244.04",
	      "width": "8.43",
	      "height": "2.45",
	      "rx": ".76",
	      "ry": ".76",
	      "transform": "translate(1654.44 586.01) rotate(-173.39)"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9acdcd"
	    },
	    attrs: {
	      "d": "m795.35,262.55l-.24.43s.13.07.24.13v-.56Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m833.51,243.97c-11.64,14.2-23.71,13.62-29.8,12.05v9.8c1.92.35,4.11.58,6.51.57,7.94-.04,19.7-2.92,30.71-16.34l-7.42-6.08Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "775.88",
	      "y": "294.68",
	      "width": "32.38",
	      "height": "46.43"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m809.82,302.26v-38.62c0-4.2-3.34-7.66-7.5-7.85h0s-.37,0-.37,0l-6.82,9.41h3.64v37.08s3.54,0,3.54,0h0s7.5,0,7.5,0h0Zm-24.46-37.08h3.75s-6.93-9.41-6.93-9.41h-.21s0,0,0,0c-4.23.11-7.65,3.61-7.65,7.86v38.62s7.65,0,7.65,0h3.39s0-37.08,0-37.08Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#edba68",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m769.48,312.46l-.62-1.68.22,6.02c.03.81-.61,1.5-1.42,1.53h0c-.81.03-1.5-.6-1.53-1.41l-.03-.8c-.08.02-.17.03-.26.03h0c-.81.03-1.5-.6-1.53-1.41l-.03-.84c-.41-.25-.7-.69-.72-1.21l-.34-9.15c0-.21.03-.42.1-.6l.28-2.59,6.95,2.94.02,3.68,1.65,4.46c.28.76-.12,1.61-.88,1.89h0c-.76.28-1.61-.12-1.89-.88Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "763.12 302.92 770.95 302.92 770.95 307.96 763.12 307.3 763.12 302.92"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m762.43,303.67l8.67,1.61,7.83-48.65c-6.52-1.12-9.69,5.02-10.17,7.98l-6.32,39.06Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m787.7,239.02h9.2c.18,0,.33.15.33.33,0,1.99-2.3,3.74-4.93,3.74-2.95,0-4.93-1.93-4.93-3.74,0-.18.15-.33.33-.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#301b0f"
	    },
	    attrs: {
	      "d": "m784.36,229.96c-1.08,0-1.95-.87-1.95-1.95s.87-1.95,1.95-1.95,1.95.87,1.95,1.95-.87,1.95-1.95,1.95Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#301b0f"
	    },
	    attrs: {
	      "cx": "800.17",
	      "cy": "228.01",
	      "r": "1.95"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "784.76 255.81 792.15 266.58 799.53 255.81 802.04 255.81 805.47 267.04 798.86 265.18 794.87 269.31 789.42 269.31 785.43 265.18 778.82 267.04 782.26 255.81 784.76 255.81"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m700.29,263.3h48.2c1.31,0,2.38,1.07,2.38,2.38v29.11c0,1.31-1.07,2.38-2.38,2.38h-48.2c-1.31,0-2.38-1.07-2.38-2.38v-29.11c0-1.31,1.07-2.38,2.38-2.38h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m698.11,297.15h52.66c.09,0,.16.07.16.16v1.91c0,.09-.07.16-.16.16h-52.66c-.09,0-.16-.07-.16-.16v-1.91c0-.09.07-.16.16-.16h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c7743e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m748.49,263.3h-24.26v33.88h24.26c1.31,0,2.38-1.07,2.38-2.38v-29.11c0-1.31-1.07-2.38-2.38-2.38Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m719.3,279.19h10.19c.16,0,.29.13.29.29v3.05c0,.16-.13.29-.29.29h-10.19c-.16,0-.29-.13-.29-.29v-3.05c0-.16.13-.29.29-.29h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fdd491",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m719.15,281.01h10.48c.08,0,.15.07.15.15v1.53c0,.08-.07.15-.15.15h-10.48c-.08,0-.15-.07-.15-.15v-1.53c0-.08.07-.15.15-.15h0Z"
	    }
	  })])]), _h('text', {
	    staticStyle: {
	      "fill": "#8e7f75",
	      "font-family": "ClassicComic, &apos",
	      "font-size": "11.67px"
	    },
	    attrs: {
	      "transform": "translate(863.86 185.73)"
	    }
	  }, [_h('tspan', {
	    attrs: {
	      "x": "0",
	      "y": "0"
	    }
	  }, ["Eco-code"])]), _h('g', {
	    staticStyle: {
	      "opacity": ".7"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m921.02,217.25c0,.85.77,1.54,1.73,1.54h0c.95,0,1.73-.69,1.73-1.54v-12.03c0-.85-.77-1.54-1.73-1.54h0c-.95,0-1.73.69-1.73,1.54v12.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m934.04,217.54h-20.42v-2.23c0-.51-.42-.93-.93-.93h-5.23c-.51,0-.93.42-.93.93v11.91c0,.51.42.93.93.93h5.23c.51,0,.93-.42.93-.93v-2.23h19.49v6.12h7.45v-7.05c0-3.59-2.92-6.51-6.52-6.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m940.55,228.17v-4.12c0-3.59-2.92-6.51-6.52-6.51h-8.37v-3.71c0-1.04-1.31-1.88-2.93-1.88s-2.93.84-2.93,1.88v3.71h-6.2v-2.23c0-.51-.42-.93-.93-.93h-5.23c-.51,0-.93.42-.93.93v11.91c0,.51.42.93.93.93h5.23c.51,0,.93-.42.93-.93v-2.23h6.22c.15.95,1.4,1.68,2.91,1.68s2.76-.74,2.91-1.68h7.45v3.2c-.38.17-.67.9-.67,1.78,0,1.01.37,1.82.84,1.82h7.17c.46,0,.84-.81.84-1.82,0-.92-.32-1.68-.73-1.8Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m906.52,227.22c0,.51.42.93.93.93h5.23c.51,0,.93-.42.93-.93v-2.23h6.22c.15.95,1.4,1.68,2.91,1.68s2.76-.74,2.91-1.68h7.45v3.2c-.38.17-.67.9-.67,1.78,0,1.01.37,1.82.84,1.82h7.17c.46,0,.84-.81.84-1.82,0-.92-.32-1.68-.73-1.8v-4.12c0-1.18-.32-2.29-.88-3.25h-33.16v6.41Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m936.67,233.3s-7.48,10.95-8.04,17.18c-1.14,12.67,17.23,12.67,16.09,0-.56-6.22-8.05-17.18-8.05-17.18Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m916.02,207.21c0,.87.79,1.58,1.77,1.58h9.9c.98,0,1.77-.71,1.77-1.58h0c0-.87-.79-1.58-1.77-1.58h-9.9c-.98,0-1.77.71-1.77,1.58h0Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "206.14",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "192.84",
	      "width": "77.12",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "195.75",
	      "width": "77.12",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "198.67",
	      "width": "50.6",
	      "height": "1.38"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "209.15",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "212.2",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "215.29",
	      "width": "35.13",
	      "height": "1.38"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "863.93",
	      "y": "218.25",
	      "width": "29.55",
	      "height": "1.38"
	    }
	  }), _h('g', {
	    staticStyle: {
	      "opacity": ".7"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.54,234.4c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.64,242.45c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.52,238.29c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "864.82",
	      "y": "235.25",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "864.82",
	      "y": "239.13",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.03,233.47c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m867.98,232.32c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m867.46,230.02h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m868.5,231.16h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m885.23,234.4c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m885.34,242.45c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m885.21,238.29c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "878.52",
	      "y": "235.25",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "878.52",
	      "y": "239.13",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m884.73,233.47c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m881.68,232.32c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m881.16,230.02h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m882.2,231.16h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m898.93,234.4c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m899.04,242.45c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m898.91,238.29c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "892.22",
	      "y": "235.25",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "892.22",
	      "y": "239.13",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m898.42,233.47c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m895.38,232.32c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m894.86,230.02h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m895.9,231.16h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })])]), _h('g', {
	    staticStyle: {
	      "opacity": ".7"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.54,251.02c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.64,259.07c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.52,254.91c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "864.82",
	      "y": "251.87",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "864.82",
	      "y": "255.75",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m871.03,250.09c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m867.98,248.94c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m867.46,246.64h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m868.5,247.78h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m885.23,251.02c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m885.34,259.07c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m885.21,254.91c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "878.52",
	      "y": "251.87",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "878.52",
	      "y": "255.75",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m884.73,250.09c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m881.68,248.94c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m881.16,246.64h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m882.2,247.78h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m898.93,251.02c0,.32-.21.58-.47.58h-6.16c-.26,0-.47-.26-.47-.58v-.08c0-.32.21-.58.47-.58h6.16c.26,0,.47.26.47.58v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m899.04,259.07c0,.33-.22.59-.49.59h-6.34c-.27,0-.49-.27-.49-.59v-.08c0-.33.22-.59.49-.59h6.34c.27,0,.49.27.49.59v.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m898.91,254.91c0,.32-.21.57-.47.57h-6.13c-.26,0-.47-.26-.47-.57v-.08c0-.32.21-.57.47-.57h6.13c.26,0,.47.26.47.57v.08Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "892.22",
	      "y": "251.87",
	      "width": "6.32",
	      "height": "2.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "892.22",
	      "y": "255.75",
	      "width": "6.32",
	      "height": "2.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m898.42,250.09c-.39-.59-1.6-1.03-3.04-1.03s-2.66.43-3.04,1.03h6.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m895.38,248.94c.29,0,.57.02.84.05v-.14c0-.15-.12-.26-.26-.26h-1.16c-.15,0-.26.12-.26.26v.14c.27-.03.55-.05.84-.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m894.86,246.64h1.04c.13,0,.24.11.24.24v.58c0,.13-.11.24-.24.24h-1.04c-.13,0-.24-.11-.24-.24v-.58c0-.13.11-.24.24-.24Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m895.9,247.78h-1.04s-.06,0-.08-.02v.83h1.21v-.83s-.05.02-.08.02Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#91989f"
	    },
	    attrs: {
	      "d": "m911.92,345.65c0,1.64,1.33,2.98,2.98,2.98h27.22c4.65,0,8.56-3.63,8.91-8.26l2.54-36.37c.12-1.64-1.11-3.07-2.74-3.19h0c-1.64-.12-3.07,1.11-3.19,2.74l-2.54,36.37c-.12,1.54-1.42,2.75-2.97,2.75h-27.22c-1.64,0-2.98,1.33-2.98,2.98h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "d": "m913.44,342.67h68.42c1.64,0,2.98,1.34,2.98,2.98v.6h-26.31c-2.22,0-4.34.93-5.85,2.57h0c-1.28,1.4-3.09,2.19-4.98,2.19h-34.26c-1.64,0-2.98-1.34-2.98-2.98v-2.38c0-1.64,1.34-2.98,2.98-2.98Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#91989f"
	    },
	    attrs: {
	      "x": "928.89",
	      "y": "342.83",
	      "width": "5.43",
	      "height": "41.67",
	      "rx": "1.7",
	      "ry": "1.7",
	      "transform": "translate(1863.22 727.33) rotate(180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m864.55,385.54h0c1.53,0,2.78-1.24,2.78-2.78v-52.59c0-4.49,3.64-8.14,8.14-8.14h20.84c1.53,0,2.78-1.24,2.78-2.78h0c0-1.53-1.24-2.78-2.78-2.78h-20.84c-7.56,0-13.69,6.13-13.69,13.69v52.59c0,1.53,1.24,2.78,2.78,2.78Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "854.89",
	      "y": "380.38",
	      "width": "82.29",
	      "height": "5.16",
	      "rx": "1.61",
	      "ry": "1.61",
	      "transform": "translate(1792.08 765.92) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m954.65,345.65c0,1.64,1.33,2.98,2.98,2.98h27.22c4.65,0,8.56-3.63,8.91-8.26l2.54-36.37c.12-1.64-1.11-3.07-2.74-3.19h0c-1.64-.12-3.07,1.11-3.19,2.74l-2.54,36.37c-.12,1.54-1.42,2.75-2.97,2.75h-27.22c-1.64,0-2.98,1.33-2.98,2.98h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m924.34,344.47c-.44,1.56-.68,3.21-.68,4.91v31.41h11.77v-31.41c0-1.73.71-3.31,1.85-4.45.16-.16.33-.31.51-.46h-13.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m968.26,281.61c-.57-.35-1.08-1.08-1.08-1.73v-18.59c0-9.44-7.88-17.09-17.63-17.16h0s-.05,0-.07,0c-.02,0-.05,0-.07,0h0c-9.75.08-17.63,7.73-17.63,17.17v18.59c0,.65-.51,1.38-1.09,1.73-1.91,1.19-3.17,3.26-3.17,5.61,0,3.68,3.09,6.67,6.91,6.67h30.12c3.81,0,6.91-2.99,6.91-6.67,0-2.36-1.27-4.43-3.18-5.61Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#632914"
	    },
	    attrs: {
	      "d": "m949.52,324.71h40.74c1.16,0,2.12-.9,2.19-2.06l1.34-20.87c.08-1.27-.92-2.34-2.19-2.34h-40.74c-1.16,0-2.12.9-2.19,2.06l-1.34,20.87c-.08,1.27.92,2.34,2.19,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m903.54,349.38v31.41h11.77v-31.41c0-1.73.71-3.31,1.85-4.45h-13.07c-.36,1.42-.56,2.92-.56,4.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "d": "m948.11,324.71h40.74c1.16,0,2.12-.9,2.19-2.06l1.34-20.87c.08-1.27-.92-2.34-2.19-2.34h-40.74c-1.16,0-2.12.9-2.19,2.06l-1.34,20.87c-.08,1.27.92,2.34,2.19,2.34Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "971.62",
	      "y": "342.83",
	      "width": "5.43",
	      "height": "41.67",
	      "rx": "1.7",
	      "ry": "1.7",
	      "transform": "translate(1948.67 727.33) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m956.95,331.69h-35.38c-4.98,0-9.5,2.03-12.78,5.31-3.05,3.05-5.02,7.19-5.28,11.76h31.95c.22-1.32.85-2.51,1.76-3.43,1.15-1.15,2.73-1.86,4.46-1.86h16.54c5.98,0,10.87-5.3,10.87-11.77h-12.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m943.61,288.38h13.96c6.36,0,11.53,5.17,11.53,11.53v31.78h-37.17v-31.62c0-6.45,5.24-11.69,11.69-11.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#3e1810"
	    },
	    attrs: {
	      "d": "m910.47,353.85c0,.94.51,1.69,1.15,1.69s1.15-.76,1.15-1.69c0-.94-.51-1.69-1.15-1.69s-1.15.76-1.15,1.69Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "864.29",
	      "y": "328.69",
	      "width": "46.04",
	      "height": "32.64",
	      "rx": "6.25",
	      "ry": "6.25",
	      "transform": "translate(1774.61 690.02) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#632914"
	    },
	    attrs: {
	      "d": "m947.83,311.79c-.02,1,.45,1.83,1.06,1.84.6.01,1.11-.79,1.13-1.8s-.45-1.83-1.06-1.84c-.6-.01-1.11.79-1.13,1.8Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m920.94,305.26h18.98c6.56,0,11.45-1.6,14.54-4.74,2.19-2.23,3.09-4.89,3.45-6.73,2.34,1.42,4.76,2.68,7.22,3.88-.81,2.59-2.26,5.61-4.87,8.31-4.64,4.81-11.49,7.25-20.34,7.25h-18.98v-7.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m958.53,309.6l-6.57-8.64c1.05-.61,6.21-9.42,6.21-9.42.06-.08.13-.17.2-.25,3.02-3.59,8.87-.88,8.31,3.78-.52,4.32-2.3,10.87-8.16,14.53Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m910.99,385.54h0c1.53,0,2.78-1.24,2.78-2.78v-52.59c0-4.49,3.64-8.14,8.14-8.14h20.84c1.53,0,2.78-1.24,2.78-2.78h0c0-1.53-1.24-2.78-2.78-2.78h-20.84c-7.56,0-13.69,6.13-13.69,13.69v52.59c0,1.53,1.24,2.78,2.78,2.78Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m937.57,299.19c.18,0,.31,0,.38,0l-.06-4.43-.03-4.44c-.74,0-18.38-.28-22.97-23.36l-8.7,1.73c3.13,15.75,11.49,23.22,17.94,26.71,6.26,3.38,11.86,3.75,13.43,3.79Z"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "x": "905.76",
	      "y": "263.05",
	      "width": "8.94",
	      "height": "10.02",
	      "rx": "2.45",
	      "ry": "2.45",
	      "transform": "translate(1857.37 325.41) rotate(167.05)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m911.55,265.95l2.55-.49-1.66-8.74c-.13-.7-.81-1.17-1.52-1.03h0c-.7.13-1.17.81-1.03,1.52l1.66,8.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m908.35,265.85l2.53-.58-1.99-8.67c-.16-.7-.86-1.13-1.56-.97h0c-.7.16-1.13.86-.97,1.56l1.99,8.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m905.81,268.35l2.5-.71-2.43-8.55c-.2-.69-.91-1.09-1.6-.89h0c-.69.2-1.09.91-.89,1.6l2.43,8.55Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "d": "m911.25,270.4l2.4.99,3.73-9.02c.27-.66-.04-1.42-.7-1.69h0c-.66-.27-1.42.04-1.69.7l-3.73,9.02Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m943.2,288.36l1.04,6.69c.14.71.94,1.06,1.55.68l3.8-2.34,3.79,2.34c.61.38,1.42.03,1.55-.68l1.04-6.69h-12.77Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m923.19,295.2l3.36-7.12c.6-1.27,2.07-1.88,3.38-1.39,4.95,1.84,8.85,1.72,8.89,1.72,0,0,.64,0,1.67,0l4.63,15.3-11.8-2.44c-2.42-.4-5.42-1.11-8.69-2.4-1.45-.57-2.11-2.27-1.44-3.68Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#decc86"
	    },
	    attrs: {
	      "x": "945.15",
	      "y": "276.29",
	      "width": "8.86",
	      "height": "12.47"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#decc86",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m949.58,293.07c2.45,0,4.43-1.98,4.43-4.43s-1.98-4.43-4.43-4.43-4.43,1.99-4.43,4.43,1.99,4.43,4.43,4.43h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f4d291"
	    },
	    attrs: {
	      "x": "911.37",
	      "y": "304.01",
	      "width": "10.42",
	      "height": "8.87",
	      "rx": "2.77",
	      "ry": "2.77"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m893.08,301.92h-32.43v7.09h32.43c-.86-2.15-.8-4.53,0-7.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m892.48,305.03h-31.83v-3.11h32.43c-.33,1.07-.54,2.11-.6,3.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#5f493b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m863.56,300.76h30.21v2.69h-30.21c-.68,0-1.3.28-1.75.72h0c-.45.45-.73,1.07-.73,1.75h0c0,.68.28,1.3.73,1.75.45.45,1.07.73,1.75.73h30.21v2.69h-30.21c-1.42,0-2.71-.58-3.65-1.51-.93-.93-1.51-2.22-1.51-3.65h0c0-1.42.58-2.71,1.51-3.65h0c.93-.93,2.22-1.51,3.64-1.51Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "901.33",
	      "y": "380.38",
	      "width": "89.04",
	      "height": "5.16",
	      "rx": "1.61",
	      "ry": "1.61",
	      "transform": "translate(1891.7 765.92) rotate(-180)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m960.03,271.35c0,2.57,2.08,4.65,4.65,4.65,2.57,0,4.65-2.08,4.65-4.65s-2.08-4.65-4.65-4.65c-2.57,0-4.65,2.08-4.65,4.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m929.61,271.35c0,2.57,2.08,4.65,4.65,4.65s4.65-2.08,4.65-4.65c0-2.57-2.08-4.65-4.65-4.65s-4.65,2.08-4.65,4.65Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m961.89,271.35c0,1.54,1.25,2.79,2.79,2.79,1.54,0,2.79-1.25,2.79-2.79s-1.25-2.79-2.79-2.79-2.79,1.25-2.79,2.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dfcc86"
	    },
	    attrs: {
	      "d": "m931.47,271.35c0,1.54,1.25,2.79,2.79,2.79s2.79-1.25,2.79-2.79c0-1.54-1.25-2.79-2.79-2.79s-2.79,1.25-2.79,2.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f0dea4"
	    },
	    attrs: {
	      "d": "m933.75,271.43c0,8.75,7.09,15.84,15.84,15.84,8.75,0,15.84-7.09,15.84-15.84v-10.64c0-8.75-7.09-10.84-15.84-10.84-16.45,0-15.84,6.46-15.84,15.84v5.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e7d197"
	    },
	    attrs: {
	      "d": "m949.6,249.95h0v37.32c8.75,0,15.84-7.09,15.84-15.84v-10.64c0-8.75-7.09-10.84-15.84-10.84Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea971e"
	    },
	    attrs: {
	      "d": "m966.33,261.7l.08.05c0-9.62-7.57-17.42-16.91-17.42s-16.59,7.47-16.89,16.81c-.11.89-.17,1.8-.17,2.74,0,.17.32.7.33.86.03.55,6.25-2.93,10.39-8.56,1.03.99,5.04,3.98,9.77,5.86,5.82,2.3,10.39,3.23,12.3,3.23,1.74,0,1.22-1.24,1.22-1.39,0-.74-.04-1.47-.11-2.18Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d48963",
	      "opacity": ".8"
	    },
	    attrs: {
	      "d": "m949.6,282.41c1.54,0,3.05-.65,3.84-1.65.2-.25.16-.61-.09-.81-.25-.2-.61-.16-.81.09-.58.73-1.74,1.21-2.94,1.21-1.48,0-2.49-.62-2.94-1.2-.19-.25-.56-.3-.81-.1-.25.2-.3.56-.1.81.8,1.04,2.24,1.65,3.85,1.65Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "942.33",
	      "cy": "271.22",
	      "r": "1.89"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7a5d49"
	    },
	    attrs: {
	      "cx": "956.85",
	      "cy": "271.22",
	      "r": "1.89"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m891.56,284.17s-.23,1-1.25,1.38c-1.03.38.54,1.51.54,1.51.83,0,1.44.02,1.88,0h0s2.45,0,2.45,0c.09,0,.18,0,.28,0h.02c.39,0,.87-.01,1.46-.01,0,0,1.57-1.13.54-1.51-1.03-.38-1.25-1.38-1.25-1.38h-4.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m893.9,287.08h1.28c.09,0,.18,0,.28,0h.02c.39,0,.87-.01,1.46,0,0,0,1.57-1.13.54-1.51-1.03-.38-1.25-1.38-1.25-1.38h-2.34v2.91h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m894.27,285.28c1.53,0,4.63-.1,4.63,1.82v4.13c0,1.92-3.1,1.81-4.63,1.81-.25,0-.5,0-.75,0-1.53,0-4.63.1-4.63-1.81v-4.13c0-1.92,3.1-1.81,4.63-1.82.25,0,.5,0,.75,0h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m894.27,285.28c1.53,0,4.63-.1,4.63,1.82v4.13c0,1.92-3.1,1.81-4.63,1.81h-.37v-7.76h.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m888.89,296.24c0-1.92,3.1-1.81,4.63-1.82.25,0,.5,0,.75,0,1.53,0,4.63-.1,4.63,1.82v14.85c0,1.92-3.1,1.81-4.63,1.81-.25,0-.5,0-.75,0-1.53,0-4.63.1-4.63-1.81v-14.85h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m893.9,294.42h.37c1.53,0,4.63-.1,4.63,1.81v14.85c0,1.92-3.1,1.81-4.63,1.81h-.37v-18.48h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "889.76 292.56 898.03 292.56 898.03 294.91 889.76 294.91 889.76 292.56 889.76 292.56"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "893.9 292.56 898.03 292.56 898.03 294.91 893.9 294.91 893.9 292.56 893.9 292.56"
	    }
	  })]), _h('polygon', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "893.08 281.03 894.71 281.03 894.71 281.89 893.08 281.89 893.08 281.03 893.08 281.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#695446",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m895.17,281.03v-1.06h0c0-.14-.06-.27-.15-.37,0,0,0-.02-.02-.02s-.02,0-.02-.02c-.1-.09-.22-.15-.37-.15h-1.44c-.3,0-.55.25-.55.55v1.07h2.54Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "893.9 281.03 894.71 281.03 894.71 281.89 893.9 281.89 893.9 281.03 893.9 281.03"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#695446",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m896.41,281.89h-5.03c-.33,0-.59.27-.59.59v1.17c0,.33.27.59.59.59h5.03c.33,0,.59-.27.59-.59h0v-1.17c0-.33-.27-.59-.59-.59Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "852.64",
	      "y": "311.05",
	      "width": "59.68",
	      "height": "5.82",
	      "rx": "1.82",
	      "ry": "1.82",
	      "transform": "translate(1764.96 627.93) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "904.5",
	      "y": "311.05",
	      "width": "56.1",
	      "height": "5.82",
	      "rx": "1.82",
	      "ry": "1.82",
	      "transform": "translate(1865.1 627.93) rotate(-180)"
	    }
	  })])])]), _h('g', {
	    attrs: {
	      "id": "scene_canteen"
	    }
	  }, [_h('rect', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "id": "canteen_rectangle",
	      "x": "1019.56",
	      "y": "523.23",
	      "width": "304.6",
	      "height": "203.94"
	    }
	  }), _h('g', {
	    attrs: {
	      "id": "canteen_complete"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1262.64,626.49c1.55.58,2.14,1,3.91,1.71.63.25,1.35-.05,1.6-.68h0l.02-.06.77.57c.55.4,1.32.28,1.72-.26h0c.14-.2.22-.42.23-.65l.39.33c.54.41,1.31.31,1.72-.22h0c.41-.54.31-1.31-.22-1.72l-5.38-4.54c-.11-.08-1.26-.67-1.36-.69-2.7-.57-8.72-1.56-11.18-1.53-22.25-1.15-29.79-10.63-32.06-21.75l-9.98-1.13c1.83,16.66,7.75,29.09,41.52,30.85.26.08.53.15.79.22h0c1.34.33,2.62.45,3.73.26,1.01-.17,2.36-.73,3.77-.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#de611e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1214.76,599.36c-.96-3.83,1.58-8.38,5.41-9.34,3.83-.96,7.49,2.04,8.45,5.87.17.66.29,1.19.74,3.04,1.08,4.41,2.41,8.82,4.51,12.75l-13.14,6.76c-2.33-5.07-3.89-10.61-5.24-16.15-.03-.14-.07-.28-.73-2.93Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1192.13,699.2l-11.27-.16.33,16.69.39-.02v2.49h11.05c-.97-8.62-.93-9.15-.51-19.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec671d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1180.89,712.74c.81,0,.94,1.37,1.18,3.06.22,1.56,1.11,2.37,1.8,2.25h8.94c.37,1.95.54,4.15.36,6.64h-22.68c-.08-6.49,5.57-10.85,10.39-11.95Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f7c5a3"
	    },
	    attrs: {
	      "x": "1170.22",
	      "y": "723.15",
	      "width": "23.15",
	      "height": "1.57"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1199.36,699.2l11.27-.16-.33,16.69-.39-.02v2.49h-11.05c.97-8.62.93-9.15.51-19.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec671d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1210.6,712.74c-.81,0-.94,1.37-1.18,3.06-.22,1.56-1.11,2.37-1.8,2.25h-8.94c-.37,1.95-.54,4.15-.36,6.64h22.68c.08-6.49-5.57-10.85-10.39-11.95Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f7c5a3"
	    },
	    attrs: {
	      "x": "1198.14",
	      "y": "723.15",
	      "width": "23.15",
	      "height": "1.57"
	    }
	  })]), _h('polygon', {
	    staticStyle: {
	      "fill": "#9acdcd",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1173.9 658.45 1177.43 703.6 1194.82 703.6 1194.82 667.42 1196.68 667.42 1196.68 703.6 1214.07 703.6 1217.6 658.45 1173.9 658.45"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#de611e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1182.12,663.54h47.75l-4.25-66.1c-.31-4.78-3.92-8.7-8.7-8.7h-21.84c-4.78,0-8.4,3.93-8.7,8.7l-4.25,66.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1188.5,610.44c-.02.09-6.43,28.64-9.9,43.22.14.19.25.4.31.64l1.59,5.82c.27.99-.33,2.02-1.32,2.29h0c-.99.27-2.02-.33-2.29-1.32l-.6-2.19-.39,7.63c-.05,1.03-.94,1.83-1.96,1.78h0c-1.03-.05-1.82-.92-1.77-1.95l.05-1.01c-.11.01-.22.02-.33.01h0c-1.03-.05-1.82-.92-1.77-1.95l.05-1.06c-.5-.36-.81-.95-.78-1.61l.59-11.6c.02-.49.24-.93.57-1.25,3.68-15.48,8.98-39.35,9-39.43l8.93,1.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#de611e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1175.7,619.01l12.05,3.99,10.7-33.65c-9.09-2.86-14.72,5.32-16.07,9.41l-6.68,20.25Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1201.7",
	      "y": "634.11",
	      "width": "6.04",
	      "height": "92.77"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#dadada"
	    },
	    attrs: {
	      "x": "1237.85",
	      "y": "580.95",
	      "width": "39.97",
	      "height": "25.9"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#878787"
	    },
	    attrs: {
	      "x": "1242.78",
	      "y": "614.22",
	      "width": "30.1",
	      "height": "1.76"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1242.78",
	      "y": "585.03",
	      "width": "30.1",
	      "height": "29.19"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#3c3c3b"
	    },
	    attrs: {
	      "points": "1263.18 592 1255.71 599.47 1269.52 599.47 1269.52 592 1263.18 592"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#575756"
	    },
	    attrs: {
	      "points": "1246.15 592 1246.15 599.47 1255.71 599.47 1263.18 592 1246.15 592"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1241.5",
	      "y": "615.98",
	      "width": "32.68",
	      "height": "12.86"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#3c3c3b"
	    },
	    attrs: {
	      "x": "1278.57",
	      "y": "623.15",
	      "width": "14.06",
	      "height": "1.14"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1278.09",
	      "y": "624.3",
	      "width": "15.03",
	      "height": "4.54"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "x": "1207.74",
	      "y": "634.11",
	      "width": "97.97",
	      "height": "92.77"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1296.49 647.54 1296.49 646.37 1288.39 646.37 1288.39 647.7 1287.71 649.06 1287.71 660.84 1297.41 660.84 1297.41 649.06 1296.49 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1281.63 647.54 1281.63 646.37 1273.53 646.37 1273.53 647.7 1272.84 649.06 1272.84 660.84 1282.55 660.84 1282.55 649.06 1281.63 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1266.77 647.54 1266.77 646.37 1258.66 646.37 1258.66 647.7 1257.98 649.06 1257.98 660.84 1267.68 660.84 1267.68 649.06 1266.77 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1251.91 647.54 1251.91 646.37 1243.8 646.37 1243.8 647.7 1243.12 649.06 1243.12 660.84 1252.82 660.84 1252.82 649.06 1251.91 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1237.04 647.54 1237.04 646.37 1228.94 646.37 1228.94 647.7 1228.26 649.06 1228.26 660.84 1237.96 660.84 1237.96 649.06 1237.04 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1222.18 647.54 1222.18 646.37 1214.07 646.37 1214.07 647.7 1213.39 649.06 1213.39 660.84 1223.1 660.84 1223.1 649.06 1222.18 647.54"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1303.14",
	      "y": "634.11",
	      "width": "6.04",
	      "height": "92.77"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "d": "m1296.71,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "d": "m1281.7,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "d": "m1266.7,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "d": "m1251.69,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1273.38",
	      "y": "706.96",
	      "width": "23.84",
	      "height": "18.42"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1244.03",
	      "y": "706.96",
	      "width": "23.84",
	      "height": "18.42"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1214.68",
	      "y": "706.96",
	      "width": "23.84",
	      "height": "18.42"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "d": "m1236.68,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "d": "m1221.67,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1252.74",
	      "y": "615.48",
	      "width": "6.04",
	      "height": "96.03",
	      "transform": "translate(1919.26 -592.26) rotate(90)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "x": "1252.56",
	      "y": "650.04",
	      "width": "6.04",
	      "height": "95.76",
	      "transform": "translate(1953.5 -557.66) rotate(90)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fdefe6"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "527.72",
	      "width": "101.39",
	      "height": "88.31"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,539.52h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,538.83v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,540.9h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,542.79h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,542.1v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,544.18h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,546.07h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,545.37v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,547.45h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,549.34h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,548.64v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,550.72h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,552.61h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,551.91v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,553.99h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })])]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,539.52h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,538.83v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,540.9h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,542.79h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,542.1v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,544.18h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,546.07h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,545.37v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,547.45h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,549.34h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,548.64v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,550.72h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cde0e8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,552.61h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,551.91v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b8ced6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,553.99h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "557.14",
	      "width": "101.39",
	      "height": "2.45"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae0ce"
	    },
	    attrs: {
	      "x": "1030.45",
	      "y": "554.85",
	      "width": "110.26",
	      "height": "3.69"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#f7d0b5"
	    },
	    attrs: {
	      "x": "1021.63",
	      "y": "634.11",
	      "width": "180.03",
	      "height": "92.77"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1079.81",
	      "y": "605.04",
	      "width": "63.66",
	      "height": "150.92",
	      "transform": "translate(1792.14 -431.14) rotate(90)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1021.63",
	      "y": "632.85",
	      "width": "287.54",
	      "height": "7.11"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1092.65,662.83c0,1.5-1.22,2.73-2.73,2.73s-2.73-1.22-2.73-2.73,1.22-2.73,2.73-2.73,2.73,1.22,2.73,2.73Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1092.12,662.83c0,1.21-.98,2.2-2.2,2.2s-2.2-.98-2.2-2.2.98-2.2,2.2-2.2,2.2.98,2.2,2.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1091.75,662.83c0,1.01-.82,1.83-1.83,1.83s-1.83-.82-1.83-1.83.82-1.83,1.83-1.83,1.83.82,1.83,1.83Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1091.45,662.83c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1091.19,662.83c0,.7-.57,1.26-1.26,1.26s-1.26-.57-1.26-1.26.57-1.26,1.26-1.26,1.26.57,1.26,1.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1090.98,662.83c0,.58-.47,1.05-1.05,1.05s-1.05-.47-1.05-1.05.47-1.05,1.05-1.05,1.05.47,1.05,1.05Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1078.74,660.95h6.08c2.75,0,4.99,2.23,4.99,4.99v.79h-16.05v-.79c0-2.75,2.23-4.99,4.99-4.99Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1095.45,659.8h1.5c2.61,0,4.73,2.12,4.73,4.73v2.2h-10.96v-2.2c0-2.61,2.12-4.73,4.73-4.73Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "2.45"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "1.98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "1.64"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "1.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1100.36,664.18c0,.63-.51,1.14-1.14,1.14s-1.14-.51-1.14-1.14.51-1.14,1.14-1.14,1.14.51,1.14,1.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1100.17,664.18c0,.52-.42.94-.94.94s-.94-.42-.94-.94.42-.94.94-.94.94.42.94.94Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1084.8,664.21c0,1.35-1.1,2.45-2.45,2.45s-2.45-1.1-2.45-2.45,1.1-2.45,2.45-2.45,2.45,1.1,2.45,2.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1084.33,664.21c0,1.09-.88,1.98-1.98,1.98s-1.98-.88-1.98-1.98.88-1.98,1.98-1.98,1.98.88,1.98,1.98Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1082.35",
	      "cy": "664.21",
	      "r": "1.64"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1083.72,664.21c0,.75-.61,1.37-1.37,1.37s-1.37-.61-1.37-1.37.61-1.37,1.37-1.37,1.37.61,1.37,1.37Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1082.35",
	      "cy": "664.21",
	      "r": "1.14"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1082.35",
	      "cy": "664.21",
	      "r": ".94"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1091.08,662.9h-.73c-2.12,0-3.83,1.72-3.83,3.83h8.4c0-2.12-1.72-3.83-3.83-3.83Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1102.84,662.9h-.73c-2.12,0-3.83,1.72-3.83,3.83h8.4c0-2.12-1.72-3.83-3.83-3.83Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1113.18,669.4h-47.91c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.91c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1103.98,672.07h-29.49c-1.47,0-2.67-1.19-2.67-2.67h34.82c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1079.14,660.95c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1079.56,660.95c0-1.23.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1091.56,663.9c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1091.14,663.9c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1107.26,664.1c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1106.85,664.1c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1068.48,666.73c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1068.9,666.73c0-1.23.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1086.03,665.72c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1101.28,663.44c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1094.46,661.92c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1079.34,662.9h-3.68c-2.12,0-3.83,1.72-3.83,3.83h11.35c0-2.12-1.72-3.83-3.83-3.83Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1079.81,664.1c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1079.4,664.1c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1082.82,661.85c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1077.71,663.68c-.09.08-.23.08-.31,0-.08-.08-.06-.22.03-.3.09-.08.47-.15.47-.15,0,0-.11.37-.2.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1077.46,661.67c-.11-.05-.17-.17-.13-.28s.17-.15.29-.1c.11.05.33.37.33.37,0,0-.38.06-.5,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1085.62,662.83c-.12,0-.23-.08-.24-.19,0-.11.09-.21.21-.22.12,0,.46.18.46.18,0,0-.32.22-.44.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1099.98,666.12c-.12.03-.24-.04-.26-.16-.02-.11.06-.22.18-.25.12-.03.48.11.48.11,0,0-.28.27-.4.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1103.02,663.56c-.11.06-.24.02-.3-.08-.05-.1,0-.23.1-.29.11-.06.5-.03.5-.03,0,0-.19.33-.3.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1092.87,665.81c-.11-.05-.17-.17-.13-.28.05-.1.17-.15.29-.1.11.05.33.37.33.37,0,0-.38.06-.5,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1094.85,661.11c-.12.02-.24-.05-.26-.16-.02-.11.06-.22.18-.25.12-.02.48.11.48.11,0,0-.28.27-.4.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1095.52,664.65c-.12.02-.24-.05-.26-.16-.02-.11.06-.22.18-.25.12-.02.48.11.48.11,0,0-.28.27-.4.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1097.41,661.24c-.12-.05-.18-.17-.13-.27.04-.11.17-.15.29-.11.12.05.34.36.34.36,0,0-.38.07-.5.02Z"
	    }
	  })])]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1113.06,693.44h-47.87c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.87c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1103.86,696.11h-29.47c-1.47,0-2.67-1.19-2.67-2.67h34.8c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#f7a53c"
	    },
	    attrs: {
	      "x": "1071.73",
	      "y": "689.77",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d56425"
	    },
	    attrs: {
	      "x": "1080.93",
	      "y": "689.77",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1089.97",
	      "y": "689.77",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1070.04",
	      "y": "688.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1078.51",
	      "y": "686.37",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-150.12 335.49) rotate(-16.45)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1092.32",
	      "y": "686.92",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-192.31 573.81) rotate(-27)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1094.39",
	      "y": "686.92",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(406.44 -409.09) rotate(25.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1089.37",
	      "y": "685.21",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(405.2 -407.08) rotate(25.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1083.21",
	      "y": "684.5",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(205.3 -250.17) rotate(14.44)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1076.26",
	      "y": "683.6",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(204.86 -248.47) rotate(14.44)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c14e17"
	    },
	    attrs: {
	      "x": "1079.25",
	      "y": "688.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c14e17"
	    },
	    attrs: {
	      "x": "1087.26",
	      "y": "685.39",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(136.47 -180.35) rotate(10.05)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c14e17"
	    },
	    attrs: {
	      "x": "1075.97",
	      "y": "684.9",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-140.63 303.93) rotate(-15.02)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8cf96"
	    },
	    attrs: {
	      "x": "1088.28",
	      "y": "688.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8cf96"
	    },
	    attrs: {
	      "x": "1075.97",
	      "y": "685.9",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-118.76 239.29) rotate(-11.96)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8cf96"
	    },
	    attrs: {
	      "x": "1086.43",
	      "y": "685.9",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-118.53 241.46) rotate(-11.96)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f7a53c"
	    },
	    attrs: {
	      "x": "1076.89",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d56425"
	    },
	    attrs: {
	      "x": "1086.1",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1094.15",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1093.84",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(272.17 -311.06) rotate(18.32)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1069.07",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(270.92 -303.27) rotate(18.32)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1080.48",
	      "y": "686.69",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(275.69 -310.62) rotate(18.58)"
	    }
	  })]), _h('g', [_h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "cx": "1138.41",
	      "cy": "661.06",
	      "r": "2.34"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "cx": "1138.41",
	      "cy": "661.06",
	      "r": "2.09"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1144.95,664.27c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1144.7,664.27c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1152.42,664.25c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1152.17,664.25c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1158.17,664.27c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1157.92,664.27c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1137.97,665.17c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1137.72,665.17c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1137.23,662.8c0,1.44-1.16,2.6-2.6,2.6s-2.6-1.16-2.6-2.6,1.16-2.6,2.6-2.6,2.6,1.16,2.6,2.6Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1134.63",
	      "cy": "662.8",
	      "r": "2.1"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1134.63",
	      "cy": "662.8",
	      "r": "1.74"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1134.63",
	      "cy": "662.8",
	      "r": "1.45"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1135.83,662.8c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21.54-1.21,1.21-1.21,1.21.54,1.21,1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1135.63,662.8c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "2.6"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "2.1"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "1.74"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "1.45"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1155.83,663.07c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21.54-1.21,1.21-1.21,1.21.54,1.21,1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1155.63,663.07c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1170.24,669.33h-47.87c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.87c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1161.04,671.99h-29.47c-1.47,0-2.67-1.19-2.67-2.67h34.8c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1133.9,664.59c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1133.3,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1142.15",
	      "cy": "659",
	      "r": "2.12"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "cx": "1142.15",
	      "cy": "659",
	      "r": "1.52"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1147.31,660.97c0,1.44-1.16,2.6-2.6,2.6s-2.6-1.16-2.6-2.6,1.16-2.6,2.6-2.6,2.6,1.16,2.6,2.6Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1146.81,660.97c0,1.16-.94,2.1-2.1,2.1s-2.1-.94-2.1-2.1.94-2.1,2.1-2.1,2.1.94,2.1,2.1Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1144.71",
	      "cy": "660.97",
	      "r": "1.74"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1144.71",
	      "cy": "660.97",
	      "r": "1.45"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1145.91,660.97c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21.54-1.21,1.21-1.21,1.21.54,1.21,1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1145.71,660.97c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1141.12,664.59c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1140.52,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1146.23",
	      "cy": "664.59",
	      "r": "2.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1147.74,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1154.1,661.51c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1153.5,661.51c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1158.34",
	      "cy": "664.59",
	      "r": "2.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1159.86,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1147.74",
	      "y": "661.8",
	      "width": "4.28",
	      "height": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1147.74",
	      "y": "661.8",
	      "width": "4.28",
	      "height": ".16"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1150.59",
	      "y": "665.47",
	      "width": "4.28",
	      "height": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1150.59",
	      "y": "665.47",
	      "width": "4.28",
	      "height": ".16"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1132.36",
	      "y": "665.47",
	      "width": "4.28",
	      "height": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1132.36",
	      "y": "665.47",
	      "width": "4.28",
	      "height": ".16"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1138.61",
	      "y": "661.55",
	      "width": "4.28",
	      "height": "1.27",
	      "transform": "translate(-146.39 373.97) rotate(-17.51)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1138.44",
	      "y": "661.58",
	      "width": "4.28",
	      "height": ".16",
	      "transform": "translate(-146.24 373.89) rotate(-17.51)"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1132.12",
	      "y": "661.23",
	      "width": "4.28",
	      "height": "1.27",
	      "transform": "translate(-45.29 84.57) rotate(-4.19)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1132.08",
	      "y": "661.23",
	      "width": "4.28",
	      "height": ".16",
	      "transform": "translate(-45.25 84.56) rotate(-4.19)"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1141.36",
	      "y": "657.74",
	      "width": "4.28",
	      "height": "1.27",
	      "transform": "translate(-45.01 85.23) rotate(-4.19)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1141.32",
	      "y": "657.74",
	      "width": "4.28",
	      "height": ".16",
	      "transform": "translate(-44.97 85.23) rotate(-4.19)"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1147.31",
	      "cy": "659.39",
	      "r": "2.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1148.83,659.39c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#587983"
	    },
	    attrs: {
	      "x": "1135.9",
	      "y": "684.96",
	      "width": "9.24",
	      "height": "5.74"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#76a1af"
	    },
	    attrs: {
	      "x": "1147.77",
	      "y": "683.79",
	      "width": "8.11",
	      "height": "6.91"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "x": "1128.89",
	      "y": "685.53",
	      "width": "5.6",
	      "height": "5.17"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "x": "1143.57",
	      "y": "686.87",
	      "width": "8.39",
	      "height": "3.83"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "x": "1155.32",
	      "y": "687.56",
	      "width": "8.39",
	      "height": "3.14"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1170.22,693.37h-47.86c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.86c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1161.02,696.03h-29.46c-1.47,0-2.67-1.19-2.67-2.67h34.79c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1136.46,684.96c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1136.88,684.96c0-1.22.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1162.61,688.07c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1162.2,688.07c0,1.22-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1136.88,690.7c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1137.29,690.7c0-1.22.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1134.9",
	      "y": "687.58",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1140.67",
	      "y": "681.81",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1149.75",
	      "y": "680.66",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1153.46",
	      "y": "687.51",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#a1daf8"
	    },
	    attrs: {
	      "x": "1042.09",
	      "y": "671.62",
	      "width": "138.52",
	      "height": "3.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#a1daf8"
	    },
	    attrs: {
	      "x": "1042.09",
	      "y": "695.74",
	      "width": "138.52",
	      "height": "3.03"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1075.86 726.89 1138.17 634.11 1021.6 634.11 1021.6 726.89 1075.86 726.89"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1093.43 726.89 1155.68 634.11 1144.52 634.11 1082.21 726.89 1093.43 726.89"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1102.25 726.89 1164.49 634.11 1162.51 634.11 1100.2 726.89 1102.25 726.89"
	    }
	  })]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1064.27,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1069.96,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1076.73,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1108.24,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1113.93,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1120.69,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1064.27,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1069.96,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1076.73,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1108.24,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1113.93,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1120.69,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "584.66",
	      "width": "101.39",
	      "height": "2.45"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae0ce"
	    },
	    attrs: {
	      "x": "1030.45",
	      "y": "582.37",
	      "width": "110.26",
	      "height": "3.69"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".4"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "613.59",
	      "width": "101.39",
	      "height": "2.45"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae0ce"
	    },
	    attrs: {
	      "x": "1030.45",
	      "y": "611.3",
	      "width": "110.26",
	      "height": "3.69"
	    }
	  })]), _h('g', [_h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#513215"
	    },
	    attrs: {
	      "d": "m1119.38,604.2s-.02,0-.04,0c-.14-.02-.24-.15-.22-.3.17-1.22-.14-2.44-.88-3.42-.74-.99-1.82-1.62-3.04-1.8-.14-.02-.24-.15-.22-.3s.15-.24.3-.22c1.36.19,2.56.91,3.38,2,.82,1.1,1.17,2.45.97,3.81-.02.13-.13.22-.26.22Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#4c9f34"
	    },
	    attrs: {
	      "d": "m1123.68,600.35c-1.49,1.82-4.2,2.06-4.2,2.06,0,0-.3-2.7,1.19-4.52,1.49-1.82,4.2-2.06,4.2-2.06,0,0,.3,2.7-1.19,4.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9ebd4c"
	    },
	    attrs: {
	      "d": "m1124.87,595.82l-5.38,6.58s2.71-.24,4.2-2.06c1.49-1.82,1.19-4.52,1.19-4.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#c9494a"
	    },
	    attrs: {
	      "d": "m1119.5,612.74c8.07,7.11,12.91-17.04,0-10.49v10.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#de6a6d"
	    },
	    attrs: {
	      "d": "m1119.5,612.75c-8.07,7.11-12.91-17.04,0-10.49v10.49Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#513215"
	    },
	    attrs: {
	      "d": "m1132.77,604.2s-.02,0-.04,0c-.14-.02-.24-.15-.22-.3.17-1.22-.14-2.44-.88-3.42-.74-.99-1.82-1.62-3.04-1.8-.14-.02-.24-.15-.22-.3s.15-.24.3-.22c1.36.19,2.56.91,3.38,2,.82,1.1,1.17,2.45.97,3.81-.02.13-.13.22-.26.22Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#4c9f34"
	    },
	    attrs: {
	      "d": "m1137.07,600.35c-1.49,1.82-4.2,2.06-4.2,2.06,0,0-.3-2.7,1.19-4.52,1.49-1.82,4.2-2.06,4.2-2.06,0,0,.3,2.7-1.19,4.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9ebd4c"
	    },
	    attrs: {
	      "d": "m1138.26,595.82l-5.38,6.58s2.71-.24,4.2-2.06c1.49-1.82,1.19-4.52,1.19-4.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#c9494a"
	    },
	    attrs: {
	      "d": "m1132.89,612.74c8.07,7.11,12.91-17.04,0-10.49v10.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#de6a6d"
	    },
	    attrs: {
	      "d": "m1132.89,612.75c-8.07,7.11-12.91-17.04,0-10.49v10.49Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#513215"
	    },
	    attrs: {
	      "d": "m1146.16,604.2s-.02,0-.04,0c-.14-.02-.24-.15-.22-.3.17-1.22-.14-2.44-.88-3.42-.74-.99-1.82-1.62-3.04-1.8-.14-.02-.24-.15-.22-.3s.15-.24.3-.22c1.36.19,2.56.91,3.38,2,.82,1.1,1.17,2.45.97,3.81-.02.13-.13.22-.26.22Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#4c9f34"
	    },
	    attrs: {
	      "d": "m1150.46,600.35c-1.49,1.82-4.2,2.06-4.2,2.06,0,0-.3-2.7,1.19-4.52,1.49-1.82,4.2-2.06,4.2-2.06,0,0,.3,2.7-1.19,4.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9ebd4c"
	    },
	    attrs: {
	      "d": "m1151.65,595.82l-5.38,6.58s2.71-.24,4.2-2.06c1.49-1.82,1.19-4.52,1.19-4.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#c9494a"
	    },
	    attrs: {
	      "d": "m1146.28,612.74c8.07,7.11,12.91-17.04,0-10.49v10.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#de6a6d"
	    },
	    attrs: {
	      "d": "m1146.28,612.75c-8.07,7.11-12.91-17.04,0-10.49v10.49Z"
	    }
	  })])])])]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m1109.28,608.52c1.76,11.68,11.84,20.64,24.02,20.64s22.25-8.95,24.02-20.64h-48.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".15"
	    },
	    attrs: {
	      "d": "m1133.26,608.52h-23.99c1.76,11.67,11.83,20.62,23.99,20.63v-20.63Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1016.19",
	      "y": "626.97",
	      "width": "296.69",
	      "height": "7.11"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1259.48,594.45c.28,0,.51.23.51.51v.71c0,.28-.23.51-.51.51h-2.04c-.09,0-.16.08-.16.16v.63c0,.09.08.16.16.16h2.55v.35h-3.06v-1.14c0-.29.22-.51.51-.51h2.04c.09,0,.16-.08.16-.16v-.71c0-.09-.08-.16-.16-.16h-2.04c-.09,0-.16.08-.16.16v.12h-.35v-.12c0-.29.22-.51.51-.51h2.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1260.75,597.48h-.35v-.35h.35v.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1264.2,595.89c.1.09.17.23.17.38v.7c0,.28-.23.51-.51.51h-2.04c-.29,0-.51-.23-.51-.51v-.07h.35v.07c0,.09.08.16.16.16h2.04c.09,0,.16-.08.16-.16v-.7c0-.09-.08-.16-.16-.16h-1.98v-.35h1.84c.09,0,.16-.08.16-.16v-.64c0-.09-.08-.16-.16-.16h-1.91c-.09,0-.16.08-.16.16v.11h-.35v-.11c0-.29.23-.51.51-.51h1.91c.29,0,.51.23.51.51v.64c0,.08-.02.16-.05.22l.02.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1267.35,594.45c.28,0,.51.23.51.51v2.01c0,.28-.23.51-.51.51h-2.04c-.29,0-.51-.23-.51-.51v-2.01c0-.29.22-.51.51-.51h2.04Zm-2.04.35c-.09,0-.16.08-.16.16v1.76l2.33-1.92h-2.16Zm2.04,2.34c.09,0,.16-.08.16-.16v-1.76l-2.33,1.92h2.17Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e6e6e6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1199.72,586c-4.63,2.14-16.23,1.96-20.38-5.29-6.89-12.06,4-29.39,7.97-33.48,4.31-4.45,9.8-7.27,14.13-7.62,14.08-1.13,25.33,13.46,25.96,16.49,1.81,8.7,4.84,28.45-4.4,31.01-16.97,4.7-17.56-2.67-23.28-1.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edb368",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1212.7,576.51h-14.67v13.23c0,9.71,14.67,9.71,14.67,0v-13.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e6e6e6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1215.06,544.85c7.82-5.08,22.59,5.88,10.47,20.13-4.59-8.06-10.47-20.13-10.47-20.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edb368",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1215.4,547.66c4.24.54,11.76,3.9,10.58,14.2-.62,5.44-1.19,6.76-1.76,9.36.86,7.79-4.69,18.62-13.26,18.82,1.58-15.12,2.85-27.26,4.43-42.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f5cb8b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1215.69,544.9c-4.26-.35-19.96-.92-21.74,13.99-1.78,14.91,1.29,18.97,2.82,21.58,3.5,5.97,10.39,8.65,14.21,9.56,5.91-.1,11.41-35.67,4.72-45.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e6e6e6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1194.89,576.87c-.33.16-2.21-9.28-1.58-13.66,1.75-1.61,2.95,4.99,13.18-1.06,10.77-6.36,6.65-13.57,16.47-11.76-.91-3.48-1.46-5.06-6.88-8.08-5.26-2.93-16.73-5.87-21.33,2.13-7.76,6.49-5.69,25.23.14,32.43Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f5cb8b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1195.13,564.88c-.29-1.06-.7-1.83-1.94-2.23-1.24-.4-3.61,0-3.98,3.6-.37,3.6,2.3,7,4.25,6.77,1.94-.23,1.76-7.17,1.67-8.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d4a15e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1194.16,565.98c-.26-.62-.6-1.15-1.35-1.39-.76-.24-1.91.02-2.14,2.21-.23,2.19,1.11,4.24,2.3,4.1.37-.04.63-.55.81-1.23-.68-.28-1.03-1.14-.79-2.01.18-.65.64-1.13,1.17-1.29,0-.25,0-.39,0-.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea5232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1192.67,574.06c.67,0,1.22-.55,1.22-1.22s-.55-1.22-1.22-1.22-1.22.55-1.22,1.22.55,1.22,1.22,1.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7b4727",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1210.47,569.97c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7b4727",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1222.51,571.94c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1219.98,579.25c-.44,2-2.28,3.43-4.39,3.3s-3.75-1.8-3.92-3.84c2.66.99,5.43,1.18,8.31.54Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "d": "m1282.95,666.55h31.47v-44.14c0-5.39-2.57-7.53-7.72-7.53h-15.69c-2.97,0-3.98,7.23-5.31,9.55,0,0-2.43-2.07-2.43.21l-.32,41.91Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1282.43,651.72c-6.9.27-11.35-1.49-13.24-5.22-2.23-4.42-.28-10.32,5.98-18.02l5.94,4.83c-5.04,6.2-5.37,9.19-5.09,9.75.14.27,1.63,1.25,6.37,1.01l.36,7.65c-.11,0-.22,0-.32.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#2e2f2f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1324.16,727.17c-.52-2.89-10.02-4.54-9.86-7.26-7.36,0-5.13,0-12.49,0-.99,2.42-1.28,4.84-1.44,7.26h23.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#2e2f2f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1270.93,727.17c.52-2.89,10.02-4.54,9.86-7.26,7.36,0,5.13,0,12.49,0,.99,2.42,1.28,4.84,1.44,7.26h-23.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1272.7,630.88l7.79,3.13c.46.19,1.06.18,1.39-.19,2.69-3.1,5.19-5.15,6.75-8.59,1.1-2.43,1.72-7.42,2.59-10.37-6.35-.23-13.87,6.12-19.19,13.81-.54.78-.21,1.86.67,2.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#66635b"
	    },
	    attrs: {
	      "d": "m1280.34,720.92l2.68-54.6h31.33l.41,54.72c-4.63,1.43-8.72,1.12-13.42.2q-.37-14.12-1.13-50.43h-3.33c-2.02,36.33-2.24,36.36-3.1,50.47-4.82.41-8.61.84-13.43-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m1291.04,614.85l1.24,8c.16.85,1.12,1.27,1.86.81l4.54-2.8,4.54,2.8c.73.45,1.69.03,1.86-.81l1.24-8h-15.28Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1279.71",
	      "y": "646.84",
	      "width": "10.47",
	      "height": "6.1",
	      "rx": "2.63",
	      "ry": "2.63"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1315.85,651.72c6.9.27,11.35-1.49,13.24-5.22,2.23-4.42.28-10.32-5.98-18.02l-5.94,4.83c5.04,6.2,5.37,9.19,5.09,9.75-.14.27-1.63,1.25-6.37,1.01l-.36,7.65c.11,0,.22,0,.32.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1325.58,630.88l-7.79,3.13c-.46.19-1.06.18-1.39-.19-2.69-3.1-5.19-5.15-6.75-8.59-1.1-2.43-1.72-7.42-2.59-10.37,6.35-.23,13.87,6.12,19.19,13.81.54.78.21,1.86-.67,2.22Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1308.1",
	      "y": "646.84",
	      "width": "10.47",
	      "height": "6.1",
	      "rx": "2.63",
	      "ry": "2.63",
	      "transform": "translate(2626.67 1299.77) rotate(180)"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1293.17,609.39v5.44c0,3.03,2.46,5.49,5.49,5.49s5.49-2.46,5.49-5.49v-5.44h-10.98Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1287.23,597.68c0,2.73-2.21,4.94-4.94,4.94-2.73,0-4.94-2.21-4.94-4.94s2.21-4.94,4.94-4.94c2.73,0,4.94,2.21,4.94,4.94Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1320.45,597.68c0,2.73-2.21,4.94-4.94,4.94s-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94c2.73,0,4.94,2.21,4.94,4.94Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#bc7946"
	    },
	    attrs: {
	      "d": "m1285.25,597.68c0,1.64-1.33,2.96-2.96,2.96-1.64,0-2.96-1.33-2.96-2.96s1.33-2.96,2.96-2.96c1.64,0,2.96,1.33,2.96,2.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#bc7946"
	    },
	    attrs: {
	      "d": "m1318.48,597.68c0,1.64-1.33,2.96-2.96,2.96-1.64,0-2.96-1.33-2.96-2.96,0-1.64,1.33-2.96,2.96-2.96,1.64,0,2.96,1.33,2.96,2.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1315.53,597.77c0,9.29-7.53,16.82-16.82,16.82-9.29,0-16.82-7.53-16.82-16.82v-11.3c0-9.29,7.53-11.51,16.82-11.51,17.46,0,16.82,6.86,16.82,16.82v5.98Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c57f4a"
	    },
	    attrs: {
	      "d": "m1298.71,574.96v39.63c9.29,0,16.82-7.53,16.82-16.82v-5.98c0-9.96.64-16.82-16.82-16.82Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#713b27"
	    },
	    attrs: {
	      "d": "m1282.27,593.36c.21-4.34.93-10.85,4.76-10.85,2.84,0,2.94.65,11.56.65,7.63,0,9.17-.86,12.03-.86,3.06,0,4.49,2.75,4.54,8.42.01,1.17.09,2.34.16,3.5.04.68.09,1.37.12,2.05.01.28.09,1.02.45.95.41-.08.45-1.58.49-1.9.29-2.26.37-4.58.37-6.86,0-4.2,1.22-12.29-6.39-17.34-4.68-3.1-14.34-3.41-19.73-1.65-3.75,1.22-7.34,4.41-8.68,8.12-1.47,4.08-1.43,7.26-.95,15.33.05.88.16,1.75.28,2.62.08.58.16,1.17.3,1.73.31,1.23.73.35.72-.41-.02-1.17-.1-2.33-.05-3.51Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#7b4727"
	    },
	    attrs: {
	      "cx": "1291.3",
	      "cy": "596.2",
	      "r": "1.96"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7b4727"
	    },
	    attrs: {
	      "cx": "1306.55",
	      "cy": "596.2",
	      "r": "1.96"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1293.82,604.46h9.82c.19,0,.35.16.35.35,0,2.13-2.46,3.99-5.26,3.99-3.15,0-5.26-2.06-5.26-3.99,0-.19.16-.35.35-.35Z"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1299.05",
	      "y": "639.25",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "points": "1306.59 639.69 1291.15 639.18 1291.15 643.89 1306.59 643.89 1306.59 639.69"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "points": "1309.57 641.57 1288.52 642.67 1288.52 643.89 1309.57 643.89 1309.57 641.57"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1313.55,645.5h-28.99c-.45,0-.81-.36-.81-.81h0c0-.45.36-.81.81-.81h28.99c.45,0,.81.36.81.81h0c0,.45-.36.81-.81.81Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1307.98,647.12h-17.85c-.89,0-1.61-.72-1.61-1.61h21.08c0,.89-.72,1.61-1.61,1.61Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1291.97",
	      "y": "639.96",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1294.38",
	      "y": "638.09",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1294.09",
	      "y": "642.28",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1300.81",
	      "y": "638.09",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1295.35",
	      "y": "641.57",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1295.18",
	      "y": "637.37",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1304.15",
	      "y": "641.57",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1307.79",
	      "y": "642.28",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1299.95",
	      "y": "642.28",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1304",
	      "y": "639.96",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1292.07,640.44c-.53-.53-1.38-.53-1.91,0l-.37.37c-.53.53-.53,1.38,0,1.91l.13.13.7-.7,1.2,1.2c.24.24.64.24.88,0,.24-.24.24-.64,0-.88l-1.2-1.2.7-.7-.13-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1308.74,641.58c.53-.53.53-1.38,0-1.91l-.37-.37c-.53-.53-1.38-.53-1.91,0l-.13.13.7.7-1.2,1.2c-.24.24-.24.64,0,.88s.64.24.88,0l1.2-1.2.7.7.13-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1299.42,640.62c.53-.53.53-1.38,0-1.91l-.37-.37c-.53-.53-1.38-.53-1.91,0l-.13.13.7.7-1.2,1.2c-.24.24-.24.64,0,.88s.64.24.88,0l1.2-1.2.7.7.13-.13Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1311.33",
	      "y": "643.5",
	      "width": "6.96",
	      "height": "2.95",
	      "rx": "1.27",
	      "ry": "1.27",
	      "transform": "translate(2629.62 1289.96) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1279.99",
	      "y": "643.5",
	      "width": "6.96",
	      "height": "2.95",
	      "rx": "1.27",
	      "ry": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dadada"
	    },
	    attrs: {
	      "x": "1280.96",
	      "y": "646.45",
	      "width": "36.28",
	      "height": "2.07"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "canteen_inactive"
	    }
	  }, [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1262.64,626.49c1.55.58,2.14,1,3.91,1.71.63.25,1.35-.05,1.6-.68h0l.02-.06.77.57c.55.4,1.32.28,1.72-.26h0c.14-.2.22-.42.23-.65l.39.33c.54.41,1.31.31,1.72-.22h0c.41-.54.31-1.31-.22-1.72l-5.38-4.54c-.11-.08-1.26-.67-1.36-.69-2.7-.57-8.72-1.56-11.18-1.53-22.25-1.15-29.79-10.63-32.06-21.75l-9.98-1.13c1.83,16.66,7.75,29.09,41.52,30.85.26.08.53.15.79.22h0c1.34.33,2.62.45,3.73.26,1.01-.17,2.36-.73,3.77-.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#4c3424",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1214.76,599.36c-.96-3.83,1.58-8.38,5.41-9.34,3.83-.96,7.49,2.04,8.45,5.87.17.66.29,1.19.74,3.04,1.08,4.41,2.41,8.82,4.51,12.75l-13.14,6.76c-2.33-5.07-3.89-10.61-5.24-16.15-.03-.14-.07-.28-.73-2.93Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1192.13,699.2l-11.27-.16.33,16.69.39-.02v2.49h11.05c-.97-8.62-.93-9.15-.51-19.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec671d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1180.89,712.74c.81,0,.94,1.37,1.18,3.06.22,1.56,1.11,2.37,1.8,2.25h8.94c.37,1.95.54,4.15.36,6.64h-22.68c-.08-6.49,5.57-10.85,10.39-11.95Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f7c5a3"
	    },
	    attrs: {
	      "x": "1170.22",
	      "y": "723.15",
	      "width": "23.15",
	      "height": "1.57"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1199.36,699.2l11.27-.16-.33,16.69-.39-.02v2.49h-11.05c.97-8.62.93-9.15.51-19.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec671d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1210.6,712.74c-.81,0-.94,1.37-1.18,3.06-.22,1.56-1.11,2.37-1.8,2.25h-8.94c-.37,1.95-.54,4.15-.36,6.64h22.68c.08-6.49-5.57-10.85-10.39-11.95Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f7c5a3"
	    },
	    attrs: {
	      "x": "1198.14",
	      "y": "723.15",
	      "width": "23.15",
	      "height": "1.57"
	    }
	  })]), _h('polygon', {
	    staticStyle: {
	      "fill": "#9acdcd",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1173.9 658.45 1177.43 703.6 1194.82 703.6 1194.82 667.42 1196.68 667.42 1196.68 703.6 1214.07 703.6 1217.6 658.45 1173.9 658.45"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#4c3424",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1182.12,663.54h47.75l-4.25-66.1c-.31-4.78-3.92-8.7-8.7-8.7h-21.84c-4.78,0-8.4,3.93-8.7,8.7l-4.25,66.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3d392",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1188.5,610.44c-.02.09-6.43,28.64-9.9,43.22.14.19.25.4.31.64l1.59,5.82c.27.99-.33,2.02-1.32,2.29h0c-.99.27-2.02-.33-2.29-1.32l-.6-2.19-.39,7.63c-.05,1.03-.94,1.83-1.96,1.78h0c-1.03-.05-1.82-.92-1.77-1.95l.05-1.01c-.11.01-.22.02-.33.01h0c-1.03-.05-1.82-.92-1.77-1.95l.05-1.06c-.5-.36-.81-.95-.78-1.61l.59-11.6c.02-.49.24-.93.57-1.25,3.68-15.48,8.98-39.35,9-39.43l8.93,1.97Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#4c3424",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1175.7,619.01l12.05,3.99,10.7-33.65c-9.09-2.86-14.72,5.32-16.07,9.41l-6.68,20.25Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1201.7",
	      "y": "634.11",
	      "width": "6.04",
	      "height": "92.77"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "1237.85",
	      "y": "580.95",
	      "width": "39.97",
	      "height": "25.9"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#878787"
	    },
	    attrs: {
	      "x": "1242.78",
	      "y": "614.22",
	      "width": "30.1",
	      "height": "1.76"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1242.78",
	      "y": "585.03",
	      "width": "30.1",
	      "height": "29.19"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#3c3c3b"
	    },
	    attrs: {
	      "points": "1263.18 592 1255.71 599.47 1269.52 599.47 1269.52 592 1263.18 592"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#575756"
	    },
	    attrs: {
	      "points": "1246.15 592 1246.15 599.47 1255.71 599.47 1263.18 592 1246.15 592"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1241.5",
	      "y": "615.98",
	      "width": "32.68",
	      "height": "12.86"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#3c3c3b"
	    },
	    attrs: {
	      "x": "1278.57",
	      "y": "623.15",
	      "width": "14.06",
	      "height": "1.14"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1278.09",
	      "y": "624.3",
	      "width": "15.03",
	      "height": "4.54"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#563f2f"
	    },
	    attrs: {
	      "x": "1207.74",
	      "y": "634.11",
	      "width": "97.97",
	      "height": "92.77"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1296.49 647.54 1296.49 646.37 1288.39 646.37 1288.39 647.7 1287.71 649.06 1287.71 660.84 1297.41 660.84 1297.41 649.06 1296.49 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1281.63 647.54 1281.63 646.37 1273.53 646.37 1273.53 647.7 1272.84 649.06 1272.84 660.84 1282.55 660.84 1282.55 649.06 1281.63 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1266.77 647.54 1266.77 646.37 1258.66 646.37 1258.66 647.7 1257.98 649.06 1257.98 660.84 1267.68 660.84 1267.68 649.06 1266.77 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1251.91 647.54 1251.91 646.37 1243.8 646.37 1243.8 647.7 1243.12 649.06 1243.12 660.84 1252.82 660.84 1252.82 649.06 1251.91 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1237.04 647.54 1237.04 646.37 1228.94 646.37 1228.94 647.7 1228.26 649.06 1228.26 660.84 1237.96 660.84 1237.96 649.06 1237.04 647.54"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1222.18 647.54 1222.18 646.37 1214.07 646.37 1214.07 647.7 1213.39 649.06 1213.39 660.84 1223.1 660.84 1223.1 649.06 1222.18 647.54"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1303.14",
	      "y": "634.11",
	      "width": "6.04",
	      "height": "92.77"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1296.71,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1281.7,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1266.7,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1251.69,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1273.38",
	      "y": "706.96",
	      "width": "23.84",
	      "height": "18.42"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1244.03",
	      "y": "706.96",
	      "width": "23.84",
	      "height": "18.42"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1214.68",
	      "y": "706.96",
	      "width": "23.84",
	      "height": "18.42"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1236.68,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1221.67,684.72c.02-.07.03-.15.03-.23v-2.89s0-.04,0-.05c0,0,0,0,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.02,0-.05-.01-.08,0-.02,0-.05-.01-.07,0-.03-.01-.06-.02-.09,0-.03-.01-.06-.02-.09,0-.04-.02-.08-.03-.11,0-.03-.02-.06-.03-.1-.01-.05-.03-.09-.05-.14-.01-.03-.02-.06-.03-.09,0,0,0,0,0-.01h0c-.28-.78-.91-1.91-2.31-3.02v-.28h.14s.08-.04.08-.08v-.06s-.04-.08-.08-.08h-.14v-.14h.15s.08-.04.08-.08v-1.24c0-.2-.16-.36-.36-.36h-2.06c-.2,0-.36.16-.36.36v1.24s.04.08.08.08h.15v.14h-.14s-.08.04-.08.08v.06s.04.08.08.08h.14v.28c-1.4,1.1-2.03,2.23-2.31,3.02h0s0,0,0,.01c-.01.03-.02.06-.03.09-.02.05-.03.1-.05.14-.01.03-.02.06-.03.1-.01.04-.02.08-.03.11,0,.03-.01.06-.02.09,0,.03-.01.06-.02.09,0,.03,0,.05-.01.07,0,.03,0,.05-.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.02,0,.02,0,.04,0,.05v2.89c0,.08,0,.16.03.23h0c.04.17.11.32.22.45h0s0,0,0,0c.06.07.12.13.2.18v.39c-.07.05-.14.11-.2.18,0,0,0,0,0,0h0c-.16.19-.25.42-.25.68v8.29c0,.59.48,1.07,1.07,1.07h5.27c.59,0,1.07-.48,1.07-1.07v-8.29c0-.26-.1-.5-.25-.68h0s0,0,0,0c-.06-.07-.12-.13-.2-.18v-.39c.07-.05.14-.11.2-.18,0,0,0,0,0,0h0c.11-.13.18-.28.22-.45h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1252.74",
	      "y": "615.48",
	      "width": "6.04",
	      "height": "96.03",
	      "transform": "translate(1919.26 -592.26) rotate(90)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1252.56",
	      "y": "650.04",
	      "width": "6.04",
	      "height": "95.76",
	      "transform": "translate(1953.5 -557.66) rotate(90)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eceae8"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "527.72",
	      "width": "101.39",
	      "height": "88.31"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,539.52h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,538.83v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,540.9h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,542.79h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,542.1v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,544.18h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,546.07h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,545.37v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,547.45h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,549.34h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,548.64v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,550.72h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1047.96,552.61h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1046.88,551.91v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1050.02,553.99h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })])]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,539.52h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,538.83v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,540.9h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,542.79h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,542.1v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,544.18h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,546.07h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,545.37v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,547.45h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,549.34h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,548.64v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,550.72h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1091.42,552.61h30.75c-1.97,0-1.61,2.56-4.97,2.56h-20.82c-3.35,0-3-2.56-4.97-2.56h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2cfba",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1090.34,551.91v.45c0,.25.2.45.45.45h32.02c.25,0,.45-.2.45-.45v-.45c0-.25-.2-.45-.45-.45h-32.02c-.25,0-.45.2-.45.45h0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1093.48,553.99h26.64c-.57.61-1.32,1.18-2.91,1.18h-20.82c-1.59,0-2.34-.57-2.91-1.18h0Z"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "557.14",
	      "width": "101.39",
	      "height": "2.45"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d9d4d1"
	    },
	    attrs: {
	      "x": "1030.45",
	      "y": "554.85",
	      "width": "110.26",
	      "height": "3.69"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#c7bfba"
	    },
	    attrs: {
	      "x": "1021.63",
	      "y": "634.11",
	      "width": "180.03",
	      "height": "92.77"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "x": "1079.81",
	      "y": "605.04",
	      "width": "63.66",
	      "height": "150.92",
	      "transform": "translate(1792.14 -431.14) rotate(90)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1021.63",
	      "y": "632.85",
	      "width": "287.54",
	      "height": "7.11"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1092.65,662.83c0,1.5-1.22,2.73-2.73,2.73s-2.73-1.22-2.73-2.73,1.22-2.73,2.73-2.73,2.73,1.22,2.73,2.73Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1092.12,662.83c0,1.21-.98,2.2-2.2,2.2s-2.2-.98-2.2-2.2.98-2.2,2.2-2.2,2.2.98,2.2,2.2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1091.75,662.83c0,1.01-.82,1.83-1.83,1.83s-1.83-.82-1.83-1.83.82-1.83,1.83-1.83,1.83.82,1.83,1.83Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1091.45,662.83c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1091.19,662.83c0,.7-.57,1.26-1.26,1.26s-1.26-.57-1.26-1.26.57-1.26,1.26-1.26,1.26.57,1.26,1.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1090.98,662.83c0,.58-.47,1.05-1.05,1.05s-1.05-.47-1.05-1.05.47-1.05,1.05-1.05,1.05.47,1.05,1.05Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1078.74,660.95h6.08c2.75,0,4.99,2.23,4.99,4.99v.79h-16.05v-.79c0-2.75,2.23-4.99,4.99-4.99Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1095.45,659.8h1.5c2.61,0,4.73,2.12,4.73,4.73v2.2h-10.96v-2.2c0-2.61,2.12-4.73,4.73-4.73Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "2.45"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "1.98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "1.64"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1099.23",
	      "cy": "664.18",
	      "r": "1.37"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1100.36,664.18c0,.63-.51,1.14-1.14,1.14s-1.14-.51-1.14-1.14.51-1.14,1.14-1.14,1.14.51,1.14,1.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1100.17,664.18c0,.52-.42.94-.94.94s-.94-.42-.94-.94.42-.94.94-.94.94.42.94.94Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1084.8,664.21c0,1.35-1.1,2.45-2.45,2.45s-2.45-1.1-2.45-2.45,1.1-2.45,2.45-2.45,2.45,1.1,2.45,2.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1084.33,664.21c0,1.09-.88,1.98-1.98,1.98s-1.98-.88-1.98-1.98.88-1.98,1.98-1.98,1.98.88,1.98,1.98Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1082.35",
	      "cy": "664.21",
	      "r": "1.64"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1083.72,664.21c0,.75-.61,1.37-1.37,1.37s-1.37-.61-1.37-1.37.61-1.37,1.37-1.37,1.37.61,1.37,1.37Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1082.35",
	      "cy": "664.21",
	      "r": "1.14"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1082.35",
	      "cy": "664.21",
	      "r": ".94"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1091.08,662.9h-.73c-2.12,0-3.83,1.72-3.83,3.83h8.4c0-2.12-1.72-3.83-3.83-3.83Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1102.84,662.9h-.73c-2.12,0-3.83,1.72-3.83,3.83h8.4c0-2.12-1.72-3.83-3.83-3.83Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1113.18,669.4h-47.91c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.91c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1103.98,672.07h-29.49c-1.47,0-2.67-1.19-2.67-2.67h34.82c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1079.14,660.95c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1079.56,660.95c0-1.23.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1091.56,663.9c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1091.14,663.9c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1107.26,664.1c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1106.85,664.1c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1068.48,666.73c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1068.9,666.73c0-1.23.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1086.03,665.72c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1101.28,663.44c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1094.46,661.92c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1079.34,662.9h-3.68c-2.12,0-3.83,1.72-3.83,3.83h11.35c0-2.12-1.72-3.83-3.83-3.83Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1079.81,664.1c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.27Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1079.4,664.1c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#424242"
	    },
	    attrs: {
	      "d": "m1082.82,661.85c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1077.71,663.68c-.09.08-.23.08-.31,0-.08-.08-.06-.22.03-.3.09-.08.47-.15.47-.15,0,0-.11.37-.2.45Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1077.46,661.67c-.11-.05-.17-.17-.13-.28s.17-.15.29-.1c.11.05.33.37.33.37,0,0-.38.06-.5,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1085.62,662.83c-.12,0-.23-.08-.24-.19,0-.11.09-.21.21-.22.12,0,.46.18.46.18,0,0-.32.22-.44.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1099.98,666.12c-.12.03-.24-.04-.26-.16-.02-.11.06-.22.18-.25.12-.03.48.11.48.11,0,0-.28.27-.4.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1103.02,663.56c-.11.06-.24.02-.3-.08-.05-.1,0-.23.1-.29.11-.06.5-.03.5-.03,0,0-.19.33-.3.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1092.87,665.81c-.11-.05-.17-.17-.13-.28.05-.1.17-.15.29-.1.11.05.33.37.33.37,0,0-.38.06-.5,0Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1094.85,661.11c-.12.02-.24-.05-.26-.16-.02-.11.06-.22.18-.25.12-.02.48.11.48.11,0,0-.28.27-.4.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1095.52,664.65c-.12.02-.24-.05-.26-.16-.02-.11.06-.22.18-.25.12-.02.48.11.48.11,0,0-.28.27-.4.29Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f6d75a"
	    },
	    attrs: {
	      "d": "m1097.41,661.24c-.12-.05-.18-.17-.13-.27.04-.11.17-.15.29-.11.12.05.34.36.34.36,0,0-.38.07-.5.02Z"
	    }
	  })])]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1113.06,693.44h-47.87c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.87c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1103.86,696.11h-29.47c-1.47,0-2.67-1.19-2.67-2.67h34.8c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#f7a53c"
	    },
	    attrs: {
	      "x": "1071.73",
	      "y": "689.77",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d56425"
	    },
	    attrs: {
	      "x": "1080.93",
	      "y": "689.77",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1089.97",
	      "y": "689.77",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1070.04",
	      "y": "688.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1078.51",
	      "y": "686.37",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-150.12 335.49) rotate(-16.45)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1092.32",
	      "y": "686.92",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-192.31 573.81) rotate(-27)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1094.39",
	      "y": "686.92",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(406.44 -409.09) rotate(25.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1089.37",
	      "y": "685.21",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(405.2 -407.08) rotate(25.67)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1083.21",
	      "y": "684.5",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(205.3 -250.17) rotate(14.44)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f49531"
	    },
	    attrs: {
	      "x": "1076.26",
	      "y": "683.6",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(204.86 -248.47) rotate(14.44)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c14e17"
	    },
	    attrs: {
	      "x": "1079.25",
	      "y": "688.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c14e17"
	    },
	    attrs: {
	      "x": "1087.26",
	      "y": "685.39",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(136.47 -180.35) rotate(10.05)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c14e17"
	    },
	    attrs: {
	      "x": "1075.97",
	      "y": "684.9",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-140.63 303.93) rotate(-15.02)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8cf96"
	    },
	    attrs: {
	      "x": "1088.28",
	      "y": "688.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8cf96"
	    },
	    attrs: {
	      "x": "1075.97",
	      "y": "685.9",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-118.76 239.29) rotate(-11.96)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e8cf96"
	    },
	    attrs: {
	      "x": "1086.43",
	      "y": "685.9",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(-118.53 241.46) rotate(-11.96)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f7a53c"
	    },
	    attrs: {
	      "x": "1076.89",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d56425"
	    },
	    attrs: {
	      "x": "1086.1",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1094.15",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1093.84",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(272.17 -311.06) rotate(18.32)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1069.07",
	      "y": "687.76",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(270.92 -303.27) rotate(18.32)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#f6dea2"
	    },
	    attrs: {
	      "x": "1080.48",
	      "y": "686.69",
	      "width": "13.2",
	      "height": "1.01",
	      "transform": "translate(275.69 -310.62) rotate(18.58)"
	    }
	  })]), _h('g', [_h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "cx": "1138.41",
	      "cy": "661.06",
	      "r": "2.34"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "cx": "1138.41",
	      "cy": "661.06",
	      "r": "2.09"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1144.95,664.27c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1144.7,664.27c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1152.42,664.25c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1152.17,664.25c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1158.17,664.27c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1157.92,664.27c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "d": "m1137.97,665.17c0,1.29-1.05,2.34-2.34,2.34s-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34,2.34,1.05,2.34,2.34Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "d": "m1137.72,665.17c0,1.15-.94,2.09-2.09,2.09s-2.09-.94-2.09-2.09.94-2.09,2.09-2.09,2.09.94,2.09,2.09Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1137.23,662.8c0,1.44-1.16,2.6-2.6,2.6s-2.6-1.16-2.6-2.6,1.16-2.6,2.6-2.6,2.6,1.16,2.6,2.6Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1134.63",
	      "cy": "662.8",
	      "r": "2.1"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1134.63",
	      "cy": "662.8",
	      "r": "1.74"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1134.63",
	      "cy": "662.8",
	      "r": "1.45"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1135.83,662.8c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21.54-1.21,1.21-1.21,1.21.54,1.21,1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1135.63,662.8c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "2.6"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "2.1"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "1.74"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1154.63",
	      "cy": "663.07",
	      "r": "1.45"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1155.83,663.07c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21.54-1.21,1.21-1.21,1.21.54,1.21,1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1155.63,663.07c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1170.24,669.33h-47.87c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.87c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1161.04,671.99h-29.47c-1.47,0-2.67-1.19-2.67-2.67h34.8c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1133.9,664.59c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1133.3,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1142.15",
	      "cy": "659",
	      "r": "2.12"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "cx": "1142.15",
	      "cy": "659",
	      "r": "1.52"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1147.31,660.97c0,1.44-1.16,2.6-2.6,2.6s-2.6-1.16-2.6-2.6,1.16-2.6,2.6-2.6,2.6,1.16,2.6,2.6Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1146.81,660.97c0,1.16-.94,2.1-2.1,2.1s-2.1-.94-2.1-2.1.94-2.1,2.1-2.1,2.1.94,2.1,2.1Z"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "cx": "1144.71",
	      "cy": "660.97",
	      "r": "1.74"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1144.71",
	      "cy": "660.97",
	      "r": "1.45"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#a7b0d9"
	    },
	    attrs: {
	      "d": "m1145.91,660.97c0,.67-.54,1.21-1.21,1.21s-1.21-.54-1.21-1.21.54-1.21,1.21-1.21,1.21.54,1.21,1.21Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1145.71,660.97c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1,1,.45,1,1Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1141.12,664.59c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1140.52,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1146.23",
	      "cy": "664.59",
	      "r": "2.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1147.74,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1154.1,661.51c0,1.17-.95,2.12-2.12,2.12s-2.12-.95-2.12-2.12.95-2.12,2.12-2.12,2.12.95,2.12,2.12Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1153.5,661.51c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1158.34",
	      "cy": "664.59",
	      "r": "2.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1159.86,664.59c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1147.74",
	      "y": "661.8",
	      "width": "4.28",
	      "height": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1147.74",
	      "y": "661.8",
	      "width": "4.28",
	      "height": ".16"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1150.59",
	      "y": "665.47",
	      "width": "4.28",
	      "height": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1150.59",
	      "y": "665.47",
	      "width": "4.28",
	      "height": ".16"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1132.36",
	      "y": "665.47",
	      "width": "4.28",
	      "height": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1132.36",
	      "y": "665.47",
	      "width": "4.28",
	      "height": ".16"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1138.61",
	      "y": "661.55",
	      "width": "4.28",
	      "height": "1.27",
	      "transform": "translate(-146.39 373.97) rotate(-17.51)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1138.44",
	      "y": "661.58",
	      "width": "4.28",
	      "height": ".16",
	      "transform": "translate(-146.24 373.89) rotate(-17.51)"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1132.12",
	      "y": "661.23",
	      "width": "4.28",
	      "height": "1.27",
	      "transform": "translate(-45.29 84.57) rotate(-4.19)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1132.08",
	      "y": "661.23",
	      "width": "4.28",
	      "height": ".16",
	      "transform": "translate(-45.25 84.56) rotate(-4.19)"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#fac38d"
	    },
	    attrs: {
	      "x": "1141.36",
	      "y": "657.74",
	      "width": "4.28",
	      "height": "1.27",
	      "transform": "translate(-45.01 85.23) rotate(-4.19)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#eaad74"
	    },
	    attrs: {
	      "x": "1141.32",
	      "y": "657.74",
	      "width": "4.28",
	      "height": ".16",
	      "transform": "translate(-44.97 85.23) rotate(-4.19)"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "cx": "1147.31",
	      "cy": "659.39",
	      "r": "2.12"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1148.83,659.39c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52.68-1.52,1.52-1.52,1.52.68,1.52,1.52Z"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#587983"
	    },
	    attrs: {
	      "x": "1135.9",
	      "y": "684.96",
	      "width": "9.24",
	      "height": "5.74"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#76a1af"
	    },
	    attrs: {
	      "x": "1147.77",
	      "y": "683.79",
	      "width": "8.11",
	      "height": "6.91"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "x": "1128.89",
	      "y": "685.53",
	      "width": "5.6",
	      "height": "5.17"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "x": "1143.57",
	      "y": "686.87",
	      "width": "8.39",
	      "height": "3.83"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "x": "1155.32",
	      "y": "687.56",
	      "width": "8.39",
	      "height": "3.14"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1170.22,693.37h-47.86c-.74,0-1.33-.6-1.33-1.33h0c0-.74.6-1.33,1.33-1.33h47.86c.74,0,1.33.6,1.33,1.33h0c0,.74-.6,1.33-1.33,1.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1161.02,696.03h-29.46c-1.47,0-2.67-1.19-2.67-2.67h34.79c0,1.47-1.19,2.67-2.67,2.67Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1136.46,684.96c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1136.88,684.96c0-1.22.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1162.61,688.07c0,1.45-1.18,2.63-2.63,2.63s-2.63-1.18-2.63-2.63h5.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1162.2,688.07c0,1.22-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22h4.44Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#cc2f2c"
	    },
	    attrs: {
	      "d": "m1136.88,690.7c0-1.45,1.18-2.63,2.63-2.63s2.63,1.18,2.63,2.63h-5.26Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e33939"
	    },
	    attrs: {
	      "d": "m1137.29,690.7c0-1.22.99-2.22,2.22-2.22s2.22.99,2.22,2.22h-4.44Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1134.9",
	      "y": "687.58",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1140.67",
	      "y": "681.81",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1149.75",
	      "y": "680.66",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#fae79c"
	    },
	    attrs: {
	      "x": "1153.46",
	      "y": "687.51",
	      "width": "3.12",
	      "height": "3.12"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1042.09",
	      "y": "671.62",
	      "width": "138.52",
	      "height": "3.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1042.09",
	      "y": "695.74",
	      "width": "138.52",
	      "height": "3.03"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1075.86 726.89 1138.17 634.11 1021.6 634.11 1021.6 726.89 1075.86 726.89"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1093.43 726.89 1155.68 634.11 1144.52 634.11 1082.21 726.89 1093.43 726.89"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1102.25 726.89 1164.49 634.11 1162.51 634.11 1100.2 726.89 1102.25 726.89"
	    }
	  })]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1064.27,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1069.96,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1076.73,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1108.24,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1113.93,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "572.51",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "572.46",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1120.69,572.46c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1056.95",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1064.27,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1062.64",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1069.96,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1069.4",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1076.73,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#d1d3d4"
	    },
	    attrs: {
	      "cx": "1100.92",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1108.24,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#f1f2f2"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#e6e7e9"
	    },
	    attrs: {
	      "cx": "1106.61",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1113.93,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })]), _h('g', [_h('ellipse', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "602.08",
	      "rx": "10.2",
	      "ry": "10.24"
	    }
	  }), _h('ellipse', {
	    staticStyle: {
	      "fill": "#f4f4f4"
	    },
	    attrs: {
	      "cx": "1113.37",
	      "cy": "602.02",
	      "rx": "7.32",
	      "ry": "7.35"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#eaeaea"
	    },
	    attrs: {
	      "d": "m1120.69,602.02c0-4.06-3.28-7.35-7.32-7.35-1.17,0-2.28.28-3.26.77.83-.32,1.72-.5,2.67-.5,4.04,0,7.32,3.29,7.32,7.35,0,2.88-1.65,5.37-4.06,6.58,2.73-1.07,4.66-3.73,4.66-6.85Z"
	    }
	  })])]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "584.66",
	      "width": "101.39",
	      "height": "2.45"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d9d4d1"
	    },
	    attrs: {
	      "x": "1030.45",
	      "y": "582.37",
	      "width": "110.26",
	      "height": "3.69"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#090400",
	      "mix-blend-mode": "multiply",
	      "opacity": ".4"
	    },
	    attrs: {
	      "x": "1034.89",
	      "y": "613.59",
	      "width": "101.39",
	      "height": "2.45"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d9d4d1"
	    },
	    attrs: {
	      "x": "1030.45",
	      "y": "611.3",
	      "width": "110.26",
	      "height": "3.69"
	    }
	  })]), _h('g', [_h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#513215"
	    },
	    attrs: {
	      "d": "m1119.38,604.2s-.02,0-.04,0c-.14-.02-.24-.15-.22-.3.17-1.22-.14-2.44-.88-3.42-.74-.99-1.82-1.62-3.04-1.8-.14-.02-.24-.15-.22-.3s.15-.24.3-.22c1.36.19,2.56.91,3.38,2,.82,1.1,1.17,2.45.97,3.81-.02.13-.13.22-.26.22Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1123.68,600.35c-1.49,1.82-4.2,2.06-4.2,2.06,0,0-.3-2.7,1.19-4.52,1.49-1.82,4.2-2.06,4.2-2.06,0,0,.3,2.7-1.19,4.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m1124.87,595.82l-5.38,6.58s2.71-.24,4.2-2.06c1.49-1.82,1.19-4.52,1.19-4.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m1119.5,612.74c8.07,7.11,12.91-17.04,0-10.49v10.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1119.5,612.75c-8.07,7.11-12.91-17.04,0-10.49v10.49Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#513215"
	    },
	    attrs: {
	      "d": "m1132.77,604.2s-.02,0-.04,0c-.14-.02-.24-.15-.22-.3.17-1.22-.14-2.44-.88-3.42-.74-.99-1.82-1.62-3.04-1.8-.14-.02-.24-.15-.22-.3s.15-.24.3-.22c1.36.19,2.56.91,3.38,2,.82,1.1,1.17,2.45.97,3.81-.02.13-.13.22-.26.22Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1137.07,600.35c-1.49,1.82-4.2,2.06-4.2,2.06,0,0-.3-2.7,1.19-4.52s4.2-2.06,4.2-2.06c0,0,.3,2.7-1.19,4.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m1138.26,595.82l-5.38,6.58s2.71-.24,4.2-2.06c1.49-1.82,1.19-4.52,1.19-4.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m1132.89,612.74c8.07,7.11,12.91-17.04,0-10.49v10.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1132.89,612.75c-8.07,7.11-12.91-17.04,0-10.49v10.49Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#513215"
	    },
	    attrs: {
	      "d": "m1146.16,604.2s-.02,0-.04,0c-.14-.02-.24-.15-.22-.3.17-1.22-.14-2.44-.88-3.42-.74-.99-1.82-1.62-3.04-1.8-.14-.02-.24-.15-.22-.3s.15-.24.3-.22c1.36.19,2.56.91,3.38,2,.82,1.1,1.17,2.45.97,3.81-.02.13-.13.22-.26.22Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1150.46,600.35c-1.49,1.82-4.2,2.06-4.2,2.06,0,0-.3-2.7,1.19-4.52,1.49-1.82,4.2-2.06,4.2-2.06,0,0,.3,2.7-1.19,4.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m1151.65,595.82l-5.38,6.58s2.71-.24,4.2-2.06c1.49-1.82,1.19-4.52,1.19-4.52Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m1146.28,612.74c8.07,7.11,12.91-17.04,0-10.49v10.49Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1146.28,612.75c-8.07,7.11-12.91-17.04,0-10.49v10.49Z"
	    }
	  })])])])]), _h('path', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "d": "m1109.28,608.52c1.76,11.68,11.84,20.64,24.02,20.64s22.25-8.95,24.02-20.64h-48.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".15"
	    },
	    attrs: {
	      "d": "m1133.26,608.52h-23.99c1.76,11.67,11.83,20.62,23.99,20.63v-20.63Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#695446"
	    },
	    attrs: {
	      "x": "1016.19",
	      "y": "626.97",
	      "width": "296.69",
	      "height": "7.11"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1259.48,594.45c.28,0,.51.23.51.51v.71c0,.28-.23.51-.51.51h-2.04c-.09,0-.16.08-.16.16v.63c0,.09.08.16.16.16h2.55v.35h-3.06v-1.14c0-.29.22-.51.51-.51h2.04c.09,0,.16-.08.16-.16v-.71c0-.09-.08-.16-.16-.16h-2.04c-.09,0-.16.08-.16.16v.12h-.35v-.12c0-.29.22-.51.51-.51h2.04Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1260.75,597.48h-.35v-.35h.35v.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1264.2,595.89c.1.09.17.23.17.38v.7c0,.28-.23.51-.51.51h-2.04c-.29,0-.51-.23-.51-.51v-.07h.35v.07c0,.09.08.16.16.16h2.04c.09,0,.16-.08.16-.16v-.7c0-.09-.08-.16-.16-.16h-1.98v-.35h1.84c.09,0,.16-.08.16-.16v-.64c0-.09-.08-.16-.16-.16h-1.91c-.09,0-.16.08-.16.16v.11h-.35v-.11c0-.29.23-.51.51-.51h1.91c.29,0,.51.23.51.51v.64c0,.08-.02.16-.05.22l.02.08Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff482"
	    },
	    attrs: {
	      "d": "m1267.35,594.45c.28,0,.51.23.51.51v2.01c0,.28-.23.51-.51.51h-2.04c-.29,0-.51-.23-.51-.51v-2.01c0-.29.22-.51.51-.51h2.04Zm-2.04.35c-.09,0-.16.08-.16.16v1.76l2.33-1.92h-2.16Zm2.04,2.34c.09,0,.16-.08.16-.16v-1.76l-2.33,1.92h2.17Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e6e6e6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1199.72,586c-4.63,2.14-16.23,1.96-20.38-5.29-6.89-12.06,4-29.39,7.97-33.48,4.31-4.45,9.8-7.27,14.13-7.62,14.08-1.13,25.33,13.46,25.96,16.49,1.81,8.7,4.84,28.45-4.4,31.01-16.97,4.7-17.56-2.67-23.28-1.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edb368",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1212.7,576.51h-14.67v13.23c0,9.71,14.67,9.71,14.67,0v-13.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e6e6e6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1215.06,544.85c7.82-5.08,22.59,5.88,10.47,20.13-4.59-8.06-10.47-20.13-10.47-20.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#edb368",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1215.4,547.66c4.24.54,11.76,3.9,10.58,14.2-.62,5.44-1.19,6.76-1.76,9.36.86,7.79-4.69,18.62-13.26,18.82,1.58-15.12,2.85-27.26,4.43-42.38Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f5cb8b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1215.69,544.9c-4.26-.35-19.96-.92-21.74,13.99-1.78,14.91,1.29,18.97,2.82,21.58,3.5,5.97,10.39,8.65,14.21,9.56,5.91-.1,11.41-35.67,4.72-45.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e6e6e6",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1194.89,576.87c-.33.16-2.21-9.28-1.58-13.66,1.75-1.61,2.95,4.99,13.18-1.06,10.77-6.36,6.65-13.57,16.47-11.76-.91-3.48-1.46-5.06-6.88-8.08-5.26-2.93-16.73-5.87-21.33,2.13-7.76,6.49-5.69,25.23.14,32.43Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f5cb8b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1195.13,564.88c-.29-1.06-.7-1.83-1.94-2.23-1.24-.4-3.61,0-3.98,3.6-.37,3.6,2.3,7,4.25,6.77,1.94-.23,1.76-7.17,1.67-8.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d4a15e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1194.16,565.98c-.26-.62-.6-1.15-1.35-1.39-.76-.24-1.91.02-2.14,2.21-.23,2.19,1.11,4.24,2.3,4.1.37-.04.63-.55.81-1.23-.68-.28-1.03-1.14-.79-2.01.18-.65.64-1.13,1.17-1.29,0-.25,0-.39,0-.39Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ea5232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1192.67,574.06c.67,0,1.22-.55,1.22-1.22s-.55-1.22-1.22-1.22-1.22.55-1.22,1.22.55,1.22,1.22,1.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7b4727",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1210.47,569.97c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#7b4727",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1222.51,571.94c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67-1.67.75-1.67,1.67.75,1.67,1.67,1.67Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1219.98,579.25c-.44,2-2.28,3.43-4.39,3.3s-3.75-1.8-3.92-3.84c2.66.99,5.43,1.18,8.31.54Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1282.95,666.55h31.47v-44.14c0-5.39-2.57-7.53-7.72-7.53h-15.69c-2.97,0-3.98,7.23-5.31,9.55,0,0-2.43-2.07-2.43.21l-.32,41.91Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1282.43,651.72c-6.9.27-11.35-1.49-13.24-5.22-2.23-4.42-.28-10.32,5.98-18.02l5.94,4.83c-5.04,6.2-5.37,9.19-5.09,9.75.14.27,1.63,1.25,6.37,1.01l.36,7.65c-.11,0-.22,0-.32.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#2e2f2f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1324.16,727.17c-.52-2.89-10.02-4.54-9.86-7.26-7.36,0-5.13,0-12.49,0-.99,2.42-1.28,4.84-1.44,7.26h23.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#2e2f2f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1270.93,727.17c.52-2.89,10.02-4.54,9.86-7.26,7.36,0,5.13,0,12.49,0,.99,2.42,1.28,4.84,1.44,7.26h-23.79Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1272.7,630.88l7.79,3.13c.46.19,1.06.18,1.39-.19,2.69-3.1,5.19-5.15,6.75-8.59,1.1-2.43,1.72-7.42,2.59-10.37-6.35-.23-13.87,6.12-19.19,13.81-.54.78-.21,1.86.67,2.22Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#66635b"
	    },
	    attrs: {
	      "d": "m1280.34,720.92l2.68-54.6h31.33l.41,54.72c-4.63,1.43-8.72,1.12-13.42.2q-.37-14.12-1.13-50.43h-3.33c-2.02,36.33-2.24,36.36-3.1,50.47-4.82.41-8.61.84-13.43-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1291.04,614.85l1.24,8c.16.85,1.12,1.27,1.86.81l4.54-2.8,4.54,2.8c.73.45,1.69.03,1.86-.81l1.24-8h-15.28Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1279.71",
	      "y": "646.84",
	      "width": "10.47",
	      "height": "6.1",
	      "rx": "2.63",
	      "ry": "2.63"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1315.85,651.72c6.9.27,11.35-1.49,13.24-5.22,2.23-4.42.28-10.32-5.98-18.02l-5.94,4.83c5.04,6.2,5.37,9.19,5.09,9.75-.14.27-1.63,1.25-6.37,1.01l-.36,7.65c.11,0,.22,0,.32.01Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1325.58,630.88l-7.79,3.13c-.46.19-1.06.18-1.39-.19-2.69-3.1-5.19-5.15-6.75-8.59-1.1-2.43-1.72-7.42-2.59-10.37,6.35-.23,13.87,6.12,19.19,13.81.54.78.21,1.86-.67,2.22Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1308.1",
	      "y": "646.84",
	      "width": "10.47",
	      "height": "6.1",
	      "rx": "2.63",
	      "ry": "2.63",
	      "transform": "translate(2626.67 1299.77) rotate(180)"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1293.17,609.39v5.44c0,3.03,2.46,5.49,5.49,5.49s5.49-2.46,5.49-5.49v-5.44h-10.98Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1287.23,597.68c0,2.73-2.21,4.94-4.94,4.94-2.73,0-4.94-2.21-4.94-4.94s2.21-4.94,4.94-4.94c2.73,0,4.94,2.21,4.94,4.94Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1320.45,597.68c0,2.73-2.21,4.94-4.94,4.94s-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94c2.73,0,4.94,2.21,4.94,4.94Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#bc7946"
	    },
	    attrs: {
	      "d": "m1285.25,597.68c0,1.64-1.33,2.96-2.96,2.96-1.64,0-2.96-1.33-2.96-2.96s1.33-2.96,2.96-2.96c1.64,0,2.96,1.33,2.96,2.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#bc7946"
	    },
	    attrs: {
	      "d": "m1318.48,597.68c0,1.64-1.33,2.96-2.96,2.96-1.64,0-2.96-1.33-2.96-2.96,0-1.64,1.33-2.96,2.96-2.96,1.64,0,2.96,1.33,2.96,2.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1315.53,597.77c0,9.29-7.53,16.82-16.82,16.82-9.29,0-16.82-7.53-16.82-16.82v-11.3c0-9.29,7.53-11.51,16.82-11.51,17.46,0,16.82,6.86,16.82,16.82v5.98Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c57f4a"
	    },
	    attrs: {
	      "d": "m1298.71,574.96v39.63c9.29,0,16.82-7.53,16.82-16.82v-5.98c0-9.96.64-16.82-16.82-16.82Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#713b27"
	    },
	    attrs: {
	      "d": "m1282.27,593.36c.21-4.34.93-10.85,4.76-10.85,2.84,0,2.94.65,11.56.65,7.63,0,9.17-.86,12.03-.86,3.06,0,4.49,2.75,4.54,8.42.01,1.17.09,2.34.16,3.5.04.68.09,1.37.12,2.05.01.28.09,1.02.45.95.41-.08.45-1.58.49-1.9.29-2.26.37-4.58.37-6.86,0-4.2,1.22-12.29-6.39-17.34-4.68-3.1-14.34-3.41-19.73-1.65-3.75,1.22-7.34,4.41-8.68,8.12-1.47,4.08-1.43,7.26-.95,15.33.05.88.16,1.75.28,2.62.08.58.16,1.17.3,1.73.31,1.23.73.35.72-.41-.02-1.17-.1-2.33-.05-3.51Z"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#7b4727"
	    },
	    attrs: {
	      "cx": "1291.3",
	      "cy": "596.2",
	      "r": "1.96"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#7b4727"
	    },
	    attrs: {
	      "cx": "1306.55",
	      "cy": "596.2",
	      "r": "1.96"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1293.82,604.46h9.82c.19,0,.35.16.35.35,0,2.13-2.46,3.99-5.26,3.99-3.15,0-5.26-2.06-5.26-3.99,0-.19.16-.35.35-.35Z"
	    }
	  }), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1299.05",
	      "y": "639.25",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#5c8a2f"
	    },
	    attrs: {
	      "points": "1306.59 639.69 1291.15 639.18 1291.15 643.89 1306.59 643.89 1306.59 639.69"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#78b72a"
	    },
	    attrs: {
	      "points": "1309.57 641.57 1288.52 642.67 1288.52 643.89 1309.57 643.89 1309.57 641.57"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1313.55,645.5h-28.99c-.45,0-.81-.36-.81-.81h0c0-.45.36-.81.81-.81h28.99c.45,0,.81.36.81.81h0c0,.45-.36.81-.81.81Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c1c1c1"
	    },
	    attrs: {
	      "d": "m1307.98,647.12h-17.85c-.89,0-1.61-.72-1.61-1.61h21.08c0,.89-.72,1.61-1.61,1.61Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1291.97",
	      "y": "639.96",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1294.38",
	      "y": "638.09",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1294.09",
	      "y": "642.28",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1300.81",
	      "y": "638.09",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1295.35",
	      "y": "641.57",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1295.18",
	      "y": "637.37",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#edb294"
	    },
	    attrs: {
	      "x": "1304.15",
	      "y": "641.57",
	      "width": "2.32",
	      "height": "2.32"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1307.79",
	      "y": "642.28",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1299.95",
	      "y": "642.28",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ec691f"
	    },
	    attrs: {
	      "x": "1304",
	      "y": "639.96",
	      "width": "1.6",
	      "height": "1.6"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1292.07,640.44c-.53-.53-1.38-.53-1.91,0l-.37.37c-.53.53-.53,1.38,0,1.91l.13.13.7-.7,1.2,1.2c.24.24.64.24.88,0,.24-.24.24-.64,0-.88l-1.2-1.2.7-.7-.13-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1308.74,641.58c.53-.53.53-1.38,0-1.91l-.37-.37c-.53-.53-1.38-.53-1.91,0l-.13.13.7.7-1.2,1.2c-.24.24-.24.64,0,.88s.64.24.88,0l1.2-1.2.7.7.13-.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e2e2e1"
	    },
	    attrs: {
	      "d": "m1299.42,640.62c.53-.53.53-1.38,0-1.91l-.37-.37c-.53-.53-1.38-.53-1.91,0l-.13.13.7.7-1.2,1.2c-.24.24-.24.64,0,.88s.64.24.88,0l1.2-1.2.7.7.13-.13Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1311.33",
	      "y": "643.5",
	      "width": "6.96",
	      "height": "2.95",
	      "rx": "1.27",
	      "ry": "1.27",
	      "transform": "translate(2629.62 1289.96) rotate(-180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "x": "1279.99",
	      "y": "643.5",
	      "width": "6.96",
	      "height": "2.95",
	      "rx": "1.27",
	      "ry": "1.27"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#dadada"
	    },
	    attrs: {
	      "x": "1280.96",
	      "y": "646.45",
	      "width": "36.28",
	      "height": "2.07"
	    }
	  })])])]), _h('g', {
	    attrs: {
	      "id": "scene_corridor"
	    }
	  }, [_h('rect', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "id": "corridor_rectangle",
	      "x": "1394.45",
	      "y": "214.03",
	      "width": "355.43",
	      "height": "183.9"
	    }
	  }), _h('g', {
	    attrs: {
	      "id": "corridor_complete"
	    }
	  }, [_h('path', {
	    staticStyle: {
	      "fill": "#2e2f2f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1696.96,397.17c.53-2.98,10.32-4.68,10.16-7.48,7.58,0,5.29,0,12.87,0,1.02,2.49,1.32,4.99,1.48,7.48h-24.5Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#3e4251"
	    },
	    attrs: {
	      "x": "1712.63",
	      "y": "289.46",
	      "width": "34.09",
	      "height": "36.4",
	      "rx": "13.66",
	      "ry": "13.66",
	      "transform": "translate(3334.99 1021.4) rotate(-166.12)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#2e2f2f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1728.82,396.96c-1.19-4.36,3.85-10.08,1.78-12.46,5.99-4.64,5.67-4.39,11.66-9.03,2.73,1.58,4.69,3.75,6.59,5.97l-20.03,15.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1702.81,307.37c0,.07-3.16,23.92-4.94,36.11.13.14.23.31.3.5l1.72,4.65c.29.79-.12,1.68-.92,1.97h0c-.79.29-1.68-.12-1.97-.91l-.65-1.75.24,6.28c.03.84-.63,1.57-1.48,1.6h0c-.84.04-1.56-.62-1.59-1.47l-.03-.83c-.09.02-.18.03-.27.04h0c-.84.04-1.56-.62-1.59-1.47l-.03-.87c-.43-.26-.73-.72-.75-1.26l-.36-9.54c-.02-.41.13-.78.38-1.07,1.88-12.95,4.47-32.87,4.48-32.93l7.46.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1695.02,306.51l9.17,1.73,3.78-24.41c-6.4-.45-9.94,5.05-10.57,8.1l-3.67,12.47c-.28.95.32,1.93,1.3,2.12Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1717.85 328.97 1700.95 328.97 1705.99 390.74 1720.67 390.74 1720.11 380.92 1718.35 341.28 1718.39 341.28 1717.85 328.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1712.76,320.12l1.27,39.65,16.81,25.27,13.22-8.46-15.65-24.42,3.02-31.42c-.27-2.43-18.67-.62-18.67-.62Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1732.36,335.13c-12.69,1.23-20.36,2.03-33.06,3.26l-2.07-33.7c-.39-5.23-1.2-19.62,5.76-20.68,4.87-.74,15.91-2.12,18.81-2.41,4.36.35,6.25,5.66,6.55,7.68l4.01,45.85Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1724.28,333.26c5.5-4.15,10.52-8.94,14.92-14.24,1.86-2.24,5.33-6.41,4.07-12.39-.92-4.32-3.66-7.53-5.87-10.1l-6.68,5.73c1.72,2,3.49,4.08,3.94,6.2.3,1.42-.18,2.48-2.22,4.94-3.97,4.78-8.5,9.1-13.46,12.85l5.3,7.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#294676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1739.97,299.13l-8.81,5.02-6.95-12.71c-1.48-2.76-4.64-8.79-2.05-9.58,4.62-1.4,8.61,2.36,9.99,4.64l8.13,11.2c.34.47.2,1.13-.31,1.42Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1713.62,328.14l5.38-1.93c.63-.23,1.34,0,1.62.61h0c.28.62.02,1.39-.61,1.62l-5.38,1.93c-.63.23-1.34,0-1.62-.61h0c-.28-.61-.02-1.4.61-1.62Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1721.05,325.11h.66c1.21,0,2.2.98,2.2,2.2v5.42c0,1.21-.98,2.2-2.2,2.2h-.66c-1.21,0-2.2-.98-2.2-2.2v-5.42c0-1.21.98-2.2,2.2-2.2Z",
	      "transform": "translate(786.4 1812.54) rotate(-68.61)"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1714.76,333.47l1.42-3.63c.25-.63.96-.94,1.59-.7h0c.63.25.94.96.7,1.59l-1.42,3.63c-.25.63-.96.94-1.59.7h0c-.63-.25-.94-.96-.69-1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1719.33,335.26l1.42-3.63c.25-.63-.07-1.34-.69-1.59h0c-.63-.25-1.34.07-1.59.69l-1.42,3.63c-.25.63.07,1.34.69,1.59h0c.63.25,1.34-.07,1.59-.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1723.9,337.05l1.94-4.96c.25-.63-.07-1.34-.7-1.59h0c-.63-.25-1.34.07-1.59.7l-1.93,4.96c-.25.63.07,1.34.7,1.59h0c.63.25,1.34-.07,1.59-.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1719.33,335.26l1.42-3.63c.25-.63.96-.94,1.59-.69h0c.63.25.94.96.69,1.59l-1.42,3.63c-.25.63-.96.94-1.59.7h0c-.63-.25-.94-.96-.7-1.59Z"
	    }
	  })])]), _h('path', {
	    staticStyle: {
	      "fill": "#58b4d3"
	    },
	    attrs: {
	      "d": "m1719.85,281.79l-.22,8.42c-.06.9-.99,1.46-1.81,1.09l-5.06-2.28-4.31,3.49c-.7.56-1.74.26-2.03-.59l-2.34-8.09,15.77-2.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1716.65,278l.46,4.42c.3,2.93-1.83,5.55-4.76,5.85-2.93.3-5.55-1.83-5.85-4.76l-.46-4.42,10.61-1.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#3e4251"
	    },
	    attrs: {
	      "d": "m1720.77,281.49c.08-.12.23-.19.37-.15l2.82-.55c.95.05,1.42,0,1.86.86,2.59,5.05,5.12,12.86,5.53,23.18.08,2.12-.13,2.86-.53,2.91-.3.04-.41-2.96-1.52-5.94-3.91-14.69-8.48-19.86-8.52-19.91-.09-.12-.09-.28-.02-.4Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1706.61,241.47c4.03-.44,16.18-1.66,18.25,12.42,2.08,14.08-.26,19.65-1.88,22.01-1.63,2.36-3.35,4.53-7.13,6.06-.89,1.16-1.91,1.69-3.6,2.14-1.74,0-2.87-.24-4.03-1.13-4.04-.5-6.28-2.14-8.46-4-2.18-1.86-5.89-6.63-7.54-20.76-1.66-14.13,10.39-16.12,14.39-16.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c57f4a",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1706.61,241.47c-4,.62-16.05,2.6-14.39,16.74,1.66,14.13,5.36,18.91,7.54,20.76,2.19,1.86,4.42,3.5,8.46,4,1.16.89,2.29,1.14,4.03,1.13-1.89-14.28-3.75-28.35-5.64-42.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1696.06,250.22c.99-2.36,10.25,5.75,24.97,3.86-.12-.81-1.18-2.11-1.29-3.49,4.55,4.09,4.46,13.61,4.46,13.61l3.96-3.39c-.79-13.06-7.33-23.75-22.09-22.74-8.52,1.35-11.66,6.44-12.59,8.41-5.27,5.85-3.95,11.94-2.47,19.21l4.71,2.28c-.68-3.01-1.22-14.01.34-17.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1717.46,265.17c-.97.13-1.87-.56-2-1.53s.56-1.87,1.53-2c.97-.13,1.87.56,2,1.53s-.56,1.87-1.53,2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1702.31,267.27c-1.02.14-1.97-.59-2.1-1.61s.59-1.97,1.61-2.1c1.02-.14,1.97.59,2.1,1.61s-.59,1.97-1.61,2.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1716.25,271.39l-11,1.32c-.22.03-.37.22-.35.44.29,2.38,3.29,4.14,6.43,3.76,3.52-.42,5.62-3.02,5.36-5.18-.03-.22-.22-.37-.44-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1729.58,263.59c.35,2.66-1.53,5.09-4.18,5.44-2.66.35-5.09-1.53-5.44-4.18-.35-2.66,1.53-5.09,4.18-5.44,2.66-.35,5.09,1.53,5.44,4.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1724.39,261.33c1.59-.21,3.06.92,3.26,2.51.21,1.59-.92,3.06-2.51,3.26"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c57f4a"
	    },
	    attrs: {
	      "d": "m1690.42,267.92c.14,2.68,2.43,4.73,5.11,4.59,2.68-.14,4.73-2.43,4.59-5.11-.14-2.68-2.43-4.73-5.11-4.59-2.68.14-4.73,2.43-4.59,5.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1694.99,264.71c-1.6.15-2.78,1.57-2.63,3.17.15,1.6,1.57,2.78,3.17,2.63"
	    }
	  })]), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#e88d53"
	    },
	    attrs: {
	      "x": "1394.45",
	      "y": "214.03",
	      "width": "37.71",
	      "height": "183.5"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1432.15",
	      "y": "214.03",
	      "width": "39.05",
	      "height": "183.5"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#dc5812"
	    },
	    attrs: {
	      "points": "1508.91 214.03 1471.2 214.03 1471.2 397.53 1508.91 397.53 1547.96 397.53 1547.96 214.03 1508.91 214.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1541.23",
	      "y": "214.03",
	      "width": "6.73",
	      "height": "183.5"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e9e9e9",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,281.45c1.94,0,3.51,1.56,3.51,3.48s-1.57,3.48-3.51,3.48-3.5-1.56-3.5-3.48,1.57-3.48,3.5-3.48Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b4b4b4",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,282.5c1.36,0,2.45,1.09,2.45,2.43s-1.1,2.43-2.45,2.43-2.45-1.09-2.45-2.43,1.1-2.43,2.45-2.43Z"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#9a9999"
	    },
	    attrs: {
	      "x": "1407.17",
	      "y": "286.97",
	      "width": ".61",
	      "height": "3.34"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#767676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,281.87h0c.51,0,.93.42.93.93v4.26c0,.51-.42.93-.93.93h0c-.51,0-.93-.42-.93-.93v-4.26c0-.51.42-.93.93-.93Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#545454",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.93,281.98c.3.15.5.46.5.82v4.28c0,.35-.2.66-.5.82-.3-.16-.5-.46-.5-.82v-4.28c0-.36.2-.66.5-.82Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,290.19c3.77,0,6.82,3.03,6.82,6.77s-3.05,6.77-6.82,6.77-6.82-3.03-6.82-6.77,3.05-6.77,6.82-6.77Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cf1417",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.21,292.92c.82,0,1.87-.9,2.56-.57,1.72.83,2.91,2.59,2.91,4.62,0,2.84-2.32,5.14-5.18,5.14-2.54,0-4.66-1.82-5.1-4.22-.05-.3.87-.51.87-.83,0-2.84,1.07-4.15,3.93-4.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dd4747",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,291.82c.84,0,1.64.2,2.34.55.08.35.12.72.12,1.09,0,2.84-2.32,5.14-5.18,5.14-.84,0-1.64-.2-2.34-.55-.08-.35-.12-.72-.12-1.09,0-2.84,2.32-5.14,5.18-5.14Z"
	    }
	  })])])]), _h('path', {
	    staticStyle: {
	      "fill": "#dd8247"
	    },
	    attrs: {
	      "d": "m1410.12,273.32h-5.3c-.91,0-1.65-.74-1.65-1.65v-6.02c0-.91.74-1.65,1.65-1.65h5.3c.91,0,1.65.74,1.65,1.65v6.02c0,.91-.74,1.65-1.65,1.65Zm-5.3-9.16c-.82,0-1.49.67-1.49,1.49v6.02c0,.82.67,1.49,1.49,1.49h5.3c.82,0,1.49-.67,1.49-1.49v-6.02c0-.82-.67-1.49-1.49-1.49h-5.3Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,236.52h51c.36,0,.66.16.66.36v.42c0,.2-.3.36-.66.36h-51c-.36,0-.66-.16-.66-.36v-.42c0-.2.29-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,234.61h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,242.55h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,240.64h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,248.58h51.01c.36,0,.66.16.66.35v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.35.66-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,246.67h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,254.61h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,252.69h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })])])]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,366.48h51c.36,0,.66.16.66.36v.42c0,.2-.3.36-.66.36h-51c-.36,0-.66-.16-.66-.36v-.42c0-.2.29-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,364.57h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,372.51h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,370.6h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,378.54h51.01c.36,0,.66.16.66.35v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.35.66-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,376.62h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#dc5812",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,384.56h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,382.65h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1405.89,266.67h.58v3.87h-.83v-3.01l-.67.16-.18-.69,1.1-.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1407.4,267.42v-.72h2.59v.64l-.97.93c.53.09,1.03.36,1.03,1.08s-.53,1.26-1.38,1.26c-.69,0-1.17-.27-1.5-.66l.58-.55c.26.3.54.46.93.46.32,0,.54-.18.54-.47,0-.32-.27-.49-.75-.49h-.35l-.13-.54.92-.92h-1.51Z"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1470.26",
	      "y": "268.37",
	      "width": "72.21",
	      "height": "3.03"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3c09d"
	    },
	    attrs: {
	      "d": "m1534.69,394.87l-.07.76-.1,1-.62,1.29h-1.58v-1.15l-1.01,1.15h-1.44v-1.15l-1.21,1.15h-1.44v-1.15l-1.29,1.15h-1.03v-1.15l-1.29,1.15h-1.04c-1.24,0-2.58-1.72-6.12-1.72v1.72h-6.11c-.47-1.68-.68-3.21-.75-4.65,3.04,0,5.79.16,10.12.91,11.99,2.1,14.97.68,14.97.68Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "d": "m1534.87,393.04c-.01.57-.09.94-.09.94l-.09.89s-2.98,1.42-14.97-.68c-4.33-.75-7.08-.91-10.12-.91-.23-5.05,1.43-8.77.94-12.19-.41-2.79-1.71-9.39-2.6-13.74h15.49c-.95,4.92-2.19,12.9-.96,15.84,3.06,7.32,7.8,4.06,10.44,5.7,1.74,1.08,1.98,3,1.95,4.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ec9e6c"
	    },
	    attrs: {
	      "d": "m1524.3,363.25s-.16.69-.4,1.82c-.14.63-.29,1.42-.46,2.29h-15.49c-.49-2.4-.84-4.11-.84-4.11h17.19Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f3c09d"
	    },
	    attrs: {
	      "d": "m1528.93,394.87l-.07.76-.1,1-.62,1.29h-1.58v-1.15l-1.01,1.15h-1.44v-1.15l-1.21,1.15h-1.44v-1.15l-1.29,1.15h-1.03v-1.15l-1.29,1.15h-1.04c-1.24,0-2.58-1.72-6.12-1.72v1.72h-6.11c-.47-1.68-.68-3.21-.75-4.65,3.04,0,5.79.16,10.12.91,11.99,2.1,14.97.68,14.97.68Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e88d53"
	    },
	    attrs: {
	      "d": "m1529.11,393.04c-.01.57-.09.94-.09.94l-.09.89s-2.98,1.42-14.97-.68c-4.33-.75-7.08-.91-10.12-.91-.23-5.05,1.43-8.77.94-12.19-.41-2.79-1.71-9.39-2.6-13.74h15.49c-.95,4.92-2.19,12.9-.96,15.84,3.06,7.32,7.8,4.06,10.44,5.7,1.74,1.08,1.98,3,1.95,4.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#f3c09d"
	    },
	    attrs: {
	      "d": "m1518.54,363.25s-.16.69-.4,1.82c-.14.63-.29,1.42-.46,2.29h-15.49c-.49-2.4-.84-4.11-.84-4.11h17.19Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1506.48,260.21h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1505.92,263.07h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e27232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1479.32,259.14h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1508.67,250.94h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1508.12,253.8h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e27232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1481.52,249.87h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1505.9,241.75h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1505.35,244.61h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e27232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1478.74,240.68h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1538.39,300.56h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1537.84,303.42h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e27232",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1511.24,299.49h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#f7d0b5"
	    },
	    attrs: {
	      "x": "1510.83",
	      "y": "239.66",
	      "width": "4.63",
	      "height": "29.1"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1526.73",
	      "y": "244.43",
	      "width": "7.28",
	      "height": "24.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#f0af84",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1515.44 233.31 1526.72 233.31 1526.72 233.31 1526.72 268.76 1515.45 268.76 1515.44 268.76 1515.44 233.31"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ea965f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1515.44 241 1526.72 241 1526.72 241 1526.72 242.77 1515.45 242.77 1515.44 242.77 1515.44 241"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1495.83,292.65c-.76.06-1.46.26-2.13.57-.48-.93-1-1.86-1.58-2.79,4.55-1.95,8.48-2.7,10.25-2.96,1.64,2.46,2.61,5.41,2.61,8.58,0,.22,0,.43-.02.65-2.11-1.93-5.53-4.36-9.13-4.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1495.92,293.69c3.54-.3,7.04,2.51,8.93,4.36-.57,4.46-3.05,8.33-6.6,10.75-.27-2.88-1.16-8.6-4.08-14.65.55-.25,1.14-.41,1.75-.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1493.25,294.66c3.02,6.29,3.8,12.22,4,14.76-2.27,1.31-4.9,2.07-7.71,2.07-1.28,0-2.53-.16-3.73-.46.66-3.63,2.8-13.26,7.45-16.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1489.83,287.18c.96-.53,1.82-1.16,2.51-1.91,1.08-1.17,1.87-2.47,2.45-3.74,2.74.99,5.12,2.74,6.89,4.99-2.05.34-5.83,1.16-10.13,3.03-.53-.8-1.1-1.59-1.72-2.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1488.19,286.83c-3.46,1.48-8.12,1.85-12.19,1.81,1.6-2.91,4.1-5.24,7.13-6.63,1.94,1.49,3.61,3.12,5.06,4.82Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1489.16,286.36c-1.41-1.69-3.05-3.31-4.93-4.81,1.65-.6,3.44-.93,5.3-.93,1.47,0,2.9.21,4.24.59-.54,1.15-1.25,2.31-2.21,3.35-.66.71-1.47,1.31-2.4,1.8Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1488.88,287.66c.61.77,1.18,1.54,1.71,2.33-5.11,2.37-10.8,6.22-15.1,12.46-.89-1.95-1.39-4.11-1.39-6.39s.49-4.42,1.37-6.36c.35,0,.71.01,1.07.01,4.14,0,8.82-.45,12.34-2.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1491.15,290.86c.6.95,1.15,1.91,1.63,2.86-5.07,3.3-7.3,13.15-7.99,17.02-3.76-1.21-6.89-3.83-8.77-7.23,4.25-6.41,10-10.3,15.13-12.66Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#c34f0e"
	    },
	    attrs: {
	      "d": "m1490.58,289.98c-.53-.78-1.09-1.56-1.71-2.33-3.52,1.59-8.19,2.05-12.34,2.05-.36,0-.72,0-1.07-.01.16-.36.34-.71.53-1.06,4.07.04,8.74-.33,12.19-1.81-1.44-1.7-3.12-3.32-5.06-4.82.36-.17.73-.32,1.11-.46,1.88,1.5,3.51,3.13,4.93,4.81.93-.49,1.75-1.09,2.4-1.8.96-1.04,1.68-2.21,2.21-3.35.34.1.68.2,1.01.33-.58,1.26-1.37,2.56-2.45,3.74-.69.75-1.55,1.38-2.51,1.91.62.78,1.19,1.57,1.72,2.37,4.3-1.86,8.08-2.69,10.13-3.03.24.31.47.62.69.95-1.78.26-5.71,1.01-10.25,2.96.58.93,1.11,1.86,1.58,2.79.67-.31,1.37-.51,2.13-.57,3.6-.3,7.02,2.13,9.13,4.06-.02.45-.06.9-.12,1.34-1.89-1.85-5.39-4.66-8.93-4.36-.62.05-1.2.21-1.75.46,2.92,6.05,3.81,11.77,4.08,14.65-.32.22-.65.43-.99.62-.2-2.55-.97-8.47-4-14.76-4.64,3.12-6.79,12.74-7.45,16.37-.34-.08-.68-.18-1.02-.29.69-3.87,2.92-13.72,7.99-17.02-.49-.95-1.03-1.91-1.63-2.86-5.13,2.35-10.88,6.25-15.13,12.66-.19-.35-.37-.71-.54-1.07,4.3-6.24,9.99-10.09,15.1-12.46Z"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#f0af84"
	    },
	    attrs: {
	      "x": "1476.82",
	      "y": "322.02",
	      "width": "27.6",
	      "height": "28.75"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e88d53"
	    },
	    attrs: {
	      "x": "1476",
	      "y": "319.8",
	      "width": "29.25",
	      "height": "5.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#e06928"
	    },
	    attrs: {
	      "d": "m1494.6,330.72h-7.96c-.59,0-1.08-.53-1.08-1.19h0c0-.66.48-1.19,1.08-1.19h7.96c.59,0,1.08.53,1.08,1.19h0c0,.66-.48,1.19-1.08,1.19Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1470.26",
	      "y": "308.81",
	      "width": "72.21",
	      "height": "3.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e47b3d"
	    },
	    attrs: {
	      "x": "1470.26",
	      "y": "349.25",
	      "width": "72.21",
	      "height": "3.03"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#27231f",
	      "fill-rule": "evenodd",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1564.86 219.21 1564.86 219.21 1564.86 294.81 1564.86 294.81 1564.86 353.33 1680.62 353.33 1680.62 310.93 1680.62 219.21 1564.86 219.21"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1564.86 213.62 1564.86 213.62 1564.86 290.59 1564.86 290.59 1564.86 351.45 1680.62 351.45 1680.62 307 1680.62 213.62 1564.86 213.62"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1568.95",
	      "cy": "217.03",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#e94b2a"
	    },
	    attrs: {
	      "cx": "1568.5",
	      "cy": "216.52",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1677.14",
	      "cy": "217.03",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#e94b2a"
	    },
	    attrs: {
	      "cx": "1676.69",
	      "cy": "216.52",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1570.35",
	      "cy": "348.07",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#e94b2a"
	    },
	    attrs: {
	      "cx": "1569.9",
	      "cy": "347.57",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1676.91",
	      "cy": "347.82",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#e94b2a"
	    },
	    attrs: {
	      "cx": "1676.47",
	      "cy": "347.31",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "329.95",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "332.55",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "335.19",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "337.87",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1604.82",
	      "y": "340.43",
	      "width": "38.9",
	      "height": "1.19"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "248.5",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "248.5",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "250.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "250.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "253.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1571.17",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1573.82",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1576.48",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1579.13",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1581.78",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1572.5",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1575.15",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1577.8",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1580.45",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1583.1",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1573.82",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1576.48",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1579.13",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1581.78",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1583.1",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1670.61",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#dff2fd"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#294676"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1600.68",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1603.34",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1605.99",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1608.64",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1611.29",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1613.94",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1616.59",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1619.25",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1621.9",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1624.55",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1627.2",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1629.85",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1632.5",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1635.16",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1637.81",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1640.46",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1643.11",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1645.76",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1648.41",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#71c8df"
	    },
	    attrs: {
	      "cx": "1651.07",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "corridor_inactive"
	    }
	  }, [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1696.96,397.17c.53-2.98,10.32-4.68,10.16-7.48,7.58,0,5.29,0,12.87,0,1.02,2.49,1.32,4.99,1.48,7.48h-24.5Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "x": "1712.63",
	      "y": "289.46",
	      "width": "34.09",
	      "height": "36.4",
	      "rx": "13.66",
	      "ry": "13.66",
	      "transform": "translate(3334.99 1021.4) rotate(-166.12)"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1728.82,396.96c-1.19-4.36,3.85-10.08,1.78-12.46,5.99-4.64,5.67-4.39,11.66-9.03,2.73,1.58,4.69,3.75,6.59,5.97l-20.03,15.51Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1702.81,307.37c0,.07-3.16,23.92-4.94,36.11.13.14.23.31.3.5l1.72,4.65c.29.79-.12,1.68-.92,1.97h0c-.79.29-1.68-.12-1.97-.91l-.65-1.75.24,6.28c.03.84-.63,1.57-1.48,1.6h0c-.84.04-1.56-.62-1.59-1.47l-.03-.83c-.09.02-.18.03-.27.04h0c-.84.04-1.56-.62-1.59-1.47l-.03-.87c-.43-.26-.73-.72-.75-1.26l-.36-9.54c-.02-.41.13-.78.38-1.07,1.88-12.95,4.47-32.87,4.48-32.93l7.46.96Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1695.02,306.51l9.17,1.73,3.78-24.41c-6.4-.45-9.94,5.05-10.57,8.1l-3.67,12.47c-.28.95.32,1.93,1.3,2.12Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1717.85 328.97 1700.95 328.97 1705.99 390.74 1720.67 390.74 1720.11 380.92 1718.35 341.28 1718.39 341.28 1717.85 328.97"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#66635b",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1712.76,320.12l1.27,39.65,16.81,25.27,13.22-8.46-15.65-24.42,3.02-31.42c-.27-2.43-18.67-.62-18.67-.62Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1732.36,335.13c-12.69,1.23-20.36,2.03-33.06,3.26l-2.07-33.7c-.39-5.23-1.2-19.62,5.76-20.68,4.87-.74,15.91-2.12,18.81-2.41,4.36.35,6.25,5.66,6.55,7.68l4.01,45.85Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1724.28,333.26c5.5-4.15,10.52-8.94,14.92-14.24,1.86-2.24,5.33-6.41,4.07-12.39-.92-4.32-3.66-7.53-5.87-10.1l-6.68,5.73c1.72,2,3.49,4.08,3.94,6.2.3,1.42-.18,2.48-2.22,4.94-3.97,4.78-8.5,9.1-13.46,12.85l5.3,7.02Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1739.97,299.13l-8.81,5.02-6.95-12.71c-1.48-2.76-4.64-8.79-2.05-9.58,4.62-1.4,8.61,2.36,9.99,4.64l8.13,11.2c.34.47.2,1.13-.31,1.42Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1713.62,328.14l5.38-1.93c.63-.23,1.34,0,1.62.61h0c.28.62.02,1.39-.61,1.62l-5.38,1.93c-.63.23-1.34,0-1.62-.61h0c-.28-.61-.02-1.4.61-1.62Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1721.05,325.11h.66c1.21,0,2.2.98,2.2,2.2v5.42c0,1.21-.98,2.2-2.2,2.2h-.66c-1.21,0-2.2-.98-2.2-2.2v-5.42c0-1.21.98-2.2,2.2-2.2Z",
	      "transform": "translate(786.4 1812.54) rotate(-68.61)"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1714.76,333.47l1.42-3.63c.25-.63.96-.94,1.59-.7h0c.63.25.94.96.7,1.59l-1.42,3.63c-.25.63-.96.94-1.59.7h0c-.63-.25-.94-.96-.69-1.59Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1719.33,335.26l1.42-3.63c.25-.63-.07-1.34-.69-1.59h0c-.63-.25-1.34.07-1.59.69l-1.42,3.63c-.25.63.07,1.34.69,1.59h0c.63.25,1.34-.07,1.59-.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1723.9,337.05l1.94-4.96c.25-.63-.07-1.34-.7-1.59h0c-.63-.25-1.34.07-1.59.7l-1.93,4.96c-.25.63.07,1.34.7,1.59h0c.63.25,1.34-.07,1.59-.69Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1719.33,335.26l1.42-3.63c.25-.63.96-.94,1.59-.69h0c.63.25.94.96.69,1.59l-1.42,3.63c-.25.63-.96.94-1.59.7h0c-.63-.25-.94-.96-.7-1.59Z"
	    }
	  })])]), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1719.85,281.79l-.22,8.42c-.06.9-.99,1.46-1.81,1.09l-5.06-2.28-4.31,3.49c-.7.56-1.74.26-2.03-.59l-2.34-8.09,15.77-2.03Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1716.65,278l.46,4.42c.3,2.93-1.83,5.55-4.76,5.85-2.93.3-5.55-1.83-5.85-4.76l-.46-4.42,10.61-1.09Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d59f60"
	    },
	    attrs: {
	      "d": "m1720.77,281.49c.08-.12.23-.19.37-.15l2.82-.55c.95.05,1.42,0,1.86.86,2.59,5.05,5.12,12.86,5.53,23.18.08,2.12-.13,2.86-.53,2.91-.3.04-.41-2.96-1.52-5.94-3.91-14.69-8.48-19.86-8.52-19.91-.09-.12-.09-.28-.02-.4Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#d1864e",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1706.61,241.47c4.03-.44,16.18-1.66,18.25,12.42,2.08,14.08-.26,19.65-1.88,22.01-1.63,2.36-3.35,4.53-7.13,6.06-.89,1.16-1.91,1.69-3.6,2.14-1.74,0-2.87-.24-4.03-1.13-4.04-.5-6.28-2.14-8.46-4-2.18-1.86-5.89-6.63-7.54-20.76-1.66-14.13,10.39-16.12,14.39-16.74Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c57f4a",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1706.61,241.47c-4,.62-16.05,2.6-14.39,16.74,1.66,14.13,5.36,18.91,7.54,20.76,2.19,1.86,4.42,3.5,8.46,4,1.16.89,2.29,1.14,4.03,1.13-1.89-14.28-3.75-28.35-5.64-42.63Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1696.06,250.22c.99-2.36,10.25,5.75,24.97,3.86-.12-.81-1.18-2.11-1.29-3.49,4.55,4.09,4.46,13.61,4.46,13.61l3.96-3.39c-.79-13.06-7.33-23.75-22.09-22.74-8.52,1.35-11.66,6.44-12.59,8.41-5.27,5.85-3.95,11.94-2.47,19.21l4.71,2.28c-.68-3.01-1.22-14.01.34-17.75Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1717.46,265.17c-.97.13-1.87-.56-2-1.53-.13-.97.56-1.87,1.53-2s1.87.56,2,1.53-.56,1.87-1.53,2Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#452211",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1702.31,267.27c-1.02.14-1.97-.59-2.1-1.61s.59-1.97,1.61-2.1c1.02-.14,1.97.59,2.1,1.61s-.59,1.97-1.61,2.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1716.25,271.39l-11,1.32c-.22.03-.37.22-.35.44.29,2.38,3.29,4.14,6.43,3.76,3.52-.42,5.62-3.02,5.36-5.18-.03-.22-.22-.37-.44-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#d1864e"
	    },
	    attrs: {
	      "d": "m1729.58,263.59c.35,2.66-1.53,5.09-4.18,5.44-2.66.35-5.09-1.53-5.44-4.18-.35-2.66,1.53-5.09,4.18-5.44,2.66-.35,5.09,1.53,5.44,4.19Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1724.39,261.33c1.59-.21,3.06.92,3.26,2.51.21,1.59-.92,3.06-2.51,3.26"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c57f4a"
	    },
	    attrs: {
	      "d": "m1690.42,267.92c.14,2.68,2.43,4.73,5.11,4.59s4.73-2.43,4.59-5.11c-.14-2.68-2.43-4.73-5.11-4.59-2.68.14-4.73,2.43-4.59,5.11Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b67544"
	    },
	    attrs: {
	      "d": "m1694.99,264.71c-1.6.15-2.78,1.57-2.63,3.17.15,1.6,1.57,2.78,3.17,2.63"
	    }
	  })]), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1394.45",
	      "y": "214.03",
	      "width": "37.71",
	      "height": "183.5"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1432.15",
	      "y": "214.03",
	      "width": "39.05",
	      "height": "183.5"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "points": "1508.91 214.03 1471.2 214.03 1471.2 397.53 1508.91 397.53 1547.96 397.53 1547.96 214.03 1508.91 214.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1541.23",
	      "y": "214.03",
	      "width": "6.73",
	      "height": "183.5"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#e9e9e9",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,281.45c1.94,0,3.51,1.56,3.51,3.48s-1.57,3.48-3.51,3.48-3.5-1.56-3.5-3.48,1.57-3.48,3.5-3.48Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#b4b4b4",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,282.5c1.36,0,2.45,1.09,2.45,2.43s-1.1,2.43-2.45,2.43-2.45-1.09-2.45-2.43,1.1-2.43,2.45-2.43Z"
	    }
	  }), _h('g', [_h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#9a9999"
	    },
	    attrs: {
	      "x": "1407.17",
	      "y": "286.97",
	      "width": ".61",
	      "height": "3.34"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#767676",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,281.87h0c.51,0,.93.42.93.93v4.26c0,.51-.42.93-.93.93h0c-.51,0-.93-.42-.93-.93v-4.26c0-.51.42-.93.93-.93Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#545454",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.93,281.98c.3.15.5.46.5.82v4.28c0,.35-.2.66-.5.82-.3-.16-.5-.46-.5-.82v-4.28c0-.36.2-.66.5-.82Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,290.19c3.77,0,6.82,3.03,6.82,6.77s-3.05,6.77-6.82,6.77-6.82-3.03-6.82-6.77,3.05-6.77,6.82-6.77Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.21,292.92c.82,0,1.87-.9,2.56-.57,1.72.83,2.91,2.59,2.91,4.62,0,2.84-2.32,5.14-5.18,5.14-2.54,0-4.66-1.82-5.1-4.22-.05-.3.87-.51.87-.83,0-2.84,1.07-4.15,3.93-4.15Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#70461f",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1407.5,291.82c.84,0,1.64.2,2.34.55.08.35.12.72.12,1.09,0,2.84-2.32,5.14-5.18,5.14-.84,0-1.64-.2-2.34-.55-.08-.35-.12-.72-.12-1.09,0-2.84,2.32-5.14,5.18-5.14Z"
	    }
	  })])])]), _h('path', {
	    staticStyle: {
	      "fill": "#dd8247"
	    },
	    attrs: {
	      "d": "m1410.12,273.32h-5.3c-.91,0-1.65-.74-1.65-1.65v-6.02c0-.91.74-1.65,1.65-1.65h5.3c.91,0,1.65.74,1.65,1.65v6.02c0,.91-.74,1.65-1.65,1.65Zm-5.3-9.16c-.82,0-1.49.67-1.49,1.49v6.02c0,.82.67,1.49,1.49,1.49h5.3c.82,0,1.49-.67,1.49-1.49v-6.02c0-.82-.67-1.49-1.49-1.49h-5.3Z"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,236.52h51c.36,0,.66.16.66.36v.42c0,.2-.3.36-.66.36h-51c-.36,0-.66-.16-.66-.36v-.42c0-.2.29-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,234.61h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,242.55h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,240.64h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,248.58h51.01c.36,0,.66.16.66.35v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.35.66-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,246.67h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,254.61h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,252.69h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })])])]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,366.48h51c.36,0,.66.16.66.36v.42c0,.2-.3.36-.66.36h-51c-.36,0-.66-.16-.66-.36v-.42c0-.2.29-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,364.57h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,372.51h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,370.6h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,378.54h51.01c.36,0,.66.16.66.35v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.35.66-.35Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,376.62h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#432918",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1406.75,384.56h51.01c.36,0,.66.16.66.36v.42c0,.2-.29.36-.66.36h-51.01c-.36,0-.66-.16-.66-.36v-.42c0-.2.3-.36.66-.36Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1408.36,382.65h47.78c1.25,0,2.27,1.02,2.27,2.27h-52.32c0-1.25,1.02-2.27,2.27-2.27Z"
	    }
	  })])])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1405.89,266.67h.58v3.87h-.83v-3.01l-.67.16-.18-.69,1.1-.33Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1407.4,267.42v-.72h2.59v.64l-.97.93c.53.09,1.03.36,1.03,1.08s-.53,1.26-1.38,1.26c-.69,0-1.17-.27-1.5-.66l.58-.55c.26.3.54.46.93.46.32,0,.54-.18.54-.47,0-.32-.27-.49-.75-.49h-.35l-.13-.54.92-.92h-1.51Z"
	    }
	  })])]), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1470.26",
	      "y": "268.37",
	      "width": "72.21",
	      "height": "3.03"
	    }
	  })]), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1534.69,394.87l-.07.76-.1,1-.62,1.29h-1.58v-1.15l-1.01,1.15h-1.44v-1.15l-1.21,1.15h-1.44v-1.15l-1.29,1.15h-1.03v-1.15l-1.29,1.15h-1.04c-1.24,0-2.58-1.72-6.12-1.72v1.72h-6.11c-.47-1.68-.68-3.21-.75-4.65,3.04,0,5.79.16,10.12.91,11.99,2.1,14.97.68,14.97.68Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1534.87,393.04c-.01.57-.09.94-.09.94l-.09.89s-2.98,1.42-14.97-.68c-4.33-.75-7.08-.91-10.12-.91-.23-5.05,1.43-8.77.94-12.19-.41-2.79-1.71-9.39-2.6-13.74h15.49c-.95,4.92-2.19,12.9-.96,15.84,3.06,7.32,7.8,4.06,10.44,5.7,1.74,1.08,1.98,3,1.95,4.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1524.3,363.25s-.16.69-.4,1.82c-.14.63-.29,1.42-.46,2.29h-15.49c-.49-2.4-.84-4.11-.84-4.11h17.19Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#c6b5a5"
	    },
	    attrs: {
	      "d": "m1528.93,394.87l-.07.76-.1,1-.62,1.29h-1.58v-1.15l-1.01,1.15h-1.44v-1.15l-1.21,1.15h-1.44v-1.15l-1.29,1.15h-1.03v-1.15l-1.29,1.15h-1.04c-1.24,0-2.58-1.72-6.12-1.72v1.72h-6.11c-.47-1.68-.68-3.21-.75-4.65,3.04,0,5.79.16,10.12.91,11.99,2.1,14.97.68,14.97.68Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1529.11,393.04c-.01.57-.09.94-.09.94l-.09.89s-2.98,1.42-14.97-.68c-4.33-.75-7.08-.91-10.12-.91-.23-5.05,1.43-8.77.94-12.19-.41-2.79-1.71-9.39-2.6-13.74h15.49c-.95,4.92-2.19,12.9-.96,15.84,3.06,7.32,7.8,4.06,10.44,5.7,1.74,1.08,1.98,3,1.95,4.14Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#c6b5a5"
	    },
	    attrs: {
	      "d": "m1518.54,363.25s-.16.69-.4,1.82c-.14.63-.29,1.42-.46,2.29h-15.49c-.49-2.4-.84-4.11-.84-4.11h17.19Z"
	    }
	  })])]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1506.48,260.21h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1505.92,263.07h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1479.32,259.14h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1508.67,250.94h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1508.12,253.8h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1481.52,249.87h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1505.9,241.75h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1505.35,244.61h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1478.74,240.68h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#f0f0f0",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1538.39,300.56h-29.84v6.52h29.84c-.79-1.98-.73-4.17,0-6.52Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#cdcccc",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1537.84,303.42h-29.28v-2.86h29.84c-.31.98-.49,1.94-.55,2.86Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "d": "m1511.24,299.49h27.8v2.47h-27.8c-.63,0-1.2.26-1.61.67h0c-.41.42-.67.98-.67,1.61h0c0,.62.26,1.19.67,1.61.41.41.98.67,1.61.67h27.8v2.47h-27.8c-1.31,0-2.49-.53-3.35-1.39-.86-.86-1.39-2.05-1.39-3.35h0c0-1.31.53-2.49,1.39-3.35h0c.86-.86,2.05-1.39,3.35-1.39Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#f7d0b5"
	    },
	    attrs: {
	      "x": "1510.83",
	      "y": "239.66",
	      "width": "4.63",
	      "height": "29.1"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1526.73",
	      "y": "244.43",
	      "width": "7.28",
	      "height": "24.33"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1515.44 233.31 1526.72 233.31 1526.72 233.31 1526.72 268.76 1515.45 268.76 1515.44 268.76 1515.44 233.31"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#a2876d",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1515.44 241 1526.72 241 1526.72 241 1526.72 242.77 1515.45 242.77 1515.44 242.77 1515.44 241"
	    }
	  }), _h('g', [_h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1495.83,292.65c-.76.06-1.46.26-2.13.57-.48-.93-1-1.86-1.58-2.79,4.55-1.95,8.48-2.7,10.25-2.96,1.64,2.46,2.61,5.41,2.61,8.58,0,.22,0,.43-.02.65-2.11-1.93-5.53-4.36-9.13-4.06Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1495.92,293.69c3.54-.3,7.04,2.51,8.93,4.36-.57,4.46-3.05,8.33-6.6,10.75-.27-2.88-1.16-8.6-4.08-14.65.55-.25,1.14-.41,1.75-.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1493.25,294.66c3.02,6.29,3.8,12.22,4,14.76-2.27,1.31-4.9,2.07-7.71,2.07-1.28,0-2.53-.16-3.73-.46.66-3.63,2.8-13.26,7.45-16.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1489.83,287.18c.96-.53,1.82-1.16,2.51-1.91,1.08-1.17,1.87-2.47,2.45-3.74,2.74.99,5.12,2.74,6.89,4.99-2.05.34-5.83,1.16-10.13,3.03-.53-.8-1.1-1.59-1.72-2.37Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1488.19,286.83c-3.46,1.48-8.12,1.85-12.19,1.81,1.6-2.91,4.1-5.24,7.13-6.63,1.94,1.49,3.61,3.12,5.06,4.82Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1489.16,286.36c-1.41-1.69-3.05-3.31-4.93-4.81,1.65-.6,3.44-.93,5.3-.93,1.47,0,2.9.21,4.24.59-.54,1.15-1.25,2.31-2.21,3.35-.66.71-1.47,1.31-2.4,1.8Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1488.88,287.66c.61.77,1.18,1.54,1.71,2.33-5.11,2.37-10.8,6.22-15.1,12.46-.89-1.95-1.39-4.11-1.39-6.39s.49-4.42,1.37-6.36c.35,0,.71.01,1.07.01,4.14,0,8.82-.45,12.34-2.05Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1491.15,290.86c.6.95,1.15,1.91,1.63,2.86-5.07,3.3-7.3,13.15-7.99,17.02-3.76-1.21-6.89-3.83-8.77-7.23,4.25-6.41,10-10.3,15.13-12.66Z"
	    }
	  })]), _h('path', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "d": "m1490.58,289.98c-.53-.78-1.09-1.56-1.71-2.33-3.52,1.59-8.19,2.05-12.34,2.05-.36,0-.72,0-1.07-.01.16-.36.34-.71.53-1.06,4.07.04,8.74-.33,12.19-1.81-1.44-1.7-3.12-3.32-5.06-4.82.36-.17.73-.32,1.11-.46,1.88,1.5,3.51,3.13,4.93,4.81.93-.49,1.75-1.09,2.4-1.8.96-1.04,1.68-2.21,2.21-3.35.34.1.68.2,1.01.33-.58,1.26-1.37,2.56-2.45,3.74-.69.75-1.55,1.38-2.51,1.91.62.78,1.19,1.57,1.72,2.37,4.3-1.86,8.08-2.69,10.13-3.03.24.31.47.62.69.95-1.78.26-5.71,1.01-10.25,2.96.58.93,1.11,1.86,1.58,2.79.67-.31,1.37-.51,2.13-.57,3.6-.3,7.02,2.13,9.13,4.06-.02.45-.06.9-.12,1.34-1.89-1.85-5.39-4.66-8.93-4.36-.62.05-1.2.21-1.75.46,2.92,6.05,3.81,11.77,4.08,14.65-.32.22-.65.43-.99.62-.2-2.55-.97-8.47-4-14.76-4.64,3.12-6.79,12.74-7.45,16.37-.34-.08-.68-.18-1.02-.29.69-3.87,2.92-13.72,7.99-17.02-.49-.95-1.03-1.91-1.63-2.86-5.13,2.35-10.88,6.25-15.13,12.66-.19-.35-.37-.71-.54-1.07,4.3-6.24,9.99-10.09,15.1-12.46Z"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "x": "1476.82",
	      "y": "322.02",
	      "width": "27.6",
	      "height": "28.75"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9b7e62"
	    },
	    attrs: {
	      "x": "1476",
	      "y": "319.8",
	      "width": "29.25",
	      "height": "5.48"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1494.6,330.72h-7.96c-.59,0-1.08-.53-1.08-1.19h0c0-.66.48-1.19,1.08-1.19h7.96c.59,0,1.08.53,1.08,1.19h0c0,.66-.48,1.19-1.08,1.19Z"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1470.26",
	      "y": "308.81",
	      "width": "72.21",
	      "height": "3.03"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1470.26",
	      "y": "349.25",
	      "width": "72.21",
	      "height": "3.03"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#27231f",
	      "fill-rule": "evenodd",
	      "mix-blend-mode": "multiply",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1564.86 219.21 1564.86 219.21 1564.86 294.81 1564.86 294.81 1564.86 353.33 1680.62 353.33 1680.62 310.93 1680.62 219.21 1564.86 219.21"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#f5efe8",
	      "fill-rule": "evenodd"
	    },
	    attrs: {
	      "points": "1564.86 213.62 1564.86 213.62 1564.86 290.59 1564.86 290.59 1564.86 351.45 1680.62 351.45 1680.62 307 1680.62 213.62 1564.86 213.62"
	    }
	  }), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1568.95",
	      "cy": "217.03",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1568.5",
	      "cy": "216.52",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1677.14",
	      "cy": "217.03",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1676.69",
	      "cy": "216.52",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1570.35",
	      "cy": "348.07",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1569.9",
	      "cy": "347.57",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#71588f",
	      "mix-blend-mode": "multiply",
	      "opacity": ".6"
	    },
	    attrs: {
	      "cx": "1676.91",
	      "cy": "347.82",
	      "r": "1.18"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1676.47",
	      "cy": "347.31",
	      "r": "1.18"
	    }
	  })]), _h('g', [_h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "329.95",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "332.55",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "335.19",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1596.22",
	      "y": "337.87",
	      "width": "56.47",
	      "height": "1.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1604.82",
	      "y": "340.43",
	      "width": "38.9",
	      "height": "1.19"
	    }
	  })]), _h('g', [_h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "223.11",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "225.42",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "227.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "230.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "232.34",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "234.65",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "236.96",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "239.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "241.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "243.88",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "246.19",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "248.5",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "248.5",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "250.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "250.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "253.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "255.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "257.73",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "260.04",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "262.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "264.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1571.17",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1573.82",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1576.48",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1579.13",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1581.78",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "266.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1572.5",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1575.15",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1577.8",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1580.45",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1583.1",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "269.27",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1573.82",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1576.48",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1579.13",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1581.78",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "271.58",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1583.1",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "273.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "276.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "278.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "280.81",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "283.12",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "285.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "287.74",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "290.05",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "292.35",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1584.43",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "294.66",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1585.76",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1670.61",
	      "cy": "296.97",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1587.08",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1669.28",
	      "cy": "299.28",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1588.41",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1667.96",
	      "cy": "301.59",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1589.73",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#f5efe8"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1666.63",
	      "cy": "303.89",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1591.06",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1665.31",
	      "cy": "306.2",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1592.39",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1661.33",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1663.98",
	      "cy": "308.51",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1593.71",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1657.35",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1660",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1662.65",
	      "cy": "310.82",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1595.04",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1597.69",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1600.34",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1602.99",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1605.64",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1608.3",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1610.95",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1613.6",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1616.25",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1618.9",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1621.55",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1624.21",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1626.86",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.51",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.16",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1634.81",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1637.46",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1640.12",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1642.77",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1645.42",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1648.07",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1650.72",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1653.37",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1656.03",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1658.68",
	      "cy": "313.13",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1596.36",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1599.01",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1601.67",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1604.32",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1606.97",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1609.62",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1612.27",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1614.92",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1617.58",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1620.23",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1622.88",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1625.53",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1628.18",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1630.83",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1633.49",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1636.14",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1638.79",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1641.44",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1644.09",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1646.74",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1649.4",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1652.05",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1654.7",
	      "cy": "315.43",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1600.68",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1603.34",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1605.99",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1608.64",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1611.29",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1613.94",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1616.59",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1619.25",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1621.9",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1624.55",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1627.2",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1629.85",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1632.5",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1635.16",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1637.81",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1640.46",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1643.11",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1645.76",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1648.41",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  }), _h('circle', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "cx": "1651.07",
	      "cy": "317.93",
	      "r": ".98"
	    }
	  })])])]), _h('g', {
	    attrs: {
	      "id": "scene_bathroom"
	    }
	  }, [_h('rect', {
	    staticStyle: {
	      "fill": "none"
	    },
	    attrs: {
	      "id": "bathroom_rectangle",
	      "x": "1485.81",
	      "y": "687.83",
	      "width": "280.91",
	      "height": "176.46"
	    }
	  }), _h('g', {
	    attrs: {
	      "id": "bathroom_complete"
	    }
	  }, [_h('polygon', {
	    staticStyle: {
	      "fill": "#93cbe9"
	    },
	    attrs: {
	      "points": "1502.09 832.81 1493.18 844.69 1493.18 689.19 1502.09 689.19 1502.09 832.81"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "points": "1641.02 864.04 1614.54 864.04 1617.06 836.16 1638.49 836.16 1641.02 864.04"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1605.49,817.58c.57,15.22,10.63,22.78,22.29,22.78,12.23,0,22.39-7.47,22.96-22.68l-45.25-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1601.97,817.68c.57,15.22,11.9,21.85,25.8,21.85s25.19-6.63,25.76-21.85h-51.57Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1653.23,820.99h-50.94c0,.17-.82-4.13.61-4.13h49.54c1.6,0,.8,4.13.8,4.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1654.88,818.55c0,.95-1.16,1.71-2.59,1.71h-49.03c-1.43,0-2.59-.77-2.59-1.71h0c0-.95,1.16-1.71,2.59-1.71h49.03c1.43,0,2.59.77,2.59,1.71h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "points": "1653.07 814.46 1603.03 814.46 1599.07 778.7 1656.45 778.7 1653.07 814.46"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1656.18,781.46h-56.81s-.53-3.23.44-3.23h55.92c.96,0,.46,3.23.46,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1658.55,779.14c0,.89-.78,1.61-1.74,1.61h-58.07c-.96,0-1.74-.72-1.74-1.61h0c0-.89.78-1.61,1.74-1.61h58.07c.96,0,1.74.72,1.74,1.61h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e27232"
	    },
	    attrs: {
	      "x": "1603.09",
	      "y": "814.46",
	      "width": "50.04",
	      "height": "2.39"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#bbdaed"
	    },
	    attrs: {
	      "x": "1584.53",
	      "y": "689.19",
	      "width": "86.19",
	      "height": "155.5"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1661.66,764.08c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#b2b2b2"
	    },
	    attrs: {
	      "d": "m1658.21,766.99c0,1.91,1.55,3.46,3.46,3.46v-6.91c-1.91,0-3.46,1.55-3.46,3.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "d": "m1665.12,766.99c0-1.91-1.55-3.46-3.46-3.46v6.91c1.91,0,3.46-1.55,3.46-3.46Z"
	    }
	  })])]), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1670.47 689.19 1594.66 844.69 1584.85 844.69 1584.85 689.19 1670.47 689.19"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "points": "1550.51 864.04 1524.03 864.04 1526.55 836.16 1547.98 836.16 1550.51 864.04"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1514.98,817.58c.57,15.22,10.63,22.78,22.29,22.78,12.23,0,22.39-7.47,22.96-22.68l-45.25-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1511.46,817.68c.57,15.22,11.9,21.85,25.8,21.85s25.19-6.63,25.76-21.85h-51.57Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1562.72,820.99h-50.94c0,.17-.82-4.13.61-4.13h49.54c1.6,0,.8,4.13.8,4.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1564.37,818.55c0,.95-1.16,1.71-2.59,1.71h-49.03c-1.43,0-2.59-.77-2.59-1.71h0c0-.95,1.16-1.71,2.59-1.71h49.03c1.43,0,2.59.77,2.59,1.71h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "points": "1562.56 814.46 1512.52 814.46 1508.56 778.7 1565.94 778.7 1562.56 814.46"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1565.67,781.46h-56.81s-.53-3.23.44-3.23h55.92c.96,0,.46,3.23.46,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1568.04,779.14c0,.89-.78,1.61-1.74,1.61h-58.07c-.96,0-1.74-.72-1.74-1.61h0c0-.89.78-1.61,1.74-1.61h58.07c.96,0,1.74.72,1.74,1.61h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e27232"
	    },
	    attrs: {
	      "x": "1512.58",
	      "y": "814.46",
	      "width": "50.04",
	      "height": "2.39"
	    }
	  })]), _h('polygon', {
	    staticStyle: {
	      "fill": "#a2cde5"
	    },
	    attrs: {
	      "points": "1541.69 831.01 1580.67 844.69 1580.67 689.19 1541.69 705.61 1541.69 831.01"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "x": "1580.67",
	      "y": "687.49",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "x": "1670.53",
	      "y": "687.49",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "points": "1731.1 864.04 1704.62 864.04 1707.14 836.16 1728.58 836.16 1731.1 864.04"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1695.57,817.58c.57,15.22,10.63,22.78,22.29,22.78,12.23,0,22.39-7.47,22.96-22.68l-45.25-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1692.06,817.68c.57,15.22,11.9,21.85,25.8,21.85s25.19-6.63,25.76-21.85h-51.57Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1743.31,820.99h-50.94c0,.17-.82-4.13.61-4.13h49.54c1.6,0,.8,4.13.8,4.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1744.96,818.55c0,.95-1.16,1.71-2.59,1.71h-49.03c-1.43,0-2.59-.77-2.59-1.71h0c0-.95,1.16-1.71,2.59-1.71h49.03c1.43,0,2.59.77,2.59,1.71h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "points": "1743.15 814.46 1693.11 814.46 1689.15 778.7 1746.53 778.7 1743.15 814.46"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1746.27,781.46h-56.81s-.53-3.23.44-3.23h55.92c.96,0,.46,3.23.46,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#fff"
	    },
	    attrs: {
	      "d": "m1748.64,779.14c0,.89-.78,1.61-1.74,1.61h-58.07c-.96,0-1.74-.72-1.74-1.61h0c0-.89.78-1.61,1.74-1.61h58.07c.96,0,1.74.72,1.74,1.61h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#e27232"
	    },
	    attrs: {
	      "x": "1693.17",
	      "y": "814.46",
	      "width": "50.04",
	      "height": "2.39"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#bbdaed"
	    },
	    attrs: {
	      "x": "1674.61",
	      "y": "689.19",
	      "width": "86.19",
	      "height": "155.5"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1751.75,764.08c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#b2b2b2"
	    },
	    attrs: {
	      "d": "m1748.29,766.99c0,1.91,1.55,3.46,3.46,3.46v-6.91c-1.91,0-3.46,1.55-3.46,3.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "d": "m1755.2,766.99c0-1.91-1.55-3.46-3.46-3.46v6.91c1.91,0,3.46-1.55,3.46-3.46Z"
	    }
	  })])]), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".2"
	    },
	    attrs: {
	      "points": "1760.55 689.19 1684.74 844.69 1674.93 844.69 1674.93 689.19 1760.55 689.19"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "x": "1760.61",
	      "y": "687.49",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "x": "1490.13",
	      "y": "687.49",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1492.17",
	      "y": "687.49",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1582.72",
	      "y": "687.49",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1673.59",
	      "y": "687.49",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#c6c6c6"
	    },
	    attrs: {
	      "x": "1763.67",
	      "y": "687.49",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1548.13,763.54c-1.41,0-2.55,1.55-2.55,3.46s1.14,3.46,2.55,3.46,2.55-1.55,2.55-3.46-1.14-3.46-2.55-3.46Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#b2b2b2"
	    },
	    attrs: {
	      "d": "m1545.09,767c0,1.91,1.14,3.46,2.55,3.46v-6.91c-1.41,0-2.55,1.55-2.55,3.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c"
	    },
	    attrs: {
	      "d": "m1550.19,767c0-1.91-1.14-3.46-2.55-3.46v6.91c1.41,0,2.55-1.55,2.55-3.46Z"
	    }
	  })])]), _h('g', {
	    attrs: {
	      "id": "bathroom_inactive"
	    }
	  }, [_h('polygon', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "points": "1501.95 832.91 1493.04 844.79 1493.04 689.29 1501.95 689.29 1501.95 832.91"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "points": "1640.87 864.14 1614.4 864.14 1616.92 836.26 1638.35 836.26 1640.87 864.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1605.34,817.68c.57,15.22,10.63,22.78,22.29,22.78,12.23,0,22.39-7.47,22.96-22.68l-45.25-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1601.83,817.78c.57,15.22,11.9,21.85,25.8,21.85s25.19-6.63,25.76-21.85h-51.57Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1653.09,821.09h-50.94c0,.17-.82-4.13.61-4.13h49.54c1.6,0,.8,4.13.8,4.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1654.73,818.65c0,.95-1.16,1.71-2.59,1.71h-49.03c-1.43,0-2.59-.77-2.59-1.71h0c0-.95,1.16-1.71,2.59-1.71h49.03c1.43,0,2.59.77,2.59,1.71h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "points": "1652.92 814.57 1602.88 814.57 1598.92 778.8 1656.3 778.8 1652.92 814.57"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1656.04,781.56h-56.81s-.53-3.23.44-3.23h55.92c.96,0,.46,3.23.46,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1658.41,779.24c0,.89-.78,1.61-1.74,1.61h-58.07c-.96,0-1.74-.72-1.74-1.61h0c0-.89.78-1.61,1.74-1.61h58.07c.96,0,1.74.72,1.74,1.61h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1602.95",
	      "y": "814.57",
	      "width": "50.04",
	      "height": "2.39"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1584.39",
	      "y": "689.29",
	      "width": "86.19",
	      "height": "155.5"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1661.52,764.18c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1658.06,767.09c0,1.91,1.55,3.46,3.46,3.46v-6.91c-1.91,0-3.46,1.55-3.46,3.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1664.98,767.09c0-1.91-1.55-3.46-3.46-3.46v6.91c1.91,0,3.46-1.55,3.46-3.46Z"
	    }
	  })])]), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".17"
	    },
	    attrs: {
	      "points": "1670.33 689.29 1594.52 844.79 1584.71 844.79 1584.71 689.29 1670.33 689.29"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "points": "1550.36 864.14 1523.89 864.14 1526.41 836.26 1547.84 836.26 1550.36 864.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1514.83,817.68c.57,15.22,10.63,22.78,22.29,22.78,12.23,0,22.39-7.47,22.96-22.68l-45.25-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1511.32,817.78c.57,15.22,11.9,21.85,25.8,21.85s25.19-6.63,25.76-21.85h-51.57Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1562.58,821.09h-50.94c0,.17-.82-4.13.61-4.13h49.54c1.6,0,.8,4.13.8,4.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1564.22,818.65c0,.95-1.16,1.71-2.59,1.71h-49.03c-1.43,0-2.59-.77-2.59-1.71h0c0-.95,1.16-1.71,2.59-1.71h49.03c1.43,0,2.59.77,2.59,1.71h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "points": "1562.41 814.57 1512.37 814.57 1508.42 778.8 1565.79 778.8 1562.41 814.57"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1565.53,781.56h-56.81s-.53-3.23.44-3.23h55.92c.96,0,.46,3.23.46,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1567.9,779.24c0,.89-.78,1.61-1.74,1.61h-58.07c-.96,0-1.74-.72-1.74-1.61h0c0-.89.78-1.61,1.74-1.61h58.07c.96,0,1.74.72,1.74,1.61h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1512.44",
	      "y": "814.57",
	      "width": "50.04",
	      "height": "2.39"
	    }
	  })]), _h('polygon', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "points": "1541.54 831.11 1580.53 844.79 1580.53 689.29 1541.54 705.71 1541.54 831.11"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1580.53",
	      "y": "687.59",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1670.38",
	      "y": "687.59",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('g', [_h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "points": "1730.96 864.14 1704.48 864.14 1707 836.26 1728.43 836.26 1730.96 864.14"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1695.42,817.68c.57,15.22,10.63,22.78,22.29,22.78,12.23,0,22.39-7.47,22.96-22.68l-45.25-.1Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1691.91,817.78c.57,15.22,11.9,21.85,25.8,21.85s25.19-6.63,25.76-21.85h-51.57Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1743.17,821.09h-50.94c0,.17-.82-4.13.61-4.13h49.54c1.6,0,.8,4.13.8,4.13Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1744.82,818.65c0,.95-1.16,1.71-2.59,1.71h-49.03c-1.43,0-2.59-.77-2.59-1.71h0c0-.95,1.16-1.71,2.59-1.71h49.03c1.43,0,2.59.77,2.59,1.71h0Z"
	    }
	  }), _h('polygon', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "points": "1743.01 814.57 1692.97 814.57 1689.01 778.8 1746.38 778.8 1743.01 814.57"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#dadada",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1746.12,781.56h-56.81s-.53-3.23.44-3.23h55.92c.96,0,.46,3.23.46,3.23Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#ceae8c"
	    },
	    attrs: {
	      "d": "m1748.49,779.24c0,.89-.78,1.61-1.74,1.61h-58.07c-.96,0-1.74-.72-1.74-1.61h0c0-.89.78-1.61,1.74-1.61h58.07c.96,0,1.74.72,1.74,1.61h0Z"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#70461f"
	    },
	    attrs: {
	      "x": "1693.03",
	      "y": "814.57",
	      "width": "50.04",
	      "height": "2.39"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1674.47",
	      "y": "689.29",
	      "width": "86.19",
	      "height": "155.5"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1751.6,764.18c-1.91,0-3.46,1.55-3.46,3.46s1.55,3.46,3.46,3.46,3.46-1.55,3.46-3.46-1.55-3.46-3.46-3.46Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1748.15,767.09c0,1.91,1.55,3.46,3.46,3.46v-6.91c-1.91,0-3.46,1.55-3.46,3.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1755.06,767.09c0-1.91-1.55-3.46-3.46-3.46v6.91c1.91,0,3.46-1.55,3.46-3.46Z"
	    }
	  })])]), _h('polygon', {
	    staticStyle: {
	      "fill": "#fff",
	      "opacity": ".17"
	    },
	    attrs: {
	      "points": "1760.41 689.29 1684.6 844.79 1674.79 844.79 1674.79 689.29 1760.41 689.29"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1760.46",
	      "y": "687.59",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "x": "1489.98",
	      "y": "687.59",
	      "width": "4.09",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1492.03",
	      "y": "687.59",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1582.57",
	      "y": "687.59",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1673.45",
	      "y": "687.59",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "x": "1763.53",
	      "y": "687.59",
	      "width": "2.04",
	      "height": "179.88"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#9d9d9c",
	      "mix-blend-mode": "multiply"
	    },
	    attrs: {
	      "d": "m1547.99,763.64c-1.41,0-2.55,1.55-2.55,3.46s1.14,3.46,2.55,3.46,2.55-1.55,2.55-3.46-1.14-3.46-2.55-3.46Z"
	    }
	  }), _h('g', [_h('path', {
	    staticStyle: {
	      "fill": "#ab8267"
	    },
	    attrs: {
	      "d": "m1544.95,767.1c0,1.91,1.14,3.46,2.55,3.46v-6.91c-1.41,0-2.55,1.55-2.55,3.46Z"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "#432918"
	    },
	    attrs: {
	      "d": "m1550.05,767.1c0-1.91-1.14-3.46-2.55-3.46v6.91c1.41,0,2.55-1.55,2.55-3.46Z"
	    }
	  })])])]), _h('g', {
	    attrs: {
	      "id": "MAP_TRAIL"
	    }
	  }, [_h('g', {
	    attrs: {
	      "id": "MAP_TRAIL-2"
	    }
	  }, [_h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#726054",
	      "stroke-miterlimit": "10",
	      "stroke-width": "41.87px"
	    },
	    attrs: {
	      "d": "m1770.91,885.25h-267.73c-18.73,0-34.06-15.33-34.06-34.06l.22-250.64c0-18.73,15.33-34.06,34.06-34.06h218.5c18.73,0,34.06-15.33,34.06-34.06l.55-80.61c0-18.73-15.33-34.06-34.06-34.06l-323.44-.03c-18.73,0-34.06,15.33-34.06,34.06v260.49c0,18.73-15.33,34.06-34.06,34.06h-318.03c-18.73,0-34.06-15.33-34.06-34.06l-.12-271.79c0-18.73-15.33-34.06-34.06-34.06h-210.7c-18.73,0-34.06,15.33-34.06,34.06v421.37c0,18.73-15.33,34.06-34.06,34.06H238.38c-18.73,0-34.06-15.33-34.06-34.06l.04-249.72c0-18.73,15.33-34.06,34.06-34.06h408.61"
	    }
	  }), _h('path', {
	    staticStyle: {
	      "fill": "none",
	      "stroke": "#fde7d3",
	      "stroke-miterlimit": "10",
	      "stroke-width": "32.45px"
	    },
	    attrs: {
	      "d": "m1770.91,885.25h-267.73c-18.73,0-34.06-15.33-34.06-34.06l.22-250.64c0-18.73,15.33-34.06,34.06-34.06h218.5c18.73,0,34.06-15.33,34.06-34.06l.55-80.61c0-18.73-15.33-34.06-34.06-34.06l-323.44-.03c-18.73,0-34.06,15.33-34.06,34.06v260.49c0,18.73-15.33,34.06-34.06,34.06h-318.03c-18.73,0-34.06-15.33-34.06-34.06l-.12-271.79c0-18.73-15.33-34.06-34.06-34.06h-210.7c-18.73,0-34.06,15.33-34.06,34.06v421.37c0,18.73-15.33,34.06-34.06,34.06H238.38c-18.73,0-34.06-15.33-34.06-34.06l.04-249.72c0-18.73,15.33-34.06,34.06-34.06h408.61"
	    }
	  })]), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "642.79",
	      "y": "557.12",
	      "width": "4.55",
	      "height": "41.86",
	      "transform": "translate(1290.14 1156.11) rotate(180)"
	    }
	  }), _h('rect', {
	    staticStyle: {
	      "fill": "#726054"
	    },
	    attrs: {
	      "x": "1766.72",
	      "y": "864.3",
	      "width": "4.55",
	      "height": "41.86",
	      "transform": "translate(3537.99 1770.46) rotate(180)"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ },
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('nav', {
	    staticClass: "view-controls"
	  }, [_h('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showProgress),
	      expression: "showProgress"
	    }],
	    staticClass: "view-controls__wrapper"
	  }, [_h('span', {
	    staticClass: "view-controls__group"
	  }, [_h('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showMap),
	      expression: "!showMap"
	    }],
	    staticClass: "view-controls__button",
	    on: {
	      "click": _vm.openMap
	    }
	  }, ["View Map"]), " ", _h('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showMap),
	      expression: "showMap"
	    }],
	    staticClass: "view-controls__button",
	    on: {
	      "click": _vm.hideMap
	    }
	  }, ["Hide Map"])]), " ", _h('ul', {
	    staticClass: "view-controls__list"
	  }, [_vm._l((_vm.routes), function(item, index) {
	    return _h('li', {
	      staticClass: "view-controls__item"
	    }, [_h('view-link', {
	      attrs: {
	        "to": {
	          name: item.name,
	          params: {
	            scene: index + 1
	          }
	        },
	        "scene": item.scene,
	        "current": _vm.sceneID
	      }
	    }, [_vm._s(item.name)])])
	  })]), " ", _h('span', {
	    staticClass: "view-controls__group"
	  }, [_h('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showBack),
	      expression: "showBack"
	    }],
	    staticClass: "view-controls__button",
	    on: {
	      "click": _vm.goBack
	    }
	  }, ["Back"]), " ", _h('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showNext),
	      expression: "showNext"
	    }],
	    staticClass: "view-controls__button",
	    on: {
	      "click": _vm.goNext
	    }
	  }, ["Next"]), " ", _h('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showFinish),
	      expression: "showFinish"
	    }],
	    staticClass: "view-controls__button",
	    on: {
	      "click": _vm.goFinish
	    }
	  }, ["Complete"])])]), " ", _h('aside', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showMap),
	      expression: "showMap"
	    }],
	    staticClass: "view-controls__map"
	  }, [_h('div', {
	    staticClass: "view-controls__map-frame"
	  }, [_h('view-map')])])])
	},staticRenderFns: []}

/***/ },
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "app-container",
	    class: _vm.$route.name,
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), " ", _h('div', {
	    staticClass: "modal-controls"
	  }), " ", _vm._m(1), " ", _h('div', {
	    staticClass: "modal-mask"
	  }), " ", _vm._m(2), " ", _h('progress-bar', {
	    key: _vm.$route.fullPath
	  }), " ", _h('view-container')])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "app-logo"
	  }, [_h('div', {
	    staticClass: "app-logo__inner"
	  }, [_h('img', {
	    staticClass: "app-logo__image",
	    attrs: {
	      "src": __webpack_require__(166),
	      "alt": ""
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "modal-container"
	  }, [_h('div', {
	    staticClass: "modal-container__inner"
	  }, [_h('div', {
	    staticClass: "modal-container__wrap"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "view-loader"
	  }, [_h('div', {
	    staticClass: "view-loader__panel"
	  })])
	}]}

/***/ },
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(142);

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.e19a29b0f900c482fe3f.js